(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'exhibition-platform-consoleApi'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'exhibition-platform-consoleApi'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'exhibition-platform-consoleApi'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'exhibition-platform-consoleApi'.");
    }
    globalThis['exhibition-platform-consoleApi'] = factory(typeof globalThis['exhibition-platform-consoleApi'] === 'undefined' ? {} : globalThis['exhibition-platform-consoleApi'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var protoOf = kotlin_kotlin.$_$.tc;
  var initMetadataForCompanion = kotlin_kotlin.$_$.rb;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y1;
  var Unit_instance = kotlin_kotlin.$_$.e5;
  var emptyList = kotlin_kotlin.$_$.x6;
  var equals = kotlin_kotlin.$_$.hb;
  var THROW_CCE = kotlin_kotlin.$_$.wg;
  var Long = kotlin_kotlin.$_$.rg;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var initMetadataForObject = kotlin_kotlin.$_$.wb;
  var VOID = kotlin_kotlin.$_$.i;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var objectCreate = kotlin_kotlin.$_$.sc;
  var toString = kotlin_kotlin.$_$.xc;
  var getStringHashCode = kotlin_kotlin.$_$.ob;
  var hashCode = kotlin_kotlin.$_$.pb;
  var getBooleanHashCode = kotlin_kotlin.$_$.kb;
  var initMetadataForClass = kotlin_kotlin.$_$.qb;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.h1;
  var isCharSequence = kotlin_kotlin.$_$.cc;
  var trim = kotlin_kotlin.$_$.dg;
  var isBlank = kotlin_kotlin.$_$.ke;
  var charSequenceLength = kotlin_kotlin.$_$.db;
  var charSequenceGet = kotlin_kotlin.$_$.cb;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.p2;
  var toString_0 = kotlin_kotlin.$_$.ci;
  var listOf = kotlin_kotlin.$_$.a8;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a2;
  var enumEntries = kotlin_kotlin.$_$.sa;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.l;
  var lazy = kotlin_kotlin.$_$.uh;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var Enum = kotlin_kotlin.$_$.mg;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var getNumberHashCode = kotlin_kotlin.$_$.mb;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.j1;
  var encodeToByteArray = kotlin_kotlin.$_$.de;
  var numberToChar = kotlin_kotlin.$_$.oc;
  var isLetterOrDigit = kotlin_kotlin.$_$.ne;
  var contains = kotlin_kotlin.$_$.xd;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var emptyMap = kotlin_kotlin.$_$.y6;
  var toLong = kotlin_kotlin.$_$.vc;
  var minus = kotlin_kotlin.$_$.h8;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.v1;
  var LinkedHashSetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var emptySet = kotlin_kotlin.$_$.z6;
  var setOf = kotlin_kotlin.$_$.a9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.p;
  var endsWith = kotlin_kotlin.$_$.ee;
  var sorted = kotlin_kotlin.$_$.f9;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.d6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.o;
  var mapCapacity = kotlin_kotlin.$_$.b8;
  var coerceAtLeast = kotlin_kotlin.$_$.dd;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.x;
  var Collection = kotlin_kotlin.$_$.j5;
  var isInterface = kotlin_kotlin.$_$.gc;
  var KtMap = kotlin_kotlin.$_$.q5;
  var joinToString = kotlin_kotlin.$_$.r7;
  var contains_0 = kotlin_kotlin.$_$.wd;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.a1;
  var toMutableSet = kotlin_kotlin.$_$.r9;
  var plus = kotlin_kotlin.$_$.o8;
  var minus_0 = kotlin_kotlin.$_$.i8;
  var intersect = kotlin_kotlin.$_$.q7;
  var contains_1 = kotlin_kotlin.$_$.e6;
  var toSet = kotlin_kotlin.$_$.s9;
  var charArrayOf = kotlin_kotlin.$_$.ab;
  var trim_0 = kotlin_kotlin.$_$.cg;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.wh;
  var to = kotlin_kotlin.$_$.di;
  var removeSuffix = kotlin_kotlin.$_$.xe;
  var setOf_0 = kotlin_kotlin.$_$.z8;
  var linkedMapOf = kotlin_kotlin.$_$.x7;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.y;
  var toList = kotlin_kotlin.$_$.n9;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantOverrideSaveResult, 'TenantOverrideSaveResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddonPackSaveResult, 'AddonPackSaveResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LimitPolicySaveResult, 'LimitPolicySaveResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForCompanion(Companion_2);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpdateLimitPolicyRequest, 'UpdateLimitPolicyRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForObject(CatalogEditorRules, 'CatalogEditorRules');
  initMetadataForCompanion(Companion_3);
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddonRequestList, 'AddonRequestList', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForCompanion(Companion_4);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddonRequestDetail, 'AddonRequestDetail', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForObject(AddonRequestPaths, 'AddonRequestPaths');
  initMetadataForCompanion(Companion_5);
  initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddonRequestDecision, 'AddonRequestDecision', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForCompanion(Companion_6);
  initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddonRequestDecisionBody, 'AddonRequestDecisionBody', AddonRequestDecisionBody, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddonRequestRow, 'AddonRequestRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForCompanion(Companion_7);
  initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BillingEffectResult, 'BillingEffectResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForCompanion(Companion_8);
  initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RecordBillingEffectRequest, 'RecordBillingEffectRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForObject(BillingEffectKinds, 'BillingEffectKinds');
  initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BillingEffectView, 'BillingEffectView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  initMetadataForCompanion(Companion_9);
  initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(StagedBrandingAssetView, 'StagedBrandingAssetView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  initMetadataForCompanion(Companion_10);
  initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(StageBrandingAssetRequest, 'StageBrandingAssetRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  initMetadataForCompanion(Companion_11);
  initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(StagedBrandingAssetContent, 'StagedBrandingAssetContent', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
  initMetadataForCompanion(Companion_12, VOID, [SerializerFactory]);
  initMetadataForClass(BrandingAssetKind, 'BrandingAssetKind', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_12});
  initMetadataForCompanion(Companion_13);
  initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BrandingContrastView, 'BrandingContrastView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
  initMetadataForCompanion(Companion_14);
  initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BrandingContrastRequest, 'BrandingContrastRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BrandingContrastPairResult, 'BrandingContrastPairResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
  initMetadataForCompanion(Companion_15);
  initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BrandingContrastPair, 'BrandingContrastPair', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
  initMetadataForCompanion(Companion_16);
  initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundleTemplate, 'CapabilityBundleTemplate', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
  initMetadataForCompanion(Companion_17);
  initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundleView, 'CapabilityBundleView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
  initMetadataForCompanion(Companion_18);
  initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundlePreview, 'CapabilityBundlePreview', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
  initMetadataForCompanion(Companion_19);
  initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundlePreviewRequest, 'CapabilityBundlePreviewRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_21});
  initMetadataForCompanion(Companion_20);
  initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundleGrantResult, 'CapabilityBundleGrantResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
  initMetadataForCompanion(Companion_21);
  initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundleGrantRequest, 'CapabilityBundleGrantRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
  initMetadataForCompanion(Companion_22);
  initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundleRevokePreview, 'CapabilityBundleRevokePreview', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
  initMetadataForCompanion(Companion_23);
  initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundleRevokeResult, 'CapabilityBundleRevokeResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_25});
  initMetadataForCompanion(Companion_24);
  initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityBundleRevokeRequest, 'CapabilityBundleRevokeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_26});
  initMetadataForCompanion(Companion_25);
  initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CommercialLedgerView, 'CommercialLedgerView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_27});
  initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LedgerFacet, 'LedgerFacet', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_28});
  initMetadataForCompanion(Companion_26);
  initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LedgerEntry, 'LedgerEntry', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
  initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LedgerSurfaceColumn, 'LedgerSurfaceColumn', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
  initMetadataForObject(LedgerSurfaceKeys, 'LedgerSurfaceKeys');
  initMetadataForCompanion(Companion_27);
  initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LedgerGap, 'LedgerGap', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_31});
  initMetadataForCompanion(Companion_28);
  initMetadataForObject($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ConsoleError, 'ConsoleError', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
  initMetadataForCompanion(Companion_29);
  initMetadataForObject($serializer_33, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OperatorSummary, 'OperatorSummary', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_33});
  initMetadataForObject($serializer_34, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Money, 'Money', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
  initMetadataForCompanion(Companion_30);
  initMetadataForObject($serializer_35, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ConsoleFieldError, 'ConsoleFieldError', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_35});
  initMetadataForCompanion(Companion_31);
  initMetadataForObject($serializer_36, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanView, 'PlanView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_36});
  initMetadataForCompanion(Companion_32);
  initMetadataForObject($serializer_37, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpsertOverrideRequest, 'UpsertOverrideRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_37});
  initMetadataForCompanion(Companion_33);
  initMetadataForObject($serializer_38, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpsertAddonPackRequest, 'UpsertAddonPackRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_38});
  initMetadataForObject(ConsoleApiPaths, 'ConsoleApiPaths');
  initMetadataForCompanion(Companion_34);
  initMetadataForObject($serializer_39, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegistryResponse, 'RegistryResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_39});
  initMetadataForCompanion(Companion_35);
  initMetadataForObject($serializer_40, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LoginResponse, 'LoginResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_40});
  initMetadataForCompanion(Companion_36);
  initMetadataForObject($serializer_41, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LoginRequest, 'LoginRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_41});
  initMetadataForCompanion(Companion_37);
  initMetadataForObject($serializer_42, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TotpEnrolmentResponse, 'TotpEnrolmentResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_42});
  initMetadataForCompanion(Companion_38);
  initMetadataForObject($serializer_43, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ConfirmTotpRequest, 'ConfirmTotpRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_43});
  initMetadataForCompanion(Companion_39);
  initMetadataForObject($serializer_44, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CockpitResponse, 'CockpitResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_44});
  initMetadataForCompanion(Companion_40);
  initMetadataForObject($serializer_45, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(IntegrationCatalogResponse, 'IntegrationCatalogResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_45});
  initMetadataForCompanion(Companion_41);
  initMetadataForObject($serializer_46, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(IntegrationAccountView, 'IntegrationAccountView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_46});
  initMetadataForCompanion(Companion_42);
  initMetadataForObject($serializer_47, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpsertIntegrationAccountRequest, 'UpsertIntegrationAccountRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_47});
  initMetadataForCompanion(Companion_43);
  initMetadataForObject($serializer_48, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(IntegrationAccountOperationRecovery, 'IntegrationAccountOperationRecovery', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_48});
  initMetadataForCompanion(Companion_44);
  initMetadataForObject($serializer_49, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(IntegrationAssignmentView, 'IntegrationAssignmentView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_49});
  initMetadataForCompanion(Companion_45);
  initMetadataForObject($serializer_50, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpsertIntegrationAssignmentRequest, 'UpsertIntegrationAssignmentRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_50});
  initMetadataForCompanion(Companion_46, VOID, [SerializerFactory]);
  initMetadataForClass($serializer_51, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(Page, 'Page', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_46});
  initMetadataForCompanion(Companion_47);
  initMetadataForObject($serializer_52, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantRow, 'TenantRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_51});
  initMetadataForCompanion(Companion_48);
  initMetadataForObject($serializer_53, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantListQuery, 'TenantListQuery', TenantListQuery, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_52});
  initMetadataForCompanion(Companion_49);
  initMetadataForObject($serializer_54, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantDetail, 'TenantDetail', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_53});
  initMetadataForCompanion(Companion_50);
  initMetadataForObject($serializer_55, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantLifecycleRequest, 'TenantLifecycleRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_54});
  initMetadataForObject($serializer_56, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SupportSessionView, 'SupportSessionView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_55});
  initMetadataForCompanion(Companion_51);
  initMetadataForObject($serializer_57, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InvoiceView, 'InvoiceView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_56});
  initMetadataForCompanion(Companion_52);
  initMetadataForObject($serializer_58, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RecordPaymentRequest, 'RecordPaymentRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_57});
  initMetadataForCompanion(Companion_53);
  initMetadataForObject($serializer_59, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProvisioningJobView, 'ProvisioningJobView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_58});
  initMetadataForCompanion(Companion_54);
  initMetadataForObject($serializer_60, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpsertPlanRequest, 'UpsertPlanRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_59});
  initMetadataForCompanion(Companion_55);
  initMetadataForObject($serializer_61, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddonPackView, 'AddonPackView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_60});
  initMetadataForCompanion(Companion_56);
  initMetadataForObject($serializer_62, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(WaRateCardView, 'WaRateCardView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_61});
  initMetadataForCompanion(Companion_57);
  initMetadataForObject($serializer_63, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddWaRateCardRequest, 'AddWaRateCardRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_62});
  initMetadataForCompanion(Companion_58);
  initMetadataForObject($serializer_64, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProtectedIdentityPageView, 'ProtectedIdentityPageView', ProtectedIdentityPageView, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_63});
  initMetadataForCompanion(Companion_59);
  initMetadataForObject($serializer_65, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProtectionStatusView, 'ProtectionStatusView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_64});
  initMetadataForCompanion(Companion_60);
  initMetadataForObject($serializer_66, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProtectedIdentityView, 'ProtectedIdentityView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_65});
  initMetadataForCompanion(Companion_61);
  initMetadataForObject($serializer_67, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AddProtectedIdentityRequest, 'AddProtectedIdentityRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_66});
  initMetadataForCompanion(Companion_62);
  initMetadataForObject($serializer_68, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ChangeProtectedIdentityRequest, 'ChangeProtectedIdentityRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_67});
  initMetadataForCompanion(Companion_63);
  initMetadataForObject($serializer_69, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CapabilityEvidenceView, 'CapabilityEvidenceView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_68});
  initMetadataForCompanion(Companion_64);
  initMetadataForObject($serializer_70, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ReverifyCapabilityRequest, 'ReverifyCapabilityRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_69});
  initMetadataForCompanion(Companion_65);
  initMetadataForObject($serializer_71, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionQueue, 'SubscriptionQueue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_70});
  initMetadataForCompanion(Companion_66);
  initMetadataForObject($serializer_72, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UsageOverview, 'UsageOverview', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_71});
  initMetadataForObject($serializer_73, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LegacyProvisioningRetryReceipt, 'LegacyProvisioningRetryReceipt', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_72});
  initMetadataForCompanion(Companion_67);
  initMetadataForObject($serializer_74, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AuditEntry, 'AuditEntry', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_73});
  initMetadataForCompanion(Companion_68);
  initMetadataForObject($serializer_75, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AuditQuery, 'AuditQuery', AuditQuery, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_74});
  initMetadataForCompanion(Companion_69);
  initMetadataForObject($serializer_76, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(NoticeView, 'NoticeView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_75});
  initMetadataForCompanion(Companion_70);
  initMetadataForObject($serializer_77, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UpsertNoticeRequest, 'UpsertNoticeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_76});
  initMetadataForCompanion(Companion_71);
  initMetadataForObject($serializer_78, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FeatureFlagView, 'FeatureFlagView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_77});
  initMetadataForCompanion(Companion_72);
  initMetadataForObject($serializer_79, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetFeatureFlagRequest, 'SetFeatureFlagRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_78});
  initMetadataForCompanion(Companion_73);
  initMetadataForObject($serializer_80, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OperatorTokenView, 'OperatorTokenView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_79});
  initMetadataForCompanion(Companion_74);
  initMetadataForObject($serializer_81, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CreatedOperatorTokenResponse, 'CreatedOperatorTokenResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_80});
  initMetadataForCompanion(Companion_75);
  initMetadataForObject($serializer_82, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CreateOperatorTokenRequest, 'CreateOperatorTokenRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_81});
  initMetadataForCompanion(Companion_76);
  initMetadataForObject($serializer_83, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RevokeOperatorTokenRequest, 'RevokeOperatorTokenRequest', RevokeOperatorTokenRequest, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_82});
  initMetadataForCompanion(Companion_77);
  initMetadataForObject($serializer_84, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OperatorMcpCallView, 'OperatorMcpCallView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_83});
  initMetadataForCompanion(Companion_78);
  initMetadataForObject($serializer_85, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscribeRequest, 'SubscribeRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_84});
  initMetadataForCompanion(Companion_79);
  initMetadataForObject($serializer_86, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ChangePlanRequest, 'ChangePlanRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_85});
  initMetadataForCompanion(Companion_80);
  initMetadataForObject($serializer_87, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegistryLimit, 'RegistryLimit', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_86});
  initMetadataForCompanion(Companion_81);
  initMetadataForObject($serializer_88, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanPriceView, 'PlanPriceView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_87});
  initMetadataForCompanion(Companion_82);
  initMetadataForObject($serializer_89, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanLimitValue, 'PlanLimitValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_88});
  initMetadataForObject($serializer_90, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ExpiringSubscription, 'ExpiringSubscription', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_89});
  initMetadataForObject($serializer_91, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(QuotaPressureSummary, 'QuotaPressureSummary', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_90});
  initMetadataForObject($serializer_92, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProviderHealth, 'ProviderHealth', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_91});
  initMetadataForObject($serializer_93, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ProvisioningStepView, 'ProvisioningStepView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_92});
  initMetadataForCompanion(Companion_83);
  initMetadataForObject($serializer_94, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(EntitlementView, 'EntitlementView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_93});
  initMetadataForObject($serializer_95, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FeatureFlagOverride, 'FeatureFlagOverride', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_94});
  initMetadataForCompanion(Companion_84, VOID, [SerializerFactory]);
  initMetadataForClass(LoginOutcome, 'LoginOutcome', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_84});
  initMetadataForObject($serializer_96, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OverdueAccount, 'OverdueAccount', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_95});
  initMetadataForCompanion(Companion_85);
  initMetadataForObject($serializer_97, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LimitUsageAcrossTenants, 'LimitUsageAcrossTenants', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_96});
  initMetadataForObject($serializer_98, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantUsageRow, 'TenantUsageRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_97});
  initMetadataForCompanion(Companion_86);
  initMetadataForObject($serializer_99, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegistryFeature, 'RegistryFeature', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_98});
  initMetadataForCompanion(Companion_87);
  initMetadataForObject($serializer_100, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RegistryModule, 'RegistryModule', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_99});
  initMetadataForObject($serializer_101, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantProtectionStatusView, 'TenantProtectionStatusView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_100});
  initMetadataForObject($serializer_102, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyChangeView, 'SetupCopyChangeView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_101});
  initMetadataForCompanion(Companion_88);
  initMetadataForObject($serializer_103, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ConsoleErrorDetails, 'ConsoleErrorDetails', ConsoleErrorDetails, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_102});
  initMetadataForCompanion(Companion_89);
  initMetadataForObject($serializer_104, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionDetail, 'SubscriptionDetail', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_103});
  initMetadataForCompanion(Companion_90);
  initMetadataForObject($serializer_105, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ModuleView, 'ModuleView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_104});
  initMetadataForObject($serializer_106, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LimitView, 'LimitView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_105});
  initMetadataForObject($serializer_107, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OverrideView, 'OverrideView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_106});
  initMetadataForObject($serializer_108, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantHost, 'TenantHost', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_107});
  initMetadataForObject($serializer_109, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ChannelAssignmentView, 'ChannelAssignmentView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_108});
  initMetadataForObject($serializer_110, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionAddonView, 'SubscriptionAddonView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_109});
  initMetadataForCompanion(Companion_91);
  initMetadataForObject($serializer_111, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UsageSeries, 'UsageSeries', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_110});
  initMetadataForObject($serializer_112, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UsagePoint, 'UsagePoint', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_111});
  initMetadataForObject($serializer_113, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantSetupProjection, 'TenantSetupProjection', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_112});
  initMetadataForObject($serializer_114, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(InvoiceLineView, 'InvoiceLineView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_113});
  initMetadataForObject($serializer_115, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PaymentView, 'PaymentView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_114});
  initMetadataForCompanion(Companion_92);
  initMetadataForObject($serializer_116, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ConfigDiffView, 'ConfigDiffView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_115});
  initMetadataForCompanion(Companion_93);
  initMetadataForObject($serializer_117, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ConfigDiffQuery, 'ConfigDiffQuery', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_116});
  initMetadataForCompanion(Companion_94);
  initMetadataForObject($serializer_118, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(BlueprintView, 'BlueprintView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_117});
  initMetadataForCompanion(Companion_95);
  initMetadataForObject($serializer_119, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SaveBlueprintRequest, 'SaveBlueprintRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_118});
  initMetadataForCompanion(Companion_96);
  initMetadataForObject($serializer_120, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ReadinessReportView, 'ReadinessReportView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_119});
  initMetadataForCompanion(Companion_97);
  initMetadataForObject($serializer_121, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CreateTrainingCopyRequest, 'CreateTrainingCopyRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_120});
  initMetadataForCompanion(Companion_98);
  initMetadataForObject($serializer_122, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DiscardedTrainingCopyView, 'DiscardedTrainingCopyView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_121});
  initMetadataForCompanion(Companion_99);
  initMetadataForObject($serializer_123, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DiscardTrainingCopyRequest, 'DiscardTrainingCopyRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_122});
  initMetadataForObject(ConfigAreaKeys, 'ConfigAreaKeys');
  initMetadataForCompanion(Companion_100);
  initMetadataForObject($serializer_124, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ConfigSourceRefView, 'ConfigSourceRefView', ConfigSourceRefView, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_123});
  initMetadataForCompanion(Companion_101);
  initMetadataForObject($serializer_125, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TableDiffView, 'TableDiffView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_124});
  initMetadataForObject($serializer_126, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RowRefView, 'RowRefView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_125});
  initMetadataForCompanion(Companion_102);
  initMetadataForObject($serializer_127, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RowChangeView, 'RowChangeView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_126});
  initMetadataForObject($serializer_128, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(FieldChangeView, 'FieldChangeView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_127});
  initMetadataForObject($serializer_129, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ReadinessItemView, 'ReadinessItemView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_128});
  initMetadataForCompanion(Companion_103);
  initMetadataForObject($serializer_130, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OwnerInvitationStatusView, 'OwnerInvitationStatusView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_129});
  initMetadataForCompanion(Companion_104);
  initMetadataForObject($serializer_131, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OwnerInvitationDeliveryView, 'OwnerInvitationDeliveryView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_130});
  initMetadataForCompanion(Companion_105);
  initMetadataForObject($serializer_132, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OwnerInvitationOneTimeView, 'OwnerInvitationOneTimeView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_131});
  initMetadataForCompanion(Companion_106);
  initMetadataForObject($serializer_133, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopySourceView, 'SetupCopySourceView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_132});
  initMetadataForCompanion(Companion_107);
  initMetadataForObject($serializer_134, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupFormOptionsView, 'SetupFormOptionsView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_133});
  initMetadataForCompanion(Companion_108);
  initMetadataForObject($serializer_135, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantAddressAvailabilityView, 'TenantAddressAvailabilityView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_134});
  initMetadataForCompanion(Companion_109);
  initMetadataForObject($serializer_136, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupDraftView, 'SetupDraftView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_135});
  initMetadataForCompanion(Companion_110, VOID, [SerializerFactory]);
  initMetadataForClass(SetupDraftState, 'SetupDraftState', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_110});
  initMetadataForCompanion(Companion_111);
  initMetadataForObject($serializer_137, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(CreateSetupDraftRequest, 'CreateSetupDraftRequest', CreateSetupDraftRequest, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_136});
  initMetadataForCompanion(Companion_112, VOID, [SerializerFactory]);
  initMetadataForClass(SetupDraftStep, 'SetupDraftStep', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_112});
  initMetadataForCompanion(Companion_113);
  initMetadataForObject($serializer_138, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SaveSetupDraftRequest, 'SaveSetupDraftRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_137});
  initMetadataForObject($serializer_139, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupAppearancePaletteView, 'SetupAppearancePaletteView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_138});
  initMetadataForCompanion(Companion_114);
  initMetadataForObject($serializer_140, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupDraftAnswers, 'SetupDraftAnswers', SetupDraftAnswers, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_139});
  initMetadataForCompanion(Companion_115, VOID, [SerializerFactory]);
  initMetadataForClass(SetupStartMode, 'SetupStartMode', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_115});
  initMetadataForCompanion(Companion_116, VOID, [SerializerFactory]);
  initMetadataForClass(TenantAddressState, 'TenantAddressState', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_116});
  initMetadataForCompanion(Companion_117);
  initMetadataForObject($serializer_141, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RemovedByPlanItem, 'RemovedByPlanItem', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_140});
  initMetadataForCompanion(Companion_118, VOID, [SerializerFactory]);
  initMetadataForClass(RemovedByPlanKind, 'RemovedByPlanKind', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_118});
  initMetadataForObject(ConsoleTenantBrandingPaths, 'ConsoleTenantBrandingPaths');
  initMetadataForObject(ConsoleTenantConnectionLifecyclePaths, 'ConsoleTenantConnectionLifecyclePaths');
  initMetadataForObject(ConsoleTenantConnectionPaths, 'ConsoleTenantConnectionPaths');
  initMetadataForObject(ManagedAssignmentSettingsPolicy, 'ManagedAssignmentSettingsPolicy');
  initMetadataForCompanion(Companion_119);
  initMetadataForObject($serializer_142, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MarketplaceSubmissionList, 'MarketplaceSubmissionList', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_141});
  initMetadataForCompanion(Companion_120);
  initMetadataForObject($serializer_143, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MarketplaceSubmissionDetail, 'MarketplaceSubmissionDetail', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_142});
  initMetadataForObject(MarketplacePaths, 'MarketplacePaths');
  initMetadataForCompanion(Companion_121);
  initMetadataForObject($serializer_144, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MarketplaceDecision, 'MarketplaceDecision', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_143});
  initMetadataForCompanion(Companion_122);
  initMetadataForObject($serializer_145, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MarketplaceDecisionBody, 'MarketplaceDecisionBody', MarketplaceDecisionBody, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_144});
  initMetadataForObject($serializer_146, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(MarketplaceSubmissionRow, 'MarketplaceSubmissionRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_145});
  initMetadataForCompanion(Companion_123);
  initMetadataForObject($serializer_147, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OfferReadinessView, 'OfferReadinessView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_146});
  initMetadataForCompanion(Companion_124);
  initMetadataForObject($serializer_148, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OfferAllowance, 'OfferAllowance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_147});
  initMetadataForObject($serializer_149, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OfferReadinessIssue, 'OfferReadinessIssue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_148});
  initMetadataForCompanion(Companion_125);
  initMetadataForObject($serializer_150, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OfferReadinessCounts, 'OfferReadinessCounts', OfferReadinessCounts, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_149});
  initMetadataForObject($serializer_151, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OfferFeatureReadiness, 'OfferFeatureReadiness', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_150});
  initMetadataForObject($serializer_152, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OfferPriceTerm, 'OfferPriceTerm', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_151});
  initMetadataForCompanion(Companion_126);
  initMetadataForObject($serializer_153, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(OfferRuntimeEvidence, 'OfferRuntimeEvidence', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_152});
  initMetadataForCompanion(Companion_127);
  initMetadataForObject($serializer_154, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanDeletionResult, 'PlanDeletionResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_153});
  initMetadataForCompanion(Companion_128);
  initMetadataForObject($serializer_155, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DeletePlanRequest, 'DeletePlanRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_154});
  initMetadataForClass(FeatureSelectionProposal, 'FeatureSelectionProposal');
  initMetadataForObject(PlanFeatureSelection, 'PlanFeatureSelection');
  initMetadataForCompanion(Companion_129);
  initMetadataForObject($serializer_156, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanImpactPreview, 'PlanImpactPreview', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_155});
  initMetadataForCompanion(Companion_130);
  initMetadataForObject($serializer_157, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(ImpactLabel, 'ImpactLabel', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_156});
  initMetadataForCompanion(Companion_131);
  initMetadataForObject($serializer_158, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanNavigationPreview, 'PlanNavigationPreview', PlanNavigationPreview, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_157});
  initMetadataForCompanion(Companion_132);
  initMetadataForObject($serializer_159, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantPlanImpact, 'TenantPlanImpact', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_158});
  initMetadataForObject($serializer_160, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanNavigationIssue, 'PlanNavigationIssue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_159});
  initMetadataForCompanion(Companion_133, VOID, [SerializerFactory]);
  initMetadataForClass(PlanUsageEvidence, 'PlanUsageEvidence', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_133});
  initMetadataForCompanion(Companion_134);
  initMetadataForObject($serializer_161, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanLimitUsageImpact, 'PlanLimitUsageImpact', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_160});
  initMetadataForCompanion(Companion_135, VOID, [SerializerFactory]);
  initMetadataForClass(PlanWorkEvidence, 'PlanWorkEvidence', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_135});
  initMetadataForCompanion(Companion_136);
  initMetadataForObject($serializer_162, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanPausedWorkImpact, 'PlanPausedWorkImpact', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_161});
  initMetadataForCompanion(Companion_137);
  initMetadataForObject($serializer_163, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanWorkImpact, 'PlanWorkImpact', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_162});
  initMetadataForObject($serializer_164, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanLimitImpact, 'PlanLimitImpact', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_163});
  initMetadataForObject(PlanKeys, 'PlanKeys');
  initMetadataForCompanion(Companion_138);
  initMetadataForObject($serializer_165, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanLifecycleResult, 'PlanLifecycleResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_164});
  initMetadataForClass(PlanLifecycleAction, 'PlanLifecycleAction', VOID, Enum);
  initMetadataForCompanion(Companion_139);
  initMetadataForObject($serializer_166, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanLifecycleRequest, 'PlanLifecycleRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_165});
  initMetadataForObject(PlanLifecyclePaths, 'PlanLifecyclePaths');
  initMetadataForCompanion(Companion_140);
  initMetadataForObject($serializer_167, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DuplicatePlanRequest, 'DuplicatePlanRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_166});
  initMetadataForObject(PlanLifecycleRules, 'PlanLifecycleRules');
  initMetadataForCompanion(Companion_141);
  initMetadataForObject($serializer_168, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SandboxRequestList, 'SandboxRequestList', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_167});
  initMetadataForCompanion(Companion_142);
  initMetadataForObject($serializer_169, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SandboxRequestDecision, 'SandboxRequestDecision', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_168});
  initMetadataForObject(SandboxRequestPaths, 'SandboxRequestPaths');
  initMetadataForCompanion(Companion_143);
  initMetadataForObject($serializer_170, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SandboxProvisionBody, 'SandboxProvisionBody', SandboxProvisionBody, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_169});
  initMetadataForCompanion(Companion_144);
  initMetadataForObject($serializer_171, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SandboxDeclineBody, 'SandboxDeclineBody', SandboxDeclineBody, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_170});
  initMetadataForObject($serializer_172, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SandboxRequestRow, 'SandboxRequestRow', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_171});
  initMetadataForCompanion(Companion_145);
  initMetadataForObject($serializer_173, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupAcceptanceResult, 'SetupAcceptanceResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_172});
  initMetadataForCompanion(Companion_146);
  initMetadataForObject($serializer_174, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AcceptSetupDraftRequest, 'AcceptSetupDraftRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_173});
  initMetadataForCompanion(Companion_147);
  initMetadataForObject($serializer_175, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupAppearanceChoices, 'SetupAppearanceChoices', SetupAppearanceChoices, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_174});
  initMetadataForClass(SetupAppearanceValidation, 'SetupAppearanceValidation');
  initMetadataForObject(SetupAppearanceRules, 'SetupAppearanceRules');
  initMetadataForCompanion(Companion_148);
  initMetadataForObject($serializer_176, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupAttemptView, 'SetupAttemptView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_175});
  initMetadataForCompanion(Companion_149);
  initMetadataForObject($serializer_177, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupAttemptResumeReceipt, 'SetupAttemptResumeReceipt', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_176});
  initMetadataForObject($serializer_178, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupAttemptStepView, 'SetupAttemptStepView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_177});
  initMetadataForObject(SetupAttemptResumeRules, 'SetupAttemptResumeRules');
  initMetadataForCompanion(Companion_150);
  initMetadataForObject($serializer_179, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCompletionView, 'SetupCompletionView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_178});
  initMetadataForObject(SetupCompletionApiPaths, 'SetupCompletionApiPaths');
  initMetadataForCompanion(Companion_151);
  initMetadataForObject($serializer_180, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupLimitGrant, 'SetupLimitGrant', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_179});
  initMetadataForObject($serializer_181, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupAcceptedPlanRecord, 'SetupAcceptedPlanRecord', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_180});
  initMetadataForCompanion(Companion_152);
  initMetadataForObject($serializer_182, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupAcceptedPlanDetails, 'SetupAcceptedPlanDetails', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_181});
  initMetadataForObject($serializer_183, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupNamedGrant, 'SetupNamedGrant', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_182});
  initMetadataForObject($serializer_184, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCurrentPlanSummary, 'SetupCurrentPlanSummary', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_183});
  initMetadataForCompanion(Companion_153);
  initMetadataForObject($serializer_185, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCurrentGrantsSummary, 'SetupCurrentGrantsSummary', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_184});
  initMetadataForObject($serializer_186, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCompletionTask, 'SetupCompletionTask', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_185});
  initMetadataForObject($serializer_187, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCompletionAvailability, 'SetupCompletionAvailability', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_186});
  initMetadataForCompanion(Companion_154);
  initMetadataForObject($serializer_188, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionDeferralView, 'SetupConnectionDeferralView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_187});
  initMetadataForObject(SetupConnectionDeferralApiPaths, 'SetupConnectionDeferralApiPaths');
  initMetadataForCompanion(Companion_155);
  initMetadataForObject($serializer_189, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionDeferralReceipt, 'SetupConnectionDeferralReceipt', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_188});
  initMetadataForCompanion(Companion_156);
  initMetadataForObject($serializer_190, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionDeferralRequest, 'SetupConnectionDeferralRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_189});
  initMetadataForCompanion(Companion_157);
  initMetadataForObject($serializer_191, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionDeferralDecisionView, 'SetupConnectionDeferralDecisionView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_190});
  initMetadataForCompanion(Companion_158, VOID, [SerializerFactory]);
  initMetadataForClass(SetupConnectionDeferralScope, 'SetupConnectionDeferralScope', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_158});
  initMetadataForCompanion(Companion_159, VOID, [SerializerFactory]);
  initMetadataForClass(SetupConnectionDeferralDecision, 'SetupConnectionDeferralDecision', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_159});
  initMetadataForCompanion(Companion_160);
  initMetadataForObject($serializer_192, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionsReadView, 'SetupConnectionsReadView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_191});
  initMetadataForCompanion(Companion_161);
  initMetadataForObject($serializer_193, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionProviderView, 'SetupConnectionProviderView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_192});
  initMetadataForCompanion(Companion_162);
  initMetadataForObject($serializer_194, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionOperationView, 'SetupConnectionOperationView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_193});
  initMetadataForCompanion(Companion_163);
  initMetadataForObject($serializer_195, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionFieldView, 'SetupConnectionFieldView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_194});
  initMetadataForObject($serializer_196, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupConnectionAccountView, 'SetupConnectionAccountView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_195});
  initMetadataForCompanion(Companion_164, VOID, [SerializerFactory]);
  initMetadataForClass(SetupCopiedImageChoice, 'SetupCopiedImageChoice', VOID, Enum, VOID, VOID, VOID, {0: Companion_getInstance_164});
  initMetadataForCompanion(Companion_165);
  initMetadataForObject($serializer_197, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopiedImageChoices, 'SetupCopiedImageChoices', SetupCopiedImageChoices, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_196});
  initMetadataForObject(SetupCopiedImageRules, 'SetupCopiedImageRules');
  initMetadataForCompanion(Companion_166);
  initMetadataForObject($serializer_198, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyPreviewView, 'SetupCopyPreviewView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_197});
  initMetadataForCompanion(Companion_167);
  initMetadataForObject($serializer_199, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PreviewSetupCopyRequest, 'PreviewSetupCopyRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_198});
  initMetadataForObject($serializer_200, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyExceptionView, 'SetupCopyExceptionView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_199});
  initMetadataForCompanion(Companion_168);
  initMetadataForObject($serializer_201, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyPreviewCategoryView, 'SetupCopyPreviewCategoryView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_200});
  initMetadataForCompanion(Companion_169);
  initMetadataForObject($serializer_202, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyPreviewEligibilityView, 'SetupCopyPreviewEligibilityView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_201});
  initMetadataForObject($serializer_203, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyExportIssueView, 'SetupCopyExportIssueView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_202});
  initMetadataForCompanion(Companion_170);
  initMetadataForObject($serializer_204, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyStatusView, 'SetupCopyStatusView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_203});
  initMetadataForObject(SetupCopyStatusRules, 'SetupCopyStatusRules');
  initMetadataForCompanion(Companion_171);
  initMetadataForObject($serializer_205, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyCategoryStatusView, 'SetupCopyCategoryStatusView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_204});
  initMetadataForObject($serializer_206, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupCopyItemNoteView, 'SetupCopyItemNoteView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_205});
  initMetadataForCompanion(Companion_172);
  initMetadataForObject($serializer_207, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupDraftReviewView, 'SetupDraftReviewView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_206});
  initMetadataForObject(SetupPlanRules, 'SetupPlanRules');
  initMetadataForCompanion(Companion_173);
  initMetadataForObject($serializer_208, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpActivationReceipt, 'SetupSmtpActivationReceipt', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_207});
  initMetadataForCompanion(Companion_174);
  initMetadataForObject($serializer_209, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpActivationRequest, 'SetupSmtpActivationRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_208});
  initMetadataForCompanion(Companion_175);
  initMetadataForObject($serializer_210, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpConfigurationReceipt, 'SetupSmtpConfigurationReceipt', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_209});
  initMetadataForCompanion(Companion_176);
  initMetadataForObject($serializer_211, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpConfigurationRequest, 'SetupSmtpConfigurationRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_210});
  initMetadataForCompanion(Companion_177);
  initMetadataForObject($serializer_212, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpConfigurationRecovery, 'SetupSmtpConfigurationRecovery', SetupSmtpConfigurationRecovery, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_211});
  initMetadataForCompanion(Companion_178);
  initMetadataForObject($serializer_213, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpOriginView, 'SetupSmtpOriginView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_212});
  initMetadataForCompanion(Companion_179);
  initMetadataForObject($serializer_214, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpVerificationReceipt, 'SetupSmtpVerificationReceipt', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_213});
  initMetadataForCompanion(Companion_180);
  initMetadataForObject($serializer_215, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpVerificationRequest, 'SetupSmtpVerificationRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_214});
  initMetadataForCompanion(Companion_181);
  initMetadataForObject($serializer_216, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SetupSmtpVerificationRecovery, 'SetupSmtpVerificationRecovery', SetupSmtpVerificationRecovery, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_215});
  initMetadataForCompanion(Companion_182);
  initMetadataForObject($serializer_217, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionCommitmentState, 'SubscriptionCommitmentState', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_216});
  initMetadataForObject(SubscriptionCommitmentPaths, 'SubscriptionCommitmentPaths');
  initMetadataForCompanion(Companion_183);
  initMetadataForObject($serializer_218, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionCommitmentPreview, 'SubscriptionCommitmentPreview', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_217});
  initMetadataForCompanion(Companion_184);
  initMetadataForObject($serializer_219, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionCommitmentPreviewRequest, 'SubscriptionCommitmentPreviewRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_218});
  initMetadataForCompanion(Companion_185);
  initMetadataForObject($serializer_220, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionCommitmentSaveResult, 'SubscriptionCommitmentSaveResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_219});
  initMetadataForCompanion(Companion_186);
  initMetadataForObject($serializer_221, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SaveSubscriptionCommitmentRequest, 'SaveSubscriptionCommitmentRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_220});
  initMetadataForObject($serializer_222, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionCommitmentInstallment, 'SubscriptionCommitmentInstallment', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_221});
  initMetadataForObject($serializer_223, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionUsageLine, 'SubscriptionUsageLine', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_222});
  initMetadataForCompanion(Companion_187);
  initMetadataForObject($serializer_224, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionCommitmentView, 'SubscriptionCommitmentView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_223});
  initMetadataForCompanion(Companion_188);
  initMetadataForObject($serializer_225, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SupportVisitPreparationView, 'SupportVisitPreparationView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_224});
  initMetadataForCompanion(Companion_189);
  initMetadataForObject($serializer_226, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SupportVisitOpenRequest, 'SupportVisitOpenRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_225});
  initMetadataForObject(ConsoleSupportVisitPaths, 'ConsoleSupportVisitPaths');
  initMetadataForCompanion(Companion_190);
  initMetadataForObject($serializer_227, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SupportVisitView, 'SupportVisitView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_226});
  initMetadataForCompanion(Companion_191);
  initMetadataForObject($serializer_228, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SupportVisitHistoryView, 'SupportVisitHistoryView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_227});
  initMetadataForObject(TenantAccessPaths, 'TenantAccessPaths');
  initMetadataForCompanion(Companion_192);
  initMetadataForObject($serializer_229, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(EffectiveAccessView, 'EffectiveAccessView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_228});
  initMetadataForCompanion(Companion_193);
  initMetadataForObject($serializer_230, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanChangePreviewView, 'PlanChangePreviewView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_229});
  initMetadataForCompanion(Companion_194);
  initMetadataForObject($serializer_231, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(PlanChangePreviewRequest, 'PlanChangePreviewRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_230});
  initMetadataForCompanion(Companion_195);
  initMetadataForObject($serializer_232, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(SubscriptionChangeResult, 'SubscriptionChangeResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_231});
  initMetadataForCompanion(Companion_196);
  initMetadataForObject($serializer_233, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantExceptionRemovalResult, 'TenantExceptionRemovalResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_232});
  initMetadataForCompanion(Companion_197);
  initMetadataForObject($serializer_234, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(RemoveTenantExceptionRequest, 'RemoveTenantExceptionRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_233});
  initMetadataForObject(TenantAccessRules, 'TenantAccessRules');
  initMetadataForObject($serializer_235, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AccessExceptionView, 'AccessExceptionView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_234});
  initMetadataForObject($serializer_236, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AccessPlanRef, 'AccessPlanRef', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_235});
  initMetadataForCompanion(Companion_198);
  initMetadataForObject($serializer_237, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(EffectiveModuleAccess, 'EffectiveModuleAccess', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_236});
  initMetadataForCompanion(Companion_199);
  initMetadataForObject($serializer_238, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(EffectiveFeatureAccess, 'EffectiveFeatureAccess', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_237});
  initMetadataForObject($serializer_239, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(AccessGrantSource, 'AccessGrantSource', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_238});
  initMetadataForObject($serializer_240, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(WithheldAccess, 'WithheldAccess', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_239});
  initMetadataForCompanion(Companion_200);
  initMetadataForObject($serializer_241, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(EffectiveLimitAccess, 'EffectiveLimitAccess', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_240});
  initMetadataForCompanion(Companion_201);
  initMetadataForObject($serializer_242, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantHealthList, 'TenantHealthList', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_241});
  initMetadataForCompanion(Companion_202);
  initMetadataForObject($serializer_243, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantHealthDto, 'TenantHealthDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_242});
  initMetadataForObject(TenantHealthPaths, 'TenantHealthPaths');
  initMetadataForCompanion(Companion_203);
  initMetadataForObject($serializer_244, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantHealthAckResult, 'TenantHealthAckResult', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_243});
  initMetadataForCompanion(Companion_204);
  initMetadataForObject($serializer_245, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantHealthAckBody, 'TenantHealthAckBody', TenantHealthAckBody, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_244});
  initMetadataForObject($serializer_246, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(HealthDimensionDto, 'HealthDimensionDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_245});
  initMetadataForObject($serializer_247, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantHealthAckDto, 'TenantHealthAckDto', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_246});
  initMetadataForObject(TenantLifecycleActions, 'TenantLifecycleActions');
  initMetadataForCompanion(Companion_205);
  initMetadataForObject($serializer_248, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(TenantSetupLookupView, 'TenantSetupLookupView', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_247});
  initMetadataForObject(TenantSetupLookupApiPaths, 'TenantSetupLookupApiPaths');
  //endregion
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a1j_1 = [null, null, new ArrayListSerializer($serializer_getInstance_234()), null, null, null];
  }
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantOverrideSaveResult', this, 6);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('exception', false);
    tmp0_serialDesc.gy('replaced', true);
    tmp0_serialDesc.gy('effective', false);
    tmp0_serialDesc.gy('accessVersion', false);
    tmp0_serialDesc.gy('replayed', true);
    this.b1j_1 = tmp0_serialDesc;
  }
  protoOf($serializer).c1j = function (encoder, value) {
    var tmp0_desc = this.b1j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance().a1j_1;
    tmp1_output.hs(tmp0_desc, 0, value.d1j_1);
    tmp1_output.js(tmp0_desc, 1, $serializer_getInstance_234(), value.e1j_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !equals(value.f1j_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.f1j_1);
    }
    tmp1_output.zr(tmp0_desc, 3, value.g1j_1);
    tmp1_output.ds(tmp0_desc, 4, value.h1j_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.i1j_1 === false)) {
      tmp1_output.zr(tmp0_desc, 5, value.i1j_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer).on = function (encoder, value) {
    return this.c1j(encoder, value instanceof TenantOverrideSaveResult ? value : THROW_CCE());
  };
  protoOf($serializer).pn = function (decoder) {
    var tmp0_desc = this.b1j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = false;
    var tmp10_input = decoder.tq(tmp0_desc);
    var tmp11_cached = Companion_getInstance().a1j_1;
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.fr(tmp0_desc, 1, $serializer_getInstance_234(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.fr(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.vq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.fr(tmp0_desc, 1, $serializer_getInstance_234(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.fr(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.vq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return TenantOverrideSaveResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer).nn = function () {
    return this.b1j_1;
  };
  protoOf($serializer).vy = function () {
    var tmp0_cached = Companion_getInstance().a1j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_234(), tmp0_cached[2], BooleanSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function TenantOverrideSaveResult_init_$Init$(seen0, tenantId, exception, replaced, effective, accessVersion, replayed, serializationConstructorMarker, $this) {
    if (!(27 === (27 & seen0))) {
      throwMissingFieldException(seen0, 27, $serializer_getInstance().b1j_1);
    }
    $this.d1j_1 = tenantId;
    $this.e1j_1 = exception;
    if (0 === (seen0 & 4))
      $this.f1j_1 = emptyList();
    else
      $this.f1j_1 = replaced;
    $this.g1j_1 = effective;
    $this.h1j_1 = accessVersion;
    if (0 === (seen0 & 32))
      $this.i1j_1 = false;
    else
      $this.i1j_1 = replayed;
    return $this;
  }
  function TenantOverrideSaveResult_init_$Create$(seen0, tenantId, exception, replaced, effective, accessVersion, replayed, serializationConstructorMarker) {
    return TenantOverrideSaveResult_init_$Init$(seen0, tenantId, exception, replaced, effective, accessVersion, replayed, serializationConstructorMarker, objectCreate(protoOf(TenantOverrideSaveResult)));
  }
  function TenantOverrideSaveResult(tenantId, exception, replaced, effective, accessVersion, replayed) {
    Companion_getInstance();
    replaced = replaced === VOID ? emptyList() : replaced;
    replayed = replayed === VOID ? false : replayed;
    this.d1j_1 = tenantId;
    this.e1j_1 = exception;
    this.f1j_1 = replaced;
    this.g1j_1 = effective;
    this.h1j_1 = accessVersion;
    this.i1j_1 = replayed;
  }
  protoOf(TenantOverrideSaveResult).toString = function () {
    return 'TenantOverrideSaveResult(tenantId=' + this.d1j_1 + ', exception=' + this.e1j_1.toString() + ', replaced=' + toString(this.f1j_1) + ', effective=' + this.g1j_1 + ', accessVersion=' + this.h1j_1.toString() + ', replayed=' + this.i1j_1 + ')';
  };
  protoOf(TenantOverrideSaveResult).hashCode = function () {
    var result = getStringHashCode(this.d1j_1);
    result = imul(result, 31) + this.e1j_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.f1j_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g1j_1) | 0;
    result = imul(result, 31) + this.h1j_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i1j_1) | 0;
    return result;
  };
  protoOf(TenantOverrideSaveResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantOverrideSaveResult))
      return false;
    var tmp0_other_with_cast = other instanceof TenantOverrideSaveResult ? other : THROW_CCE();
    if (!(this.d1j_1 === tmp0_other_with_cast.d1j_1))
      return false;
    if (!this.e1j_1.equals(tmp0_other_with_cast.e1j_1))
      return false;
    if (!equals(this.f1j_1, tmp0_other_with_cast.f1j_1))
      return false;
    if (!(this.g1j_1 === tmp0_other_with_cast.g1j_1))
      return false;
    if (!this.h1j_1.equals(tmp0_other_with_cast.h1j_1))
      return false;
    if (!(this.i1j_1 === tmp0_other_with_cast.i1j_1))
      return false;
    return true;
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddonPackSaveResult', this, 4);
    tmp0_serialDesc.gy('pack', false);
    tmp0_serialDesc.gy('created', false);
    tmp0_serialDesc.gy('tenantsRepublished', false);
    tmp0_serialDesc.gy('replayed', true);
    this.j1j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).k1j = function (encoder, value) {
    var tmp0_desc = this.j1j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_60(), value.l1j_1);
    tmp1_output.zr(tmp0_desc, 1, value.m1j_1);
    tmp1_output.cs(tmp0_desc, 2, value.n1j_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.o1j_1 === false)) {
      tmp1_output.zr(tmp0_desc, 3, value.o1j_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_0).on = function (encoder, value) {
    return this.k1j(encoder, value instanceof AddonPackSaveResult ? value : THROW_CCE());
  };
  protoOf($serializer_0).pn = function (decoder) {
    var tmp0_desc = this.j1j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = 0;
    var tmp7_local3 = false;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_60(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.yq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_60(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.yq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return AddonPackSaveResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_0).nn = function () {
    return this.j1j_1;
  };
  protoOf($serializer_0).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_60(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_0() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function AddonPackSaveResult_init_$Init$(seen0, pack, created, tenantsRepublished, replayed, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_0().j1j_1);
    }
    $this.l1j_1 = pack;
    $this.m1j_1 = created;
    $this.n1j_1 = tenantsRepublished;
    if (0 === (seen0 & 8))
      $this.o1j_1 = false;
    else
      $this.o1j_1 = replayed;
    return $this;
  }
  function AddonPackSaveResult_init_$Create$(seen0, pack, created, tenantsRepublished, replayed, serializationConstructorMarker) {
    return AddonPackSaveResult_init_$Init$(seen0, pack, created, tenantsRepublished, replayed, serializationConstructorMarker, objectCreate(protoOf(AddonPackSaveResult)));
  }
  function AddonPackSaveResult(pack, created, tenantsRepublished, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.l1j_1 = pack;
    this.m1j_1 = created;
    this.n1j_1 = tenantsRepublished;
    this.o1j_1 = replayed;
  }
  protoOf(AddonPackSaveResult).toString = function () {
    return 'AddonPackSaveResult(pack=' + this.l1j_1.toString() + ', created=' + this.m1j_1 + ', tenantsRepublished=' + this.n1j_1 + ', replayed=' + this.o1j_1 + ')';
  };
  protoOf(AddonPackSaveResult).hashCode = function () {
    var result = this.l1j_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.m1j_1) | 0;
    result = imul(result, 31) + this.n1j_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o1j_1) | 0;
    return result;
  };
  protoOf(AddonPackSaveResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddonPackSaveResult))
      return false;
    var tmp0_other_with_cast = other instanceof AddonPackSaveResult ? other : THROW_CCE();
    if (!this.l1j_1.equals(tmp0_other_with_cast.l1j_1))
      return false;
    if (!(this.m1j_1 === tmp0_other_with_cast.m1j_1))
      return false;
    if (!(this.n1j_1 === tmp0_other_with_cast.n1j_1))
      return false;
    if (!(this.o1j_1 === tmp0_other_with_cast.o1j_1))
      return false;
    return true;
  };
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p1j_1 = [null, new ArrayListSerializer($serializer_getInstance_156()), null, null];
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LimitPolicySaveResult', this, 4);
    tmp0_serialDesc.gy('limit', false);
    tmp0_serialDesc.gy('plansUpdated', true);
    tmp0_serialDesc.gy('tenantsRepublished', true);
    tmp0_serialDesc.gy('replayed', true);
    this.q1j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).r1j = function (encoder, value) {
    var tmp0_desc = this.q1j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().p1j_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_86(), value.s1j_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !equals(value.t1j_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.t1j_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.u1j_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 2, value.u1j_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.v1j_1 === false)) {
      tmp1_output.zr(tmp0_desc, 3, value.v1j_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_1).on = function (encoder, value) {
    return this.r1j(encoder, value instanceof LimitPolicySaveResult ? value : THROW_CCE());
  };
  protoOf($serializer_1).pn = function (decoder) {
    var tmp0_desc = this.q1j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = false;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_1().p1j_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_86(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.yq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_86(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.yq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return LimitPolicySaveResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_1).nn = function () {
    return this.q1j_1;
  };
  protoOf($serializer_1).vy = function () {
    var tmp0_cached = Companion_getInstance_1().p1j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_86(), tmp0_cached[1], IntSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_1() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function LimitPolicySaveResult_init_$Init$(seen0, limit, plansUpdated, tenantsRepublished, replayed, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_1().q1j_1);
    }
    $this.s1j_1 = limit;
    if (0 === (seen0 & 2))
      $this.t1j_1 = emptyList();
    else
      $this.t1j_1 = plansUpdated;
    if (0 === (seen0 & 4))
      $this.u1j_1 = 0;
    else
      $this.u1j_1 = tenantsRepublished;
    if (0 === (seen0 & 8))
      $this.v1j_1 = false;
    else
      $this.v1j_1 = replayed;
    return $this;
  }
  function LimitPolicySaveResult_init_$Create$(seen0, limit, plansUpdated, tenantsRepublished, replayed, serializationConstructorMarker) {
    return LimitPolicySaveResult_init_$Init$(seen0, limit, plansUpdated, tenantsRepublished, replayed, serializationConstructorMarker, objectCreate(protoOf(LimitPolicySaveResult)));
  }
  function LimitPolicySaveResult(limit, plansUpdated, tenantsRepublished, replayed) {
    Companion_getInstance_1();
    plansUpdated = plansUpdated === VOID ? emptyList() : plansUpdated;
    tenantsRepublished = tenantsRepublished === VOID ? 0 : tenantsRepublished;
    replayed = replayed === VOID ? false : replayed;
    this.s1j_1 = limit;
    this.t1j_1 = plansUpdated;
    this.u1j_1 = tenantsRepublished;
    this.v1j_1 = replayed;
  }
  protoOf(LimitPolicySaveResult).toString = function () {
    return 'LimitPolicySaveResult(limit=' + this.s1j_1.toString() + ', plansUpdated=' + toString(this.t1j_1) + ', tenantsRepublished=' + this.u1j_1 + ', replayed=' + this.v1j_1 + ')';
  };
  protoOf(LimitPolicySaveResult).hashCode = function () {
    var result = this.s1j_1.hashCode();
    result = imul(result, 31) + hashCode(this.t1j_1) | 0;
    result = imul(result, 31) + this.u1j_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v1j_1) | 0;
    return result;
  };
  protoOf(LimitPolicySaveResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LimitPolicySaveResult))
      return false;
    var tmp0_other_with_cast = other instanceof LimitPolicySaveResult ? other : THROW_CCE();
    if (!this.s1j_1.equals(tmp0_other_with_cast.s1j_1))
      return false;
    if (!equals(this.t1j_1, tmp0_other_with_cast.t1j_1))
      return false;
    if (!(this.u1j_1 === tmp0_other_with_cast.u1j_1))
      return false;
    if (!(this.v1j_1 === tmp0_other_with_cast.v1j_1))
      return false;
    return true;
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UpdateLimitPolicyRequest', this, 9);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('unit', false);
    tmp0_serialDesc.gy('period', false);
    tmp0_serialDesc.gy('currency', true);
    tmp0_serialDesc.gy('policy', true);
    tmp0_serialDesc.gy('mode', true);
    tmp0_serialDesc.gy('expectedRevision', false);
    tmp0_serialDesc.gy('reason', false);
    this.w1j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).x1j = function (encoder, value) {
    var tmp0_desc = this.w1j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.y1j_1);
    tmp1_output.hs(tmp0_desc, 1, value.z1j_1);
    tmp1_output.hs(tmp0_desc, 2, value.a1k_1);
    tmp1_output.hs(tmp0_desc, 3, value.b1k_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.c1k_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.c1k_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.d1k_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.d1k_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.e1k_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.e1k_1);
    }
    tmp1_output.hs(tmp0_desc, 7, value.f1k_1);
    tmp1_output.hs(tmp0_desc, 8, value.g1k_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_2).on = function (encoder, value) {
    return this.x1j(encoder, value instanceof UpdateLimitPolicyRequest ? value : THROW_CCE());
  };
  protoOf($serializer_2).pn = function (decoder) {
    var tmp0_desc = this.w1j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return UpdateLimitPolicyRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_2).nn = function () {
    return this.w1j_1;
  };
  protoOf($serializer_2).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_2() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function UpdateLimitPolicyRequest_init_$Init$(seen0, nameEn, nameAr, unit, period, currency, policy, mode, expectedRevision, reason, serializationConstructorMarker, $this) {
    if (!(399 === (399 & seen0))) {
      throwMissingFieldException(seen0, 399, $serializer_getInstance_2().w1j_1);
    }
    $this.y1j_1 = nameEn;
    $this.z1j_1 = nameAr;
    $this.a1k_1 = unit;
    $this.b1k_1 = period;
    if (0 === (seen0 & 16))
      $this.c1k_1 = null;
    else
      $this.c1k_1 = currency;
    if (0 === (seen0 & 32))
      $this.d1k_1 = null;
    else
      $this.d1k_1 = policy;
    if (0 === (seen0 & 64))
      $this.e1k_1 = null;
    else
      $this.e1k_1 = mode;
    $this.f1k_1 = expectedRevision;
    $this.g1k_1 = reason;
    return $this;
  }
  function UpdateLimitPolicyRequest_init_$Create$(seen0, nameEn, nameAr, unit, period, currency, policy, mode, expectedRevision, reason, serializationConstructorMarker) {
    return UpdateLimitPolicyRequest_init_$Init$(seen0, nameEn, nameAr, unit, period, currency, policy, mode, expectedRevision, reason, serializationConstructorMarker, objectCreate(protoOf(UpdateLimitPolicyRequest)));
  }
  function UpdateLimitPolicyRequest(nameEn, nameAr, unit, period, currency, policy, mode, expectedRevision, reason) {
    currency = currency === VOID ? null : currency;
    policy = policy === VOID ? null : policy;
    mode = mode === VOID ? null : mode;
    this.y1j_1 = nameEn;
    this.z1j_1 = nameAr;
    this.a1k_1 = unit;
    this.b1k_1 = period;
    this.c1k_1 = currency;
    this.d1k_1 = policy;
    this.e1k_1 = mode;
    this.f1k_1 = expectedRevision;
    this.g1k_1 = reason;
  }
  protoOf(UpdateLimitPolicyRequest).toString = function () {
    return 'UpdateLimitPolicyRequest(nameEn=' + this.y1j_1 + ', nameAr=' + this.z1j_1 + ', unit=' + this.a1k_1 + ', period=' + this.b1k_1 + ', currency=' + this.c1k_1 + ', policy=' + this.d1k_1 + ', mode=' + this.e1k_1 + ', expectedRevision=' + this.f1k_1 + ', reason=' + this.g1k_1 + ')';
  };
  protoOf(UpdateLimitPolicyRequest).hashCode = function () {
    var result = getStringHashCode(this.y1j_1);
    result = imul(result, 31) + getStringHashCode(this.z1j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1k_1) | 0;
    result = imul(result, 31) + (this.c1k_1 == null ? 0 : getStringHashCode(this.c1k_1)) | 0;
    result = imul(result, 31) + (this.d1k_1 == null ? 0 : getStringHashCode(this.d1k_1)) | 0;
    result = imul(result, 31) + (this.e1k_1 == null ? 0 : getStringHashCode(this.e1k_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1k_1) | 0;
    return result;
  };
  protoOf(UpdateLimitPolicyRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpdateLimitPolicyRequest))
      return false;
    var tmp0_other_with_cast = other instanceof UpdateLimitPolicyRequest ? other : THROW_CCE();
    if (!(this.y1j_1 === tmp0_other_with_cast.y1j_1))
      return false;
    if (!(this.z1j_1 === tmp0_other_with_cast.z1j_1))
      return false;
    if (!(this.a1k_1 === tmp0_other_with_cast.a1k_1))
      return false;
    if (!(this.b1k_1 === tmp0_other_with_cast.b1k_1))
      return false;
    if (!(this.c1k_1 == tmp0_other_with_cast.c1k_1))
      return false;
    if (!(this.d1k_1 == tmp0_other_with_cast.d1k_1))
      return false;
    if (!(this.e1k_1 == tmp0_other_with_cast.e1k_1))
      return false;
    if (!(this.f1k_1 === tmp0_other_with_cast.f1k_1))
      return false;
    if (!(this.g1k_1 === tmp0_other_with_cast.g1k_1))
      return false;
    return true;
  };
  function CatalogEditorRules() {
    CatalogEditorRules_instance = this;
    this.h1k_1 = 120;
    this.i1k_1 = 80;
    this.j1k_1 = 3650;
    this.k1k_1 = Regex_init_$Create$('^[a-z0-9][a-z0-9._-]*$');
  }
  protoOf(CatalogEditorRules).l1k = function (name) {
    var tmp;
    if (isBlank(name)) {
      tmp = 'required';
    } else {
      // Inline function 'kotlin.text.trim' call
      if (toString(trim(isCharSequence(name) ? name : THROW_CCE())).length > 120) {
        tmp = 'too_long';
      } else {
        tmp = null;
      }
    }
    return tmp;
  };
  protoOf(CatalogEditorRules).m1k = function (key) {
    var tmp;
    if (isBlank(key)) {
      tmp = 'required';
    } else {
      // Inline function 'kotlin.text.trim' call
      if (toString(trim(isCharSequence(key) ? key : THROW_CCE())).length > 80) {
        tmp = 'too_long';
      } else {
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$1 = toString(trim(isCharSequence(key) ? key : THROW_CCE()));
        if (!this.k1k_1.nd(tmp$ret$1)) {
          tmp = 'invalid_key';
        } else {
          tmp = null;
        }
      }
    }
    return tmp;
  };
  protoOf(CatalogEditorRules).n1k = function (text) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.text.any' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(text)) {
        var element = charSequenceGet(text, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ems.console.api.CatalogEditorRules.hasArabic.<anonymous>' call
        if ((_Char___init__impl__6a9atx(1536) <= element ? element <= _Char___init__impl__6a9atx(1791) : false) || (_Char___init__impl__6a9atx(1872) <= element ? element <= _Char___init__impl__6a9atx(1919) : false)) {
          tmp$ret$1 = true;
          break $l$block;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  var CatalogEditorRules_instance;
  function CatalogEditorRules_getInstance() {
    if (CatalogEditorRules_instance == null)
      new CatalogEditorRules();
    return CatalogEditorRules_instance;
  }
  function Companion_3() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o1k_1 = [new ArrayListSerializer($serializer_getInstance_7()), null];
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddonRequestList', this, 2);
    tmp0_serialDesc.gy('items', false);
    tmp0_serialDesc.gy('pendingCount', false);
    this.p1k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).q1k = function (encoder, value) {
    var tmp0_desc = this.p1k_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_3().o1k_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.r1k_1);
    tmp1_output.cs(tmp0_desc, 1, value.s1k_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_3).on = function (encoder, value) {
    return this.q1k(encoder, value instanceof AddonRequestList ? value : THROW_CCE());
  };
  protoOf($serializer_3).pn = function (decoder) {
    var tmp0_desc = this.p1k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_3().o1k_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return AddonRequestList_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).nn = function () {
    return this.p1k_1;
  };
  protoOf($serializer_3).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_3().o1k_1[0], IntSerializer_getInstance()];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_3() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function AddonRequestList_init_$Init$(seen0, items, pendingCount, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_3().p1k_1);
    }
    $this.r1k_1 = items;
    $this.s1k_1 = pendingCount;
    return $this;
  }
  function AddonRequestList_init_$Create$(seen0, items, pendingCount, serializationConstructorMarker) {
    return AddonRequestList_init_$Init$(seen0, items, pendingCount, serializationConstructorMarker, objectCreate(protoOf(AddonRequestList)));
  }
  function AddonRequestList(items, pendingCount) {
    Companion_getInstance_3();
    this.r1k_1 = items;
    this.s1k_1 = pendingCount;
  }
  protoOf(AddonRequestList).toString = function () {
    return 'AddonRequestList(items=' + toString(this.r1k_1) + ', pendingCount=' + this.s1k_1 + ')';
  };
  protoOf(AddonRequestList).hashCode = function () {
    var result = hashCode(this.r1k_1);
    result = imul(result, 31) + this.s1k_1 | 0;
    return result;
  };
  protoOf(AddonRequestList).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddonRequestList))
      return false;
    var tmp0_other_with_cast = other instanceof AddonRequestList ? other : THROW_CCE();
    if (!equals(this.r1k_1, tmp0_other_with_cast.r1k_1))
      return false;
    if (!(this.s1k_1 === tmp0_other_with_cast.s1k_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddonRequestDetail', this, 3);
    tmp0_serialDesc.gy('request', false);
    tmp0_serialDesc.gy('subscriptionId', true);
    tmp0_serialDesc.gy('planName', true);
    this.t1k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).u1k = function (encoder, value) {
    var tmp0_desc = this.t1k_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_7(), value.v1k_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.w1k_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.w1k_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.x1k_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.x1k_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_4).on = function (encoder, value) {
    return this.u1k(encoder, value instanceof AddonRequestDetail ? value : THROW_CCE());
  };
  protoOf($serializer_4).pn = function (decoder) {
    var tmp0_desc = this.t1k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_7(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_7(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return AddonRequestDetail_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_4).nn = function () {
    return this.t1k_1;
  };
  protoOf($serializer_4).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_7(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_4() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function AddonRequestDetail_init_$Init$(seen0, request, subscriptionId, planName, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_4().t1k_1);
    }
    $this.v1k_1 = request;
    if (0 === (seen0 & 2))
      $this.w1k_1 = null;
    else
      $this.w1k_1 = subscriptionId;
    if (0 === (seen0 & 4))
      $this.x1k_1 = null;
    else
      $this.x1k_1 = planName;
    return $this;
  }
  function AddonRequestDetail_init_$Create$(seen0, request, subscriptionId, planName, serializationConstructorMarker) {
    return AddonRequestDetail_init_$Init$(seen0, request, subscriptionId, planName, serializationConstructorMarker, objectCreate(protoOf(AddonRequestDetail)));
  }
  function AddonRequestDetail(request, subscriptionId, planName) {
    subscriptionId = subscriptionId === VOID ? null : subscriptionId;
    planName = planName === VOID ? null : planName;
    this.v1k_1 = request;
    this.w1k_1 = subscriptionId;
    this.x1k_1 = planName;
  }
  protoOf(AddonRequestDetail).toString = function () {
    return 'AddonRequestDetail(request=' + this.v1k_1.toString() + ', subscriptionId=' + this.w1k_1 + ', planName=' + this.x1k_1 + ')';
  };
  protoOf(AddonRequestDetail).hashCode = function () {
    var result = this.v1k_1.hashCode();
    result = imul(result, 31) + (this.w1k_1 == null ? 0 : getStringHashCode(this.w1k_1)) | 0;
    result = imul(result, 31) + (this.x1k_1 == null ? 0 : getStringHashCode(this.x1k_1)) | 0;
    return result;
  };
  protoOf(AddonRequestDetail).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddonRequestDetail))
      return false;
    var tmp0_other_with_cast = other instanceof AddonRequestDetail ? other : THROW_CCE();
    if (!this.v1k_1.equals(tmp0_other_with_cast.v1k_1))
      return false;
    if (!(this.w1k_1 == tmp0_other_with_cast.w1k_1))
      return false;
    if (!(this.x1k_1 == tmp0_other_with_cast.x1k_1))
      return false;
    return true;
  };
  function AddonRequestPaths() {
    this.y1k_1 = '/api/console/addon-requests';
    this.z1k_1 = 'status';
  }
  protoOf(AddonRequestPaths).a1l = function (id) {
    return '/api/console/addon-requests/' + id;
  };
  protoOf(AddonRequestPaths).b1l = function (id) {
    return '/api/console/addon-requests/' + id + '/approve';
  };
  protoOf(AddonRequestPaths).c1l = function (id) {
    return '/api/console/addon-requests/' + id + '/decline';
  };
  var AddonRequestPaths_instance;
  function AddonRequestPaths_getInstance() {
    return AddonRequestPaths_instance;
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddonRequestDecision', this, 3);
    tmp0_serialDesc.gy('request', false);
    tmp0_serialDesc.gy('replayed', true);
    tmp0_serialDesc.gy('accessVersion', true);
    this.d1l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).e1l = function (encoder, value) {
    var tmp0_desc = this.d1l_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_7(), value.f1l_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.g1l_1 === false)) {
      tmp1_output.zr(tmp0_desc, 1, value.g1l_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.h1l_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, LongSerializer_getInstance(), value.h1l_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_5).on = function (encoder, value) {
    return this.e1l(encoder, value instanceof AddonRequestDecision ? value : THROW_CCE());
  };
  protoOf($serializer_5).pn = function (decoder) {
    var tmp0_desc = this.d1l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_7(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_7(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return AddonRequestDecision_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_5).nn = function () {
    return this.d1l_1;
  };
  protoOf($serializer_5).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_7(), BooleanSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_5;
  function $serializer_getInstance_5() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function AddonRequestDecision_init_$Init$(seen0, request, replayed, accessVersion, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_5().d1l_1);
    }
    $this.f1l_1 = request;
    if (0 === (seen0 & 2))
      $this.g1l_1 = false;
    else
      $this.g1l_1 = replayed;
    if (0 === (seen0 & 4))
      $this.h1l_1 = null;
    else
      $this.h1l_1 = accessVersion;
    return $this;
  }
  function AddonRequestDecision_init_$Create$(seen0, request, replayed, accessVersion, serializationConstructorMarker) {
    return AddonRequestDecision_init_$Init$(seen0, request, replayed, accessVersion, serializationConstructorMarker, objectCreate(protoOf(AddonRequestDecision)));
  }
  function AddonRequestDecision(request, replayed, accessVersion) {
    replayed = replayed === VOID ? false : replayed;
    accessVersion = accessVersion === VOID ? null : accessVersion;
    this.f1l_1 = request;
    this.g1l_1 = replayed;
    this.h1l_1 = accessVersion;
  }
  protoOf(AddonRequestDecision).toString = function () {
    return 'AddonRequestDecision(request=' + this.f1l_1.toString() + ', replayed=' + this.g1l_1 + ', accessVersion=' + toString_0(this.h1l_1) + ')';
  };
  protoOf(AddonRequestDecision).hashCode = function () {
    var result = this.f1l_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.g1l_1) | 0;
    result = imul(result, 31) + (this.h1l_1 == null ? 0 : this.h1l_1.hashCode()) | 0;
    return result;
  };
  protoOf(AddonRequestDecision).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddonRequestDecision))
      return false;
    var tmp0_other_with_cast = other instanceof AddonRequestDecision ? other : THROW_CCE();
    if (!this.f1l_1.equals(tmp0_other_with_cast.f1l_1))
      return false;
    if (!(this.g1l_1 === tmp0_other_with_cast.g1l_1))
      return false;
    if (!equals(this.h1l_1, tmp0_other_with_cast.h1l_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddonRequestDecisionBody', this, 1);
    tmp0_serialDesc.gy('note', true);
    this.i1l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).j1l = function (encoder, value) {
    var tmp0_desc = this.i1l_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.k1l_1 === '')) {
      tmp1_output.hs(tmp0_desc, 0, value.k1l_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_6).on = function (encoder, value) {
    return this.j1l(encoder, value instanceof AddonRequestDecisionBody ? value : THROW_CCE());
  };
  protoOf($serializer_6).pn = function (decoder) {
    var tmp0_desc = this.i1l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return AddonRequestDecisionBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_6).nn = function () {
    return this.i1l_1;
  };
  protoOf($serializer_6).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_6;
  function $serializer_getInstance_6() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function AddonRequestDecisionBody_init_$Init$(seen0, note, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_6().i1l_1);
    }
    if (0 === (seen0 & 1))
      $this.k1l_1 = '';
    else
      $this.k1l_1 = note;
    return $this;
  }
  function AddonRequestDecisionBody_init_$Create$(seen0, note, serializationConstructorMarker) {
    return AddonRequestDecisionBody_init_$Init$(seen0, note, serializationConstructorMarker, objectCreate(protoOf(AddonRequestDecisionBody)));
  }
  function AddonRequestDecisionBody(note) {
    note = note === VOID ? '' : note;
    this.k1l_1 = note;
  }
  protoOf(AddonRequestDecisionBody).toString = function () {
    return 'AddonRequestDecisionBody(note=' + this.k1l_1 + ')';
  };
  protoOf(AddonRequestDecisionBody).hashCode = function () {
    return getStringHashCode(this.k1l_1);
  };
  protoOf(AddonRequestDecisionBody).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddonRequestDecisionBody))
      return false;
    var tmp0_other_with_cast = other instanceof AddonRequestDecisionBody ? other : THROW_CCE();
    if (!(this.k1l_1 === tmp0_other_with_cast.k1l_1))
      return false;
    return true;
  };
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddonRequestRow', this, 21);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantSlug', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('addonPackId', false);
    tmp0_serialDesc.gy('packKey', false);
    tmp0_serialDesc.gy('packNameEn', false);
    tmp0_serialDesc.gy('packNameAr', false);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('quantity', false);
    tmp0_serialDesc.gy('expiresDays', true);
    tmp0_serialDesc.gy('currency', true);
    tmp0_serialDesc.gy('quotedAmountMinor', true);
    tmp0_serialDesc.gy('requestedByName', false);
    tmp0_serialDesc.gy('usagePercent', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('createdAtMs', false);
    tmp0_serialDesc.gy('decidedAtMs', true);
    tmp0_serialDesc.gy('decidedBy', true);
    tmp0_serialDesc.gy('decisionNote', true);
    tmp0_serialDesc.gy('subscriptionAddonId', true);
    this.l1l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).m1l = function (encoder, value) {
    var tmp0_desc = this.l1l_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.n1l_1);
    tmp1_output.hs(tmp0_desc, 1, value.o1l_1);
    tmp1_output.hs(tmp0_desc, 2, value.p1l_1);
    tmp1_output.hs(tmp0_desc, 3, value.q1l_1);
    tmp1_output.hs(tmp0_desc, 4, value.r1l_1);
    tmp1_output.hs(tmp0_desc, 5, value.s1l_1);
    tmp1_output.hs(tmp0_desc, 6, value.t1l_1);
    tmp1_output.hs(tmp0_desc, 7, value.u1l_1);
    tmp1_output.hs(tmp0_desc, 8, value.v1l_1);
    tmp1_output.ds(tmp0_desc, 9, value.w1l_1);
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.x1l_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, IntSerializer_getInstance(), value.x1l_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.y1l_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, StringSerializer_getInstance(), value.y1l_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.z1l_1 == null)) {
      tmp1_output.ls(tmp0_desc, 12, LongSerializer_getInstance(), value.z1l_1);
    }
    tmp1_output.hs(tmp0_desc, 13, value.a1m_1);
    tmp1_output.cs(tmp0_desc, 14, value.b1m_1);
    tmp1_output.hs(tmp0_desc, 15, value.c1m_1);
    tmp1_output.ds(tmp0_desc, 16, value.d1m_1);
    if (tmp1_output.ps(tmp0_desc, 17) ? true : !(value.e1m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 17, LongSerializer_getInstance(), value.e1m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 18) ? true : !(value.f1m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 18, StringSerializer_getInstance(), value.f1m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 19) ? true : !(value.g1m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 19, StringSerializer_getInstance(), value.g1m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 20) ? true : !(value.h1m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 20, StringSerializer_getInstance(), value.h1m_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_7).on = function (encoder, value) {
    return this.m1l(encoder, value instanceof AddonRequestRow ? value : THROW_CCE());
  };
  protoOf($serializer_7).pn = function (decoder) {
    var tmp0_desc = this.l1l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = new Long(0, 0);
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = 0;
    var tmp19_local15 = null;
    var tmp20_local16 = new Long(0, 0);
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_input = decoder.tq(tmp0_desc);
    if (tmp25_input.ir()) {
      tmp4_local0 = tmp25_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp25_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp25_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp25_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp25_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp25_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp25_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp25_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp25_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp25_input.zq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp25_input.hr(tmp0_desc, 10, IntSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp25_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp25_input.hr(tmp0_desc, 12, LongSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp25_input.dr(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp25_input.yq(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp25_input.dr(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp25_input.zq(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp25_input.hr(tmp0_desc, 17, LongSerializer_getInstance(), tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp25_input.hr(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp25_input.hr(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp25_input.hr(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp25_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp25_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp25_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp25_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp25_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp25_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp25_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp25_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp25_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp25_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp25_input.zq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp25_input.hr(tmp0_desc, 10, IntSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp25_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp25_input.hr(tmp0_desc, 12, LongSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp25_input.dr(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp25_input.yq(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp25_input.dr(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp25_input.zq(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp25_input.hr(tmp0_desc, 17, LongSerializer_getInstance(), tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp25_input.hr(tmp0_desc, 18, StringSerializer_getInstance(), tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp25_input.hr(tmp0_desc, 19, StringSerializer_getInstance(), tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp25_input.hr(tmp0_desc, 20, StringSerializer_getInstance(), tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp25_input.uq(tmp0_desc);
    return AddonRequestRow_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, null);
  };
  protoOf($serializer_7).nn = function () {
    return this.l1l_1;
  };
  protoOf($serializer_7).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_7;
  function $serializer_getInstance_7() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function AddonRequestRow_init_$Init$(seen0, id, tenantId, tenantSlug, tenantName, addonPackId, packKey, packNameEn, packNameAr, limitKey, quantity, expiresDays, currency, quotedAmountMinor, requestedByName, usagePercent, status, createdAtMs, decidedAtMs, decidedBy, decisionNote, subscriptionAddonId, serializationConstructorMarker, $this) {
    if (!(123903 === (123903 & seen0))) {
      throwMissingFieldException(seen0, 123903, $serializer_getInstance_7().l1l_1);
    }
    $this.n1l_1 = id;
    $this.o1l_1 = tenantId;
    $this.p1l_1 = tenantSlug;
    $this.q1l_1 = tenantName;
    $this.r1l_1 = addonPackId;
    $this.s1l_1 = packKey;
    $this.t1l_1 = packNameEn;
    $this.u1l_1 = packNameAr;
    $this.v1l_1 = limitKey;
    $this.w1l_1 = quantity;
    if (0 === (seen0 & 1024))
      $this.x1l_1 = null;
    else
      $this.x1l_1 = expiresDays;
    if (0 === (seen0 & 2048))
      $this.y1l_1 = null;
    else
      $this.y1l_1 = currency;
    if (0 === (seen0 & 4096))
      $this.z1l_1 = null;
    else
      $this.z1l_1 = quotedAmountMinor;
    $this.a1m_1 = requestedByName;
    $this.b1m_1 = usagePercent;
    $this.c1m_1 = status;
    $this.d1m_1 = createdAtMs;
    if (0 === (seen0 & 131072))
      $this.e1m_1 = null;
    else
      $this.e1m_1 = decidedAtMs;
    if (0 === (seen0 & 262144))
      $this.f1m_1 = null;
    else
      $this.f1m_1 = decidedBy;
    if (0 === (seen0 & 524288))
      $this.g1m_1 = null;
    else
      $this.g1m_1 = decisionNote;
    if (0 === (seen0 & 1048576))
      $this.h1m_1 = null;
    else
      $this.h1m_1 = subscriptionAddonId;
    return $this;
  }
  function AddonRequestRow_init_$Create$(seen0, id, tenantId, tenantSlug, tenantName, addonPackId, packKey, packNameEn, packNameAr, limitKey, quantity, expiresDays, currency, quotedAmountMinor, requestedByName, usagePercent, status, createdAtMs, decidedAtMs, decidedBy, decisionNote, subscriptionAddonId, serializationConstructorMarker) {
    return AddonRequestRow_init_$Init$(seen0, id, tenantId, tenantSlug, tenantName, addonPackId, packKey, packNameEn, packNameAr, limitKey, quantity, expiresDays, currency, quotedAmountMinor, requestedByName, usagePercent, status, createdAtMs, decidedAtMs, decidedBy, decisionNote, subscriptionAddonId, serializationConstructorMarker, objectCreate(protoOf(AddonRequestRow)));
  }
  function AddonRequestRow() {
  }
  protoOf(AddonRequestRow).toString = function () {
    return 'AddonRequestRow(id=' + this.n1l_1 + ', tenantId=' + this.o1l_1 + ', tenantSlug=' + this.p1l_1 + ', tenantName=' + this.q1l_1 + ', addonPackId=' + this.r1l_1 + ', packKey=' + this.s1l_1 + ', packNameEn=' + this.t1l_1 + ', packNameAr=' + this.u1l_1 + ', limitKey=' + this.v1l_1 + ', quantity=' + this.w1l_1.toString() + ', expiresDays=' + this.x1l_1 + ', currency=' + this.y1l_1 + ', quotedAmountMinor=' + toString_0(this.z1l_1) + ', requestedByName=' + this.a1m_1 + ', usagePercent=' + this.b1m_1 + ', status=' + this.c1m_1 + ', createdAtMs=' + this.d1m_1.toString() + ', decidedAtMs=' + toString_0(this.e1m_1) + ', decidedBy=' + this.f1m_1 + ', decisionNote=' + this.g1m_1 + ', subscriptionAddonId=' + this.h1m_1 + ')';
  };
  protoOf(AddonRequestRow).hashCode = function () {
    var result = getStringHashCode(this.n1l_1);
    result = imul(result, 31) + getStringHashCode(this.o1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1l_1) | 0;
    result = imul(result, 31) + this.w1l_1.hashCode() | 0;
    result = imul(result, 31) + (this.x1l_1 == null ? 0 : this.x1l_1) | 0;
    result = imul(result, 31) + (this.y1l_1 == null ? 0 : getStringHashCode(this.y1l_1)) | 0;
    result = imul(result, 31) + (this.z1l_1 == null ? 0 : this.z1l_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1m_1) | 0;
    result = imul(result, 31) + this.b1m_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.c1m_1) | 0;
    result = imul(result, 31) + this.d1m_1.hashCode() | 0;
    result = imul(result, 31) + (this.e1m_1 == null ? 0 : this.e1m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f1m_1 == null ? 0 : getStringHashCode(this.f1m_1)) | 0;
    result = imul(result, 31) + (this.g1m_1 == null ? 0 : getStringHashCode(this.g1m_1)) | 0;
    result = imul(result, 31) + (this.h1m_1 == null ? 0 : getStringHashCode(this.h1m_1)) | 0;
    return result;
  };
  protoOf(AddonRequestRow).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddonRequestRow))
      return false;
    var tmp0_other_with_cast = other instanceof AddonRequestRow ? other : THROW_CCE();
    if (!(this.n1l_1 === tmp0_other_with_cast.n1l_1))
      return false;
    if (!(this.o1l_1 === tmp0_other_with_cast.o1l_1))
      return false;
    if (!(this.p1l_1 === tmp0_other_with_cast.p1l_1))
      return false;
    if (!(this.q1l_1 === tmp0_other_with_cast.q1l_1))
      return false;
    if (!(this.r1l_1 === tmp0_other_with_cast.r1l_1))
      return false;
    if (!(this.s1l_1 === tmp0_other_with_cast.s1l_1))
      return false;
    if (!(this.t1l_1 === tmp0_other_with_cast.t1l_1))
      return false;
    if (!(this.u1l_1 === tmp0_other_with_cast.u1l_1))
      return false;
    if (!(this.v1l_1 === tmp0_other_with_cast.v1l_1))
      return false;
    if (!this.w1l_1.equals(tmp0_other_with_cast.w1l_1))
      return false;
    if (!(this.x1l_1 == tmp0_other_with_cast.x1l_1))
      return false;
    if (!(this.y1l_1 == tmp0_other_with_cast.y1l_1))
      return false;
    if (!equals(this.z1l_1, tmp0_other_with_cast.z1l_1))
      return false;
    if (!(this.a1m_1 === tmp0_other_with_cast.a1m_1))
      return false;
    if (!(this.b1m_1 === tmp0_other_with_cast.b1m_1))
      return false;
    if (!(this.c1m_1 === tmp0_other_with_cast.c1m_1))
      return false;
    if (!this.d1m_1.equals(tmp0_other_with_cast.d1m_1))
      return false;
    if (!equals(this.e1m_1, tmp0_other_with_cast.e1m_1))
      return false;
    if (!(this.f1m_1 == tmp0_other_with_cast.f1m_1))
      return false;
    if (!(this.g1m_1 == tmp0_other_with_cast.g1m_1))
      return false;
    if (!(this.h1m_1 == tmp0_other_with_cast.h1m_1))
      return false;
    return true;
  };
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.BillingEffectResult', this, 2);
    tmp0_serialDesc.gy('billingEffect', false);
    tmp0_serialDesc.gy('replayed', true);
    this.i1m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).j1m = function (encoder, value) {
    var tmp0_desc = this.i1m_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_10(), value.k1m_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.l1m_1 === false)) {
      tmp1_output.zr(tmp0_desc, 1, value.l1m_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_8).on = function (encoder, value) {
    return this.j1m(encoder, value instanceof BillingEffectResult ? value : THROW_CCE());
  };
  protoOf($serializer_8).pn = function (decoder) {
    var tmp0_desc = this.i1m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return BillingEffectResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_8).nn = function () {
    return this.i1m_1;
  };
  protoOf($serializer_8).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_10(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_8;
  function $serializer_getInstance_8() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function BillingEffectResult_init_$Init$(seen0, billingEffect, replayed, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_8().i1m_1);
    }
    $this.k1m_1 = billingEffect;
    if (0 === (seen0 & 2))
      $this.l1m_1 = false;
    else
      $this.l1m_1 = replayed;
    return $this;
  }
  function BillingEffectResult_init_$Create$(seen0, billingEffect, replayed, serializationConstructorMarker) {
    return BillingEffectResult_init_$Init$(seen0, billingEffect, replayed, serializationConstructorMarker, objectCreate(protoOf(BillingEffectResult)));
  }
  function BillingEffectResult(billingEffect, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.k1m_1 = billingEffect;
    this.l1m_1 = replayed;
  }
  protoOf(BillingEffectResult).toString = function () {
    return 'BillingEffectResult(billingEffect=' + this.k1m_1.toString() + ', replayed=' + this.l1m_1 + ')';
  };
  protoOf(BillingEffectResult).hashCode = function () {
    var result = this.k1m_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.l1m_1) | 0;
    return result;
  };
  protoOf(BillingEffectResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BillingEffectResult))
      return false;
    var tmp0_other_with_cast = other instanceof BillingEffectResult ? other : THROW_CCE();
    if (!this.k1m_1.equals(tmp0_other_with_cast.k1m_1))
      return false;
    if (!(this.l1m_1 === tmp0_other_with_cast.l1m_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RecordBillingEffectRequest', this, 4);
    tmp0_serialDesc.gy('causeKind', false);
    tmp0_serialDesc.gy('causeRef', false);
    tmp0_serialDesc.gy('effect', false);
    tmp0_serialDesc.gy('note', true);
    this.m1m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).n1m = function (encoder, value) {
    var tmp0_desc = this.m1m_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.o1m_1);
    tmp1_output.hs(tmp0_desc, 1, value.p1m_1);
    tmp1_output.hs(tmp0_desc, 2, value.q1m_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.r1m_1 === '')) {
      tmp1_output.hs(tmp0_desc, 3, value.r1m_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_9).on = function (encoder, value) {
    return this.n1m(encoder, value instanceof RecordBillingEffectRequest ? value : THROW_CCE());
  };
  protoOf($serializer_9).pn = function (decoder) {
    var tmp0_desc = this.m1m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return RecordBillingEffectRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_9).nn = function () {
    return this.m1m_1;
  };
  protoOf($serializer_9).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_9;
  function $serializer_getInstance_9() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function RecordBillingEffectRequest_init_$Init$(seen0, causeKind, causeRef, effect, note, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_9().m1m_1);
    }
    $this.o1m_1 = causeKind;
    $this.p1m_1 = causeRef;
    $this.q1m_1 = effect;
    if (0 === (seen0 & 8))
      $this.r1m_1 = '';
    else
      $this.r1m_1 = note;
    return $this;
  }
  function RecordBillingEffectRequest_init_$Create$(seen0, causeKind, causeRef, effect, note, serializationConstructorMarker) {
    return RecordBillingEffectRequest_init_$Init$(seen0, causeKind, causeRef, effect, note, serializationConstructorMarker, objectCreate(protoOf(RecordBillingEffectRequest)));
  }
  function RecordBillingEffectRequest(causeKind, causeRef, effect, note) {
    note = note === VOID ? '' : note;
    this.o1m_1 = causeKind;
    this.p1m_1 = causeRef;
    this.q1m_1 = effect;
    this.r1m_1 = note;
  }
  protoOf(RecordBillingEffectRequest).toString = function () {
    return 'RecordBillingEffectRequest(causeKind=' + this.o1m_1 + ', causeRef=' + this.p1m_1 + ', effect=' + this.q1m_1 + ', note=' + this.r1m_1 + ')';
  };
  protoOf(RecordBillingEffectRequest).hashCode = function () {
    var result = getStringHashCode(this.o1m_1);
    result = imul(result, 31) + getStringHashCode(this.p1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q1m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1m_1) | 0;
    return result;
  };
  protoOf(RecordBillingEffectRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RecordBillingEffectRequest))
      return false;
    var tmp0_other_with_cast = other instanceof RecordBillingEffectRequest ? other : THROW_CCE();
    if (!(this.o1m_1 === tmp0_other_with_cast.o1m_1))
      return false;
    if (!(this.p1m_1 === tmp0_other_with_cast.p1m_1))
      return false;
    if (!(this.q1m_1 === tmp0_other_with_cast.q1m_1))
      return false;
    if (!(this.r1m_1 === tmp0_other_with_cast.r1m_1))
      return false;
    return true;
  };
  function BillingEffectKinds() {
    BillingEffectKinds_instance = this;
    this.s1m_1 = 'END_OF_TERM';
    this.t1m_1 = 'PRORATE';
    this.u1m_1 = 'CREDIT';
    this.v1m_1 = 'COMMITTED_TERM_CONTINUES';
    this.w1m_1 = listOf(['END_OF_TERM', 'PRORATE', 'CREDIT', 'COMMITTED_TERM_CONTINUES']);
  }
  var BillingEffectKinds_instance;
  function BillingEffectKinds_getInstance() {
    if (BillingEffectKinds_instance == null)
      new BillingEffectKinds();
    return BillingEffectKinds_instance;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.BillingEffectView', this, 9);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('causeKind', false);
    tmp0_serialDesc.gy('causeRef', false);
    tmp0_serialDesc.gy('effect', false);
    tmp0_serialDesc.gy('note', false);
    tmp0_serialDesc.gy('recordedBy', false);
    tmp0_serialDesc.gy('recordedAtMs', false);
    tmp0_serialDesc.gy('supersededBy', true);
    this.x1m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).y1m = function (encoder, value) {
    var tmp0_desc = this.x1m_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.z1m_1);
    tmp1_output.hs(tmp0_desc, 1, value.a1n_1);
    tmp1_output.hs(tmp0_desc, 2, value.b1n_1);
    tmp1_output.hs(tmp0_desc, 3, value.c1n_1);
    tmp1_output.hs(tmp0_desc, 4, value.d1n_1);
    tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.e1n_1);
    tmp1_output.hs(tmp0_desc, 6, value.f1n_1);
    tmp1_output.ds(tmp0_desc, 7, value.g1n_1);
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.h1n_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.h1n_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_10).on = function (encoder, value) {
    return this.y1m(encoder, value instanceof BillingEffectView ? value : THROW_CCE());
  };
  protoOf($serializer_10).pn = function (decoder) {
    var tmp0_desc = this.x1m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = new Long(0, 0);
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return BillingEffectView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_10).nn = function () {
    return this.x1m_1;
  };
  protoOf($serializer_10).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_10;
  function $serializer_getInstance_10() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function BillingEffectView_init_$Init$(seen0, id, tenantId, causeKind, causeRef, effect, note, recordedBy, recordedAtMs, supersededBy, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_10().x1m_1);
    }
    $this.z1m_1 = id;
    $this.a1n_1 = tenantId;
    $this.b1n_1 = causeKind;
    $this.c1n_1 = causeRef;
    $this.d1n_1 = effect;
    $this.e1n_1 = note;
    $this.f1n_1 = recordedBy;
    $this.g1n_1 = recordedAtMs;
    if (0 === (seen0 & 256))
      $this.h1n_1 = null;
    else
      $this.h1n_1 = supersededBy;
    return $this;
  }
  function BillingEffectView_init_$Create$(seen0, id, tenantId, causeKind, causeRef, effect, note, recordedBy, recordedAtMs, supersededBy, serializationConstructorMarker) {
    return BillingEffectView_init_$Init$(seen0, id, tenantId, causeKind, causeRef, effect, note, recordedBy, recordedAtMs, supersededBy, serializationConstructorMarker, objectCreate(protoOf(BillingEffectView)));
  }
  function BillingEffectView() {
  }
  protoOf(BillingEffectView).toString = function () {
    return 'BillingEffectView(id=' + this.z1m_1 + ', tenantId=' + this.a1n_1 + ', causeKind=' + this.b1n_1 + ', causeRef=' + this.c1n_1 + ', effect=' + this.d1n_1 + ', note=' + this.e1n_1 + ', recordedBy=' + this.f1n_1 + ', recordedAtMs=' + this.g1n_1.toString() + ', supersededBy=' + this.h1n_1 + ')';
  };
  protoOf(BillingEffectView).hashCode = function () {
    var result = getStringHashCode(this.z1m_1);
    result = imul(result, 31) + getStringHashCode(this.a1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1n_1) | 0;
    result = imul(result, 31) + (this.e1n_1 == null ? 0 : getStringHashCode(this.e1n_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1n_1) | 0;
    result = imul(result, 31) + this.g1n_1.hashCode() | 0;
    result = imul(result, 31) + (this.h1n_1 == null ? 0 : getStringHashCode(this.h1n_1)) | 0;
    return result;
  };
  protoOf(BillingEffectView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BillingEffectView))
      return false;
    var tmp0_other_with_cast = other instanceof BillingEffectView ? other : THROW_CCE();
    if (!(this.z1m_1 === tmp0_other_with_cast.z1m_1))
      return false;
    if (!(this.a1n_1 === tmp0_other_with_cast.a1n_1))
      return false;
    if (!(this.b1n_1 === tmp0_other_with_cast.b1n_1))
      return false;
    if (!(this.c1n_1 === tmp0_other_with_cast.c1n_1))
      return false;
    if (!(this.d1n_1 === tmp0_other_with_cast.d1n_1))
      return false;
    if (!(this.e1n_1 == tmp0_other_with_cast.e1n_1))
      return false;
    if (!(this.f1n_1 === tmp0_other_with_cast.f1n_1))
      return false;
    if (!this.g1n_1.equals(tmp0_other_with_cast.g1n_1))
      return false;
    if (!(this.h1n_1 == tmp0_other_with_cast.h1n_1))
      return false;
    return true;
  };
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j1n_1 = [null, null, Companion_getInstance_12().w19(), null, null, null, null, null, null];
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.StagedBrandingAssetView', this, 9);
    tmp0_serialDesc.gy('assetId', false);
    tmp0_serialDesc.gy('draftId', false);
    tmp0_serialDesc.gy('assetKind', false);
    tmp0_serialDesc.gy('mime', false);
    tmp0_serialDesc.gy('sizeBytes', false);
    tmp0_serialDesc.gy('width', false);
    tmp0_serialDesc.gy('height', false);
    tmp0_serialDesc.gy('sha256', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    this.k1n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).l1n = function (encoder, value) {
    var tmp0_desc = this.k1n_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().j1n_1;
    tmp1_output.hs(tmp0_desc, 0, value.m1n_1);
    tmp1_output.hs(tmp0_desc, 1, value.n1n_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.o1n_1);
    tmp1_output.hs(tmp0_desc, 3, value.p1n_1);
    tmp1_output.cs(tmp0_desc, 4, value.q1n_1);
    tmp1_output.cs(tmp0_desc, 5, value.r1n_1);
    tmp1_output.cs(tmp0_desc, 6, value.s1n_1);
    tmp1_output.hs(tmp0_desc, 7, value.t1n_1);
    tmp1_output.ds(tmp0_desc, 8, value.u1n_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_11).on = function (encoder, value) {
    return this.l1n(encoder, value instanceof StagedBrandingAssetView ? value : THROW_CCE());
  };
  protoOf($serializer_11).pn = function (decoder) {
    var tmp0_desc = this.k1n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_local8 = new Long(0, 0);
    var tmp13_input = decoder.tq(tmp0_desc);
    var tmp14_cached = Companion_getInstance_9().j1n_1;
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.fr(tmp0_desc, 2, tmp14_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.yq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.yq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.fr(tmp0_desc, 2, tmp14_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.yq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.yq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return StagedBrandingAssetView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_11).nn = function () {
    return this.k1n_1;
  };
  protoOf($serializer_11).vy = function () {
    var tmp0_cached = Companion_getInstance_9().j1n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_11;
  function $serializer_getInstance_11() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function StagedBrandingAssetView_init_$Init$(seen0, assetId, draftId, assetKind, mime, sizeBytes, width, height, sha256, expiresAtMs, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_11().k1n_1);
    }
    $this.m1n_1 = assetId;
    $this.n1n_1 = draftId;
    $this.o1n_1 = assetKind;
    $this.p1n_1 = mime;
    $this.q1n_1 = sizeBytes;
    $this.r1n_1 = width;
    $this.s1n_1 = height;
    $this.t1n_1 = sha256;
    $this.u1n_1 = expiresAtMs;
    return $this;
  }
  function StagedBrandingAssetView_init_$Create$(seen0, assetId, draftId, assetKind, mime, sizeBytes, width, height, sha256, expiresAtMs, serializationConstructorMarker) {
    return StagedBrandingAssetView_init_$Init$(seen0, assetId, draftId, assetKind, mime, sizeBytes, width, height, sha256, expiresAtMs, serializationConstructorMarker, objectCreate(protoOf(StagedBrandingAssetView)));
  }
  function StagedBrandingAssetView(assetId, draftId, assetKind, mime, sizeBytes, width, height, sha256, expiresAtMs) {
    Companion_getInstance_9();
    this.m1n_1 = assetId;
    this.n1n_1 = draftId;
    this.o1n_1 = assetKind;
    this.p1n_1 = mime;
    this.q1n_1 = sizeBytes;
    this.r1n_1 = width;
    this.s1n_1 = height;
    this.t1n_1 = sha256;
    this.u1n_1 = expiresAtMs;
  }
  protoOf(StagedBrandingAssetView).toString = function () {
    return 'StagedBrandingAssetView(assetId=' + this.m1n_1 + ', draftId=' + this.n1n_1 + ', assetKind=' + this.o1n_1.toString() + ', mime=' + this.p1n_1 + ', sizeBytes=' + this.q1n_1 + ', width=' + this.r1n_1 + ', height=' + this.s1n_1 + ', sha256=' + this.t1n_1 + ', expiresAtMs=' + this.u1n_1.toString() + ')';
  };
  protoOf(StagedBrandingAssetView).hashCode = function () {
    var result = getStringHashCode(this.m1n_1);
    result = imul(result, 31) + getStringHashCode(this.n1n_1) | 0;
    result = imul(result, 31) + this.o1n_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.p1n_1) | 0;
    result = imul(result, 31) + this.q1n_1 | 0;
    result = imul(result, 31) + this.r1n_1 | 0;
    result = imul(result, 31) + this.s1n_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.t1n_1) | 0;
    result = imul(result, 31) + this.u1n_1.hashCode() | 0;
    return result;
  };
  protoOf(StagedBrandingAssetView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StagedBrandingAssetView))
      return false;
    var tmp0_other_with_cast = other instanceof StagedBrandingAssetView ? other : THROW_CCE();
    if (!(this.m1n_1 === tmp0_other_with_cast.m1n_1))
      return false;
    if (!(this.n1n_1 === tmp0_other_with_cast.n1n_1))
      return false;
    if (!this.o1n_1.equals(tmp0_other_with_cast.o1n_1))
      return false;
    if (!(this.p1n_1 === tmp0_other_with_cast.p1n_1))
      return false;
    if (!(this.q1n_1 === tmp0_other_with_cast.q1n_1))
      return false;
    if (!(this.r1n_1 === tmp0_other_with_cast.r1n_1))
      return false;
    if (!(this.s1n_1 === tmp0_other_with_cast.s1n_1))
      return false;
    if (!(this.t1n_1 === tmp0_other_with_cast.t1n_1))
      return false;
    if (!this.u1n_1.equals(tmp0_other_with_cast.u1n_1))
      return false;
    return true;
  };
  function Companion_10() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v1n_1 = [null, null, Companion_getInstance_12().w19(), null, null];
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.StageBrandingAssetRequest', this, 5);
    tmp0_serialDesc.gy('draftId', false);
    tmp0_serialDesc.gy('expectedRevision', false);
    tmp0_serialDesc.gy('assetKind', false);
    tmp0_serialDesc.gy('contentBase64', false);
    tmp0_serialDesc.gy('mime', false);
    this.w1n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).x1n = function (encoder, value) {
    var tmp0_desc = this.w1n_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().v1n_1;
    tmp1_output.hs(tmp0_desc, 0, value.y1n_1);
    tmp1_output.ds(tmp0_desc, 1, value.z1n_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.a1o_1);
    tmp1_output.hs(tmp0_desc, 3, value.b1o_1);
    tmp1_output.hs(tmp0_desc, 4, value.c1o_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_12).on = function (encoder, value) {
    return this.x1n(encoder, value instanceof StageBrandingAssetRequest ? value : THROW_CCE());
  };
  protoOf($serializer_12).pn = function (decoder) {
    var tmp0_desc = this.w1n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    var tmp10_cached = Companion_getInstance_10().v1n_1;
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.fr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.fr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return StageBrandingAssetRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_12).nn = function () {
    return this.w1n_1;
  };
  protoOf($serializer_12).vy = function () {
    var tmp0_cached = Companion_getInstance_10().v1n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[2], StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_12;
  function $serializer_getInstance_12() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function StageBrandingAssetRequest_init_$Init$(seen0, draftId, expectedRevision, assetKind, contentBase64, mime, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_12().w1n_1);
    }
    $this.y1n_1 = draftId;
    $this.z1n_1 = expectedRevision;
    $this.a1o_1 = assetKind;
    $this.b1o_1 = contentBase64;
    $this.c1o_1 = mime;
    return $this;
  }
  function StageBrandingAssetRequest_init_$Create$(seen0, draftId, expectedRevision, assetKind, contentBase64, mime, serializationConstructorMarker) {
    return StageBrandingAssetRequest_init_$Init$(seen0, draftId, expectedRevision, assetKind, contentBase64, mime, serializationConstructorMarker, objectCreate(protoOf(StageBrandingAssetRequest)));
  }
  function StageBrandingAssetRequest(draftId, expectedRevision, assetKind, contentBase64, mime) {
    Companion_getInstance_10();
    this.y1n_1 = draftId;
    this.z1n_1 = expectedRevision;
    this.a1o_1 = assetKind;
    this.b1o_1 = contentBase64;
    this.c1o_1 = mime;
  }
  protoOf(StageBrandingAssetRequest).toString = function () {
    return 'StageBrandingAssetRequest(draftId=' + this.y1n_1 + ', expectedRevision=' + this.z1n_1.toString() + ', assetKind=' + this.a1o_1.toString() + ', contentBase64=' + this.b1o_1 + ', mime=' + this.c1o_1 + ')';
  };
  protoOf(StageBrandingAssetRequest).hashCode = function () {
    var result = getStringHashCode(this.y1n_1);
    result = imul(result, 31) + this.z1n_1.hashCode() | 0;
    result = imul(result, 31) + this.a1o_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.b1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1o_1) | 0;
    return result;
  };
  protoOf(StageBrandingAssetRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StageBrandingAssetRequest))
      return false;
    var tmp0_other_with_cast = other instanceof StageBrandingAssetRequest ? other : THROW_CCE();
    if (!(this.y1n_1 === tmp0_other_with_cast.y1n_1))
      return false;
    if (!this.z1n_1.equals(tmp0_other_with_cast.z1n_1))
      return false;
    if (!this.a1o_1.equals(tmp0_other_with_cast.a1o_1))
      return false;
    if (!(this.b1o_1 === tmp0_other_with_cast.b1o_1))
      return false;
    if (!(this.c1o_1 === tmp0_other_with_cast.c1o_1))
      return false;
    return true;
  };
  function Companion_11() {
  }
  var Companion_instance_11;
  function Companion_getInstance_11() {
    return Companion_instance_11;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.StagedBrandingAssetContent', this, 2);
    tmp0_serialDesc.gy('asset', false);
    tmp0_serialDesc.gy('contentBase64', false);
    this.d1o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).e1o = function (encoder, value) {
    var tmp0_desc = this.d1o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_11(), value.f1o_1);
    tmp1_output.hs(tmp0_desc, 1, value.g1o_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_13).on = function (encoder, value) {
    return this.e1o(encoder, value instanceof StagedBrandingAssetContent ? value : THROW_CCE());
  };
  protoOf($serializer_13).pn = function (decoder) {
    var tmp0_desc = this.d1o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return StagedBrandingAssetContent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_13).nn = function () {
    return this.d1o_1;
  };
  protoOf($serializer_13).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11(), StringSerializer_getInstance()];
  };
  var $serializer_instance_13;
  function $serializer_getInstance_13() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function StagedBrandingAssetContent_init_$Init$(seen0, asset, contentBase64, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_13().d1o_1);
    }
    $this.f1o_1 = asset;
    $this.g1o_1 = contentBase64;
    return $this;
  }
  function StagedBrandingAssetContent_init_$Create$(seen0, asset, contentBase64, serializationConstructorMarker) {
    return StagedBrandingAssetContent_init_$Init$(seen0, asset, contentBase64, serializationConstructorMarker, objectCreate(protoOf(StagedBrandingAssetContent)));
  }
  function StagedBrandingAssetContent(asset, contentBase64) {
    this.f1o_1 = asset;
    this.g1o_1 = contentBase64;
  }
  protoOf(StagedBrandingAssetContent).toString = function () {
    return 'StagedBrandingAssetContent(asset=' + this.f1o_1.toString() + ', contentBase64=' + this.g1o_1 + ')';
  };
  protoOf(StagedBrandingAssetContent).hashCode = function () {
    var result = this.f1o_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.g1o_1) | 0;
    return result;
  };
  protoOf(StagedBrandingAssetContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StagedBrandingAssetContent))
      return false;
    var tmp0_other_with_cast = other instanceof StagedBrandingAssetContent ? other : THROW_CCE();
    if (!this.f1o_1.equals(tmp0_other_with_cast.f1o_1))
      return false;
    if (!(this.g1o_1 === tmp0_other_with_cast.g1o_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.i1n_1.w();
  }
  function BrandingAssetKind$Companion$_anonymous__mst9ye() {
    return createSimpleEnumSerializer('com.ems.console.api.BrandingAssetKind', values());
  }
  var BrandingAssetKind_LIGHT_LOGO_instance;
  var BrandingAssetKind_DARK_LOGO_instance;
  var BrandingAssetKind_FAVICON_instance;
  function values() {
    return [BrandingAssetKind_LIGHT_LOGO_getInstance(), BrandingAssetKind_DARK_LOGO_getInstance(), BrandingAssetKind_FAVICON_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  function Companion_12() {
    Companion_instance_12 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.i1n_1 = lazy(tmp_0, BrandingAssetKind$Companion$_anonymous__mst9ye);
  }
  protoOf(Companion_12).w19 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion_12).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    BrandingAssetKind_initEntries();
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  var BrandingAssetKind_entriesInitialized;
  function BrandingAssetKind_initEntries() {
    if (BrandingAssetKind_entriesInitialized)
      return Unit_instance;
    BrandingAssetKind_entriesInitialized = true;
    BrandingAssetKind_LIGHT_LOGO_instance = new BrandingAssetKind('LIGHT_LOGO', 0);
    BrandingAssetKind_DARK_LOGO_instance = new BrandingAssetKind('DARK_LOGO', 1);
    BrandingAssetKind_FAVICON_instance = new BrandingAssetKind('FAVICON', 2);
    Companion_getInstance_12();
  }
  var $ENTRIES;
  function BrandingAssetKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BrandingAssetKind_LIGHT_LOGO_getInstance() {
    BrandingAssetKind_initEntries();
    return BrandingAssetKind_LIGHT_LOGO_instance;
  }
  function BrandingAssetKind_DARK_LOGO_getInstance() {
    BrandingAssetKind_initEntries();
    return BrandingAssetKind_DARK_LOGO_instance;
  }
  function BrandingAssetKind_FAVICON_getInstance() {
    BrandingAssetKind_initEntries();
    return BrandingAssetKind_FAVICON_instance;
  }
  function Companion_13() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h1o_1 = [null, new ArrayListSerializer($serializer_getInstance_16())];
  }
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.BrandingContrastView', this, 2);
    tmp0_serialDesc.gy('mode', false);
    tmp0_serialDesc.gy('pairs', false);
    this.i1o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).j1o = function (encoder, value) {
    var tmp0_desc = this.i1o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_13().h1o_1;
    tmp1_output.hs(tmp0_desc, 0, value.k1o_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.l1o_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_14).on = function (encoder, value) {
    return this.j1o(encoder, value instanceof BrandingContrastView ? value : THROW_CCE());
  };
  protoOf($serializer_14).pn = function (decoder) {
    var tmp0_desc = this.i1o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_13().h1o_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.fr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.fr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return BrandingContrastView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_14).nn = function () {
    return this.i1o_1;
  };
  protoOf($serializer_14).vy = function () {
    var tmp0_cached = Companion_getInstance_13().h1o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1]];
  };
  var $serializer_instance_14;
  function $serializer_getInstance_14() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function BrandingContrastView_init_$Init$(seen0, mode, pairs, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_14().i1o_1);
    }
    $this.k1o_1 = mode;
    $this.l1o_1 = pairs;
    return $this;
  }
  function BrandingContrastView_init_$Create$(seen0, mode, pairs, serializationConstructorMarker) {
    return BrandingContrastView_init_$Init$(seen0, mode, pairs, serializationConstructorMarker, objectCreate(protoOf(BrandingContrastView)));
  }
  function BrandingContrastView(mode, pairs) {
    Companion_getInstance_13();
    this.k1o_1 = mode;
    this.l1o_1 = pairs;
  }
  protoOf(BrandingContrastView).toString = function () {
    return 'BrandingContrastView(mode=' + this.k1o_1 + ', pairs=' + toString(this.l1o_1) + ')';
  };
  protoOf(BrandingContrastView).hashCode = function () {
    var result = getStringHashCode(this.k1o_1);
    result = imul(result, 31) + hashCode(this.l1o_1) | 0;
    return result;
  };
  protoOf(BrandingContrastView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BrandingContrastView))
      return false;
    var tmp0_other_with_cast = other instanceof BrandingContrastView ? other : THROW_CCE();
    if (!(this.k1o_1 === tmp0_other_with_cast.k1o_1))
      return false;
    if (!equals(this.l1o_1, tmp0_other_with_cast.l1o_1))
      return false;
    return true;
  };
  function Companion_14() {
    Companion_instance_14 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m1o_1 = [new ArrayListSerializer($serializer_getInstance_17()), null];
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    if (Companion_instance_14 == null)
      new Companion_14();
    return Companion_instance_14;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.BrandingContrastRequest', this, 2);
    tmp0_serialDesc.gy('pairs', false);
    tmp0_serialDesc.gy('mode', true);
    this.n1o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).o1o = function (encoder, value) {
    var tmp0_desc = this.n1o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_14().m1o_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.p1o_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.q1o_1 === 'SYSTEM')) {
      tmp1_output.hs(tmp0_desc, 1, value.q1o_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_15).on = function (encoder, value) {
    return this.o1o(encoder, value instanceof BrandingContrastRequest ? value : THROW_CCE());
  };
  protoOf($serializer_15).pn = function (decoder) {
    var tmp0_desc = this.n1o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_14().m1o_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return BrandingContrastRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_15).nn = function () {
    return this.n1o_1;
  };
  protoOf($serializer_15).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_14().m1o_1[0], StringSerializer_getInstance()];
  };
  var $serializer_instance_15;
  function $serializer_getInstance_15() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function BrandingContrastRequest_init_$Init$(seen0, pairs, mode, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_15().n1o_1);
    }
    $this.p1o_1 = pairs;
    if (0 === (seen0 & 2))
      $this.q1o_1 = 'SYSTEM';
    else
      $this.q1o_1 = mode;
    return $this;
  }
  function BrandingContrastRequest_init_$Create$(seen0, pairs, mode, serializationConstructorMarker) {
    return BrandingContrastRequest_init_$Init$(seen0, pairs, mode, serializationConstructorMarker, objectCreate(protoOf(BrandingContrastRequest)));
  }
  function BrandingContrastRequest(pairs, mode) {
    Companion_getInstance_14();
    mode = mode === VOID ? 'SYSTEM' : mode;
    this.p1o_1 = pairs;
    this.q1o_1 = mode;
  }
  protoOf(BrandingContrastRequest).toString = function () {
    return 'BrandingContrastRequest(pairs=' + toString(this.p1o_1) + ', mode=' + this.q1o_1 + ')';
  };
  protoOf(BrandingContrastRequest).hashCode = function () {
    var result = hashCode(this.p1o_1);
    result = imul(result, 31) + getStringHashCode(this.q1o_1) | 0;
    return result;
  };
  protoOf(BrandingContrastRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BrandingContrastRequest))
      return false;
    var tmp0_other_with_cast = other instanceof BrandingContrastRequest ? other : THROW_CCE();
    if (!equals(this.p1o_1, tmp0_other_with_cast.p1o_1))
      return false;
    if (!(this.q1o_1 === tmp0_other_with_cast.q1o_1))
      return false;
    return true;
  };
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.BrandingContrastPairResult', this, 9);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('backgroundColor', false);
    tmp0_serialDesc.gy('foregroundColor', false);
    tmp0_serialDesc.gy('textSize', false);
    tmp0_serialDesc.gy('ratio', false);
    tmp0_serialDesc.gy('minimumRatio', false);
    tmp0_serialDesc.gy('passes', false);
    tmp0_serialDesc.gy('suggestedForegroundColor', false);
    tmp0_serialDesc.gy('suggestedBackgroundColor', false);
    this.r1o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).s1o = function (encoder, value) {
    var tmp0_desc = this.r1o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.t1o_1);
    tmp1_output.hs(tmp0_desc, 1, value.u1o_1);
    tmp1_output.hs(tmp0_desc, 2, value.v1o_1);
    tmp1_output.hs(tmp0_desc, 3, value.w1o_1);
    tmp1_output.fs(tmp0_desc, 4, value.x1o_1);
    tmp1_output.fs(tmp0_desc, 5, value.y1o_1);
    tmp1_output.zr(tmp0_desc, 6, value.z1o_1);
    tmp1_output.hs(tmp0_desc, 7, value.a1p_1);
    tmp1_output.hs(tmp0_desc, 8, value.b1p_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_16).on = function (encoder, value) {
    return this.s1o(encoder, value instanceof BrandingContrastPairResult ? value : THROW_CCE());
  };
  protoOf($serializer_16).pn = function (decoder) {
    var tmp0_desc = this.r1o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0.0;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = false;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.br(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.br(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.vq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.br(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.br(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.vq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return BrandingContrastPairResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_16).nn = function () {
    return this.r1o_1;
  };
  protoOf($serializer_16).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_16;
  function $serializer_getInstance_16() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function BrandingContrastPairResult_init_$Init$(seen0, key, backgroundColor, foregroundColor, textSize, ratio, minimumRatio, passes, suggestedForegroundColor, suggestedBackgroundColor, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_16().r1o_1);
    }
    $this.t1o_1 = key;
    $this.u1o_1 = backgroundColor;
    $this.v1o_1 = foregroundColor;
    $this.w1o_1 = textSize;
    $this.x1o_1 = ratio;
    $this.y1o_1 = minimumRatio;
    $this.z1o_1 = passes;
    $this.a1p_1 = suggestedForegroundColor;
    $this.b1p_1 = suggestedBackgroundColor;
    return $this;
  }
  function BrandingContrastPairResult_init_$Create$(seen0, key, backgroundColor, foregroundColor, textSize, ratio, minimumRatio, passes, suggestedForegroundColor, suggestedBackgroundColor, serializationConstructorMarker) {
    return BrandingContrastPairResult_init_$Init$(seen0, key, backgroundColor, foregroundColor, textSize, ratio, minimumRatio, passes, suggestedForegroundColor, suggestedBackgroundColor, serializationConstructorMarker, objectCreate(protoOf(BrandingContrastPairResult)));
  }
  function BrandingContrastPairResult() {
  }
  protoOf(BrandingContrastPairResult).toString = function () {
    return 'BrandingContrastPairResult(key=' + this.t1o_1 + ', backgroundColor=' + this.u1o_1 + ', foregroundColor=' + this.v1o_1 + ', textSize=' + this.w1o_1 + ', ratio=' + this.x1o_1 + ', minimumRatio=' + this.y1o_1 + ', passes=' + this.z1o_1 + ', suggestedForegroundColor=' + this.a1p_1 + ', suggestedBackgroundColor=' + this.b1p_1 + ')';
  };
  protoOf(BrandingContrastPairResult).hashCode = function () {
    var result = getStringHashCode(this.t1o_1);
    result = imul(result, 31) + getStringHashCode(this.u1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x1o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y1o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z1o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1p_1) | 0;
    return result;
  };
  protoOf(BrandingContrastPairResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BrandingContrastPairResult))
      return false;
    var tmp0_other_with_cast = other instanceof BrandingContrastPairResult ? other : THROW_CCE();
    if (!(this.t1o_1 === tmp0_other_with_cast.t1o_1))
      return false;
    if (!(this.u1o_1 === tmp0_other_with_cast.u1o_1))
      return false;
    if (!(this.v1o_1 === tmp0_other_with_cast.v1o_1))
      return false;
    if (!(this.w1o_1 === tmp0_other_with_cast.w1o_1))
      return false;
    if (!equals(this.x1o_1, tmp0_other_with_cast.x1o_1))
      return false;
    if (!equals(this.y1o_1, tmp0_other_with_cast.y1o_1))
      return false;
    if (!(this.z1o_1 === tmp0_other_with_cast.z1o_1))
      return false;
    if (!(this.a1p_1 === tmp0_other_with_cast.a1p_1))
      return false;
    if (!(this.b1p_1 === tmp0_other_with_cast.b1p_1))
      return false;
    return true;
  };
  function Companion_15() {
  }
  var Companion_instance_15;
  function Companion_getInstance_15() {
    return Companion_instance_15;
  }
  function $serializer_17() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.BrandingContrastPair', this, 4);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('backgroundColor', false);
    tmp0_serialDesc.gy('foregroundColor', false);
    tmp0_serialDesc.gy('textSize', true);
    this.c1p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).d1p = function (encoder, value) {
    var tmp0_desc = this.c1p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.e1p_1);
    tmp1_output.hs(tmp0_desc, 1, value.f1p_1);
    tmp1_output.hs(tmp0_desc, 2, value.g1p_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.h1p_1 === 'NORMAL')) {
      tmp1_output.hs(tmp0_desc, 3, value.h1p_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_17).on = function (encoder, value) {
    return this.d1p(encoder, value instanceof BrandingContrastPair ? value : THROW_CCE());
  };
  protoOf($serializer_17).pn = function (decoder) {
    var tmp0_desc = this.c1p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return BrandingContrastPair_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_17).nn = function () {
    return this.c1p_1;
  };
  protoOf($serializer_17).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_17;
  function $serializer_getInstance_17() {
    if ($serializer_instance_17 == null)
      new $serializer_17();
    return $serializer_instance_17;
  }
  function BrandingContrastPair_init_$Init$(seen0, key, backgroundColor, foregroundColor, textSize, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_17().c1p_1);
    }
    $this.e1p_1 = key;
    $this.f1p_1 = backgroundColor;
    $this.g1p_1 = foregroundColor;
    if (0 === (seen0 & 8))
      $this.h1p_1 = 'NORMAL';
    else
      $this.h1p_1 = textSize;
    return $this;
  }
  function BrandingContrastPair_init_$Create$(seen0, key, backgroundColor, foregroundColor, textSize, serializationConstructorMarker) {
    return BrandingContrastPair_init_$Init$(seen0, key, backgroundColor, foregroundColor, textSize, serializationConstructorMarker, objectCreate(protoOf(BrandingContrastPair)));
  }
  function BrandingContrastPair(key, backgroundColor, foregroundColor, textSize) {
    textSize = textSize === VOID ? 'NORMAL' : textSize;
    this.e1p_1 = key;
    this.f1p_1 = backgroundColor;
    this.g1p_1 = foregroundColor;
    this.h1p_1 = textSize;
  }
  protoOf(BrandingContrastPair).toString = function () {
    return 'BrandingContrastPair(key=' + this.e1p_1 + ', backgroundColor=' + this.f1p_1 + ', foregroundColor=' + this.g1p_1 + ', textSize=' + this.h1p_1 + ')';
  };
  protoOf(BrandingContrastPair).hashCode = function () {
    var result = getStringHashCode(this.e1p_1);
    result = imul(result, 31) + getStringHashCode(this.f1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1p_1) | 0;
    return result;
  };
  protoOf(BrandingContrastPair).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BrandingContrastPair))
      return false;
    var tmp0_other_with_cast = other instanceof BrandingContrastPair ? other : THROW_CCE();
    if (!(this.e1p_1 === tmp0_other_with_cast.e1p_1))
      return false;
    if (!(this.f1p_1 === tmp0_other_with_cast.f1p_1))
      return false;
    if (!(this.g1p_1 === tmp0_other_with_cast.g1p_1))
      return false;
    if (!(this.h1p_1 === tmp0_other_with_cast.h1p_1))
      return false;
    return true;
  };
  function Companion_16() {
    Companion_instance_16 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i1p_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_16();
    return Companion_instance_16;
  }
  function $serializer_18() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundleTemplate', this, 6);
    tmp0_serialDesc.gy('code', false);
    tmp0_serialDesc.gy('labelEn', false);
    tmp0_serialDesc.gy('labelAr', false);
    tmp0_serialDesc.gy('modules', false);
    tmp0_serialDesc.gy('leaves', false);
    tmp0_serialDesc.gy('defaultEmployees', true);
    this.j1p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).k1p = function (encoder, value) {
    var tmp0_desc = this.j1p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().i1p_1;
    tmp1_output.hs(tmp0_desc, 0, value.l1p_1);
    tmp1_output.hs(tmp0_desc, 1, value.m1p_1);
    tmp1_output.hs(tmp0_desc, 2, value.n1p_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.o1p_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.p1p_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !value.q1p_1.equals(new Long(1, 0))) {
      tmp1_output.ds(tmp0_desc, 5, value.q1p_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_18).on = function (encoder, value) {
    return this.k1p(encoder, value instanceof CapabilityBundleTemplate ? value : THROW_CCE());
  };
  protoOf($serializer_18).pn = function (decoder) {
    var tmp0_desc = this.j1p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_input = decoder.tq(tmp0_desc);
    var tmp11_cached = Companion_getInstance_16().i1p_1;
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.fr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.fr(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.fr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.fr(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return CapabilityBundleTemplate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_18).nn = function () {
    return this.j1p_1;
  };
  protoOf($serializer_18).vy = function () {
    var tmp0_cached = Companion_getInstance_16().i1p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3], tmp0_cached[4], LongSerializer_getInstance()];
  };
  var $serializer_instance_18;
  function $serializer_getInstance_18() {
    if ($serializer_instance_18 == null)
      new $serializer_18();
    return $serializer_instance_18;
  }
  function CapabilityBundleTemplate_init_$Init$(seen0, code, labelEn, labelAr, modules, leaves, defaultEmployees, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_18().j1p_1);
    }
    $this.l1p_1 = code;
    $this.m1p_1 = labelEn;
    $this.n1p_1 = labelAr;
    $this.o1p_1 = modules;
    $this.p1p_1 = leaves;
    if (0 === (seen0 & 32))
      $this.q1p_1 = new Long(1, 0);
    else
      $this.q1p_1 = defaultEmployees;
    return $this;
  }
  function CapabilityBundleTemplate_init_$Create$(seen0, code, labelEn, labelAr, modules, leaves, defaultEmployees, serializationConstructorMarker) {
    return CapabilityBundleTemplate_init_$Init$(seen0, code, labelEn, labelAr, modules, leaves, defaultEmployees, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundleTemplate)));
  }
  function CapabilityBundleTemplate(code, labelEn, labelAr, modules, leaves, defaultEmployees) {
    Companion_getInstance_16();
    defaultEmployees = defaultEmployees === VOID ? new Long(1, 0) : defaultEmployees;
    this.l1p_1 = code;
    this.m1p_1 = labelEn;
    this.n1p_1 = labelAr;
    this.o1p_1 = modules;
    this.p1p_1 = leaves;
    this.q1p_1 = defaultEmployees;
  }
  protoOf(CapabilityBundleTemplate).toString = function () {
    return 'CapabilityBundleTemplate(code=' + this.l1p_1 + ', labelEn=' + this.m1p_1 + ', labelAr=' + this.n1p_1 + ', modules=' + toString(this.o1p_1) + ', leaves=' + toString(this.p1p_1) + ', defaultEmployees=' + this.q1p_1.toString() + ')';
  };
  protoOf(CapabilityBundleTemplate).hashCode = function () {
    var result = getStringHashCode(this.l1p_1);
    result = imul(result, 31) + getStringHashCode(this.m1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n1p_1) | 0;
    result = imul(result, 31) + hashCode(this.o1p_1) | 0;
    result = imul(result, 31) + hashCode(this.p1p_1) | 0;
    result = imul(result, 31) + this.q1p_1.hashCode() | 0;
    return result;
  };
  protoOf(CapabilityBundleTemplate).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundleTemplate))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundleTemplate ? other : THROW_CCE();
    if (!(this.l1p_1 === tmp0_other_with_cast.l1p_1))
      return false;
    if (!(this.m1p_1 === tmp0_other_with_cast.m1p_1))
      return false;
    if (!(this.n1p_1 === tmp0_other_with_cast.n1p_1))
      return false;
    if (!equals(this.o1p_1, tmp0_other_with_cast.o1p_1))
      return false;
    if (!equals(this.p1p_1, tmp0_other_with_cast.p1p_1))
      return false;
    if (!this.q1p_1.equals(tmp0_other_with_cast.q1p_1))
      return false;
    return true;
  };
  function Companion_17() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r1p_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null, null, null, null, null];
  }
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_17();
    return Companion_instance_17;
  }
  function $serializer_19() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundleView', this, 13);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('templateCode', false);
    tmp0_serialDesc.gy('overrideIds', false);
    tmp0_serialDesc.gy('employeesCapacity', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('startsAtMs', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    tmp0_serialDesc.gy('grantedBy', false);
    tmp0_serialDesc.gy('grantedAtMs', false);
    tmp0_serialDesc.gy('revokedAtMs', true);
    tmp0_serialDesc.gy('revokedBy', true);
    tmp0_serialDesc.gy('revokeReason', true);
    this.s1p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).t1p = function (encoder, value) {
    var tmp0_desc = this.s1p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_17().r1p_1;
    tmp1_output.hs(tmp0_desc, 0, value.u1p_1);
    tmp1_output.hs(tmp0_desc, 1, value.v1p_1);
    tmp1_output.hs(tmp0_desc, 2, value.w1p_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.x1p_1);
    tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.y1p_1);
    tmp1_output.hs(tmp0_desc, 5, value.z1p_1);
    tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.a1q_1);
    tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.b1q_1);
    tmp1_output.hs(tmp0_desc, 8, value.c1q_1);
    tmp1_output.ds(tmp0_desc, 9, value.d1q_1);
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.e1q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, LongSerializer_getInstance(), value.e1q_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.f1q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, StringSerializer_getInstance(), value.f1q_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.g1q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 12, StringSerializer_getInstance(), value.g1q_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_19).on = function (encoder, value) {
    return this.t1p(encoder, value instanceof CapabilityBundleView ? value : THROW_CCE());
  };
  protoOf($serializer_19).pn = function (decoder) {
    var tmp0_desc = this.s1p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = new Long(0, 0);
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.tq(tmp0_desc);
    var tmp18_cached = Companion_getInstance_17().r1p_1;
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.fr(tmp0_desc, 3, tmp18_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.zq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.fr(tmp0_desc, 3, tmp18_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.zq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return CapabilityBundleView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_19).nn = function () {
    return this.s1p_1;
  };
  protoOf($serializer_19).vy = function () {
    var tmp0_cached = Companion_getInstance_17().r1p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3], get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_19;
  function $serializer_getInstance_19() {
    if ($serializer_instance_19 == null)
      new $serializer_19();
    return $serializer_instance_19;
  }
  function CapabilityBundleView_init_$Init$(seen0, id, tenantId, templateCode, overrideIds, employeesCapacity, reason, startsAtMs, expiresAtMs, grantedBy, grantedAtMs, revokedAtMs, revokedBy, revokeReason, serializationConstructorMarker, $this) {
    if (!(1023 === (1023 & seen0))) {
      throwMissingFieldException(seen0, 1023, $serializer_getInstance_19().s1p_1);
    }
    $this.u1p_1 = id;
    $this.v1p_1 = tenantId;
    $this.w1p_1 = templateCode;
    $this.x1p_1 = overrideIds;
    $this.y1p_1 = employeesCapacity;
    $this.z1p_1 = reason;
    $this.a1q_1 = startsAtMs;
    $this.b1q_1 = expiresAtMs;
    $this.c1q_1 = grantedBy;
    $this.d1q_1 = grantedAtMs;
    if (0 === (seen0 & 1024))
      $this.e1q_1 = null;
    else
      $this.e1q_1 = revokedAtMs;
    if (0 === (seen0 & 2048))
      $this.f1q_1 = null;
    else
      $this.f1q_1 = revokedBy;
    if (0 === (seen0 & 4096))
      $this.g1q_1 = null;
    else
      $this.g1q_1 = revokeReason;
    return $this;
  }
  function CapabilityBundleView_init_$Create$(seen0, id, tenantId, templateCode, overrideIds, employeesCapacity, reason, startsAtMs, expiresAtMs, grantedBy, grantedAtMs, revokedAtMs, revokedBy, revokeReason, serializationConstructorMarker) {
    return CapabilityBundleView_init_$Init$(seen0, id, tenantId, templateCode, overrideIds, employeesCapacity, reason, startsAtMs, expiresAtMs, grantedBy, grantedAtMs, revokedAtMs, revokedBy, revokeReason, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundleView)));
  }
  function CapabilityBundleView(id, tenantId, templateCode, overrideIds, employeesCapacity, reason, startsAtMs, expiresAtMs, grantedBy, grantedAtMs, revokedAtMs, revokedBy, revokeReason) {
    Companion_getInstance_17();
    revokedAtMs = revokedAtMs === VOID ? null : revokedAtMs;
    revokedBy = revokedBy === VOID ? null : revokedBy;
    revokeReason = revokeReason === VOID ? null : revokeReason;
    this.u1p_1 = id;
    this.v1p_1 = tenantId;
    this.w1p_1 = templateCode;
    this.x1p_1 = overrideIds;
    this.y1p_1 = employeesCapacity;
    this.z1p_1 = reason;
    this.a1q_1 = startsAtMs;
    this.b1q_1 = expiresAtMs;
    this.c1q_1 = grantedBy;
    this.d1q_1 = grantedAtMs;
    this.e1q_1 = revokedAtMs;
    this.f1q_1 = revokedBy;
    this.g1q_1 = revokeReason;
  }
  protoOf(CapabilityBundleView).toString = function () {
    return 'CapabilityBundleView(id=' + this.u1p_1 + ', tenantId=' + this.v1p_1 + ', templateCode=' + this.w1p_1 + ', overrideIds=' + toString(this.x1p_1) + ', employeesCapacity=' + toString_0(this.y1p_1) + ', reason=' + this.z1p_1 + ', startsAtMs=' + toString_0(this.a1q_1) + ', expiresAtMs=' + toString_0(this.b1q_1) + ', grantedBy=' + this.c1q_1 + ', grantedAtMs=' + this.d1q_1.toString() + ', revokedAtMs=' + toString_0(this.e1q_1) + ', revokedBy=' + this.f1q_1 + ', revokeReason=' + this.g1q_1 + ')';
  };
  protoOf(CapabilityBundleView).hashCode = function () {
    var result = getStringHashCode(this.u1p_1);
    result = imul(result, 31) + getStringHashCode(this.v1p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w1p_1) | 0;
    result = imul(result, 31) + hashCode(this.x1p_1) | 0;
    result = imul(result, 31) + (this.y1p_1 == null ? 0 : this.y1p_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1p_1) | 0;
    result = imul(result, 31) + (this.a1q_1 == null ? 0 : this.a1q_1.hashCode()) | 0;
    result = imul(result, 31) + (this.b1q_1 == null ? 0 : this.b1q_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1q_1) | 0;
    result = imul(result, 31) + this.d1q_1.hashCode() | 0;
    result = imul(result, 31) + (this.e1q_1 == null ? 0 : this.e1q_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f1q_1 == null ? 0 : getStringHashCode(this.f1q_1)) | 0;
    result = imul(result, 31) + (this.g1q_1 == null ? 0 : getStringHashCode(this.g1q_1)) | 0;
    return result;
  };
  protoOf(CapabilityBundleView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundleView))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundleView ? other : THROW_CCE();
    if (!(this.u1p_1 === tmp0_other_with_cast.u1p_1))
      return false;
    if (!(this.v1p_1 === tmp0_other_with_cast.v1p_1))
      return false;
    if (!(this.w1p_1 === tmp0_other_with_cast.w1p_1))
      return false;
    if (!equals(this.x1p_1, tmp0_other_with_cast.x1p_1))
      return false;
    if (!equals(this.y1p_1, tmp0_other_with_cast.y1p_1))
      return false;
    if (!(this.z1p_1 === tmp0_other_with_cast.z1p_1))
      return false;
    if (!equals(this.a1q_1, tmp0_other_with_cast.a1q_1))
      return false;
    if (!equals(this.b1q_1, tmp0_other_with_cast.b1q_1))
      return false;
    if (!(this.c1q_1 === tmp0_other_with_cast.c1q_1))
      return false;
    if (!this.d1q_1.equals(tmp0_other_with_cast.d1q_1))
      return false;
    if (!equals(this.e1q_1, tmp0_other_with_cast.e1q_1))
      return false;
    if (!(this.f1q_1 == tmp0_other_with_cast.f1q_1))
      return false;
    if (!(this.g1q_1 == tmp0_other_with_cast.g1q_1))
      return false;
    return true;
  };
  function Companion_18() {
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h1q_1 = [new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_18;
  function Companion_getInstance_18() {
    if (Companion_instance_18 == null)
      new Companion_18();
    return Companion_instance_18;
  }
  function $serializer_20() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundlePreview', this, 6);
    tmp0_serialDesc.gy('modulesToGrant', false);
    tmp0_serialDesc.gy('leavesGranted', false);
    tmp0_serialDesc.gy('leavesNotYetAvailable', false);
    tmp0_serialDesc.gy('employeesCapacity', false);
    tmp0_serialDesc.gy('accessVersion', false);
    tmp0_serialDesc.gy('warnings', true);
    this.i1q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).j1q = function (encoder, value) {
    var tmp0_desc = this.i1q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_18().h1q_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.k1q_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.l1q_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.m1q_1);
    tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.n1q_1);
    tmp1_output.ds(tmp0_desc, 4, value.o1q_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !equals(value.p1q_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.p1q_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_20).on = function (encoder, value) {
    return this.j1q(encoder, value instanceof CapabilityBundlePreview ? value : THROW_CCE());
  };
  protoOf($serializer_20).pn = function (decoder) {
    var tmp0_desc = this.i1q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    var tmp11_cached = Companion_getInstance_18().h1q_1;
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.fr(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.fr(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.fr(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.fr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.fr(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.fr(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.fr(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.fr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return CapabilityBundlePreview_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_20).nn = function () {
    return this.i1q_1;
  };
  protoOf($serializer_20).vy = function () {
    var tmp0_cached = Companion_getInstance_18().h1q_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], get_nullable(LongSerializer_getInstance()), LongSerializer_getInstance(), tmp0_cached[5]];
  };
  var $serializer_instance_20;
  function $serializer_getInstance_20() {
    if ($serializer_instance_20 == null)
      new $serializer_20();
    return $serializer_instance_20;
  }
  function CapabilityBundlePreview_init_$Init$(seen0, modulesToGrant, leavesGranted, leavesNotYetAvailable, employeesCapacity, accessVersion, warnings, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_20().i1q_1);
    }
    $this.k1q_1 = modulesToGrant;
    $this.l1q_1 = leavesGranted;
    $this.m1q_1 = leavesNotYetAvailable;
    $this.n1q_1 = employeesCapacity;
    $this.o1q_1 = accessVersion;
    if (0 === (seen0 & 32))
      $this.p1q_1 = emptyList();
    else
      $this.p1q_1 = warnings;
    return $this;
  }
  function CapabilityBundlePreview_init_$Create$(seen0, modulesToGrant, leavesGranted, leavesNotYetAvailable, employeesCapacity, accessVersion, warnings, serializationConstructorMarker) {
    return CapabilityBundlePreview_init_$Init$(seen0, modulesToGrant, leavesGranted, leavesNotYetAvailable, employeesCapacity, accessVersion, warnings, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundlePreview)));
  }
  function CapabilityBundlePreview(modulesToGrant, leavesGranted, leavesNotYetAvailable, employeesCapacity, accessVersion, warnings) {
    Companion_getInstance_18();
    warnings = warnings === VOID ? emptyList() : warnings;
    this.k1q_1 = modulesToGrant;
    this.l1q_1 = leavesGranted;
    this.m1q_1 = leavesNotYetAvailable;
    this.n1q_1 = employeesCapacity;
    this.o1q_1 = accessVersion;
    this.p1q_1 = warnings;
  }
  protoOf(CapabilityBundlePreview).toString = function () {
    return 'CapabilityBundlePreview(modulesToGrant=' + toString(this.k1q_1) + ', leavesGranted=' + toString(this.l1q_1) + ', leavesNotYetAvailable=' + toString(this.m1q_1) + ', employeesCapacity=' + toString_0(this.n1q_1) + ', accessVersion=' + this.o1q_1.toString() + ', warnings=' + toString(this.p1q_1) + ')';
  };
  protoOf(CapabilityBundlePreview).hashCode = function () {
    var result = hashCode(this.k1q_1);
    result = imul(result, 31) + hashCode(this.l1q_1) | 0;
    result = imul(result, 31) + hashCode(this.m1q_1) | 0;
    result = imul(result, 31) + (this.n1q_1 == null ? 0 : this.n1q_1.hashCode()) | 0;
    result = imul(result, 31) + this.o1q_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.p1q_1) | 0;
    return result;
  };
  protoOf(CapabilityBundlePreview).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundlePreview))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundlePreview ? other : THROW_CCE();
    if (!equals(this.k1q_1, tmp0_other_with_cast.k1q_1))
      return false;
    if (!equals(this.l1q_1, tmp0_other_with_cast.l1q_1))
      return false;
    if (!equals(this.m1q_1, tmp0_other_with_cast.m1q_1))
      return false;
    if (!equals(this.n1q_1, tmp0_other_with_cast.n1q_1))
      return false;
    if (!this.o1q_1.equals(tmp0_other_with_cast.o1q_1))
      return false;
    if (!equals(this.p1q_1, tmp0_other_with_cast.p1q_1))
      return false;
    return true;
  };
  function Companion_19() {
  }
  var Companion_instance_19;
  function Companion_getInstance_19() {
    return Companion_instance_19;
  }
  function $serializer_21() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundlePreviewRequest', this, 4);
    tmp0_serialDesc.gy('templateCode', false);
    tmp0_serialDesc.gy('employeesCapacity', true);
    tmp0_serialDesc.gy('startsAtMs', true);
    tmp0_serialDesc.gy('expiresAtMs', true);
    this.q1q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_21).r1q = function (encoder, value) {
    var tmp0_desc = this.q1q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.s1q_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.t1q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.t1q_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.u1q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, LongSerializer_getInstance(), value.u1q_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.v1q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.v1q_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_21).on = function (encoder, value) {
    return this.r1q(encoder, value instanceof CapabilityBundlePreviewRequest ? value : THROW_CCE());
  };
  protoOf($serializer_21).pn = function (decoder) {
    var tmp0_desc = this.q1q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return CapabilityBundlePreviewRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_21).nn = function () {
    return this.q1q_1;
  };
  protoOf($serializer_21).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_21;
  function $serializer_getInstance_21() {
    if ($serializer_instance_21 == null)
      new $serializer_21();
    return $serializer_instance_21;
  }
  function CapabilityBundlePreviewRequest_init_$Init$(seen0, templateCode, employeesCapacity, startsAtMs, expiresAtMs, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_21().q1q_1);
    }
    $this.s1q_1 = templateCode;
    if (0 === (seen0 & 2))
      $this.t1q_1 = null;
    else
      $this.t1q_1 = employeesCapacity;
    if (0 === (seen0 & 4))
      $this.u1q_1 = null;
    else
      $this.u1q_1 = startsAtMs;
    if (0 === (seen0 & 8))
      $this.v1q_1 = null;
    else
      $this.v1q_1 = expiresAtMs;
    return $this;
  }
  function CapabilityBundlePreviewRequest_init_$Create$(seen0, templateCode, employeesCapacity, startsAtMs, expiresAtMs, serializationConstructorMarker) {
    return CapabilityBundlePreviewRequest_init_$Init$(seen0, templateCode, employeesCapacity, startsAtMs, expiresAtMs, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundlePreviewRequest)));
  }
  function CapabilityBundlePreviewRequest(templateCode, employeesCapacity, startsAtMs, expiresAtMs) {
    employeesCapacity = employeesCapacity === VOID ? null : employeesCapacity;
    startsAtMs = startsAtMs === VOID ? null : startsAtMs;
    expiresAtMs = expiresAtMs === VOID ? null : expiresAtMs;
    this.s1q_1 = templateCode;
    this.t1q_1 = employeesCapacity;
    this.u1q_1 = startsAtMs;
    this.v1q_1 = expiresAtMs;
  }
  protoOf(CapabilityBundlePreviewRequest).toString = function () {
    return 'CapabilityBundlePreviewRequest(templateCode=' + this.s1q_1 + ', employeesCapacity=' + toString_0(this.t1q_1) + ', startsAtMs=' + toString_0(this.u1q_1) + ', expiresAtMs=' + toString_0(this.v1q_1) + ')';
  };
  protoOf(CapabilityBundlePreviewRequest).hashCode = function () {
    var result = getStringHashCode(this.s1q_1);
    result = imul(result, 31) + (this.t1q_1 == null ? 0 : this.t1q_1.hashCode()) | 0;
    result = imul(result, 31) + (this.u1q_1 == null ? 0 : this.u1q_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v1q_1 == null ? 0 : this.v1q_1.hashCode()) | 0;
    return result;
  };
  protoOf(CapabilityBundlePreviewRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundlePreviewRequest))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundlePreviewRequest ? other : THROW_CCE();
    if (!(this.s1q_1 === tmp0_other_with_cast.s1q_1))
      return false;
    if (!equals(this.t1q_1, tmp0_other_with_cast.t1q_1))
      return false;
    if (!equals(this.u1q_1, tmp0_other_with_cast.u1q_1))
      return false;
    if (!equals(this.v1q_1, tmp0_other_with_cast.v1q_1))
      return false;
    return true;
  };
  function Companion_20() {
  }
  var Companion_instance_20;
  function Companion_getInstance_20() {
    return Companion_instance_20;
  }
  function $serializer_22() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundleGrantResult', this, 4);
    tmp0_serialDesc.gy('bundle', false);
    tmp0_serialDesc.gy('preview', false);
    tmp0_serialDesc.gy('accessVersion', false);
    tmp0_serialDesc.gy('replayed', true);
    this.w1q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_22).x1q = function (encoder, value) {
    var tmp0_desc = this.w1q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_19(), value.y1q_1);
    tmp1_output.js(tmp0_desc, 1, $serializer_getInstance_20(), value.z1q_1);
    tmp1_output.ds(tmp0_desc, 2, value.a1r_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.b1r_1 === false)) {
      tmp1_output.zr(tmp0_desc, 3, value.b1r_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_22).on = function (encoder, value) {
    return this.x1q(encoder, value instanceof CapabilityBundleGrantResult ? value : THROW_CCE());
  };
  protoOf($serializer_22).pn = function (decoder) {
    var tmp0_desc = this.w1q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = false;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_19(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_19(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, $serializer_getInstance_20(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return CapabilityBundleGrantResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_22).nn = function () {
    return this.w1q_1;
  };
  protoOf($serializer_22).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_19(), $serializer_getInstance_20(), LongSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_22;
  function $serializer_getInstance_22() {
    if ($serializer_instance_22 == null)
      new $serializer_22();
    return $serializer_instance_22;
  }
  function CapabilityBundleGrantResult_init_$Init$(seen0, bundle, preview, accessVersion, replayed, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_22().w1q_1);
    }
    $this.y1q_1 = bundle;
    $this.z1q_1 = preview;
    $this.a1r_1 = accessVersion;
    if (0 === (seen0 & 8))
      $this.b1r_1 = false;
    else
      $this.b1r_1 = replayed;
    return $this;
  }
  function CapabilityBundleGrantResult_init_$Create$(seen0, bundle, preview, accessVersion, replayed, serializationConstructorMarker) {
    return CapabilityBundleGrantResult_init_$Init$(seen0, bundle, preview, accessVersion, replayed, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundleGrantResult)));
  }
  function CapabilityBundleGrantResult(bundle, preview, accessVersion, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.y1q_1 = bundle;
    this.z1q_1 = preview;
    this.a1r_1 = accessVersion;
    this.b1r_1 = replayed;
  }
  protoOf(CapabilityBundleGrantResult).toString = function () {
    return 'CapabilityBundleGrantResult(bundle=' + this.y1q_1.toString() + ', preview=' + this.z1q_1.toString() + ', accessVersion=' + this.a1r_1.toString() + ', replayed=' + this.b1r_1 + ')';
  };
  protoOf(CapabilityBundleGrantResult).hashCode = function () {
    var result = this.y1q_1.hashCode();
    result = imul(result, 31) + this.z1q_1.hashCode() | 0;
    result = imul(result, 31) + this.a1r_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b1r_1) | 0;
    return result;
  };
  protoOf(CapabilityBundleGrantResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundleGrantResult))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundleGrantResult ? other : THROW_CCE();
    if (!this.y1q_1.equals(tmp0_other_with_cast.y1q_1))
      return false;
    if (!this.z1q_1.equals(tmp0_other_with_cast.z1q_1))
      return false;
    if (!this.a1r_1.equals(tmp0_other_with_cast.a1r_1))
      return false;
    if (!(this.b1r_1 === tmp0_other_with_cast.b1r_1))
      return false;
    return true;
  };
  function Companion_21() {
  }
  var Companion_instance_21;
  function Companion_getInstance_21() {
    return Companion_instance_21;
  }
  function $serializer_23() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundleGrantRequest', this, 6);
    tmp0_serialDesc.gy('templateCode', false);
    tmp0_serialDesc.gy('employeesCapacity', true);
    tmp0_serialDesc.gy('startsAtMs', true);
    tmp0_serialDesc.gy('expiresAtMs', true);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('expectedAccessVersion', true);
    this.c1r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_23).d1r = function (encoder, value) {
    var tmp0_desc = this.c1r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.e1r_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.f1r_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.f1r_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.g1r_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, LongSerializer_getInstance(), value.g1r_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.h1r_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.h1r_1);
    }
    tmp1_output.hs(tmp0_desc, 4, value.i1r_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.j1r_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.j1r_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_23).on = function (encoder, value) {
    return this.d1r(encoder, value instanceof CapabilityBundleGrantRequest ? value : THROW_CCE());
  };
  protoOf($serializer_23).pn = function (decoder) {
    var tmp0_desc = this.c1r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return CapabilityBundleGrantRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_23).nn = function () {
    return this.c1r_1;
  };
  protoOf($serializer_23).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_23;
  function $serializer_getInstance_23() {
    if ($serializer_instance_23 == null)
      new $serializer_23();
    return $serializer_instance_23;
  }
  function CapabilityBundleGrantRequest_init_$Init$(seen0, templateCode, employeesCapacity, startsAtMs, expiresAtMs, reason, expectedAccessVersion, serializationConstructorMarker, $this) {
    if (!(17 === (17 & seen0))) {
      throwMissingFieldException(seen0, 17, $serializer_getInstance_23().c1r_1);
    }
    $this.e1r_1 = templateCode;
    if (0 === (seen0 & 2))
      $this.f1r_1 = null;
    else
      $this.f1r_1 = employeesCapacity;
    if (0 === (seen0 & 4))
      $this.g1r_1 = null;
    else
      $this.g1r_1 = startsAtMs;
    if (0 === (seen0 & 8))
      $this.h1r_1 = null;
    else
      $this.h1r_1 = expiresAtMs;
    $this.i1r_1 = reason;
    if (0 === (seen0 & 32))
      $this.j1r_1 = null;
    else
      $this.j1r_1 = expectedAccessVersion;
    return $this;
  }
  function CapabilityBundleGrantRequest_init_$Create$(seen0, templateCode, employeesCapacity, startsAtMs, expiresAtMs, reason, expectedAccessVersion, serializationConstructorMarker) {
    return CapabilityBundleGrantRequest_init_$Init$(seen0, templateCode, employeesCapacity, startsAtMs, expiresAtMs, reason, expectedAccessVersion, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundleGrantRequest)));
  }
  function CapabilityBundleGrantRequest(templateCode, employeesCapacity, startsAtMs, expiresAtMs, reason, expectedAccessVersion) {
    employeesCapacity = employeesCapacity === VOID ? null : employeesCapacity;
    startsAtMs = startsAtMs === VOID ? null : startsAtMs;
    expiresAtMs = expiresAtMs === VOID ? null : expiresAtMs;
    expectedAccessVersion = expectedAccessVersion === VOID ? null : expectedAccessVersion;
    this.e1r_1 = templateCode;
    this.f1r_1 = employeesCapacity;
    this.g1r_1 = startsAtMs;
    this.h1r_1 = expiresAtMs;
    this.i1r_1 = reason;
    this.j1r_1 = expectedAccessVersion;
  }
  protoOf(CapabilityBundleGrantRequest).toString = function () {
    return 'CapabilityBundleGrantRequest(templateCode=' + this.e1r_1 + ', employeesCapacity=' + toString_0(this.f1r_1) + ', startsAtMs=' + toString_0(this.g1r_1) + ', expiresAtMs=' + toString_0(this.h1r_1) + ', reason=' + this.i1r_1 + ', expectedAccessVersion=' + toString_0(this.j1r_1) + ')';
  };
  protoOf(CapabilityBundleGrantRequest).hashCode = function () {
    var result = getStringHashCode(this.e1r_1);
    result = imul(result, 31) + (this.f1r_1 == null ? 0 : this.f1r_1.hashCode()) | 0;
    result = imul(result, 31) + (this.g1r_1 == null ? 0 : this.g1r_1.hashCode()) | 0;
    result = imul(result, 31) + (this.h1r_1 == null ? 0 : this.h1r_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1r_1) | 0;
    result = imul(result, 31) + (this.j1r_1 == null ? 0 : this.j1r_1.hashCode()) | 0;
    return result;
  };
  protoOf(CapabilityBundleGrantRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundleGrantRequest))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundleGrantRequest ? other : THROW_CCE();
    if (!(this.e1r_1 === tmp0_other_with_cast.e1r_1))
      return false;
    if (!equals(this.f1r_1, tmp0_other_with_cast.f1r_1))
      return false;
    if (!equals(this.g1r_1, tmp0_other_with_cast.g1r_1))
      return false;
    if (!equals(this.h1r_1, tmp0_other_with_cast.h1r_1))
      return false;
    if (!(this.i1r_1 === tmp0_other_with_cast.i1r_1))
      return false;
    if (!equals(this.j1r_1, tmp0_other_with_cast.j1r_1))
      return false;
    return true;
  };
  function Companion_22() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k1r_1 = [null, new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_22();
    return Companion_instance_22;
  }
  function $serializer_24() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundleRevokePreview', this, 3);
    tmp0_serialDesc.gy('bundleId', false);
    tmp0_serialDesc.gy('modulesWithheld', false);
    tmp0_serialDesc.gy('accessVersion', false);
    this.l1r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_24).m1r = function (encoder, value) {
    var tmp0_desc = this.l1r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_22().k1r_1;
    tmp1_output.hs(tmp0_desc, 0, value.n1r_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.o1r_1);
    tmp1_output.ds(tmp0_desc, 2, value.p1r_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_24).on = function (encoder, value) {
    return this.m1r(encoder, value instanceof CapabilityBundleRevokePreview ? value : THROW_CCE());
  };
  protoOf($serializer_24).pn = function (decoder) {
    var tmp0_desc = this.l1r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_22().k1r_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return CapabilityBundleRevokePreview_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_24).nn = function () {
    return this.l1r_1;
  };
  protoOf($serializer_24).vy = function () {
    var tmp0_cached = Companion_getInstance_22().k1r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], LongSerializer_getInstance()];
  };
  var $serializer_instance_24;
  function $serializer_getInstance_24() {
    if ($serializer_instance_24 == null)
      new $serializer_24();
    return $serializer_instance_24;
  }
  function CapabilityBundleRevokePreview_init_$Init$(seen0, bundleId, modulesWithheld, accessVersion, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_24().l1r_1);
    }
    $this.n1r_1 = bundleId;
    $this.o1r_1 = modulesWithheld;
    $this.p1r_1 = accessVersion;
    return $this;
  }
  function CapabilityBundleRevokePreview_init_$Create$(seen0, bundleId, modulesWithheld, accessVersion, serializationConstructorMarker) {
    return CapabilityBundleRevokePreview_init_$Init$(seen0, bundleId, modulesWithheld, accessVersion, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundleRevokePreview)));
  }
  function CapabilityBundleRevokePreview(bundleId, modulesWithheld, accessVersion) {
    Companion_getInstance_22();
    this.n1r_1 = bundleId;
    this.o1r_1 = modulesWithheld;
    this.p1r_1 = accessVersion;
  }
  protoOf(CapabilityBundleRevokePreview).toString = function () {
    return 'CapabilityBundleRevokePreview(bundleId=' + this.n1r_1 + ', modulesWithheld=' + toString(this.o1r_1) + ', accessVersion=' + this.p1r_1.toString() + ')';
  };
  protoOf(CapabilityBundleRevokePreview).hashCode = function () {
    var result = getStringHashCode(this.n1r_1);
    result = imul(result, 31) + hashCode(this.o1r_1) | 0;
    result = imul(result, 31) + this.p1r_1.hashCode() | 0;
    return result;
  };
  protoOf(CapabilityBundleRevokePreview).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundleRevokePreview))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundleRevokePreview ? other : THROW_CCE();
    if (!(this.n1r_1 === tmp0_other_with_cast.n1r_1))
      return false;
    if (!equals(this.o1r_1, tmp0_other_with_cast.o1r_1))
      return false;
    if (!this.p1r_1.equals(tmp0_other_with_cast.p1r_1))
      return false;
    return true;
  };
  function Companion_23() {
    Companion_instance_23 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q1r_1 = [null, new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_23();
    return Companion_instance_23;
  }
  function $serializer_25() {
    $serializer_instance_25 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundleRevokeResult', this, 4);
    tmp0_serialDesc.gy('bundle', false);
    tmp0_serialDesc.gy('modulesWithheld', false);
    tmp0_serialDesc.gy('accessVersion', false);
    tmp0_serialDesc.gy('replayed', true);
    this.r1r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_25).s1r = function (encoder, value) {
    var tmp0_desc = this.r1r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_23().q1r_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_19(), value.t1r_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.u1r_1);
    tmp1_output.ds(tmp0_desc, 2, value.v1r_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.w1r_1 === false)) {
      tmp1_output.zr(tmp0_desc, 3, value.w1r_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_25).on = function (encoder, value) {
    return this.s1r(encoder, value instanceof CapabilityBundleRevokeResult ? value : THROW_CCE());
  };
  protoOf($serializer_25).pn = function (decoder) {
    var tmp0_desc = this.r1r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = false;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_23().q1r_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_19(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_19(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return CapabilityBundleRevokeResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_25).nn = function () {
    return this.r1r_1;
  };
  protoOf($serializer_25).vy = function () {
    var tmp0_cached = Companion_getInstance_23().q1r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_19(), tmp0_cached[1], LongSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_25;
  function $serializer_getInstance_25() {
    if ($serializer_instance_25 == null)
      new $serializer_25();
    return $serializer_instance_25;
  }
  function CapabilityBundleRevokeResult_init_$Init$(seen0, bundle, modulesWithheld, accessVersion, replayed, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_25().r1r_1);
    }
    $this.t1r_1 = bundle;
    $this.u1r_1 = modulesWithheld;
    $this.v1r_1 = accessVersion;
    if (0 === (seen0 & 8))
      $this.w1r_1 = false;
    else
      $this.w1r_1 = replayed;
    return $this;
  }
  function CapabilityBundleRevokeResult_init_$Create$(seen0, bundle, modulesWithheld, accessVersion, replayed, serializationConstructorMarker) {
    return CapabilityBundleRevokeResult_init_$Init$(seen0, bundle, modulesWithheld, accessVersion, replayed, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundleRevokeResult)));
  }
  function CapabilityBundleRevokeResult(bundle, modulesWithheld, accessVersion, replayed) {
    Companion_getInstance_23();
    replayed = replayed === VOID ? false : replayed;
    this.t1r_1 = bundle;
    this.u1r_1 = modulesWithheld;
    this.v1r_1 = accessVersion;
    this.w1r_1 = replayed;
  }
  protoOf(CapabilityBundleRevokeResult).toString = function () {
    return 'CapabilityBundleRevokeResult(bundle=' + this.t1r_1.toString() + ', modulesWithheld=' + toString(this.u1r_1) + ', accessVersion=' + this.v1r_1.toString() + ', replayed=' + this.w1r_1 + ')';
  };
  protoOf(CapabilityBundleRevokeResult).hashCode = function () {
    var result = this.t1r_1.hashCode();
    result = imul(result, 31) + hashCode(this.u1r_1) | 0;
    result = imul(result, 31) + this.v1r_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w1r_1) | 0;
    return result;
  };
  protoOf(CapabilityBundleRevokeResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundleRevokeResult))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundleRevokeResult ? other : THROW_CCE();
    if (!this.t1r_1.equals(tmp0_other_with_cast.t1r_1))
      return false;
    if (!equals(this.u1r_1, tmp0_other_with_cast.u1r_1))
      return false;
    if (!this.v1r_1.equals(tmp0_other_with_cast.v1r_1))
      return false;
    if (!(this.w1r_1 === tmp0_other_with_cast.w1r_1))
      return false;
    return true;
  };
  function Companion_24() {
  }
  var Companion_instance_24;
  function Companion_getInstance_24() {
    return Companion_instance_24;
  }
  function $serializer_26() {
    $serializer_instance_26 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityBundleRevokeRequest', this, 2);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('expectedAccessVersion', true);
    this.x1r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_26).y1r = function (encoder, value) {
    var tmp0_desc = this.x1r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.z1r_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.a1s_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.a1s_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_26).on = function (encoder, value) {
    return this.y1r(encoder, value instanceof CapabilityBundleRevokeRequest ? value : THROW_CCE());
  };
  protoOf($serializer_26).pn = function (decoder) {
    var tmp0_desc = this.x1r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return CapabilityBundleRevokeRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_26).nn = function () {
    return this.x1r_1;
  };
  protoOf($serializer_26).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_26;
  function $serializer_getInstance_26() {
    if ($serializer_instance_26 == null)
      new $serializer_26();
    return $serializer_instance_26;
  }
  function CapabilityBundleRevokeRequest_init_$Init$(seen0, reason, expectedAccessVersion, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_26().x1r_1);
    }
    $this.z1r_1 = reason;
    if (0 === (seen0 & 2))
      $this.a1s_1 = null;
    else
      $this.a1s_1 = expectedAccessVersion;
    return $this;
  }
  function CapabilityBundleRevokeRequest_init_$Create$(seen0, reason, expectedAccessVersion, serializationConstructorMarker) {
    return CapabilityBundleRevokeRequest_init_$Init$(seen0, reason, expectedAccessVersion, serializationConstructorMarker, objectCreate(protoOf(CapabilityBundleRevokeRequest)));
  }
  function CapabilityBundleRevokeRequest(reason, expectedAccessVersion) {
    expectedAccessVersion = expectedAccessVersion === VOID ? null : expectedAccessVersion;
    this.z1r_1 = reason;
    this.a1s_1 = expectedAccessVersion;
  }
  protoOf(CapabilityBundleRevokeRequest).toString = function () {
    return 'CapabilityBundleRevokeRequest(reason=' + this.z1r_1 + ', expectedAccessVersion=' + toString_0(this.a1s_1) + ')';
  };
  protoOf(CapabilityBundleRevokeRequest).hashCode = function () {
    var result = getStringHashCode(this.z1r_1);
    result = imul(result, 31) + (this.a1s_1 == null ? 0 : this.a1s_1.hashCode()) | 0;
    return result;
  };
  protoOf(CapabilityBundleRevokeRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityBundleRevokeRequest))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityBundleRevokeRequest ? other : THROW_CCE();
    if (!(this.z1r_1 === tmp0_other_with_cast.z1r_1))
      return false;
    if (!equals(this.a1s_1, tmp0_other_with_cast.a1s_1))
      return false;
    return true;
  };
  function Companion_25() {
    Companion_instance_25 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b1s_1 = [null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_28()), new ArrayListSerializer($serializer_getInstance_28()), null, null, null, new ArrayListSerializer($serializer_getInstance_29())];
  }
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_25();
    return Companion_instance_25;
  }
  function $serializer_27() {
    $serializer_instance_27 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CommercialLedgerView', this, 12);
    tmp0_serialDesc.gy('ledgerStatus', false);
    tmp0_serialDesc.gy('catalogVersion', false);
    tmp0_serialDesc.gy('measuredCatalogVersion', false);
    tmp0_serialDesc.gy('measuredRoutes', false);
    tmp0_serialDesc.gy('measuredTools', false);
    tmp0_serialDesc.gy('notes', false);
    tmp0_serialDesc.gy('modules', false);
    tmp0_serialDesc.gy('statuses', false);
    tmp0_serialDesc.gy('total', false);
    tmp0_serialDesc.gy('offset', false);
    tmp0_serialDesc.gy('limit', false);
    tmp0_serialDesc.gy('entries', false);
    this.c1s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_27).d1s = function (encoder, value) {
    var tmp0_desc = this.c1s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_25().b1s_1;
    tmp1_output.hs(tmp0_desc, 0, value.e1s_1);
    tmp1_output.cs(tmp0_desc, 1, value.f1s_1);
    tmp1_output.cs(tmp0_desc, 2, value.g1s_1);
    tmp1_output.cs(tmp0_desc, 3, value.h1s_1);
    tmp1_output.cs(tmp0_desc, 4, value.i1s_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.j1s_1);
    tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.k1s_1);
    tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.l1s_1);
    tmp1_output.cs(tmp0_desc, 8, value.m1s_1);
    tmp1_output.cs(tmp0_desc, 9, value.n1s_1);
    tmp1_output.cs(tmp0_desc, 10, value.o1s_1);
    tmp1_output.js(tmp0_desc, 11, tmp2_cached[11], value.p1s_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_27).on = function (encoder, value) {
    return this.d1s(encoder, value instanceof CommercialLedgerView ? value : THROW_CCE());
  };
  protoOf($serializer_27).pn = function (decoder) {
    var tmp0_desc = this.c1s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = 0;
    var tmp13_local9 = 0;
    var tmp14_local10 = 0;
    var tmp15_local11 = null;
    var tmp16_input = decoder.tq(tmp0_desc);
    var tmp17_cached = Companion_getInstance_25().b1s_1;
    if (tmp16_input.ir()) {
      tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.yq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.yq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.yq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.fr(tmp0_desc, 5, tmp17_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.fr(tmp0_desc, 6, tmp17_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.fr(tmp0_desc, 7, tmp17_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.yq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.yq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.yq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.fr(tmp0_desc, 11, tmp17_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.yq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.yq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.yq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.fr(tmp0_desc, 5, tmp17_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.fr(tmp0_desc, 6, tmp17_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.fr(tmp0_desc, 7, tmp17_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.yq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.yq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.yq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.fr(tmp0_desc, 11, tmp17_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.uq(tmp0_desc);
    return CommercialLedgerView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  protoOf($serializer_27).nn = function () {
    return this.c1s_1;
  };
  protoOf($serializer_27).vy = function () {
    var tmp0_cached = Companion_getInstance_25().b1s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[5], tmp0_cached[6], tmp0_cached[7], IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[11]];
  };
  var $serializer_instance_27;
  function $serializer_getInstance_27() {
    if ($serializer_instance_27 == null)
      new $serializer_27();
    return $serializer_instance_27;
  }
  function CommercialLedgerView_init_$Init$(seen0, ledgerStatus, catalogVersion, measuredCatalogVersion, measuredRoutes, measuredTools, notes, modules, statuses, total, offset, limit, entries, serializationConstructorMarker, $this) {
    if (!(4095 === (4095 & seen0))) {
      throwMissingFieldException(seen0, 4095, $serializer_getInstance_27().c1s_1);
    }
    $this.e1s_1 = ledgerStatus;
    $this.f1s_1 = catalogVersion;
    $this.g1s_1 = measuredCatalogVersion;
    $this.h1s_1 = measuredRoutes;
    $this.i1s_1 = measuredTools;
    $this.j1s_1 = notes;
    $this.k1s_1 = modules;
    $this.l1s_1 = statuses;
    $this.m1s_1 = total;
    $this.n1s_1 = offset;
    $this.o1s_1 = limit;
    $this.p1s_1 = entries;
    return $this;
  }
  function CommercialLedgerView_init_$Create$(seen0, ledgerStatus, catalogVersion, measuredCatalogVersion, measuredRoutes, measuredTools, notes, modules, statuses, total, offset, limit, entries, serializationConstructorMarker) {
    return CommercialLedgerView_init_$Init$(seen0, ledgerStatus, catalogVersion, measuredCatalogVersion, measuredRoutes, measuredTools, notes, modules, statuses, total, offset, limit, entries, serializationConstructorMarker, objectCreate(protoOf(CommercialLedgerView)));
  }
  function CommercialLedgerView(ledgerStatus, catalogVersion, measuredCatalogVersion, measuredRoutes, measuredTools, notes, modules, statuses, total, offset, limit, entries) {
    Companion_getInstance_25();
    this.e1s_1 = ledgerStatus;
    this.f1s_1 = catalogVersion;
    this.g1s_1 = measuredCatalogVersion;
    this.h1s_1 = measuredRoutes;
    this.i1s_1 = measuredTools;
    this.j1s_1 = notes;
    this.k1s_1 = modules;
    this.l1s_1 = statuses;
    this.m1s_1 = total;
    this.n1s_1 = offset;
    this.o1s_1 = limit;
    this.p1s_1 = entries;
  }
  protoOf(CommercialLedgerView).toString = function () {
    return 'CommercialLedgerView(ledgerStatus=' + this.e1s_1 + ', catalogVersion=' + this.f1s_1 + ', measuredCatalogVersion=' + this.g1s_1 + ', measuredRoutes=' + this.h1s_1 + ', measuredTools=' + this.i1s_1 + ', notes=' + toString(this.j1s_1) + ', modules=' + toString(this.k1s_1) + ', statuses=' + toString(this.l1s_1) + ', total=' + this.m1s_1 + ', offset=' + this.n1s_1 + ', limit=' + this.o1s_1 + ', entries=' + toString(this.p1s_1) + ')';
  };
  protoOf(CommercialLedgerView).hashCode = function () {
    var result = getStringHashCode(this.e1s_1);
    result = imul(result, 31) + this.f1s_1 | 0;
    result = imul(result, 31) + this.g1s_1 | 0;
    result = imul(result, 31) + this.h1s_1 | 0;
    result = imul(result, 31) + this.i1s_1 | 0;
    result = imul(result, 31) + hashCode(this.j1s_1) | 0;
    result = imul(result, 31) + hashCode(this.k1s_1) | 0;
    result = imul(result, 31) + hashCode(this.l1s_1) | 0;
    result = imul(result, 31) + this.m1s_1 | 0;
    result = imul(result, 31) + this.n1s_1 | 0;
    result = imul(result, 31) + this.o1s_1 | 0;
    result = imul(result, 31) + hashCode(this.p1s_1) | 0;
    return result;
  };
  protoOf(CommercialLedgerView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CommercialLedgerView))
      return false;
    var tmp0_other_with_cast = other instanceof CommercialLedgerView ? other : THROW_CCE();
    if (!(this.e1s_1 === tmp0_other_with_cast.e1s_1))
      return false;
    if (!(this.f1s_1 === tmp0_other_with_cast.f1s_1))
      return false;
    if (!(this.g1s_1 === tmp0_other_with_cast.g1s_1))
      return false;
    if (!(this.h1s_1 === tmp0_other_with_cast.h1s_1))
      return false;
    if (!(this.i1s_1 === tmp0_other_with_cast.i1s_1))
      return false;
    if (!equals(this.j1s_1, tmp0_other_with_cast.j1s_1))
      return false;
    if (!equals(this.k1s_1, tmp0_other_with_cast.k1s_1))
      return false;
    if (!equals(this.l1s_1, tmp0_other_with_cast.l1s_1))
      return false;
    if (!(this.m1s_1 === tmp0_other_with_cast.m1s_1))
      return false;
    if (!(this.n1s_1 === tmp0_other_with_cast.n1s_1))
      return false;
    if (!(this.o1s_1 === tmp0_other_with_cast.o1s_1))
      return false;
    if (!equals(this.p1s_1, tmp0_other_with_cast.p1s_1))
      return false;
    return true;
  };
  function $serializer_28() {
    $serializer_instance_28 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LedgerFacet', this, 4);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('count', false);
    this.q1s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_28).r1s = function (encoder, value) {
    var tmp0_desc = this.q1s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.s1s_1);
    tmp1_output.hs(tmp0_desc, 1, value.t1s_1);
    tmp1_output.hs(tmp0_desc, 2, value.u1s_1);
    tmp1_output.cs(tmp0_desc, 3, value.v1s_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_28).on = function (encoder, value) {
    return this.r1s(encoder, value instanceof LedgerFacet ? value : THROW_CCE());
  };
  protoOf($serializer_28).pn = function (decoder) {
    var tmp0_desc = this.q1s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.yq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.yq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return LedgerFacet_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_28).nn = function () {
    return this.q1s_1;
  };
  protoOf($serializer_28).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_28;
  function $serializer_getInstance_28() {
    if ($serializer_instance_28 == null)
      new $serializer_28();
    return $serializer_instance_28;
  }
  function LedgerFacet_init_$Init$(seen0, key, nameEn, nameAr, count, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_28().q1s_1);
    }
    $this.s1s_1 = key;
    $this.t1s_1 = nameEn;
    $this.u1s_1 = nameAr;
    $this.v1s_1 = count;
    return $this;
  }
  function LedgerFacet_init_$Create$(seen0, key, nameEn, nameAr, count, serializationConstructorMarker) {
    return LedgerFacet_init_$Init$(seen0, key, nameEn, nameAr, count, serializationConstructorMarker, objectCreate(protoOf(LedgerFacet)));
  }
  function LedgerFacet() {
  }
  protoOf(LedgerFacet).toString = function () {
    return 'LedgerFacet(key=' + this.s1s_1 + ', nameEn=' + this.t1s_1 + ', nameAr=' + this.u1s_1 + ', count=' + this.v1s_1 + ')';
  };
  protoOf(LedgerFacet).hashCode = function () {
    var result = getStringHashCode(this.s1s_1);
    result = imul(result, 31) + getStringHashCode(this.t1s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1s_1) | 0;
    result = imul(result, 31) + this.v1s_1 | 0;
    return result;
  };
  protoOf(LedgerFacet).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LedgerFacet))
      return false;
    var tmp0_other_with_cast = other instanceof LedgerFacet ? other : THROW_CCE();
    if (!(this.s1s_1 === tmp0_other_with_cast.s1s_1))
      return false;
    if (!(this.t1s_1 === tmp0_other_with_cast.t1s_1))
      return false;
    if (!(this.u1s_1 === tmp0_other_with_cast.u1s_1))
      return false;
    if (!(this.v1s_1 === tmp0_other_with_cast.v1s_1))
      return false;
    return true;
  };
  function Companion_26() {
    Companion_instance_26 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w1s_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_30()), new ArrayListSerializer($serializer_getInstance_31())];
  }
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_26();
    return Companion_instance_26;
  }
  function $serializer_29() {
    $serializer_instance_29 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LedgerEntry', this, 16);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('scope', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('moduleKey', true);
    tmp0_serialDesc.gy('sectionNameEn', false);
    tmp0_serialDesc.gy('sectionNameAr', false);
    tmp0_serialDesc.gy('group', false);
    tmp0_serialDesc.gy('groupNameEn', false);
    tmp0_serialDesc.gy('groupNameAr', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('sellable', false);
    tmp0_serialDesc.gy('releaseBlocking', false);
    tmp0_serialDesc.gy('surfaces', false);
    tmp0_serialDesc.gy('gaps', false);
    this.x1s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_29).y1s = function (encoder, value) {
    var tmp0_desc = this.x1s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_26().w1s_1;
    tmp1_output.hs(tmp0_desc, 0, value.z1s_1);
    tmp1_output.hs(tmp0_desc, 1, value.a1t_1);
    tmp1_output.hs(tmp0_desc, 2, value.b1t_1);
    tmp1_output.hs(tmp0_desc, 3, value.c1t_1);
    tmp1_output.hs(tmp0_desc, 4, value.d1t_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.e1t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.e1t_1);
    }
    tmp1_output.hs(tmp0_desc, 6, value.f1t_1);
    tmp1_output.hs(tmp0_desc, 7, value.g1t_1);
    tmp1_output.hs(tmp0_desc, 8, value.h1t_1);
    tmp1_output.hs(tmp0_desc, 9, value.i1t_1);
    tmp1_output.hs(tmp0_desc, 10, value.j1t_1);
    tmp1_output.hs(tmp0_desc, 11, value.k1t_1);
    tmp1_output.zr(tmp0_desc, 12, value.l1t_1);
    tmp1_output.zr(tmp0_desc, 13, value.m1t_1);
    tmp1_output.js(tmp0_desc, 14, tmp2_cached[14], value.n1t_1);
    tmp1_output.js(tmp0_desc, 15, tmp2_cached[15], value.o1t_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_29).on = function (encoder, value) {
    return this.y1s(encoder, value instanceof LedgerEntry ? value : THROW_CCE());
  };
  protoOf($serializer_29).pn = function (decoder) {
    var tmp0_desc = this.x1s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = false;
    var tmp17_local13 = false;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_input = decoder.tq(tmp0_desc);
    var tmp21_cached = Companion_getInstance_26().w1s_1;
    if (tmp20_input.ir()) {
      tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp20_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp20_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp20_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp20_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp20_input.dr(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp20_input.dr(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp20_input.dr(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp20_input.vq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp20_input.vq(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp20_input.fr(tmp0_desc, 14, tmp21_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp20_input.fr(tmp0_desc, 15, tmp21_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp20_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp20_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp20_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp20_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp20_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp20_input.dr(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp20_input.dr(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp20_input.dr(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp20_input.vq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp20_input.vq(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp20_input.fr(tmp0_desc, 14, tmp21_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp20_input.fr(tmp0_desc, 15, tmp21_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp20_input.uq(tmp0_desc);
    return LedgerEntry_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
  };
  protoOf($serializer_29).nn = function () {
    return this.x1s_1;
  };
  protoOf($serializer_29).vy = function () {
    var tmp0_cached = Companion_getInstance_26().w1s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[14], tmp0_cached[15]];
  };
  var $serializer_instance_29;
  function $serializer_getInstance_29() {
    if ($serializer_instance_29 == null)
      new $serializer_29();
    return $serializer_instance_29;
  }
  function LedgerEntry_init_$Init$(seen0, key, nameEn, nameAr, scope, kind, moduleKey, sectionNameEn, sectionNameAr, group, groupNameEn, groupNameAr, status, sellable, releaseBlocking, surfaces, gaps, serializationConstructorMarker, $this) {
    if (!(65503 === (65503 & seen0))) {
      throwMissingFieldException(seen0, 65503, $serializer_getInstance_29().x1s_1);
    }
    $this.z1s_1 = key;
    $this.a1t_1 = nameEn;
    $this.b1t_1 = nameAr;
    $this.c1t_1 = scope;
    $this.d1t_1 = kind;
    if (0 === (seen0 & 32))
      $this.e1t_1 = null;
    else
      $this.e1t_1 = moduleKey;
    $this.f1t_1 = sectionNameEn;
    $this.g1t_1 = sectionNameAr;
    $this.h1t_1 = group;
    $this.i1t_1 = groupNameEn;
    $this.j1t_1 = groupNameAr;
    $this.k1t_1 = status;
    $this.l1t_1 = sellable;
    $this.m1t_1 = releaseBlocking;
    $this.n1t_1 = surfaces;
    $this.o1t_1 = gaps;
    return $this;
  }
  function LedgerEntry_init_$Create$(seen0, key, nameEn, nameAr, scope, kind, moduleKey, sectionNameEn, sectionNameAr, group, groupNameEn, groupNameAr, status, sellable, releaseBlocking, surfaces, gaps, serializationConstructorMarker) {
    return LedgerEntry_init_$Init$(seen0, key, nameEn, nameAr, scope, kind, moduleKey, sectionNameEn, sectionNameAr, group, groupNameEn, groupNameAr, status, sellable, releaseBlocking, surfaces, gaps, serializationConstructorMarker, objectCreate(protoOf(LedgerEntry)));
  }
  function LedgerEntry() {
  }
  protoOf(LedgerEntry).toString = function () {
    return 'LedgerEntry(key=' + this.z1s_1 + ', nameEn=' + this.a1t_1 + ', nameAr=' + this.b1t_1 + ', scope=' + this.c1t_1 + ', kind=' + this.d1t_1 + ', moduleKey=' + this.e1t_1 + ', sectionNameEn=' + this.f1t_1 + ', sectionNameAr=' + this.g1t_1 + ', group=' + this.h1t_1 + ', groupNameEn=' + this.i1t_1 + ', groupNameAr=' + this.j1t_1 + ', status=' + this.k1t_1 + ', sellable=' + this.l1t_1 + ', releaseBlocking=' + this.m1t_1 + ', surfaces=' + toString(this.n1t_1) + ', gaps=' + toString(this.o1t_1) + ')';
  };
  protoOf(LedgerEntry).hashCode = function () {
    var result = getStringHashCode(this.z1s_1);
    result = imul(result, 31) + getStringHashCode(this.a1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d1t_1) | 0;
    result = imul(result, 31) + (this.e1t_1 == null ? 0 : getStringHashCode(this.e1t_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.f1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j1t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1t_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l1t_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m1t_1) | 0;
    result = imul(result, 31) + hashCode(this.n1t_1) | 0;
    result = imul(result, 31) + hashCode(this.o1t_1) | 0;
    return result;
  };
  protoOf(LedgerEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LedgerEntry))
      return false;
    var tmp0_other_with_cast = other instanceof LedgerEntry ? other : THROW_CCE();
    if (!(this.z1s_1 === tmp0_other_with_cast.z1s_1))
      return false;
    if (!(this.a1t_1 === tmp0_other_with_cast.a1t_1))
      return false;
    if (!(this.b1t_1 === tmp0_other_with_cast.b1t_1))
      return false;
    if (!(this.c1t_1 === tmp0_other_with_cast.c1t_1))
      return false;
    if (!(this.d1t_1 === tmp0_other_with_cast.d1t_1))
      return false;
    if (!(this.e1t_1 == tmp0_other_with_cast.e1t_1))
      return false;
    if (!(this.f1t_1 === tmp0_other_with_cast.f1t_1))
      return false;
    if (!(this.g1t_1 === tmp0_other_with_cast.g1t_1))
      return false;
    if (!(this.h1t_1 === tmp0_other_with_cast.h1t_1))
      return false;
    if (!(this.i1t_1 === tmp0_other_with_cast.i1t_1))
      return false;
    if (!(this.j1t_1 === tmp0_other_with_cast.j1t_1))
      return false;
    if (!(this.k1t_1 === tmp0_other_with_cast.k1t_1))
      return false;
    if (!(this.l1t_1 === tmp0_other_with_cast.l1t_1))
      return false;
    if (!(this.m1t_1 === tmp0_other_with_cast.m1t_1))
      return false;
    if (!equals(this.n1t_1, tmp0_other_with_cast.n1t_1))
      return false;
    if (!equals(this.o1t_1, tmp0_other_with_cast.o1t_1))
      return false;
    return true;
  };
  function $serializer_30() {
    $serializer_instance_30 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LedgerSurfaceColumn', this, 5);
    tmp0_serialDesc.gy('surface', false);
    tmp0_serialDesc.gy('authored', false);
    tmp0_serialDesc.gy('measured', false);
    tmp0_serialDesc.gy('mapped', true);
    tmp0_serialDesc.gy('gated', true);
    this.p1t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_30).q1t = function (encoder, value) {
    var tmp0_desc = this.p1t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.r1t_1);
    tmp1_output.cs(tmp0_desc, 1, value.s1t_1);
    tmp1_output.zr(tmp0_desc, 2, value.t1t_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.u1t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, IntSerializer_getInstance(), value.u1t_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.v1t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, IntSerializer_getInstance(), value.v1t_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_30).on = function (encoder, value) {
    return this.q1t(encoder, value instanceof LedgerSurfaceColumn ? value : THROW_CCE());
  };
  protoOf($serializer_30).pn = function (decoder) {
    var tmp0_desc = this.p1t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return LedgerSurfaceColumn_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_30).nn = function () {
    return this.p1t_1;
  };
  protoOf($serializer_30).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
  };
  var $serializer_instance_30;
  function $serializer_getInstance_30() {
    if ($serializer_instance_30 == null)
      new $serializer_30();
    return $serializer_instance_30;
  }
  function LedgerSurfaceColumn_init_$Init$(seen0, surface, authored, measured, mapped, gated, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_30().p1t_1);
    }
    $this.r1t_1 = surface;
    $this.s1t_1 = authored;
    $this.t1t_1 = measured;
    if (0 === (seen0 & 8))
      $this.u1t_1 = null;
    else
      $this.u1t_1 = mapped;
    if (0 === (seen0 & 16))
      $this.v1t_1 = null;
    else
      $this.v1t_1 = gated;
    return $this;
  }
  function LedgerSurfaceColumn_init_$Create$(seen0, surface, authored, measured, mapped, gated, serializationConstructorMarker) {
    return LedgerSurfaceColumn_init_$Init$(seen0, surface, authored, measured, mapped, gated, serializationConstructorMarker, objectCreate(protoOf(LedgerSurfaceColumn)));
  }
  function LedgerSurfaceColumn() {
  }
  protoOf(LedgerSurfaceColumn).toString = function () {
    return 'LedgerSurfaceColumn(surface=' + this.r1t_1 + ', authored=' + this.s1t_1 + ', measured=' + this.t1t_1 + ', mapped=' + this.u1t_1 + ', gated=' + this.v1t_1 + ')';
  };
  protoOf(LedgerSurfaceColumn).hashCode = function () {
    var result = getStringHashCode(this.r1t_1);
    result = imul(result, 31) + this.s1t_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t1t_1) | 0;
    result = imul(result, 31) + (this.u1t_1 == null ? 0 : this.u1t_1) | 0;
    result = imul(result, 31) + (this.v1t_1 == null ? 0 : this.v1t_1) | 0;
    return result;
  };
  protoOf(LedgerSurfaceColumn).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LedgerSurfaceColumn))
      return false;
    var tmp0_other_with_cast = other instanceof LedgerSurfaceColumn ? other : THROW_CCE();
    if (!(this.r1t_1 === tmp0_other_with_cast.r1t_1))
      return false;
    if (!(this.s1t_1 === tmp0_other_with_cast.s1t_1))
      return false;
    if (!(this.t1t_1 === tmp0_other_with_cast.t1t_1))
      return false;
    if (!(this.u1t_1 == tmp0_other_with_cast.u1t_1))
      return false;
    if (!(this.v1t_1 == tmp0_other_with_cast.v1t_1))
      return false;
    return true;
  };
  function LedgerSurfaceKeys() {
    LedgerSurfaceKeys_instance = this;
    this.w1t_1 = 'HTTP';
    this.x1t_1 = 'MCP';
    this.y1t_1 = 'WEB';
    this.z1t_1 = 'MOBILE';
    this.a1u_1 = 'JOBS';
    this.b1u_1 = 'WEBHOOKS';
    this.c1u_1 = listOf(['HTTP', 'MCP', 'WEB', 'MOBILE', 'JOBS', 'WEBHOOKS']);
  }
  var LedgerSurfaceKeys_instance;
  function LedgerSurfaceKeys_getInstance() {
    if (LedgerSurfaceKeys_instance == null)
      new LedgerSurfaceKeys();
    return LedgerSurfaceKeys_instance;
  }
  function Companion_27() {
    Companion_instance_27 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d1u_1 = [null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_27;
  function Companion_getInstance_27() {
    if (Companion_instance_27 == null)
      new Companion_27();
    return Companion_instance_27;
  }
  function $serializer_31() {
    $serializer_instance_31 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LedgerGap', this, 3);
    tmp0_serialDesc.gy('code', false);
    tmp0_serialDesc.gy('surface', true);
    tmp0_serialDesc.gy('items', true);
    this.e1u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_31).f1u = function (encoder, value) {
    var tmp0_desc = this.e1u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_27().d1u_1;
    tmp1_output.hs(tmp0_desc, 0, value.g1u_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.h1u_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.h1u_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !equals(value.i1u_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.i1u_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_31).on = function (encoder, value) {
    return this.f1u(encoder, value instanceof LedgerGap ? value : THROW_CCE());
  };
  protoOf($serializer_31).pn = function (decoder) {
    var tmp0_desc = this.e1u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_27().d1u_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return LedgerGap_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_31).nn = function () {
    return this.e1u_1;
  };
  protoOf($serializer_31).vy = function () {
    var tmp0_cached = Companion_getInstance_27().d1u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[2]];
  };
  var $serializer_instance_31;
  function $serializer_getInstance_31() {
    if ($serializer_instance_31 == null)
      new $serializer_31();
    return $serializer_instance_31;
  }
  function LedgerGap_init_$Init$(seen0, code, surface, items, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_31().e1u_1);
    }
    $this.g1u_1 = code;
    if (0 === (seen0 & 2))
      $this.h1u_1 = null;
    else
      $this.h1u_1 = surface;
    if (0 === (seen0 & 4))
      $this.i1u_1 = emptyList();
    else
      $this.i1u_1 = items;
    return $this;
  }
  function LedgerGap_init_$Create$(seen0, code, surface, items, serializationConstructorMarker) {
    return LedgerGap_init_$Init$(seen0, code, surface, items, serializationConstructorMarker, objectCreate(protoOf(LedgerGap)));
  }
  function LedgerGap() {
  }
  protoOf(LedgerGap).toString = function () {
    return 'LedgerGap(code=' + this.g1u_1 + ', surface=' + this.h1u_1 + ', items=' + toString(this.i1u_1) + ')';
  };
  protoOf(LedgerGap).hashCode = function () {
    var result = getStringHashCode(this.g1u_1);
    result = imul(result, 31) + (this.h1u_1 == null ? 0 : getStringHashCode(this.h1u_1)) | 0;
    result = imul(result, 31) + hashCode(this.i1u_1) | 0;
    return result;
  };
  protoOf(LedgerGap).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LedgerGap))
      return false;
    var tmp0_other_with_cast = other instanceof LedgerGap ? other : THROW_CCE();
    if (!(this.g1u_1 === tmp0_other_with_cast.g1u_1))
      return false;
    if (!(this.h1u_1 == tmp0_other_with_cast.h1u_1))
      return false;
    if (!equals(this.i1u_1, tmp0_other_with_cast.i1u_1))
      return false;
    return true;
  };
  function Companion_28() {
    Companion_instance_28 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j1u_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_35()), null];
  }
  protoOf(Companion_28).w19 = function () {
    return $serializer_getInstance_32();
  };
  var Companion_instance_28;
  function Companion_getInstance_28() {
    if (Companion_instance_28 == null)
      new Companion_28();
    return Companion_instance_28;
  }
  function $serializer_32() {
    $serializer_instance_32 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ConsoleError', this, 5);
    tmp0_serialDesc.gy('code', false);
    tmp0_serialDesc.gy('message', false);
    tmp0_serialDesc.gy('field', true);
    tmp0_serialDesc.gy('fieldErrors', true);
    tmp0_serialDesc.gy('details', true);
    this.k1u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_32).l1u = function (encoder, value) {
    var tmp0_desc = this.k1u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_28().j1u_1;
    tmp1_output.hs(tmp0_desc, 0, value.m1u_1);
    tmp1_output.hs(tmp0_desc, 1, value.n1u_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.o1u_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.o1u_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !equals(value.p1u_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.p1u_1);
    }
    if (!(value.q1u_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, $serializer_getInstance_102(), value.q1u_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_32).on = function (encoder, value) {
    return this.l1u(encoder, value instanceof ConsoleError ? value : THROW_CCE());
  };
  protoOf($serializer_32).pn = function (decoder) {
    var tmp0_desc = this.k1u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    var tmp10_cached = Companion_getInstance_28().j1u_1;
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.fr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, $serializer_getInstance_102(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.fr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, $serializer_getInstance_102(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return ConsoleError_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_32).nn = function () {
    return this.k1u_1;
  };
  protoOf($serializer_32).vy = function () {
    var tmp0_cached = Companion_getInstance_28().j1u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[3], get_nullable($serializer_getInstance_102())];
  };
  var $serializer_instance_32;
  function $serializer_getInstance_32() {
    if ($serializer_instance_32 == null)
      new $serializer_32();
    return $serializer_instance_32;
  }
  function ConsoleError_init_$Init$(seen0, code, message, field, fieldErrors, details, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_32().k1u_1);
    }
    $this.m1u_1 = code;
    $this.n1u_1 = message;
    if (0 === (seen0 & 4))
      $this.o1u_1 = null;
    else
      $this.o1u_1 = field;
    if (0 === (seen0 & 8))
      $this.p1u_1 = emptyList();
    else
      $this.p1u_1 = fieldErrors;
    if (0 === (seen0 & 16))
      $this.q1u_1 = null;
    else
      $this.q1u_1 = details;
    return $this;
  }
  function ConsoleError_init_$Create$(seen0, code, message, field, fieldErrors, details, serializationConstructorMarker) {
    return ConsoleError_init_$Init$(seen0, code, message, field, fieldErrors, details, serializationConstructorMarker, objectCreate(protoOf(ConsoleError)));
  }
  function ConsoleError(code, message, field, fieldErrors, details) {
    Companion_getInstance_28();
    field = field === VOID ? null : field;
    fieldErrors = fieldErrors === VOID ? emptyList() : fieldErrors;
    details = details === VOID ? null : details;
    this.m1u_1 = code;
    this.n1u_1 = message;
    this.o1u_1 = field;
    this.p1u_1 = fieldErrors;
    this.q1u_1 = details;
  }
  protoOf(ConsoleError).r1u = function (code, message, field, fieldErrors, details) {
    return new ConsoleError(code, message, field, fieldErrors, details);
  };
  protoOf(ConsoleError).s1u = function (code, message, field, fieldErrors, details, $super) {
    code = code === VOID ? this.m1u_1 : code;
    message = message === VOID ? this.n1u_1 : message;
    field = field === VOID ? this.o1u_1 : field;
    fieldErrors = fieldErrors === VOID ? this.p1u_1 : fieldErrors;
    details = details === VOID ? this.q1u_1 : details;
    return $super === VOID ? this.r1u(code, message, field, fieldErrors, details) : $super.r1u.call(this, code, message, field, fieldErrors, details);
  };
  protoOf(ConsoleError).toString = function () {
    return 'ConsoleError(code=' + this.m1u_1 + ', message=' + this.n1u_1 + ', field=' + this.o1u_1 + ', fieldErrors=' + toString(this.p1u_1) + ', details=' + toString_0(this.q1u_1) + ')';
  };
  protoOf(ConsoleError).hashCode = function () {
    var result = getStringHashCode(this.m1u_1);
    result = imul(result, 31) + getStringHashCode(this.n1u_1) | 0;
    result = imul(result, 31) + (this.o1u_1 == null ? 0 : getStringHashCode(this.o1u_1)) | 0;
    result = imul(result, 31) + hashCode(this.p1u_1) | 0;
    result = imul(result, 31) + (this.q1u_1 == null ? 0 : this.q1u_1.hashCode()) | 0;
    return result;
  };
  protoOf(ConsoleError).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConsoleError))
      return false;
    var tmp0_other_with_cast = other instanceof ConsoleError ? other : THROW_CCE();
    if (!(this.m1u_1 === tmp0_other_with_cast.m1u_1))
      return false;
    if (!(this.n1u_1 === tmp0_other_with_cast.n1u_1))
      return false;
    if (!(this.o1u_1 == tmp0_other_with_cast.o1u_1))
      return false;
    if (!equals(this.p1u_1, tmp0_other_with_cast.p1u_1))
      return false;
    if (!equals(this.q1u_1, tmp0_other_with_cast.q1u_1))
      return false;
    return true;
  };
  function Companion_29() {
    Companion_instance_29 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t1u_1 = [null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_29;
  function Companion_getInstance_29() {
    if (Companion_instance_29 == null)
      new Companion_29();
    return Companion_instance_29;
  }
  function $serializer_33() {
    $serializer_instance_33 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OperatorSummary', this, 5);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('email', false);
    tmp0_serialDesc.gy('displayName', false);
    tmp0_serialDesc.gy('role', false);
    tmp0_serialDesc.gy('capabilities', false);
    this.u1u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_33).v1u = function (encoder, value) {
    var tmp0_desc = this.u1u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_29().t1u_1;
    tmp1_output.hs(tmp0_desc, 0, value.w1u_1);
    tmp1_output.hs(tmp0_desc, 1, value.x1u_1);
    tmp1_output.hs(tmp0_desc, 2, value.y1u_1);
    tmp1_output.hs(tmp0_desc, 3, value.z1u_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.a1v_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_33).on = function (encoder, value) {
    return this.v1u(encoder, value instanceof OperatorSummary ? value : THROW_CCE());
  };
  protoOf($serializer_33).pn = function (decoder) {
    var tmp0_desc = this.u1u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    var tmp10_cached = Companion_getInstance_29().t1u_1;
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.fr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.fr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return OperatorSummary_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_33).nn = function () {
    return this.u1u_1;
  };
  protoOf($serializer_33).vy = function () {
    var tmp0_cached = Companion_getInstance_29().t1u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4]];
  };
  var $serializer_instance_33;
  function $serializer_getInstance_33() {
    if ($serializer_instance_33 == null)
      new $serializer_33();
    return $serializer_instance_33;
  }
  function OperatorSummary_init_$Init$(seen0, id, email, displayName, role, capabilities, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_33().u1u_1);
    }
    $this.w1u_1 = id;
    $this.x1u_1 = email;
    $this.y1u_1 = displayName;
    $this.z1u_1 = role;
    $this.a1v_1 = capabilities;
    return $this;
  }
  function OperatorSummary_init_$Create$(seen0, id, email, displayName, role, capabilities, serializationConstructorMarker) {
    return OperatorSummary_init_$Init$(seen0, id, email, displayName, role, capabilities, serializationConstructorMarker, objectCreate(protoOf(OperatorSummary)));
  }
  function OperatorSummary(id, email, displayName, role, capabilities) {
    Companion_getInstance_29();
    this.w1u_1 = id;
    this.x1u_1 = email;
    this.y1u_1 = displayName;
    this.z1u_1 = role;
    this.a1v_1 = capabilities;
  }
  protoOf(OperatorSummary).toString = function () {
    return 'OperatorSummary(id=' + this.w1u_1 + ', email=' + this.x1u_1 + ', displayName=' + this.y1u_1 + ', role=' + this.z1u_1 + ', capabilities=' + toString(this.a1v_1) + ')';
  };
  protoOf(OperatorSummary).hashCode = function () {
    var result = getStringHashCode(this.w1u_1);
    result = imul(result, 31) + getStringHashCode(this.x1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y1u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z1u_1) | 0;
    result = imul(result, 31) + hashCode(this.a1v_1) | 0;
    return result;
  };
  protoOf(OperatorSummary).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OperatorSummary))
      return false;
    var tmp0_other_with_cast = other instanceof OperatorSummary ? other : THROW_CCE();
    if (!(this.w1u_1 === tmp0_other_with_cast.w1u_1))
      return false;
    if (!(this.x1u_1 === tmp0_other_with_cast.x1u_1))
      return false;
    if (!(this.y1u_1 === tmp0_other_with_cast.y1u_1))
      return false;
    if (!(this.z1u_1 === tmp0_other_with_cast.z1u_1))
      return false;
    if (!equals(this.a1v_1, tmp0_other_with_cast.a1v_1))
      return false;
    return true;
  };
  function $serializer_34() {
    $serializer_instance_34 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.Money', this, 2);
    tmp0_serialDesc.gy('amountMinor', false);
    tmp0_serialDesc.gy('currency', false);
    this.b1v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_34).c1v = function (encoder, value) {
    var tmp0_desc = this.b1v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.d1v_1);
    tmp1_output.hs(tmp0_desc, 1, value.e1v_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_34).on = function (encoder, value) {
    return this.c1v(encoder, value instanceof Money ? value : THROW_CCE());
  };
  protoOf($serializer_34).pn = function (decoder) {
    var tmp0_desc = this.b1v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return Money_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_34).nn = function () {
    return this.b1v_1;
  };
  protoOf($serializer_34).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_34;
  function $serializer_getInstance_34() {
    if ($serializer_instance_34 == null)
      new $serializer_34();
    return $serializer_instance_34;
  }
  function Money_init_$Init$(seen0, amountMinor, currency, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_34().b1v_1);
    }
    $this.d1v_1 = amountMinor;
    $this.e1v_1 = currency;
    return $this;
  }
  function Money_init_$Create$(seen0, amountMinor, currency, serializationConstructorMarker) {
    return Money_init_$Init$(seen0, amountMinor, currency, serializationConstructorMarker, objectCreate(protoOf(Money)));
  }
  function Money() {
  }
  protoOf(Money).toString = function () {
    return 'Money(amountMinor=' + this.d1v_1.toString() + ', currency=' + this.e1v_1 + ')';
  };
  protoOf(Money).hashCode = function () {
    var result = this.d1v_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.e1v_1) | 0;
    return result;
  };
  protoOf(Money).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Money))
      return false;
    var tmp0_other_with_cast = other instanceof Money ? other : THROW_CCE();
    if (!this.d1v_1.equals(tmp0_other_with_cast.d1v_1))
      return false;
    if (!(this.e1v_1 === tmp0_other_with_cast.e1v_1))
      return false;
    return true;
  };
  function Companion_30() {
    Companion_instance_30 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f1v_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_30;
  function Companion_getInstance_30() {
    if (Companion_instance_30 == null)
      new Companion_30();
    return Companion_instance_30;
  }
  function $serializer_35() {
    $serializer_instance_35 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ConsoleFieldError', this, 4);
    tmp0_serialDesc.gy('path', false);
    tmp0_serialDesc.gy('code', false);
    tmp0_serialDesc.gy('messageKey', false);
    tmp0_serialDesc.gy('resolution', true);
    this.g1v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_35).h1v = function (encoder, value) {
    var tmp0_desc = this.g1v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_30().f1v_1;
    tmp1_output.hs(tmp0_desc, 0, value.i1v_1);
    tmp1_output.hs(tmp0_desc, 1, value.j1v_1);
    tmp1_output.hs(tmp0_desc, 2, value.k1v_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !equals(value.l1v_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.l1v_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_35).on = function (encoder, value) {
    return this.h1v(encoder, value instanceof ConsoleFieldError ? value : THROW_CCE());
  };
  protoOf($serializer_35).pn = function (decoder) {
    var tmp0_desc = this.g1v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_30().f1v_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return ConsoleFieldError_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_35).nn = function () {
    return this.g1v_1;
  };
  protoOf($serializer_35).vy = function () {
    var tmp0_cached = Companion_getInstance_30().f1v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3]];
  };
  var $serializer_instance_35;
  function $serializer_getInstance_35() {
    if ($serializer_instance_35 == null)
      new $serializer_35();
    return $serializer_instance_35;
  }
  function ConsoleFieldError_init_$Init$(seen0, path, code, messageKey, resolution, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_35().g1v_1);
    }
    $this.i1v_1 = path;
    $this.j1v_1 = code;
    $this.k1v_1 = messageKey;
    if (0 === (seen0 & 8))
      $this.l1v_1 = emptyList();
    else
      $this.l1v_1 = resolution;
    return $this;
  }
  function ConsoleFieldError_init_$Create$(seen0, path, code, messageKey, resolution, serializationConstructorMarker) {
    return ConsoleFieldError_init_$Init$(seen0, path, code, messageKey, resolution, serializationConstructorMarker, objectCreate(protoOf(ConsoleFieldError)));
  }
  function ConsoleFieldError(path, code, messageKey, resolution) {
    Companion_getInstance_30();
    resolution = resolution === VOID ? emptyList() : resolution;
    this.i1v_1 = path;
    this.j1v_1 = code;
    this.k1v_1 = messageKey;
    this.l1v_1 = resolution;
  }
  protoOf(ConsoleFieldError).m1v = function (path, code, messageKey, resolution) {
    return new ConsoleFieldError(path, code, messageKey, resolution);
  };
  protoOf(ConsoleFieldError).n1v = function (path, code, messageKey, resolution, $super) {
    path = path === VOID ? this.i1v_1 : path;
    code = code === VOID ? this.j1v_1 : code;
    messageKey = messageKey === VOID ? this.k1v_1 : messageKey;
    resolution = resolution === VOID ? this.l1v_1 : resolution;
    return $super === VOID ? this.m1v(path, code, messageKey, resolution) : $super.m1v.call(this, path, code, messageKey, resolution);
  };
  protoOf(ConsoleFieldError).toString = function () {
    return 'ConsoleFieldError(path=' + this.i1v_1 + ', code=' + this.j1v_1 + ', messageKey=' + this.k1v_1 + ', resolution=' + toString(this.l1v_1) + ')';
  };
  protoOf(ConsoleFieldError).hashCode = function () {
    var result = getStringHashCode(this.i1v_1);
    result = imul(result, 31) + getStringHashCode(this.j1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k1v_1) | 0;
    result = imul(result, 31) + hashCode(this.l1v_1) | 0;
    return result;
  };
  protoOf(ConsoleFieldError).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConsoleFieldError))
      return false;
    var tmp0_other_with_cast = other instanceof ConsoleFieldError ? other : THROW_CCE();
    if (!(this.i1v_1 === tmp0_other_with_cast.i1v_1))
      return false;
    if (!(this.j1v_1 === tmp0_other_with_cast.j1v_1))
      return false;
    if (!(this.k1v_1 === tmp0_other_with_cast.k1v_1))
      return false;
    if (!equals(this.l1v_1, tmp0_other_with_cast.l1v_1))
      return false;
    return true;
  };
  function Companion_31() {
    Companion_instance_31 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o1v_1 = [null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_88()), new ArrayListSerializer($serializer_getInstance_87()), null, new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_31;
  function Companion_getInstance_31() {
    if (Companion_instance_31 == null)
      new Companion_31();
    return Companion_instance_31;
  }
  function $serializer_36() {
    $serializer_instance_36 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanView', this, 18);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('descriptionEn', false);
    tmp0_serialDesc.gy('descriptionAr', false);
    tmp0_serialDesc.gy('isPublic', false);
    tmp0_serialDesc.gy('isActive', false);
    tmp0_serialDesc.gy('isCustom', false);
    tmp0_serialDesc.gy('customForTenantId', false);
    tmp0_serialDesc.gy('sortOrder', false);
    tmp0_serialDesc.gy('modules', false);
    tmp0_serialDesc.gy('limits', false);
    tmp0_serialDesc.gy('prices', false);
    tmp0_serialDesc.gy('subscriberCount', false);
    tmp0_serialDesc.gy('features', true);
    tmp0_serialDesc.gy('revision', true);
    tmp0_serialDesc.gy('lifecycle', true);
    this.p1v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_36).q1v = function (encoder, value) {
    var tmp0_desc = this.p1v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_31().o1v_1;
    tmp1_output.hs(tmp0_desc, 0, value.r1v_1);
    tmp1_output.hs(tmp0_desc, 1, value.s1v_1);
    tmp1_output.hs(tmp0_desc, 2, value.t1v_1);
    tmp1_output.hs(tmp0_desc, 3, value.u1v_1);
    tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.v1v_1);
    tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.w1v_1);
    tmp1_output.zr(tmp0_desc, 6, value.x1v_1);
    tmp1_output.zr(tmp0_desc, 7, value.y1v_1);
    tmp1_output.zr(tmp0_desc, 8, value.z1v_1);
    tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.a1w_1);
    tmp1_output.cs(tmp0_desc, 10, value.b1w_1);
    tmp1_output.js(tmp0_desc, 11, tmp2_cached[11], value.c1w_1);
    tmp1_output.js(tmp0_desc, 12, tmp2_cached[12], value.d1w_1);
    tmp1_output.js(tmp0_desc, 13, tmp2_cached[13], value.e1w_1);
    tmp1_output.cs(tmp0_desc, 14, value.f1w_1);
    if (tmp1_output.ps(tmp0_desc, 15) ? true : !equals(value.g1w_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 15, tmp2_cached[15], value.g1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 16) ? true : !value.h1w_1.equals(new Long(1, 0))) {
      tmp1_output.ds(tmp0_desc, 16, value.h1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 17) ? true : !(value.i1w_1 === 'DRAFT')) {
      tmp1_output.hs(tmp0_desc, 17, value.i1w_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_36).on = function (encoder, value) {
    return this.q1v(encoder, value instanceof PlanView ? value : THROW_CCE());
  };
  protoOf($serializer_36).pn = function (decoder) {
    var tmp0_desc = this.p1v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = null;
    var tmp14_local10 = 0;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = 0;
    var tmp19_local15 = null;
    var tmp20_local16 = new Long(0, 0);
    var tmp21_local17 = null;
    var tmp22_input = decoder.tq(tmp0_desc);
    var tmp23_cached = Companion_getInstance_31().o1v_1;
    if (tmp22_input.ir()) {
      tmp4_local0 = tmp22_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp22_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp22_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp22_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp22_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp22_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp22_input.vq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp22_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp22_input.vq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp22_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp22_input.yq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp22_input.fr(tmp0_desc, 11, tmp23_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp22_input.fr(tmp0_desc, 12, tmp23_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp22_input.fr(tmp0_desc, 13, tmp23_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp22_input.yq(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp22_input.fr(tmp0_desc, 15, tmp23_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp22_input.zq(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp22_input.dr(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp22_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp22_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp22_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp22_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp22_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp22_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp22_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp22_input.vq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp22_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp22_input.vq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp22_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp22_input.yq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp22_input.fr(tmp0_desc, 11, tmp23_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp22_input.fr(tmp0_desc, 12, tmp23_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp22_input.fr(tmp0_desc, 13, tmp23_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp22_input.yq(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp22_input.fr(tmp0_desc, 15, tmp23_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp22_input.zq(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp22_input.dr(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp22_input.uq(tmp0_desc);
    return PlanView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, null);
  };
  protoOf($serializer_36).nn = function () {
    return this.p1v_1;
  };
  protoOf($serializer_36).vy = function () {
    var tmp0_cached = Companion_getInstance_31().o1v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance(), tmp0_cached[11], tmp0_cached[12], tmp0_cached[13], IntSerializer_getInstance(), tmp0_cached[15], LongSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_36;
  function $serializer_getInstance_36() {
    if ($serializer_instance_36 == null)
      new $serializer_36();
    return $serializer_instance_36;
  }
  function PlanView_init_$Init$(seen0, id, key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, subscriberCount, features, revision, lifecycle, serializationConstructorMarker, $this) {
    if (!(32767 === (32767 & seen0))) {
      throwMissingFieldException(seen0, 32767, $serializer_getInstance_36().p1v_1);
    }
    $this.r1v_1 = id;
    $this.s1v_1 = key;
    $this.t1v_1 = nameEn;
    $this.u1v_1 = nameAr;
    $this.v1v_1 = descriptionEn;
    $this.w1v_1 = descriptionAr;
    $this.x1v_1 = isPublic;
    $this.y1v_1 = isActive;
    $this.z1v_1 = isCustom;
    $this.a1w_1 = customForTenantId;
    $this.b1w_1 = sortOrder;
    $this.c1w_1 = modules;
    $this.d1w_1 = limits;
    $this.e1w_1 = prices;
    $this.f1w_1 = subscriberCount;
    if (0 === (seen0 & 32768))
      $this.g1w_1 = emptyList();
    else
      $this.g1w_1 = features;
    if (0 === (seen0 & 65536))
      $this.h1w_1 = new Long(1, 0);
    else
      $this.h1w_1 = revision;
    if (0 === (seen0 & 131072))
      $this.i1w_1 = 'DRAFT';
    else
      $this.i1w_1 = lifecycle;
    return $this;
  }
  function PlanView_init_$Create$(seen0, id, key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, subscriberCount, features, revision, lifecycle, serializationConstructorMarker) {
    return PlanView_init_$Init$(seen0, id, key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, subscriberCount, features, revision, lifecycle, serializationConstructorMarker, objectCreate(protoOf(PlanView)));
  }
  function PlanView(id, key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, subscriberCount, features, revision, lifecycle) {
    Companion_getInstance_31();
    features = features === VOID ? emptyList() : features;
    revision = revision === VOID ? new Long(1, 0) : revision;
    lifecycle = lifecycle === VOID ? 'DRAFT' : lifecycle;
    this.r1v_1 = id;
    this.s1v_1 = key;
    this.t1v_1 = nameEn;
    this.u1v_1 = nameAr;
    this.v1v_1 = descriptionEn;
    this.w1v_1 = descriptionAr;
    this.x1v_1 = isPublic;
    this.y1v_1 = isActive;
    this.z1v_1 = isCustom;
    this.a1w_1 = customForTenantId;
    this.b1w_1 = sortOrder;
    this.c1w_1 = modules;
    this.d1w_1 = limits;
    this.e1w_1 = prices;
    this.f1w_1 = subscriberCount;
    this.g1w_1 = features;
    this.h1w_1 = revision;
    this.i1w_1 = lifecycle;
  }
  protoOf(PlanView).toString = function () {
    return 'PlanView(id=' + this.r1v_1 + ', key=' + this.s1v_1 + ', nameEn=' + this.t1v_1 + ', nameAr=' + this.u1v_1 + ', descriptionEn=' + this.v1v_1 + ', descriptionAr=' + this.w1v_1 + ', isPublic=' + this.x1v_1 + ', isActive=' + this.y1v_1 + ', isCustom=' + this.z1v_1 + ', customForTenantId=' + this.a1w_1 + ', sortOrder=' + this.b1w_1 + ', modules=' + toString(this.c1w_1) + ', limits=' + toString(this.d1w_1) + ', prices=' + toString(this.e1w_1) + ', subscriberCount=' + this.f1w_1 + ', features=' + toString(this.g1w_1) + ', revision=' + this.h1w_1.toString() + ', lifecycle=' + this.i1w_1 + ')';
  };
  protoOf(PlanView).hashCode = function () {
    var result = getStringHashCode(this.r1v_1);
    result = imul(result, 31) + getStringHashCode(this.s1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t1v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u1v_1) | 0;
    result = imul(result, 31) + (this.v1v_1 == null ? 0 : getStringHashCode(this.v1v_1)) | 0;
    result = imul(result, 31) + (this.w1v_1 == null ? 0 : getStringHashCode(this.w1v_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x1v_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y1v_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z1v_1) | 0;
    result = imul(result, 31) + (this.a1w_1 == null ? 0 : getStringHashCode(this.a1w_1)) | 0;
    result = imul(result, 31) + this.b1w_1 | 0;
    result = imul(result, 31) + hashCode(this.c1w_1) | 0;
    result = imul(result, 31) + hashCode(this.d1w_1) | 0;
    result = imul(result, 31) + hashCode(this.e1w_1) | 0;
    result = imul(result, 31) + this.f1w_1 | 0;
    result = imul(result, 31) + hashCode(this.g1w_1) | 0;
    result = imul(result, 31) + this.h1w_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.i1w_1) | 0;
    return result;
  };
  protoOf(PlanView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanView))
      return false;
    var tmp0_other_with_cast = other instanceof PlanView ? other : THROW_CCE();
    if (!(this.r1v_1 === tmp0_other_with_cast.r1v_1))
      return false;
    if (!(this.s1v_1 === tmp0_other_with_cast.s1v_1))
      return false;
    if (!(this.t1v_1 === tmp0_other_with_cast.t1v_1))
      return false;
    if (!(this.u1v_1 === tmp0_other_with_cast.u1v_1))
      return false;
    if (!(this.v1v_1 == tmp0_other_with_cast.v1v_1))
      return false;
    if (!(this.w1v_1 == tmp0_other_with_cast.w1v_1))
      return false;
    if (!(this.x1v_1 === tmp0_other_with_cast.x1v_1))
      return false;
    if (!(this.y1v_1 === tmp0_other_with_cast.y1v_1))
      return false;
    if (!(this.z1v_1 === tmp0_other_with_cast.z1v_1))
      return false;
    if (!(this.a1w_1 == tmp0_other_with_cast.a1w_1))
      return false;
    if (!(this.b1w_1 === tmp0_other_with_cast.b1w_1))
      return false;
    if (!equals(this.c1w_1, tmp0_other_with_cast.c1w_1))
      return false;
    if (!equals(this.d1w_1, tmp0_other_with_cast.d1w_1))
      return false;
    if (!equals(this.e1w_1, tmp0_other_with_cast.e1w_1))
      return false;
    if (!(this.f1w_1 === tmp0_other_with_cast.f1w_1))
      return false;
    if (!equals(this.g1w_1, tmp0_other_with_cast.g1w_1))
      return false;
    if (!this.h1w_1.equals(tmp0_other_with_cast.h1w_1))
      return false;
    if (!(this.i1w_1 === tmp0_other_with_cast.i1w_1))
      return false;
    return true;
  };
  function Companion_32() {
  }
  var Companion_instance_32;
  function Companion_getInstance_32() {
    return Companion_instance_32;
  }
  function $serializer_37() {
    $serializer_instance_37 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UpsertOverrideRequest', this, 12);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('targetKey', false);
    tmp0_serialDesc.gy('moduleGranted', true);
    tmp0_serialDesc.gy('limitValue', true);
    tmp0_serialDesc.gy('limitUnlimited', true);
    tmp0_serialDesc.gy('mode', true);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('expiresAtMs', true);
    tmp0_serialDesc.gy('granted', true);
    tmp0_serialDesc.gy('policy', true);
    tmp0_serialDesc.gy('expectedAccessVersion', true);
    tmp0_serialDesc.gy('startsAtMs', true);
    this.j1w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_37).k1w = function (encoder, value) {
    var tmp0_desc = this.j1w_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.l1w_1);
    tmp1_output.hs(tmp0_desc, 1, value.m1w_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.n1w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, BooleanSerializer_getInstance(), value.n1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.o1w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.o1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.p1w_1 === false)) {
      tmp1_output.zr(tmp0_desc, 4, value.p1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.q1w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.q1w_1);
    }
    tmp1_output.hs(tmp0_desc, 6, value.r1w_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.s1w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.s1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.t1w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, BooleanSerializer_getInstance(), value.t1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.u1w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.u1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.v1w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, LongSerializer_getInstance(), value.v1w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.w1w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, LongSerializer_getInstance(), value.w1w_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_37).on = function (encoder, value) {
    return this.k1w(encoder, value instanceof UpsertOverrideRequest ? value : THROW_CCE());
  };
  protoOf($serializer_37).pn = function (decoder) {
    var tmp0_desc = this.j1w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_input = decoder.tq(tmp0_desc);
    if (tmp16_input.ir()) {
      tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.hr(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.hr(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.hr(tmp0_desc, 2, BooleanSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.hr(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.uq(tmp0_desc);
    return UpsertOverrideRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  protoOf($serializer_37).nn = function () {
    return this.j1w_1;
  };
  protoOf($serializer_37).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(BooleanSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_37;
  function $serializer_getInstance_37() {
    if ($serializer_instance_37 == null)
      new $serializer_37();
    return $serializer_instance_37;
  }
  function UpsertOverrideRequest_init_$Init$(seen0, kind, targetKey, moduleGranted, limitValue, limitUnlimited, mode, reason, expiresAtMs, granted, policy, expectedAccessVersion, startsAtMs, serializationConstructorMarker, $this) {
    if (!(67 === (67 & seen0))) {
      throwMissingFieldException(seen0, 67, $serializer_getInstance_37().j1w_1);
    }
    $this.l1w_1 = kind;
    $this.m1w_1 = targetKey;
    if (0 === (seen0 & 4))
      $this.n1w_1 = null;
    else
      $this.n1w_1 = moduleGranted;
    if (0 === (seen0 & 8))
      $this.o1w_1 = null;
    else
      $this.o1w_1 = limitValue;
    if (0 === (seen0 & 16))
      $this.p1w_1 = false;
    else
      $this.p1w_1 = limitUnlimited;
    if (0 === (seen0 & 32))
      $this.q1w_1 = null;
    else
      $this.q1w_1 = mode;
    $this.r1w_1 = reason;
    if (0 === (seen0 & 128))
      $this.s1w_1 = null;
    else
      $this.s1w_1 = expiresAtMs;
    if (0 === (seen0 & 256))
      $this.t1w_1 = null;
    else
      $this.t1w_1 = granted;
    if (0 === (seen0 & 512))
      $this.u1w_1 = null;
    else
      $this.u1w_1 = policy;
    if (0 === (seen0 & 1024))
      $this.v1w_1 = null;
    else
      $this.v1w_1 = expectedAccessVersion;
    if (0 === (seen0 & 2048))
      $this.w1w_1 = null;
    else
      $this.w1w_1 = startsAtMs;
    return $this;
  }
  function UpsertOverrideRequest_init_$Create$(seen0, kind, targetKey, moduleGranted, limitValue, limitUnlimited, mode, reason, expiresAtMs, granted, policy, expectedAccessVersion, startsAtMs, serializationConstructorMarker) {
    return UpsertOverrideRequest_init_$Init$(seen0, kind, targetKey, moduleGranted, limitValue, limitUnlimited, mode, reason, expiresAtMs, granted, policy, expectedAccessVersion, startsAtMs, serializationConstructorMarker, objectCreate(protoOf(UpsertOverrideRequest)));
  }
  function UpsertOverrideRequest(kind, targetKey, moduleGranted, limitValue, limitUnlimited, mode, reason, expiresAtMs, granted, policy, expectedAccessVersion, startsAtMs) {
    moduleGranted = moduleGranted === VOID ? null : moduleGranted;
    limitValue = limitValue === VOID ? null : limitValue;
    limitUnlimited = limitUnlimited === VOID ? false : limitUnlimited;
    mode = mode === VOID ? null : mode;
    expiresAtMs = expiresAtMs === VOID ? null : expiresAtMs;
    granted = granted === VOID ? null : granted;
    policy = policy === VOID ? null : policy;
    expectedAccessVersion = expectedAccessVersion === VOID ? null : expectedAccessVersion;
    startsAtMs = startsAtMs === VOID ? null : startsAtMs;
    this.l1w_1 = kind;
    this.m1w_1 = targetKey;
    this.n1w_1 = moduleGranted;
    this.o1w_1 = limitValue;
    this.p1w_1 = limitUnlimited;
    this.q1w_1 = mode;
    this.r1w_1 = reason;
    this.s1w_1 = expiresAtMs;
    this.t1w_1 = granted;
    this.u1w_1 = policy;
    this.v1w_1 = expectedAccessVersion;
    this.w1w_1 = startsAtMs;
  }
  protoOf(UpsertOverrideRequest).toString = function () {
    return 'UpsertOverrideRequest(kind=' + this.l1w_1 + ', targetKey=' + this.m1w_1 + ', moduleGranted=' + this.n1w_1 + ', limitValue=' + toString_0(this.o1w_1) + ', limitUnlimited=' + this.p1w_1 + ', mode=' + this.q1w_1 + ', reason=' + this.r1w_1 + ', expiresAtMs=' + toString_0(this.s1w_1) + ', granted=' + this.t1w_1 + ', policy=' + this.u1w_1 + ', expectedAccessVersion=' + toString_0(this.v1w_1) + ', startsAtMs=' + toString_0(this.w1w_1) + ')';
  };
  protoOf(UpsertOverrideRequest).hashCode = function () {
    var result = getStringHashCode(this.l1w_1);
    result = imul(result, 31) + getStringHashCode(this.m1w_1) | 0;
    result = imul(result, 31) + (this.n1w_1 == null ? 0 : getBooleanHashCode(this.n1w_1)) | 0;
    result = imul(result, 31) + (this.o1w_1 == null ? 0 : this.o1w_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p1w_1) | 0;
    result = imul(result, 31) + (this.q1w_1 == null ? 0 : getStringHashCode(this.q1w_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.r1w_1) | 0;
    result = imul(result, 31) + (this.s1w_1 == null ? 0 : this.s1w_1.hashCode()) | 0;
    result = imul(result, 31) + (this.t1w_1 == null ? 0 : getBooleanHashCode(this.t1w_1)) | 0;
    result = imul(result, 31) + (this.u1w_1 == null ? 0 : getStringHashCode(this.u1w_1)) | 0;
    result = imul(result, 31) + (this.v1w_1 == null ? 0 : this.v1w_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w1w_1 == null ? 0 : this.w1w_1.hashCode()) | 0;
    return result;
  };
  protoOf(UpsertOverrideRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpsertOverrideRequest))
      return false;
    var tmp0_other_with_cast = other instanceof UpsertOverrideRequest ? other : THROW_CCE();
    if (!(this.l1w_1 === tmp0_other_with_cast.l1w_1))
      return false;
    if (!(this.m1w_1 === tmp0_other_with_cast.m1w_1))
      return false;
    if (!(this.n1w_1 == tmp0_other_with_cast.n1w_1))
      return false;
    if (!equals(this.o1w_1, tmp0_other_with_cast.o1w_1))
      return false;
    if (!(this.p1w_1 === tmp0_other_with_cast.p1w_1))
      return false;
    if (!(this.q1w_1 == tmp0_other_with_cast.q1w_1))
      return false;
    if (!(this.r1w_1 === tmp0_other_with_cast.r1w_1))
      return false;
    if (!equals(this.s1w_1, tmp0_other_with_cast.s1w_1))
      return false;
    if (!(this.t1w_1 == tmp0_other_with_cast.t1w_1))
      return false;
    if (!(this.u1w_1 == tmp0_other_with_cast.u1w_1))
      return false;
    if (!equals(this.v1w_1, tmp0_other_with_cast.v1w_1))
      return false;
    if (!equals(this.w1w_1, tmp0_other_with_cast.w1w_1))
      return false;
    return true;
  };
  function Companion_33() {
    Companion_instance_33 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x1w_1 = [null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_87()), new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_33;
  function Companion_getInstance_33() {
    if (Companion_instance_33 == null)
      new Companion_33();
    return Companion_instance_33;
  }
  function $serializer_38() {
    $serializer_instance_38 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UpsertAddonPackRequest', this, 12);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('quantity', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('expiresDays', true);
    tmp0_serialDesc.gy('isPublic', true);
    tmp0_serialDesc.gy('isActive', true);
    tmp0_serialDesc.gy('prices', true);
    tmp0_serialDesc.gy('features', true);
    tmp0_serialDesc.gy('expectedRevision', true);
    tmp0_serialDesc.gy('reason', true);
    this.y1w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_38).z1w = function (encoder, value) {
    var tmp0_desc = this.y1w_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_33().x1w_1;
    tmp1_output.hs(tmp0_desc, 0, value.a1x_1);
    tmp1_output.hs(tmp0_desc, 1, value.b1x_1);
    tmp1_output.ds(tmp0_desc, 2, value.c1x_1);
    tmp1_output.hs(tmp0_desc, 3, value.d1x_1);
    tmp1_output.hs(tmp0_desc, 4, value.e1x_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.f1x_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, IntSerializer_getInstance(), value.f1x_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.g1x_1 === true)) {
      tmp1_output.zr(tmp0_desc, 6, value.g1x_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.h1x_1 === true)) {
      tmp1_output.zr(tmp0_desc, 7, value.h1x_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !equals(value.i1x_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.i1x_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !equals(value.j1x_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.j1x_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.k1x_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.k1x_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.l1x_1 === '')) {
      tmp1_output.hs(tmp0_desc, 11, value.l1x_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_38).on = function (encoder, value) {
    return this.z1w(encoder, value instanceof UpsertAddonPackRequest ? value : THROW_CCE());
  };
  protoOf($serializer_38).pn = function (decoder) {
    var tmp0_desc = this.y1w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_local7 = false;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_input = decoder.tq(tmp0_desc);
    var tmp17_cached = Companion_getInstance_33().x1w_1;
    if (tmp16_input.ir()) {
      tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.hr(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.vq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.fr(tmp0_desc, 8, tmp17_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.fr(tmp0_desc, 9, tmp17_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.dr(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.hr(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.vq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.fr(tmp0_desc, 8, tmp17_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.fr(tmp0_desc, 9, tmp17_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.dr(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.uq(tmp0_desc);
    return UpsertAddonPackRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  protoOf($serializer_38).nn = function () {
    return this.y1w_1;
  };
  protoOf($serializer_38).vy = function () {
    var tmp0_cached = Companion_getInstance_33().x1w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[8], tmp0_cached[9], get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
  };
  var $serializer_instance_38;
  function $serializer_getInstance_38() {
    if ($serializer_instance_38 == null)
      new $serializer_38();
    return $serializer_instance_38;
  }
  function UpsertAddonPackRequest_init_$Init$(seen0, key, limitKey, quantity, nameEn, nameAr, expiresDays, isPublic, isActive, prices, features, expectedRevision, reason, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_38().y1w_1);
    }
    $this.a1x_1 = key;
    $this.b1x_1 = limitKey;
    $this.c1x_1 = quantity;
    $this.d1x_1 = nameEn;
    $this.e1x_1 = nameAr;
    if (0 === (seen0 & 32))
      $this.f1x_1 = null;
    else
      $this.f1x_1 = expiresDays;
    if (0 === (seen0 & 64))
      $this.g1x_1 = true;
    else
      $this.g1x_1 = isPublic;
    if (0 === (seen0 & 128))
      $this.h1x_1 = true;
    else
      $this.h1x_1 = isActive;
    if (0 === (seen0 & 256))
      $this.i1x_1 = emptyList();
    else
      $this.i1x_1 = prices;
    if (0 === (seen0 & 512))
      $this.j1x_1 = emptyList();
    else
      $this.j1x_1 = features;
    if (0 === (seen0 & 1024))
      $this.k1x_1 = null;
    else
      $this.k1x_1 = expectedRevision;
    if (0 === (seen0 & 2048))
      $this.l1x_1 = '';
    else
      $this.l1x_1 = reason;
    return $this;
  }
  function UpsertAddonPackRequest_init_$Create$(seen0, key, limitKey, quantity, nameEn, nameAr, expiresDays, isPublic, isActive, prices, features, expectedRevision, reason, serializationConstructorMarker) {
    return UpsertAddonPackRequest_init_$Init$(seen0, key, limitKey, quantity, nameEn, nameAr, expiresDays, isPublic, isActive, prices, features, expectedRevision, reason, serializationConstructorMarker, objectCreate(protoOf(UpsertAddonPackRequest)));
  }
  function UpsertAddonPackRequest(key, limitKey, quantity, nameEn, nameAr, expiresDays, isPublic, isActive, prices, features, expectedRevision, reason) {
    Companion_getInstance_33();
    expiresDays = expiresDays === VOID ? null : expiresDays;
    isPublic = isPublic === VOID ? true : isPublic;
    isActive = isActive === VOID ? true : isActive;
    prices = prices === VOID ? emptyList() : prices;
    features = features === VOID ? emptyList() : features;
    expectedRevision = expectedRevision === VOID ? null : expectedRevision;
    reason = reason === VOID ? '' : reason;
    this.a1x_1 = key;
    this.b1x_1 = limitKey;
    this.c1x_1 = quantity;
    this.d1x_1 = nameEn;
    this.e1x_1 = nameAr;
    this.f1x_1 = expiresDays;
    this.g1x_1 = isPublic;
    this.h1x_1 = isActive;
    this.i1x_1 = prices;
    this.j1x_1 = features;
    this.k1x_1 = expectedRevision;
    this.l1x_1 = reason;
  }
  protoOf(UpsertAddonPackRequest).toString = function () {
    return 'UpsertAddonPackRequest(key=' + this.a1x_1 + ', limitKey=' + this.b1x_1 + ', quantity=' + this.c1x_1.toString() + ', nameEn=' + this.d1x_1 + ', nameAr=' + this.e1x_1 + ', expiresDays=' + this.f1x_1 + ', isPublic=' + this.g1x_1 + ', isActive=' + this.h1x_1 + ', prices=' + toString(this.i1x_1) + ', features=' + toString(this.j1x_1) + ', expectedRevision=' + this.k1x_1 + ', reason=' + this.l1x_1 + ')';
  };
  protoOf(UpsertAddonPackRequest).hashCode = function () {
    var result = getStringHashCode(this.a1x_1);
    result = imul(result, 31) + getStringHashCode(this.b1x_1) | 0;
    result = imul(result, 31) + this.c1x_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.d1x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e1x_1) | 0;
    result = imul(result, 31) + (this.f1x_1 == null ? 0 : this.f1x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g1x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h1x_1) | 0;
    result = imul(result, 31) + hashCode(this.i1x_1) | 0;
    result = imul(result, 31) + hashCode(this.j1x_1) | 0;
    result = imul(result, 31) + (this.k1x_1 == null ? 0 : getStringHashCode(this.k1x_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.l1x_1) | 0;
    return result;
  };
  protoOf(UpsertAddonPackRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpsertAddonPackRequest))
      return false;
    var tmp0_other_with_cast = other instanceof UpsertAddonPackRequest ? other : THROW_CCE();
    if (!(this.a1x_1 === tmp0_other_with_cast.a1x_1))
      return false;
    if (!(this.b1x_1 === tmp0_other_with_cast.b1x_1))
      return false;
    if (!this.c1x_1.equals(tmp0_other_with_cast.c1x_1))
      return false;
    if (!(this.d1x_1 === tmp0_other_with_cast.d1x_1))
      return false;
    if (!(this.e1x_1 === tmp0_other_with_cast.e1x_1))
      return false;
    if (!(this.f1x_1 == tmp0_other_with_cast.f1x_1))
      return false;
    if (!(this.g1x_1 === tmp0_other_with_cast.g1x_1))
      return false;
    if (!(this.h1x_1 === tmp0_other_with_cast.h1x_1))
      return false;
    if (!equals(this.i1x_1, tmp0_other_with_cast.i1x_1))
      return false;
    if (!equals(this.j1x_1, tmp0_other_with_cast.j1x_1))
      return false;
    if (!(this.k1x_1 == tmp0_other_with_cast.k1x_1))
      return false;
    if (!(this.l1x_1 === tmp0_other_with_cast.l1x_1))
      return false;
    return true;
  };
  function ConsoleApiPaths() {
    this.m1x_1 = '/api/console';
    this.n1x_1 = '/api/console/auth/login';
    this.o1x_1 = '/api/console/auth/logout';
    this.p1x_1 = '/api/console/auth/me';
    this.q1x_1 = '/api/console/auth/totp/enrol';
    this.r1x_1 = '/api/console/auth/totp/confirm';
    this.s1x_1 = '/api/console/cockpit';
    this.t1x_1 = '/api/console/tenants';
    this.u1x_1 = '/api/console/catalog/plans';
    this.v1x_1 = '/api/console/catalog/addons';
    this.w1x_1 = '/api/console/catalog/registry';
    this.x1x_1 = '/api/console/catalog/wa-rate-cards';
    this.y1x_1 = '/api/console/protected-identities';
    this.z1x_1 = '/api/console/protected-identities/status';
    this.a1y_1 = '/api/console/capabilities';
    this.b1y_1 = '/api/console/subscriptions';
    this.c1y_1 = '/api/console/usage';
    this.d1y_1 = '/api/console/ops';
    this.e1y_1 = '/api/console/audit';
    this.f1y_1 = '/api/console/notices';
    this.g1y_1 = '/api/console/flags';
    this.h1y_1 = '/api/console/invoices';
    this.i1y_1 = '/api/console/integrations';
    this.j1y_1 = '/api/console/config/preview';
    this.k1y_1 = '/api/console/config/diff';
    this.l1y_1 = '/api/console/blueprints';
    this.m1y_1 = '/api/console/mcp';
    this.n1y_1 = '/api/console/mcp/tokens';
    this.o1y_1 = '/api/console/mcp/activity';
    this.p1y_1 = 'readiness';
    this.q1y_1 = 'training-copy';
    this.r1y_1 = 'discard';
    this.s1y_1 = 'owner-link';
    this.t1y_1 = 'support-session';
    this.u1y_1 = '/api/console/ops/provisioning';
    this.v1y_1 = '/api/console/ops/schema-versions';
    this.w1y_1 = '/api/console/ops/channels';
    this.x1y_1 = '/api/console/ops/domains';
    this.y1y_1 = '/api/console/ops/unrouted';
    this.z1y_1 = '0123456789ABCDEF';
  }
  protoOf(ConsoleApiPaths).a1z = function (id) {
    return '/api/console/protected-identities/' + id + '/deactivate';
  };
  protoOf(ConsoleApiPaths).b1z = function (id) {
    return '/api/console/protected-identities/' + id + '/reactivate';
  };
  protoOf(ConsoleApiPaths).c1z = function (id) {
    return '/api/console/capabilities/' + id + '/reverify';
  };
  protoOf(ConsoleApiPaths).d1z = function (id) {
    return '/api/console/tenants/' + this.e1z(id);
  };
  protoOf(ConsoleApiPaths).f1z = function (id) {
    return this.d1z(id) + '/lifecycle';
  };
  protoOf(ConsoleApiPaths).g1z = function (id) {
    return this.d1z(id) + '/overrides';
  };
  protoOf(ConsoleApiPaths).h1z = function (id) {
    return this.d1z(id) + '/support-session';
  };
  protoOf(ConsoleApiPaths).i1z = function (id) {
    return this.d1z(id) + '/readiness';
  };
  protoOf(ConsoleApiPaths).j1z = function (id) {
    return this.d1z(id) + '/training-copy';
  };
  protoOf(ConsoleApiPaths).k1z = function (id) {
    return this.d1z(id) + '/discard';
  };
  protoOf(ConsoleApiPaths).l1z = function (id) {
    return '/api/console/blueprints/' + this.e1z(id);
  };
  protoOf(ConsoleApiPaths).m1z = function (key) {
    return '/api/console/catalog/plans/' + this.e1z(key);
  };
  protoOf(ConsoleApiPaths).n1z = function (key) {
    return '/api/console/catalog/addons/' + this.e1z(key);
  };
  protoOf(ConsoleApiPaths).o1z = function (key) {
    return '/api/console/catalog/registry/limits/' + this.e1z(key);
  };
  protoOf(ConsoleApiPaths).p1z = function (id) {
    return '/api/console/invoices/' + this.e1z(id);
  };
  protoOf(ConsoleApiPaths).q1z = function (id) {
    return this.p1z(id) + '/payments';
  };
  protoOf(ConsoleApiPaths).r1z = function (id) {
    return '/api/console/notices/' + this.e1z(id);
  };
  protoOf(ConsoleApiPaths).s1z = function (id) {
    return '/api/console/integrations/' + this.e1z(id);
  };
  protoOf(ConsoleApiPaths).t1z = function (id) {
    return this.s1z(id) + '/assignments';
  };
  protoOf(ConsoleApiPaths).u1z = function (id, tenantId) {
    return this.t1z(id) + '/' + this.e1z(tenantId);
  };
  protoOf(ConsoleApiPaths).v1z = function (id) {
    return '/api/console/mcp/tokens/' + this.e1z(id) + '/revoke';
  };
  protoOf(ConsoleApiPaths).w1z = function (key) {
    return '/api/console/flags/' + this.e1z(key);
  };
  protoOf(ConsoleApiPaths).x1z = function (key, tenantId) {
    return this.w1z(key) + '/' + this.e1z(tenantId);
  };
  protoOf(ConsoleApiPaths).y1z = function (jobId) {
    return '/api/console/ops/provisioning/' + this.e1z(jobId);
  };
  protoOf(ConsoleApiPaths).z1z = function (jobId) {
    return this.y1z(jobId) + '/retry';
  };
  protoOf(ConsoleApiPaths).e1z = function (segment) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'com.ems.console.api.ConsoleApiPaths.enc.<anonymous>' call
    var indexedObject = encodeToByteArray(segment);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var byte = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var code = byte & 255;
      var character = numberToChar(code);
      if (isLetterOrDigit(character) && code < 128 || contains('-_.~', character)) {
        this_0.j8(character);
      } else {
        this_0.j8(_Char___init__impl__6a9atx(37));
        this_0.j8(charSequenceGet('0123456789ABCDEF', code >> 4));
        this_0.j8(charSequenceGet('0123456789ABCDEF', code & 15));
      }
    }
    return this_0.toString();
  };
  var ConsoleApiPaths_instance;
  function ConsoleApiPaths_getInstance() {
    return ConsoleApiPaths_instance;
  }
  function Companion_34() {
    Companion_instance_34 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a20_1 = [new ArrayListSerializer($serializer_getInstance_99()), new ArrayListSerializer($serializer_getInstance_86()), new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_98()), null];
  }
  var Companion_instance_34;
  function Companion_getInstance_34() {
    if (Companion_instance_34 == null)
      new Companion_34();
    return Companion_instance_34;
  }
  function $serializer_39() {
    $serializer_instance_39 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RegistryResponse', this, 6);
    tmp0_serialDesc.gy('modules', false);
    tmp0_serialDesc.gy('limits', false);
    tmp0_serialDesc.gy('currencies', false);
    tmp0_serialDesc.gy('billingCycles', false);
    tmp0_serialDesc.gy('features', true);
    tmp0_serialDesc.gy('featureCatalogVersion', true);
    this.b20_1 = tmp0_serialDesc;
  }
  protoOf($serializer_39).c20 = function (encoder, value) {
    var tmp0_desc = this.b20_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_34().a20_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.d20_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.e20_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.f20_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.g20_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !equals(value.h20_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.h20_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.i20_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 5, value.i20_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_39).on = function (encoder, value) {
    return this.c20(encoder, value instanceof RegistryResponse ? value : THROW_CCE());
  };
  protoOf($serializer_39).pn = function (decoder) {
    var tmp0_desc = this.b20_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_input = decoder.tq(tmp0_desc);
    var tmp11_cached = Companion_getInstance_34().a20_1;
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.fr(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.fr(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.fr(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.fr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.fr(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.fr(tmp0_desc, 0, tmp11_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.fr(tmp0_desc, 1, tmp11_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.fr(tmp0_desc, 2, tmp11_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.fr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.fr(tmp0_desc, 4, tmp11_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return RegistryResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_39).nn = function () {
    return this.b20_1;
  };
  protoOf($serializer_39).vy = function () {
    var tmp0_cached = Companion_getInstance_34().a20_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], tmp0_cached[3], tmp0_cached[4], IntSerializer_getInstance()];
  };
  var $serializer_instance_39;
  function $serializer_getInstance_39() {
    if ($serializer_instance_39 == null)
      new $serializer_39();
    return $serializer_instance_39;
  }
  function RegistryResponse_init_$Init$(seen0, modules, limits, currencies, billingCycles, features, featureCatalogVersion, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_39().b20_1);
    }
    $this.d20_1 = modules;
    $this.e20_1 = limits;
    $this.f20_1 = currencies;
    $this.g20_1 = billingCycles;
    if (0 === (seen0 & 16))
      $this.h20_1 = emptyList();
    else
      $this.h20_1 = features;
    if (0 === (seen0 & 32))
      $this.i20_1 = 0;
    else
      $this.i20_1 = featureCatalogVersion;
    return $this;
  }
  function RegistryResponse_init_$Create$(seen0, modules, limits, currencies, billingCycles, features, featureCatalogVersion, serializationConstructorMarker) {
    return RegistryResponse_init_$Init$(seen0, modules, limits, currencies, billingCycles, features, featureCatalogVersion, serializationConstructorMarker, objectCreate(protoOf(RegistryResponse)));
  }
  function RegistryResponse(modules, limits, currencies, billingCycles, features, featureCatalogVersion) {
    Companion_getInstance_34();
    features = features === VOID ? emptyList() : features;
    featureCatalogVersion = featureCatalogVersion === VOID ? 0 : featureCatalogVersion;
    this.d20_1 = modules;
    this.e20_1 = limits;
    this.f20_1 = currencies;
    this.g20_1 = billingCycles;
    this.h20_1 = features;
    this.i20_1 = featureCatalogVersion;
  }
  protoOf(RegistryResponse).toString = function () {
    return 'RegistryResponse(modules=' + toString(this.d20_1) + ', limits=' + toString(this.e20_1) + ', currencies=' + toString(this.f20_1) + ', billingCycles=' + toString(this.g20_1) + ', features=' + toString(this.h20_1) + ', featureCatalogVersion=' + this.i20_1 + ')';
  };
  protoOf(RegistryResponse).hashCode = function () {
    var result = hashCode(this.d20_1);
    result = imul(result, 31) + hashCode(this.e20_1) | 0;
    result = imul(result, 31) + hashCode(this.f20_1) | 0;
    result = imul(result, 31) + hashCode(this.g20_1) | 0;
    result = imul(result, 31) + hashCode(this.h20_1) | 0;
    result = imul(result, 31) + this.i20_1 | 0;
    return result;
  };
  protoOf(RegistryResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegistryResponse))
      return false;
    var tmp0_other_with_cast = other instanceof RegistryResponse ? other : THROW_CCE();
    if (!equals(this.d20_1, tmp0_other_with_cast.d20_1))
      return false;
    if (!equals(this.e20_1, tmp0_other_with_cast.e20_1))
      return false;
    if (!equals(this.f20_1, tmp0_other_with_cast.f20_1))
      return false;
    if (!equals(this.g20_1, tmp0_other_with_cast.g20_1))
      return false;
    if (!equals(this.h20_1, tmp0_other_with_cast.h20_1))
      return false;
    if (!(this.i20_1 === tmp0_other_with_cast.i20_1))
      return false;
    return true;
  };
  function Companion_35() {
    Companion_instance_35 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k20_1 = [Companion_getInstance_84().w19(), null, null, null];
  }
  var Companion_instance_35;
  function Companion_getInstance_35() {
    if (Companion_instance_35 == null)
      new Companion_35();
    return Companion_instance_35;
  }
  function $serializer_40() {
    $serializer_instance_40 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LoginResponse', this, 4);
    tmp0_serialDesc.gy('outcome', false);
    tmp0_serialDesc.gy('operator', true);
    tmp0_serialDesc.gy('enrolmentTicket', true);
    tmp0_serialDesc.gy('message', true);
    this.l20_1 = tmp0_serialDesc;
  }
  protoOf($serializer_40).m20 = function (encoder, value) {
    var tmp0_desc = this.l20_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_35().k20_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.n20_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.o20_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, $serializer_getInstance_33(), value.o20_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.p20_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.p20_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.q20_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.q20_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_40).on = function (encoder, value) {
    return this.m20(encoder, value instanceof LoginResponse ? value : THROW_CCE());
  };
  protoOf($serializer_40).pn = function (decoder) {
    var tmp0_desc = this.l20_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_35().k20_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, $serializer_getInstance_33(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, $serializer_getInstance_33(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return LoginResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_40).nn = function () {
    return this.l20_1;
  };
  protoOf($serializer_40).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_35().k20_1[0], get_nullable($serializer_getInstance_33()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_40;
  function $serializer_getInstance_40() {
    if ($serializer_instance_40 == null)
      new $serializer_40();
    return $serializer_instance_40;
  }
  function LoginResponse_init_$Init$(seen0, outcome, operator, enrolmentTicket, message, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_40().l20_1);
    }
    $this.n20_1 = outcome;
    if (0 === (seen0 & 2))
      $this.o20_1 = null;
    else
      $this.o20_1 = operator;
    if (0 === (seen0 & 4))
      $this.p20_1 = null;
    else
      $this.p20_1 = enrolmentTicket;
    if (0 === (seen0 & 8))
      $this.q20_1 = null;
    else
      $this.q20_1 = message;
    return $this;
  }
  function LoginResponse_init_$Create$(seen0, outcome, operator, enrolmentTicket, message, serializationConstructorMarker) {
    return LoginResponse_init_$Init$(seen0, outcome, operator, enrolmentTicket, message, serializationConstructorMarker, objectCreate(protoOf(LoginResponse)));
  }
  function LoginResponse(outcome, operator, enrolmentTicket, message) {
    Companion_getInstance_35();
    operator = operator === VOID ? null : operator;
    enrolmentTicket = enrolmentTicket === VOID ? null : enrolmentTicket;
    message = message === VOID ? null : message;
    this.n20_1 = outcome;
    this.o20_1 = operator;
    this.p20_1 = enrolmentTicket;
    this.q20_1 = message;
  }
  protoOf(LoginResponse).toString = function () {
    return 'LoginResponse(outcome=' + this.n20_1.toString() + ', operator=' + toString_0(this.o20_1) + ', enrolmentTicket=' + this.p20_1 + ', message=' + this.q20_1 + ')';
  };
  protoOf(LoginResponse).hashCode = function () {
    var result = this.n20_1.hashCode();
    result = imul(result, 31) + (this.o20_1 == null ? 0 : this.o20_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p20_1 == null ? 0 : getStringHashCode(this.p20_1)) | 0;
    result = imul(result, 31) + (this.q20_1 == null ? 0 : getStringHashCode(this.q20_1)) | 0;
    return result;
  };
  protoOf(LoginResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoginResponse))
      return false;
    var tmp0_other_with_cast = other instanceof LoginResponse ? other : THROW_CCE();
    if (!this.n20_1.equals(tmp0_other_with_cast.n20_1))
      return false;
    if (!equals(this.o20_1, tmp0_other_with_cast.o20_1))
      return false;
    if (!(this.p20_1 == tmp0_other_with_cast.p20_1))
      return false;
    if (!(this.q20_1 == tmp0_other_with_cast.q20_1))
      return false;
    return true;
  };
  function Companion_36() {
  }
  var Companion_instance_36;
  function Companion_getInstance_36() {
    return Companion_instance_36;
  }
  function $serializer_41() {
    $serializer_instance_41 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LoginRequest', this, 3);
    tmp0_serialDesc.gy('email', false);
    tmp0_serialDesc.gy('password', false);
    tmp0_serialDesc.gy('totpCode', true);
    this.r20_1 = tmp0_serialDesc;
  }
  protoOf($serializer_41).s20 = function (encoder, value) {
    var tmp0_desc = this.r20_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.t20_1);
    tmp1_output.hs(tmp0_desc, 1, value.u20_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.v20_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.v20_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_41).on = function (encoder, value) {
    return this.s20(encoder, value instanceof LoginRequest ? value : THROW_CCE());
  };
  protoOf($serializer_41).pn = function (decoder) {
    var tmp0_desc = this.r20_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return LoginRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_41).nn = function () {
    return this.r20_1;
  };
  protoOf($serializer_41).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_41;
  function $serializer_getInstance_41() {
    if ($serializer_instance_41 == null)
      new $serializer_41();
    return $serializer_instance_41;
  }
  function LoginRequest_init_$Init$(seen0, email, password, totpCode, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_41().r20_1);
    }
    $this.t20_1 = email;
    $this.u20_1 = password;
    if (0 === (seen0 & 4))
      $this.v20_1 = null;
    else
      $this.v20_1 = totpCode;
    return $this;
  }
  function LoginRequest_init_$Create$(seen0, email, password, totpCode, serializationConstructorMarker) {
    return LoginRequest_init_$Init$(seen0, email, password, totpCode, serializationConstructorMarker, objectCreate(protoOf(LoginRequest)));
  }
  function LoginRequest(email, password, totpCode) {
    totpCode = totpCode === VOID ? null : totpCode;
    this.t20_1 = email;
    this.u20_1 = password;
    this.v20_1 = totpCode;
  }
  protoOf(LoginRequest).toString = function () {
    return 'LoginRequest(email=' + this.t20_1 + ', password=' + this.u20_1 + ', totpCode=' + this.v20_1 + ')';
  };
  protoOf(LoginRequest).hashCode = function () {
    var result = getStringHashCode(this.t20_1);
    result = imul(result, 31) + getStringHashCode(this.u20_1) | 0;
    result = imul(result, 31) + (this.v20_1 == null ? 0 : getStringHashCode(this.v20_1)) | 0;
    return result;
  };
  protoOf(LoginRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LoginRequest))
      return false;
    var tmp0_other_with_cast = other instanceof LoginRequest ? other : THROW_CCE();
    if (!(this.t20_1 === tmp0_other_with_cast.t20_1))
      return false;
    if (!(this.u20_1 === tmp0_other_with_cast.u20_1))
      return false;
    if (!(this.v20_1 == tmp0_other_with_cast.v20_1))
      return false;
    return true;
  };
  function Companion_37() {
  }
  var Companion_instance_37;
  function Companion_getInstance_37() {
    return Companion_instance_37;
  }
  function $serializer_42() {
    $serializer_instance_42 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TotpEnrolmentResponse', this, 2);
    tmp0_serialDesc.gy('secret', false);
    tmp0_serialDesc.gy('otpauthUri', false);
    this.w20_1 = tmp0_serialDesc;
  }
  protoOf($serializer_42).x20 = function (encoder, value) {
    var tmp0_desc = this.w20_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.y20_1);
    tmp1_output.hs(tmp0_desc, 1, value.z20_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_42).on = function (encoder, value) {
    return this.x20(encoder, value instanceof TotpEnrolmentResponse ? value : THROW_CCE());
  };
  protoOf($serializer_42).pn = function (decoder) {
    var tmp0_desc = this.w20_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return TotpEnrolmentResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_42).nn = function () {
    return this.w20_1;
  };
  protoOf($serializer_42).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_42;
  function $serializer_getInstance_42() {
    if ($serializer_instance_42 == null)
      new $serializer_42();
    return $serializer_instance_42;
  }
  function TotpEnrolmentResponse_init_$Init$(seen0, secret, otpauthUri, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_42().w20_1);
    }
    $this.y20_1 = secret;
    $this.z20_1 = otpauthUri;
    return $this;
  }
  function TotpEnrolmentResponse_init_$Create$(seen0, secret, otpauthUri, serializationConstructorMarker) {
    return TotpEnrolmentResponse_init_$Init$(seen0, secret, otpauthUri, serializationConstructorMarker, objectCreate(protoOf(TotpEnrolmentResponse)));
  }
  function TotpEnrolmentResponse(secret, otpauthUri) {
    this.y20_1 = secret;
    this.z20_1 = otpauthUri;
  }
  protoOf(TotpEnrolmentResponse).toString = function () {
    return 'TotpEnrolmentResponse(secret=' + this.y20_1 + ', otpauthUri=' + this.z20_1 + ')';
  };
  protoOf(TotpEnrolmentResponse).hashCode = function () {
    var result = getStringHashCode(this.y20_1);
    result = imul(result, 31) + getStringHashCode(this.z20_1) | 0;
    return result;
  };
  protoOf(TotpEnrolmentResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TotpEnrolmentResponse))
      return false;
    var tmp0_other_with_cast = other instanceof TotpEnrolmentResponse ? other : THROW_CCE();
    if (!(this.y20_1 === tmp0_other_with_cast.y20_1))
      return false;
    if (!(this.z20_1 === tmp0_other_with_cast.z20_1))
      return false;
    return true;
  };
  function Companion_38() {
  }
  var Companion_instance_38;
  function Companion_getInstance_38() {
    return Companion_instance_38;
  }
  function $serializer_43() {
    $serializer_instance_43 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ConfirmTotpRequest', this, 3);
    tmp0_serialDesc.gy('enrolmentTicket', false);
    tmp0_serialDesc.gy('code', false);
    tmp0_serialDesc.gy('secret', true);
    this.a21_1 = tmp0_serialDesc;
  }
  protoOf($serializer_43).b21 = function (encoder, value) {
    var tmp0_desc = this.a21_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.c21_1);
    tmp1_output.hs(tmp0_desc, 1, value.d21_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.e21_1 === '')) {
      tmp1_output.hs(tmp0_desc, 2, value.e21_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_43).on = function (encoder, value) {
    return this.b21(encoder, value instanceof ConfirmTotpRequest ? value : THROW_CCE());
  };
  protoOf($serializer_43).pn = function (decoder) {
    var tmp0_desc = this.a21_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return ConfirmTotpRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_43).nn = function () {
    return this.a21_1;
  };
  protoOf($serializer_43).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_43;
  function $serializer_getInstance_43() {
    if ($serializer_instance_43 == null)
      new $serializer_43();
    return $serializer_instance_43;
  }
  function ConfirmTotpRequest_init_$Init$(seen0, enrolmentTicket, code, secret, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_43().a21_1);
    }
    $this.c21_1 = enrolmentTicket;
    $this.d21_1 = code;
    if (0 === (seen0 & 4))
      $this.e21_1 = '';
    else
      $this.e21_1 = secret;
    return $this;
  }
  function ConfirmTotpRequest_init_$Create$(seen0, enrolmentTicket, code, secret, serializationConstructorMarker) {
    return ConfirmTotpRequest_init_$Init$(seen0, enrolmentTicket, code, secret, serializationConstructorMarker, objectCreate(protoOf(ConfirmTotpRequest)));
  }
  function ConfirmTotpRequest(enrolmentTicket, code, secret) {
    secret = secret === VOID ? '' : secret;
    this.c21_1 = enrolmentTicket;
    this.d21_1 = code;
    this.e21_1 = secret;
  }
  protoOf(ConfirmTotpRequest).toString = function () {
    return 'ConfirmTotpRequest(enrolmentTicket=' + this.c21_1 + ', code=' + this.d21_1 + ', secret=' + this.e21_1 + ')';
  };
  protoOf(ConfirmTotpRequest).hashCode = function () {
    var result = getStringHashCode(this.c21_1);
    result = imul(result, 31) + getStringHashCode(this.d21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e21_1) | 0;
    return result;
  };
  protoOf(ConfirmTotpRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConfirmTotpRequest))
      return false;
    var tmp0_other_with_cast = other instanceof ConfirmTotpRequest ? other : THROW_CCE();
    if (!(this.c21_1 === tmp0_other_with_cast.c21_1))
      return false;
    if (!(this.d21_1 === tmp0_other_with_cast.d21_1))
      return false;
    if (!(this.e21_1 === tmp0_other_with_cast.e21_1))
      return false;
    return true;
  };
  function Companion_39() {
    Companion_instance_39 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f21_1 = [new ArrayListSerializer($serializer_getInstance_34()), new LinkedHashMapSerializer(StringSerializer_getInstance(), IntSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_89()), new ArrayListSerializer($serializer_getInstance_90()), new ArrayListSerializer($serializer_getInstance_91()), null, null, null];
  }
  var Companion_instance_39;
  function Companion_getInstance_39() {
    if (Companion_instance_39 == null)
      new Companion_39();
    return Companion_instance_39;
  }
  function $serializer_44() {
    $serializer_instance_44 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CockpitResponse', this, 8);
    tmp0_serialDesc.gy('recurringRevenue', false);
    tmp0_serialDesc.gy('tenantsByStatus', false);
    tmp0_serialDesc.gy('subscriptionsExpiringSoon', false);
    tmp0_serialDesc.gy('quotaPressure', false);
    tmp0_serialDesc.gy('providerHealth', false);
    tmp0_serialDesc.gy('provisioningFailures', false);
    tmp0_serialDesc.gy('invoicesOverdue', false);
    tmp0_serialDesc.gy('generatedAtMs', false);
    this.g21_1 = tmp0_serialDesc;
  }
  protoOf($serializer_44).h21 = function (encoder, value) {
    var tmp0_desc = this.g21_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_39().f21_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.i21_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.j21_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.k21_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.l21_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.m21_1);
    tmp1_output.cs(tmp0_desc, 5, value.n21_1);
    tmp1_output.cs(tmp0_desc, 6, value.o21_1);
    tmp1_output.ds(tmp0_desc, 7, value.p21_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_44).on = function (encoder, value) {
    return this.h21(encoder, value instanceof CockpitResponse ? value : THROW_CCE());
  };
  protoOf($serializer_44).pn = function (decoder) {
    var tmp0_desc = this.g21_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = new Long(0, 0);
    var tmp12_input = decoder.tq(tmp0_desc);
    var tmp13_cached = Companion_getInstance_39().f21_1;
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.fr(tmp0_desc, 0, tmp13_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.fr(tmp0_desc, 1, tmp13_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.fr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.fr(tmp0_desc, 3, tmp13_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.fr(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.yq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.fr(tmp0_desc, 0, tmp13_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.fr(tmp0_desc, 1, tmp13_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.fr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.fr(tmp0_desc, 3, tmp13_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.fr(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.yq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return CockpitResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_44).nn = function () {
    return this.g21_1;
  };
  protoOf($serializer_44).vy = function () {
    var tmp0_cached = Companion_getInstance_39().f21_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], tmp0_cached[3], tmp0_cached[4], IntSerializer_getInstance(), IntSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_44;
  function $serializer_getInstance_44() {
    if ($serializer_instance_44 == null)
      new $serializer_44();
    return $serializer_instance_44;
  }
  function CockpitResponse_init_$Init$(seen0, recurringRevenue, tenantsByStatus, subscriptionsExpiringSoon, quotaPressure, providerHealth, provisioningFailures, invoicesOverdue, generatedAtMs, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_44().g21_1);
    }
    $this.i21_1 = recurringRevenue;
    $this.j21_1 = tenantsByStatus;
    $this.k21_1 = subscriptionsExpiringSoon;
    $this.l21_1 = quotaPressure;
    $this.m21_1 = providerHealth;
    $this.n21_1 = provisioningFailures;
    $this.o21_1 = invoicesOverdue;
    $this.p21_1 = generatedAtMs;
    return $this;
  }
  function CockpitResponse_init_$Create$(seen0, recurringRevenue, tenantsByStatus, subscriptionsExpiringSoon, quotaPressure, providerHealth, provisioningFailures, invoicesOverdue, generatedAtMs, serializationConstructorMarker) {
    return CockpitResponse_init_$Init$(seen0, recurringRevenue, tenantsByStatus, subscriptionsExpiringSoon, quotaPressure, providerHealth, provisioningFailures, invoicesOverdue, generatedAtMs, serializationConstructorMarker, objectCreate(protoOf(CockpitResponse)));
  }
  function CockpitResponse(recurringRevenue, tenantsByStatus, subscriptionsExpiringSoon, quotaPressure, providerHealth, provisioningFailures, invoicesOverdue, generatedAtMs) {
    Companion_getInstance_39();
    this.i21_1 = recurringRevenue;
    this.j21_1 = tenantsByStatus;
    this.k21_1 = subscriptionsExpiringSoon;
    this.l21_1 = quotaPressure;
    this.m21_1 = providerHealth;
    this.n21_1 = provisioningFailures;
    this.o21_1 = invoicesOverdue;
    this.p21_1 = generatedAtMs;
  }
  protoOf(CockpitResponse).toString = function () {
    return 'CockpitResponse(recurringRevenue=' + toString(this.i21_1) + ', tenantsByStatus=' + toString(this.j21_1) + ', subscriptionsExpiringSoon=' + toString(this.k21_1) + ', quotaPressure=' + toString(this.l21_1) + ', providerHealth=' + toString(this.m21_1) + ', provisioningFailures=' + this.n21_1 + ', invoicesOverdue=' + this.o21_1 + ', generatedAtMs=' + this.p21_1.toString() + ')';
  };
  protoOf(CockpitResponse).hashCode = function () {
    var result = hashCode(this.i21_1);
    result = imul(result, 31) + hashCode(this.j21_1) | 0;
    result = imul(result, 31) + hashCode(this.k21_1) | 0;
    result = imul(result, 31) + hashCode(this.l21_1) | 0;
    result = imul(result, 31) + hashCode(this.m21_1) | 0;
    result = imul(result, 31) + this.n21_1 | 0;
    result = imul(result, 31) + this.o21_1 | 0;
    result = imul(result, 31) + this.p21_1.hashCode() | 0;
    return result;
  };
  protoOf(CockpitResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CockpitResponse))
      return false;
    var tmp0_other_with_cast = other instanceof CockpitResponse ? other : THROW_CCE();
    if (!equals(this.i21_1, tmp0_other_with_cast.i21_1))
      return false;
    if (!equals(this.j21_1, tmp0_other_with_cast.j21_1))
      return false;
    if (!equals(this.k21_1, tmp0_other_with_cast.k21_1))
      return false;
    if (!equals(this.l21_1, tmp0_other_with_cast.l21_1))
      return false;
    if (!equals(this.m21_1, tmp0_other_with_cast.m21_1))
      return false;
    if (!(this.n21_1 === tmp0_other_with_cast.n21_1))
      return false;
    if (!(this.o21_1 === tmp0_other_with_cast.o21_1))
      return false;
    if (!this.p21_1.equals(tmp0_other_with_cast.p21_1))
      return false;
    return true;
  };
  function Companion_40() {
    Companion_instance_40 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q21_1 = [new ArrayListSerializer($serializer_getInstance_46()), new LinkedHashMapSerializer(StringSerializer_getInstance(), IntSerializer_getInstance())];
  }
  var Companion_instance_40;
  function Companion_getInstance_40() {
    if (Companion_instance_40 == null)
      new Companion_40();
    return Companion_instance_40;
  }
  function $serializer_45() {
    $serializer_instance_45 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.IntegrationCatalogResponse', this, 2);
    tmp0_serialDesc.gy('accounts', false);
    tmp0_serialDesc.gy('countsByKind', false);
    this.r21_1 = tmp0_serialDesc;
  }
  protoOf($serializer_45).s21 = function (encoder, value) {
    var tmp0_desc = this.r21_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_40().q21_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.t21_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.u21_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_45).on = function (encoder, value) {
    return this.s21(encoder, value instanceof IntegrationCatalogResponse ? value : THROW_CCE());
  };
  protoOf($serializer_45).pn = function (decoder) {
    var tmp0_desc = this.r21_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_40().q21_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.fr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.fr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return IntegrationCatalogResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_45).nn = function () {
    return this.r21_1;
  };
  protoOf($serializer_45).vy = function () {
    var tmp0_cached = Companion_getInstance_40().q21_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1]];
  };
  var $serializer_instance_45;
  function $serializer_getInstance_45() {
    if ($serializer_instance_45 == null)
      new $serializer_45();
    return $serializer_instance_45;
  }
  function IntegrationCatalogResponse_init_$Init$(seen0, accounts, countsByKind, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_45().r21_1);
    }
    $this.t21_1 = accounts;
    $this.u21_1 = countsByKind;
    return $this;
  }
  function IntegrationCatalogResponse_init_$Create$(seen0, accounts, countsByKind, serializationConstructorMarker) {
    return IntegrationCatalogResponse_init_$Init$(seen0, accounts, countsByKind, serializationConstructorMarker, objectCreate(protoOf(IntegrationCatalogResponse)));
  }
  function IntegrationCatalogResponse(accounts, countsByKind) {
    Companion_getInstance_40();
    this.t21_1 = accounts;
    this.u21_1 = countsByKind;
  }
  protoOf(IntegrationCatalogResponse).toString = function () {
    return 'IntegrationCatalogResponse(accounts=' + toString(this.t21_1) + ', countsByKind=' + toString(this.u21_1) + ')';
  };
  protoOf(IntegrationCatalogResponse).hashCode = function () {
    var result = hashCode(this.t21_1);
    result = imul(result, 31) + hashCode(this.u21_1) | 0;
    return result;
  };
  protoOf(IntegrationCatalogResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IntegrationCatalogResponse))
      return false;
    var tmp0_other_with_cast = other instanceof IntegrationCatalogResponse ? other : THROW_CCE();
    if (!equals(this.t21_1, tmp0_other_with_cast.t21_1))
      return false;
    if (!equals(this.u21_1, tmp0_other_with_cast.u21_1))
      return false;
    return true;
  };
  function Companion_41() {
    Companion_instance_41 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v21_1 = [null, null, null, null, null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_49()), null, null, null];
  }
  var Companion_instance_41;
  function Companion_getInstance_41() {
    if (Companion_instance_41 == null)
      new Companion_41();
    return Companion_instance_41;
  }
  function $serializer_46() {
    $serializer_instance_46 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.IntegrationAccountView', this, 13);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('displayName', false);
    tmp0_serialDesc.gy('accountScope', false);
    tmp0_serialDesc.gy('dedicatedTenantId', true);
    tmp0_serialDesc.gy('enabled', false);
    tmp0_serialDesc.gy('readiness', false);
    tmp0_serialDesc.gy('configuration', true);
    tmp0_serialDesc.gy('configuredSecrets', true);
    tmp0_serialDesc.gy('assignments', true);
    tmp0_serialDesc.gy('configVersion', false);
    tmp0_serialDesc.gy('updatedBy', false);
    tmp0_serialDesc.gy('updatedAtMs', false);
    this.w21_1 = tmp0_serialDesc;
  }
  protoOf($serializer_46).x21 = function (encoder, value) {
    var tmp0_desc = this.w21_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_41().v21_1;
    tmp1_output.hs(tmp0_desc, 0, value.y21_1);
    tmp1_output.hs(tmp0_desc, 1, value.z21_1);
    tmp1_output.hs(tmp0_desc, 2, value.a22_1);
    tmp1_output.hs(tmp0_desc, 3, value.b22_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.c22_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.c22_1);
    }
    tmp1_output.zr(tmp0_desc, 5, value.d22_1);
    tmp1_output.hs(tmp0_desc, 6, value.e22_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !equals(value.f22_1, emptyMap())) {
      tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.f22_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !equals(value.g22_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.g22_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !equals(value.h22_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.h22_1);
    }
    tmp1_output.ds(tmp0_desc, 10, value.i22_1);
    tmp1_output.hs(tmp0_desc, 11, value.j22_1);
    tmp1_output.ds(tmp0_desc, 12, value.k22_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_46).on = function (encoder, value) {
    return this.x21(encoder, value instanceof IntegrationAccountView ? value : THROW_CCE());
  };
  protoOf($serializer_46).pn = function (decoder) {
    var tmp0_desc = this.w21_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = new Long(0, 0);
    var tmp15_local11 = null;
    var tmp16_local12 = new Long(0, 0);
    var tmp17_input = decoder.tq(tmp0_desc);
    var tmp18_cached = Companion_getInstance_41().v21_1;
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.vq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.fr(tmp0_desc, 7, tmp18_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.fr(tmp0_desc, 8, tmp18_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.zq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.dr(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.zq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.vq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.fr(tmp0_desc, 7, tmp18_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.fr(tmp0_desc, 8, tmp18_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.zq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.dr(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.zq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return IntegrationAccountView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_46).nn = function () {
    return this.w21_1;
  };
  protoOf($serializer_46).vy = function () {
    var tmp0_cached = Companion_getInstance_41().v21_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[7], tmp0_cached[8], tmp0_cached[9], LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_46;
  function $serializer_getInstance_46() {
    if ($serializer_instance_46 == null)
      new $serializer_46();
    return $serializer_instance_46;
  }
  function IntegrationAccountView_init_$Init$(seen0, id, kind, displayName, accountScope, dedicatedTenantId, enabled, readiness, configuration, configuredSecrets, assignments, configVersion, updatedBy, updatedAtMs, serializationConstructorMarker, $this) {
    if (!(7279 === (7279 & seen0))) {
      throwMissingFieldException(seen0, 7279, $serializer_getInstance_46().w21_1);
    }
    $this.y21_1 = id;
    $this.z21_1 = kind;
    $this.a22_1 = displayName;
    $this.b22_1 = accountScope;
    if (0 === (seen0 & 16))
      $this.c22_1 = null;
    else
      $this.c22_1 = dedicatedTenantId;
    $this.d22_1 = enabled;
    $this.e22_1 = readiness;
    if (0 === (seen0 & 128))
      $this.f22_1 = emptyMap();
    else
      $this.f22_1 = configuration;
    if (0 === (seen0 & 256))
      $this.g22_1 = emptyList();
    else
      $this.g22_1 = configuredSecrets;
    if (0 === (seen0 & 512))
      $this.h22_1 = emptyList();
    else
      $this.h22_1 = assignments;
    $this.i22_1 = configVersion;
    $this.j22_1 = updatedBy;
    $this.k22_1 = updatedAtMs;
    return $this;
  }
  function IntegrationAccountView_init_$Create$(seen0, id, kind, displayName, accountScope, dedicatedTenantId, enabled, readiness, configuration, configuredSecrets, assignments, configVersion, updatedBy, updatedAtMs, serializationConstructorMarker) {
    return IntegrationAccountView_init_$Init$(seen0, id, kind, displayName, accountScope, dedicatedTenantId, enabled, readiness, configuration, configuredSecrets, assignments, configVersion, updatedBy, updatedAtMs, serializationConstructorMarker, objectCreate(protoOf(IntegrationAccountView)));
  }
  function IntegrationAccountView(id, kind, displayName, accountScope, dedicatedTenantId, enabled, readiness, configuration, configuredSecrets, assignments, configVersion, updatedBy, updatedAtMs) {
    Companion_getInstance_41();
    dedicatedTenantId = dedicatedTenantId === VOID ? null : dedicatedTenantId;
    configuration = configuration === VOID ? emptyMap() : configuration;
    configuredSecrets = configuredSecrets === VOID ? emptyList() : configuredSecrets;
    assignments = assignments === VOID ? emptyList() : assignments;
    this.y21_1 = id;
    this.z21_1 = kind;
    this.a22_1 = displayName;
    this.b22_1 = accountScope;
    this.c22_1 = dedicatedTenantId;
    this.d22_1 = enabled;
    this.e22_1 = readiness;
    this.f22_1 = configuration;
    this.g22_1 = configuredSecrets;
    this.h22_1 = assignments;
    this.i22_1 = configVersion;
    this.j22_1 = updatedBy;
    this.k22_1 = updatedAtMs;
  }
  protoOf(IntegrationAccountView).toString = function () {
    return 'IntegrationAccountView(id=' + this.y21_1 + ', kind=' + this.z21_1 + ', displayName=' + this.a22_1 + ', accountScope=' + this.b22_1 + ', dedicatedTenantId=' + this.c22_1 + ', enabled=' + this.d22_1 + ', readiness=' + this.e22_1 + ', configuration=' + toString(this.f22_1) + ', configuredSecrets=' + toString(this.g22_1) + ', assignments=' + toString(this.h22_1) + ', configVersion=' + this.i22_1.toString() + ', updatedBy=' + this.j22_1 + ', updatedAtMs=' + this.k22_1.toString() + ')';
  };
  protoOf(IntegrationAccountView).hashCode = function () {
    var result = getStringHashCode(this.y21_1);
    result = imul(result, 31) + getStringHashCode(this.z21_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a22_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b22_1) | 0;
    result = imul(result, 31) + (this.c22_1 == null ? 0 : getStringHashCode(this.c22_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d22_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e22_1) | 0;
    result = imul(result, 31) + hashCode(this.f22_1) | 0;
    result = imul(result, 31) + hashCode(this.g22_1) | 0;
    result = imul(result, 31) + hashCode(this.h22_1) | 0;
    result = imul(result, 31) + this.i22_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.j22_1) | 0;
    result = imul(result, 31) + this.k22_1.hashCode() | 0;
    return result;
  };
  protoOf(IntegrationAccountView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IntegrationAccountView))
      return false;
    var tmp0_other_with_cast = other instanceof IntegrationAccountView ? other : THROW_CCE();
    if (!(this.y21_1 === tmp0_other_with_cast.y21_1))
      return false;
    if (!(this.z21_1 === tmp0_other_with_cast.z21_1))
      return false;
    if (!(this.a22_1 === tmp0_other_with_cast.a22_1))
      return false;
    if (!(this.b22_1 === tmp0_other_with_cast.b22_1))
      return false;
    if (!(this.c22_1 == tmp0_other_with_cast.c22_1))
      return false;
    if (!(this.d22_1 === tmp0_other_with_cast.d22_1))
      return false;
    if (!(this.e22_1 === tmp0_other_with_cast.e22_1))
      return false;
    if (!equals(this.f22_1, tmp0_other_with_cast.f22_1))
      return false;
    if (!equals(this.g22_1, tmp0_other_with_cast.g22_1))
      return false;
    if (!equals(this.h22_1, tmp0_other_with_cast.h22_1))
      return false;
    if (!this.i22_1.equals(tmp0_other_with_cast.i22_1))
      return false;
    if (!(this.j22_1 === tmp0_other_with_cast.j22_1))
      return false;
    if (!this.k22_1.equals(tmp0_other_with_cast.k22_1))
      return false;
    return true;
  };
  function Companion_42() {
    Companion_instance_42 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l22_1 = [null, null, null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_42;
  function Companion_getInstance_42() {
    if (Companion_instance_42 == null)
      new Companion_42();
    return Companion_instance_42;
  }
  function $serializer_47() {
    $serializer_instance_47 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UpsertIntegrationAccountRequest', this, 9);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('displayName', false);
    tmp0_serialDesc.gy('accountScope', true);
    tmp0_serialDesc.gy('dedicatedTenantId', true);
    tmp0_serialDesc.gy('enabled', true);
    tmp0_serialDesc.gy('configuration', true);
    tmp0_serialDesc.gy('secrets', true);
    tmp0_serialDesc.gy('clearSecrets', true);
    tmp0_serialDesc.gy('expectedConfigVersion', true);
    this.m22_1 = tmp0_serialDesc;
  }
  protoOf($serializer_47).n22 = function (encoder, value) {
    var tmp0_desc = this.m22_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_42().l22_1;
    tmp1_output.hs(tmp0_desc, 0, value.o22_1);
    tmp1_output.hs(tmp0_desc, 1, value.p22_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.q22_1 === 'shared')) {
      tmp1_output.hs(tmp0_desc, 2, value.q22_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.r22_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.r22_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.s22_1 === false)) {
      tmp1_output.zr(tmp0_desc, 4, value.s22_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !equals(value.t22_1, emptyMap())) {
      tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.t22_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !equals(value.u22_1, emptyMap())) {
      tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.u22_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !equals(value.v22_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.v22_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.w22_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, LongSerializer_getInstance(), value.w22_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_47).on = function (encoder, value) {
    return this.n22(encoder, value instanceof UpsertIntegrationAccountRequest ? value : THROW_CCE());
  };
  protoOf($serializer_47).pn = function (decoder) {
    var tmp0_desc = this.m22_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    var tmp14_cached = Companion_getInstance_42().l22_1;
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.fr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.fr(tmp0_desc, 6, tmp14_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.fr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.fr(tmp0_desc, 6, tmp14_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return UpsertIntegrationAccountRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_47).nn = function () {
    return this.m22_1;
  };
  protoOf($serializer_47).vy = function () {
    var tmp0_cached = Companion_getInstance_42().l22_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), tmp0_cached[5], tmp0_cached[6], tmp0_cached[7], get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_47;
  function $serializer_getInstance_47() {
    if ($serializer_instance_47 == null)
      new $serializer_47();
    return $serializer_instance_47;
  }
  function UpsertIntegrationAccountRequest_init_$Init$(seen0, kind, displayName, accountScope, dedicatedTenantId, enabled, configuration, secrets, clearSecrets, expectedConfigVersion, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_47().m22_1);
    }
    $this.o22_1 = kind;
    $this.p22_1 = displayName;
    if (0 === (seen0 & 4))
      $this.q22_1 = 'shared';
    else
      $this.q22_1 = accountScope;
    if (0 === (seen0 & 8))
      $this.r22_1 = null;
    else
      $this.r22_1 = dedicatedTenantId;
    if (0 === (seen0 & 16))
      $this.s22_1 = false;
    else
      $this.s22_1 = enabled;
    if (0 === (seen0 & 32))
      $this.t22_1 = emptyMap();
    else
      $this.t22_1 = configuration;
    if (0 === (seen0 & 64))
      $this.u22_1 = emptyMap();
    else
      $this.u22_1 = secrets;
    if (0 === (seen0 & 128))
      $this.v22_1 = emptyList();
    else
      $this.v22_1 = clearSecrets;
    if (0 === (seen0 & 256))
      $this.w22_1 = null;
    else
      $this.w22_1 = expectedConfigVersion;
    return $this;
  }
  function UpsertIntegrationAccountRequest_init_$Create$(seen0, kind, displayName, accountScope, dedicatedTenantId, enabled, configuration, secrets, clearSecrets, expectedConfigVersion, serializationConstructorMarker) {
    return UpsertIntegrationAccountRequest_init_$Init$(seen0, kind, displayName, accountScope, dedicatedTenantId, enabled, configuration, secrets, clearSecrets, expectedConfigVersion, serializationConstructorMarker, objectCreate(protoOf(UpsertIntegrationAccountRequest)));
  }
  function UpsertIntegrationAccountRequest(kind, displayName, accountScope, dedicatedTenantId, enabled, configuration, secrets, clearSecrets, expectedConfigVersion) {
    Companion_getInstance_42();
    accountScope = accountScope === VOID ? 'shared' : accountScope;
    dedicatedTenantId = dedicatedTenantId === VOID ? null : dedicatedTenantId;
    enabled = enabled === VOID ? false : enabled;
    configuration = configuration === VOID ? emptyMap() : configuration;
    secrets = secrets === VOID ? emptyMap() : secrets;
    clearSecrets = clearSecrets === VOID ? emptyList() : clearSecrets;
    expectedConfigVersion = expectedConfigVersion === VOID ? null : expectedConfigVersion;
    this.o22_1 = kind;
    this.p22_1 = displayName;
    this.q22_1 = accountScope;
    this.r22_1 = dedicatedTenantId;
    this.s22_1 = enabled;
    this.t22_1 = configuration;
    this.u22_1 = secrets;
    this.v22_1 = clearSecrets;
    this.w22_1 = expectedConfigVersion;
  }
  protoOf(UpsertIntegrationAccountRequest).toString = function () {
    return 'UpsertIntegrationAccountRequest(kind=' + this.o22_1 + ', displayName=' + this.p22_1 + ', accountScope=' + this.q22_1 + ', dedicatedTenantId=' + this.r22_1 + ', enabled=' + this.s22_1 + ', configuration=' + toString(this.t22_1) + ', secrets=' + toString(this.u22_1) + ', clearSecrets=' + toString(this.v22_1) + ', expectedConfigVersion=' + toString_0(this.w22_1) + ')';
  };
  protoOf(UpsertIntegrationAccountRequest).hashCode = function () {
    var result = getStringHashCode(this.o22_1);
    result = imul(result, 31) + getStringHashCode(this.p22_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q22_1) | 0;
    result = imul(result, 31) + (this.r22_1 == null ? 0 : getStringHashCode(this.r22_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s22_1) | 0;
    result = imul(result, 31) + hashCode(this.t22_1) | 0;
    result = imul(result, 31) + hashCode(this.u22_1) | 0;
    result = imul(result, 31) + hashCode(this.v22_1) | 0;
    result = imul(result, 31) + (this.w22_1 == null ? 0 : this.w22_1.hashCode()) | 0;
    return result;
  };
  protoOf(UpsertIntegrationAccountRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpsertIntegrationAccountRequest))
      return false;
    var tmp0_other_with_cast = other instanceof UpsertIntegrationAccountRequest ? other : THROW_CCE();
    if (!(this.o22_1 === tmp0_other_with_cast.o22_1))
      return false;
    if (!(this.p22_1 === tmp0_other_with_cast.p22_1))
      return false;
    if (!(this.q22_1 === tmp0_other_with_cast.q22_1))
      return false;
    if (!(this.r22_1 == tmp0_other_with_cast.r22_1))
      return false;
    if (!(this.s22_1 === tmp0_other_with_cast.s22_1))
      return false;
    if (!equals(this.t22_1, tmp0_other_with_cast.t22_1))
      return false;
    if (!equals(this.u22_1, tmp0_other_with_cast.u22_1))
      return false;
    if (!equals(this.v22_1, tmp0_other_with_cast.v22_1))
      return false;
    if (!equals(this.w22_1, tmp0_other_with_cast.w22_1))
      return false;
    return true;
  };
  function Companion_43() {
  }
  var Companion_instance_43;
  function Companion_getInstance_43() {
    return Companion_instance_43;
  }
  function $serializer_48() {
    $serializer_instance_48 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.IntegrationAccountOperationRecovery', this, 1);
    tmp0_serialDesc.gy('receipt', false);
    this.x22_1 = tmp0_serialDesc;
  }
  protoOf($serializer_48).y22 = function (encoder, value) {
    var tmp0_desc = this.x22_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ls(tmp0_desc, 0, $serializer_getInstance_46(), value.z22_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_48).on = function (encoder, value) {
    return this.y22(encoder, value instanceof IntegrationAccountOperationRecovery ? value : THROW_CCE());
  };
  protoOf($serializer_48).pn = function (decoder) {
    var tmp0_desc = this.x22_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.hr(tmp0_desc, 0, $serializer_getInstance_46(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hr(tmp0_desc, 0, $serializer_getInstance_46(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return IntegrationAccountOperationRecovery_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_48).nn = function () {
    return this.x22_1;
  };
  protoOf($serializer_48).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_46())];
  };
  var $serializer_instance_48;
  function $serializer_getInstance_48() {
    if ($serializer_instance_48 == null)
      new $serializer_48();
    return $serializer_instance_48;
  }
  function IntegrationAccountOperationRecovery_init_$Init$(seen0, receipt, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_48().x22_1);
    }
    $this.z22_1 = receipt;
    return $this;
  }
  function IntegrationAccountOperationRecovery_init_$Create$(seen0, receipt, serializationConstructorMarker) {
    return IntegrationAccountOperationRecovery_init_$Init$(seen0, receipt, serializationConstructorMarker, objectCreate(protoOf(IntegrationAccountOperationRecovery)));
  }
  function IntegrationAccountOperationRecovery(receipt) {
    this.z22_1 = receipt;
  }
  protoOf(IntegrationAccountOperationRecovery).toString = function () {
    return 'IntegrationAccountOperationRecovery(receipt=' + toString_0(this.z22_1) + ')';
  };
  protoOf(IntegrationAccountOperationRecovery).hashCode = function () {
    return this.z22_1 == null ? 0 : this.z22_1.hashCode();
  };
  protoOf(IntegrationAccountOperationRecovery).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IntegrationAccountOperationRecovery))
      return false;
    var tmp0_other_with_cast = other instanceof IntegrationAccountOperationRecovery ? other : THROW_CCE();
    if (!equals(this.z22_1, tmp0_other_with_cast.z22_1))
      return false;
    return true;
  };
  function Companion_44() {
    Companion_instance_44 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a23_1 = [null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_44;
  function Companion_getInstance_44() {
    if (Companion_instance_44 == null)
      new Companion_44();
    return Companion_instance_44;
  }
  function $serializer_49() {
    $serializer_instance_49 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.IntegrationAssignmentView', this, 6);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('enabled', false);
    tmp0_serialDesc.gy('settings', true);
    tmp0_serialDesc.gy('updatedBy', false);
    tmp0_serialDesc.gy('updatedAtMs', false);
    this.b23_1 = tmp0_serialDesc;
  }
  protoOf($serializer_49).c23 = function (encoder, value) {
    var tmp0_desc = this.b23_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_44().a23_1;
    tmp1_output.hs(tmp0_desc, 0, value.d23_1);
    tmp1_output.hs(tmp0_desc, 1, value.e23_1);
    tmp1_output.zr(tmp0_desc, 2, value.f23_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !equals(value.g23_1, emptyMap())) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.g23_1);
    }
    tmp1_output.hs(tmp0_desc, 4, value.h23_1);
    tmp1_output.ds(tmp0_desc, 5, value.i23_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_49).on = function (encoder, value) {
    return this.c23(encoder, value instanceof IntegrationAssignmentView ? value : THROW_CCE());
  };
  protoOf($serializer_49).pn = function (decoder) {
    var tmp0_desc = this.b23_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_input = decoder.tq(tmp0_desc);
    var tmp11_cached = Companion_getInstance_44().a23_1;
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.fr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.fr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return IntegrationAssignmentView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_49).nn = function () {
    return this.b23_1;
  };
  protoOf($serializer_49).vy = function () {
    var tmp0_cached = Companion_getInstance_44().a23_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[3], StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_49;
  function $serializer_getInstance_49() {
    if ($serializer_instance_49 == null)
      new $serializer_49();
    return $serializer_instance_49;
  }
  function IntegrationAssignmentView_init_$Init$(seen0, tenantId, tenantName, enabled, settings, updatedBy, updatedAtMs, serializationConstructorMarker, $this) {
    if (!(55 === (55 & seen0))) {
      throwMissingFieldException(seen0, 55, $serializer_getInstance_49().b23_1);
    }
    $this.d23_1 = tenantId;
    $this.e23_1 = tenantName;
    $this.f23_1 = enabled;
    if (0 === (seen0 & 8))
      $this.g23_1 = emptyMap();
    else
      $this.g23_1 = settings;
    $this.h23_1 = updatedBy;
    $this.i23_1 = updatedAtMs;
    return $this;
  }
  function IntegrationAssignmentView_init_$Create$(seen0, tenantId, tenantName, enabled, settings, updatedBy, updatedAtMs, serializationConstructorMarker) {
    return IntegrationAssignmentView_init_$Init$(seen0, tenantId, tenantName, enabled, settings, updatedBy, updatedAtMs, serializationConstructorMarker, objectCreate(protoOf(IntegrationAssignmentView)));
  }
  function IntegrationAssignmentView(tenantId, tenantName, enabled, settings, updatedBy, updatedAtMs) {
    Companion_getInstance_44();
    settings = settings === VOID ? emptyMap() : settings;
    this.d23_1 = tenantId;
    this.e23_1 = tenantName;
    this.f23_1 = enabled;
    this.g23_1 = settings;
    this.h23_1 = updatedBy;
    this.i23_1 = updatedAtMs;
  }
  protoOf(IntegrationAssignmentView).toString = function () {
    return 'IntegrationAssignmentView(tenantId=' + this.d23_1 + ', tenantName=' + this.e23_1 + ', enabled=' + this.f23_1 + ', settings=' + toString(this.g23_1) + ', updatedBy=' + this.h23_1 + ', updatedAtMs=' + this.i23_1.toString() + ')';
  };
  protoOf(IntegrationAssignmentView).hashCode = function () {
    var result = getStringHashCode(this.d23_1);
    result = imul(result, 31) + getStringHashCode(this.e23_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f23_1) | 0;
    result = imul(result, 31) + hashCode(this.g23_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h23_1) | 0;
    result = imul(result, 31) + this.i23_1.hashCode() | 0;
    return result;
  };
  protoOf(IntegrationAssignmentView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IntegrationAssignmentView))
      return false;
    var tmp0_other_with_cast = other instanceof IntegrationAssignmentView ? other : THROW_CCE();
    if (!(this.d23_1 === tmp0_other_with_cast.d23_1))
      return false;
    if (!(this.e23_1 === tmp0_other_with_cast.e23_1))
      return false;
    if (!(this.f23_1 === tmp0_other_with_cast.f23_1))
      return false;
    if (!equals(this.g23_1, tmp0_other_with_cast.g23_1))
      return false;
    if (!(this.h23_1 === tmp0_other_with_cast.h23_1))
      return false;
    if (!this.i23_1.equals(tmp0_other_with_cast.i23_1))
      return false;
    return true;
  };
  function Companion_45() {
    Companion_instance_45 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j23_1 = [null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance())];
  }
  var Companion_instance_45;
  function Companion_getInstance_45() {
    if (Companion_instance_45 == null)
      new Companion_45();
    return Companion_instance_45;
  }
  function $serializer_50() {
    $serializer_instance_50 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UpsertIntegrationAssignmentRequest', this, 3);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('enabled', true);
    tmp0_serialDesc.gy('settings', true);
    this.k23_1 = tmp0_serialDesc;
  }
  protoOf($serializer_50).l23 = function (encoder, value) {
    var tmp0_desc = this.k23_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_45().j23_1;
    tmp1_output.hs(tmp0_desc, 0, value.m23_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.n23_1 === true)) {
      tmp1_output.zr(tmp0_desc, 1, value.n23_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !equals(value.o23_1, emptyMap())) {
      tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.o23_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_50).on = function (encoder, value) {
    return this.l23(encoder, value instanceof UpsertIntegrationAssignmentRequest ? value : THROW_CCE());
  };
  protoOf($serializer_50).pn = function (decoder) {
    var tmp0_desc = this.k23_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_45().j23_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return UpsertIntegrationAssignmentRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_50).nn = function () {
    return this.k23_1;
  };
  protoOf($serializer_50).vy = function () {
    var tmp0_cached = Companion_getInstance_45().j23_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[2]];
  };
  var $serializer_instance_50;
  function $serializer_getInstance_50() {
    if ($serializer_instance_50 == null)
      new $serializer_50();
    return $serializer_instance_50;
  }
  function UpsertIntegrationAssignmentRequest_init_$Init$(seen0, tenantId, enabled, settings, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_50().k23_1);
    }
    $this.m23_1 = tenantId;
    if (0 === (seen0 & 2))
      $this.n23_1 = true;
    else
      $this.n23_1 = enabled;
    if (0 === (seen0 & 4))
      $this.o23_1 = emptyMap();
    else
      $this.o23_1 = settings;
    return $this;
  }
  function UpsertIntegrationAssignmentRequest_init_$Create$(seen0, tenantId, enabled, settings, serializationConstructorMarker) {
    return UpsertIntegrationAssignmentRequest_init_$Init$(seen0, tenantId, enabled, settings, serializationConstructorMarker, objectCreate(protoOf(UpsertIntegrationAssignmentRequest)));
  }
  function UpsertIntegrationAssignmentRequest(tenantId, enabled, settings) {
    Companion_getInstance_45();
    enabled = enabled === VOID ? true : enabled;
    settings = settings === VOID ? emptyMap() : settings;
    this.m23_1 = tenantId;
    this.n23_1 = enabled;
    this.o23_1 = settings;
  }
  protoOf(UpsertIntegrationAssignmentRequest).p23 = function (tenantId, enabled, settings) {
    return new UpsertIntegrationAssignmentRequest(tenantId, enabled, settings);
  };
  protoOf(UpsertIntegrationAssignmentRequest).q23 = function (tenantId, enabled, settings, $super) {
    tenantId = tenantId === VOID ? this.m23_1 : tenantId;
    enabled = enabled === VOID ? this.n23_1 : enabled;
    settings = settings === VOID ? this.o23_1 : settings;
    return $super === VOID ? this.p23(tenantId, enabled, settings) : $super.p23.call(this, tenantId, enabled, settings);
  };
  protoOf(UpsertIntegrationAssignmentRequest).toString = function () {
    return 'UpsertIntegrationAssignmentRequest(tenantId=' + this.m23_1 + ', enabled=' + this.n23_1 + ', settings=' + toString(this.o23_1) + ')';
  };
  protoOf(UpsertIntegrationAssignmentRequest).hashCode = function () {
    var result = getStringHashCode(this.m23_1);
    result = imul(result, 31) + getBooleanHashCode(this.n23_1) | 0;
    result = imul(result, 31) + hashCode(this.o23_1) | 0;
    return result;
  };
  protoOf(UpsertIntegrationAssignmentRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpsertIntegrationAssignmentRequest))
      return false;
    var tmp0_other_with_cast = other instanceof UpsertIntegrationAssignmentRequest ? other : THROW_CCE();
    if (!(this.m23_1 === tmp0_other_with_cast.m23_1))
      return false;
    if (!(this.n23_1 === tmp0_other_with_cast.n23_1))
      return false;
    if (!equals(this.o23_1, tmp0_other_with_cast.o23_1))
      return false;
    return true;
  };
  function $serializer_init_$Init$(typeSerial0, $this) {
    $serializer_51.call($this);
    $this.s23_1 = typeSerial0;
    return $this;
  }
  function $serializer_init_$Create$(typeSerial0) {
    return $serializer_init_$Init$(typeSerial0, objectCreate(protoOf($serializer_51)));
  }
  function Companion_46() {
    Companion_instance_46 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.Page', null, 4);
    tmp0_serialDesc.gy('items', false);
    tmp0_serialDesc.gy('total', false);
    tmp0_serialDesc.gy('offset', false);
    tmp0_serialDesc.gy('limit', false);
    this.t23_1 = tmp0_serialDesc;
  }
  protoOf(Companion_46).u23 = function (typeSerial0) {
    return $serializer_init_$Create$(typeSerial0);
  };
  protoOf(Companion_46).gz = function (typeParamsSerializers) {
    return this.u23(typeParamsSerializers[0]);
  };
  var Companion_instance_46;
  function Companion_getInstance_46() {
    if (Companion_instance_46 == null)
      new Companion_46();
    return Companion_instance_46;
  }
  function $serializer_51() {
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.Page', this, 4);
    tmp0_serialDesc.gy('items', false);
    tmp0_serialDesc.gy('total', false);
    tmp0_serialDesc.gy('offset', false);
    tmp0_serialDesc.gy('limit', false);
    this.r23_1 = tmp0_serialDesc;
  }
  protoOf($serializer_51).v23 = function (encoder, value) {
    var tmp0_desc = this.r23_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, new ArrayListSerializer(this.s23_1), value.w23_1);
    tmp1_output.ds(tmp0_desc, 1, value.x23_1);
    tmp1_output.cs(tmp0_desc, 2, value.y23_1);
    tmp1_output.cs(tmp0_desc, 3, value.z23_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_51).on = function (encoder, value) {
    return this.v23(encoder, value instanceof Page ? value : THROW_CCE());
  };
  protoOf($serializer_51).pn = function (decoder) {
    var tmp0_desc = this.r23_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, new ArrayListSerializer(this.s23_1), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.yq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.yq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, new ArrayListSerializer(this.s23_1), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.yq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.yq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return Page_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_51).nn = function () {
    return this.r23_1;
  };
  protoOf($serializer_51).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [new ArrayListSerializer(this.s23_1), LongSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  protoOf($serializer_51).wy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.s23_1];
  };
  function Page_init_$Init$(seen0, items, total, offset, limit, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, Companion_getInstance_46().t23_1);
    }
    $this.w23_1 = items;
    $this.x23_1 = total;
    $this.y23_1 = offset;
    $this.z23_1 = limit;
    return $this;
  }
  function Page_init_$Create$(seen0, items, total, offset, limit, serializationConstructorMarker) {
    return Page_init_$Init$(seen0, items, total, offset, limit, serializationConstructorMarker, objectCreate(protoOf(Page)));
  }
  function Page(items, total, offset, limit) {
    Companion_getInstance_46();
    this.w23_1 = items;
    this.x23_1 = total;
    this.y23_1 = offset;
    this.z23_1 = limit;
  }
  protoOf(Page).a24 = function () {
    return toLong(this.y23_1 + this.w23_1.j() | 0).e1(this.x23_1) < 0;
  };
  protoOf(Page).toString = function () {
    return 'Page(items=' + toString(this.w23_1) + ', total=' + this.x23_1.toString() + ', offset=' + this.y23_1 + ', limit=' + this.z23_1 + ')';
  };
  protoOf(Page).hashCode = function () {
    var result = hashCode(this.w23_1);
    result = imul(result, 31) + this.x23_1.hashCode() | 0;
    result = imul(result, 31) + this.y23_1 | 0;
    result = imul(result, 31) + this.z23_1 | 0;
    return result;
  };
  protoOf(Page).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Page))
      return false;
    var tmp0_other_with_cast = other instanceof Page ? other : THROW_CCE();
    if (!equals(this.w23_1, tmp0_other_with_cast.w23_1))
      return false;
    if (!this.x23_1.equals(tmp0_other_with_cast.x23_1))
      return false;
    if (!(this.y23_1 === tmp0_other_with_cast.y23_1))
      return false;
    if (!(this.z23_1 === tmp0_other_with_cast.z23_1))
      return false;
    return true;
  };
  function Companion_47() {
  }
  var Companion_instance_47;
  function Companion_getInstance_47() {
    return Companion_instance_47;
  }
  function $serializer_52() {
    $serializer_instance_51 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantRow', this, 13);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('slug', false);
    tmp0_serialDesc.gy('displayNameEn', false);
    tmp0_serialDesc.gy('displayNameAr', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('planName', false);
    tmp0_serialDesc.gy('primaryHost', false);
    tmp0_serialDesc.gy('createdAtMs', false);
    tmp0_serialDesc.gy('seatsUsed', false);
    tmp0_serialDesc.gy('contactsUsed', false);
    tmp0_serialDesc.gy('messagesThisPeriod', false);
    tmp0_serialDesc.gy('health', false);
    this.b24_1 = tmp0_serialDesc;
  }
  protoOf($serializer_52).c24 = function (encoder, value) {
    var tmp0_desc = this.b24_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.d24_1);
    tmp1_output.hs(tmp0_desc, 1, value.e24_1);
    tmp1_output.hs(tmp0_desc, 2, value.f24_1);
    tmp1_output.hs(tmp0_desc, 3, value.g24_1);
    tmp1_output.hs(tmp0_desc, 4, value.h24_1);
    tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.i24_1);
    tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.j24_1);
    tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.k24_1);
    tmp1_output.ds(tmp0_desc, 8, value.l24_1);
    tmp1_output.ls(tmp0_desc, 9, LongSerializer_getInstance(), value.m24_1);
    tmp1_output.ls(tmp0_desc, 10, LongSerializer_getInstance(), value.n24_1);
    tmp1_output.ls(tmp0_desc, 11, LongSerializer_getInstance(), value.o24_1);
    tmp1_output.hs(tmp0_desc, 12, value.p24_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_52).on = function (encoder, value) {
    return this.c24(encoder, value instanceof TenantRow ? value : THROW_CCE());
  };
  protoOf($serializer_52).pn = function (decoder) {
    var tmp0_desc = this.b24_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.tq(tmp0_desc);
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.hr(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.dr(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.hr(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.dr(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return TenantRow_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_52).nn = function () {
    return this.b24_1;
  };
  protoOf($serializer_52).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance()];
  };
  var $serializer_instance_51;
  function $serializer_getInstance_51() {
    if ($serializer_instance_51 == null)
      new $serializer_52();
    return $serializer_instance_51;
  }
  function TenantRow_init_$Init$(seen0, id, slug, displayNameEn, displayNameAr, status, planKey, planName, primaryHost, createdAtMs, seatsUsed, contactsUsed, messagesThisPeriod, health, serializationConstructorMarker, $this) {
    if (!(8191 === (8191 & seen0))) {
      throwMissingFieldException(seen0, 8191, $serializer_getInstance_51().b24_1);
    }
    $this.d24_1 = id;
    $this.e24_1 = slug;
    $this.f24_1 = displayNameEn;
    $this.g24_1 = displayNameAr;
    $this.h24_1 = status;
    $this.i24_1 = planKey;
    $this.j24_1 = planName;
    $this.k24_1 = primaryHost;
    $this.l24_1 = createdAtMs;
    $this.m24_1 = seatsUsed;
    $this.n24_1 = contactsUsed;
    $this.o24_1 = messagesThisPeriod;
    $this.p24_1 = health;
    return $this;
  }
  function TenantRow_init_$Create$(seen0, id, slug, displayNameEn, displayNameAr, status, planKey, planName, primaryHost, createdAtMs, seatsUsed, contactsUsed, messagesThisPeriod, health, serializationConstructorMarker) {
    return TenantRow_init_$Init$(seen0, id, slug, displayNameEn, displayNameAr, status, planKey, planName, primaryHost, createdAtMs, seatsUsed, contactsUsed, messagesThisPeriod, health, serializationConstructorMarker, objectCreate(protoOf(TenantRow)));
  }
  function TenantRow(id, slug, displayNameEn, displayNameAr, status, planKey, planName, primaryHost, createdAtMs, seatsUsed, contactsUsed, messagesThisPeriod, health) {
    this.d24_1 = id;
    this.e24_1 = slug;
    this.f24_1 = displayNameEn;
    this.g24_1 = displayNameAr;
    this.h24_1 = status;
    this.i24_1 = planKey;
    this.j24_1 = planName;
    this.k24_1 = primaryHost;
    this.l24_1 = createdAtMs;
    this.m24_1 = seatsUsed;
    this.n24_1 = contactsUsed;
    this.o24_1 = messagesThisPeriod;
    this.p24_1 = health;
  }
  protoOf(TenantRow).toString = function () {
    return 'TenantRow(id=' + this.d24_1 + ', slug=' + this.e24_1 + ', displayNameEn=' + this.f24_1 + ', displayNameAr=' + this.g24_1 + ', status=' + this.h24_1 + ', planKey=' + this.i24_1 + ', planName=' + this.j24_1 + ', primaryHost=' + this.k24_1 + ', createdAtMs=' + this.l24_1.toString() + ', seatsUsed=' + toString_0(this.m24_1) + ', contactsUsed=' + toString_0(this.n24_1) + ', messagesThisPeriod=' + toString_0(this.o24_1) + ', health=' + this.p24_1 + ')';
  };
  protoOf(TenantRow).hashCode = function () {
    var result = getStringHashCode(this.d24_1);
    result = imul(result, 31) + getStringHashCode(this.e24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g24_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h24_1) | 0;
    result = imul(result, 31) + (this.i24_1 == null ? 0 : getStringHashCode(this.i24_1)) | 0;
    result = imul(result, 31) + (this.j24_1 == null ? 0 : getStringHashCode(this.j24_1)) | 0;
    result = imul(result, 31) + (this.k24_1 == null ? 0 : getStringHashCode(this.k24_1)) | 0;
    result = imul(result, 31) + this.l24_1.hashCode() | 0;
    result = imul(result, 31) + (this.m24_1 == null ? 0 : this.m24_1.hashCode()) | 0;
    result = imul(result, 31) + (this.n24_1 == null ? 0 : this.n24_1.hashCode()) | 0;
    result = imul(result, 31) + (this.o24_1 == null ? 0 : this.o24_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.p24_1) | 0;
    return result;
  };
  protoOf(TenantRow).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantRow))
      return false;
    var tmp0_other_with_cast = other instanceof TenantRow ? other : THROW_CCE();
    if (!(this.d24_1 === tmp0_other_with_cast.d24_1))
      return false;
    if (!(this.e24_1 === tmp0_other_with_cast.e24_1))
      return false;
    if (!(this.f24_1 === tmp0_other_with_cast.f24_1))
      return false;
    if (!(this.g24_1 === tmp0_other_with_cast.g24_1))
      return false;
    if (!(this.h24_1 === tmp0_other_with_cast.h24_1))
      return false;
    if (!(this.i24_1 == tmp0_other_with_cast.i24_1))
      return false;
    if (!(this.j24_1 == tmp0_other_with_cast.j24_1))
      return false;
    if (!(this.k24_1 == tmp0_other_with_cast.k24_1))
      return false;
    if (!this.l24_1.equals(tmp0_other_with_cast.l24_1))
      return false;
    if (!equals(this.m24_1, tmp0_other_with_cast.m24_1))
      return false;
    if (!equals(this.n24_1, tmp0_other_with_cast.n24_1))
      return false;
    if (!equals(this.o24_1, tmp0_other_with_cast.o24_1))
      return false;
    if (!(this.p24_1 === tmp0_other_with_cast.p24_1))
      return false;
    return true;
  };
  function Companion_48() {
  }
  var Companion_instance_48;
  function Companion_getInstance_48() {
    return Companion_instance_48;
  }
  function $serializer_53() {
    $serializer_instance_52 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantListQuery', this, 6);
    tmp0_serialDesc.gy('search', true);
    tmp0_serialDesc.gy('status', true);
    tmp0_serialDesc.gy('planKey', true);
    tmp0_serialDesc.gy('offset', true);
    tmp0_serialDesc.gy('limit', true);
    tmp0_serialDesc.gy('sort', true);
    this.q24_1 = tmp0_serialDesc;
  }
  protoOf($serializer_53).r24 = function (encoder, value) {
    var tmp0_desc = this.q24_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.s24_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, StringSerializer_getInstance(), value.s24_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.t24_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.t24_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.u24_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.u24_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.v24_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 3, value.v24_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.w24_1 === 50)) {
      tmp1_output.cs(tmp0_desc, 4, value.w24_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.x24_1 === 'created_desc')) {
      tmp1_output.hs(tmp0_desc, 5, value.x24_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_53).on = function (encoder, value) {
    return this.r24(encoder, value instanceof TenantListQuery ? value : THROW_CCE());
  };
  protoOf($serializer_53).pn = function (decoder) {
    var tmp0_desc = this.q24_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_local4 = 0;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.yq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.yq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.yq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.yq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return TenantListQuery_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_53).nn = function () {
    return this.q24_1;
  };
  protoOf($serializer_53).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_52;
  function $serializer_getInstance_52() {
    if ($serializer_instance_52 == null)
      new $serializer_53();
    return $serializer_instance_52;
  }
  function TenantListQuery_init_$Init$(seen0, search, status, planKey, offset, limit, sort, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_52().q24_1);
    }
    if (0 === (seen0 & 1))
      $this.s24_1 = null;
    else
      $this.s24_1 = search;
    if (0 === (seen0 & 2))
      $this.t24_1 = null;
    else
      $this.t24_1 = status;
    if (0 === (seen0 & 4))
      $this.u24_1 = null;
    else
      $this.u24_1 = planKey;
    if (0 === (seen0 & 8))
      $this.v24_1 = 0;
    else
      $this.v24_1 = offset;
    if (0 === (seen0 & 16))
      $this.w24_1 = 50;
    else
      $this.w24_1 = limit;
    if (0 === (seen0 & 32))
      $this.x24_1 = 'created_desc';
    else
      $this.x24_1 = sort;
    return $this;
  }
  function TenantListQuery_init_$Create$(seen0, search, status, planKey, offset, limit, sort, serializationConstructorMarker) {
    return TenantListQuery_init_$Init$(seen0, search, status, planKey, offset, limit, sort, serializationConstructorMarker, objectCreate(protoOf(TenantListQuery)));
  }
  function TenantListQuery(search, status, planKey, offset, limit, sort) {
    search = search === VOID ? null : search;
    status = status === VOID ? null : status;
    planKey = planKey === VOID ? null : planKey;
    offset = offset === VOID ? 0 : offset;
    limit = limit === VOID ? 50 : limit;
    sort = sort === VOID ? 'created_desc' : sort;
    this.s24_1 = search;
    this.t24_1 = status;
    this.u24_1 = planKey;
    this.v24_1 = offset;
    this.w24_1 = limit;
    this.x24_1 = sort;
  }
  protoOf(TenantListQuery).y24 = function (search, status, planKey, offset, limit, sort) {
    return new TenantListQuery(search, status, planKey, offset, limit, sort);
  };
  protoOf(TenantListQuery).z24 = function (search, status, planKey, offset, limit, sort, $super) {
    search = search === VOID ? this.s24_1 : search;
    status = status === VOID ? this.t24_1 : status;
    planKey = planKey === VOID ? this.u24_1 : planKey;
    offset = offset === VOID ? this.v24_1 : offset;
    limit = limit === VOID ? this.w24_1 : limit;
    sort = sort === VOID ? this.x24_1 : sort;
    return $super === VOID ? this.y24(search, status, planKey, offset, limit, sort) : $super.y24.call(this, search, status, planKey, offset, limit, sort);
  };
  protoOf(TenantListQuery).toString = function () {
    return 'TenantListQuery(search=' + this.s24_1 + ', status=' + this.t24_1 + ', planKey=' + this.u24_1 + ', offset=' + this.v24_1 + ', limit=' + this.w24_1 + ', sort=' + this.x24_1 + ')';
  };
  protoOf(TenantListQuery).hashCode = function () {
    var result = this.s24_1 == null ? 0 : getStringHashCode(this.s24_1);
    result = imul(result, 31) + (this.t24_1 == null ? 0 : getStringHashCode(this.t24_1)) | 0;
    result = imul(result, 31) + (this.u24_1 == null ? 0 : getStringHashCode(this.u24_1)) | 0;
    result = imul(result, 31) + this.v24_1 | 0;
    result = imul(result, 31) + this.w24_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.x24_1) | 0;
    return result;
  };
  protoOf(TenantListQuery).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantListQuery))
      return false;
    var tmp0_other_with_cast = other instanceof TenantListQuery ? other : THROW_CCE();
    if (!(this.s24_1 == tmp0_other_with_cast.s24_1))
      return false;
    if (!(this.t24_1 == tmp0_other_with_cast.t24_1))
      return false;
    if (!(this.u24_1 == tmp0_other_with_cast.u24_1))
      return false;
    if (!(this.v24_1 === tmp0_other_with_cast.v24_1))
      return false;
    if (!(this.w24_1 === tmp0_other_with_cast.w24_1))
      return false;
    if (!(this.x24_1 === tmp0_other_with_cast.x24_1))
      return false;
    return true;
  };
  function Companion_49() {
    Companion_instance_49 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a25_1 = [null, new ArrayListSerializer($serializer_getInstance_107()), null, null, new ArrayListSerializer($serializer_getInstance_106()), new ArrayListSerializer($serializer_getInstance_110()), new ArrayListSerializer($serializer_getInstance_108()), null, null, null, null, new ArrayListSerializer($serializer_getInstance_73()), null, null];
  }
  var Companion_instance_49;
  function Companion_getInstance_49() {
    if (Companion_instance_49 == null)
      new Companion_49();
    return Companion_instance_49;
  }
  function $serializer_54() {
    $serializer_instance_53 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantDetail', this, 14);
    tmp0_serialDesc.gy('tenant', false);
    tmp0_serialDesc.gy('hosts', false);
    tmp0_serialDesc.gy('subscription', false);
    tmp0_serialDesc.gy('entitlements', false);
    tmp0_serialDesc.gy('overrides', false);
    tmp0_serialDesc.gy('usage', false);
    tmp0_serialDesc.gy('channels', false);
    tmp0_serialDesc.gy('supportAccessEnabled', false);
    tmp0_serialDesc.gy('activeSupportSession', false);
    tmp0_serialDesc.gy('schemaVersion', false);
    tmp0_serialDesc.gy('databaseName', false);
    tmp0_serialDesc.gy('recentActivity', false);
    tmp0_serialDesc.gy('trainingCopyOf', true);
    tmp0_serialDesc.gy('setup', true);
    this.b25_1 = tmp0_serialDesc;
  }
  protoOf($serializer_54).c25 = function (encoder, value) {
    var tmp0_desc = this.b25_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_49().a25_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_51(), value.d25_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.e25_1);
    tmp1_output.ls(tmp0_desc, 2, $serializer_getInstance_103(), value.f25_1);
    tmp1_output.js(tmp0_desc, 3, $serializer_getInstance_93(), value.g25_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.h25_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.i25_1);
    tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.j25_1);
    tmp1_output.zr(tmp0_desc, 7, value.k25_1);
    tmp1_output.ls(tmp0_desc, 8, $serializer_getInstance_55(), value.l25_1);
    tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.m25_1);
    tmp1_output.hs(tmp0_desc, 10, value.n25_1);
    tmp1_output.js(tmp0_desc, 11, tmp2_cached[11], value.o25_1);
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.p25_1 == null)) {
      tmp1_output.ls(tmp0_desc, 12, StringSerializer_getInstance(), value.p25_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.q25_1 == null)) {
      tmp1_output.ls(tmp0_desc, 13, $serializer_getInstance_112(), value.q25_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_54).on = function (encoder, value) {
    return this.c25(encoder, value instanceof TenantDetail ? value : THROW_CCE());
  };
  protoOf($serializer_54).pn = function (decoder) {
    var tmp0_desc = this.b25_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_input = decoder.tq(tmp0_desc);
    var tmp19_cached = Companion_getInstance_49().a25_1;
    if (tmp18_input.ir()) {
      tmp4_local0 = tmp18_input.fr(tmp0_desc, 0, $serializer_getInstance_51(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp18_input.fr(tmp0_desc, 1, tmp19_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp18_input.hr(tmp0_desc, 2, $serializer_getInstance_103(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp18_input.fr(tmp0_desc, 3, $serializer_getInstance_93(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp18_input.fr(tmp0_desc, 4, tmp19_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp18_input.fr(tmp0_desc, 5, tmp19_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp18_input.fr(tmp0_desc, 6, tmp19_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp18_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp18_input.hr(tmp0_desc, 8, $serializer_getInstance_55(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp18_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp18_input.dr(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp18_input.fr(tmp0_desc, 11, tmp19_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp18_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp18_input.hr(tmp0_desc, 13, $serializer_getInstance_112(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp18_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp18_input.fr(tmp0_desc, 0, $serializer_getInstance_51(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp18_input.fr(tmp0_desc, 1, tmp19_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp18_input.hr(tmp0_desc, 2, $serializer_getInstance_103(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp18_input.fr(tmp0_desc, 3, $serializer_getInstance_93(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp18_input.fr(tmp0_desc, 4, tmp19_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp18_input.fr(tmp0_desc, 5, tmp19_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp18_input.fr(tmp0_desc, 6, tmp19_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp18_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp18_input.hr(tmp0_desc, 8, $serializer_getInstance_55(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp18_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp18_input.dr(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp18_input.fr(tmp0_desc, 11, tmp19_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp18_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp18_input.hr(tmp0_desc, 13, $serializer_getInstance_112(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp18_input.uq(tmp0_desc);
    return TenantDetail_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
  };
  protoOf($serializer_54).nn = function () {
    return this.b25_1;
  };
  protoOf($serializer_54).vy = function () {
    var tmp0_cached = Companion_getInstance_49().a25_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_51(), tmp0_cached[1], get_nullable($serializer_getInstance_103()), $serializer_getInstance_93(), tmp0_cached[4], tmp0_cached[5], tmp0_cached[6], BooleanSerializer_getInstance(), get_nullable($serializer_getInstance_55()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[11], get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_112())];
  };
  var $serializer_instance_53;
  function $serializer_getInstance_53() {
    if ($serializer_instance_53 == null)
      new $serializer_54();
    return $serializer_instance_53;
  }
  function TenantDetail_init_$Init$(seen0, tenant, hosts, subscription, entitlements, overrides, usage, channels, supportAccessEnabled, activeSupportSession, schemaVersion, databaseName, recentActivity, trainingCopyOf, setup, serializationConstructorMarker, $this) {
    if (!(4095 === (4095 & seen0))) {
      throwMissingFieldException(seen0, 4095, $serializer_getInstance_53().b25_1);
    }
    $this.d25_1 = tenant;
    $this.e25_1 = hosts;
    $this.f25_1 = subscription;
    $this.g25_1 = entitlements;
    $this.h25_1 = overrides;
    $this.i25_1 = usage;
    $this.j25_1 = channels;
    $this.k25_1 = supportAccessEnabled;
    $this.l25_1 = activeSupportSession;
    $this.m25_1 = schemaVersion;
    $this.n25_1 = databaseName;
    $this.o25_1 = recentActivity;
    if (0 === (seen0 & 4096))
      $this.p25_1 = null;
    else
      $this.p25_1 = trainingCopyOf;
    if (0 === (seen0 & 8192))
      $this.q25_1 = null;
    else
      $this.q25_1 = setup;
    return $this;
  }
  function TenantDetail_init_$Create$(seen0, tenant, hosts, subscription, entitlements, overrides, usage, channels, supportAccessEnabled, activeSupportSession, schemaVersion, databaseName, recentActivity, trainingCopyOf, setup, serializationConstructorMarker) {
    return TenantDetail_init_$Init$(seen0, tenant, hosts, subscription, entitlements, overrides, usage, channels, supportAccessEnabled, activeSupportSession, schemaVersion, databaseName, recentActivity, trainingCopyOf, setup, serializationConstructorMarker, objectCreate(protoOf(TenantDetail)));
  }
  function TenantDetail(tenant, hosts, subscription, entitlements, overrides, usage, channels, supportAccessEnabled, activeSupportSession, schemaVersion, databaseName, recentActivity, trainingCopyOf, setup) {
    Companion_getInstance_49();
    trainingCopyOf = trainingCopyOf === VOID ? null : trainingCopyOf;
    setup = setup === VOID ? null : setup;
    this.d25_1 = tenant;
    this.e25_1 = hosts;
    this.f25_1 = subscription;
    this.g25_1 = entitlements;
    this.h25_1 = overrides;
    this.i25_1 = usage;
    this.j25_1 = channels;
    this.k25_1 = supportAccessEnabled;
    this.l25_1 = activeSupportSession;
    this.m25_1 = schemaVersion;
    this.n25_1 = databaseName;
    this.o25_1 = recentActivity;
    this.p25_1 = trainingCopyOf;
    this.q25_1 = setup;
  }
  protoOf(TenantDetail).toString = function () {
    return 'TenantDetail(tenant=' + this.d25_1.toString() + ', hosts=' + toString(this.e25_1) + ', subscription=' + toString_0(this.f25_1) + ', entitlements=' + this.g25_1.toString() + ', overrides=' + toString(this.h25_1) + ', usage=' + toString(this.i25_1) + ', channels=' + toString(this.j25_1) + ', supportAccessEnabled=' + this.k25_1 + ', activeSupportSession=' + toString_0(this.l25_1) + ', schemaVersion=' + this.m25_1 + ', databaseName=' + this.n25_1 + ', recentActivity=' + toString(this.o25_1) + ', trainingCopyOf=' + this.p25_1 + ', setup=' + toString_0(this.q25_1) + ')';
  };
  protoOf(TenantDetail).hashCode = function () {
    var result = this.d25_1.hashCode();
    result = imul(result, 31) + hashCode(this.e25_1) | 0;
    result = imul(result, 31) + (this.f25_1 == null ? 0 : this.f25_1.hashCode()) | 0;
    result = imul(result, 31) + this.g25_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.h25_1) | 0;
    result = imul(result, 31) + hashCode(this.i25_1) | 0;
    result = imul(result, 31) + hashCode(this.j25_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k25_1) | 0;
    result = imul(result, 31) + (this.l25_1 == null ? 0 : this.l25_1.hashCode()) | 0;
    result = imul(result, 31) + (this.m25_1 == null ? 0 : getStringHashCode(this.m25_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.n25_1) | 0;
    result = imul(result, 31) + hashCode(this.o25_1) | 0;
    result = imul(result, 31) + (this.p25_1 == null ? 0 : getStringHashCode(this.p25_1)) | 0;
    result = imul(result, 31) + (this.q25_1 == null ? 0 : this.q25_1.hashCode()) | 0;
    return result;
  };
  protoOf(TenantDetail).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantDetail))
      return false;
    var tmp0_other_with_cast = other instanceof TenantDetail ? other : THROW_CCE();
    if (!this.d25_1.equals(tmp0_other_with_cast.d25_1))
      return false;
    if (!equals(this.e25_1, tmp0_other_with_cast.e25_1))
      return false;
    if (!equals(this.f25_1, tmp0_other_with_cast.f25_1))
      return false;
    if (!this.g25_1.equals(tmp0_other_with_cast.g25_1))
      return false;
    if (!equals(this.h25_1, tmp0_other_with_cast.h25_1))
      return false;
    if (!equals(this.i25_1, tmp0_other_with_cast.i25_1))
      return false;
    if (!equals(this.j25_1, tmp0_other_with_cast.j25_1))
      return false;
    if (!(this.k25_1 === tmp0_other_with_cast.k25_1))
      return false;
    if (!equals(this.l25_1, tmp0_other_with_cast.l25_1))
      return false;
    if (!(this.m25_1 == tmp0_other_with_cast.m25_1))
      return false;
    if (!(this.n25_1 === tmp0_other_with_cast.n25_1))
      return false;
    if (!equals(this.o25_1, tmp0_other_with_cast.o25_1))
      return false;
    if (!(this.p25_1 == tmp0_other_with_cast.p25_1))
      return false;
    if (!equals(this.q25_1, tmp0_other_with_cast.q25_1))
      return false;
    return true;
  };
  function Companion_50() {
  }
  var Companion_instance_50;
  function Companion_getInstance_50() {
    return Companion_instance_50;
  }
  function $serializer_55() {
    $serializer_instance_54 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantLifecycleRequest', this, 3);
    tmp0_serialDesc.gy('action', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('confirmation', true);
    this.r25_1 = tmp0_serialDesc;
  }
  protoOf($serializer_55).s25 = function (encoder, value) {
    var tmp0_desc = this.r25_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.t25_1);
    tmp1_output.hs(tmp0_desc, 1, value.u25_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.v25_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.v25_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_55).on = function (encoder, value) {
    return this.s25(encoder, value instanceof TenantLifecycleRequest ? value : THROW_CCE());
  };
  protoOf($serializer_55).pn = function (decoder) {
    var tmp0_desc = this.r25_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return TenantLifecycleRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_55).nn = function () {
    return this.r25_1;
  };
  protoOf($serializer_55).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_54;
  function $serializer_getInstance_54() {
    if ($serializer_instance_54 == null)
      new $serializer_55();
    return $serializer_instance_54;
  }
  function TenantLifecycleRequest_init_$Init$(seen0, action, reason, confirmation, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_54().r25_1);
    }
    $this.t25_1 = action;
    $this.u25_1 = reason;
    if (0 === (seen0 & 4))
      $this.v25_1 = null;
    else
      $this.v25_1 = confirmation;
    return $this;
  }
  function TenantLifecycleRequest_init_$Create$(seen0, action, reason, confirmation, serializationConstructorMarker) {
    return TenantLifecycleRequest_init_$Init$(seen0, action, reason, confirmation, serializationConstructorMarker, objectCreate(protoOf(TenantLifecycleRequest)));
  }
  function TenantLifecycleRequest(action, reason, confirmation) {
    confirmation = confirmation === VOID ? null : confirmation;
    this.t25_1 = action;
    this.u25_1 = reason;
    this.v25_1 = confirmation;
  }
  protoOf(TenantLifecycleRequest).toString = function () {
    return 'TenantLifecycleRequest(action=' + this.t25_1 + ', reason=' + this.u25_1 + ', confirmation=' + this.v25_1 + ')';
  };
  protoOf(TenantLifecycleRequest).hashCode = function () {
    var result = getStringHashCode(this.t25_1);
    result = imul(result, 31) + getStringHashCode(this.u25_1) | 0;
    result = imul(result, 31) + (this.v25_1 == null ? 0 : getStringHashCode(this.v25_1)) | 0;
    return result;
  };
  protoOf(TenantLifecycleRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantLifecycleRequest))
      return false;
    var tmp0_other_with_cast = other instanceof TenantLifecycleRequest ? other : THROW_CCE();
    if (!(this.t25_1 === tmp0_other_with_cast.t25_1))
      return false;
    if (!(this.u25_1 === tmp0_other_with_cast.u25_1))
      return false;
    if (!(this.v25_1 == tmp0_other_with_cast.v25_1))
      return false;
    return true;
  };
  function $serializer_56() {
    $serializer_instance_55 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SupportSessionView', this, 8);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('operatorEmail', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('grantedAtMs', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    tmp0_serialDesc.gy('endedAtMs', false);
    tmp0_serialDesc.gy('token', true);
    this.w25_1 = tmp0_serialDesc;
  }
  protoOf($serializer_56).x25 = function (encoder, value) {
    var tmp0_desc = this.w25_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.y25_1);
    tmp1_output.hs(tmp0_desc, 1, value.z25_1);
    tmp1_output.hs(tmp0_desc, 2, value.a26_1);
    tmp1_output.hs(tmp0_desc, 3, value.b26_1);
    tmp1_output.ds(tmp0_desc, 4, value.c26_1);
    tmp1_output.ds(tmp0_desc, 5, value.d26_1);
    tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.e26_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.f26_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.f26_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_56).on = function (encoder, value) {
    return this.x25(encoder, value instanceof SupportSessionView ? value : THROW_CCE());
  };
  protoOf($serializer_56).pn = function (decoder) {
    var tmp0_desc = this.w25_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.tq(tmp0_desc);
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return SupportSessionView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_56).nn = function () {
    return this.w25_1;
  };
  protoOf($serializer_56).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_55;
  function $serializer_getInstance_55() {
    if ($serializer_instance_55 == null)
      new $serializer_56();
    return $serializer_instance_55;
  }
  function SupportSessionView_init_$Init$(seen0, id, tenantId, operatorEmail, reason, grantedAtMs, expiresAtMs, endedAtMs, token, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_55().w25_1);
    }
    $this.y25_1 = id;
    $this.z25_1 = tenantId;
    $this.a26_1 = operatorEmail;
    $this.b26_1 = reason;
    $this.c26_1 = grantedAtMs;
    $this.d26_1 = expiresAtMs;
    $this.e26_1 = endedAtMs;
    if (0 === (seen0 & 128))
      $this.f26_1 = null;
    else
      $this.f26_1 = token;
    return $this;
  }
  function SupportSessionView_init_$Create$(seen0, id, tenantId, operatorEmail, reason, grantedAtMs, expiresAtMs, endedAtMs, token, serializationConstructorMarker) {
    return SupportSessionView_init_$Init$(seen0, id, tenantId, operatorEmail, reason, grantedAtMs, expiresAtMs, endedAtMs, token, serializationConstructorMarker, objectCreate(protoOf(SupportSessionView)));
  }
  function SupportSessionView() {
  }
  protoOf(SupportSessionView).toString = function () {
    return 'SupportSessionView(id=' + this.y25_1 + ', tenantId=' + this.z25_1 + ', operatorEmail=' + this.a26_1 + ', reason=' + this.b26_1 + ', grantedAtMs=' + this.c26_1.toString() + ', expiresAtMs=' + this.d26_1.toString() + ', endedAtMs=' + toString_0(this.e26_1) + ', token=' + this.f26_1 + ')';
  };
  protoOf(SupportSessionView).hashCode = function () {
    var result = getStringHashCode(this.y25_1);
    result = imul(result, 31) + getStringHashCode(this.z25_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a26_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b26_1) | 0;
    result = imul(result, 31) + this.c26_1.hashCode() | 0;
    result = imul(result, 31) + this.d26_1.hashCode() | 0;
    result = imul(result, 31) + (this.e26_1 == null ? 0 : this.e26_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f26_1 == null ? 0 : getStringHashCode(this.f26_1)) | 0;
    return result;
  };
  protoOf(SupportSessionView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SupportSessionView))
      return false;
    var tmp0_other_with_cast = other instanceof SupportSessionView ? other : THROW_CCE();
    if (!(this.y25_1 === tmp0_other_with_cast.y25_1))
      return false;
    if (!(this.z25_1 === tmp0_other_with_cast.z25_1))
      return false;
    if (!(this.a26_1 === tmp0_other_with_cast.a26_1))
      return false;
    if (!(this.b26_1 === tmp0_other_with_cast.b26_1))
      return false;
    if (!this.c26_1.equals(tmp0_other_with_cast.c26_1))
      return false;
    if (!this.d26_1.equals(tmp0_other_with_cast.d26_1))
      return false;
    if (!equals(this.e26_1, tmp0_other_with_cast.e26_1))
      return false;
    if (!(this.f26_1 == tmp0_other_with_cast.f26_1))
      return false;
    return true;
  };
  function Companion_51() {
    Companion_instance_51 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g26_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_113()), new ArrayListSerializer($serializer_getInstance_114())];
  }
  var Companion_instance_51;
  function Companion_getInstance_51() {
    if (Companion_instance_51 == null)
      new Companion_51();
    return Companion_instance_51;
  }
  function $serializer_57() {
    $serializer_instance_56 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.InvoiceView', this, 16);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('number', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('subtotalMinor', false);
    tmp0_serialDesc.gy('taxMinor', false);
    tmp0_serialDesc.gy('totalMinor', false);
    tmp0_serialDesc.gy('paidMinor', false);
    tmp0_serialDesc.gy('issuedAtMs', false);
    tmp0_serialDesc.gy('dueAtMs', false);
    tmp0_serialDesc.gy('periodStartMs', false);
    tmp0_serialDesc.gy('periodEndMs', false);
    tmp0_serialDesc.gy('lines', false);
    tmp0_serialDesc.gy('payments', false);
    this.h26_1 = tmp0_serialDesc;
  }
  protoOf($serializer_57).i26 = function (encoder, value) {
    var tmp0_desc = this.h26_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_51().g26_1;
    tmp1_output.hs(tmp0_desc, 0, value.j26_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.k26_1);
    tmp1_output.hs(tmp0_desc, 2, value.l26_1);
    tmp1_output.hs(tmp0_desc, 3, value.m26_1);
    tmp1_output.hs(tmp0_desc, 4, value.n26_1);
    tmp1_output.hs(tmp0_desc, 5, value.o26_1);
    tmp1_output.ds(tmp0_desc, 6, value.p26_1);
    tmp1_output.ds(tmp0_desc, 7, value.q26_1);
    tmp1_output.ds(tmp0_desc, 8, value.r26_1);
    tmp1_output.ds(tmp0_desc, 9, value.s26_1);
    tmp1_output.ls(tmp0_desc, 10, LongSerializer_getInstance(), value.t26_1);
    tmp1_output.ls(tmp0_desc, 11, LongSerializer_getInstance(), value.u26_1);
    tmp1_output.ds(tmp0_desc, 12, value.v26_1);
    tmp1_output.ds(tmp0_desc, 13, value.w26_1);
    tmp1_output.js(tmp0_desc, 14, tmp2_cached[14], value.x26_1);
    tmp1_output.js(tmp0_desc, 15, tmp2_cached[15], value.y26_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_57).on = function (encoder, value) {
    return this.i26(encoder, value instanceof InvoiceView ? value : THROW_CCE());
  };
  protoOf($serializer_57).pn = function (decoder) {
    var tmp0_desc = this.h26_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = new Long(0, 0);
    var tmp11_local7 = new Long(0, 0);
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = new Long(0, 0);
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = new Long(0, 0);
    var tmp17_local13 = new Long(0, 0);
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_input = decoder.tq(tmp0_desc);
    var tmp21_cached = Companion_getInstance_51().g26_1;
    if (tmp20_input.ir()) {
      tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp20_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp20_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp20_input.zq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp20_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp20_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp20_input.zq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp20_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp20_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp20_input.zq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp20_input.zq(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp20_input.fr(tmp0_desc, 14, tmp21_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp20_input.fr(tmp0_desc, 15, tmp21_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp20_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp20_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp20_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp20_input.zq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp20_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp20_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp20_input.zq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp20_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp20_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp20_input.zq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp20_input.zq(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp20_input.fr(tmp0_desc, 14, tmp21_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp20_input.fr(tmp0_desc, 15, tmp21_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp20_input.uq(tmp0_desc);
    return InvoiceView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
  };
  protoOf($serializer_57).nn = function () {
    return this.h26_1;
  };
  protoOf($serializer_57).vy = function () {
    var tmp0_cached = Companion_getInstance_51().g26_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), LongSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[14], tmp0_cached[15]];
  };
  var $serializer_instance_56;
  function $serializer_getInstance_56() {
    if ($serializer_instance_56 == null)
      new $serializer_57();
    return $serializer_instance_56;
  }
  function InvoiceView_init_$Init$(seen0, id, number, tenantId, tenantName, status, currency, subtotalMinor, taxMinor, totalMinor, paidMinor, issuedAtMs, dueAtMs, periodStartMs, periodEndMs, lines, payments, serializationConstructorMarker, $this) {
    if (!(65535 === (65535 & seen0))) {
      throwMissingFieldException(seen0, 65535, $serializer_getInstance_56().h26_1);
    }
    $this.j26_1 = id;
    $this.k26_1 = number;
    $this.l26_1 = tenantId;
    $this.m26_1 = tenantName;
    $this.n26_1 = status;
    $this.o26_1 = currency;
    $this.p26_1 = subtotalMinor;
    $this.q26_1 = taxMinor;
    $this.r26_1 = totalMinor;
    $this.s26_1 = paidMinor;
    $this.t26_1 = issuedAtMs;
    $this.u26_1 = dueAtMs;
    $this.v26_1 = periodStartMs;
    $this.w26_1 = periodEndMs;
    $this.x26_1 = lines;
    $this.y26_1 = payments;
    return $this;
  }
  function InvoiceView_init_$Create$(seen0, id, number, tenantId, tenantName, status, currency, subtotalMinor, taxMinor, totalMinor, paidMinor, issuedAtMs, dueAtMs, periodStartMs, periodEndMs, lines, payments, serializationConstructorMarker) {
    return InvoiceView_init_$Init$(seen0, id, number, tenantId, tenantName, status, currency, subtotalMinor, taxMinor, totalMinor, paidMinor, issuedAtMs, dueAtMs, periodStartMs, periodEndMs, lines, payments, serializationConstructorMarker, objectCreate(protoOf(InvoiceView)));
  }
  function InvoiceView(id, number, tenantId, tenantName, status, currency, subtotalMinor, taxMinor, totalMinor, paidMinor, issuedAtMs, dueAtMs, periodStartMs, periodEndMs, lines, payments) {
    Companion_getInstance_51();
    this.j26_1 = id;
    this.k26_1 = number;
    this.l26_1 = tenantId;
    this.m26_1 = tenantName;
    this.n26_1 = status;
    this.o26_1 = currency;
    this.p26_1 = subtotalMinor;
    this.q26_1 = taxMinor;
    this.r26_1 = totalMinor;
    this.s26_1 = paidMinor;
    this.t26_1 = issuedAtMs;
    this.u26_1 = dueAtMs;
    this.v26_1 = periodStartMs;
    this.w26_1 = periodEndMs;
    this.x26_1 = lines;
    this.y26_1 = payments;
  }
  protoOf(InvoiceView).toString = function () {
    return 'InvoiceView(id=' + this.j26_1 + ', number=' + this.k26_1 + ', tenantId=' + this.l26_1 + ', tenantName=' + this.m26_1 + ', status=' + this.n26_1 + ', currency=' + this.o26_1 + ', subtotalMinor=' + this.p26_1.toString() + ', taxMinor=' + this.q26_1.toString() + ', totalMinor=' + this.r26_1.toString() + ', paidMinor=' + this.s26_1.toString() + ', issuedAtMs=' + toString_0(this.t26_1) + ', dueAtMs=' + toString_0(this.u26_1) + ', periodStartMs=' + this.v26_1.toString() + ', periodEndMs=' + this.w26_1.toString() + ', lines=' + toString(this.x26_1) + ', payments=' + toString(this.y26_1) + ')';
  };
  protoOf(InvoiceView).hashCode = function () {
    var result = getStringHashCode(this.j26_1);
    result = imul(result, 31) + (this.k26_1 == null ? 0 : getStringHashCode(this.k26_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.l26_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m26_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n26_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o26_1) | 0;
    result = imul(result, 31) + this.p26_1.hashCode() | 0;
    result = imul(result, 31) + this.q26_1.hashCode() | 0;
    result = imul(result, 31) + this.r26_1.hashCode() | 0;
    result = imul(result, 31) + this.s26_1.hashCode() | 0;
    result = imul(result, 31) + (this.t26_1 == null ? 0 : this.t26_1.hashCode()) | 0;
    result = imul(result, 31) + (this.u26_1 == null ? 0 : this.u26_1.hashCode()) | 0;
    result = imul(result, 31) + this.v26_1.hashCode() | 0;
    result = imul(result, 31) + this.w26_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.x26_1) | 0;
    result = imul(result, 31) + hashCode(this.y26_1) | 0;
    return result;
  };
  protoOf(InvoiceView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InvoiceView))
      return false;
    var tmp0_other_with_cast = other instanceof InvoiceView ? other : THROW_CCE();
    if (!(this.j26_1 === tmp0_other_with_cast.j26_1))
      return false;
    if (!(this.k26_1 == tmp0_other_with_cast.k26_1))
      return false;
    if (!(this.l26_1 === tmp0_other_with_cast.l26_1))
      return false;
    if (!(this.m26_1 === tmp0_other_with_cast.m26_1))
      return false;
    if (!(this.n26_1 === tmp0_other_with_cast.n26_1))
      return false;
    if (!(this.o26_1 === tmp0_other_with_cast.o26_1))
      return false;
    if (!this.p26_1.equals(tmp0_other_with_cast.p26_1))
      return false;
    if (!this.q26_1.equals(tmp0_other_with_cast.q26_1))
      return false;
    if (!this.r26_1.equals(tmp0_other_with_cast.r26_1))
      return false;
    if (!this.s26_1.equals(tmp0_other_with_cast.s26_1))
      return false;
    if (!equals(this.t26_1, tmp0_other_with_cast.t26_1))
      return false;
    if (!equals(this.u26_1, tmp0_other_with_cast.u26_1))
      return false;
    if (!this.v26_1.equals(tmp0_other_with_cast.v26_1))
      return false;
    if (!this.w26_1.equals(tmp0_other_with_cast.w26_1))
      return false;
    if (!equals(this.x26_1, tmp0_other_with_cast.x26_1))
      return false;
    if (!equals(this.y26_1, tmp0_other_with_cast.y26_1))
      return false;
    return true;
  };
  function Companion_52() {
  }
  var Companion_instance_52;
  function Companion_getInstance_52() {
    return Companion_instance_52;
  }
  function $serializer_58() {
    $serializer_instance_57 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RecordPaymentRequest', this, 5);
    tmp0_serialDesc.gy('amountMinor', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('method', false);
    tmp0_serialDesc.gy('paidAtMs', false);
    tmp0_serialDesc.gy('reference', true);
    this.z26_1 = tmp0_serialDesc;
  }
  protoOf($serializer_58).a27 = function (encoder, value) {
    var tmp0_desc = this.z26_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.b27_1);
    tmp1_output.hs(tmp0_desc, 1, value.c27_1);
    tmp1_output.hs(tmp0_desc, 2, value.d27_1);
    tmp1_output.ds(tmp0_desc, 3, value.e27_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.f27_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.f27_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_58).on = function (encoder, value) {
    return this.a27(encoder, value instanceof RecordPaymentRequest ? value : THROW_CCE());
  };
  protoOf($serializer_58).pn = function (decoder) {
    var tmp0_desc = this.z26_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return RecordPaymentRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_58).nn = function () {
    return this.z26_1;
  };
  protoOf($serializer_58).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_57;
  function $serializer_getInstance_57() {
    if ($serializer_instance_57 == null)
      new $serializer_58();
    return $serializer_instance_57;
  }
  function RecordPaymentRequest_init_$Init$(seen0, amountMinor, currency, method, paidAtMs, reference, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_57().z26_1);
    }
    $this.b27_1 = amountMinor;
    $this.c27_1 = currency;
    $this.d27_1 = method;
    $this.e27_1 = paidAtMs;
    if (0 === (seen0 & 16))
      $this.f27_1 = null;
    else
      $this.f27_1 = reference;
    return $this;
  }
  function RecordPaymentRequest_init_$Create$(seen0, amountMinor, currency, method, paidAtMs, reference, serializationConstructorMarker) {
    return RecordPaymentRequest_init_$Init$(seen0, amountMinor, currency, method, paidAtMs, reference, serializationConstructorMarker, objectCreate(protoOf(RecordPaymentRequest)));
  }
  function RecordPaymentRequest(amountMinor, currency, method, paidAtMs, reference) {
    reference = reference === VOID ? null : reference;
    this.b27_1 = amountMinor;
    this.c27_1 = currency;
    this.d27_1 = method;
    this.e27_1 = paidAtMs;
    this.f27_1 = reference;
  }
  protoOf(RecordPaymentRequest).toString = function () {
    return 'RecordPaymentRequest(amountMinor=' + this.b27_1.toString() + ', currency=' + this.c27_1 + ', method=' + this.d27_1 + ', paidAtMs=' + this.e27_1.toString() + ', reference=' + this.f27_1 + ')';
  };
  protoOf(RecordPaymentRequest).hashCode = function () {
    var result = this.b27_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.c27_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d27_1) | 0;
    result = imul(result, 31) + this.e27_1.hashCode() | 0;
    result = imul(result, 31) + (this.f27_1 == null ? 0 : getStringHashCode(this.f27_1)) | 0;
    return result;
  };
  protoOf(RecordPaymentRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RecordPaymentRequest))
      return false;
    var tmp0_other_with_cast = other instanceof RecordPaymentRequest ? other : THROW_CCE();
    if (!this.b27_1.equals(tmp0_other_with_cast.b27_1))
      return false;
    if (!(this.c27_1 === tmp0_other_with_cast.c27_1))
      return false;
    if (!(this.d27_1 === tmp0_other_with_cast.d27_1))
      return false;
    if (!this.e27_1.equals(tmp0_other_with_cast.e27_1))
      return false;
    if (!(this.f27_1 == tmp0_other_with_cast.f27_1))
      return false;
    return true;
  };
  function Companion_53() {
    Companion_instance_53 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g27_1 = [null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_92()), null, null, null];
  }
  var Companion_instance_53;
  function Companion_getInstance_53() {
    if (Companion_instance_53 == null)
      new Companion_53();
    return Companion_instance_53;
  }
  function $serializer_59() {
    $serializer_instance_58 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ProvisioningJobView', this, 10);
    tmp0_serialDesc.gy('jobId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantSlug', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('startedAtMs', false);
    tmp0_serialDesc.gy('finishedAtMs', true);
    tmp0_serialDesc.gy('steps', false);
    tmp0_serialDesc.gy('error', true);
    tmp0_serialDesc.gy('setupResumeReceipt', true);
    tmp0_serialDesc.gy('legacyRetryReceipt', true);
    this.h27_1 = tmp0_serialDesc;
  }
  protoOf($serializer_59).i27 = function (encoder, value) {
    var tmp0_desc = this.h27_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_53().g27_1;
    tmp1_output.hs(tmp0_desc, 0, value.j27_1);
    tmp1_output.hs(tmp0_desc, 1, value.k27_1);
    tmp1_output.hs(tmp0_desc, 2, value.l27_1);
    tmp1_output.hs(tmp0_desc, 3, value.m27_1);
    tmp1_output.ds(tmp0_desc, 4, value.n27_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.o27_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.o27_1);
    }
    tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.p27_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.q27_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.q27_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.r27_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, $serializer_getInstance_176(), value.r27_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.s27_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, $serializer_getInstance_72(), value.s27_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_59).on = function (encoder, value) {
    return this.i27(encoder, value instanceof ProvisioningJobView ? value : THROW_CCE());
  };
  protoOf($serializer_59).pn = function (decoder) {
    var tmp0_desc = this.h27_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.tq(tmp0_desc);
    var tmp15_cached = Companion_getInstance_53().g27_1;
    if (tmp14_input.ir()) {
      tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.fr(tmp0_desc, 6, tmp15_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.hr(tmp0_desc, 8, $serializer_getInstance_176(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.hr(tmp0_desc, 9, $serializer_getInstance_72(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.fr(tmp0_desc, 6, tmp15_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.hr(tmp0_desc, 8, $serializer_getInstance_176(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.hr(tmp0_desc, 9, $serializer_getInstance_72(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.uq(tmp0_desc);
    return ProvisioningJobView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_59).nn = function () {
    return this.h27_1;
  };
  protoOf($serializer_59).vy = function () {
    var tmp0_cached = Companion_getInstance_53().g27_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), tmp0_cached[6], get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_176()), get_nullable($serializer_getInstance_72())];
  };
  var $serializer_instance_58;
  function $serializer_getInstance_58() {
    if ($serializer_instance_58 == null)
      new $serializer_59();
    return $serializer_instance_58;
  }
  function ProvisioningJobView_init_$Init$(seen0, jobId, tenantId, tenantSlug, state, startedAtMs, finishedAtMs, steps, error, setupResumeReceipt, legacyRetryReceipt, serializationConstructorMarker, $this) {
    if (!(95 === (95 & seen0))) {
      throwMissingFieldException(seen0, 95, $serializer_getInstance_58().h27_1);
    }
    $this.j27_1 = jobId;
    $this.k27_1 = tenantId;
    $this.l27_1 = tenantSlug;
    $this.m27_1 = state;
    $this.n27_1 = startedAtMs;
    if (0 === (seen0 & 32))
      $this.o27_1 = null;
    else
      $this.o27_1 = finishedAtMs;
    $this.p27_1 = steps;
    if (0 === (seen0 & 128))
      $this.q27_1 = null;
    else
      $this.q27_1 = error;
    if (0 === (seen0 & 256))
      $this.r27_1 = null;
    else
      $this.r27_1 = setupResumeReceipt;
    if (0 === (seen0 & 512))
      $this.s27_1 = null;
    else
      $this.s27_1 = legacyRetryReceipt;
    return $this;
  }
  function ProvisioningJobView_init_$Create$(seen0, jobId, tenantId, tenantSlug, state, startedAtMs, finishedAtMs, steps, error, setupResumeReceipt, legacyRetryReceipt, serializationConstructorMarker) {
    return ProvisioningJobView_init_$Init$(seen0, jobId, tenantId, tenantSlug, state, startedAtMs, finishedAtMs, steps, error, setupResumeReceipt, legacyRetryReceipt, serializationConstructorMarker, objectCreate(protoOf(ProvisioningJobView)));
  }
  function ProvisioningJobView(jobId, tenantId, tenantSlug, state, startedAtMs, finishedAtMs, steps, error, setupResumeReceipt, legacyRetryReceipt) {
    Companion_getInstance_53();
    finishedAtMs = finishedAtMs === VOID ? null : finishedAtMs;
    error = error === VOID ? null : error;
    setupResumeReceipt = setupResumeReceipt === VOID ? null : setupResumeReceipt;
    legacyRetryReceipt = legacyRetryReceipt === VOID ? null : legacyRetryReceipt;
    this.j27_1 = jobId;
    this.k27_1 = tenantId;
    this.l27_1 = tenantSlug;
    this.m27_1 = state;
    this.n27_1 = startedAtMs;
    this.o27_1 = finishedAtMs;
    this.p27_1 = steps;
    this.q27_1 = error;
    this.r27_1 = setupResumeReceipt;
    this.s27_1 = legacyRetryReceipt;
  }
  protoOf(ProvisioningJobView).toString = function () {
    return 'ProvisioningJobView(jobId=' + this.j27_1 + ', tenantId=' + this.k27_1 + ', tenantSlug=' + this.l27_1 + ', state=' + this.m27_1 + ', startedAtMs=' + this.n27_1.toString() + ', finishedAtMs=' + toString_0(this.o27_1) + ', steps=' + toString(this.p27_1) + ', error=' + this.q27_1 + ', setupResumeReceipt=' + toString_0(this.r27_1) + ', legacyRetryReceipt=' + toString_0(this.s27_1) + ')';
  };
  protoOf(ProvisioningJobView).hashCode = function () {
    var result = getStringHashCode(this.j27_1);
    result = imul(result, 31) + getStringHashCode(this.k27_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l27_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m27_1) | 0;
    result = imul(result, 31) + this.n27_1.hashCode() | 0;
    result = imul(result, 31) + (this.o27_1 == null ? 0 : this.o27_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.p27_1) | 0;
    result = imul(result, 31) + (this.q27_1 == null ? 0 : getStringHashCode(this.q27_1)) | 0;
    result = imul(result, 31) + (this.r27_1 == null ? 0 : this.r27_1.hashCode()) | 0;
    result = imul(result, 31) + (this.s27_1 == null ? 0 : this.s27_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProvisioningJobView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProvisioningJobView))
      return false;
    var tmp0_other_with_cast = other instanceof ProvisioningJobView ? other : THROW_CCE();
    if (!(this.j27_1 === tmp0_other_with_cast.j27_1))
      return false;
    if (!(this.k27_1 === tmp0_other_with_cast.k27_1))
      return false;
    if (!(this.l27_1 === tmp0_other_with_cast.l27_1))
      return false;
    if (!(this.m27_1 === tmp0_other_with_cast.m27_1))
      return false;
    if (!this.n27_1.equals(tmp0_other_with_cast.n27_1))
      return false;
    if (!equals(this.o27_1, tmp0_other_with_cast.o27_1))
      return false;
    if (!equals(this.p27_1, tmp0_other_with_cast.p27_1))
      return false;
    if (!(this.q27_1 == tmp0_other_with_cast.q27_1))
      return false;
    if (!equals(this.r27_1, tmp0_other_with_cast.r27_1))
      return false;
    if (!equals(this.s27_1, tmp0_other_with_cast.s27_1))
      return false;
    return true;
  };
  function Companion_54() {
    Companion_instance_54 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t27_1 = [null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_88()), new ArrayListSerializer($serializer_getInstance_87()), new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_54;
  function Companion_getInstance_54() {
    if (Companion_instance_54 == null)
      new Companion_54();
    return Companion_instance_54;
  }
  function $serializer_60() {
    $serializer_instance_59 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UpsertPlanRequest', this, 16);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('descriptionEn', true);
    tmp0_serialDesc.gy('descriptionAr', true);
    tmp0_serialDesc.gy('isPublic', true);
    tmp0_serialDesc.gy('isActive', true);
    tmp0_serialDesc.gy('isCustom', true);
    tmp0_serialDesc.gy('customForTenantId', true);
    tmp0_serialDesc.gy('sortOrder', true);
    tmp0_serialDesc.gy('modules', true);
    tmp0_serialDesc.gy('limits', true);
    tmp0_serialDesc.gy('prices', true);
    tmp0_serialDesc.gy('features', true);
    tmp0_serialDesc.gy('expectedRevision', true);
    tmp0_serialDesc.gy('reviewReceipt', true);
    this.u27_1 = tmp0_serialDesc;
  }
  protoOf($serializer_60).v27 = function (encoder, value) {
    var tmp0_desc = this.u27_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_54().t27_1;
    tmp1_output.hs(tmp0_desc, 0, value.w27_1);
    tmp1_output.hs(tmp0_desc, 1, value.x27_1);
    tmp1_output.hs(tmp0_desc, 2, value.y27_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.z27_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.z27_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.a28_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.a28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.b28_1 === true)) {
      tmp1_output.zr(tmp0_desc, 5, value.b28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.c28_1 === true)) {
      tmp1_output.zr(tmp0_desc, 6, value.c28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.d28_1 === false)) {
      tmp1_output.zr(tmp0_desc, 7, value.d28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.e28_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.e28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.f28_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 9, value.f28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !equals(value.g28_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 10, tmp2_cached[10], value.g28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !equals(value.h28_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 11, tmp2_cached[11], value.h28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !equals(value.i28_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 12, tmp2_cached[12], value.i28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !equals(value.j28_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 13, tmp2_cached[13], value.j28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !value.k28_1.equals(new Long(0, 0))) {
      tmp1_output.ds(tmp0_desc, 14, value.k28_1);
    }
    if (tmp1_output.ps(tmp0_desc, 15) ? true : !(value.l28_1 == null)) {
      tmp1_output.ls(tmp0_desc, 15, StringSerializer_getInstance(), value.l28_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_60).on = function (encoder, value) {
    return this.v27(encoder, value instanceof UpsertPlanRequest ? value : THROW_CCE());
  };
  protoOf($serializer_60).pn = function (decoder) {
    var tmp0_desc = this.u27_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = false;
    var tmp10_local6 = false;
    var tmp11_local7 = false;
    var tmp12_local8 = null;
    var tmp13_local9 = 0;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = new Long(0, 0);
    var tmp19_local15 = null;
    var tmp20_input = decoder.tq(tmp0_desc);
    var tmp21_cached = Companion_getInstance_54().t27_1;
    if (tmp20_input.ir()) {
      tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp20_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp20_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp20_input.vq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp20_input.vq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp20_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp20_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp20_input.yq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp20_input.fr(tmp0_desc, 10, tmp21_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp20_input.fr(tmp0_desc, 11, tmp21_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp20_input.fr(tmp0_desc, 12, tmp21_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp20_input.fr(tmp0_desc, 13, tmp21_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp20_input.zq(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp20_input.hr(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp20_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp20_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp20_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp20_input.vq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp20_input.vq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp20_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp20_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp20_input.yq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp20_input.fr(tmp0_desc, 10, tmp21_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp20_input.fr(tmp0_desc, 11, tmp21_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp20_input.fr(tmp0_desc, 12, tmp21_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp20_input.fr(tmp0_desc, 13, tmp21_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp20_input.zq(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp20_input.hr(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp20_input.uq(tmp0_desc);
    return UpsertPlanRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
  };
  protoOf($serializer_60).nn = function () {
    return this.u27_1;
  };
  protoOf($serializer_60).vy = function () {
    var tmp0_cached = Companion_getInstance_54().t27_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance(), tmp0_cached[10], tmp0_cached[11], tmp0_cached[12], tmp0_cached[13], LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_59;
  function $serializer_getInstance_59() {
    if ($serializer_instance_59 == null)
      new $serializer_60();
    return $serializer_instance_59;
  }
  function UpsertPlanRequest_init_$Init$(seen0, key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_59().u27_1);
    }
    $this.w27_1 = key;
    $this.x27_1 = nameEn;
    $this.y27_1 = nameAr;
    if (0 === (seen0 & 8))
      $this.z27_1 = null;
    else
      $this.z27_1 = descriptionEn;
    if (0 === (seen0 & 16))
      $this.a28_1 = null;
    else
      $this.a28_1 = descriptionAr;
    if (0 === (seen0 & 32))
      $this.b28_1 = true;
    else
      $this.b28_1 = isPublic;
    if (0 === (seen0 & 64))
      $this.c28_1 = true;
    else
      $this.c28_1 = isActive;
    if (0 === (seen0 & 128))
      $this.d28_1 = false;
    else
      $this.d28_1 = isCustom;
    if (0 === (seen0 & 256))
      $this.e28_1 = null;
    else
      $this.e28_1 = customForTenantId;
    if (0 === (seen0 & 512))
      $this.f28_1 = 0;
    else
      $this.f28_1 = sortOrder;
    if (0 === (seen0 & 1024))
      $this.g28_1 = emptyList();
    else
      $this.g28_1 = modules;
    if (0 === (seen0 & 2048))
      $this.h28_1 = emptyList();
    else
      $this.h28_1 = limits;
    if (0 === (seen0 & 4096))
      $this.i28_1 = emptyList();
    else
      $this.i28_1 = prices;
    if (0 === (seen0 & 8192))
      $this.j28_1 = emptyList();
    else
      $this.j28_1 = features;
    if (0 === (seen0 & 16384))
      $this.k28_1 = new Long(0, 0);
    else
      $this.k28_1 = expectedRevision;
    if (0 === (seen0 & 32768))
      $this.l28_1 = null;
    else
      $this.l28_1 = reviewReceipt;
    return $this;
  }
  function UpsertPlanRequest_init_$Create$(seen0, key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt, serializationConstructorMarker) {
    return UpsertPlanRequest_init_$Init$(seen0, key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt, serializationConstructorMarker, objectCreate(protoOf(UpsertPlanRequest)));
  }
  function UpsertPlanRequest(key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt) {
    Companion_getInstance_54();
    descriptionEn = descriptionEn === VOID ? null : descriptionEn;
    descriptionAr = descriptionAr === VOID ? null : descriptionAr;
    isPublic = isPublic === VOID ? true : isPublic;
    isActive = isActive === VOID ? true : isActive;
    isCustom = isCustom === VOID ? false : isCustom;
    customForTenantId = customForTenantId === VOID ? null : customForTenantId;
    sortOrder = sortOrder === VOID ? 0 : sortOrder;
    modules = modules === VOID ? emptyList() : modules;
    limits = limits === VOID ? emptyList() : limits;
    prices = prices === VOID ? emptyList() : prices;
    features = features === VOID ? emptyList() : features;
    expectedRevision = expectedRevision === VOID ? new Long(0, 0) : expectedRevision;
    reviewReceipt = reviewReceipt === VOID ? null : reviewReceipt;
    this.w27_1 = key;
    this.x27_1 = nameEn;
    this.y27_1 = nameAr;
    this.z27_1 = descriptionEn;
    this.a28_1 = descriptionAr;
    this.b28_1 = isPublic;
    this.c28_1 = isActive;
    this.d28_1 = isCustom;
    this.e28_1 = customForTenantId;
    this.f28_1 = sortOrder;
    this.g28_1 = modules;
    this.h28_1 = limits;
    this.i28_1 = prices;
    this.j28_1 = features;
    this.k28_1 = expectedRevision;
    this.l28_1 = reviewReceipt;
  }
  protoOf(UpsertPlanRequest).m28 = function (key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt) {
    return new UpsertPlanRequest(key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt);
  };
  protoOf(UpsertPlanRequest).n28 = function (key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt, $super) {
    key = key === VOID ? this.w27_1 : key;
    nameEn = nameEn === VOID ? this.x27_1 : nameEn;
    nameAr = nameAr === VOID ? this.y27_1 : nameAr;
    descriptionEn = descriptionEn === VOID ? this.z27_1 : descriptionEn;
    descriptionAr = descriptionAr === VOID ? this.a28_1 : descriptionAr;
    isPublic = isPublic === VOID ? this.b28_1 : isPublic;
    isActive = isActive === VOID ? this.c28_1 : isActive;
    isCustom = isCustom === VOID ? this.d28_1 : isCustom;
    customForTenantId = customForTenantId === VOID ? this.e28_1 : customForTenantId;
    sortOrder = sortOrder === VOID ? this.f28_1 : sortOrder;
    modules = modules === VOID ? this.g28_1 : modules;
    limits = limits === VOID ? this.h28_1 : limits;
    prices = prices === VOID ? this.i28_1 : prices;
    features = features === VOID ? this.j28_1 : features;
    expectedRevision = expectedRevision === VOID ? this.k28_1 : expectedRevision;
    reviewReceipt = reviewReceipt === VOID ? this.l28_1 : reviewReceipt;
    return $super === VOID ? this.m28(key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt) : $super.m28.call(this, key, nameEn, nameAr, descriptionEn, descriptionAr, isPublic, isActive, isCustom, customForTenantId, sortOrder, modules, limits, prices, features, expectedRevision, reviewReceipt);
  };
  protoOf(UpsertPlanRequest).toString = function () {
    return 'UpsertPlanRequest(key=' + this.w27_1 + ', nameEn=' + this.x27_1 + ', nameAr=' + this.y27_1 + ', descriptionEn=' + this.z27_1 + ', descriptionAr=' + this.a28_1 + ', isPublic=' + this.b28_1 + ', isActive=' + this.c28_1 + ', isCustom=' + this.d28_1 + ', customForTenantId=' + this.e28_1 + ', sortOrder=' + this.f28_1 + ', modules=' + toString(this.g28_1) + ', limits=' + toString(this.h28_1) + ', prices=' + toString(this.i28_1) + ', features=' + toString(this.j28_1) + ', expectedRevision=' + this.k28_1.toString() + ', reviewReceipt=' + this.l28_1 + ')';
  };
  protoOf(UpsertPlanRequest).hashCode = function () {
    var result = getStringHashCode(this.w27_1);
    result = imul(result, 31) + getStringHashCode(this.x27_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y27_1) | 0;
    result = imul(result, 31) + (this.z27_1 == null ? 0 : getStringHashCode(this.z27_1)) | 0;
    result = imul(result, 31) + (this.a28_1 == null ? 0 : getStringHashCode(this.a28_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b28_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c28_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d28_1) | 0;
    result = imul(result, 31) + (this.e28_1 == null ? 0 : getStringHashCode(this.e28_1)) | 0;
    result = imul(result, 31) + this.f28_1 | 0;
    result = imul(result, 31) + hashCode(this.g28_1) | 0;
    result = imul(result, 31) + hashCode(this.h28_1) | 0;
    result = imul(result, 31) + hashCode(this.i28_1) | 0;
    result = imul(result, 31) + hashCode(this.j28_1) | 0;
    result = imul(result, 31) + this.k28_1.hashCode() | 0;
    result = imul(result, 31) + (this.l28_1 == null ? 0 : getStringHashCode(this.l28_1)) | 0;
    return result;
  };
  protoOf(UpsertPlanRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpsertPlanRequest))
      return false;
    var tmp0_other_with_cast = other instanceof UpsertPlanRequest ? other : THROW_CCE();
    if (!(this.w27_1 === tmp0_other_with_cast.w27_1))
      return false;
    if (!(this.x27_1 === tmp0_other_with_cast.x27_1))
      return false;
    if (!(this.y27_1 === tmp0_other_with_cast.y27_1))
      return false;
    if (!(this.z27_1 == tmp0_other_with_cast.z27_1))
      return false;
    if (!(this.a28_1 == tmp0_other_with_cast.a28_1))
      return false;
    if (!(this.b28_1 === tmp0_other_with_cast.b28_1))
      return false;
    if (!(this.c28_1 === tmp0_other_with_cast.c28_1))
      return false;
    if (!(this.d28_1 === tmp0_other_with_cast.d28_1))
      return false;
    if (!(this.e28_1 == tmp0_other_with_cast.e28_1))
      return false;
    if (!(this.f28_1 === tmp0_other_with_cast.f28_1))
      return false;
    if (!equals(this.g28_1, tmp0_other_with_cast.g28_1))
      return false;
    if (!equals(this.h28_1, tmp0_other_with_cast.h28_1))
      return false;
    if (!equals(this.i28_1, tmp0_other_with_cast.i28_1))
      return false;
    if (!equals(this.j28_1, tmp0_other_with_cast.j28_1))
      return false;
    if (!this.k28_1.equals(tmp0_other_with_cast.k28_1))
      return false;
    if (!(this.l28_1 == tmp0_other_with_cast.l28_1))
      return false;
    return true;
  };
  function Companion_55() {
    Companion_instance_55 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o28_1 = [null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_87()), new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_55;
  function Companion_getInstance_55() {
    if (Companion_instance_55 == null)
      new Companion_55();
    return Companion_instance_55;
  }
  function $serializer_61() {
    $serializer_instance_60 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddonPackView', this, 13);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('quantity', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('expiresDays', false);
    tmp0_serialDesc.gy('isPublic', false);
    tmp0_serialDesc.gy('isActive', false);
    tmp0_serialDesc.gy('prices', false);
    tmp0_serialDesc.gy('features', true);
    tmp0_serialDesc.gy('revision', true);
    tmp0_serialDesc.gy('activeTenants', true);
    this.p28_1 = tmp0_serialDesc;
  }
  protoOf($serializer_61).q28 = function (encoder, value) {
    var tmp0_desc = this.p28_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_55().o28_1;
    tmp1_output.hs(tmp0_desc, 0, value.r28_1);
    tmp1_output.hs(tmp0_desc, 1, value.s28_1);
    tmp1_output.hs(tmp0_desc, 2, value.t28_1);
    tmp1_output.ds(tmp0_desc, 3, value.u28_1);
    tmp1_output.hs(tmp0_desc, 4, value.v28_1);
    tmp1_output.hs(tmp0_desc, 5, value.w28_1);
    tmp1_output.ls(tmp0_desc, 6, IntSerializer_getInstance(), value.x28_1);
    tmp1_output.zr(tmp0_desc, 7, value.y28_1);
    tmp1_output.zr(tmp0_desc, 8, value.z28_1);
    tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.a29_1);
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !equals(value.b29_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 10, tmp2_cached[10], value.b29_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.c29_1 === '')) {
      tmp1_output.hs(tmp0_desc, 11, value.c29_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.d29_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 12, value.d29_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_61).on = function (encoder, value) {
    return this.q28(encoder, value instanceof AddonPackView ? value : THROW_CCE());
  };
  protoOf($serializer_61).pn = function (decoder) {
    var tmp0_desc = this.p28_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = 0;
    var tmp17_input = decoder.tq(tmp0_desc);
    var tmp18_cached = Companion_getInstance_55().o28_1;
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.vq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.fr(tmp0_desc, 10, tmp18_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.dr(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.yq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.vq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.fr(tmp0_desc, 10, tmp18_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.dr(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.yq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return AddonPackView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_61).nn = function () {
    return this.p28_1;
  };
  protoOf($serializer_61).vy = function () {
    var tmp0_cached = Companion_getInstance_55().o28_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[9], tmp0_cached[10], StringSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_60;
  function $serializer_getInstance_60() {
    if ($serializer_instance_60 == null)
      new $serializer_61();
    return $serializer_instance_60;
  }
  function AddonPackView_init_$Init$(seen0, id, key, limitKey, quantity, nameEn, nameAr, expiresDays, isPublic, isActive, prices, features, revision, activeTenants, serializationConstructorMarker, $this) {
    if (!(1023 === (1023 & seen0))) {
      throwMissingFieldException(seen0, 1023, $serializer_getInstance_60().p28_1);
    }
    $this.r28_1 = id;
    $this.s28_1 = key;
    $this.t28_1 = limitKey;
    $this.u28_1 = quantity;
    $this.v28_1 = nameEn;
    $this.w28_1 = nameAr;
    $this.x28_1 = expiresDays;
    $this.y28_1 = isPublic;
    $this.z28_1 = isActive;
    $this.a29_1 = prices;
    if (0 === (seen0 & 1024))
      $this.b29_1 = emptyList();
    else
      $this.b29_1 = features;
    if (0 === (seen0 & 2048))
      $this.c29_1 = '';
    else
      $this.c29_1 = revision;
    if (0 === (seen0 & 4096))
      $this.d29_1 = 0;
    else
      $this.d29_1 = activeTenants;
    return $this;
  }
  function AddonPackView_init_$Create$(seen0, id, key, limitKey, quantity, nameEn, nameAr, expiresDays, isPublic, isActive, prices, features, revision, activeTenants, serializationConstructorMarker) {
    return AddonPackView_init_$Init$(seen0, id, key, limitKey, quantity, nameEn, nameAr, expiresDays, isPublic, isActive, prices, features, revision, activeTenants, serializationConstructorMarker, objectCreate(protoOf(AddonPackView)));
  }
  function AddonPackView(id, key, limitKey, quantity, nameEn, nameAr, expiresDays, isPublic, isActive, prices, features, revision, activeTenants) {
    Companion_getInstance_55();
    features = features === VOID ? emptyList() : features;
    revision = revision === VOID ? '' : revision;
    activeTenants = activeTenants === VOID ? 0 : activeTenants;
    this.r28_1 = id;
    this.s28_1 = key;
    this.t28_1 = limitKey;
    this.u28_1 = quantity;
    this.v28_1 = nameEn;
    this.w28_1 = nameAr;
    this.x28_1 = expiresDays;
    this.y28_1 = isPublic;
    this.z28_1 = isActive;
    this.a29_1 = prices;
    this.b29_1 = features;
    this.c29_1 = revision;
    this.d29_1 = activeTenants;
  }
  protoOf(AddonPackView).toString = function () {
    return 'AddonPackView(id=' + this.r28_1 + ', key=' + this.s28_1 + ', limitKey=' + this.t28_1 + ', quantity=' + this.u28_1.toString() + ', nameEn=' + this.v28_1 + ', nameAr=' + this.w28_1 + ', expiresDays=' + this.x28_1 + ', isPublic=' + this.y28_1 + ', isActive=' + this.z28_1 + ', prices=' + toString(this.a29_1) + ', features=' + toString(this.b29_1) + ', revision=' + this.c29_1 + ', activeTenants=' + this.d29_1 + ')';
  };
  protoOf(AddonPackView).hashCode = function () {
    var result = getStringHashCode(this.r28_1);
    result = imul(result, 31) + getStringHashCode(this.s28_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t28_1) | 0;
    result = imul(result, 31) + this.u28_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.v28_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w28_1) | 0;
    result = imul(result, 31) + (this.x28_1 == null ? 0 : this.x28_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y28_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z28_1) | 0;
    result = imul(result, 31) + hashCode(this.a29_1) | 0;
    result = imul(result, 31) + hashCode(this.b29_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c29_1) | 0;
    result = imul(result, 31) + this.d29_1 | 0;
    return result;
  };
  protoOf(AddonPackView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddonPackView))
      return false;
    var tmp0_other_with_cast = other instanceof AddonPackView ? other : THROW_CCE();
    if (!(this.r28_1 === tmp0_other_with_cast.r28_1))
      return false;
    if (!(this.s28_1 === tmp0_other_with_cast.s28_1))
      return false;
    if (!(this.t28_1 === tmp0_other_with_cast.t28_1))
      return false;
    if (!this.u28_1.equals(tmp0_other_with_cast.u28_1))
      return false;
    if (!(this.v28_1 === tmp0_other_with_cast.v28_1))
      return false;
    if (!(this.w28_1 === tmp0_other_with_cast.w28_1))
      return false;
    if (!(this.x28_1 == tmp0_other_with_cast.x28_1))
      return false;
    if (!(this.y28_1 === tmp0_other_with_cast.y28_1))
      return false;
    if (!(this.z28_1 === tmp0_other_with_cast.z28_1))
      return false;
    if (!equals(this.a29_1, tmp0_other_with_cast.a29_1))
      return false;
    if (!equals(this.b29_1, tmp0_other_with_cast.b29_1))
      return false;
    if (!(this.c29_1 === tmp0_other_with_cast.c29_1))
      return false;
    if (!(this.d29_1 === tmp0_other_with_cast.d29_1))
      return false;
    return true;
  };
  function Companion_56() {
  }
  var Companion_instance_56;
  function Companion_getInstance_56() {
    return Companion_instance_56;
  }
  function $serializer_62() {
    $serializer_instance_61 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.WaRateCardView', this, 9);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('regionCode', false);
    tmp0_serialDesc.gy('category', false);
    tmp0_serialDesc.gy('unitCostMicros', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('effectiveFrom', false);
    tmp0_serialDesc.gy('note', true);
    tmp0_serialDesc.gy('createdBy', true);
    tmp0_serialDesc.gy('createdAt', true);
    this.e29_1 = tmp0_serialDesc;
  }
  protoOf($serializer_62).f29 = function (encoder, value) {
    var tmp0_desc = this.e29_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.g29_1);
    tmp1_output.hs(tmp0_desc, 1, value.h29_1);
    tmp1_output.hs(tmp0_desc, 2, value.i29_1);
    tmp1_output.ds(tmp0_desc, 3, value.j29_1);
    tmp1_output.hs(tmp0_desc, 4, value.k29_1);
    tmp1_output.hs(tmp0_desc, 5, value.l29_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.m29_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.m29_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.n29_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.n29_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !value.o29_1.equals(new Long(0, 0))) {
      tmp1_output.ds(tmp0_desc, 8, value.o29_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_62).on = function (encoder, value) {
    return this.f29(encoder, value instanceof WaRateCardView ? value : THROW_CCE());
  };
  protoOf($serializer_62).pn = function (decoder) {
    var tmp0_desc = this.e29_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = new Long(0, 0);
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return WaRateCardView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_62).nn = function () {
    return this.e29_1;
  };
  protoOf($serializer_62).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance()];
  };
  var $serializer_instance_61;
  function $serializer_getInstance_61() {
    if ($serializer_instance_61 == null)
      new $serializer_62();
    return $serializer_instance_61;
  }
  function WaRateCardView_init_$Init$(seen0, id, regionCode, category, unitCostMicros, currency, effectiveFrom, note, createdBy, createdAt, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_61().e29_1);
    }
    $this.g29_1 = id;
    $this.h29_1 = regionCode;
    $this.i29_1 = category;
    $this.j29_1 = unitCostMicros;
    $this.k29_1 = currency;
    $this.l29_1 = effectiveFrom;
    if (0 === (seen0 & 64))
      $this.m29_1 = null;
    else
      $this.m29_1 = note;
    if (0 === (seen0 & 128))
      $this.n29_1 = null;
    else
      $this.n29_1 = createdBy;
    if (0 === (seen0 & 256))
      $this.o29_1 = new Long(0, 0);
    else
      $this.o29_1 = createdAt;
    return $this;
  }
  function WaRateCardView_init_$Create$(seen0, id, regionCode, category, unitCostMicros, currency, effectiveFrom, note, createdBy, createdAt, serializationConstructorMarker) {
    return WaRateCardView_init_$Init$(seen0, id, regionCode, category, unitCostMicros, currency, effectiveFrom, note, createdBy, createdAt, serializationConstructorMarker, objectCreate(protoOf(WaRateCardView)));
  }
  function WaRateCardView(id, regionCode, category, unitCostMicros, currency, effectiveFrom, note, createdBy, createdAt) {
    note = note === VOID ? null : note;
    createdBy = createdBy === VOID ? null : createdBy;
    createdAt = createdAt === VOID ? new Long(0, 0) : createdAt;
    this.g29_1 = id;
    this.h29_1 = regionCode;
    this.i29_1 = category;
    this.j29_1 = unitCostMicros;
    this.k29_1 = currency;
    this.l29_1 = effectiveFrom;
    this.m29_1 = note;
    this.n29_1 = createdBy;
    this.o29_1 = createdAt;
  }
  protoOf(WaRateCardView).toString = function () {
    return 'WaRateCardView(id=' + this.g29_1 + ', regionCode=' + this.h29_1 + ', category=' + this.i29_1 + ', unitCostMicros=' + this.j29_1.toString() + ', currency=' + this.k29_1 + ', effectiveFrom=' + this.l29_1 + ', note=' + this.m29_1 + ', createdBy=' + this.n29_1 + ', createdAt=' + this.o29_1.toString() + ')';
  };
  protoOf(WaRateCardView).hashCode = function () {
    var result = getStringHashCode(this.g29_1);
    result = imul(result, 31) + getStringHashCode(this.h29_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i29_1) | 0;
    result = imul(result, 31) + this.j29_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.k29_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l29_1) | 0;
    result = imul(result, 31) + (this.m29_1 == null ? 0 : getStringHashCode(this.m29_1)) | 0;
    result = imul(result, 31) + (this.n29_1 == null ? 0 : getStringHashCode(this.n29_1)) | 0;
    result = imul(result, 31) + this.o29_1.hashCode() | 0;
    return result;
  };
  protoOf(WaRateCardView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WaRateCardView))
      return false;
    var tmp0_other_with_cast = other instanceof WaRateCardView ? other : THROW_CCE();
    if (!(this.g29_1 === tmp0_other_with_cast.g29_1))
      return false;
    if (!(this.h29_1 === tmp0_other_with_cast.h29_1))
      return false;
    if (!(this.i29_1 === tmp0_other_with_cast.i29_1))
      return false;
    if (!this.j29_1.equals(tmp0_other_with_cast.j29_1))
      return false;
    if (!(this.k29_1 === tmp0_other_with_cast.k29_1))
      return false;
    if (!(this.l29_1 === tmp0_other_with_cast.l29_1))
      return false;
    if (!(this.m29_1 == tmp0_other_with_cast.m29_1))
      return false;
    if (!(this.n29_1 == tmp0_other_with_cast.n29_1))
      return false;
    if (!this.o29_1.equals(tmp0_other_with_cast.o29_1))
      return false;
    return true;
  };
  function Companion_57() {
  }
  var Companion_instance_57;
  function Companion_getInstance_57() {
    return Companion_instance_57;
  }
  function $serializer_63() {
    $serializer_instance_62 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddWaRateCardRequest', this, 6);
    tmp0_serialDesc.gy('regionCode', false);
    tmp0_serialDesc.gy('category', false);
    tmp0_serialDesc.gy('unitCostMicros', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('effectiveFrom', false);
    tmp0_serialDesc.gy('note', true);
    this.p29_1 = tmp0_serialDesc;
  }
  protoOf($serializer_63).q29 = function (encoder, value) {
    var tmp0_desc = this.p29_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.r29_1);
    tmp1_output.hs(tmp0_desc, 1, value.s29_1);
    tmp1_output.ds(tmp0_desc, 2, value.t29_1);
    tmp1_output.hs(tmp0_desc, 3, value.u29_1);
    tmp1_output.hs(tmp0_desc, 4, value.v29_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.w29_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.w29_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_63).on = function (encoder, value) {
    return this.q29(encoder, value instanceof AddWaRateCardRequest ? value : THROW_CCE());
  };
  protoOf($serializer_63).pn = function (decoder) {
    var tmp0_desc = this.p29_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return AddWaRateCardRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_63).nn = function () {
    return this.p29_1;
  };
  protoOf($serializer_63).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_62;
  function $serializer_getInstance_62() {
    if ($serializer_instance_62 == null)
      new $serializer_63();
    return $serializer_instance_62;
  }
  function AddWaRateCardRequest_init_$Init$(seen0, regionCode, category, unitCostMicros, currency, effectiveFrom, note, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_62().p29_1);
    }
    $this.r29_1 = regionCode;
    $this.s29_1 = category;
    $this.t29_1 = unitCostMicros;
    $this.u29_1 = currency;
    $this.v29_1 = effectiveFrom;
    if (0 === (seen0 & 32))
      $this.w29_1 = null;
    else
      $this.w29_1 = note;
    return $this;
  }
  function AddWaRateCardRequest_init_$Create$(seen0, regionCode, category, unitCostMicros, currency, effectiveFrom, note, serializationConstructorMarker) {
    return AddWaRateCardRequest_init_$Init$(seen0, regionCode, category, unitCostMicros, currency, effectiveFrom, note, serializationConstructorMarker, objectCreate(protoOf(AddWaRateCardRequest)));
  }
  function AddWaRateCardRequest(regionCode, category, unitCostMicros, currency, effectiveFrom, note) {
    note = note === VOID ? null : note;
    this.r29_1 = regionCode;
    this.s29_1 = category;
    this.t29_1 = unitCostMicros;
    this.u29_1 = currency;
    this.v29_1 = effectiveFrom;
    this.w29_1 = note;
  }
  protoOf(AddWaRateCardRequest).toString = function () {
    return 'AddWaRateCardRequest(regionCode=' + this.r29_1 + ', category=' + this.s29_1 + ', unitCostMicros=' + this.t29_1.toString() + ', currency=' + this.u29_1 + ', effectiveFrom=' + this.v29_1 + ', note=' + this.w29_1 + ')';
  };
  protoOf(AddWaRateCardRequest).hashCode = function () {
    var result = getStringHashCode(this.r29_1);
    result = imul(result, 31) + getStringHashCode(this.s29_1) | 0;
    result = imul(result, 31) + this.t29_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.u29_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v29_1) | 0;
    result = imul(result, 31) + (this.w29_1 == null ? 0 : getStringHashCode(this.w29_1)) | 0;
    return result;
  };
  protoOf(AddWaRateCardRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddWaRateCardRequest))
      return false;
    var tmp0_other_with_cast = other instanceof AddWaRateCardRequest ? other : THROW_CCE();
    if (!(this.r29_1 === tmp0_other_with_cast.r29_1))
      return false;
    if (!(this.s29_1 === tmp0_other_with_cast.s29_1))
      return false;
    if (!this.t29_1.equals(tmp0_other_with_cast.t29_1))
      return false;
    if (!(this.u29_1 === tmp0_other_with_cast.u29_1))
      return false;
    if (!(this.v29_1 === tmp0_other_with_cast.v29_1))
      return false;
    if (!(this.w29_1 == tmp0_other_with_cast.w29_1))
      return false;
    return true;
  };
  function Companion_58() {
    Companion_instance_58 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x29_1 = [new ArrayListSerializer($serializer_getInstance_65()), null];
  }
  var Companion_instance_58;
  function Companion_getInstance_58() {
    if (Companion_instance_58 == null)
      new Companion_58();
    return Companion_instance_58;
  }
  function $serializer_64() {
    $serializer_instance_63 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ProtectedIdentityPageView', this, 2);
    tmp0_serialDesc.gy('items', true);
    tmp0_serialDesc.gy('nextCursor', true);
    this.y29_1 = tmp0_serialDesc;
  }
  protoOf($serializer_64).z29 = function (encoder, value) {
    var tmp0_desc = this.y29_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_58().x29_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !equals(value.a2a_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.a2a_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.b2a_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.b2a_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_64).on = function (encoder, value) {
    return this.z29(encoder, value instanceof ProtectedIdentityPageView ? value : THROW_CCE());
  };
  protoOf($serializer_64).pn = function (decoder) {
    var tmp0_desc = this.y29_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_58().x29_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return ProtectedIdentityPageView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_64).nn = function () {
    return this.y29_1;
  };
  protoOf($serializer_64).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_58().x29_1[0], get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_63;
  function $serializer_getInstance_63() {
    if ($serializer_instance_63 == null)
      new $serializer_64();
    return $serializer_instance_63;
  }
  function ProtectedIdentityPageView_init_$Init$(seen0, items, nextCursor, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_63().y29_1);
    }
    if (0 === (seen0 & 1))
      $this.a2a_1 = emptyList();
    else
      $this.a2a_1 = items;
    if (0 === (seen0 & 2))
      $this.b2a_1 = null;
    else
      $this.b2a_1 = nextCursor;
    return $this;
  }
  function ProtectedIdentityPageView_init_$Create$(seen0, items, nextCursor, serializationConstructorMarker) {
    return ProtectedIdentityPageView_init_$Init$(seen0, items, nextCursor, serializationConstructorMarker, objectCreate(protoOf(ProtectedIdentityPageView)));
  }
  function ProtectedIdentityPageView(items, nextCursor) {
    Companion_getInstance_58();
    items = items === VOID ? emptyList() : items;
    nextCursor = nextCursor === VOID ? null : nextCursor;
    this.a2a_1 = items;
    this.b2a_1 = nextCursor;
  }
  protoOf(ProtectedIdentityPageView).toString = function () {
    return 'ProtectedIdentityPageView(items=' + toString(this.a2a_1) + ', nextCursor=' + this.b2a_1 + ')';
  };
  protoOf(ProtectedIdentityPageView).hashCode = function () {
    var result = hashCode(this.a2a_1);
    result = imul(result, 31) + (this.b2a_1 == null ? 0 : getStringHashCode(this.b2a_1)) | 0;
    return result;
  };
  protoOf(ProtectedIdentityPageView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProtectedIdentityPageView))
      return false;
    var tmp0_other_with_cast = other instanceof ProtectedIdentityPageView ? other : THROW_CCE();
    if (!equals(this.a2a_1, tmp0_other_with_cast.a2a_1))
      return false;
    if (!(this.b2a_1 == tmp0_other_with_cast.b2a_1))
      return false;
    return true;
  };
  function Companion_59() {
    Companion_instance_59 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c2a_1 = [null, new ArrayListSerializer($serializer_getInstance_100())];
  }
  var Companion_instance_59;
  function Companion_getInstance_59() {
    if (Companion_instance_59 == null)
      new Companion_59();
    return Companion_instance_59;
  }
  function $serializer_65() {
    $serializer_instance_64 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ProtectionStatusView', this, 2);
    tmp0_serialDesc.gy('revision', false);
    tmp0_serialDesc.gy('tenants', true);
    this.d2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_65).e2a = function (encoder, value) {
    var tmp0_desc = this.d2a_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_59().c2a_1;
    tmp1_output.ds(tmp0_desc, 0, value.f2a_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !equals(value.g2a_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.g2a_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_65).on = function (encoder, value) {
    return this.e2a(encoder, value instanceof ProtectionStatusView ? value : THROW_CCE());
  };
  protoOf($serializer_65).pn = function (decoder) {
    var tmp0_desc = this.d2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_59().c2a_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.fr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.fr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return ProtectionStatusView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_65).nn = function () {
    return this.d2a_1;
  };
  protoOf($serializer_65).vy = function () {
    var tmp0_cached = Companion_getInstance_59().c2a_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), tmp0_cached[1]];
  };
  var $serializer_instance_64;
  function $serializer_getInstance_64() {
    if ($serializer_instance_64 == null)
      new $serializer_65();
    return $serializer_instance_64;
  }
  function ProtectionStatusView_init_$Init$(seen0, revision, tenants, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_64().d2a_1);
    }
    $this.f2a_1 = revision;
    if (0 === (seen0 & 2))
      $this.g2a_1 = emptyList();
    else
      $this.g2a_1 = tenants;
    return $this;
  }
  function ProtectionStatusView_init_$Create$(seen0, revision, tenants, serializationConstructorMarker) {
    return ProtectionStatusView_init_$Init$(seen0, revision, tenants, serializationConstructorMarker, objectCreate(protoOf(ProtectionStatusView)));
  }
  function ProtectionStatusView(revision, tenants) {
    Companion_getInstance_59();
    tenants = tenants === VOID ? emptyList() : tenants;
    this.f2a_1 = revision;
    this.g2a_1 = tenants;
  }
  protoOf(ProtectionStatusView).toString = function () {
    return 'ProtectionStatusView(revision=' + this.f2a_1.toString() + ', tenants=' + toString(this.g2a_1) + ')';
  };
  protoOf(ProtectionStatusView).hashCode = function () {
    var result = this.f2a_1.hashCode();
    result = imul(result, 31) + hashCode(this.g2a_1) | 0;
    return result;
  };
  protoOf(ProtectionStatusView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProtectionStatusView))
      return false;
    var tmp0_other_with_cast = other instanceof ProtectionStatusView ? other : THROW_CCE();
    if (!this.f2a_1.equals(tmp0_other_with_cast.f2a_1))
      return false;
    if (!equals(this.g2a_1, tmp0_other_with_cast.g2a_1))
      return false;
    return true;
  };
  function Companion_60() {
  }
  var Companion_instance_60;
  function Companion_getInstance_60() {
    return Companion_instance_60;
  }
  function $serializer_66() {
    $serializer_instance_65 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ProtectedIdentityView', this, 10);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('value', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('active', false);
    tmp0_serialDesc.gy('epoch', false);
    tmp0_serialDesc.gy('createdBy', false);
    tmp0_serialDesc.gy('updatedBy', false);
    tmp0_serialDesc.gy('createdAt', false);
    tmp0_serialDesc.gy('updatedAt', false);
    this.h2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_66).i2a = function (encoder, value) {
    var tmp0_desc = this.h2a_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.j2a_1);
    tmp1_output.hs(tmp0_desc, 1, value.k2a_1);
    tmp1_output.hs(tmp0_desc, 2, value.l2a_1);
    tmp1_output.hs(tmp0_desc, 3, value.m2a_1);
    tmp1_output.zr(tmp0_desc, 4, value.n2a_1);
    tmp1_output.cs(tmp0_desc, 5, value.o2a_1);
    tmp1_output.hs(tmp0_desc, 6, value.p2a_1);
    tmp1_output.hs(tmp0_desc, 7, value.q2a_1);
    tmp1_output.hs(tmp0_desc, 8, value.r2a_1);
    tmp1_output.hs(tmp0_desc, 9, value.s2a_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_66).on = function (encoder, value) {
    return this.i2a(encoder, value instanceof ProtectedIdentityView ? value : THROW_CCE());
  };
  protoOf($serializer_66).pn = function (decoder) {
    var tmp0_desc = this.h2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.tq(tmp0_desc);
    if (tmp14_input.ir()) {
      tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.dr(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.dr(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.uq(tmp0_desc);
    return ProtectedIdentityView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_66).nn = function () {
    return this.h2a_1;
  };
  protoOf($serializer_66).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_65;
  function $serializer_getInstance_65() {
    if ($serializer_instance_65 == null)
      new $serializer_66();
    return $serializer_instance_65;
  }
  function ProtectedIdentityView_init_$Init$(seen0, id, kind, value, reason, active, epoch, createdBy, updatedBy, createdAt, updatedAt, serializationConstructorMarker, $this) {
    if (!(1023 === (1023 & seen0))) {
      throwMissingFieldException(seen0, 1023, $serializer_getInstance_65().h2a_1);
    }
    $this.j2a_1 = id;
    $this.k2a_1 = kind;
    $this.l2a_1 = value;
    $this.m2a_1 = reason;
    $this.n2a_1 = active;
    $this.o2a_1 = epoch;
    $this.p2a_1 = createdBy;
    $this.q2a_1 = updatedBy;
    $this.r2a_1 = createdAt;
    $this.s2a_1 = updatedAt;
    return $this;
  }
  function ProtectedIdentityView_init_$Create$(seen0, id, kind, value, reason, active, epoch, createdBy, updatedBy, createdAt, updatedAt, serializationConstructorMarker) {
    return ProtectedIdentityView_init_$Init$(seen0, id, kind, value, reason, active, epoch, createdBy, updatedBy, createdAt, updatedAt, serializationConstructorMarker, objectCreate(protoOf(ProtectedIdentityView)));
  }
  function ProtectedIdentityView(id, kind, value, reason, active, epoch, createdBy, updatedBy, createdAt, updatedAt) {
    this.j2a_1 = id;
    this.k2a_1 = kind;
    this.l2a_1 = value;
    this.m2a_1 = reason;
    this.n2a_1 = active;
    this.o2a_1 = epoch;
    this.p2a_1 = createdBy;
    this.q2a_1 = updatedBy;
    this.r2a_1 = createdAt;
    this.s2a_1 = updatedAt;
  }
  protoOf(ProtectedIdentityView).toString = function () {
    return 'ProtectedIdentityView(id=' + this.j2a_1 + ', kind=' + this.k2a_1 + ', value=' + this.l2a_1 + ', reason=' + this.m2a_1 + ', active=' + this.n2a_1 + ', epoch=' + this.o2a_1 + ', createdBy=' + this.p2a_1 + ', updatedBy=' + this.q2a_1 + ', createdAt=' + this.r2a_1 + ', updatedAt=' + this.s2a_1 + ')';
  };
  protoOf(ProtectedIdentityView).hashCode = function () {
    var result = getStringHashCode(this.j2a_1);
    result = imul(result, 31) + getStringHashCode(this.k2a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l2a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2a_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n2a_1) | 0;
    result = imul(result, 31) + this.o2a_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.p2a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q2a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r2a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s2a_1) | 0;
    return result;
  };
  protoOf(ProtectedIdentityView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProtectedIdentityView))
      return false;
    var tmp0_other_with_cast = other instanceof ProtectedIdentityView ? other : THROW_CCE();
    if (!(this.j2a_1 === tmp0_other_with_cast.j2a_1))
      return false;
    if (!(this.k2a_1 === tmp0_other_with_cast.k2a_1))
      return false;
    if (!(this.l2a_1 === tmp0_other_with_cast.l2a_1))
      return false;
    if (!(this.m2a_1 === tmp0_other_with_cast.m2a_1))
      return false;
    if (!(this.n2a_1 === tmp0_other_with_cast.n2a_1))
      return false;
    if (!(this.o2a_1 === tmp0_other_with_cast.o2a_1))
      return false;
    if (!(this.p2a_1 === tmp0_other_with_cast.p2a_1))
      return false;
    if (!(this.q2a_1 === tmp0_other_with_cast.q2a_1))
      return false;
    if (!(this.r2a_1 === tmp0_other_with_cast.r2a_1))
      return false;
    if (!(this.s2a_1 === tmp0_other_with_cast.s2a_1))
      return false;
    return true;
  };
  function Companion_61() {
  }
  var Companion_instance_61;
  function Companion_getInstance_61() {
    return Companion_instance_61;
  }
  function $serializer_67() {
    $serializer_instance_66 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AddProtectedIdentityRequest', this, 4);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('value', false);
    tmp0_serialDesc.gy('countryCode', true);
    tmp0_serialDesc.gy('reason', false);
    this.t2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_67).u2a = function (encoder, value) {
    var tmp0_desc = this.t2a_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.v2a_1);
    tmp1_output.hs(tmp0_desc, 1, value.w2a_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.x2a_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.x2a_1);
    }
    tmp1_output.hs(tmp0_desc, 3, value.y2a_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_67).on = function (encoder, value) {
    return this.u2a(encoder, value instanceof AddProtectedIdentityRequest ? value : THROW_CCE());
  };
  protoOf($serializer_67).pn = function (decoder) {
    var tmp0_desc = this.t2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return AddProtectedIdentityRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_67).nn = function () {
    return this.t2a_1;
  };
  protoOf($serializer_67).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance()];
  };
  var $serializer_instance_66;
  function $serializer_getInstance_66() {
    if ($serializer_instance_66 == null)
      new $serializer_67();
    return $serializer_instance_66;
  }
  function AddProtectedIdentityRequest_init_$Init$(seen0, kind, value, countryCode, reason, serializationConstructorMarker, $this) {
    if (!(11 === (11 & seen0))) {
      throwMissingFieldException(seen0, 11, $serializer_getInstance_66().t2a_1);
    }
    $this.v2a_1 = kind;
    $this.w2a_1 = value;
    if (0 === (seen0 & 4))
      $this.x2a_1 = null;
    else
      $this.x2a_1 = countryCode;
    $this.y2a_1 = reason;
    return $this;
  }
  function AddProtectedIdentityRequest_init_$Create$(seen0, kind, value, countryCode, reason, serializationConstructorMarker) {
    return AddProtectedIdentityRequest_init_$Init$(seen0, kind, value, countryCode, reason, serializationConstructorMarker, objectCreate(protoOf(AddProtectedIdentityRequest)));
  }
  function AddProtectedIdentityRequest(kind, value, countryCode, reason) {
    countryCode = countryCode === VOID ? null : countryCode;
    this.v2a_1 = kind;
    this.w2a_1 = value;
    this.x2a_1 = countryCode;
    this.y2a_1 = reason;
  }
  protoOf(AddProtectedIdentityRequest).toString = function () {
    return 'AddProtectedIdentityRequest(kind=' + this.v2a_1 + ', value=' + this.w2a_1 + ', countryCode=' + this.x2a_1 + ', reason=' + this.y2a_1 + ')';
  };
  protoOf(AddProtectedIdentityRequest).hashCode = function () {
    var result = getStringHashCode(this.v2a_1);
    result = imul(result, 31) + getStringHashCode(this.w2a_1) | 0;
    result = imul(result, 31) + (this.x2a_1 == null ? 0 : getStringHashCode(this.x2a_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2a_1) | 0;
    return result;
  };
  protoOf(AddProtectedIdentityRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AddProtectedIdentityRequest))
      return false;
    var tmp0_other_with_cast = other instanceof AddProtectedIdentityRequest ? other : THROW_CCE();
    if (!(this.v2a_1 === tmp0_other_with_cast.v2a_1))
      return false;
    if (!(this.w2a_1 === tmp0_other_with_cast.w2a_1))
      return false;
    if (!(this.x2a_1 == tmp0_other_with_cast.x2a_1))
      return false;
    if (!(this.y2a_1 === tmp0_other_with_cast.y2a_1))
      return false;
    return true;
  };
  function Companion_62() {
  }
  var Companion_instance_62;
  function Companion_getInstance_62() {
    return Companion_instance_62;
  }
  function $serializer_68() {
    $serializer_instance_67 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ChangeProtectedIdentityRequest', this, 2);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('expectedRevision', true);
    this.z2a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_68).a2b = function (encoder, value) {
    var tmp0_desc = this.z2a_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.b2b_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.c2b_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.c2b_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_68).on = function (encoder, value) {
    return this.a2b(encoder, value instanceof ChangeProtectedIdentityRequest ? value : THROW_CCE());
  };
  protoOf($serializer_68).pn = function (decoder) {
    var tmp0_desc = this.z2a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return ChangeProtectedIdentityRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_68).nn = function () {
    return this.z2a_1;
  };
  protoOf($serializer_68).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_67;
  function $serializer_getInstance_67() {
    if ($serializer_instance_67 == null)
      new $serializer_68();
    return $serializer_instance_67;
  }
  function ChangeProtectedIdentityRequest_init_$Init$(seen0, reason, expectedRevision, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_67().z2a_1);
    }
    $this.b2b_1 = reason;
    if (0 === (seen0 & 2))
      $this.c2b_1 = null;
    else
      $this.c2b_1 = expectedRevision;
    return $this;
  }
  function ChangeProtectedIdentityRequest_init_$Create$(seen0, reason, expectedRevision, serializationConstructorMarker) {
    return ChangeProtectedIdentityRequest_init_$Init$(seen0, reason, expectedRevision, serializationConstructorMarker, objectCreate(protoOf(ChangeProtectedIdentityRequest)));
  }
  function ChangeProtectedIdentityRequest(reason, expectedRevision) {
    expectedRevision = expectedRevision === VOID ? null : expectedRevision;
    this.b2b_1 = reason;
    this.c2b_1 = expectedRevision;
  }
  protoOf(ChangeProtectedIdentityRequest).toString = function () {
    return 'ChangeProtectedIdentityRequest(reason=' + this.b2b_1 + ', expectedRevision=' + toString_0(this.c2b_1) + ')';
  };
  protoOf(ChangeProtectedIdentityRequest).hashCode = function () {
    var result = getStringHashCode(this.b2b_1);
    result = imul(result, 31) + (this.c2b_1 == null ? 0 : this.c2b_1.hashCode()) | 0;
    return result;
  };
  protoOf(ChangeProtectedIdentityRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangeProtectedIdentityRequest))
      return false;
    var tmp0_other_with_cast = other instanceof ChangeProtectedIdentityRequest ? other : THROW_CCE();
    if (!(this.b2b_1 === tmp0_other_with_cast.b2b_1))
      return false;
    if (!equals(this.c2b_1, tmp0_other_with_cast.c2b_1))
      return false;
    return true;
  };
  function Companion_63() {
  }
  var Companion_instance_63;
  function Companion_getInstance_63() {
    return Companion_instance_63;
  }
  function $serializer_69() {
    $serializer_instance_68 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CapabilityEvidenceView', this, 14);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('channel', false);
    tmp0_serialDesc.gy('capability', false);
    tmp0_serialDesc.gy('valueJson', false);
    tmp0_serialDesc.gy('market', false);
    tmp0_serialDesc.gy('accountKind', false);
    tmp0_serialDesc.gy('sourceKind', false);
    tmp0_serialDesc.gy('sourceRef', false);
    tmp0_serialDesc.gy('verifiedAt', false);
    tmp0_serialDesc.gy('recheckBy', false);
    tmp0_serialDesc.gy('current', false);
    tmp0_serialDesc.gy('daysLeft', false);
    tmp0_serialDesc.gy('verifiedBy', true);
    tmp0_serialDesc.gy('note', true);
    this.d2b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_69).e2b = function (encoder, value) {
    var tmp0_desc = this.d2b_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.f2b_1);
    tmp1_output.hs(tmp0_desc, 1, value.g2b_1);
    tmp1_output.hs(tmp0_desc, 2, value.h2b_1);
    tmp1_output.hs(tmp0_desc, 3, value.i2b_1);
    tmp1_output.hs(tmp0_desc, 4, value.j2b_1);
    tmp1_output.hs(tmp0_desc, 5, value.k2b_1);
    tmp1_output.hs(tmp0_desc, 6, value.l2b_1);
    tmp1_output.hs(tmp0_desc, 7, value.m2b_1);
    tmp1_output.ds(tmp0_desc, 8, value.n2b_1);
    tmp1_output.ds(tmp0_desc, 9, value.o2b_1);
    tmp1_output.zr(tmp0_desc, 10, value.p2b_1);
    tmp1_output.ds(tmp0_desc, 11, value.q2b_1);
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.r2b_1 == null)) {
      tmp1_output.ls(tmp0_desc, 12, StringSerializer_getInstance(), value.r2b_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.s2b_1 == null)) {
      tmp1_output.ls(tmp0_desc, 13, StringSerializer_getInstance(), value.s2b_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_69).on = function (encoder, value) {
    return this.e2b(encoder, value instanceof CapabilityEvidenceView ? value : THROW_CCE());
  };
  protoOf($serializer_69).pn = function (decoder) {
    var tmp0_desc = this.d2b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = new Long(0, 0);
    var tmp14_local10 = false;
    var tmp15_local11 = new Long(0, 0);
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_input = decoder.tq(tmp0_desc);
    if (tmp18_input.ir()) {
      tmp4_local0 = tmp18_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp18_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp18_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp18_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp18_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp18_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp18_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp18_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp18_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp18_input.zq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp18_input.vq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp18_input.zq(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp18_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp18_input.hr(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp18_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp18_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp18_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp18_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp18_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp18_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp18_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp18_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp18_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp18_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp18_input.zq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp18_input.vq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp18_input.zq(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp18_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp18_input.hr(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp18_input.uq(tmp0_desc);
    return CapabilityEvidenceView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
  };
  protoOf($serializer_69).nn = function () {
    return this.d2b_1;
  };
  protoOf($serializer_69).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_68;
  function $serializer_getInstance_68() {
    if ($serializer_instance_68 == null)
      new $serializer_69();
    return $serializer_instance_68;
  }
  function CapabilityEvidenceView_init_$Init$(seen0, id, channel, capability, valueJson, market, accountKind, sourceKind, sourceRef, verifiedAt, recheckBy, current, daysLeft, verifiedBy, note, serializationConstructorMarker, $this) {
    if (!(4095 === (4095 & seen0))) {
      throwMissingFieldException(seen0, 4095, $serializer_getInstance_68().d2b_1);
    }
    $this.f2b_1 = id;
    $this.g2b_1 = channel;
    $this.h2b_1 = capability;
    $this.i2b_1 = valueJson;
    $this.j2b_1 = market;
    $this.k2b_1 = accountKind;
    $this.l2b_1 = sourceKind;
    $this.m2b_1 = sourceRef;
    $this.n2b_1 = verifiedAt;
    $this.o2b_1 = recheckBy;
    $this.p2b_1 = current;
    $this.q2b_1 = daysLeft;
    if (0 === (seen0 & 4096))
      $this.r2b_1 = null;
    else
      $this.r2b_1 = verifiedBy;
    if (0 === (seen0 & 8192))
      $this.s2b_1 = null;
    else
      $this.s2b_1 = note;
    return $this;
  }
  function CapabilityEvidenceView_init_$Create$(seen0, id, channel, capability, valueJson, market, accountKind, sourceKind, sourceRef, verifiedAt, recheckBy, current, daysLeft, verifiedBy, note, serializationConstructorMarker) {
    return CapabilityEvidenceView_init_$Init$(seen0, id, channel, capability, valueJson, market, accountKind, sourceKind, sourceRef, verifiedAt, recheckBy, current, daysLeft, verifiedBy, note, serializationConstructorMarker, objectCreate(protoOf(CapabilityEvidenceView)));
  }
  function CapabilityEvidenceView(id, channel, capability, valueJson, market, accountKind, sourceKind, sourceRef, verifiedAt, recheckBy, current, daysLeft, verifiedBy, note) {
    verifiedBy = verifiedBy === VOID ? null : verifiedBy;
    note = note === VOID ? null : note;
    this.f2b_1 = id;
    this.g2b_1 = channel;
    this.h2b_1 = capability;
    this.i2b_1 = valueJson;
    this.j2b_1 = market;
    this.k2b_1 = accountKind;
    this.l2b_1 = sourceKind;
    this.m2b_1 = sourceRef;
    this.n2b_1 = verifiedAt;
    this.o2b_1 = recheckBy;
    this.p2b_1 = current;
    this.q2b_1 = daysLeft;
    this.r2b_1 = verifiedBy;
    this.s2b_1 = note;
  }
  protoOf(CapabilityEvidenceView).toString = function () {
    return 'CapabilityEvidenceView(id=' + this.f2b_1 + ', channel=' + this.g2b_1 + ', capability=' + this.h2b_1 + ', valueJson=' + this.i2b_1 + ', market=' + this.j2b_1 + ', accountKind=' + this.k2b_1 + ', sourceKind=' + this.l2b_1 + ', sourceRef=' + this.m2b_1 + ', verifiedAt=' + this.n2b_1.toString() + ', recheckBy=' + this.o2b_1.toString() + ', current=' + this.p2b_1 + ', daysLeft=' + this.q2b_1.toString() + ', verifiedBy=' + this.r2b_1 + ', note=' + this.s2b_1 + ')';
  };
  protoOf(CapabilityEvidenceView).hashCode = function () {
    var result = getStringHashCode(this.f2b_1);
    result = imul(result, 31) + getStringHashCode(this.g2b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h2b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i2b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j2b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l2b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2b_1) | 0;
    result = imul(result, 31) + this.n2b_1.hashCode() | 0;
    result = imul(result, 31) + this.o2b_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p2b_1) | 0;
    result = imul(result, 31) + this.q2b_1.hashCode() | 0;
    result = imul(result, 31) + (this.r2b_1 == null ? 0 : getStringHashCode(this.r2b_1)) | 0;
    result = imul(result, 31) + (this.s2b_1 == null ? 0 : getStringHashCode(this.s2b_1)) | 0;
    return result;
  };
  protoOf(CapabilityEvidenceView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CapabilityEvidenceView))
      return false;
    var tmp0_other_with_cast = other instanceof CapabilityEvidenceView ? other : THROW_CCE();
    if (!(this.f2b_1 === tmp0_other_with_cast.f2b_1))
      return false;
    if (!(this.g2b_1 === tmp0_other_with_cast.g2b_1))
      return false;
    if (!(this.h2b_1 === tmp0_other_with_cast.h2b_1))
      return false;
    if (!(this.i2b_1 === tmp0_other_with_cast.i2b_1))
      return false;
    if (!(this.j2b_1 === tmp0_other_with_cast.j2b_1))
      return false;
    if (!(this.k2b_1 === tmp0_other_with_cast.k2b_1))
      return false;
    if (!(this.l2b_1 === tmp0_other_with_cast.l2b_1))
      return false;
    if (!(this.m2b_1 === tmp0_other_with_cast.m2b_1))
      return false;
    if (!this.n2b_1.equals(tmp0_other_with_cast.n2b_1))
      return false;
    if (!this.o2b_1.equals(tmp0_other_with_cast.o2b_1))
      return false;
    if (!(this.p2b_1 === tmp0_other_with_cast.p2b_1))
      return false;
    if (!this.q2b_1.equals(tmp0_other_with_cast.q2b_1))
      return false;
    if (!(this.r2b_1 == tmp0_other_with_cast.r2b_1))
      return false;
    if (!(this.s2b_1 == tmp0_other_with_cast.s2b_1))
      return false;
    return true;
  };
  function Companion_64() {
  }
  var Companion_instance_64;
  function Companion_getInstance_64() {
    return Companion_instance_64;
  }
  function $serializer_70() {
    $serializer_instance_69 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ReverifyCapabilityRequest', this, 3);
    tmp0_serialDesc.gy('sourceKind', false);
    tmp0_serialDesc.gy('sourceRef', false);
    tmp0_serialDesc.gy('note', true);
    this.t2b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_70).u2b = function (encoder, value) {
    var tmp0_desc = this.t2b_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.v2b_1);
    tmp1_output.hs(tmp0_desc, 1, value.w2b_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.x2b_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.x2b_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_70).on = function (encoder, value) {
    return this.u2b(encoder, value instanceof ReverifyCapabilityRequest ? value : THROW_CCE());
  };
  protoOf($serializer_70).pn = function (decoder) {
    var tmp0_desc = this.t2b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return ReverifyCapabilityRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_70).nn = function () {
    return this.t2b_1;
  };
  protoOf($serializer_70).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_69;
  function $serializer_getInstance_69() {
    if ($serializer_instance_69 == null)
      new $serializer_70();
    return $serializer_instance_69;
  }
  function ReverifyCapabilityRequest_init_$Init$(seen0, sourceKind, sourceRef, note, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_69().t2b_1);
    }
    $this.v2b_1 = sourceKind;
    $this.w2b_1 = sourceRef;
    if (0 === (seen0 & 4))
      $this.x2b_1 = null;
    else
      $this.x2b_1 = note;
    return $this;
  }
  function ReverifyCapabilityRequest_init_$Create$(seen0, sourceKind, sourceRef, note, serializationConstructorMarker) {
    return ReverifyCapabilityRequest_init_$Init$(seen0, sourceKind, sourceRef, note, serializationConstructorMarker, objectCreate(protoOf(ReverifyCapabilityRequest)));
  }
  function ReverifyCapabilityRequest(sourceKind, sourceRef, note) {
    note = note === VOID ? null : note;
    this.v2b_1 = sourceKind;
    this.w2b_1 = sourceRef;
    this.x2b_1 = note;
  }
  protoOf(ReverifyCapabilityRequest).toString = function () {
    return 'ReverifyCapabilityRequest(sourceKind=' + this.v2b_1 + ', sourceRef=' + this.w2b_1 + ', note=' + this.x2b_1 + ')';
  };
  protoOf(ReverifyCapabilityRequest).hashCode = function () {
    var result = getStringHashCode(this.v2b_1);
    result = imul(result, 31) + getStringHashCode(this.w2b_1) | 0;
    result = imul(result, 31) + (this.x2b_1 == null ? 0 : getStringHashCode(this.x2b_1)) | 0;
    return result;
  };
  protoOf(ReverifyCapabilityRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReverifyCapabilityRequest))
      return false;
    var tmp0_other_with_cast = other instanceof ReverifyCapabilityRequest ? other : THROW_CCE();
    if (!(this.v2b_1 === tmp0_other_with_cast.v2b_1))
      return false;
    if (!(this.w2b_1 === tmp0_other_with_cast.w2b_1))
      return false;
    if (!(this.x2b_1 == tmp0_other_with_cast.x2b_1))
      return false;
    return true;
  };
  function Companion_65() {
    Companion_instance_65 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y2b_1 = [new ArrayListSerializer($serializer_getInstance_89()), new ArrayListSerializer($serializer_getInstance_89()), new ArrayListSerializer($serializer_getInstance_95())];
  }
  var Companion_instance_65;
  function Companion_getInstance_65() {
    if (Companion_instance_65 == null)
      new Companion_65();
    return Companion_instance_65;
  }
  function $serializer_71() {
    $serializer_instance_70 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionQueue', this, 3);
    tmp0_serialDesc.gy('renewalsDue', false);
    tmp0_serialDesc.gy('trialsExpiring', false);
    tmp0_serialDesc.gy('overdue', false);
    this.z2b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_71).a2c = function (encoder, value) {
    var tmp0_desc = this.z2b_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_65().y2b_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.b2c_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.c2c_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.d2c_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_71).on = function (encoder, value) {
    return this.a2c(encoder, value instanceof SubscriptionQueue ? value : THROW_CCE());
  };
  protoOf($serializer_71).pn = function (decoder) {
    var tmp0_desc = this.z2b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_65().y2b_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return SubscriptionQueue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_71).nn = function () {
    return this.z2b_1;
  };
  protoOf($serializer_71).vy = function () {
    var tmp0_cached = Companion_getInstance_65().y2b_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2]];
  };
  var $serializer_instance_70;
  function $serializer_getInstance_70() {
    if ($serializer_instance_70 == null)
      new $serializer_71();
    return $serializer_instance_70;
  }
  function SubscriptionQueue_init_$Init$(seen0, renewalsDue, trialsExpiring, overdue, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_70().z2b_1);
    }
    $this.b2c_1 = renewalsDue;
    $this.c2c_1 = trialsExpiring;
    $this.d2c_1 = overdue;
    return $this;
  }
  function SubscriptionQueue_init_$Create$(seen0, renewalsDue, trialsExpiring, overdue, serializationConstructorMarker) {
    return SubscriptionQueue_init_$Init$(seen0, renewalsDue, trialsExpiring, overdue, serializationConstructorMarker, objectCreate(protoOf(SubscriptionQueue)));
  }
  function SubscriptionQueue(renewalsDue, trialsExpiring, overdue) {
    Companion_getInstance_65();
    this.b2c_1 = renewalsDue;
    this.c2c_1 = trialsExpiring;
    this.d2c_1 = overdue;
  }
  protoOf(SubscriptionQueue).toString = function () {
    return 'SubscriptionQueue(renewalsDue=' + toString(this.b2c_1) + ', trialsExpiring=' + toString(this.c2c_1) + ', overdue=' + toString(this.d2c_1) + ')';
  };
  protoOf(SubscriptionQueue).hashCode = function () {
    var result = hashCode(this.b2c_1);
    result = imul(result, 31) + hashCode(this.c2c_1) | 0;
    result = imul(result, 31) + hashCode(this.d2c_1) | 0;
    return result;
  };
  protoOf(SubscriptionQueue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionQueue))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionQueue ? other : THROW_CCE();
    if (!equals(this.b2c_1, tmp0_other_with_cast.b2c_1))
      return false;
    if (!equals(this.c2c_1, tmp0_other_with_cast.c2c_1))
      return false;
    if (!equals(this.d2c_1, tmp0_other_with_cast.d2c_1))
      return false;
    return true;
  };
  function Companion_66() {
    Companion_instance_66 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2c_1 = [null, null, new ArrayListSerializer($serializer_getInstance_96()), new ArrayListSerializer($serializer_getInstance_34())];
  }
  var Companion_instance_66;
  function Companion_getInstance_66() {
    if (Companion_instance_66 == null)
      new Companion_66();
    return Companion_instance_66;
  }
  function $serializer_72() {
    $serializer_instance_71 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UsageOverview', this, 4);
    tmp0_serialDesc.gy('periodStartMs', false);
    tmp0_serialDesc.gy('periodEndMs', false);
    tmp0_serialDesc.gy('perLimit', false);
    tmp0_serialDesc.gy('recurringRevenue', true);
    this.f2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_72).g2c = function (encoder, value) {
    var tmp0_desc = this.f2c_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_66().e2c_1;
    tmp1_output.ds(tmp0_desc, 0, value.h2c_1);
    tmp1_output.ds(tmp0_desc, 1, value.i2c_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.j2c_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !equals(value.k2c_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.k2c_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_72).on = function (encoder, value) {
    return this.g2c(encoder, value instanceof UsageOverview ? value : THROW_CCE());
  };
  protoOf($serializer_72).pn = function (decoder) {
    var tmp0_desc = this.f2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_66().e2c_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return UsageOverview_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_72).nn = function () {
    return this.f2c_1;
  };
  protoOf($serializer_72).vy = function () {
    var tmp0_cached = Companion_getInstance_66().e2c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[2], tmp0_cached[3]];
  };
  var $serializer_instance_71;
  function $serializer_getInstance_71() {
    if ($serializer_instance_71 == null)
      new $serializer_72();
    return $serializer_instance_71;
  }
  function UsageOverview_init_$Init$(seen0, periodStartMs, periodEndMs, perLimit, recurringRevenue, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_71().f2c_1);
    }
    $this.h2c_1 = periodStartMs;
    $this.i2c_1 = periodEndMs;
    $this.j2c_1 = perLimit;
    if (0 === (seen0 & 8))
      $this.k2c_1 = emptyList();
    else
      $this.k2c_1 = recurringRevenue;
    return $this;
  }
  function UsageOverview_init_$Create$(seen0, periodStartMs, periodEndMs, perLimit, recurringRevenue, serializationConstructorMarker) {
    return UsageOverview_init_$Init$(seen0, periodStartMs, periodEndMs, perLimit, recurringRevenue, serializationConstructorMarker, objectCreate(protoOf(UsageOverview)));
  }
  function UsageOverview(periodStartMs, periodEndMs, perLimit, recurringRevenue) {
    Companion_getInstance_66();
    recurringRevenue = recurringRevenue === VOID ? emptyList() : recurringRevenue;
    this.h2c_1 = periodStartMs;
    this.i2c_1 = periodEndMs;
    this.j2c_1 = perLimit;
    this.k2c_1 = recurringRevenue;
  }
  protoOf(UsageOverview).toString = function () {
    return 'UsageOverview(periodStartMs=' + this.h2c_1.toString() + ', periodEndMs=' + this.i2c_1.toString() + ', perLimit=' + toString(this.j2c_1) + ', recurringRevenue=' + toString(this.k2c_1) + ')';
  };
  protoOf(UsageOverview).hashCode = function () {
    var result = this.h2c_1.hashCode();
    result = imul(result, 31) + this.i2c_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.j2c_1) | 0;
    result = imul(result, 31) + hashCode(this.k2c_1) | 0;
    return result;
  };
  protoOf(UsageOverview).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UsageOverview))
      return false;
    var tmp0_other_with_cast = other instanceof UsageOverview ? other : THROW_CCE();
    if (!this.h2c_1.equals(tmp0_other_with_cast.h2c_1))
      return false;
    if (!this.i2c_1.equals(tmp0_other_with_cast.i2c_1))
      return false;
    if (!equals(this.j2c_1, tmp0_other_with_cast.j2c_1))
      return false;
    if (!equals(this.k2c_1, tmp0_other_with_cast.k2c_1))
      return false;
    return true;
  };
  function $serializer_73() {
    $serializer_instance_72 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LegacyProvisioningRetryReceipt', this, 2);
    tmp0_serialDesc.gy('operationId', false);
    tmp0_serialDesc.gy('originalJobId', false);
    this.l2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_73).m2c = function (encoder, value) {
    var tmp0_desc = this.l2c_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.n2c_1);
    tmp1_output.hs(tmp0_desc, 1, value.o2c_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_73).on = function (encoder, value) {
    return this.m2c(encoder, value instanceof LegacyProvisioningRetryReceipt ? value : THROW_CCE());
  };
  protoOf($serializer_73).pn = function (decoder) {
    var tmp0_desc = this.l2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return LegacyProvisioningRetryReceipt_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_73).nn = function () {
    return this.l2c_1;
  };
  protoOf($serializer_73).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_72;
  function $serializer_getInstance_72() {
    if ($serializer_instance_72 == null)
      new $serializer_73();
    return $serializer_instance_72;
  }
  function LegacyProvisioningRetryReceipt_init_$Init$(seen0, operationId, originalJobId, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_72().l2c_1);
    }
    $this.n2c_1 = operationId;
    $this.o2c_1 = originalJobId;
    return $this;
  }
  function LegacyProvisioningRetryReceipt_init_$Create$(seen0, operationId, originalJobId, serializationConstructorMarker) {
    return LegacyProvisioningRetryReceipt_init_$Init$(seen0, operationId, originalJobId, serializationConstructorMarker, objectCreate(protoOf(LegacyProvisioningRetryReceipt)));
  }
  function LegacyProvisioningRetryReceipt() {
  }
  protoOf(LegacyProvisioningRetryReceipt).toString = function () {
    return 'LegacyProvisioningRetryReceipt(operationId=' + this.n2c_1 + ', originalJobId=' + this.o2c_1 + ')';
  };
  protoOf(LegacyProvisioningRetryReceipt).hashCode = function () {
    var result = getStringHashCode(this.n2c_1);
    result = imul(result, 31) + getStringHashCode(this.o2c_1) | 0;
    return result;
  };
  protoOf(LegacyProvisioningRetryReceipt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LegacyProvisioningRetryReceipt))
      return false;
    var tmp0_other_with_cast = other instanceof LegacyProvisioningRetryReceipt ? other : THROW_CCE();
    if (!(this.n2c_1 === tmp0_other_with_cast.n2c_1))
      return false;
    if (!(this.o2c_1 === tmp0_other_with_cast.o2c_1))
      return false;
    return true;
  };
  function Companion_67() {
  }
  var Companion_instance_67;
  function Companion_getInstance_67() {
    return Companion_instance_67;
  }
  function $serializer_74() {
    $serializer_instance_73 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AuditEntry', this, 10);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('actorEmail', false);
    tmp0_serialDesc.gy('actorRole', false);
    tmp0_serialDesc.gy('action', false);
    tmp0_serialDesc.gy('targetTenantId', false);
    tmp0_serialDesc.gy('targetType', false);
    tmp0_serialDesc.gy('targetId', false);
    tmp0_serialDesc.gy('beforeJson', false);
    tmp0_serialDesc.gy('afterJson', false);
    tmp0_serialDesc.gy('atMs', false);
    this.p2c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_74).q2c = function (encoder, value) {
    var tmp0_desc = this.p2c_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.r2c_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.s2c_1);
    tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.t2c_1);
    tmp1_output.hs(tmp0_desc, 3, value.u2c_1);
    tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.v2c_1);
    tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.w2c_1);
    tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.x2c_1);
    tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.y2c_1);
    tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.z2c_1);
    tmp1_output.ds(tmp0_desc, 9, value.a2d_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_74).on = function (encoder, value) {
    return this.q2c(encoder, value instanceof AuditEntry ? value : THROW_CCE());
  };
  protoOf($serializer_74).pn = function (decoder) {
    var tmp0_desc = this.p2c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = new Long(0, 0);
    var tmp14_input = decoder.tq(tmp0_desc);
    if (tmp14_input.ir()) {
      tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.zq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.zq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.uq(tmp0_desc);
    return AuditEntry_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_74).nn = function () {
    return this.p2c_1;
  };
  protoOf($serializer_74).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance()];
  };
  var $serializer_instance_73;
  function $serializer_getInstance_73() {
    if ($serializer_instance_73 == null)
      new $serializer_74();
    return $serializer_instance_73;
  }
  function AuditEntry_init_$Init$(seen0, id, actorEmail, actorRole, action, targetTenantId, targetType, targetId, beforeJson, afterJson, atMs, serializationConstructorMarker, $this) {
    if (!(1023 === (1023 & seen0))) {
      throwMissingFieldException(seen0, 1023, $serializer_getInstance_73().p2c_1);
    }
    $this.r2c_1 = id;
    $this.s2c_1 = actorEmail;
    $this.t2c_1 = actorRole;
    $this.u2c_1 = action;
    $this.v2c_1 = targetTenantId;
    $this.w2c_1 = targetType;
    $this.x2c_1 = targetId;
    $this.y2c_1 = beforeJson;
    $this.z2c_1 = afterJson;
    $this.a2d_1 = atMs;
    return $this;
  }
  function AuditEntry_init_$Create$(seen0, id, actorEmail, actorRole, action, targetTenantId, targetType, targetId, beforeJson, afterJson, atMs, serializationConstructorMarker) {
    return AuditEntry_init_$Init$(seen0, id, actorEmail, actorRole, action, targetTenantId, targetType, targetId, beforeJson, afterJson, atMs, serializationConstructorMarker, objectCreate(protoOf(AuditEntry)));
  }
  function AuditEntry(id, actorEmail, actorRole, action, targetTenantId, targetType, targetId, beforeJson, afterJson, atMs) {
    this.r2c_1 = id;
    this.s2c_1 = actorEmail;
    this.t2c_1 = actorRole;
    this.u2c_1 = action;
    this.v2c_1 = targetTenantId;
    this.w2c_1 = targetType;
    this.x2c_1 = targetId;
    this.y2c_1 = beforeJson;
    this.z2c_1 = afterJson;
    this.a2d_1 = atMs;
  }
  protoOf(AuditEntry).toString = function () {
    return 'AuditEntry(id=' + this.r2c_1 + ', actorEmail=' + this.s2c_1 + ', actorRole=' + this.t2c_1 + ', action=' + this.u2c_1 + ', targetTenantId=' + this.v2c_1 + ', targetType=' + this.w2c_1 + ', targetId=' + this.x2c_1 + ', beforeJson=' + this.y2c_1 + ', afterJson=' + this.z2c_1 + ', atMs=' + this.a2d_1.toString() + ')';
  };
  protoOf(AuditEntry).hashCode = function () {
    var result = getStringHashCode(this.r2c_1);
    result = imul(result, 31) + (this.s2c_1 == null ? 0 : getStringHashCode(this.s2c_1)) | 0;
    result = imul(result, 31) + (this.t2c_1 == null ? 0 : getStringHashCode(this.t2c_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.u2c_1) | 0;
    result = imul(result, 31) + (this.v2c_1 == null ? 0 : getStringHashCode(this.v2c_1)) | 0;
    result = imul(result, 31) + (this.w2c_1 == null ? 0 : getStringHashCode(this.w2c_1)) | 0;
    result = imul(result, 31) + (this.x2c_1 == null ? 0 : getStringHashCode(this.x2c_1)) | 0;
    result = imul(result, 31) + (this.y2c_1 == null ? 0 : getStringHashCode(this.y2c_1)) | 0;
    result = imul(result, 31) + (this.z2c_1 == null ? 0 : getStringHashCode(this.z2c_1)) | 0;
    result = imul(result, 31) + this.a2d_1.hashCode() | 0;
    return result;
  };
  protoOf(AuditEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AuditEntry))
      return false;
    var tmp0_other_with_cast = other instanceof AuditEntry ? other : THROW_CCE();
    if (!(this.r2c_1 === tmp0_other_with_cast.r2c_1))
      return false;
    if (!(this.s2c_1 == tmp0_other_with_cast.s2c_1))
      return false;
    if (!(this.t2c_1 == tmp0_other_with_cast.t2c_1))
      return false;
    if (!(this.u2c_1 === tmp0_other_with_cast.u2c_1))
      return false;
    if (!(this.v2c_1 == tmp0_other_with_cast.v2c_1))
      return false;
    if (!(this.w2c_1 == tmp0_other_with_cast.w2c_1))
      return false;
    if (!(this.x2c_1 == tmp0_other_with_cast.x2c_1))
      return false;
    if (!(this.y2c_1 == tmp0_other_with_cast.y2c_1))
      return false;
    if (!(this.z2c_1 == tmp0_other_with_cast.z2c_1))
      return false;
    if (!this.a2d_1.equals(tmp0_other_with_cast.a2d_1))
      return false;
    return true;
  };
  function Companion_68() {
  }
  var Companion_instance_68;
  function Companion_getInstance_68() {
    return Companion_instance_68;
  }
  function $serializer_75() {
    $serializer_instance_74 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AuditQuery', this, 6);
    tmp0_serialDesc.gy('tenantId', true);
    tmp0_serialDesc.gy('actorId', true);
    tmp0_serialDesc.gy('action', true);
    tmp0_serialDesc.gy('sinceMs', true);
    tmp0_serialDesc.gy('offset', true);
    tmp0_serialDesc.gy('limit', true);
    this.b2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_75).c2d = function (encoder, value) {
    var tmp0_desc = this.b2d_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.d2d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, StringSerializer_getInstance(), value.d2d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.e2d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.e2d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.f2d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.f2d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.g2d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.g2d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.h2d_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 4, value.h2d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.i2d_1 === 100)) {
      tmp1_output.cs(tmp0_desc, 5, value.i2d_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_75).on = function (encoder, value) {
    return this.c2d(encoder, value instanceof AuditQuery ? value : THROW_CCE());
  };
  protoOf($serializer_75).pn = function (decoder) {
    var tmp0_desc = this.b2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_local5 = 0;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.yq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.yq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return AuditQuery_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_75).nn = function () {
    return this.b2d_1;
  };
  protoOf($serializer_75).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_74;
  function $serializer_getInstance_74() {
    if ($serializer_instance_74 == null)
      new $serializer_75();
    return $serializer_instance_74;
  }
  function AuditQuery_init_$Init$(seen0, tenantId, actorId, action, sinceMs, offset, limit, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_74().b2d_1);
    }
    if (0 === (seen0 & 1))
      $this.d2d_1 = null;
    else
      $this.d2d_1 = tenantId;
    if (0 === (seen0 & 2))
      $this.e2d_1 = null;
    else
      $this.e2d_1 = actorId;
    if (0 === (seen0 & 4))
      $this.f2d_1 = null;
    else
      $this.f2d_1 = action;
    if (0 === (seen0 & 8))
      $this.g2d_1 = null;
    else
      $this.g2d_1 = sinceMs;
    if (0 === (seen0 & 16))
      $this.h2d_1 = 0;
    else
      $this.h2d_1 = offset;
    if (0 === (seen0 & 32))
      $this.i2d_1 = 100;
    else
      $this.i2d_1 = limit;
    return $this;
  }
  function AuditQuery_init_$Create$(seen0, tenantId, actorId, action, sinceMs, offset, limit, serializationConstructorMarker) {
    return AuditQuery_init_$Init$(seen0, tenantId, actorId, action, sinceMs, offset, limit, serializationConstructorMarker, objectCreate(protoOf(AuditQuery)));
  }
  function AuditQuery(tenantId, actorId, action, sinceMs, offset, limit) {
    tenantId = tenantId === VOID ? null : tenantId;
    actorId = actorId === VOID ? null : actorId;
    action = action === VOID ? null : action;
    sinceMs = sinceMs === VOID ? null : sinceMs;
    offset = offset === VOID ? 0 : offset;
    limit = limit === VOID ? 100 : limit;
    this.d2d_1 = tenantId;
    this.e2d_1 = actorId;
    this.f2d_1 = action;
    this.g2d_1 = sinceMs;
    this.h2d_1 = offset;
    this.i2d_1 = limit;
  }
  protoOf(AuditQuery).j2d = function (tenantId, actorId, action, sinceMs, offset, limit) {
    return new AuditQuery(tenantId, actorId, action, sinceMs, offset, limit);
  };
  protoOf(AuditQuery).k2d = function (tenantId, actorId, action, sinceMs, offset, limit, $super) {
    tenantId = tenantId === VOID ? this.d2d_1 : tenantId;
    actorId = actorId === VOID ? this.e2d_1 : actorId;
    action = action === VOID ? this.f2d_1 : action;
    sinceMs = sinceMs === VOID ? this.g2d_1 : sinceMs;
    offset = offset === VOID ? this.h2d_1 : offset;
    limit = limit === VOID ? this.i2d_1 : limit;
    return $super === VOID ? this.j2d(tenantId, actorId, action, sinceMs, offset, limit) : $super.j2d.call(this, tenantId, actorId, action, sinceMs, offset, limit);
  };
  protoOf(AuditQuery).toString = function () {
    return 'AuditQuery(tenantId=' + this.d2d_1 + ', actorId=' + this.e2d_1 + ', action=' + this.f2d_1 + ', sinceMs=' + toString_0(this.g2d_1) + ', offset=' + this.h2d_1 + ', limit=' + this.i2d_1 + ')';
  };
  protoOf(AuditQuery).hashCode = function () {
    var result = this.d2d_1 == null ? 0 : getStringHashCode(this.d2d_1);
    result = imul(result, 31) + (this.e2d_1 == null ? 0 : getStringHashCode(this.e2d_1)) | 0;
    result = imul(result, 31) + (this.f2d_1 == null ? 0 : getStringHashCode(this.f2d_1)) | 0;
    result = imul(result, 31) + (this.g2d_1 == null ? 0 : this.g2d_1.hashCode()) | 0;
    result = imul(result, 31) + this.h2d_1 | 0;
    result = imul(result, 31) + this.i2d_1 | 0;
    return result;
  };
  protoOf(AuditQuery).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AuditQuery))
      return false;
    var tmp0_other_with_cast = other instanceof AuditQuery ? other : THROW_CCE();
    if (!(this.d2d_1 == tmp0_other_with_cast.d2d_1))
      return false;
    if (!(this.e2d_1 == tmp0_other_with_cast.e2d_1))
      return false;
    if (!(this.f2d_1 == tmp0_other_with_cast.f2d_1))
      return false;
    if (!equals(this.g2d_1, tmp0_other_with_cast.g2d_1))
      return false;
    if (!(this.h2d_1 === tmp0_other_with_cast.h2d_1))
      return false;
    if (!(this.i2d_1 === tmp0_other_with_cast.i2d_1))
      return false;
    return true;
  };
  function Companion_69() {
    Companion_instance_69 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l2d_1 = [null, null, null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_69;
  function Companion_getInstance_69() {
    if (Companion_instance_69 == null)
      new Companion_69();
    return Companion_instance_69;
  }
  function $serializer_76() {
    $serializer_instance_75 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.NoticeView', this, 11);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('titleEn', false);
    tmp0_serialDesc.gy('titleAr', false);
    tmp0_serialDesc.gy('bodyEn', false);
    tmp0_serialDesc.gy('bodyAr', false);
    tmp0_serialDesc.gy('severity', false);
    tmp0_serialDesc.gy('startsAtMs', false);
    tmp0_serialDesc.gy('endsAtMs', false);
    tmp0_serialDesc.gy('target', false);
    tmp0_serialDesc.gy('tenantIds', false);
    tmp0_serialDesc.gy('isActive', false);
    this.m2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_76).n2d = function (encoder, value) {
    var tmp0_desc = this.m2d_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_69().l2d_1;
    tmp1_output.hs(tmp0_desc, 0, value.o2d_1);
    tmp1_output.hs(tmp0_desc, 1, value.p2d_1);
    tmp1_output.hs(tmp0_desc, 2, value.q2d_1);
    tmp1_output.hs(tmp0_desc, 3, value.r2d_1);
    tmp1_output.hs(tmp0_desc, 4, value.s2d_1);
    tmp1_output.hs(tmp0_desc, 5, value.t2d_1);
    tmp1_output.ds(tmp0_desc, 6, value.u2d_1);
    tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.v2d_1);
    tmp1_output.hs(tmp0_desc, 8, value.w2d_1);
    tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.x2d_1);
    tmp1_output.zr(tmp0_desc, 10, value.y2d_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_76).on = function (encoder, value) {
    return this.n2d(encoder, value instanceof NoticeView ? value : THROW_CCE());
  };
  protoOf($serializer_76).pn = function (decoder) {
    var tmp0_desc = this.m2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = new Long(0, 0);
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = false;
    var tmp15_input = decoder.tq(tmp0_desc);
    var tmp16_cached = Companion_getInstance_69().l2d_1;
    if (tmp15_input.ir()) {
      tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.zq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.fr(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.vq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.zq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.fr(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.vq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.uq(tmp0_desc);
    return NoticeView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_76).nn = function () {
    return this.m2d_1;
  };
  protoOf($serializer_76).vy = function () {
    var tmp0_cached = Companion_getInstance_69().l2d_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[9], BooleanSerializer_getInstance()];
  };
  var $serializer_instance_75;
  function $serializer_getInstance_75() {
    if ($serializer_instance_75 == null)
      new $serializer_76();
    return $serializer_instance_75;
  }
  function NoticeView_init_$Init$(seen0, id, titleEn, titleAr, bodyEn, bodyAr, severity, startsAtMs, endsAtMs, target, tenantIds, isActive, serializationConstructorMarker, $this) {
    if (!(2047 === (2047 & seen0))) {
      throwMissingFieldException(seen0, 2047, $serializer_getInstance_75().m2d_1);
    }
    $this.o2d_1 = id;
    $this.p2d_1 = titleEn;
    $this.q2d_1 = titleAr;
    $this.r2d_1 = bodyEn;
    $this.s2d_1 = bodyAr;
    $this.t2d_1 = severity;
    $this.u2d_1 = startsAtMs;
    $this.v2d_1 = endsAtMs;
    $this.w2d_1 = target;
    $this.x2d_1 = tenantIds;
    $this.y2d_1 = isActive;
    return $this;
  }
  function NoticeView_init_$Create$(seen0, id, titleEn, titleAr, bodyEn, bodyAr, severity, startsAtMs, endsAtMs, target, tenantIds, isActive, serializationConstructorMarker) {
    return NoticeView_init_$Init$(seen0, id, titleEn, titleAr, bodyEn, bodyAr, severity, startsAtMs, endsAtMs, target, tenantIds, isActive, serializationConstructorMarker, objectCreate(protoOf(NoticeView)));
  }
  function NoticeView(id, titleEn, titleAr, bodyEn, bodyAr, severity, startsAtMs, endsAtMs, target, tenantIds, isActive) {
    Companion_getInstance_69();
    this.o2d_1 = id;
    this.p2d_1 = titleEn;
    this.q2d_1 = titleAr;
    this.r2d_1 = bodyEn;
    this.s2d_1 = bodyAr;
    this.t2d_1 = severity;
    this.u2d_1 = startsAtMs;
    this.v2d_1 = endsAtMs;
    this.w2d_1 = target;
    this.x2d_1 = tenantIds;
    this.y2d_1 = isActive;
  }
  protoOf(NoticeView).toString = function () {
    return 'NoticeView(id=' + this.o2d_1 + ', titleEn=' + this.p2d_1 + ', titleAr=' + this.q2d_1 + ', bodyEn=' + this.r2d_1 + ', bodyAr=' + this.s2d_1 + ', severity=' + this.t2d_1 + ', startsAtMs=' + this.u2d_1.toString() + ', endsAtMs=' + toString_0(this.v2d_1) + ', target=' + this.w2d_1 + ', tenantIds=' + toString(this.x2d_1) + ', isActive=' + this.y2d_1 + ')';
  };
  protoOf(NoticeView).hashCode = function () {
    var result = getStringHashCode(this.o2d_1);
    result = imul(result, 31) + getStringHashCode(this.p2d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q2d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r2d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s2d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t2d_1) | 0;
    result = imul(result, 31) + this.u2d_1.hashCode() | 0;
    result = imul(result, 31) + (this.v2d_1 == null ? 0 : this.v2d_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.w2d_1) | 0;
    result = imul(result, 31) + hashCode(this.x2d_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y2d_1) | 0;
    return result;
  };
  protoOf(NoticeView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof NoticeView))
      return false;
    var tmp0_other_with_cast = other instanceof NoticeView ? other : THROW_CCE();
    if (!(this.o2d_1 === tmp0_other_with_cast.o2d_1))
      return false;
    if (!(this.p2d_1 === tmp0_other_with_cast.p2d_1))
      return false;
    if (!(this.q2d_1 === tmp0_other_with_cast.q2d_1))
      return false;
    if (!(this.r2d_1 === tmp0_other_with_cast.r2d_1))
      return false;
    if (!(this.s2d_1 === tmp0_other_with_cast.s2d_1))
      return false;
    if (!(this.t2d_1 === tmp0_other_with_cast.t2d_1))
      return false;
    if (!this.u2d_1.equals(tmp0_other_with_cast.u2d_1))
      return false;
    if (!equals(this.v2d_1, tmp0_other_with_cast.v2d_1))
      return false;
    if (!(this.w2d_1 === tmp0_other_with_cast.w2d_1))
      return false;
    if (!equals(this.x2d_1, tmp0_other_with_cast.x2d_1))
      return false;
    if (!(this.y2d_1 === tmp0_other_with_cast.y2d_1))
      return false;
    return true;
  };
  function Companion_70() {
    Companion_instance_70 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2d_1 = [null, null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_70;
  function Companion_getInstance_70() {
    if (Companion_instance_70 == null)
      new Companion_70();
    return Companion_instance_70;
  }
  function $serializer_77() {
    $serializer_instance_76 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UpsertNoticeRequest', this, 10);
    tmp0_serialDesc.gy('titleEn', false);
    tmp0_serialDesc.gy('titleAr', false);
    tmp0_serialDesc.gy('bodyEn', false);
    tmp0_serialDesc.gy('bodyAr', false);
    tmp0_serialDesc.gy('severity', true);
    tmp0_serialDesc.gy('startsAtMs', false);
    tmp0_serialDesc.gy('endsAtMs', true);
    tmp0_serialDesc.gy('target', true);
    tmp0_serialDesc.gy('tenantIds', true);
    tmp0_serialDesc.gy('isActive', true);
    this.a2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_77).b2e = function (encoder, value) {
    var tmp0_desc = this.a2e_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_70().z2d_1;
    tmp1_output.hs(tmp0_desc, 0, value.c2e_1);
    tmp1_output.hs(tmp0_desc, 1, value.d2e_1);
    tmp1_output.hs(tmp0_desc, 2, value.e2e_1);
    tmp1_output.hs(tmp0_desc, 3, value.f2e_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.g2e_1 === 'info')) {
      tmp1_output.hs(tmp0_desc, 4, value.g2e_1);
    }
    tmp1_output.ds(tmp0_desc, 5, value.h2e_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.i2e_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.i2e_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.j2e_1 === 'all')) {
      tmp1_output.hs(tmp0_desc, 7, value.j2e_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !equals(value.k2e_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.k2e_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.l2e_1 === true)) {
      tmp1_output.zr(tmp0_desc, 9, value.l2e_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_77).on = function (encoder, value) {
    return this.b2e(encoder, value instanceof UpsertNoticeRequest ? value : THROW_CCE());
  };
  protoOf($serializer_77).pn = function (decoder) {
    var tmp0_desc = this.a2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = false;
    var tmp14_input = decoder.tq(tmp0_desc);
    var tmp15_cached = Companion_getInstance_70().z2d_1;
    if (tmp14_input.ir()) {
      tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.fr(tmp0_desc, 8, tmp15_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.vq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.fr(tmp0_desc, 8, tmp15_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.vq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.uq(tmp0_desc);
    return UpsertNoticeRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_77).nn = function () {
    return this.a2e_1;
  };
  protoOf($serializer_77).vy = function () {
    var tmp0_cached = Companion_getInstance_70().z2d_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[8], BooleanSerializer_getInstance()];
  };
  var $serializer_instance_76;
  function $serializer_getInstance_76() {
    if ($serializer_instance_76 == null)
      new $serializer_77();
    return $serializer_instance_76;
  }
  function UpsertNoticeRequest_init_$Init$(seen0, titleEn, titleAr, bodyEn, bodyAr, severity, startsAtMs, endsAtMs, target, tenantIds, isActive, serializationConstructorMarker, $this) {
    if (!(47 === (47 & seen0))) {
      throwMissingFieldException(seen0, 47, $serializer_getInstance_76().a2e_1);
    }
    $this.c2e_1 = titleEn;
    $this.d2e_1 = titleAr;
    $this.e2e_1 = bodyEn;
    $this.f2e_1 = bodyAr;
    if (0 === (seen0 & 16))
      $this.g2e_1 = 'info';
    else
      $this.g2e_1 = severity;
    $this.h2e_1 = startsAtMs;
    if (0 === (seen0 & 64))
      $this.i2e_1 = null;
    else
      $this.i2e_1 = endsAtMs;
    if (0 === (seen0 & 128))
      $this.j2e_1 = 'all';
    else
      $this.j2e_1 = target;
    if (0 === (seen0 & 256))
      $this.k2e_1 = emptyList();
    else
      $this.k2e_1 = tenantIds;
    if (0 === (seen0 & 512))
      $this.l2e_1 = true;
    else
      $this.l2e_1 = isActive;
    return $this;
  }
  function UpsertNoticeRequest_init_$Create$(seen0, titleEn, titleAr, bodyEn, bodyAr, severity, startsAtMs, endsAtMs, target, tenantIds, isActive, serializationConstructorMarker) {
    return UpsertNoticeRequest_init_$Init$(seen0, titleEn, titleAr, bodyEn, bodyAr, severity, startsAtMs, endsAtMs, target, tenantIds, isActive, serializationConstructorMarker, objectCreate(protoOf(UpsertNoticeRequest)));
  }
  function UpsertNoticeRequest(titleEn, titleAr, bodyEn, bodyAr, severity, startsAtMs, endsAtMs, target, tenantIds, isActive) {
    Companion_getInstance_70();
    severity = severity === VOID ? 'info' : severity;
    endsAtMs = endsAtMs === VOID ? null : endsAtMs;
    target = target === VOID ? 'all' : target;
    tenantIds = tenantIds === VOID ? emptyList() : tenantIds;
    isActive = isActive === VOID ? true : isActive;
    this.c2e_1 = titleEn;
    this.d2e_1 = titleAr;
    this.e2e_1 = bodyEn;
    this.f2e_1 = bodyAr;
    this.g2e_1 = severity;
    this.h2e_1 = startsAtMs;
    this.i2e_1 = endsAtMs;
    this.j2e_1 = target;
    this.k2e_1 = tenantIds;
    this.l2e_1 = isActive;
  }
  protoOf(UpsertNoticeRequest).toString = function () {
    return 'UpsertNoticeRequest(titleEn=' + this.c2e_1 + ', titleAr=' + this.d2e_1 + ', bodyEn=' + this.e2e_1 + ', bodyAr=' + this.f2e_1 + ', severity=' + this.g2e_1 + ', startsAtMs=' + this.h2e_1.toString() + ', endsAtMs=' + toString_0(this.i2e_1) + ', target=' + this.j2e_1 + ', tenantIds=' + toString(this.k2e_1) + ', isActive=' + this.l2e_1 + ')';
  };
  protoOf(UpsertNoticeRequest).hashCode = function () {
    var result = getStringHashCode(this.c2e_1);
    result = imul(result, 31) + getStringHashCode(this.d2e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e2e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f2e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g2e_1) | 0;
    result = imul(result, 31) + this.h2e_1.hashCode() | 0;
    result = imul(result, 31) + (this.i2e_1 == null ? 0 : this.i2e_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.j2e_1) | 0;
    result = imul(result, 31) + hashCode(this.k2e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l2e_1) | 0;
    return result;
  };
  protoOf(UpsertNoticeRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UpsertNoticeRequest))
      return false;
    var tmp0_other_with_cast = other instanceof UpsertNoticeRequest ? other : THROW_CCE();
    if (!(this.c2e_1 === tmp0_other_with_cast.c2e_1))
      return false;
    if (!(this.d2e_1 === tmp0_other_with_cast.d2e_1))
      return false;
    if (!(this.e2e_1 === tmp0_other_with_cast.e2e_1))
      return false;
    if (!(this.f2e_1 === tmp0_other_with_cast.f2e_1))
      return false;
    if (!(this.g2e_1 === tmp0_other_with_cast.g2e_1))
      return false;
    if (!this.h2e_1.equals(tmp0_other_with_cast.h2e_1))
      return false;
    if (!equals(this.i2e_1, tmp0_other_with_cast.i2e_1))
      return false;
    if (!(this.j2e_1 === tmp0_other_with_cast.j2e_1))
      return false;
    if (!equals(this.k2e_1, tmp0_other_with_cast.k2e_1))
      return false;
    if (!(this.l2e_1 === tmp0_other_with_cast.l2e_1))
      return false;
    return true;
  };
  function Companion_71() {
    Companion_instance_71 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m2e_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_94())];
  }
  var Companion_instance_71;
  function Companion_getInstance_71() {
    if (Companion_instance_71 == null)
      new Companion_71();
    return Companion_instance_71;
  }
  function $serializer_78() {
    $serializer_instance_77 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.FeatureFlagView', this, 4);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('description', false);
    tmp0_serialDesc.gy('defaultEnabled', false);
    tmp0_serialDesc.gy('overrides', false);
    this.n2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_78).o2e = function (encoder, value) {
    var tmp0_desc = this.n2e_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_71().m2e_1;
    tmp1_output.hs(tmp0_desc, 0, value.p2e_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.q2e_1);
    tmp1_output.zr(tmp0_desc, 2, value.r2e_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.s2e_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_78).on = function (encoder, value) {
    return this.o2e(encoder, value instanceof FeatureFlagView ? value : THROW_CCE());
  };
  protoOf($serializer_78).pn = function (decoder) {
    var tmp0_desc = this.n2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_71().m2e_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return FeatureFlagView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_78).nn = function () {
    return this.n2e_1;
  };
  protoOf($serializer_78).vy = function () {
    var tmp0_cached = Companion_getInstance_71().m2e_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), tmp0_cached[3]];
  };
  var $serializer_instance_77;
  function $serializer_getInstance_77() {
    if ($serializer_instance_77 == null)
      new $serializer_78();
    return $serializer_instance_77;
  }
  function FeatureFlagView_init_$Init$(seen0, key, description, defaultEnabled, overrides, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_77().n2e_1);
    }
    $this.p2e_1 = key;
    $this.q2e_1 = description;
    $this.r2e_1 = defaultEnabled;
    $this.s2e_1 = overrides;
    return $this;
  }
  function FeatureFlagView_init_$Create$(seen0, key, description, defaultEnabled, overrides, serializationConstructorMarker) {
    return FeatureFlagView_init_$Init$(seen0, key, description, defaultEnabled, overrides, serializationConstructorMarker, objectCreate(protoOf(FeatureFlagView)));
  }
  function FeatureFlagView(key, description, defaultEnabled, overrides) {
    Companion_getInstance_71();
    this.p2e_1 = key;
    this.q2e_1 = description;
    this.r2e_1 = defaultEnabled;
    this.s2e_1 = overrides;
  }
  protoOf(FeatureFlagView).toString = function () {
    return 'FeatureFlagView(key=' + this.p2e_1 + ', description=' + this.q2e_1 + ', defaultEnabled=' + this.r2e_1 + ', overrides=' + toString(this.s2e_1) + ')';
  };
  protoOf(FeatureFlagView).hashCode = function () {
    var result = getStringHashCode(this.p2e_1);
    result = imul(result, 31) + (this.q2e_1 == null ? 0 : getStringHashCode(this.q2e_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r2e_1) | 0;
    result = imul(result, 31) + hashCode(this.s2e_1) | 0;
    return result;
  };
  protoOf(FeatureFlagView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FeatureFlagView))
      return false;
    var tmp0_other_with_cast = other instanceof FeatureFlagView ? other : THROW_CCE();
    if (!(this.p2e_1 === tmp0_other_with_cast.p2e_1))
      return false;
    if (!(this.q2e_1 == tmp0_other_with_cast.q2e_1))
      return false;
    if (!(this.r2e_1 === tmp0_other_with_cast.r2e_1))
      return false;
    if (!equals(this.s2e_1, tmp0_other_with_cast.s2e_1))
      return false;
    return true;
  };
  function Companion_72() {
  }
  var Companion_instance_72;
  function Companion_getInstance_72() {
    return Companion_instance_72;
  }
  function $serializer_79() {
    $serializer_instance_78 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetFeatureFlagRequest', this, 2);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('enabled', false);
    this.t2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_79).u2e = function (encoder, value) {
    var tmp0_desc = this.t2e_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.v2e_1);
    tmp1_output.zr(tmp0_desc, 1, value.w2e_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_79).on = function (encoder, value) {
    return this.u2e(encoder, value instanceof SetFeatureFlagRequest ? value : THROW_CCE());
  };
  protoOf($serializer_79).pn = function (decoder) {
    var tmp0_desc = this.t2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SetFeatureFlagRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_79).nn = function () {
    return this.t2e_1;
  };
  protoOf($serializer_79).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_78;
  function $serializer_getInstance_78() {
    if ($serializer_instance_78 == null)
      new $serializer_79();
    return $serializer_instance_78;
  }
  function SetFeatureFlagRequest_init_$Init$(seen0, tenantId, enabled, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_78().t2e_1);
    }
    $this.v2e_1 = tenantId;
    $this.w2e_1 = enabled;
    return $this;
  }
  function SetFeatureFlagRequest_init_$Create$(seen0, tenantId, enabled, serializationConstructorMarker) {
    return SetFeatureFlagRequest_init_$Init$(seen0, tenantId, enabled, serializationConstructorMarker, objectCreate(protoOf(SetFeatureFlagRequest)));
  }
  function SetFeatureFlagRequest(tenantId, enabled) {
    this.v2e_1 = tenantId;
    this.w2e_1 = enabled;
  }
  protoOf(SetFeatureFlagRequest).toString = function () {
    return 'SetFeatureFlagRequest(tenantId=' + this.v2e_1 + ', enabled=' + this.w2e_1 + ')';
  };
  protoOf(SetFeatureFlagRequest).hashCode = function () {
    var result = getStringHashCode(this.v2e_1);
    result = imul(result, 31) + getBooleanHashCode(this.w2e_1) | 0;
    return result;
  };
  protoOf(SetFeatureFlagRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetFeatureFlagRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SetFeatureFlagRequest ? other : THROW_CCE();
    if (!(this.v2e_1 === tmp0_other_with_cast.v2e_1))
      return false;
    if (!(this.w2e_1 === tmp0_other_with_cast.w2e_1))
      return false;
    return true;
  };
  function Companion_73() {
    Companion_instance_73 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x2e_1 = [null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null, null];
  }
  var Companion_instance_73;
  function Companion_getInstance_73() {
    if (Companion_instance_73 == null)
      new Companion_73();
    return Companion_instance_73;
  }
  function $serializer_80() {
    $serializer_instance_79 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OperatorTokenView', this, 11);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('operatorId', false);
    tmp0_serialDesc.gy('label', false);
    tmp0_serialDesc.gy('tokenPrefix', false);
    tmp0_serialDesc.gy('capabilities', false);
    tmp0_serialDesc.gy('createdAtMs', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    tmp0_serialDesc.gy('lastUsedAtMs', true);
    tmp0_serialDesc.gy('revokedAtMs', true);
    tmp0_serialDesc.gy('revokedBy', true);
    tmp0_serialDesc.gy('revokeReason', true);
    this.y2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_80).z2e = function (encoder, value) {
    var tmp0_desc = this.y2e_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_73().x2e_1;
    tmp1_output.hs(tmp0_desc, 0, value.a2f_1);
    tmp1_output.hs(tmp0_desc, 1, value.b2f_1);
    tmp1_output.hs(tmp0_desc, 2, value.c2f_1);
    tmp1_output.hs(tmp0_desc, 3, value.d2f_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.e2f_1);
    tmp1_output.ds(tmp0_desc, 5, value.f2f_1);
    tmp1_output.ds(tmp0_desc, 6, value.g2f_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.h2f_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.h2f_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.i2f_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, LongSerializer_getInstance(), value.i2f_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.j2f_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.j2f_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.k2f_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.k2f_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_80).on = function (encoder, value) {
    return this.z2e(encoder, value instanceof OperatorTokenView ? value : THROW_CCE());
  };
  protoOf($serializer_80).pn = function (decoder) {
    var tmp0_desc = this.y2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = new Long(0, 0);
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.tq(tmp0_desc);
    var tmp16_cached = Companion_getInstance_73().x2e_1;
    if (tmp15_input.ir()) {
      tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.fr(tmp0_desc, 4, tmp16_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.zq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.fr(tmp0_desc, 4, tmp16_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.zq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.uq(tmp0_desc);
    return OperatorTokenView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_80).nn = function () {
    return this.y2e_1;
  };
  protoOf($serializer_80).vy = function () {
    var tmp0_cached = Companion_getInstance_73().x2e_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4], LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_79;
  function $serializer_getInstance_79() {
    if ($serializer_instance_79 == null)
      new $serializer_80();
    return $serializer_instance_79;
  }
  function OperatorTokenView_init_$Init$(seen0, id, operatorId, label, tokenPrefix, capabilities, createdAtMs, expiresAtMs, lastUsedAtMs, revokedAtMs, revokedBy, revokeReason, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_79().y2e_1);
    }
    $this.a2f_1 = id;
    $this.b2f_1 = operatorId;
    $this.c2f_1 = label;
    $this.d2f_1 = tokenPrefix;
    $this.e2f_1 = capabilities;
    $this.f2f_1 = createdAtMs;
    $this.g2f_1 = expiresAtMs;
    if (0 === (seen0 & 128))
      $this.h2f_1 = null;
    else
      $this.h2f_1 = lastUsedAtMs;
    if (0 === (seen0 & 256))
      $this.i2f_1 = null;
    else
      $this.i2f_1 = revokedAtMs;
    if (0 === (seen0 & 512))
      $this.j2f_1 = null;
    else
      $this.j2f_1 = revokedBy;
    if (0 === (seen0 & 1024))
      $this.k2f_1 = null;
    else
      $this.k2f_1 = revokeReason;
    return $this;
  }
  function OperatorTokenView_init_$Create$(seen0, id, operatorId, label, tokenPrefix, capabilities, createdAtMs, expiresAtMs, lastUsedAtMs, revokedAtMs, revokedBy, revokeReason, serializationConstructorMarker) {
    return OperatorTokenView_init_$Init$(seen0, id, operatorId, label, tokenPrefix, capabilities, createdAtMs, expiresAtMs, lastUsedAtMs, revokedAtMs, revokedBy, revokeReason, serializationConstructorMarker, objectCreate(protoOf(OperatorTokenView)));
  }
  function OperatorTokenView(id, operatorId, label, tokenPrefix, capabilities, createdAtMs, expiresAtMs, lastUsedAtMs, revokedAtMs, revokedBy, revokeReason) {
    Companion_getInstance_73();
    lastUsedAtMs = lastUsedAtMs === VOID ? null : lastUsedAtMs;
    revokedAtMs = revokedAtMs === VOID ? null : revokedAtMs;
    revokedBy = revokedBy === VOID ? null : revokedBy;
    revokeReason = revokeReason === VOID ? null : revokeReason;
    this.a2f_1 = id;
    this.b2f_1 = operatorId;
    this.c2f_1 = label;
    this.d2f_1 = tokenPrefix;
    this.e2f_1 = capabilities;
    this.f2f_1 = createdAtMs;
    this.g2f_1 = expiresAtMs;
    this.h2f_1 = lastUsedAtMs;
    this.i2f_1 = revokedAtMs;
    this.j2f_1 = revokedBy;
    this.k2f_1 = revokeReason;
  }
  protoOf(OperatorTokenView).toString = function () {
    return 'OperatorTokenView(id=' + this.a2f_1 + ', operatorId=' + this.b2f_1 + ', label=' + this.c2f_1 + ', tokenPrefix=' + this.d2f_1 + ', capabilities=' + toString(this.e2f_1) + ', createdAtMs=' + this.f2f_1.toString() + ', expiresAtMs=' + this.g2f_1.toString() + ', lastUsedAtMs=' + toString_0(this.h2f_1) + ', revokedAtMs=' + toString_0(this.i2f_1) + ', revokedBy=' + this.j2f_1 + ', revokeReason=' + this.k2f_1 + ')';
  };
  protoOf(OperatorTokenView).hashCode = function () {
    var result = getStringHashCode(this.a2f_1);
    result = imul(result, 31) + getStringHashCode(this.b2f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c2f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d2f_1) | 0;
    result = imul(result, 31) + hashCode(this.e2f_1) | 0;
    result = imul(result, 31) + this.f2f_1.hashCode() | 0;
    result = imul(result, 31) + this.g2f_1.hashCode() | 0;
    result = imul(result, 31) + (this.h2f_1 == null ? 0 : this.h2f_1.hashCode()) | 0;
    result = imul(result, 31) + (this.i2f_1 == null ? 0 : this.i2f_1.hashCode()) | 0;
    result = imul(result, 31) + (this.j2f_1 == null ? 0 : getStringHashCode(this.j2f_1)) | 0;
    result = imul(result, 31) + (this.k2f_1 == null ? 0 : getStringHashCode(this.k2f_1)) | 0;
    return result;
  };
  protoOf(OperatorTokenView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OperatorTokenView))
      return false;
    var tmp0_other_with_cast = other instanceof OperatorTokenView ? other : THROW_CCE();
    if (!(this.a2f_1 === tmp0_other_with_cast.a2f_1))
      return false;
    if (!(this.b2f_1 === tmp0_other_with_cast.b2f_1))
      return false;
    if (!(this.c2f_1 === tmp0_other_with_cast.c2f_1))
      return false;
    if (!(this.d2f_1 === tmp0_other_with_cast.d2f_1))
      return false;
    if (!equals(this.e2f_1, tmp0_other_with_cast.e2f_1))
      return false;
    if (!this.f2f_1.equals(tmp0_other_with_cast.f2f_1))
      return false;
    if (!this.g2f_1.equals(tmp0_other_with_cast.g2f_1))
      return false;
    if (!equals(this.h2f_1, tmp0_other_with_cast.h2f_1))
      return false;
    if (!equals(this.i2f_1, tmp0_other_with_cast.i2f_1))
      return false;
    if (!(this.j2f_1 == tmp0_other_with_cast.j2f_1))
      return false;
    if (!(this.k2f_1 == tmp0_other_with_cast.k2f_1))
      return false;
    return true;
  };
  function Companion_74() {
  }
  var Companion_instance_74;
  function Companion_getInstance_74() {
    return Companion_instance_74;
  }
  function $serializer_81() {
    $serializer_instance_80 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CreatedOperatorTokenResponse', this, 2);
    tmp0_serialDesc.gy('token', false);
    tmp0_serialDesc.gy('secret', false);
    this.l2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_81).m2f = function (encoder, value) {
    var tmp0_desc = this.l2f_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_79(), value.n2f_1);
    tmp1_output.hs(tmp0_desc, 1, value.o2f_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_81).on = function (encoder, value) {
    return this.m2f(encoder, value instanceof CreatedOperatorTokenResponse ? value : THROW_CCE());
  };
  protoOf($serializer_81).pn = function (decoder) {
    var tmp0_desc = this.l2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_79(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_79(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return CreatedOperatorTokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_81).nn = function () {
    return this.l2f_1;
  };
  protoOf($serializer_81).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_79(), StringSerializer_getInstance()];
  };
  var $serializer_instance_80;
  function $serializer_getInstance_80() {
    if ($serializer_instance_80 == null)
      new $serializer_81();
    return $serializer_instance_80;
  }
  function CreatedOperatorTokenResponse_init_$Init$(seen0, token, secret, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_80().l2f_1);
    }
    $this.n2f_1 = token;
    $this.o2f_1 = secret;
    return $this;
  }
  function CreatedOperatorTokenResponse_init_$Create$(seen0, token, secret, serializationConstructorMarker) {
    return CreatedOperatorTokenResponse_init_$Init$(seen0, token, secret, serializationConstructorMarker, objectCreate(protoOf(CreatedOperatorTokenResponse)));
  }
  function CreatedOperatorTokenResponse(token, secret) {
    this.n2f_1 = token;
    this.o2f_1 = secret;
  }
  protoOf(CreatedOperatorTokenResponse).toString = function () {
    return 'CreatedOperatorTokenResponse(token=' + this.n2f_1.toString() + ', secret=' + this.o2f_1 + ')';
  };
  protoOf(CreatedOperatorTokenResponse).hashCode = function () {
    var result = this.n2f_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.o2f_1) | 0;
    return result;
  };
  protoOf(CreatedOperatorTokenResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CreatedOperatorTokenResponse))
      return false;
    var tmp0_other_with_cast = other instanceof CreatedOperatorTokenResponse ? other : THROW_CCE();
    if (!this.n2f_1.equals(tmp0_other_with_cast.n2f_1))
      return false;
    if (!(this.o2f_1 === tmp0_other_with_cast.o2f_1))
      return false;
    return true;
  };
  function Companion_75() {
    Companion_instance_75 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p2f_1 = [null, new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_75;
  function Companion_getInstance_75() {
    if (Companion_instance_75 == null)
      new Companion_75();
    return Companion_instance_75;
  }
  function $serializer_82() {
    $serializer_instance_81 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CreateOperatorTokenRequest', this, 3);
    tmp0_serialDesc.gy('label', false);
    tmp0_serialDesc.gy('capabilities', true);
    tmp0_serialDesc.gy('expiresInDays', true);
    this.q2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_82).r2f = function (encoder, value) {
    var tmp0_desc = this.q2f_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_75().p2f_1;
    tmp1_output.hs(tmp0_desc, 0, value.s2f_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !equals(value.t2f_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.t2f_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.u2f_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, IntSerializer_getInstance(), value.u2f_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_82).on = function (encoder, value) {
    return this.r2f(encoder, value instanceof CreateOperatorTokenRequest ? value : THROW_CCE());
  };
  protoOf($serializer_82).pn = function (decoder) {
    var tmp0_desc = this.q2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_75().p2f_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return CreateOperatorTokenRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_82).nn = function () {
    return this.q2f_1;
  };
  protoOf($serializer_82).vy = function () {
    var tmp0_cached = Companion_getInstance_75().p2f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], get_nullable(IntSerializer_getInstance())];
  };
  var $serializer_instance_81;
  function $serializer_getInstance_81() {
    if ($serializer_instance_81 == null)
      new $serializer_82();
    return $serializer_instance_81;
  }
  function CreateOperatorTokenRequest_init_$Init$(seen0, label, capabilities, expiresInDays, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_81().q2f_1);
    }
    $this.s2f_1 = label;
    if (0 === (seen0 & 2))
      $this.t2f_1 = emptyList();
    else
      $this.t2f_1 = capabilities;
    if (0 === (seen0 & 4))
      $this.u2f_1 = null;
    else
      $this.u2f_1 = expiresInDays;
    return $this;
  }
  function CreateOperatorTokenRequest_init_$Create$(seen0, label, capabilities, expiresInDays, serializationConstructorMarker) {
    return CreateOperatorTokenRequest_init_$Init$(seen0, label, capabilities, expiresInDays, serializationConstructorMarker, objectCreate(protoOf(CreateOperatorTokenRequest)));
  }
  function CreateOperatorTokenRequest(label, capabilities, expiresInDays) {
    Companion_getInstance_75();
    capabilities = capabilities === VOID ? emptyList() : capabilities;
    expiresInDays = expiresInDays === VOID ? null : expiresInDays;
    this.s2f_1 = label;
    this.t2f_1 = capabilities;
    this.u2f_1 = expiresInDays;
  }
  protoOf(CreateOperatorTokenRequest).toString = function () {
    return 'CreateOperatorTokenRequest(label=' + this.s2f_1 + ', capabilities=' + toString(this.t2f_1) + ', expiresInDays=' + this.u2f_1 + ')';
  };
  protoOf(CreateOperatorTokenRequest).hashCode = function () {
    var result = getStringHashCode(this.s2f_1);
    result = imul(result, 31) + hashCode(this.t2f_1) | 0;
    result = imul(result, 31) + (this.u2f_1 == null ? 0 : this.u2f_1) | 0;
    return result;
  };
  protoOf(CreateOperatorTokenRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CreateOperatorTokenRequest))
      return false;
    var tmp0_other_with_cast = other instanceof CreateOperatorTokenRequest ? other : THROW_CCE();
    if (!(this.s2f_1 === tmp0_other_with_cast.s2f_1))
      return false;
    if (!equals(this.t2f_1, tmp0_other_with_cast.t2f_1))
      return false;
    if (!(this.u2f_1 == tmp0_other_with_cast.u2f_1))
      return false;
    return true;
  };
  function Companion_76() {
  }
  var Companion_instance_76;
  function Companion_getInstance_76() {
    return Companion_instance_76;
  }
  function $serializer_83() {
    $serializer_instance_82 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RevokeOperatorTokenRequest', this, 1);
    tmp0_serialDesc.gy('reason', true);
    this.v2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_83).w2f = function (encoder, value) {
    var tmp0_desc = this.v2f_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.x2f_1 === '')) {
      tmp1_output.hs(tmp0_desc, 0, value.x2f_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_83).on = function (encoder, value) {
    return this.w2f(encoder, value instanceof RevokeOperatorTokenRequest ? value : THROW_CCE());
  };
  protoOf($serializer_83).pn = function (decoder) {
    var tmp0_desc = this.v2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return RevokeOperatorTokenRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_83).nn = function () {
    return this.v2f_1;
  };
  protoOf($serializer_83).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_82;
  function $serializer_getInstance_82() {
    if ($serializer_instance_82 == null)
      new $serializer_83();
    return $serializer_instance_82;
  }
  function RevokeOperatorTokenRequest_init_$Init$(seen0, reason, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_82().v2f_1);
    }
    if (0 === (seen0 & 1))
      $this.x2f_1 = '';
    else
      $this.x2f_1 = reason;
    return $this;
  }
  function RevokeOperatorTokenRequest_init_$Create$(seen0, reason, serializationConstructorMarker) {
    return RevokeOperatorTokenRequest_init_$Init$(seen0, reason, serializationConstructorMarker, objectCreate(protoOf(RevokeOperatorTokenRequest)));
  }
  function RevokeOperatorTokenRequest(reason) {
    reason = reason === VOID ? '' : reason;
    this.x2f_1 = reason;
  }
  protoOf(RevokeOperatorTokenRequest).toString = function () {
    return 'RevokeOperatorTokenRequest(reason=' + this.x2f_1 + ')';
  };
  protoOf(RevokeOperatorTokenRequest).hashCode = function () {
    return getStringHashCode(this.x2f_1);
  };
  protoOf(RevokeOperatorTokenRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RevokeOperatorTokenRequest))
      return false;
    var tmp0_other_with_cast = other instanceof RevokeOperatorTokenRequest ? other : THROW_CCE();
    if (!(this.x2f_1 === tmp0_other_with_cast.x2f_1))
      return false;
    return true;
  };
  function Companion_77() {
  }
  var Companion_instance_77;
  function Companion_getInstance_77() {
    return Companion_instance_77;
  }
  function $serializer_84() {
    $serializer_instance_83 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OperatorMcpCallView', this, 15);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('tokenId', false);
    tmp0_serialDesc.gy('operatorId', false);
    tmp0_serialDesc.gy('method', false);
    tmp0_serialDesc.gy('name', false);
    tmp0_serialDesc.gy('loggedArgsJson', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('errorCode', true);
    tmp0_serialDesc.gy('correlationId', false);
    tmp0_serialDesc.gy('durationMs', false);
    tmp0_serialDesc.gy('clientName', true);
    tmp0_serialDesc.gy('clientVersion', true);
    tmp0_serialDesc.gy('protocolVersion', true);
    tmp0_serialDesc.gy('ipAddress', false);
    tmp0_serialDesc.gy('atMs', false);
    this.y2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_84).z2f = function (encoder, value) {
    var tmp0_desc = this.y2f_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.a2g_1);
    tmp1_output.hs(tmp0_desc, 1, value.b2g_1);
    tmp1_output.hs(tmp0_desc, 2, value.c2g_1);
    tmp1_output.hs(tmp0_desc, 3, value.d2g_1);
    tmp1_output.hs(tmp0_desc, 4, value.e2g_1);
    tmp1_output.hs(tmp0_desc, 5, value.f2g_1);
    tmp1_output.hs(tmp0_desc, 6, value.g2g_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.h2g_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.h2g_1);
    }
    tmp1_output.hs(tmp0_desc, 8, value.i2g_1);
    tmp1_output.ds(tmp0_desc, 9, value.j2g_1);
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.k2g_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.k2g_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.l2g_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, StringSerializer_getInstance(), value.l2g_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.m2g_1 == null)) {
      tmp1_output.ls(tmp0_desc, 12, StringSerializer_getInstance(), value.m2g_1);
    }
    tmp1_output.hs(tmp0_desc, 13, value.n2g_1);
    tmp1_output.ds(tmp0_desc, 14, value.o2g_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_84).on = function (encoder, value) {
    return this.z2f(encoder, value instanceof OperatorMcpCallView ? value : THROW_CCE());
  };
  protoOf($serializer_84).pn = function (decoder) {
    var tmp0_desc = this.y2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = new Long(0, 0);
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = new Long(0, 0);
    var tmp19_input = decoder.tq(tmp0_desc);
    if (tmp19_input.ir()) {
      tmp4_local0 = tmp19_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp19_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp19_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp19_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp19_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp19_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp19_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp19_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp19_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp19_input.zq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp19_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp19_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp19_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp19_input.dr(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp19_input.zq(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp19_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp19_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp19_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp19_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp19_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp19_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp19_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp19_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp19_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp19_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp19_input.zq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp19_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp19_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp19_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp19_input.dr(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp19_input.zq(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp19_input.uq(tmp0_desc);
    return OperatorMcpCallView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
  };
  protoOf($serializer_84).nn = function () {
    return this.y2f_1;
  };
  protoOf($serializer_84).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_83;
  function $serializer_getInstance_83() {
    if ($serializer_instance_83 == null)
      new $serializer_84();
    return $serializer_instance_83;
  }
  function OperatorMcpCallView_init_$Init$(seen0, id, tokenId, operatorId, method, name, loggedArgsJson, status, errorCode, correlationId, durationMs, clientName, clientVersion, protocolVersion, ipAddress, atMs, serializationConstructorMarker, $this) {
    if (!(25471 === (25471 & seen0))) {
      throwMissingFieldException(seen0, 25471, $serializer_getInstance_83().y2f_1);
    }
    $this.a2g_1 = id;
    $this.b2g_1 = tokenId;
    $this.c2g_1 = operatorId;
    $this.d2g_1 = method;
    $this.e2g_1 = name;
    $this.f2g_1 = loggedArgsJson;
    $this.g2g_1 = status;
    if (0 === (seen0 & 128))
      $this.h2g_1 = null;
    else
      $this.h2g_1 = errorCode;
    $this.i2g_1 = correlationId;
    $this.j2g_1 = durationMs;
    if (0 === (seen0 & 1024))
      $this.k2g_1 = null;
    else
      $this.k2g_1 = clientName;
    if (0 === (seen0 & 2048))
      $this.l2g_1 = null;
    else
      $this.l2g_1 = clientVersion;
    if (0 === (seen0 & 4096))
      $this.m2g_1 = null;
    else
      $this.m2g_1 = protocolVersion;
    $this.n2g_1 = ipAddress;
    $this.o2g_1 = atMs;
    return $this;
  }
  function OperatorMcpCallView_init_$Create$(seen0, id, tokenId, operatorId, method, name, loggedArgsJson, status, errorCode, correlationId, durationMs, clientName, clientVersion, protocolVersion, ipAddress, atMs, serializationConstructorMarker) {
    return OperatorMcpCallView_init_$Init$(seen0, id, tokenId, operatorId, method, name, loggedArgsJson, status, errorCode, correlationId, durationMs, clientName, clientVersion, protocolVersion, ipAddress, atMs, serializationConstructorMarker, objectCreate(protoOf(OperatorMcpCallView)));
  }
  function OperatorMcpCallView(id, tokenId, operatorId, method, name, loggedArgsJson, status, errorCode, correlationId, durationMs, clientName, clientVersion, protocolVersion, ipAddress, atMs) {
    errorCode = errorCode === VOID ? null : errorCode;
    clientName = clientName === VOID ? null : clientName;
    clientVersion = clientVersion === VOID ? null : clientVersion;
    protocolVersion = protocolVersion === VOID ? null : protocolVersion;
    this.a2g_1 = id;
    this.b2g_1 = tokenId;
    this.c2g_1 = operatorId;
    this.d2g_1 = method;
    this.e2g_1 = name;
    this.f2g_1 = loggedArgsJson;
    this.g2g_1 = status;
    this.h2g_1 = errorCode;
    this.i2g_1 = correlationId;
    this.j2g_1 = durationMs;
    this.k2g_1 = clientName;
    this.l2g_1 = clientVersion;
    this.m2g_1 = protocolVersion;
    this.n2g_1 = ipAddress;
    this.o2g_1 = atMs;
  }
  protoOf(OperatorMcpCallView).toString = function () {
    return 'OperatorMcpCallView(id=' + this.a2g_1 + ', tokenId=' + this.b2g_1 + ', operatorId=' + this.c2g_1 + ', method=' + this.d2g_1 + ', name=' + this.e2g_1 + ', loggedArgsJson=' + this.f2g_1 + ', status=' + this.g2g_1 + ', errorCode=' + this.h2g_1 + ', correlationId=' + this.i2g_1 + ', durationMs=' + this.j2g_1.toString() + ', clientName=' + this.k2g_1 + ', clientVersion=' + this.l2g_1 + ', protocolVersion=' + this.m2g_1 + ', ipAddress=' + this.n2g_1 + ', atMs=' + this.o2g_1.toString() + ')';
  };
  protoOf(OperatorMcpCallView).hashCode = function () {
    var result = getStringHashCode(this.a2g_1);
    result = imul(result, 31) + getStringHashCode(this.b2g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c2g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d2g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e2g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f2g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g2g_1) | 0;
    result = imul(result, 31) + (this.h2g_1 == null ? 0 : getStringHashCode(this.h2g_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.i2g_1) | 0;
    result = imul(result, 31) + this.j2g_1.hashCode() | 0;
    result = imul(result, 31) + (this.k2g_1 == null ? 0 : getStringHashCode(this.k2g_1)) | 0;
    result = imul(result, 31) + (this.l2g_1 == null ? 0 : getStringHashCode(this.l2g_1)) | 0;
    result = imul(result, 31) + (this.m2g_1 == null ? 0 : getStringHashCode(this.m2g_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.n2g_1) | 0;
    result = imul(result, 31) + this.o2g_1.hashCode() | 0;
    return result;
  };
  protoOf(OperatorMcpCallView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OperatorMcpCallView))
      return false;
    var tmp0_other_with_cast = other instanceof OperatorMcpCallView ? other : THROW_CCE();
    if (!(this.a2g_1 === tmp0_other_with_cast.a2g_1))
      return false;
    if (!(this.b2g_1 === tmp0_other_with_cast.b2g_1))
      return false;
    if (!(this.c2g_1 === tmp0_other_with_cast.c2g_1))
      return false;
    if (!(this.d2g_1 === tmp0_other_with_cast.d2g_1))
      return false;
    if (!(this.e2g_1 === tmp0_other_with_cast.e2g_1))
      return false;
    if (!(this.f2g_1 === tmp0_other_with_cast.f2g_1))
      return false;
    if (!(this.g2g_1 === tmp0_other_with_cast.g2g_1))
      return false;
    if (!(this.h2g_1 == tmp0_other_with_cast.h2g_1))
      return false;
    if (!(this.i2g_1 === tmp0_other_with_cast.i2g_1))
      return false;
    if (!this.j2g_1.equals(tmp0_other_with_cast.j2g_1))
      return false;
    if (!(this.k2g_1 == tmp0_other_with_cast.k2g_1))
      return false;
    if (!(this.l2g_1 == tmp0_other_with_cast.l2g_1))
      return false;
    if (!(this.m2g_1 == tmp0_other_with_cast.m2g_1))
      return false;
    if (!(this.n2g_1 === tmp0_other_with_cast.n2g_1))
      return false;
    if (!this.o2g_1.equals(tmp0_other_with_cast.o2g_1))
      return false;
    return true;
  };
  function Companion_78() {
  }
  var Companion_instance_78;
  function Companion_getInstance_78() {
    return Companion_instance_78;
  }
  function $serializer_85() {
    $serializer_instance_84 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscribeRequest', this, 8);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('billingCycle', true);
    tmp0_serialDesc.gy('currency', true);
    tmp0_serialDesc.gy('periodStartMs', true);
    tmp0_serialDesc.gy('periodEndMs', true);
    tmp0_serialDesc.gy('status', true);
    tmp0_serialDesc.gy('expectedAccessVersion', true);
    this.p2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_85).q2g = function (encoder, value) {
    var tmp0_desc = this.p2g_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.r2g_1);
    tmp1_output.hs(tmp0_desc, 1, value.s2g_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.t2g_1 === 'monthly')) {
      tmp1_output.hs(tmp0_desc, 2, value.t2g_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.u2g_1 === 'EGP')) {
      tmp1_output.hs(tmp0_desc, 3, value.u2g_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.v2g_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.v2g_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.w2g_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.w2g_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.x2g_1 === 'trialing')) {
      tmp1_output.hs(tmp0_desc, 6, value.x2g_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.y2g_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.y2g_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_85).on = function (encoder, value) {
    return this.q2g(encoder, value instanceof SubscribeRequest ? value : THROW_CCE());
  };
  protoOf($serializer_85).pn = function (decoder) {
    var tmp0_desc = this.p2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.tq(tmp0_desc);
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return SubscribeRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_85).nn = function () {
    return this.p2g_1;
  };
  protoOf($serializer_85).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_84;
  function $serializer_getInstance_84() {
    if ($serializer_instance_84 == null)
      new $serializer_85();
    return $serializer_instance_84;
  }
  function SubscribeRequest_init_$Init$(seen0, tenantId, planKey, billingCycle, currency, periodStartMs, periodEndMs, status, expectedAccessVersion, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_84().p2g_1);
    }
    $this.r2g_1 = tenantId;
    $this.s2g_1 = planKey;
    if (0 === (seen0 & 4))
      $this.t2g_1 = 'monthly';
    else
      $this.t2g_1 = billingCycle;
    if (0 === (seen0 & 8))
      $this.u2g_1 = 'EGP';
    else
      $this.u2g_1 = currency;
    if (0 === (seen0 & 16))
      $this.v2g_1 = null;
    else
      $this.v2g_1 = periodStartMs;
    if (0 === (seen0 & 32))
      $this.w2g_1 = null;
    else
      $this.w2g_1 = periodEndMs;
    if (0 === (seen0 & 64))
      $this.x2g_1 = 'trialing';
    else
      $this.x2g_1 = status;
    if (0 === (seen0 & 128))
      $this.y2g_1 = null;
    else
      $this.y2g_1 = expectedAccessVersion;
    return $this;
  }
  function SubscribeRequest_init_$Create$(seen0, tenantId, planKey, billingCycle, currency, periodStartMs, periodEndMs, status, expectedAccessVersion, serializationConstructorMarker) {
    return SubscribeRequest_init_$Init$(seen0, tenantId, planKey, billingCycle, currency, periodStartMs, periodEndMs, status, expectedAccessVersion, serializationConstructorMarker, objectCreate(protoOf(SubscribeRequest)));
  }
  function SubscribeRequest(tenantId, planKey, billingCycle, currency, periodStartMs, periodEndMs, status, expectedAccessVersion) {
    billingCycle = billingCycle === VOID ? 'monthly' : billingCycle;
    currency = currency === VOID ? 'EGP' : currency;
    periodStartMs = periodStartMs === VOID ? null : periodStartMs;
    periodEndMs = periodEndMs === VOID ? null : periodEndMs;
    status = status === VOID ? 'trialing' : status;
    expectedAccessVersion = expectedAccessVersion === VOID ? null : expectedAccessVersion;
    this.r2g_1 = tenantId;
    this.s2g_1 = planKey;
    this.t2g_1 = billingCycle;
    this.u2g_1 = currency;
    this.v2g_1 = periodStartMs;
    this.w2g_1 = periodEndMs;
    this.x2g_1 = status;
    this.y2g_1 = expectedAccessVersion;
  }
  protoOf(SubscribeRequest).toString = function () {
    return 'SubscribeRequest(tenantId=' + this.r2g_1 + ', planKey=' + this.s2g_1 + ', billingCycle=' + this.t2g_1 + ', currency=' + this.u2g_1 + ', periodStartMs=' + toString_0(this.v2g_1) + ', periodEndMs=' + toString_0(this.w2g_1) + ', status=' + this.x2g_1 + ', expectedAccessVersion=' + toString_0(this.y2g_1) + ')';
  };
  protoOf(SubscribeRequest).hashCode = function () {
    var result = getStringHashCode(this.r2g_1);
    result = imul(result, 31) + getStringHashCode(this.s2g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t2g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u2g_1) | 0;
    result = imul(result, 31) + (this.v2g_1 == null ? 0 : this.v2g_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w2g_1 == null ? 0 : this.w2g_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.x2g_1) | 0;
    result = imul(result, 31) + (this.y2g_1 == null ? 0 : this.y2g_1.hashCode()) | 0;
    return result;
  };
  protoOf(SubscribeRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscribeRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SubscribeRequest ? other : THROW_CCE();
    if (!(this.r2g_1 === tmp0_other_with_cast.r2g_1))
      return false;
    if (!(this.s2g_1 === tmp0_other_with_cast.s2g_1))
      return false;
    if (!(this.t2g_1 === tmp0_other_with_cast.t2g_1))
      return false;
    if (!(this.u2g_1 === tmp0_other_with_cast.u2g_1))
      return false;
    if (!equals(this.v2g_1, tmp0_other_with_cast.v2g_1))
      return false;
    if (!equals(this.w2g_1, tmp0_other_with_cast.w2g_1))
      return false;
    if (!(this.x2g_1 === tmp0_other_with_cast.x2g_1))
      return false;
    if (!equals(this.y2g_1, tmp0_other_with_cast.y2g_1))
      return false;
    return true;
  };
  function Companion_79() {
  }
  var Companion_instance_79;
  function Companion_getInstance_79() {
    return Companion_instance_79;
  }
  function $serializer_86() {
    $serializer_instance_85 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ChangePlanRequest', this, 5);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('agreedPriceMinor', true);
    tmp0_serialDesc.gy('billingCycle', true);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('expectedAccessVersion', true);
    this.z2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_86).a2h = function (encoder, value) {
    var tmp0_desc = this.z2g_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.b2h_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.c2h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.c2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.d2h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.d2h_1);
    }
    tmp1_output.hs(tmp0_desc, 3, value.e2h_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.f2h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.f2h_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_86).on = function (encoder, value) {
    return this.a2h(encoder, value instanceof ChangePlanRequest ? value : THROW_CCE());
  };
  protoOf($serializer_86).pn = function (decoder) {
    var tmp0_desc = this.z2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return ChangePlanRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_86).nn = function () {
    return this.z2g_1;
  };
  protoOf($serializer_86).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_85;
  function $serializer_getInstance_85() {
    if ($serializer_instance_85 == null)
      new $serializer_86();
    return $serializer_instance_85;
  }
  function ChangePlanRequest_init_$Init$(seen0, planKey, agreedPriceMinor, billingCycle, reason, expectedAccessVersion, serializationConstructorMarker, $this) {
    if (!(9 === (9 & seen0))) {
      throwMissingFieldException(seen0, 9, $serializer_getInstance_85().z2g_1);
    }
    $this.b2h_1 = planKey;
    if (0 === (seen0 & 2))
      $this.c2h_1 = null;
    else
      $this.c2h_1 = agreedPriceMinor;
    if (0 === (seen0 & 4))
      $this.d2h_1 = null;
    else
      $this.d2h_1 = billingCycle;
    $this.e2h_1 = reason;
    if (0 === (seen0 & 16))
      $this.f2h_1 = null;
    else
      $this.f2h_1 = expectedAccessVersion;
    return $this;
  }
  function ChangePlanRequest_init_$Create$(seen0, planKey, agreedPriceMinor, billingCycle, reason, expectedAccessVersion, serializationConstructorMarker) {
    return ChangePlanRequest_init_$Init$(seen0, planKey, agreedPriceMinor, billingCycle, reason, expectedAccessVersion, serializationConstructorMarker, objectCreate(protoOf(ChangePlanRequest)));
  }
  function ChangePlanRequest(planKey, agreedPriceMinor, billingCycle, reason, expectedAccessVersion) {
    agreedPriceMinor = agreedPriceMinor === VOID ? null : agreedPriceMinor;
    billingCycle = billingCycle === VOID ? null : billingCycle;
    expectedAccessVersion = expectedAccessVersion === VOID ? null : expectedAccessVersion;
    this.b2h_1 = planKey;
    this.c2h_1 = agreedPriceMinor;
    this.d2h_1 = billingCycle;
    this.e2h_1 = reason;
    this.f2h_1 = expectedAccessVersion;
  }
  protoOf(ChangePlanRequest).toString = function () {
    return 'ChangePlanRequest(planKey=' + this.b2h_1 + ', agreedPriceMinor=' + toString_0(this.c2h_1) + ', billingCycle=' + this.d2h_1 + ', reason=' + this.e2h_1 + ', expectedAccessVersion=' + toString_0(this.f2h_1) + ')';
  };
  protoOf(ChangePlanRequest).hashCode = function () {
    var result = getStringHashCode(this.b2h_1);
    result = imul(result, 31) + (this.c2h_1 == null ? 0 : this.c2h_1.hashCode()) | 0;
    result = imul(result, 31) + (this.d2h_1 == null ? 0 : getStringHashCode(this.d2h_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.e2h_1) | 0;
    result = imul(result, 31) + (this.f2h_1 == null ? 0 : this.f2h_1.hashCode()) | 0;
    return result;
  };
  protoOf(ChangePlanRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ChangePlanRequest))
      return false;
    var tmp0_other_with_cast = other instanceof ChangePlanRequest ? other : THROW_CCE();
    if (!(this.b2h_1 === tmp0_other_with_cast.b2h_1))
      return false;
    if (!equals(this.c2h_1, tmp0_other_with_cast.c2h_1))
      return false;
    if (!(this.d2h_1 == tmp0_other_with_cast.d2h_1))
      return false;
    if (!(this.e2h_1 === tmp0_other_with_cast.e2h_1))
      return false;
    if (!equals(this.f2h_1, tmp0_other_with_cast.f2h_1))
      return false;
    return true;
  };
  function Companion_80() {
    Companion_instance_80 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g2h_1 = [null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_156()), null, null, null];
  }
  var Companion_instance_80;
  function Companion_getInstance_80() {
    if (Companion_instance_80 == null)
      new Companion_80();
    return Companion_instance_80;
  }
  function $serializer_87() {
    $serializer_instance_86 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RegistryLimit', this, 20);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('unit', false);
    tmp0_serialDesc.gy('period', false);
    tmp0_serialDesc.gy('defaultMode', false);
    tmp0_serialDesc.gy('moduleKey', false);
    tmp0_serialDesc.gy('sortOrder', false);
    tmp0_serialDesc.gy('unitCode', true);
    tmp0_serialDesc.gy('periodCode', true);
    tmp0_serialDesc.gy('supportedUnits', true);
    tmp0_serialDesc.gy('supportedPeriods', true);
    tmp0_serialDesc.gy('supportedPolicies', true);
    tmp0_serialDesc.gy('catalogPolicy', true);
    tmp0_serialDesc.gy('isLiveCount', true);
    tmp0_serialDesc.gy('currencies', true);
    tmp0_serialDesc.gy('plansFollowingCatalog', true);
    tmp0_serialDesc.gy('explicitPolicyPlans', true);
    tmp0_serialDesc.gy('affectedTenants', true);
    tmp0_serialDesc.gy('revision', true);
    this.h2h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_87).i2h = function (encoder, value) {
    var tmp0_desc = this.h2h_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_80().g2h_1;
    tmp1_output.hs(tmp0_desc, 0, value.j2h_1);
    tmp1_output.hs(tmp0_desc, 1, value.k2h_1);
    tmp1_output.hs(tmp0_desc, 2, value.l2h_1);
    tmp1_output.hs(tmp0_desc, 3, value.m2h_1);
    tmp1_output.hs(tmp0_desc, 4, value.n2h_1);
    tmp1_output.hs(tmp0_desc, 5, value.o2h_1);
    tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.p2h_1);
    tmp1_output.cs(tmp0_desc, 7, value.q2h_1);
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.r2h_1 === '')) {
      tmp1_output.hs(tmp0_desc, 8, value.r2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.s2h_1 === '')) {
      tmp1_output.hs(tmp0_desc, 9, value.s2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !equals(value.t2h_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 10, tmp2_cached[10], value.t2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !equals(value.u2h_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 11, tmp2_cached[11], value.u2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !equals(value.v2h_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 12, tmp2_cached[12], value.v2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.w2h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 13, StringSerializer_getInstance(), value.w2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !(value.x2h_1 === false)) {
      tmp1_output.zr(tmp0_desc, 14, value.x2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 15) ? true : !equals(value.y2h_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 15, tmp2_cached[15], value.y2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 16) ? true : !equals(value.z2h_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 16, tmp2_cached[16], value.z2h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 17) ? true : !(value.a2i_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 17, value.a2i_1);
    }
    if (tmp1_output.ps(tmp0_desc, 18) ? true : !(value.b2i_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 18, value.b2i_1);
    }
    if (tmp1_output.ps(tmp0_desc, 19) ? true : !(value.c2i_1 === '')) {
      tmp1_output.hs(tmp0_desc, 19, value.c2i_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_87).on = function (encoder, value) {
    return this.i2h(encoder, value instanceof RegistryLimit ? value : THROW_CCE());
  };
  protoOf($serializer_87).pn = function (decoder) {
    var tmp0_desc = this.h2h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = 0;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = false;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = 0;
    var tmp22_local18 = 0;
    var tmp23_local19 = null;
    var tmp24_input = decoder.tq(tmp0_desc);
    var tmp25_cached = Companion_getInstance_80().g2h_1;
    if (tmp24_input.ir()) {
      tmp4_local0 = tmp24_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp24_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp24_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp24_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp24_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp24_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp24_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp24_input.yq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp24_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp24_input.dr(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp24_input.fr(tmp0_desc, 10, tmp25_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp24_input.fr(tmp0_desc, 11, tmp25_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp24_input.fr(tmp0_desc, 12, tmp25_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp24_input.hr(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp24_input.vq(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp24_input.fr(tmp0_desc, 15, tmp25_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp24_input.fr(tmp0_desc, 16, tmp25_cached[16], tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp24_input.yq(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp24_input.yq(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp24_input.dr(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp24_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp24_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp24_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp24_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp24_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp24_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp24_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp24_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp24_input.yq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp24_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp24_input.dr(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp24_input.fr(tmp0_desc, 10, tmp25_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp24_input.fr(tmp0_desc, 11, tmp25_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp24_input.fr(tmp0_desc, 12, tmp25_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp24_input.hr(tmp0_desc, 13, StringSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp24_input.vq(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp24_input.fr(tmp0_desc, 15, tmp25_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp24_input.fr(tmp0_desc, 16, tmp25_cached[16], tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp24_input.yq(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp24_input.yq(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp24_input.dr(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp24_input.uq(tmp0_desc);
    return RegistryLimit_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, null);
  };
  protoOf($serializer_87).nn = function () {
    return this.h2h_1;
  };
  protoOf($serializer_87).vy = function () {
    var tmp0_cached = Companion_getInstance_80().g2h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[10], tmp0_cached[11], tmp0_cached[12], get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), tmp0_cached[15], tmp0_cached[16], IntSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_86;
  function $serializer_getInstance_86() {
    if ($serializer_instance_86 == null)
      new $serializer_87();
    return $serializer_instance_86;
  }
  function RegistryLimit_init_$Init$(seen0, key, nameEn, nameAr, unit, period, defaultMode, moduleKey, sortOrder, unitCode, periodCode, supportedUnits, supportedPeriods, supportedPolicies, catalogPolicy, isLiveCount, currencies, plansFollowingCatalog, explicitPolicyPlans, affectedTenants, revision, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_86().h2h_1);
    }
    $this.j2h_1 = key;
    $this.k2h_1 = nameEn;
    $this.l2h_1 = nameAr;
    $this.m2h_1 = unit;
    $this.n2h_1 = period;
    $this.o2h_1 = defaultMode;
    $this.p2h_1 = moduleKey;
    $this.q2h_1 = sortOrder;
    if (0 === (seen0 & 256))
      $this.r2h_1 = '';
    else
      $this.r2h_1 = unitCode;
    if (0 === (seen0 & 512))
      $this.s2h_1 = '';
    else
      $this.s2h_1 = periodCode;
    if (0 === (seen0 & 1024))
      $this.t2h_1 = emptyList();
    else
      $this.t2h_1 = supportedUnits;
    if (0 === (seen0 & 2048))
      $this.u2h_1 = emptyList();
    else
      $this.u2h_1 = supportedPeriods;
    if (0 === (seen0 & 4096))
      $this.v2h_1 = emptyList();
    else
      $this.v2h_1 = supportedPolicies;
    if (0 === (seen0 & 8192))
      $this.w2h_1 = null;
    else
      $this.w2h_1 = catalogPolicy;
    if (0 === (seen0 & 16384))
      $this.x2h_1 = false;
    else
      $this.x2h_1 = isLiveCount;
    if (0 === (seen0 & 32768))
      $this.y2h_1 = emptyList();
    else
      $this.y2h_1 = currencies;
    if (0 === (seen0 & 65536))
      $this.z2h_1 = emptyList();
    else
      $this.z2h_1 = plansFollowingCatalog;
    if (0 === (seen0 & 131072))
      $this.a2i_1 = 0;
    else
      $this.a2i_1 = explicitPolicyPlans;
    if (0 === (seen0 & 262144))
      $this.b2i_1 = 0;
    else
      $this.b2i_1 = affectedTenants;
    if (0 === (seen0 & 524288))
      $this.c2i_1 = '';
    else
      $this.c2i_1 = revision;
    return $this;
  }
  function RegistryLimit_init_$Create$(seen0, key, nameEn, nameAr, unit, period, defaultMode, moduleKey, sortOrder, unitCode, periodCode, supportedUnits, supportedPeriods, supportedPolicies, catalogPolicy, isLiveCount, currencies, plansFollowingCatalog, explicitPolicyPlans, affectedTenants, revision, serializationConstructorMarker) {
    return RegistryLimit_init_$Init$(seen0, key, nameEn, nameAr, unit, period, defaultMode, moduleKey, sortOrder, unitCode, periodCode, supportedUnits, supportedPeriods, supportedPolicies, catalogPolicy, isLiveCount, currencies, plansFollowingCatalog, explicitPolicyPlans, affectedTenants, revision, serializationConstructorMarker, objectCreate(protoOf(RegistryLimit)));
  }
  function RegistryLimit() {
  }
  protoOf(RegistryLimit).toString = function () {
    return 'RegistryLimit(key=' + this.j2h_1 + ', nameEn=' + this.k2h_1 + ', nameAr=' + this.l2h_1 + ', unit=' + this.m2h_1 + ', period=' + this.n2h_1 + ', defaultMode=' + this.o2h_1 + ', moduleKey=' + this.p2h_1 + ', sortOrder=' + this.q2h_1 + ', unitCode=' + this.r2h_1 + ', periodCode=' + this.s2h_1 + ', supportedUnits=' + toString(this.t2h_1) + ', supportedPeriods=' + toString(this.u2h_1) + ', supportedPolicies=' + toString(this.v2h_1) + ', catalogPolicy=' + this.w2h_1 + ', isLiveCount=' + this.x2h_1 + ', currencies=' + toString(this.y2h_1) + ', plansFollowingCatalog=' + toString(this.z2h_1) + ', explicitPolicyPlans=' + this.a2i_1 + ', affectedTenants=' + this.b2i_1 + ', revision=' + this.c2i_1 + ')';
  };
  protoOf(RegistryLimit).hashCode = function () {
    var result = getStringHashCode(this.j2h_1);
    result = imul(result, 31) + getStringHashCode(this.k2h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l2h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n2h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o2h_1) | 0;
    result = imul(result, 31) + (this.p2h_1 == null ? 0 : getStringHashCode(this.p2h_1)) | 0;
    result = imul(result, 31) + this.q2h_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.r2h_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s2h_1) | 0;
    result = imul(result, 31) + hashCode(this.t2h_1) | 0;
    result = imul(result, 31) + hashCode(this.u2h_1) | 0;
    result = imul(result, 31) + hashCode(this.v2h_1) | 0;
    result = imul(result, 31) + (this.w2h_1 == null ? 0 : getStringHashCode(this.w2h_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x2h_1) | 0;
    result = imul(result, 31) + hashCode(this.y2h_1) | 0;
    result = imul(result, 31) + hashCode(this.z2h_1) | 0;
    result = imul(result, 31) + this.a2i_1 | 0;
    result = imul(result, 31) + this.b2i_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.c2i_1) | 0;
    return result;
  };
  protoOf(RegistryLimit).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegistryLimit))
      return false;
    var tmp0_other_with_cast = other instanceof RegistryLimit ? other : THROW_CCE();
    if (!(this.j2h_1 === tmp0_other_with_cast.j2h_1))
      return false;
    if (!(this.k2h_1 === tmp0_other_with_cast.k2h_1))
      return false;
    if (!(this.l2h_1 === tmp0_other_with_cast.l2h_1))
      return false;
    if (!(this.m2h_1 === tmp0_other_with_cast.m2h_1))
      return false;
    if (!(this.n2h_1 === tmp0_other_with_cast.n2h_1))
      return false;
    if (!(this.o2h_1 === tmp0_other_with_cast.o2h_1))
      return false;
    if (!(this.p2h_1 == tmp0_other_with_cast.p2h_1))
      return false;
    if (!(this.q2h_1 === tmp0_other_with_cast.q2h_1))
      return false;
    if (!(this.r2h_1 === tmp0_other_with_cast.r2h_1))
      return false;
    if (!(this.s2h_1 === tmp0_other_with_cast.s2h_1))
      return false;
    if (!equals(this.t2h_1, tmp0_other_with_cast.t2h_1))
      return false;
    if (!equals(this.u2h_1, tmp0_other_with_cast.u2h_1))
      return false;
    if (!equals(this.v2h_1, tmp0_other_with_cast.v2h_1))
      return false;
    if (!(this.w2h_1 == tmp0_other_with_cast.w2h_1))
      return false;
    if (!(this.x2h_1 === tmp0_other_with_cast.x2h_1))
      return false;
    if (!equals(this.y2h_1, tmp0_other_with_cast.y2h_1))
      return false;
    if (!equals(this.z2h_1, tmp0_other_with_cast.z2h_1))
      return false;
    if (!(this.a2i_1 === tmp0_other_with_cast.a2i_1))
      return false;
    if (!(this.b2i_1 === tmp0_other_with_cast.b2i_1))
      return false;
    if (!(this.c2i_1 === tmp0_other_with_cast.c2i_1))
      return false;
    return true;
  };
  function Companion_81() {
  }
  var Companion_instance_81;
  function Companion_getInstance_81() {
    return Companion_instance_81;
  }
  function $serializer_88() {
    $serializer_instance_87 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanPriceView', this, 3);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('billingCycle', false);
    tmp0_serialDesc.gy('amountMinor', false);
    this.d2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_88).e2i = function (encoder, value) {
    var tmp0_desc = this.d2i_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.f2i_1);
    tmp1_output.hs(tmp0_desc, 1, value.g2i_1);
    tmp1_output.ds(tmp0_desc, 2, value.h2i_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_88).on = function (encoder, value) {
    return this.e2i(encoder, value instanceof PlanPriceView ? value : THROW_CCE());
  };
  protoOf($serializer_88).pn = function (decoder) {
    var tmp0_desc = this.d2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return PlanPriceView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_88).nn = function () {
    return this.d2i_1;
  };
  protoOf($serializer_88).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_87;
  function $serializer_getInstance_87() {
    if ($serializer_instance_87 == null)
      new $serializer_88();
    return $serializer_instance_87;
  }
  function PlanPriceView_init_$Init$(seen0, currency, billingCycle, amountMinor, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_87().d2i_1);
    }
    $this.f2i_1 = currency;
    $this.g2i_1 = billingCycle;
    $this.h2i_1 = amountMinor;
    return $this;
  }
  function PlanPriceView_init_$Create$(seen0, currency, billingCycle, amountMinor, serializationConstructorMarker) {
    return PlanPriceView_init_$Init$(seen0, currency, billingCycle, amountMinor, serializationConstructorMarker, objectCreate(protoOf(PlanPriceView)));
  }
  function PlanPriceView(currency, billingCycle, amountMinor) {
    this.f2i_1 = currency;
    this.g2i_1 = billingCycle;
    this.h2i_1 = amountMinor;
  }
  protoOf(PlanPriceView).toString = function () {
    return 'PlanPriceView(currency=' + this.f2i_1 + ', billingCycle=' + this.g2i_1 + ', amountMinor=' + this.h2i_1.toString() + ')';
  };
  protoOf(PlanPriceView).hashCode = function () {
    var result = getStringHashCode(this.f2i_1);
    result = imul(result, 31) + getStringHashCode(this.g2i_1) | 0;
    result = imul(result, 31) + this.h2i_1.hashCode() | 0;
    return result;
  };
  protoOf(PlanPriceView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanPriceView))
      return false;
    var tmp0_other_with_cast = other instanceof PlanPriceView ? other : THROW_CCE();
    if (!(this.f2i_1 === tmp0_other_with_cast.f2i_1))
      return false;
    if (!(this.g2i_1 === tmp0_other_with_cast.g2i_1))
      return false;
    if (!this.h2i_1.equals(tmp0_other_with_cast.h2i_1))
      return false;
    return true;
  };
  function Companion_82() {
  }
  var Companion_instance_82;
  function Companion_getInstance_82() {
    return Companion_instance_82;
  }
  function $serializer_89() {
    $serializer_instance_88 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanLimitValue', this, 5);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('value', true);
    tmp0_serialDesc.gy('unlimited', false);
    tmp0_serialDesc.gy('mode', false);
    tmp0_serialDesc.gy('policy', true);
    this.i2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_89).j2i = function (encoder, value) {
    var tmp0_desc = this.i2i_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.k2i_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.l2i_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.l2i_1);
    }
    tmp1_output.zr(tmp0_desc, 2, value.m2i_1);
    tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.n2i_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.o2i_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.o2i_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_89).on = function (encoder, value) {
    return this.j2i(encoder, value instanceof PlanLimitValue ? value : THROW_CCE());
  };
  protoOf($serializer_89).pn = function (decoder) {
    var tmp0_desc = this.i2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return PlanLimitValue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_89).nn = function () {
    return this.i2i_1;
  };
  protoOf($serializer_89).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_88;
  function $serializer_getInstance_88() {
    if ($serializer_instance_88 == null)
      new $serializer_89();
    return $serializer_instance_88;
  }
  function PlanLimitValue_init_$Init$(seen0, limitKey, value, unlimited, mode, policy, serializationConstructorMarker, $this) {
    if (!(13 === (13 & seen0))) {
      throwMissingFieldException(seen0, 13, $serializer_getInstance_88().i2i_1);
    }
    $this.k2i_1 = limitKey;
    if (0 === (seen0 & 2))
      $this.l2i_1 = null;
    else
      $this.l2i_1 = value;
    $this.m2i_1 = unlimited;
    $this.n2i_1 = mode;
    if (0 === (seen0 & 16))
      $this.o2i_1 = null;
    else
      $this.o2i_1 = policy;
    return $this;
  }
  function PlanLimitValue_init_$Create$(seen0, limitKey, value, unlimited, mode, policy, serializationConstructorMarker) {
    return PlanLimitValue_init_$Init$(seen0, limitKey, value, unlimited, mode, policy, serializationConstructorMarker, objectCreate(protoOf(PlanLimitValue)));
  }
  function PlanLimitValue(limitKey, value, unlimited, mode, policy) {
    value = value === VOID ? null : value;
    policy = policy === VOID ? null : policy;
    this.k2i_1 = limitKey;
    this.l2i_1 = value;
    this.m2i_1 = unlimited;
    this.n2i_1 = mode;
    this.o2i_1 = policy;
  }
  protoOf(PlanLimitValue).toString = function () {
    return 'PlanLimitValue(limitKey=' + this.k2i_1 + ', value=' + toString_0(this.l2i_1) + ', unlimited=' + this.m2i_1 + ', mode=' + this.n2i_1 + ', policy=' + this.o2i_1 + ')';
  };
  protoOf(PlanLimitValue).hashCode = function () {
    var result = getStringHashCode(this.k2i_1);
    result = imul(result, 31) + (this.l2i_1 == null ? 0 : this.l2i_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m2i_1) | 0;
    result = imul(result, 31) + (this.n2i_1 == null ? 0 : getStringHashCode(this.n2i_1)) | 0;
    result = imul(result, 31) + (this.o2i_1 == null ? 0 : getStringHashCode(this.o2i_1)) | 0;
    return result;
  };
  protoOf(PlanLimitValue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanLimitValue))
      return false;
    var tmp0_other_with_cast = other instanceof PlanLimitValue ? other : THROW_CCE();
    if (!(this.k2i_1 === tmp0_other_with_cast.k2i_1))
      return false;
    if (!equals(this.l2i_1, tmp0_other_with_cast.l2i_1))
      return false;
    if (!(this.m2i_1 === tmp0_other_with_cast.m2i_1))
      return false;
    if (!(this.n2i_1 == tmp0_other_with_cast.n2i_1))
      return false;
    if (!(this.o2i_1 == tmp0_other_with_cast.o2i_1))
      return false;
    return true;
  };
  function $serializer_90() {
    $serializer_instance_89 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ExpiringSubscription', this, 6);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('periodEndMs', false);
    tmp0_serialDesc.gy('daysRemaining', false);
    this.p2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_90).q2i = function (encoder, value) {
    var tmp0_desc = this.p2i_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.r2i_1);
    tmp1_output.hs(tmp0_desc, 1, value.s2i_1);
    tmp1_output.hs(tmp0_desc, 2, value.t2i_1);
    tmp1_output.hs(tmp0_desc, 3, value.u2i_1);
    tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.v2i_1);
    tmp1_output.ls(tmp0_desc, 5, IntSerializer_getInstance(), value.w2i_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_90).on = function (encoder, value) {
    return this.q2i(encoder, value instanceof ExpiringSubscription ? value : THROW_CCE());
  };
  protoOf($serializer_90).pn = function (decoder) {
    var tmp0_desc = this.p2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return ExpiringSubscription_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_90).nn = function () {
    return this.p2i_1;
  };
  protoOf($serializer_90).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
  };
  var $serializer_instance_89;
  function $serializer_getInstance_89() {
    if ($serializer_instance_89 == null)
      new $serializer_90();
    return $serializer_instance_89;
  }
  function ExpiringSubscription_init_$Init$(seen0, tenantId, tenantName, planKey, status, periodEndMs, daysRemaining, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_89().p2i_1);
    }
    $this.r2i_1 = tenantId;
    $this.s2i_1 = tenantName;
    $this.t2i_1 = planKey;
    $this.u2i_1 = status;
    $this.v2i_1 = periodEndMs;
    $this.w2i_1 = daysRemaining;
    return $this;
  }
  function ExpiringSubscription_init_$Create$(seen0, tenantId, tenantName, planKey, status, periodEndMs, daysRemaining, serializationConstructorMarker) {
    return ExpiringSubscription_init_$Init$(seen0, tenantId, tenantName, planKey, status, periodEndMs, daysRemaining, serializationConstructorMarker, objectCreate(protoOf(ExpiringSubscription)));
  }
  function ExpiringSubscription() {
  }
  protoOf(ExpiringSubscription).toString = function () {
    return 'ExpiringSubscription(tenantId=' + this.r2i_1 + ', tenantName=' + this.s2i_1 + ', planKey=' + this.t2i_1 + ', status=' + this.u2i_1 + ', periodEndMs=' + toString_0(this.v2i_1) + ', daysRemaining=' + this.w2i_1 + ')';
  };
  protoOf(ExpiringSubscription).hashCode = function () {
    var result = getStringHashCode(this.r2i_1);
    result = imul(result, 31) + getStringHashCode(this.s2i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t2i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u2i_1) | 0;
    result = imul(result, 31) + (this.v2i_1 == null ? 0 : this.v2i_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w2i_1 == null ? 0 : this.w2i_1) | 0;
    return result;
  };
  protoOf(ExpiringSubscription).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ExpiringSubscription))
      return false;
    var tmp0_other_with_cast = other instanceof ExpiringSubscription ? other : THROW_CCE();
    if (!(this.r2i_1 === tmp0_other_with_cast.r2i_1))
      return false;
    if (!(this.s2i_1 === tmp0_other_with_cast.s2i_1))
      return false;
    if (!(this.t2i_1 === tmp0_other_with_cast.t2i_1))
      return false;
    if (!(this.u2i_1 === tmp0_other_with_cast.u2i_1))
      return false;
    if (!equals(this.v2i_1, tmp0_other_with_cast.v2i_1))
      return false;
    if (!(this.w2i_1 == tmp0_other_with_cast.w2i_1))
      return false;
    return true;
  };
  function $serializer_91() {
    $serializer_instance_90 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.QuotaPressureSummary', this, 5);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('overage', false);
    tmp0_serialDesc.gy('windowStartMs', false);
    this.x2i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_91).y2i = function (encoder, value) {
    var tmp0_desc = this.x2i_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.z2i_1);
    tmp1_output.hs(tmp0_desc, 1, value.a2j_1);
    tmp1_output.hs(tmp0_desc, 2, value.b2j_1);
    tmp1_output.ds(tmp0_desc, 3, value.c2j_1);
    tmp1_output.ds(tmp0_desc, 4, value.d2j_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_91).on = function (encoder, value) {
    return this.y2i(encoder, value instanceof QuotaPressureSummary ? value : THROW_CCE());
  };
  protoOf($serializer_91).pn = function (decoder) {
    var tmp0_desc = this.x2i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = new Long(0, 0);
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return QuotaPressureSummary_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_91).nn = function () {
    return this.x2i_1;
  };
  protoOf($serializer_91).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_90;
  function $serializer_getInstance_90() {
    if ($serializer_instance_90 == null)
      new $serializer_91();
    return $serializer_instance_90;
  }
  function QuotaPressureSummary_init_$Init$(seen0, limitKey, tenantId, tenantName, overage, windowStartMs, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_90().x2i_1);
    }
    $this.z2i_1 = limitKey;
    $this.a2j_1 = tenantId;
    $this.b2j_1 = tenantName;
    $this.c2j_1 = overage;
    $this.d2j_1 = windowStartMs;
    return $this;
  }
  function QuotaPressureSummary_init_$Create$(seen0, limitKey, tenantId, tenantName, overage, windowStartMs, serializationConstructorMarker) {
    return QuotaPressureSummary_init_$Init$(seen0, limitKey, tenantId, tenantName, overage, windowStartMs, serializationConstructorMarker, objectCreate(protoOf(QuotaPressureSummary)));
  }
  function QuotaPressureSummary() {
  }
  protoOf(QuotaPressureSummary).toString = function () {
    return 'QuotaPressureSummary(limitKey=' + this.z2i_1 + ', tenantId=' + this.a2j_1 + ', tenantName=' + this.b2j_1 + ', overage=' + this.c2j_1.toString() + ', windowStartMs=' + this.d2j_1.toString() + ')';
  };
  protoOf(QuotaPressureSummary).hashCode = function () {
    var result = getStringHashCode(this.z2i_1);
    result = imul(result, 31) + getStringHashCode(this.a2j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b2j_1) | 0;
    result = imul(result, 31) + this.c2j_1.hashCode() | 0;
    result = imul(result, 31) + this.d2j_1.hashCode() | 0;
    return result;
  };
  protoOf(QuotaPressureSummary).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QuotaPressureSummary))
      return false;
    var tmp0_other_with_cast = other instanceof QuotaPressureSummary ? other : THROW_CCE();
    if (!(this.z2i_1 === tmp0_other_with_cast.z2i_1))
      return false;
    if (!(this.a2j_1 === tmp0_other_with_cast.a2j_1))
      return false;
    if (!(this.b2j_1 === tmp0_other_with_cast.b2j_1))
      return false;
    if (!this.c2j_1.equals(tmp0_other_with_cast.c2j_1))
      return false;
    if (!this.d2j_1.equals(tmp0_other_with_cast.d2j_1))
      return false;
    return true;
  };
  function $serializer_92() {
    $serializer_instance_91 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ProviderHealth', this, 4);
    tmp0_serialDesc.gy('provider', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('detail', true);
    tmp0_serialDesc.gy('checkedAtMs', true);
    this.e2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_92).f2j = function (encoder, value) {
    var tmp0_desc = this.e2j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.g2j_1);
    tmp1_output.hs(tmp0_desc, 1, value.h2j_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.i2j_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.i2j_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.j2j_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.j2j_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_92).on = function (encoder, value) {
    return this.f2j(encoder, value instanceof ProviderHealth ? value : THROW_CCE());
  };
  protoOf($serializer_92).pn = function (decoder) {
    var tmp0_desc = this.e2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return ProviderHealth_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_92).nn = function () {
    return this.e2j_1;
  };
  protoOf($serializer_92).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_91;
  function $serializer_getInstance_91() {
    if ($serializer_instance_91 == null)
      new $serializer_92();
    return $serializer_instance_91;
  }
  function ProviderHealth_init_$Init$(seen0, provider, state, detail, checkedAtMs, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_91().e2j_1);
    }
    $this.g2j_1 = provider;
    $this.h2j_1 = state;
    if (0 === (seen0 & 4))
      $this.i2j_1 = null;
    else
      $this.i2j_1 = detail;
    if (0 === (seen0 & 8))
      $this.j2j_1 = null;
    else
      $this.j2j_1 = checkedAtMs;
    return $this;
  }
  function ProviderHealth_init_$Create$(seen0, provider, state, detail, checkedAtMs, serializationConstructorMarker) {
    return ProviderHealth_init_$Init$(seen0, provider, state, detail, checkedAtMs, serializationConstructorMarker, objectCreate(protoOf(ProviderHealth)));
  }
  function ProviderHealth() {
  }
  protoOf(ProviderHealth).toString = function () {
    return 'ProviderHealth(provider=' + this.g2j_1 + ', state=' + this.h2j_1 + ', detail=' + this.i2j_1 + ', checkedAtMs=' + toString_0(this.j2j_1) + ')';
  };
  protoOf(ProviderHealth).hashCode = function () {
    var result = getStringHashCode(this.g2j_1);
    result = imul(result, 31) + getStringHashCode(this.h2j_1) | 0;
    result = imul(result, 31) + (this.i2j_1 == null ? 0 : getStringHashCode(this.i2j_1)) | 0;
    result = imul(result, 31) + (this.j2j_1 == null ? 0 : this.j2j_1.hashCode()) | 0;
    return result;
  };
  protoOf(ProviderHealth).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProviderHealth))
      return false;
    var tmp0_other_with_cast = other instanceof ProviderHealth ? other : THROW_CCE();
    if (!(this.g2j_1 === tmp0_other_with_cast.g2j_1))
      return false;
    if (!(this.h2j_1 === tmp0_other_with_cast.h2j_1))
      return false;
    if (!(this.i2j_1 == tmp0_other_with_cast.i2j_1))
      return false;
    if (!equals(this.j2j_1, tmp0_other_with_cast.j2j_1))
      return false;
    return true;
  };
  function $serializer_93() {
    $serializer_instance_92 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ProvisioningStepView', this, 4);
    tmp0_serialDesc.gy('step', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('detail', true);
    tmp0_serialDesc.gy('atMs', false);
    this.k2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_93).l2j = function (encoder, value) {
    var tmp0_desc = this.k2j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.m2j_1);
    tmp1_output.hs(tmp0_desc, 1, value.n2j_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.o2j_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.o2j_1);
    }
    tmp1_output.ds(tmp0_desc, 3, value.p2j_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_93).on = function (encoder, value) {
    return this.l2j(encoder, value instanceof ProvisioningStepView ? value : THROW_CCE());
  };
  protoOf($serializer_93).pn = function (decoder) {
    var tmp0_desc = this.k2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return ProvisioningStepView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_93).nn = function () {
    return this.k2j_1;
  };
  protoOf($serializer_93).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance()];
  };
  var $serializer_instance_92;
  function $serializer_getInstance_92() {
    if ($serializer_instance_92 == null)
      new $serializer_93();
    return $serializer_instance_92;
  }
  function ProvisioningStepView_init_$Init$(seen0, step, state, detail, atMs, serializationConstructorMarker, $this) {
    if (!(11 === (11 & seen0))) {
      throwMissingFieldException(seen0, 11, $serializer_getInstance_92().k2j_1);
    }
    $this.m2j_1 = step;
    $this.n2j_1 = state;
    if (0 === (seen0 & 4))
      $this.o2j_1 = null;
    else
      $this.o2j_1 = detail;
    $this.p2j_1 = atMs;
    return $this;
  }
  function ProvisioningStepView_init_$Create$(seen0, step, state, detail, atMs, serializationConstructorMarker) {
    return ProvisioningStepView_init_$Init$(seen0, step, state, detail, atMs, serializationConstructorMarker, objectCreate(protoOf(ProvisioningStepView)));
  }
  function ProvisioningStepView() {
  }
  protoOf(ProvisioningStepView).toString = function () {
    return 'ProvisioningStepView(step=' + this.m2j_1 + ', state=' + this.n2j_1 + ', detail=' + this.o2j_1 + ', atMs=' + this.p2j_1.toString() + ')';
  };
  protoOf(ProvisioningStepView).hashCode = function () {
    var result = getStringHashCode(this.m2j_1);
    result = imul(result, 31) + getStringHashCode(this.n2j_1) | 0;
    result = imul(result, 31) + (this.o2j_1 == null ? 0 : getStringHashCode(this.o2j_1)) | 0;
    result = imul(result, 31) + this.p2j_1.hashCode() | 0;
    return result;
  };
  protoOf(ProvisioningStepView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ProvisioningStepView))
      return false;
    var tmp0_other_with_cast = other instanceof ProvisioningStepView ? other : THROW_CCE();
    if (!(this.m2j_1 === tmp0_other_with_cast.m2j_1))
      return false;
    if (!(this.n2j_1 === tmp0_other_with_cast.n2j_1))
      return false;
    if (!(this.o2j_1 == tmp0_other_with_cast.o2j_1))
      return false;
    if (!this.p2j_1.equals(tmp0_other_with_cast.p2j_1))
      return false;
    return true;
  };
  function Companion_83() {
    Companion_instance_83 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q2j_1 = [null, null, new ArrayListSerializer($serializer_getInstance_104()), new ArrayListSerializer($serializer_getInstance_105())];
  }
  var Companion_instance_83;
  function Companion_getInstance_83() {
    if (Companion_instance_83 == null)
      new Companion_83();
    return Companion_instance_83;
  }
  function $serializer_94() {
    $serializer_instance_93 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.EntitlementView', this, 4);
    tmp0_serialDesc.gy('version', false);
    tmp0_serialDesc.gy('computedAtMs', false);
    tmp0_serialDesc.gy('modules', false);
    tmp0_serialDesc.gy('limits', false);
    this.r2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_94).s2j = function (encoder, value) {
    var tmp0_desc = this.r2j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_83().q2j_1;
    tmp1_output.ds(tmp0_desc, 0, value.t2j_1);
    tmp1_output.ds(tmp0_desc, 1, value.u2j_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.v2j_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.w2j_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_94).on = function (encoder, value) {
    return this.s2j(encoder, value instanceof EntitlementView ? value : THROW_CCE());
  };
  protoOf($serializer_94).pn = function (decoder) {
    var tmp0_desc = this.r2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_83().q2j_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return EntitlementView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_94).nn = function () {
    return this.r2j_1;
  };
  protoOf($serializer_94).vy = function () {
    var tmp0_cached = Companion_getInstance_83().q2j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[2], tmp0_cached[3]];
  };
  var $serializer_instance_93;
  function $serializer_getInstance_93() {
    if ($serializer_instance_93 == null)
      new $serializer_94();
    return $serializer_instance_93;
  }
  function EntitlementView_init_$Init$(seen0, version, computedAtMs, modules, limits, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_93().r2j_1);
    }
    $this.t2j_1 = version;
    $this.u2j_1 = computedAtMs;
    $this.v2j_1 = modules;
    $this.w2j_1 = limits;
    return $this;
  }
  function EntitlementView_init_$Create$(seen0, version, computedAtMs, modules, limits, serializationConstructorMarker) {
    return EntitlementView_init_$Init$(seen0, version, computedAtMs, modules, limits, serializationConstructorMarker, objectCreate(protoOf(EntitlementView)));
  }
  function EntitlementView() {
  }
  protoOf(EntitlementView).toString = function () {
    return 'EntitlementView(version=' + this.t2j_1.toString() + ', computedAtMs=' + this.u2j_1.toString() + ', modules=' + toString(this.v2j_1) + ', limits=' + toString(this.w2j_1) + ')';
  };
  protoOf(EntitlementView).hashCode = function () {
    var result = this.t2j_1.hashCode();
    result = imul(result, 31) + this.u2j_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.v2j_1) | 0;
    result = imul(result, 31) + hashCode(this.w2j_1) | 0;
    return result;
  };
  protoOf(EntitlementView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EntitlementView))
      return false;
    var tmp0_other_with_cast = other instanceof EntitlementView ? other : THROW_CCE();
    if (!this.t2j_1.equals(tmp0_other_with_cast.t2j_1))
      return false;
    if (!this.u2j_1.equals(tmp0_other_with_cast.u2j_1))
      return false;
    if (!equals(this.v2j_1, tmp0_other_with_cast.v2j_1))
      return false;
    if (!equals(this.w2j_1, tmp0_other_with_cast.w2j_1))
      return false;
    return true;
  };
  function $serializer_95() {
    $serializer_instance_94 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.FeatureFlagOverride', this, 5);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('enabled', false);
    tmp0_serialDesc.gy('setBy', false);
    tmp0_serialDesc.gy('setAtMs', false);
    this.x2j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_95).y2j = function (encoder, value) {
    var tmp0_desc = this.x2j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.z2j_1);
    tmp1_output.hs(tmp0_desc, 1, value.a2k_1);
    tmp1_output.zr(tmp0_desc, 2, value.b2k_1);
    tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.c2k_1);
    tmp1_output.ds(tmp0_desc, 4, value.d2k_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_95).on = function (encoder, value) {
    return this.y2j(encoder, value instanceof FeatureFlagOverride ? value : THROW_CCE());
  };
  protoOf($serializer_95).pn = function (decoder) {
    var tmp0_desc = this.x2j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return FeatureFlagOverride_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_95).nn = function () {
    return this.x2j_1;
  };
  protoOf($serializer_95).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance()];
  };
  var $serializer_instance_94;
  function $serializer_getInstance_94() {
    if ($serializer_instance_94 == null)
      new $serializer_95();
    return $serializer_instance_94;
  }
  function FeatureFlagOverride_init_$Init$(seen0, tenantId, tenantName, enabled, setBy, setAtMs, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_94().x2j_1);
    }
    $this.z2j_1 = tenantId;
    $this.a2k_1 = tenantName;
    $this.b2k_1 = enabled;
    $this.c2k_1 = setBy;
    $this.d2k_1 = setAtMs;
    return $this;
  }
  function FeatureFlagOverride_init_$Create$(seen0, tenantId, tenantName, enabled, setBy, setAtMs, serializationConstructorMarker) {
    return FeatureFlagOverride_init_$Init$(seen0, tenantId, tenantName, enabled, setBy, setAtMs, serializationConstructorMarker, objectCreate(protoOf(FeatureFlagOverride)));
  }
  function FeatureFlagOverride() {
  }
  protoOf(FeatureFlagOverride).toString = function () {
    return 'FeatureFlagOverride(tenantId=' + this.z2j_1 + ', tenantName=' + this.a2k_1 + ', enabled=' + this.b2k_1 + ', setBy=' + this.c2k_1 + ', setAtMs=' + this.d2k_1.toString() + ')';
  };
  protoOf(FeatureFlagOverride).hashCode = function () {
    var result = getStringHashCode(this.z2j_1);
    result = imul(result, 31) + getStringHashCode(this.a2k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b2k_1) | 0;
    result = imul(result, 31) + (this.c2k_1 == null ? 0 : getStringHashCode(this.c2k_1)) | 0;
    result = imul(result, 31) + this.d2k_1.hashCode() | 0;
    return result;
  };
  protoOf(FeatureFlagOverride).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FeatureFlagOverride))
      return false;
    var tmp0_other_with_cast = other instanceof FeatureFlagOverride ? other : THROW_CCE();
    if (!(this.z2j_1 === tmp0_other_with_cast.z2j_1))
      return false;
    if (!(this.a2k_1 === tmp0_other_with_cast.a2k_1))
      return false;
    if (!(this.b2k_1 === tmp0_other_with_cast.b2k_1))
      return false;
    if (!(this.c2k_1 == tmp0_other_with_cast.c2k_1))
      return false;
    if (!this.d2k_1.equals(tmp0_other_with_cast.d2k_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_0($this) {
    return $this.j20_1.w();
  }
  function LoginOutcome$Companion$_anonymous__tdh19i() {
    return createSimpleEnumSerializer('com.ems.console.api.LoginOutcome', values_0());
  }
  var LoginOutcome_SUCCESS_instance;
  var LoginOutcome_BAD_CREDENTIALS_instance;
  var LoginOutcome_TOTP_REQUIRED_instance;
  var LoginOutcome_TOTP_INVALID_instance;
  var LoginOutcome_ENROLMENT_REQUIRED_instance;
  var LoginOutcome_LOCKED_instance;
  var LoginOutcome_INACTIVE_instance;
  function values_0() {
    return [LoginOutcome_SUCCESS_getInstance(), LoginOutcome_BAD_CREDENTIALS_getInstance(), LoginOutcome_TOTP_REQUIRED_getInstance(), LoginOutcome_TOTP_INVALID_getInstance(), LoginOutcome_ENROLMENT_REQUIRED_getInstance(), LoginOutcome_LOCKED_getInstance(), LoginOutcome_INACTIVE_getInstance()];
  }
  function Companion_84() {
    Companion_instance_84 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.j20_1 = lazy(tmp_0, LoginOutcome$Companion$_anonymous__tdh19i);
  }
  protoOf(Companion_84).w19 = function () {
    return _get_$cachedSerializer__te6jhj_0(this);
  };
  protoOf(Companion_84).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_84;
  function Companion_getInstance_84() {
    LoginOutcome_initEntries();
    if (Companion_instance_84 == null)
      new Companion_84();
    return Companion_instance_84;
  }
  var LoginOutcome_entriesInitialized;
  function LoginOutcome_initEntries() {
    if (LoginOutcome_entriesInitialized)
      return Unit_instance;
    LoginOutcome_entriesInitialized = true;
    LoginOutcome_SUCCESS_instance = new LoginOutcome('SUCCESS', 0);
    LoginOutcome_BAD_CREDENTIALS_instance = new LoginOutcome('BAD_CREDENTIALS', 1);
    LoginOutcome_TOTP_REQUIRED_instance = new LoginOutcome('TOTP_REQUIRED', 2);
    LoginOutcome_TOTP_INVALID_instance = new LoginOutcome('TOTP_INVALID', 3);
    LoginOutcome_ENROLMENT_REQUIRED_instance = new LoginOutcome('ENROLMENT_REQUIRED', 4);
    LoginOutcome_LOCKED_instance = new LoginOutcome('LOCKED', 5);
    LoginOutcome_INACTIVE_instance = new LoginOutcome('INACTIVE', 6);
    Companion_getInstance_84();
  }
  function LoginOutcome(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function $serializer_96() {
    $serializer_instance_95 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OverdueAccount', this, 8);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('invoiceId', false);
    tmp0_serialDesc.gy('invoiceNumber', false);
    tmp0_serialDesc.gy('total', false);
    tmp0_serialDesc.gy('dueAtMs', false);
    tmp0_serialDesc.gy('daysOverdue', false);
    tmp0_serialDesc.gy('lastReminderStage', false);
    this.e2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_96).f2k = function (encoder, value) {
    var tmp0_desc = this.e2k_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.g2k_1);
    tmp1_output.hs(tmp0_desc, 1, value.h2k_1);
    tmp1_output.hs(tmp0_desc, 2, value.i2k_1);
    tmp1_output.hs(tmp0_desc, 3, value.j2k_1);
    tmp1_output.js(tmp0_desc, 4, $serializer_getInstance_34(), value.k2k_1);
    tmp1_output.ds(tmp0_desc, 5, value.l2k_1);
    tmp1_output.cs(tmp0_desc, 6, value.m2k_1);
    tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.n2k_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_96).on = function (encoder, value) {
    return this.f2k(encoder, value instanceof OverdueAccount ? value : THROW_CCE());
  };
  protoOf($serializer_96).pn = function (decoder) {
    var tmp0_desc = this.e2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_input = decoder.tq(tmp0_desc);
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.fr(tmp0_desc, 4, $serializer_getInstance_34(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.yq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.fr(tmp0_desc, 4, $serializer_getInstance_34(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.yq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return OverdueAccount_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_96).nn = function () {
    return this.e2k_1;
  };
  protoOf($serializer_96).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_34(), LongSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_95;
  function $serializer_getInstance_95() {
    if ($serializer_instance_95 == null)
      new $serializer_96();
    return $serializer_instance_95;
  }
  function OverdueAccount_init_$Init$(seen0, tenantId, tenantName, invoiceId, invoiceNumber, total, dueAtMs, daysOverdue, lastReminderStage, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_95().e2k_1);
    }
    $this.g2k_1 = tenantId;
    $this.h2k_1 = tenantName;
    $this.i2k_1 = invoiceId;
    $this.j2k_1 = invoiceNumber;
    $this.k2k_1 = total;
    $this.l2k_1 = dueAtMs;
    $this.m2k_1 = daysOverdue;
    $this.n2k_1 = lastReminderStage;
    return $this;
  }
  function OverdueAccount_init_$Create$(seen0, tenantId, tenantName, invoiceId, invoiceNumber, total, dueAtMs, daysOverdue, lastReminderStage, serializationConstructorMarker) {
    return OverdueAccount_init_$Init$(seen0, tenantId, tenantName, invoiceId, invoiceNumber, total, dueAtMs, daysOverdue, lastReminderStage, serializationConstructorMarker, objectCreate(protoOf(OverdueAccount)));
  }
  function OverdueAccount() {
  }
  protoOf(OverdueAccount).toString = function () {
    return 'OverdueAccount(tenantId=' + this.g2k_1 + ', tenantName=' + this.h2k_1 + ', invoiceId=' + this.i2k_1 + ', invoiceNumber=' + this.j2k_1 + ', total=' + this.k2k_1.toString() + ', dueAtMs=' + this.l2k_1.toString() + ', daysOverdue=' + this.m2k_1 + ', lastReminderStage=' + this.n2k_1 + ')';
  };
  protoOf(OverdueAccount).hashCode = function () {
    var result = getStringHashCode(this.g2k_1);
    result = imul(result, 31) + getStringHashCode(this.h2k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i2k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j2k_1) | 0;
    result = imul(result, 31) + this.k2k_1.hashCode() | 0;
    result = imul(result, 31) + this.l2k_1.hashCode() | 0;
    result = imul(result, 31) + this.m2k_1 | 0;
    result = imul(result, 31) + (this.n2k_1 == null ? 0 : getStringHashCode(this.n2k_1)) | 0;
    return result;
  };
  protoOf(OverdueAccount).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OverdueAccount))
      return false;
    var tmp0_other_with_cast = other instanceof OverdueAccount ? other : THROW_CCE();
    if (!(this.g2k_1 === tmp0_other_with_cast.g2k_1))
      return false;
    if (!(this.h2k_1 === tmp0_other_with_cast.h2k_1))
      return false;
    if (!(this.i2k_1 === tmp0_other_with_cast.i2k_1))
      return false;
    if (!(this.j2k_1 === tmp0_other_with_cast.j2k_1))
      return false;
    if (!this.k2k_1.equals(tmp0_other_with_cast.k2k_1))
      return false;
    if (!this.l2k_1.equals(tmp0_other_with_cast.l2k_1))
      return false;
    if (!(this.m2k_1 === tmp0_other_with_cast.m2k_1))
      return false;
    if (!(this.n2k_1 == tmp0_other_with_cast.n2k_1))
      return false;
    return true;
  };
  function Companion_85() {
    Companion_instance_85 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o2k_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_97()), null];
  }
  var Companion_instance_85;
  function Companion_getInstance_85() {
    if (Companion_instance_85 == null)
      new Companion_85();
    return Companion_instance_85;
  }
  function $serializer_97() {
    $serializer_instance_96 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LimitUsageAcrossTenants', this, 5);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('unit', false);
    tmp0_serialDesc.gy('totalUsed', false);
    tmp0_serialDesc.gy('topConsumers', false);
    tmp0_serialDesc.gy('providerCost', true);
    this.p2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_97).q2k = function (encoder, value) {
    var tmp0_desc = this.p2k_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_85().o2k_1;
    tmp1_output.hs(tmp0_desc, 0, value.r2k_1);
    tmp1_output.hs(tmp0_desc, 1, value.s2k_1);
    tmp1_output.ds(tmp0_desc, 2, value.t2k_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.u2k_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.v2k_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, $serializer_getInstance_34(), value.v2k_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_97).on = function (encoder, value) {
    return this.q2k(encoder, value instanceof LimitUsageAcrossTenants ? value : THROW_CCE());
  };
  protoOf($serializer_97).pn = function (decoder) {
    var tmp0_desc = this.p2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    var tmp10_cached = Companion_getInstance_85().o2k_1;
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.fr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, $serializer_getInstance_34(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.fr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, $serializer_getInstance_34(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return LimitUsageAcrossTenants_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_97).nn = function () {
    return this.p2k_1;
  };
  protoOf($serializer_97).vy = function () {
    var tmp0_cached = Companion_getInstance_85().o2k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[3], get_nullable($serializer_getInstance_34())];
  };
  var $serializer_instance_96;
  function $serializer_getInstance_96() {
    if ($serializer_instance_96 == null)
      new $serializer_97();
    return $serializer_instance_96;
  }
  function LimitUsageAcrossTenants_init_$Init$(seen0, limitKey, unit, totalUsed, topConsumers, providerCost, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_96().p2k_1);
    }
    $this.r2k_1 = limitKey;
    $this.s2k_1 = unit;
    $this.t2k_1 = totalUsed;
    $this.u2k_1 = topConsumers;
    if (0 === (seen0 & 16))
      $this.v2k_1 = null;
    else
      $this.v2k_1 = providerCost;
    return $this;
  }
  function LimitUsageAcrossTenants_init_$Create$(seen0, limitKey, unit, totalUsed, topConsumers, providerCost, serializationConstructorMarker) {
    return LimitUsageAcrossTenants_init_$Init$(seen0, limitKey, unit, totalUsed, topConsumers, providerCost, serializationConstructorMarker, objectCreate(protoOf(LimitUsageAcrossTenants)));
  }
  function LimitUsageAcrossTenants() {
  }
  protoOf(LimitUsageAcrossTenants).toString = function () {
    return 'LimitUsageAcrossTenants(limitKey=' + this.r2k_1 + ', unit=' + this.s2k_1 + ', totalUsed=' + this.t2k_1.toString() + ', topConsumers=' + toString(this.u2k_1) + ', providerCost=' + toString_0(this.v2k_1) + ')';
  };
  protoOf(LimitUsageAcrossTenants).hashCode = function () {
    var result = getStringHashCode(this.r2k_1);
    result = imul(result, 31) + getStringHashCode(this.s2k_1) | 0;
    result = imul(result, 31) + this.t2k_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.u2k_1) | 0;
    result = imul(result, 31) + (this.v2k_1 == null ? 0 : this.v2k_1.hashCode()) | 0;
    return result;
  };
  protoOf(LimitUsageAcrossTenants).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LimitUsageAcrossTenants))
      return false;
    var tmp0_other_with_cast = other instanceof LimitUsageAcrossTenants ? other : THROW_CCE();
    if (!(this.r2k_1 === tmp0_other_with_cast.r2k_1))
      return false;
    if (!(this.s2k_1 === tmp0_other_with_cast.s2k_1))
      return false;
    if (!this.t2k_1.equals(tmp0_other_with_cast.t2k_1))
      return false;
    if (!equals(this.u2k_1, tmp0_other_with_cast.u2k_1))
      return false;
    if (!equals(this.v2k_1, tmp0_other_with_cast.v2k_1))
      return false;
    return true;
  };
  function $serializer_98() {
    $serializer_instance_97 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantUsageRow', this, 5);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('used', false);
    tmp0_serialDesc.gy('allowance', false);
    tmp0_serialDesc.gy('percentOfAllowance', false);
    this.w2k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_98).x2k = function (encoder, value) {
    var tmp0_desc = this.w2k_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.y2k_1);
    tmp1_output.hs(tmp0_desc, 1, value.z2k_1);
    tmp1_output.ds(tmp0_desc, 2, value.a2l_1);
    tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.b2l_1);
    tmp1_output.ls(tmp0_desc, 4, IntSerializer_getInstance(), value.c2l_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_98).on = function (encoder, value) {
    return this.x2k(encoder, value instanceof TenantUsageRow ? value : THROW_CCE());
  };
  protoOf($serializer_98).pn = function (decoder) {
    var tmp0_desc = this.w2k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return TenantUsageRow_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_98).nn = function () {
    return this.w2k_1;
  };
  protoOf($serializer_98).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
  };
  var $serializer_instance_97;
  function $serializer_getInstance_97() {
    if ($serializer_instance_97 == null)
      new $serializer_98();
    return $serializer_instance_97;
  }
  function TenantUsageRow_init_$Init$(seen0, tenantId, tenantName, used, allowance, percentOfAllowance, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_97().w2k_1);
    }
    $this.y2k_1 = tenantId;
    $this.z2k_1 = tenantName;
    $this.a2l_1 = used;
    $this.b2l_1 = allowance;
    $this.c2l_1 = percentOfAllowance;
    return $this;
  }
  function TenantUsageRow_init_$Create$(seen0, tenantId, tenantName, used, allowance, percentOfAllowance, serializationConstructorMarker) {
    return TenantUsageRow_init_$Init$(seen0, tenantId, tenantName, used, allowance, percentOfAllowance, serializationConstructorMarker, objectCreate(protoOf(TenantUsageRow)));
  }
  function TenantUsageRow() {
  }
  protoOf(TenantUsageRow).toString = function () {
    return 'TenantUsageRow(tenantId=' + this.y2k_1 + ', tenantName=' + this.z2k_1 + ', used=' + this.a2l_1.toString() + ', allowance=' + toString_0(this.b2l_1) + ', percentOfAllowance=' + this.c2l_1 + ')';
  };
  protoOf(TenantUsageRow).hashCode = function () {
    var result = getStringHashCode(this.y2k_1);
    result = imul(result, 31) + getStringHashCode(this.z2k_1) | 0;
    result = imul(result, 31) + this.a2l_1.hashCode() | 0;
    result = imul(result, 31) + (this.b2l_1 == null ? 0 : this.b2l_1.hashCode()) | 0;
    result = imul(result, 31) + (this.c2l_1 == null ? 0 : this.c2l_1) | 0;
    return result;
  };
  protoOf(TenantUsageRow).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantUsageRow))
      return false;
    var tmp0_other_with_cast = other instanceof TenantUsageRow ? other : THROW_CCE();
    if (!(this.y2k_1 === tmp0_other_with_cast.y2k_1))
      return false;
    if (!(this.z2k_1 === tmp0_other_with_cast.z2k_1))
      return false;
    if (!this.a2l_1.equals(tmp0_other_with_cast.a2l_1))
      return false;
    if (!equals(this.b2l_1, tmp0_other_with_cast.b2l_1))
      return false;
    if (!(this.c2l_1 == tmp0_other_with_cast.c2l_1))
      return false;
    return true;
  };
  function Companion_86() {
    Companion_instance_86 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d2l_1 = [null, null, null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null];
  }
  var Companion_instance_86;
  function Companion_getInstance_86() {
    if (Companion_instance_86 == null)
      new Companion_86();
    return Companion_instance_86;
  }
  function $serializer_99() {
    $serializer_instance_98 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RegistryFeature', this, 16);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('scope', false);
    tmp0_serialDesc.gy('group', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('descriptionEn', false);
    tmp0_serialDesc.gy('descriptionAr', false);
    tmp0_serialDesc.gy('moduleKey', false);
    tmp0_serialDesc.gy('requires', false);
    tmp0_serialDesc.gy('consumes', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('sellable', false);
    tmp0_serialDesc.gy('sinceVersion', false);
    tmp0_serialDesc.gy('groupNameEn', true);
    tmp0_serialDesc.gy('groupNameAr', true);
    this.e2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_99).f2l = function (encoder, value) {
    var tmp0_desc = this.e2l_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_86().d2l_1;
    tmp1_output.hs(tmp0_desc, 0, value.g2l_1);
    tmp1_output.hs(tmp0_desc, 1, value.h2l_1);
    tmp1_output.hs(tmp0_desc, 2, value.i2l_1);
    tmp1_output.hs(tmp0_desc, 3, value.j2l_1);
    tmp1_output.hs(tmp0_desc, 4, value.k2l_1);
    tmp1_output.hs(tmp0_desc, 5, value.l2l_1);
    tmp1_output.hs(tmp0_desc, 6, value.m2l_1);
    tmp1_output.hs(tmp0_desc, 7, value.n2l_1);
    tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.o2l_1);
    tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.p2l_1);
    tmp1_output.js(tmp0_desc, 10, tmp2_cached[10], value.q2l_1);
    tmp1_output.hs(tmp0_desc, 11, value.r2l_1);
    tmp1_output.zr(tmp0_desc, 12, value.s2l_1);
    tmp1_output.cs(tmp0_desc, 13, value.t2l_1);
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !(value.u2l_1 === '')) {
      tmp1_output.hs(tmp0_desc, 14, value.u2l_1);
    }
    if (tmp1_output.ps(tmp0_desc, 15) ? true : !(value.v2l_1 === '')) {
      tmp1_output.hs(tmp0_desc, 15, value.v2l_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_99).on = function (encoder, value) {
    return this.f2l(encoder, value instanceof RegistryFeature ? value : THROW_CCE());
  };
  protoOf($serializer_99).pn = function (decoder) {
    var tmp0_desc = this.e2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = false;
    var tmp17_local13 = 0;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_input = decoder.tq(tmp0_desc);
    var tmp21_cached = Companion_getInstance_86().d2l_1;
    if (tmp20_input.ir()) {
      tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp20_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp20_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp20_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp20_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp20_input.fr(tmp0_desc, 9, tmp21_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp20_input.fr(tmp0_desc, 10, tmp21_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp20_input.dr(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp20_input.vq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp20_input.yq(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp20_input.dr(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp20_input.dr(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp20_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp20_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp20_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp20_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp20_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp20_input.fr(tmp0_desc, 9, tmp21_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp20_input.fr(tmp0_desc, 10, tmp21_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp20_input.dr(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp20_input.vq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp20_input.yq(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp20_input.dr(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp20_input.dr(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp20_input.uq(tmp0_desc);
    return RegistryFeature_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
  };
  protoOf($serializer_99).nn = function () {
    return this.e2l_1;
  };
  protoOf($serializer_99).vy = function () {
    var tmp0_cached = Companion_getInstance_86().d2l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[9], tmp0_cached[10], StringSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_98;
  function $serializer_getInstance_98() {
    if ($serializer_instance_98 == null)
      new $serializer_99();
    return $serializer_instance_98;
  }
  function RegistryFeature_init_$Init$(seen0, key, scope, group, kind, nameEn, nameAr, descriptionEn, descriptionAr, moduleKey, requires, consumes, status, sellable, sinceVersion, groupNameEn, groupNameAr, serializationConstructorMarker, $this) {
    if (!(16383 === (16383 & seen0))) {
      throwMissingFieldException(seen0, 16383, $serializer_getInstance_98().e2l_1);
    }
    $this.g2l_1 = key;
    $this.h2l_1 = scope;
    $this.i2l_1 = group;
    $this.j2l_1 = kind;
    $this.k2l_1 = nameEn;
    $this.l2l_1 = nameAr;
    $this.m2l_1 = descriptionEn;
    $this.n2l_1 = descriptionAr;
    $this.o2l_1 = moduleKey;
    $this.p2l_1 = requires;
    $this.q2l_1 = consumes;
    $this.r2l_1 = status;
    $this.s2l_1 = sellable;
    $this.t2l_1 = sinceVersion;
    if (0 === (seen0 & 16384))
      $this.u2l_1 = '';
    else
      $this.u2l_1 = groupNameEn;
    if (0 === (seen0 & 32768))
      $this.v2l_1 = '';
    else
      $this.v2l_1 = groupNameAr;
    return $this;
  }
  function RegistryFeature_init_$Create$(seen0, key, scope, group, kind, nameEn, nameAr, descriptionEn, descriptionAr, moduleKey, requires, consumes, status, sellable, sinceVersion, groupNameEn, groupNameAr, serializationConstructorMarker) {
    return RegistryFeature_init_$Init$(seen0, key, scope, group, kind, nameEn, nameAr, descriptionEn, descriptionAr, moduleKey, requires, consumes, status, sellable, sinceVersion, groupNameEn, groupNameAr, serializationConstructorMarker, objectCreate(protoOf(RegistryFeature)));
  }
  function RegistryFeature() {
  }
  protoOf(RegistryFeature).toString = function () {
    return 'RegistryFeature(key=' + this.g2l_1 + ', scope=' + this.h2l_1 + ', group=' + this.i2l_1 + ', kind=' + this.j2l_1 + ', nameEn=' + this.k2l_1 + ', nameAr=' + this.l2l_1 + ', descriptionEn=' + this.m2l_1 + ', descriptionAr=' + this.n2l_1 + ', moduleKey=' + this.o2l_1 + ', requires=' + toString(this.p2l_1) + ', consumes=' + toString(this.q2l_1) + ', status=' + this.r2l_1 + ', sellable=' + this.s2l_1 + ', sinceVersion=' + this.t2l_1 + ', groupNameEn=' + this.u2l_1 + ', groupNameAr=' + this.v2l_1 + ')';
  };
  protoOf(RegistryFeature).hashCode = function () {
    var result = getStringHashCode(this.g2l_1);
    result = imul(result, 31) + getStringHashCode(this.h2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n2l_1) | 0;
    result = imul(result, 31) + (this.o2l_1 == null ? 0 : getStringHashCode(this.o2l_1)) | 0;
    result = imul(result, 31) + hashCode(this.p2l_1) | 0;
    result = imul(result, 31) + hashCode(this.q2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r2l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s2l_1) | 0;
    result = imul(result, 31) + this.t2l_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.u2l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v2l_1) | 0;
    return result;
  };
  protoOf(RegistryFeature).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegistryFeature))
      return false;
    var tmp0_other_with_cast = other instanceof RegistryFeature ? other : THROW_CCE();
    if (!(this.g2l_1 === tmp0_other_with_cast.g2l_1))
      return false;
    if (!(this.h2l_1 === tmp0_other_with_cast.h2l_1))
      return false;
    if (!(this.i2l_1 === tmp0_other_with_cast.i2l_1))
      return false;
    if (!(this.j2l_1 === tmp0_other_with_cast.j2l_1))
      return false;
    if (!(this.k2l_1 === tmp0_other_with_cast.k2l_1))
      return false;
    if (!(this.l2l_1 === tmp0_other_with_cast.l2l_1))
      return false;
    if (!(this.m2l_1 === tmp0_other_with_cast.m2l_1))
      return false;
    if (!(this.n2l_1 === tmp0_other_with_cast.n2l_1))
      return false;
    if (!(this.o2l_1 == tmp0_other_with_cast.o2l_1))
      return false;
    if (!equals(this.p2l_1, tmp0_other_with_cast.p2l_1))
      return false;
    if (!equals(this.q2l_1, tmp0_other_with_cast.q2l_1))
      return false;
    if (!(this.r2l_1 === tmp0_other_with_cast.r2l_1))
      return false;
    if (!(this.s2l_1 === tmp0_other_with_cast.s2l_1))
      return false;
    if (!(this.t2l_1 === tmp0_other_with_cast.t2l_1))
      return false;
    if (!(this.u2l_1 === tmp0_other_with_cast.u2l_1))
      return false;
    if (!(this.v2l_1 === tmp0_other_with_cast.v2l_1))
      return false;
    return true;
  };
  function Companion_87() {
    Companion_instance_87 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w2l_1 = [null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_87;
  function Companion_getInstance_87() {
    if (Companion_instance_87 == null)
      new Companion_87();
    return Companion_instance_87;
  }
  function $serializer_100() {
    $serializer_instance_99 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RegistryModule', this, 7);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('descriptionEn', false);
    tmp0_serialDesc.gy('descriptionAr', false);
    tmp0_serialDesc.gy('requires', false);
    tmp0_serialDesc.gy('sortOrder', false);
    this.x2l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_100).y2l = function (encoder, value) {
    var tmp0_desc = this.x2l_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_87().w2l_1;
    tmp1_output.hs(tmp0_desc, 0, value.z2l_1);
    tmp1_output.hs(tmp0_desc, 1, value.a2m_1);
    tmp1_output.hs(tmp0_desc, 2, value.b2m_1);
    tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.c2m_1);
    tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.d2m_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.e2m_1);
    tmp1_output.cs(tmp0_desc, 6, value.f2m_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_100).on = function (encoder, value) {
    return this.y2l(encoder, value instanceof RegistryModule ? value : THROW_CCE());
  };
  protoOf($serializer_100).pn = function (decoder) {
    var tmp0_desc = this.x2l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = 0;
    var tmp11_input = decoder.tq(tmp0_desc);
    var tmp12_cached = Companion_getInstance_87().w2l_1;
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.fr(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.yq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.fr(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.yq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return RegistryModule_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_100).nn = function () {
    return this.x2l_1;
  };
  protoOf($serializer_100).vy = function () {
    var tmp0_cached = Companion_getInstance_87().w2l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[5], IntSerializer_getInstance()];
  };
  var $serializer_instance_99;
  function $serializer_getInstance_99() {
    if ($serializer_instance_99 == null)
      new $serializer_100();
    return $serializer_instance_99;
  }
  function RegistryModule_init_$Init$(seen0, key, nameEn, nameAr, descriptionEn, descriptionAr, requires, sortOrder, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_99().x2l_1);
    }
    $this.z2l_1 = key;
    $this.a2m_1 = nameEn;
    $this.b2m_1 = nameAr;
    $this.c2m_1 = descriptionEn;
    $this.d2m_1 = descriptionAr;
    $this.e2m_1 = requires;
    $this.f2m_1 = sortOrder;
    return $this;
  }
  function RegistryModule_init_$Create$(seen0, key, nameEn, nameAr, descriptionEn, descriptionAr, requires, sortOrder, serializationConstructorMarker) {
    return RegistryModule_init_$Init$(seen0, key, nameEn, nameAr, descriptionEn, descriptionAr, requires, sortOrder, serializationConstructorMarker, objectCreate(protoOf(RegistryModule)));
  }
  function RegistryModule() {
  }
  protoOf(RegistryModule).toString = function () {
    return 'RegistryModule(key=' + this.z2l_1 + ', nameEn=' + this.a2m_1 + ', nameAr=' + this.b2m_1 + ', descriptionEn=' + this.c2m_1 + ', descriptionAr=' + this.d2m_1 + ', requires=' + toString(this.e2m_1) + ', sortOrder=' + this.f2m_1 + ')';
  };
  protoOf(RegistryModule).hashCode = function () {
    var result = getStringHashCode(this.z2l_1);
    result = imul(result, 31) + getStringHashCode(this.a2m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b2m_1) | 0;
    result = imul(result, 31) + (this.c2m_1 == null ? 0 : getStringHashCode(this.c2m_1)) | 0;
    result = imul(result, 31) + (this.d2m_1 == null ? 0 : getStringHashCode(this.d2m_1)) | 0;
    result = imul(result, 31) + hashCode(this.e2m_1) | 0;
    result = imul(result, 31) + this.f2m_1 | 0;
    return result;
  };
  protoOf(RegistryModule).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RegistryModule))
      return false;
    var tmp0_other_with_cast = other instanceof RegistryModule ? other : THROW_CCE();
    if (!(this.z2l_1 === tmp0_other_with_cast.z2l_1))
      return false;
    if (!(this.a2m_1 === tmp0_other_with_cast.a2m_1))
      return false;
    if (!(this.b2m_1 === tmp0_other_with_cast.b2m_1))
      return false;
    if (!(this.c2m_1 == tmp0_other_with_cast.c2m_1))
      return false;
    if (!(this.d2m_1 == tmp0_other_with_cast.d2m_1))
      return false;
    if (!equals(this.e2m_1, tmp0_other_with_cast.e2m_1))
      return false;
    if (!(this.f2m_1 === tmp0_other_with_cast.f2m_1))
      return false;
    return true;
  };
  function $serializer_101() {
    $serializer_instance_100 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantProtectionStatusView', this, 6);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('appliedRevision', false);
    tmp0_serialDesc.gy('appliedAt', false);
    tmp0_serialDesc.gy('ready', false);
    tmp0_serialDesc.gy('stale', false);
    tmp0_serialDesc.gy('tenantSlug', true);
    this.g2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_101).h2m = function (encoder, value) {
    var tmp0_desc = this.g2m_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.i2m_1);
    tmp1_output.ds(tmp0_desc, 1, value.j2m_1);
    tmp1_output.hs(tmp0_desc, 2, value.k2m_1);
    tmp1_output.zr(tmp0_desc, 3, value.l2m_1);
    tmp1_output.zr(tmp0_desc, 4, value.m2m_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.n2m_1 === '')) {
      tmp1_output.hs(tmp0_desc, 5, value.n2m_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_101).on = function (encoder, value) {
    return this.h2m(encoder, value instanceof TenantProtectionStatusView ? value : THROW_CCE());
  };
  protoOf($serializer_101).pn = function (decoder) {
    var tmp0_desc = this.g2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return TenantProtectionStatusView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_101).nn = function () {
    return this.g2m_1;
  };
  protoOf($serializer_101).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_100;
  function $serializer_getInstance_100() {
    if ($serializer_instance_100 == null)
      new $serializer_101();
    return $serializer_instance_100;
  }
  function TenantProtectionStatusView_init_$Init$(seen0, tenantId, appliedRevision, appliedAt, ready, stale, tenantSlug, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_100().g2m_1);
    }
    $this.i2m_1 = tenantId;
    $this.j2m_1 = appliedRevision;
    $this.k2m_1 = appliedAt;
    $this.l2m_1 = ready;
    $this.m2m_1 = stale;
    if (0 === (seen0 & 32))
      $this.n2m_1 = '';
    else
      $this.n2m_1 = tenantSlug;
    return $this;
  }
  function TenantProtectionStatusView_init_$Create$(seen0, tenantId, appliedRevision, appliedAt, ready, stale, tenantSlug, serializationConstructorMarker) {
    return TenantProtectionStatusView_init_$Init$(seen0, tenantId, appliedRevision, appliedAt, ready, stale, tenantSlug, serializationConstructorMarker, objectCreate(protoOf(TenantProtectionStatusView)));
  }
  function TenantProtectionStatusView() {
  }
  protoOf(TenantProtectionStatusView).toString = function () {
    return 'TenantProtectionStatusView(tenantId=' + this.i2m_1 + ', appliedRevision=' + this.j2m_1.toString() + ', appliedAt=' + this.k2m_1 + ', ready=' + this.l2m_1 + ', stale=' + this.m2m_1 + ', tenantSlug=' + this.n2m_1 + ')';
  };
  protoOf(TenantProtectionStatusView).hashCode = function () {
    var result = getStringHashCode(this.i2m_1);
    result = imul(result, 31) + this.j2m_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.k2m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l2m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m2m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n2m_1) | 0;
    return result;
  };
  protoOf(TenantProtectionStatusView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantProtectionStatusView))
      return false;
    var tmp0_other_with_cast = other instanceof TenantProtectionStatusView ? other : THROW_CCE();
    if (!(this.i2m_1 === tmp0_other_with_cast.i2m_1))
      return false;
    if (!this.j2m_1.equals(tmp0_other_with_cast.j2m_1))
      return false;
    if (!(this.k2m_1 === tmp0_other_with_cast.k2m_1))
      return false;
    if (!(this.l2m_1 === tmp0_other_with_cast.l2m_1))
      return false;
    if (!(this.m2m_1 === tmp0_other_with_cast.m2m_1))
      return false;
    if (!(this.n2m_1 === tmp0_other_with_cast.n2m_1))
      return false;
    return true;
  };
  function $serializer_102() {
    $serializer_instance_101 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyChangeView', this, 5);
    tmp0_serialDesc.gy('category', false);
    tmp0_serialDesc.gy('code', false);
    tmp0_serialDesc.gy('message', false);
    tmp0_serialDesc.gy('previousCount', true);
    tmp0_serialDesc.gy('currentCount', true);
    this.o2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_102).p2m = function (encoder, value) {
    var tmp0_desc = this.o2m_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.q2m_1);
    tmp1_output.hs(tmp0_desc, 1, value.r2m_1);
    tmp1_output.hs(tmp0_desc, 2, value.s2m_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.t2m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, IntSerializer_getInstance(), value.t2m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.u2m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, IntSerializer_getInstance(), value.u2m_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_102).on = function (encoder, value) {
    return this.p2m(encoder, value instanceof SetupCopyChangeView ? value : THROW_CCE());
  };
  protoOf($serializer_102).pn = function (decoder) {
    var tmp0_desc = this.o2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return SetupCopyChangeView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_102).nn = function () {
    return this.o2m_1;
  };
  protoOf($serializer_102).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
  };
  var $serializer_instance_101;
  function $serializer_getInstance_101() {
    if ($serializer_instance_101 == null)
      new $serializer_102();
    return $serializer_instance_101;
  }
  function SetupCopyChangeView_init_$Init$(seen0, category, code, message, previousCount, currentCount, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_101().o2m_1);
    }
    $this.q2m_1 = category;
    $this.r2m_1 = code;
    $this.s2m_1 = message;
    if (0 === (seen0 & 8))
      $this.t2m_1 = null;
    else
      $this.t2m_1 = previousCount;
    if (0 === (seen0 & 16))
      $this.u2m_1 = null;
    else
      $this.u2m_1 = currentCount;
    return $this;
  }
  function SetupCopyChangeView_init_$Create$(seen0, category, code, message, previousCount, currentCount, serializationConstructorMarker) {
    return SetupCopyChangeView_init_$Init$(seen0, category, code, message, previousCount, currentCount, serializationConstructorMarker, objectCreate(protoOf(SetupCopyChangeView)));
  }
  function SetupCopyChangeView() {
  }
  protoOf(SetupCopyChangeView).toString = function () {
    return 'SetupCopyChangeView(category=' + this.q2m_1 + ', code=' + this.r2m_1 + ', message=' + this.s2m_1 + ', previousCount=' + this.t2m_1 + ', currentCount=' + this.u2m_1 + ')';
  };
  protoOf(SetupCopyChangeView).hashCode = function () {
    var result = getStringHashCode(this.q2m_1);
    result = imul(result, 31) + getStringHashCode(this.r2m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s2m_1) | 0;
    result = imul(result, 31) + (this.t2m_1 == null ? 0 : this.t2m_1) | 0;
    result = imul(result, 31) + (this.u2m_1 == null ? 0 : this.u2m_1) | 0;
    return result;
  };
  protoOf(SetupCopyChangeView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyChangeView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyChangeView ? other : THROW_CCE();
    if (!(this.q2m_1 === tmp0_other_with_cast.q2m_1))
      return false;
    if (!(this.r2m_1 === tmp0_other_with_cast.r2m_1))
      return false;
    if (!(this.s2m_1 === tmp0_other_with_cast.s2m_1))
      return false;
    if (!(this.t2m_1 == tmp0_other_with_cast.t2m_1))
      return false;
    if (!(this.u2m_1 == tmp0_other_with_cast.u2m_1))
      return false;
    return true;
  };
  function Companion_88() {
    Companion_instance_88 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v2m_1 = [null, null, new ArrayListSerializer($serializer_getInstance_101())];
  }
  var Companion_instance_88;
  function Companion_getInstance_88() {
    if (Companion_instance_88 == null)
      new Companion_88();
    return Companion_instance_88;
  }
  function $serializer_103() {
    $serializer_instance_102 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ConsoleErrorDetails', this, 3);
    tmp0_serialDesc.gy('newSnapshotSha256', true);
    tmp0_serialDesc.gy('previousSnapshotSha256', true);
    tmp0_serialDesc.gy('changes', true);
    this.w2m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_103).x2m = function (encoder, value) {
    var tmp0_desc = this.w2m_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_88().v2m_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.y2m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, StringSerializer_getInstance(), value.y2m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.z2m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.z2m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !equals(value.a2n_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.a2n_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_103).on = function (encoder, value) {
    return this.x2m(encoder, value instanceof ConsoleErrorDetails ? value : THROW_CCE());
  };
  protoOf($serializer_103).pn = function (decoder) {
    var tmp0_desc = this.w2m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_88().v2m_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return ConsoleErrorDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_103).nn = function () {
    return this.w2m_1;
  };
  protoOf($serializer_103).vy = function () {
    var tmp0_cached = Companion_getInstance_88().v2m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[2]];
  };
  var $serializer_instance_102;
  function $serializer_getInstance_102() {
    if ($serializer_instance_102 == null)
      new $serializer_103();
    return $serializer_instance_102;
  }
  function ConsoleErrorDetails_init_$Init$(seen0, newSnapshotSha256, previousSnapshotSha256, changes, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_102().w2m_1);
    }
    if (0 === (seen0 & 1))
      $this.y2m_1 = null;
    else
      $this.y2m_1 = newSnapshotSha256;
    if (0 === (seen0 & 2))
      $this.z2m_1 = null;
    else
      $this.z2m_1 = previousSnapshotSha256;
    if (0 === (seen0 & 4))
      $this.a2n_1 = emptyList();
    else
      $this.a2n_1 = changes;
    return $this;
  }
  function ConsoleErrorDetails_init_$Create$(seen0, newSnapshotSha256, previousSnapshotSha256, changes, serializationConstructorMarker) {
    return ConsoleErrorDetails_init_$Init$(seen0, newSnapshotSha256, previousSnapshotSha256, changes, serializationConstructorMarker, objectCreate(protoOf(ConsoleErrorDetails)));
  }
  function ConsoleErrorDetails(newSnapshotSha256, previousSnapshotSha256, changes) {
    Companion_getInstance_88();
    newSnapshotSha256 = newSnapshotSha256 === VOID ? null : newSnapshotSha256;
    previousSnapshotSha256 = previousSnapshotSha256 === VOID ? null : previousSnapshotSha256;
    changes = changes === VOID ? emptyList() : changes;
    this.y2m_1 = newSnapshotSha256;
    this.z2m_1 = previousSnapshotSha256;
    this.a2n_1 = changes;
  }
  protoOf(ConsoleErrorDetails).toString = function () {
    return 'ConsoleErrorDetails(newSnapshotSha256=' + this.y2m_1 + ', previousSnapshotSha256=' + this.z2m_1 + ', changes=' + toString(this.a2n_1) + ')';
  };
  protoOf(ConsoleErrorDetails).hashCode = function () {
    var result = this.y2m_1 == null ? 0 : getStringHashCode(this.y2m_1);
    result = imul(result, 31) + (this.z2m_1 == null ? 0 : getStringHashCode(this.z2m_1)) | 0;
    result = imul(result, 31) + hashCode(this.a2n_1) | 0;
    return result;
  };
  protoOf(ConsoleErrorDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConsoleErrorDetails))
      return false;
    var tmp0_other_with_cast = other instanceof ConsoleErrorDetails ? other : THROW_CCE();
    if (!(this.y2m_1 == tmp0_other_with_cast.y2m_1))
      return false;
    if (!(this.z2m_1 == tmp0_other_with_cast.z2m_1))
      return false;
    if (!equals(this.a2n_1, tmp0_other_with_cast.a2n_1))
      return false;
    return true;
  };
  function Companion_89() {
    Companion_instance_89 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b2n_1 = [null, null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_109())];
  }
  var Companion_instance_89;
  function Companion_getInstance_89() {
    if (Companion_instance_89 == null)
      new Companion_89();
    return Companion_instance_89;
  }
  function $serializer_104() {
    $serializer_instance_103 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionDetail', this, 13);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('planName', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('billingCycle', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('agreedPriceMinor', false);
    tmp0_serialDesc.gy('periodStartMs', false);
    tmp0_serialDesc.gy('periodEndMs', false);
    tmp0_serialDesc.gy('autoRenew', false);
    tmp0_serialDesc.gy('cancelledAtMs', false);
    tmp0_serialDesc.gy('addons', false);
    this.c2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_104).d2n = function (encoder, value) {
    var tmp0_desc = this.c2n_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_89().b2n_1;
    tmp1_output.hs(tmp0_desc, 0, value.e2n_1);
    tmp1_output.hs(tmp0_desc, 1, value.f2n_1);
    tmp1_output.hs(tmp0_desc, 2, value.g2n_1);
    tmp1_output.hs(tmp0_desc, 3, value.h2n_1);
    tmp1_output.hs(tmp0_desc, 4, value.i2n_1);
    tmp1_output.hs(tmp0_desc, 5, value.j2n_1);
    tmp1_output.hs(tmp0_desc, 6, value.k2n_1);
    tmp1_output.ds(tmp0_desc, 7, value.l2n_1);
    tmp1_output.ds(tmp0_desc, 8, value.m2n_1);
    tmp1_output.ls(tmp0_desc, 9, LongSerializer_getInstance(), value.n2n_1);
    tmp1_output.zr(tmp0_desc, 10, value.o2n_1);
    tmp1_output.ls(tmp0_desc, 11, LongSerializer_getInstance(), value.p2n_1);
    tmp1_output.js(tmp0_desc, 12, tmp2_cached[12], value.q2n_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_104).on = function (encoder, value) {
    return this.d2n(encoder, value instanceof SubscriptionDetail ? value : THROW_CCE());
  };
  protoOf($serializer_104).pn = function (decoder) {
    var tmp0_desc = this.c2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = new Long(0, 0);
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = null;
    var tmp14_local10 = false;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.tq(tmp0_desc);
    var tmp18_cached = Companion_getInstance_89().b2n_1;
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.hr(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.vq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.fr(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.hr(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.vq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.fr(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return SubscriptionDetail_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_104).nn = function () {
    return this.c2n_1;
  };
  protoOf($serializer_104).vy = function () {
    var tmp0_cached = Companion_getInstance_89().b2n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), tmp0_cached[12]];
  };
  var $serializer_instance_103;
  function $serializer_getInstance_103() {
    if ($serializer_instance_103 == null)
      new $serializer_104();
    return $serializer_instance_103;
  }
  function SubscriptionDetail_init_$Init$(seen0, id, tenantId, planKey, planName, status, billingCycle, currency, agreedPriceMinor, periodStartMs, periodEndMs, autoRenew, cancelledAtMs, addons, serializationConstructorMarker, $this) {
    if (!(8191 === (8191 & seen0))) {
      throwMissingFieldException(seen0, 8191, $serializer_getInstance_103().c2n_1);
    }
    $this.e2n_1 = id;
    $this.f2n_1 = tenantId;
    $this.g2n_1 = planKey;
    $this.h2n_1 = planName;
    $this.i2n_1 = status;
    $this.j2n_1 = billingCycle;
    $this.k2n_1 = currency;
    $this.l2n_1 = agreedPriceMinor;
    $this.m2n_1 = periodStartMs;
    $this.n2n_1 = periodEndMs;
    $this.o2n_1 = autoRenew;
    $this.p2n_1 = cancelledAtMs;
    $this.q2n_1 = addons;
    return $this;
  }
  function SubscriptionDetail_init_$Create$(seen0, id, tenantId, planKey, planName, status, billingCycle, currency, agreedPriceMinor, periodStartMs, periodEndMs, autoRenew, cancelledAtMs, addons, serializationConstructorMarker) {
    return SubscriptionDetail_init_$Init$(seen0, id, tenantId, planKey, planName, status, billingCycle, currency, agreedPriceMinor, periodStartMs, periodEndMs, autoRenew, cancelledAtMs, addons, serializationConstructorMarker, objectCreate(protoOf(SubscriptionDetail)));
  }
  function SubscriptionDetail() {
  }
  protoOf(SubscriptionDetail).toString = function () {
    return 'SubscriptionDetail(id=' + this.e2n_1 + ', tenantId=' + this.f2n_1 + ', planKey=' + this.g2n_1 + ', planName=' + this.h2n_1 + ', status=' + this.i2n_1 + ', billingCycle=' + this.j2n_1 + ', currency=' + this.k2n_1 + ', agreedPriceMinor=' + this.l2n_1.toString() + ', periodStartMs=' + this.m2n_1.toString() + ', periodEndMs=' + toString_0(this.n2n_1) + ', autoRenew=' + this.o2n_1 + ', cancelledAtMs=' + toString_0(this.p2n_1) + ', addons=' + toString(this.q2n_1) + ')';
  };
  protoOf(SubscriptionDetail).hashCode = function () {
    var result = getStringHashCode(this.e2n_1);
    result = imul(result, 31) + getStringHashCode(this.f2n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g2n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h2n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i2n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j2n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2n_1) | 0;
    result = imul(result, 31) + this.l2n_1.hashCode() | 0;
    result = imul(result, 31) + this.m2n_1.hashCode() | 0;
    result = imul(result, 31) + (this.n2n_1 == null ? 0 : this.n2n_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o2n_1) | 0;
    result = imul(result, 31) + (this.p2n_1 == null ? 0 : this.p2n_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.q2n_1) | 0;
    return result;
  };
  protoOf(SubscriptionDetail).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionDetail))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionDetail ? other : THROW_CCE();
    if (!(this.e2n_1 === tmp0_other_with_cast.e2n_1))
      return false;
    if (!(this.f2n_1 === tmp0_other_with_cast.f2n_1))
      return false;
    if (!(this.g2n_1 === tmp0_other_with_cast.g2n_1))
      return false;
    if (!(this.h2n_1 === tmp0_other_with_cast.h2n_1))
      return false;
    if (!(this.i2n_1 === tmp0_other_with_cast.i2n_1))
      return false;
    if (!(this.j2n_1 === tmp0_other_with_cast.j2n_1))
      return false;
    if (!(this.k2n_1 === tmp0_other_with_cast.k2n_1))
      return false;
    if (!this.l2n_1.equals(tmp0_other_with_cast.l2n_1))
      return false;
    if (!this.m2n_1.equals(tmp0_other_with_cast.m2n_1))
      return false;
    if (!equals(this.n2n_1, tmp0_other_with_cast.n2n_1))
      return false;
    if (!(this.o2n_1 === tmp0_other_with_cast.o2n_1))
      return false;
    if (!equals(this.p2n_1, tmp0_other_with_cast.p2n_1))
      return false;
    if (!equals(this.q2n_1, tmp0_other_with_cast.q2n_1))
      return false;
    return true;
  };
  function Companion_90() {
    Companion_instance_90 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r2n_1 = [null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_90;
  function Companion_getInstance_90() {
    if (Companion_instance_90 == null)
      new Companion_90();
    return Companion_instance_90;
  }
  function $serializer_105() {
    $serializer_instance_104 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ModuleView', this, 6);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('granted', false);
    tmp0_serialDesc.gy('overridden', false);
    tmp0_serialDesc.gy('requires', false);
    this.s2n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_105).t2n = function (encoder, value) {
    var tmp0_desc = this.s2n_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_90().r2n_1;
    tmp1_output.hs(tmp0_desc, 0, value.u2n_1);
    tmp1_output.hs(tmp0_desc, 1, value.v2n_1);
    tmp1_output.hs(tmp0_desc, 2, value.w2n_1);
    tmp1_output.zr(tmp0_desc, 3, value.x2n_1);
    tmp1_output.zr(tmp0_desc, 4, value.y2n_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.z2n_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_105).on = function (encoder, value) {
    return this.t2n(encoder, value instanceof ModuleView ? value : THROW_CCE());
  };
  protoOf($serializer_105).pn = function (decoder) {
    var tmp0_desc = this.s2n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    var tmp11_cached = Companion_getInstance_90().r2n_1;
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.fr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.fr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return ModuleView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_105).nn = function () {
    return this.s2n_1;
  };
  protoOf($serializer_105).vy = function () {
    var tmp0_cached = Companion_getInstance_90().r2n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[5]];
  };
  var $serializer_instance_104;
  function $serializer_getInstance_104() {
    if ($serializer_instance_104 == null)
      new $serializer_105();
    return $serializer_instance_104;
  }
  function ModuleView_init_$Init$(seen0, key, nameEn, nameAr, granted, overridden, requires, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_104().s2n_1);
    }
    $this.u2n_1 = key;
    $this.v2n_1 = nameEn;
    $this.w2n_1 = nameAr;
    $this.x2n_1 = granted;
    $this.y2n_1 = overridden;
    $this.z2n_1 = requires;
    return $this;
  }
  function ModuleView_init_$Create$(seen0, key, nameEn, nameAr, granted, overridden, requires, serializationConstructorMarker) {
    return ModuleView_init_$Init$(seen0, key, nameEn, nameAr, granted, overridden, requires, serializationConstructorMarker, objectCreate(protoOf(ModuleView)));
  }
  function ModuleView() {
  }
  protoOf(ModuleView).toString = function () {
    return 'ModuleView(key=' + this.u2n_1 + ', nameEn=' + this.v2n_1 + ', nameAr=' + this.w2n_1 + ', granted=' + this.x2n_1 + ', overridden=' + this.y2n_1 + ', requires=' + toString(this.z2n_1) + ')';
  };
  protoOf(ModuleView).hashCode = function () {
    var result = getStringHashCode(this.u2n_1);
    result = imul(result, 31) + getStringHashCode(this.v2n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w2n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x2n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y2n_1) | 0;
    result = imul(result, 31) + hashCode(this.z2n_1) | 0;
    return result;
  };
  protoOf(ModuleView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ModuleView))
      return false;
    var tmp0_other_with_cast = other instanceof ModuleView ? other : THROW_CCE();
    if (!(this.u2n_1 === tmp0_other_with_cast.u2n_1))
      return false;
    if (!(this.v2n_1 === tmp0_other_with_cast.v2n_1))
      return false;
    if (!(this.w2n_1 === tmp0_other_with_cast.w2n_1))
      return false;
    if (!(this.x2n_1 === tmp0_other_with_cast.x2n_1))
      return false;
    if (!(this.y2n_1 === tmp0_other_with_cast.y2n_1))
      return false;
    if (!equals(this.z2n_1, tmp0_other_with_cast.z2n_1))
      return false;
    return true;
  };
  function $serializer_106() {
    $serializer_instance_105 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.LimitView', this, 10);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('unit', false);
    tmp0_serialDesc.gy('period', false);
    tmp0_serialDesc.gy('mode', false);
    tmp0_serialDesc.gy('value', false);
    tmp0_serialDesc.gy('used', false);
    tmp0_serialDesc.gy('overridden', false);
    tmp0_serialDesc.gy('moduleKey', false);
    this.a2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_106).b2o = function (encoder, value) {
    var tmp0_desc = this.a2o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.c2o_1);
    tmp1_output.hs(tmp0_desc, 1, value.d2o_1);
    tmp1_output.hs(tmp0_desc, 2, value.e2o_1);
    tmp1_output.hs(tmp0_desc, 3, value.f2o_1);
    tmp1_output.hs(tmp0_desc, 4, value.g2o_1);
    tmp1_output.hs(tmp0_desc, 5, value.h2o_1);
    tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.i2o_1);
    tmp1_output.ds(tmp0_desc, 7, value.j2o_1);
    tmp1_output.zr(tmp0_desc, 8, value.k2o_1);
    tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.l2o_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_106).on = function (encoder, value) {
    return this.b2o(encoder, value instanceof LimitView ? value : THROW_CCE());
  };
  protoOf($serializer_106).pn = function (decoder) {
    var tmp0_desc = this.a2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = new Long(0, 0);
    var tmp12_local8 = false;
    var tmp13_local9 = null;
    var tmp14_input = decoder.tq(tmp0_desc);
    if (tmp14_input.ir()) {
      tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.vq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.vq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.uq(tmp0_desc);
    return LimitView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_106).nn = function () {
    return this.a2o_1;
  };
  protoOf($serializer_106).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), LongSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_105;
  function $serializer_getInstance_105() {
    if ($serializer_instance_105 == null)
      new $serializer_106();
    return $serializer_instance_105;
  }
  function LimitView_init_$Init$(seen0, key, nameEn, nameAr, unit, period, mode, value, used, overridden, moduleKey, serializationConstructorMarker, $this) {
    if (!(1023 === (1023 & seen0))) {
      throwMissingFieldException(seen0, 1023, $serializer_getInstance_105().a2o_1);
    }
    $this.c2o_1 = key;
    $this.d2o_1 = nameEn;
    $this.e2o_1 = nameAr;
    $this.f2o_1 = unit;
    $this.g2o_1 = period;
    $this.h2o_1 = mode;
    $this.i2o_1 = value;
    $this.j2o_1 = used;
    $this.k2o_1 = overridden;
    $this.l2o_1 = moduleKey;
    return $this;
  }
  function LimitView_init_$Create$(seen0, key, nameEn, nameAr, unit, period, mode, value, used, overridden, moduleKey, serializationConstructorMarker) {
    return LimitView_init_$Init$(seen0, key, nameEn, nameAr, unit, period, mode, value, used, overridden, moduleKey, serializationConstructorMarker, objectCreate(protoOf(LimitView)));
  }
  function LimitView() {
  }
  protoOf(LimitView).toString = function () {
    return 'LimitView(key=' + this.c2o_1 + ', nameEn=' + this.d2o_1 + ', nameAr=' + this.e2o_1 + ', unit=' + this.f2o_1 + ', period=' + this.g2o_1 + ', mode=' + this.h2o_1 + ', value=' + toString_0(this.i2o_1) + ', used=' + this.j2o_1.toString() + ', overridden=' + this.k2o_1 + ', moduleKey=' + this.l2o_1 + ')';
  };
  protoOf(LimitView).hashCode = function () {
    var result = getStringHashCode(this.c2o_1);
    result = imul(result, 31) + getStringHashCode(this.d2o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e2o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f2o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g2o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h2o_1) | 0;
    result = imul(result, 31) + (this.i2o_1 == null ? 0 : this.i2o_1.hashCode()) | 0;
    result = imul(result, 31) + this.j2o_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k2o_1) | 0;
    result = imul(result, 31) + (this.l2o_1 == null ? 0 : getStringHashCode(this.l2o_1)) | 0;
    return result;
  };
  protoOf(LimitView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LimitView))
      return false;
    var tmp0_other_with_cast = other instanceof LimitView ? other : THROW_CCE();
    if (!(this.c2o_1 === tmp0_other_with_cast.c2o_1))
      return false;
    if (!(this.d2o_1 === tmp0_other_with_cast.d2o_1))
      return false;
    if (!(this.e2o_1 === tmp0_other_with_cast.e2o_1))
      return false;
    if (!(this.f2o_1 === tmp0_other_with_cast.f2o_1))
      return false;
    if (!(this.g2o_1 === tmp0_other_with_cast.g2o_1))
      return false;
    if (!(this.h2o_1 === tmp0_other_with_cast.h2o_1))
      return false;
    if (!equals(this.i2o_1, tmp0_other_with_cast.i2o_1))
      return false;
    if (!this.j2o_1.equals(tmp0_other_with_cast.j2o_1))
      return false;
    if (!(this.k2o_1 === tmp0_other_with_cast.k2o_1))
      return false;
    if (!(this.l2o_1 == tmp0_other_with_cast.l2o_1))
      return false;
    return true;
  };
  function $serializer_107() {
    $serializer_instance_106 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OverrideView', this, 11);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('targetKey', false);
    tmp0_serialDesc.gy('moduleGranted', true);
    tmp0_serialDesc.gy('limitValue', true);
    tmp0_serialDesc.gy('limitUnlimited', true);
    tmp0_serialDesc.gy('mode', true);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    tmp0_serialDesc.gy('createdBy', false);
    tmp0_serialDesc.gy('createdAtMs', false);
    this.m2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_107).n2o = function (encoder, value) {
    var tmp0_desc = this.m2o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.o2o_1);
    tmp1_output.hs(tmp0_desc, 1, value.p2o_1);
    tmp1_output.hs(tmp0_desc, 2, value.q2o_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.r2o_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, BooleanSerializer_getInstance(), value.r2o_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.s2o_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.s2o_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.t2o_1 === false)) {
      tmp1_output.zr(tmp0_desc, 5, value.t2o_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.u2o_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.u2o_1);
    }
    tmp1_output.hs(tmp0_desc, 7, value.v2o_1);
    tmp1_output.ls(tmp0_desc, 8, LongSerializer_getInstance(), value.w2o_1);
    tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.x2o_1);
    tmp1_output.ds(tmp0_desc, 10, value.y2o_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_107).on = function (encoder, value) {
    return this.n2o(encoder, value instanceof OverrideView ? value : THROW_CCE());
  };
  protoOf($serializer_107).pn = function (decoder) {
    var tmp0_desc = this.m2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = new Long(0, 0);
    var tmp15_input = decoder.tq(tmp0_desc);
    if (tmp15_input.ir()) {
      tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.hr(tmp0_desc, 3, BooleanSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.vq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.zq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.hr(tmp0_desc, 3, BooleanSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.vq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.zq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.uq(tmp0_desc);
    return OverrideView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_107).nn = function () {
    return this.m2o_1;
  };
  protoOf($serializer_107).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(BooleanSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance()];
  };
  var $serializer_instance_106;
  function $serializer_getInstance_106() {
    if ($serializer_instance_106 == null)
      new $serializer_107();
    return $serializer_instance_106;
  }
  function OverrideView_init_$Init$(seen0, id, kind, targetKey, moduleGranted, limitValue, limitUnlimited, mode, reason, expiresAtMs, createdBy, createdAtMs, serializationConstructorMarker, $this) {
    if (!(1927 === (1927 & seen0))) {
      throwMissingFieldException(seen0, 1927, $serializer_getInstance_106().m2o_1);
    }
    $this.o2o_1 = id;
    $this.p2o_1 = kind;
    $this.q2o_1 = targetKey;
    if (0 === (seen0 & 8))
      $this.r2o_1 = null;
    else
      $this.r2o_1 = moduleGranted;
    if (0 === (seen0 & 16))
      $this.s2o_1 = null;
    else
      $this.s2o_1 = limitValue;
    if (0 === (seen0 & 32))
      $this.t2o_1 = false;
    else
      $this.t2o_1 = limitUnlimited;
    if (0 === (seen0 & 64))
      $this.u2o_1 = null;
    else
      $this.u2o_1 = mode;
    $this.v2o_1 = reason;
    $this.w2o_1 = expiresAtMs;
    $this.x2o_1 = createdBy;
    $this.y2o_1 = createdAtMs;
    return $this;
  }
  function OverrideView_init_$Create$(seen0, id, kind, targetKey, moduleGranted, limitValue, limitUnlimited, mode, reason, expiresAtMs, createdBy, createdAtMs, serializationConstructorMarker) {
    return OverrideView_init_$Init$(seen0, id, kind, targetKey, moduleGranted, limitValue, limitUnlimited, mode, reason, expiresAtMs, createdBy, createdAtMs, serializationConstructorMarker, objectCreate(protoOf(OverrideView)));
  }
  function OverrideView() {
  }
  protoOf(OverrideView).toString = function () {
    return 'OverrideView(id=' + this.o2o_1 + ', kind=' + this.p2o_1 + ', targetKey=' + this.q2o_1 + ', moduleGranted=' + this.r2o_1 + ', limitValue=' + toString_0(this.s2o_1) + ', limitUnlimited=' + this.t2o_1 + ', mode=' + this.u2o_1 + ', reason=' + this.v2o_1 + ', expiresAtMs=' + toString_0(this.w2o_1) + ', createdBy=' + this.x2o_1 + ', createdAtMs=' + this.y2o_1.toString() + ')';
  };
  protoOf(OverrideView).hashCode = function () {
    var result = getStringHashCode(this.o2o_1);
    result = imul(result, 31) + getStringHashCode(this.p2o_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q2o_1) | 0;
    result = imul(result, 31) + (this.r2o_1 == null ? 0 : getBooleanHashCode(this.r2o_1)) | 0;
    result = imul(result, 31) + (this.s2o_1 == null ? 0 : this.s2o_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t2o_1) | 0;
    result = imul(result, 31) + (this.u2o_1 == null ? 0 : getStringHashCode(this.u2o_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.v2o_1) | 0;
    result = imul(result, 31) + (this.w2o_1 == null ? 0 : this.w2o_1.hashCode()) | 0;
    result = imul(result, 31) + (this.x2o_1 == null ? 0 : getStringHashCode(this.x2o_1)) | 0;
    result = imul(result, 31) + this.y2o_1.hashCode() | 0;
    return result;
  };
  protoOf(OverrideView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OverrideView))
      return false;
    var tmp0_other_with_cast = other instanceof OverrideView ? other : THROW_CCE();
    if (!(this.o2o_1 === tmp0_other_with_cast.o2o_1))
      return false;
    if (!(this.p2o_1 === tmp0_other_with_cast.p2o_1))
      return false;
    if (!(this.q2o_1 === tmp0_other_with_cast.q2o_1))
      return false;
    if (!(this.r2o_1 == tmp0_other_with_cast.r2o_1))
      return false;
    if (!equals(this.s2o_1, tmp0_other_with_cast.s2o_1))
      return false;
    if (!(this.t2o_1 === tmp0_other_with_cast.t2o_1))
      return false;
    if (!(this.u2o_1 == tmp0_other_with_cast.u2o_1))
      return false;
    if (!(this.v2o_1 === tmp0_other_with_cast.v2o_1))
      return false;
    if (!equals(this.w2o_1, tmp0_other_with_cast.w2o_1))
      return false;
    if (!(this.x2o_1 == tmp0_other_with_cast.x2o_1))
      return false;
    if (!this.y2o_1.equals(tmp0_other_with_cast.y2o_1))
      return false;
    return true;
  };
  function $serializer_108() {
    $serializer_instance_107 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantHost', this, 5);
    tmp0_serialDesc.gy('host', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('isPrimary', false);
    tmp0_serialDesc.gy('verifiedAtMs', false);
    tmp0_serialDesc.gy('certificateState', false);
    this.z2o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_108).a2p = function (encoder, value) {
    var tmp0_desc = this.z2o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.b2p_1);
    tmp1_output.hs(tmp0_desc, 1, value.c2p_1);
    tmp1_output.zr(tmp0_desc, 2, value.d2p_1);
    tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.e2p_1);
    tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.f2p_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_108).on = function (encoder, value) {
    return this.a2p(encoder, value instanceof TenantHost ? value : THROW_CCE());
  };
  protoOf($serializer_108).pn = function (decoder) {
    var tmp0_desc = this.z2o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return TenantHost_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_108).nn = function () {
    return this.z2o_1;
  };
  protoOf($serializer_108).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_107;
  function $serializer_getInstance_107() {
    if ($serializer_instance_107 == null)
      new $serializer_108();
    return $serializer_instance_107;
  }
  function TenantHost_init_$Init$(seen0, host, kind, isPrimary, verifiedAtMs, certificateState, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_107().z2o_1);
    }
    $this.b2p_1 = host;
    $this.c2p_1 = kind;
    $this.d2p_1 = isPrimary;
    $this.e2p_1 = verifiedAtMs;
    $this.f2p_1 = certificateState;
    return $this;
  }
  function TenantHost_init_$Create$(seen0, host, kind, isPrimary, verifiedAtMs, certificateState, serializationConstructorMarker) {
    return TenantHost_init_$Init$(seen0, host, kind, isPrimary, verifiedAtMs, certificateState, serializationConstructorMarker, objectCreate(protoOf(TenantHost)));
  }
  function TenantHost() {
  }
  protoOf(TenantHost).toString = function () {
    return 'TenantHost(host=' + this.b2p_1 + ', kind=' + this.c2p_1 + ', isPrimary=' + this.d2p_1 + ', verifiedAtMs=' + toString_0(this.e2p_1) + ', certificateState=' + this.f2p_1 + ')';
  };
  protoOf(TenantHost).hashCode = function () {
    var result = getStringHashCode(this.b2p_1);
    result = imul(result, 31) + getStringHashCode(this.c2p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d2p_1) | 0;
    result = imul(result, 31) + (this.e2p_1 == null ? 0 : this.e2p_1.hashCode()) | 0;
    result = imul(result, 31) + (this.f2p_1 == null ? 0 : getStringHashCode(this.f2p_1)) | 0;
    return result;
  };
  protoOf(TenantHost).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantHost))
      return false;
    var tmp0_other_with_cast = other instanceof TenantHost ? other : THROW_CCE();
    if (!(this.b2p_1 === tmp0_other_with_cast.b2p_1))
      return false;
    if (!(this.c2p_1 === tmp0_other_with_cast.c2p_1))
      return false;
    if (!(this.d2p_1 === tmp0_other_with_cast.d2p_1))
      return false;
    if (!equals(this.e2p_1, tmp0_other_with_cast.e2p_1))
      return false;
    if (!(this.f2p_1 == tmp0_other_with_cast.f2p_1))
      return false;
    return true;
  };
  function $serializer_109() {
    $serializer_instance_108 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ChannelAssignmentView', this, 7);
    tmp0_serialDesc.gy('channel', false);
    tmp0_serialDesc.gy('assetKind', false);
    tmp0_serialDesc.gy('identifier', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('assignedAtMs', false);
    tmp0_serialDesc.gy('hasCredentials', false);
    tmp0_serialDesc.gy('credentialHint', false);
    this.g2p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_109).h2p = function (encoder, value) {
    var tmp0_desc = this.g2p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.i2p_1);
    tmp1_output.hs(tmp0_desc, 1, value.j2p_1);
    tmp1_output.hs(tmp0_desc, 2, value.k2p_1);
    tmp1_output.hs(tmp0_desc, 3, value.l2p_1);
    tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.m2p_1);
    tmp1_output.zr(tmp0_desc, 5, value.n2p_1);
    tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.o2p_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_109).on = function (encoder, value) {
    return this.h2p(encoder, value instanceof ChannelAssignmentView ? value : THROW_CCE());
  };
  protoOf($serializer_109).pn = function (decoder) {
    var tmp0_desc = this.g2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.vq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.vq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return ChannelAssignmentView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_109).nn = function () {
    return this.g2p_1;
  };
  protoOf($serializer_109).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_108;
  function $serializer_getInstance_108() {
    if ($serializer_instance_108 == null)
      new $serializer_109();
    return $serializer_instance_108;
  }
  function ChannelAssignmentView_init_$Init$(seen0, channel, assetKind, identifier, state, assignedAtMs, hasCredentials, credentialHint, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_108().g2p_1);
    }
    $this.i2p_1 = channel;
    $this.j2p_1 = assetKind;
    $this.k2p_1 = identifier;
    $this.l2p_1 = state;
    $this.m2p_1 = assignedAtMs;
    $this.n2p_1 = hasCredentials;
    $this.o2p_1 = credentialHint;
    return $this;
  }
  function ChannelAssignmentView_init_$Create$(seen0, channel, assetKind, identifier, state, assignedAtMs, hasCredentials, credentialHint, serializationConstructorMarker) {
    return ChannelAssignmentView_init_$Init$(seen0, channel, assetKind, identifier, state, assignedAtMs, hasCredentials, credentialHint, serializationConstructorMarker, objectCreate(protoOf(ChannelAssignmentView)));
  }
  function ChannelAssignmentView() {
  }
  protoOf(ChannelAssignmentView).toString = function () {
    return 'ChannelAssignmentView(channel=' + this.i2p_1 + ', assetKind=' + this.j2p_1 + ', identifier=' + this.k2p_1 + ', state=' + this.l2p_1 + ', assignedAtMs=' + toString_0(this.m2p_1) + ', hasCredentials=' + this.n2p_1 + ', credentialHint=' + this.o2p_1 + ')';
  };
  protoOf(ChannelAssignmentView).hashCode = function () {
    var result = getStringHashCode(this.i2p_1);
    result = imul(result, 31) + getStringHashCode(this.j2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l2p_1) | 0;
    result = imul(result, 31) + (this.m2p_1 == null ? 0 : this.m2p_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n2p_1) | 0;
    result = imul(result, 31) + (this.o2p_1 == null ? 0 : getStringHashCode(this.o2p_1)) | 0;
    return result;
  };
  protoOf(ChannelAssignmentView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ChannelAssignmentView))
      return false;
    var tmp0_other_with_cast = other instanceof ChannelAssignmentView ? other : THROW_CCE();
    if (!(this.i2p_1 === tmp0_other_with_cast.i2p_1))
      return false;
    if (!(this.j2p_1 === tmp0_other_with_cast.j2p_1))
      return false;
    if (!(this.k2p_1 === tmp0_other_with_cast.k2p_1))
      return false;
    if (!(this.l2p_1 === tmp0_other_with_cast.l2p_1))
      return false;
    if (!equals(this.m2p_1, tmp0_other_with_cast.m2p_1))
      return false;
    if (!(this.n2p_1 === tmp0_other_with_cast.n2p_1))
      return false;
    if (!(this.o2p_1 == tmp0_other_with_cast.o2p_1))
      return false;
    return true;
  };
  function $serializer_110() {
    $serializer_instance_109 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionAddonView', this, 6);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('packKey', false);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('quantity', false);
    tmp0_serialDesc.gy('purchasedAtMs', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    this.p2p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_110).q2p = function (encoder, value) {
    var tmp0_desc = this.p2p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.r2p_1);
    tmp1_output.hs(tmp0_desc, 1, value.s2p_1);
    tmp1_output.hs(tmp0_desc, 2, value.t2p_1);
    tmp1_output.ds(tmp0_desc, 3, value.u2p_1);
    tmp1_output.ds(tmp0_desc, 4, value.v2p_1);
    tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.w2p_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_110).on = function (encoder, value) {
    return this.q2p(encoder, value instanceof SubscriptionAddonView ? value : THROW_CCE());
  };
  protoOf($serializer_110).pn = function (decoder) {
    var tmp0_desc = this.p2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return SubscriptionAddonView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_110).nn = function () {
    return this.p2p_1;
  };
  protoOf($serializer_110).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_109;
  function $serializer_getInstance_109() {
    if ($serializer_instance_109 == null)
      new $serializer_110();
    return $serializer_instance_109;
  }
  function SubscriptionAddonView_init_$Init$(seen0, id, packKey, limitKey, quantity, purchasedAtMs, expiresAtMs, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_109().p2p_1);
    }
    $this.r2p_1 = id;
    $this.s2p_1 = packKey;
    $this.t2p_1 = limitKey;
    $this.u2p_1 = quantity;
    $this.v2p_1 = purchasedAtMs;
    $this.w2p_1 = expiresAtMs;
    return $this;
  }
  function SubscriptionAddonView_init_$Create$(seen0, id, packKey, limitKey, quantity, purchasedAtMs, expiresAtMs, serializationConstructorMarker) {
    return SubscriptionAddonView_init_$Init$(seen0, id, packKey, limitKey, quantity, purchasedAtMs, expiresAtMs, serializationConstructorMarker, objectCreate(protoOf(SubscriptionAddonView)));
  }
  function SubscriptionAddonView() {
  }
  protoOf(SubscriptionAddonView).toString = function () {
    return 'SubscriptionAddonView(id=' + this.r2p_1 + ', packKey=' + this.s2p_1 + ', limitKey=' + this.t2p_1 + ', quantity=' + this.u2p_1.toString() + ', purchasedAtMs=' + this.v2p_1.toString() + ', expiresAtMs=' + toString_0(this.w2p_1) + ')';
  };
  protoOf(SubscriptionAddonView).hashCode = function () {
    var result = getStringHashCode(this.r2p_1);
    result = imul(result, 31) + getStringHashCode(this.s2p_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t2p_1) | 0;
    result = imul(result, 31) + this.u2p_1.hashCode() | 0;
    result = imul(result, 31) + this.v2p_1.hashCode() | 0;
    result = imul(result, 31) + (this.w2p_1 == null ? 0 : this.w2p_1.hashCode()) | 0;
    return result;
  };
  protoOf(SubscriptionAddonView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionAddonView))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionAddonView ? other : THROW_CCE();
    if (!(this.r2p_1 === tmp0_other_with_cast.r2p_1))
      return false;
    if (!(this.s2p_1 === tmp0_other_with_cast.s2p_1))
      return false;
    if (!(this.t2p_1 === tmp0_other_with_cast.t2p_1))
      return false;
    if (!this.u2p_1.equals(tmp0_other_with_cast.u2p_1))
      return false;
    if (!this.v2p_1.equals(tmp0_other_with_cast.v2p_1))
      return false;
    if (!equals(this.w2p_1, tmp0_other_with_cast.w2p_1))
      return false;
    return true;
  };
  function Companion_91() {
    Companion_instance_91 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x2p_1 = [null, null, new ArrayListSerializer($serializer_getInstance_111()), null];
  }
  var Companion_instance_91;
  function Companion_getInstance_91() {
    if (Companion_instance_91 == null)
      new Companion_91();
    return Companion_instance_91;
  }
  function $serializer_111() {
    $serializer_instance_110 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UsageSeries', this, 4);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('unit', false);
    tmp0_serialDesc.gy('points', false);
    tmp0_serialDesc.gy('allowance', false);
    this.y2p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_111).z2p = function (encoder, value) {
    var tmp0_desc = this.y2p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_91().x2p_1;
    tmp1_output.hs(tmp0_desc, 0, value.a2q_1);
    tmp1_output.hs(tmp0_desc, 1, value.b2q_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.c2q_1);
    tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.d2q_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_111).on = function (encoder, value) {
    return this.z2p(encoder, value instanceof UsageSeries ? value : THROW_CCE());
  };
  protoOf($serializer_111).pn = function (decoder) {
    var tmp0_desc = this.y2p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_91().x2p_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return UsageSeries_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_111).nn = function () {
    return this.y2p_1;
  };
  protoOf($serializer_111).vy = function () {
    var tmp0_cached = Companion_getInstance_91().x2p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_110;
  function $serializer_getInstance_110() {
    if ($serializer_instance_110 == null)
      new $serializer_111();
    return $serializer_instance_110;
  }
  function UsageSeries_init_$Init$(seen0, limitKey, unit, points, allowance, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_110().y2p_1);
    }
    $this.a2q_1 = limitKey;
    $this.b2q_1 = unit;
    $this.c2q_1 = points;
    $this.d2q_1 = allowance;
    return $this;
  }
  function UsageSeries_init_$Create$(seen0, limitKey, unit, points, allowance, serializationConstructorMarker) {
    return UsageSeries_init_$Init$(seen0, limitKey, unit, points, allowance, serializationConstructorMarker, objectCreate(protoOf(UsageSeries)));
  }
  function UsageSeries() {
  }
  protoOf(UsageSeries).toString = function () {
    return 'UsageSeries(limitKey=' + this.a2q_1 + ', unit=' + this.b2q_1 + ', points=' + toString(this.c2q_1) + ', allowance=' + toString_0(this.d2q_1) + ')';
  };
  protoOf(UsageSeries).hashCode = function () {
    var result = getStringHashCode(this.a2q_1);
    result = imul(result, 31) + getStringHashCode(this.b2q_1) | 0;
    result = imul(result, 31) + hashCode(this.c2q_1) | 0;
    result = imul(result, 31) + (this.d2q_1 == null ? 0 : this.d2q_1.hashCode()) | 0;
    return result;
  };
  protoOf(UsageSeries).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UsageSeries))
      return false;
    var tmp0_other_with_cast = other instanceof UsageSeries ? other : THROW_CCE();
    if (!(this.a2q_1 === tmp0_other_with_cast.a2q_1))
      return false;
    if (!(this.b2q_1 === tmp0_other_with_cast.b2q_1))
      return false;
    if (!equals(this.c2q_1, tmp0_other_with_cast.c2q_1))
      return false;
    if (!equals(this.d2q_1, tmp0_other_with_cast.d2q_1))
      return false;
    return true;
  };
  function $serializer_112() {
    $serializer_instance_111 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.UsagePoint', this, 2);
    tmp0_serialDesc.gy('periodStartMs', false);
    tmp0_serialDesc.gy('used', false);
    this.e2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_112).f2q = function (encoder, value) {
    var tmp0_desc = this.e2q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.g2q_1);
    tmp1_output.ds(tmp0_desc, 1, value.h2q_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_112).on = function (encoder, value) {
    return this.f2q(encoder, value instanceof UsagePoint ? value : THROW_CCE());
  };
  protoOf($serializer_112).pn = function (decoder) {
    var tmp0_desc = this.e2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return UsagePoint_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_112).nn = function () {
    return this.e2q_1;
  };
  protoOf($serializer_112).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_111;
  function $serializer_getInstance_111() {
    if ($serializer_instance_111 == null)
      new $serializer_112();
    return $serializer_instance_111;
  }
  function UsagePoint_init_$Init$(seen0, periodStartMs, used, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_111().e2q_1);
    }
    $this.g2q_1 = periodStartMs;
    $this.h2q_1 = used;
    return $this;
  }
  function UsagePoint_init_$Create$(seen0, periodStartMs, used, serializationConstructorMarker) {
    return UsagePoint_init_$Init$(seen0, periodStartMs, used, serializationConstructorMarker, objectCreate(protoOf(UsagePoint)));
  }
  function UsagePoint() {
  }
  protoOf(UsagePoint).toString = function () {
    return 'UsagePoint(periodStartMs=' + this.g2q_1.toString() + ', used=' + this.h2q_1.toString() + ')';
  };
  protoOf(UsagePoint).hashCode = function () {
    var result = this.g2q_1.hashCode();
    result = imul(result, 31) + this.h2q_1.hashCode() | 0;
    return result;
  };
  protoOf(UsagePoint).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UsagePoint))
      return false;
    var tmp0_other_with_cast = other instanceof UsagePoint ? other : THROW_CCE();
    if (!this.g2q_1.equals(tmp0_other_with_cast.g2q_1))
      return false;
    if (!this.h2q_1.equals(tmp0_other_with_cast.h2q_1))
      return false;
    return true;
  };
  function $serializer_113() {
    $serializer_instance_112 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantSetupProjection', this, 5);
    tmp0_serialDesc.gy('ownerStatus', false);
    tmp0_serialDesc.gy('ownerFirstSignInAtMs', true);
    tmp0_serialDesc.gy('setupStatus', false);
    tmp0_serialDesc.gy('pendingItems', true);
    tmp0_serialDesc.gy('activeVisitCount', true);
    this.i2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_113).j2q = function (encoder, value) {
    var tmp0_desc = this.i2q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.k2q_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.l2q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.l2q_1);
    }
    tmp1_output.hs(tmp0_desc, 2, value.m2q_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.n2q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, IntSerializer_getInstance(), value.n2q_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.o2q_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, IntSerializer_getInstance(), value.o2q_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_113).on = function (encoder, value) {
    return this.j2q(encoder, value instanceof TenantSetupProjection ? value : THROW_CCE());
  };
  protoOf($serializer_113).pn = function (decoder) {
    var tmp0_desc = this.i2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.hr(tmp0_desc, 4, IntSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return TenantSetupProjection_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_113).nn = function () {
    return this.i2q_1;
  };
  protoOf($serializer_113).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance())];
  };
  var $serializer_instance_112;
  function $serializer_getInstance_112() {
    if ($serializer_instance_112 == null)
      new $serializer_113();
    return $serializer_instance_112;
  }
  function TenantSetupProjection_init_$Init$(seen0, ownerStatus, ownerFirstSignInAtMs, setupStatus, pendingItems, activeVisitCount, serializationConstructorMarker, $this) {
    if (!(5 === (5 & seen0))) {
      throwMissingFieldException(seen0, 5, $serializer_getInstance_112().i2q_1);
    }
    $this.k2q_1 = ownerStatus;
    if (0 === (seen0 & 2))
      $this.l2q_1 = null;
    else
      $this.l2q_1 = ownerFirstSignInAtMs;
    $this.m2q_1 = setupStatus;
    if (0 === (seen0 & 8))
      $this.n2q_1 = null;
    else
      $this.n2q_1 = pendingItems;
    if (0 === (seen0 & 16))
      $this.o2q_1 = null;
    else
      $this.o2q_1 = activeVisitCount;
    return $this;
  }
  function TenantSetupProjection_init_$Create$(seen0, ownerStatus, ownerFirstSignInAtMs, setupStatus, pendingItems, activeVisitCount, serializationConstructorMarker) {
    return TenantSetupProjection_init_$Init$(seen0, ownerStatus, ownerFirstSignInAtMs, setupStatus, pendingItems, activeVisitCount, serializationConstructorMarker, objectCreate(protoOf(TenantSetupProjection)));
  }
  function TenantSetupProjection() {
  }
  protoOf(TenantSetupProjection).toString = function () {
    return 'TenantSetupProjection(ownerStatus=' + this.k2q_1 + ', ownerFirstSignInAtMs=' + toString_0(this.l2q_1) + ', setupStatus=' + this.m2q_1 + ', pendingItems=' + this.n2q_1 + ', activeVisitCount=' + this.o2q_1 + ')';
  };
  protoOf(TenantSetupProjection).hashCode = function () {
    var result = getStringHashCode(this.k2q_1);
    result = imul(result, 31) + (this.l2q_1 == null ? 0 : this.l2q_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.m2q_1) | 0;
    result = imul(result, 31) + (this.n2q_1 == null ? 0 : this.n2q_1) | 0;
    result = imul(result, 31) + (this.o2q_1 == null ? 0 : this.o2q_1) | 0;
    return result;
  };
  protoOf(TenantSetupProjection).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantSetupProjection))
      return false;
    var tmp0_other_with_cast = other instanceof TenantSetupProjection ? other : THROW_CCE();
    if (!(this.k2q_1 === tmp0_other_with_cast.k2q_1))
      return false;
    if (!equals(this.l2q_1, tmp0_other_with_cast.l2q_1))
      return false;
    if (!(this.m2q_1 === tmp0_other_with_cast.m2q_1))
      return false;
    if (!(this.n2q_1 == tmp0_other_with_cast.n2q_1))
      return false;
    if (!(this.o2q_1 == tmp0_other_with_cast.o2q_1))
      return false;
    return true;
  };
  function $serializer_114() {
    $serializer_instance_113 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.InvoiceLineView', this, 5);
    tmp0_serialDesc.gy('description', false);
    tmp0_serialDesc.gy('quantity', false);
    tmp0_serialDesc.gy('unitPriceMinor', false);
    tmp0_serialDesc.gy('amountMinor', false);
    tmp0_serialDesc.gy('kind', false);
    this.p2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_114).q2q = function (encoder, value) {
    var tmp0_desc = this.p2q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.r2q_1);
    tmp1_output.ds(tmp0_desc, 1, value.s2q_1);
    tmp1_output.ds(tmp0_desc, 2, value.t2q_1);
    tmp1_output.ds(tmp0_desc, 3, value.u2q_1);
    tmp1_output.hs(tmp0_desc, 4, value.v2q_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_114).on = function (encoder, value) {
    return this.q2q(encoder, value instanceof InvoiceLineView ? value : THROW_CCE());
  };
  protoOf($serializer_114).pn = function (decoder) {
    var tmp0_desc = this.p2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return InvoiceLineView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_114).nn = function () {
    return this.p2q_1;
  };
  protoOf($serializer_114).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_113;
  function $serializer_getInstance_113() {
    if ($serializer_instance_113 == null)
      new $serializer_114();
    return $serializer_instance_113;
  }
  function InvoiceLineView_init_$Init$(seen0, description, quantity, unitPriceMinor, amountMinor, kind, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_113().p2q_1);
    }
    $this.r2q_1 = description;
    $this.s2q_1 = quantity;
    $this.t2q_1 = unitPriceMinor;
    $this.u2q_1 = amountMinor;
    $this.v2q_1 = kind;
    return $this;
  }
  function InvoiceLineView_init_$Create$(seen0, description, quantity, unitPriceMinor, amountMinor, kind, serializationConstructorMarker) {
    return InvoiceLineView_init_$Init$(seen0, description, quantity, unitPriceMinor, amountMinor, kind, serializationConstructorMarker, objectCreate(protoOf(InvoiceLineView)));
  }
  function InvoiceLineView() {
  }
  protoOf(InvoiceLineView).toString = function () {
    return 'InvoiceLineView(description=' + this.r2q_1 + ', quantity=' + this.s2q_1.toString() + ', unitPriceMinor=' + this.t2q_1.toString() + ', amountMinor=' + this.u2q_1.toString() + ', kind=' + this.v2q_1 + ')';
  };
  protoOf(InvoiceLineView).hashCode = function () {
    var result = getStringHashCode(this.r2q_1);
    result = imul(result, 31) + this.s2q_1.hashCode() | 0;
    result = imul(result, 31) + this.t2q_1.hashCode() | 0;
    result = imul(result, 31) + this.u2q_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.v2q_1) | 0;
    return result;
  };
  protoOf(InvoiceLineView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof InvoiceLineView))
      return false;
    var tmp0_other_with_cast = other instanceof InvoiceLineView ? other : THROW_CCE();
    if (!(this.r2q_1 === tmp0_other_with_cast.r2q_1))
      return false;
    if (!this.s2q_1.equals(tmp0_other_with_cast.s2q_1))
      return false;
    if (!this.t2q_1.equals(tmp0_other_with_cast.t2q_1))
      return false;
    if (!this.u2q_1.equals(tmp0_other_with_cast.u2q_1))
      return false;
    if (!(this.v2q_1 === tmp0_other_with_cast.v2q_1))
      return false;
    return true;
  };
  function $serializer_115() {
    $serializer_instance_114 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PaymentView', this, 7);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('amountMinor', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('method', false);
    tmp0_serialDesc.gy('paidAtMs', false);
    tmp0_serialDesc.gy('reference', false);
    tmp0_serialDesc.gy('recordedBy', false);
    this.w2q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_115).x2q = function (encoder, value) {
    var tmp0_desc = this.w2q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.y2q_1);
    tmp1_output.ds(tmp0_desc, 1, value.z2q_1);
    tmp1_output.hs(tmp0_desc, 2, value.a2r_1);
    tmp1_output.hs(tmp0_desc, 3, value.b2r_1);
    tmp1_output.ds(tmp0_desc, 4, value.c2r_1);
    tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.d2r_1);
    tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.e2r_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_115).on = function (encoder, value) {
    return this.x2q(encoder, value instanceof PaymentView ? value : THROW_CCE());
  };
  protoOf($serializer_115).pn = function (decoder) {
    var tmp0_desc = this.w2q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return PaymentView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_115).nn = function () {
    return this.w2q_1;
  };
  protoOf($serializer_115).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_114;
  function $serializer_getInstance_114() {
    if ($serializer_instance_114 == null)
      new $serializer_115();
    return $serializer_instance_114;
  }
  function PaymentView_init_$Init$(seen0, id, amountMinor, currency, method, paidAtMs, reference, recordedBy, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_114().w2q_1);
    }
    $this.y2q_1 = id;
    $this.z2q_1 = amountMinor;
    $this.a2r_1 = currency;
    $this.b2r_1 = method;
    $this.c2r_1 = paidAtMs;
    $this.d2r_1 = reference;
    $this.e2r_1 = recordedBy;
    return $this;
  }
  function PaymentView_init_$Create$(seen0, id, amountMinor, currency, method, paidAtMs, reference, recordedBy, serializationConstructorMarker) {
    return PaymentView_init_$Init$(seen0, id, amountMinor, currency, method, paidAtMs, reference, recordedBy, serializationConstructorMarker, objectCreate(protoOf(PaymentView)));
  }
  function PaymentView() {
  }
  protoOf(PaymentView).toString = function () {
    return 'PaymentView(id=' + this.y2q_1 + ', amountMinor=' + this.z2q_1.toString() + ', currency=' + this.a2r_1 + ', method=' + this.b2r_1 + ', paidAtMs=' + this.c2r_1.toString() + ', reference=' + this.d2r_1 + ', recordedBy=' + this.e2r_1 + ')';
  };
  protoOf(PaymentView).hashCode = function () {
    var result = getStringHashCode(this.y2q_1);
    result = imul(result, 31) + this.z2q_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.a2r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b2r_1) | 0;
    result = imul(result, 31) + this.c2r_1.hashCode() | 0;
    result = imul(result, 31) + (this.d2r_1 == null ? 0 : getStringHashCode(this.d2r_1)) | 0;
    result = imul(result, 31) + (this.e2r_1 == null ? 0 : getStringHashCode(this.e2r_1)) | 0;
    return result;
  };
  protoOf(PaymentView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PaymentView))
      return false;
    var tmp0_other_with_cast = other instanceof PaymentView ? other : THROW_CCE();
    if (!(this.y2q_1 === tmp0_other_with_cast.y2q_1))
      return false;
    if (!this.z2q_1.equals(tmp0_other_with_cast.z2q_1))
      return false;
    if (!(this.a2r_1 === tmp0_other_with_cast.a2r_1))
      return false;
    if (!(this.b2r_1 === tmp0_other_with_cast.b2r_1))
      return false;
    if (!this.c2r_1.equals(tmp0_other_with_cast.c2r_1))
      return false;
    if (!(this.d2r_1 == tmp0_other_with_cast.d2r_1))
      return false;
    if (!(this.e2r_1 == tmp0_other_with_cast.e2r_1))
      return false;
    return true;
  };
  function LoginOutcome_SUCCESS_getInstance() {
    LoginOutcome_initEntries();
    return LoginOutcome_SUCCESS_instance;
  }
  function LoginOutcome_BAD_CREDENTIALS_getInstance() {
    LoginOutcome_initEntries();
    return LoginOutcome_BAD_CREDENTIALS_instance;
  }
  function LoginOutcome_TOTP_REQUIRED_getInstance() {
    LoginOutcome_initEntries();
    return LoginOutcome_TOTP_REQUIRED_instance;
  }
  function LoginOutcome_TOTP_INVALID_getInstance() {
    LoginOutcome_initEntries();
    return LoginOutcome_TOTP_INVALID_instance;
  }
  function LoginOutcome_ENROLMENT_REQUIRED_getInstance() {
    LoginOutcome_initEntries();
    return LoginOutcome_ENROLMENT_REQUIRED_instance;
  }
  function LoginOutcome_LOCKED_getInstance() {
    LoginOutcome_initEntries();
    return LoginOutcome_LOCKED_instance;
  }
  function LoginOutcome_INACTIVE_getInstance() {
    LoginOutcome_initEntries();
    return LoginOutcome_INACTIVE_instance;
  }
  function Companion_92() {
    Companion_instance_92 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f2r_1 = [null, null, new ArrayListSerializer($serializer_getInstance_124())];
  }
  var Companion_instance_92;
  function Companion_getInstance_92() {
    if (Companion_instance_92 == null)
      new Companion_92();
    return Companion_instance_92;
  }
  function $serializer_116() {
    $serializer_instance_115 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ConfigDiffView', this, 3);
    tmp0_serialDesc.gy('left', false);
    tmp0_serialDesc.gy('right', false);
    tmp0_serialDesc.gy('tables', false);
    this.g2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_116).h2r = function (encoder, value) {
    var tmp0_desc = this.g2r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_92().f2r_1;
    tmp1_output.hs(tmp0_desc, 0, value.i2r_1);
    tmp1_output.hs(tmp0_desc, 1, value.j2r_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.k2r_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_116).on = function (encoder, value) {
    return this.h2r(encoder, value instanceof ConfigDiffView ? value : THROW_CCE());
  };
  protoOf($serializer_116).pn = function (decoder) {
    var tmp0_desc = this.g2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_92().f2r_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return ConfigDiffView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_116).nn = function () {
    return this.g2r_1;
  };
  protoOf($serializer_116).vy = function () {
    var tmp0_cached = Companion_getInstance_92().f2r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2]];
  };
  var $serializer_instance_115;
  function $serializer_getInstance_115() {
    if ($serializer_instance_115 == null)
      new $serializer_116();
    return $serializer_instance_115;
  }
  function ConfigDiffView_init_$Init$(seen0, left, right, tables, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_115().g2r_1);
    }
    $this.i2r_1 = left;
    $this.j2r_1 = right;
    $this.k2r_1 = tables;
    return $this;
  }
  function ConfigDiffView_init_$Create$(seen0, left, right, tables, serializationConstructorMarker) {
    return ConfigDiffView_init_$Init$(seen0, left, right, tables, serializationConstructorMarker, objectCreate(protoOf(ConfigDiffView)));
  }
  function ConfigDiffView(left, right, tables) {
    Companion_getInstance_92();
    this.i2r_1 = left;
    this.j2r_1 = right;
    this.k2r_1 = tables;
  }
  protoOf(ConfigDiffView).toString = function () {
    return 'ConfigDiffView(left=' + this.i2r_1 + ', right=' + this.j2r_1 + ', tables=' + toString(this.k2r_1) + ')';
  };
  protoOf(ConfigDiffView).hashCode = function () {
    var result = getStringHashCode(this.i2r_1);
    result = imul(result, 31) + getStringHashCode(this.j2r_1) | 0;
    result = imul(result, 31) + hashCode(this.k2r_1) | 0;
    return result;
  };
  protoOf(ConfigDiffView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConfigDiffView))
      return false;
    var tmp0_other_with_cast = other instanceof ConfigDiffView ? other : THROW_CCE();
    if (!(this.i2r_1 === tmp0_other_with_cast.i2r_1))
      return false;
    if (!(this.j2r_1 === tmp0_other_with_cast.j2r_1))
      return false;
    if (!equals(this.k2r_1, tmp0_other_with_cast.k2r_1))
      return false;
    return true;
  };
  function Companion_93() {
    Companion_instance_93 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l2r_1 = [null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_93;
  function Companion_getInstance_93() {
    if (Companion_instance_93 == null)
      new Companion_93();
    return Companion_instance_93;
  }
  function $serializer_117() {
    $serializer_instance_116 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ConfigDiffQuery', this, 3);
    tmp0_serialDesc.gy('left', false);
    tmp0_serialDesc.gy('right', false);
    tmp0_serialDesc.gy('areas', true);
    this.m2r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_117).n2r = function (encoder, value) {
    var tmp0_desc = this.m2r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_93().l2r_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_123(), value.o2r_1);
    tmp1_output.js(tmp0_desc, 1, $serializer_getInstance_123(), value.p2r_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !equals(value.q2r_1, ConfigAreaKeys_getInstance().x2r_1)) {
      tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.q2r_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_117).on = function (encoder, value) {
    return this.n2r(encoder, value instanceof ConfigDiffQuery ? value : THROW_CCE());
  };
  protoOf($serializer_117).pn = function (decoder) {
    var tmp0_desc = this.m2r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_93().l2r_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, $serializer_getInstance_123(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_123(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, $serializer_getInstance_123(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return ConfigDiffQuery_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_117).nn = function () {
    return this.m2r_1;
  };
  protoOf($serializer_117).vy = function () {
    var tmp0_cached = Companion_getInstance_93().l2r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_123(), $serializer_getInstance_123(), tmp0_cached[2]];
  };
  var $serializer_instance_116;
  function $serializer_getInstance_116() {
    if ($serializer_instance_116 == null)
      new $serializer_117();
    return $serializer_instance_116;
  }
  function ConfigDiffQuery_init_$Init$(seen0, left, right, areas, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_116().m2r_1);
    }
    $this.o2r_1 = left;
    $this.p2r_1 = right;
    if (0 === (seen0 & 4))
      $this.q2r_1 = ConfigAreaKeys_getInstance().x2r_1;
    else
      $this.q2r_1 = areas;
    return $this;
  }
  function ConfigDiffQuery_init_$Create$(seen0, left, right, areas, serializationConstructorMarker) {
    return ConfigDiffQuery_init_$Init$(seen0, left, right, areas, serializationConstructorMarker, objectCreate(protoOf(ConfigDiffQuery)));
  }
  function ConfigDiffQuery(left, right, areas) {
    Companion_getInstance_93();
    areas = areas === VOID ? ConfigAreaKeys_getInstance().x2r_1 : areas;
    this.o2r_1 = left;
    this.p2r_1 = right;
    this.q2r_1 = areas;
  }
  protoOf(ConfigDiffQuery).toString = function () {
    return 'ConfigDiffQuery(left=' + this.o2r_1.toString() + ', right=' + this.p2r_1.toString() + ', areas=' + toString(this.q2r_1) + ')';
  };
  protoOf(ConfigDiffQuery).hashCode = function () {
    var result = this.o2r_1.hashCode();
    result = imul(result, 31) + this.p2r_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.q2r_1) | 0;
    return result;
  };
  protoOf(ConfigDiffQuery).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConfigDiffQuery))
      return false;
    var tmp0_other_with_cast = other instanceof ConfigDiffQuery ? other : THROW_CCE();
    if (!this.o2r_1.equals(tmp0_other_with_cast.o2r_1))
      return false;
    if (!this.p2r_1.equals(tmp0_other_with_cast.p2r_1))
      return false;
    if (!equals(this.q2r_1, tmp0_other_with_cast.q2r_1))
      return false;
    return true;
  };
  function Companion_94() {
    Companion_instance_94 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2r_1 = [null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null];
  }
  var Companion_instance_94;
  function Companion_getInstance_94() {
    if (Companion_instance_94 == null)
      new Companion_94();
    return Companion_instance_94;
  }
  function $serializer_118() {
    $serializer_instance_117 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.BlueprintView', this, 10);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('name', false);
    tmp0_serialDesc.gy('description', false);
    tmp0_serialDesc.gy('sourceSlug', false);
    tmp0_serialDesc.gy('areas', false);
    tmp0_serialDesc.gy('manifestVersion', false);
    tmp0_serialDesc.gy('tableCount', false);
    tmp0_serialDesc.gy('rowCount', false);
    tmp0_serialDesc.gy('createdAtMs', false);
    tmp0_serialDesc.gy('createdBy', false);
    this.a2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_118).b2s = function (encoder, value) {
    var tmp0_desc = this.a2s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_94().z2r_1;
    tmp1_output.hs(tmp0_desc, 0, value.c2s_1);
    tmp1_output.hs(tmp0_desc, 1, value.d2s_1);
    tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.e2s_1);
    tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.f2s_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.g2s_1);
    tmp1_output.cs(tmp0_desc, 5, value.h2s_1);
    tmp1_output.cs(tmp0_desc, 6, value.i2s_1);
    tmp1_output.cs(tmp0_desc, 7, value.j2s_1);
    tmp1_output.ds(tmp0_desc, 8, value.k2s_1);
    tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.l2s_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_118).on = function (encoder, value) {
    return this.b2s(encoder, value instanceof BlueprintView ? value : THROW_CCE());
  };
  protoOf($serializer_118).pn = function (decoder) {
    var tmp0_desc = this.a2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = 0;
    var tmp11_local7 = 0;
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = null;
    var tmp14_input = decoder.tq(tmp0_desc);
    var tmp15_cached = Companion_getInstance_94().z2r_1;
    if (tmp14_input.ir()) {
      tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.fr(tmp0_desc, 4, tmp15_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.yq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.yq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.fr(tmp0_desc, 4, tmp15_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.yq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.yq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.uq(tmp0_desc);
    return BlueprintView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_118).nn = function () {
    return this.a2s_1;
  };
  protoOf($serializer_118).vy = function () {
    var tmp0_cached = Companion_getInstance_94().z2r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[4], IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_117;
  function $serializer_getInstance_117() {
    if ($serializer_instance_117 == null)
      new $serializer_118();
    return $serializer_instance_117;
  }
  function BlueprintView_init_$Init$(seen0, id, name, description, sourceSlug, areas, manifestVersion, tableCount, rowCount, createdAtMs, createdBy, serializationConstructorMarker, $this) {
    if (!(1023 === (1023 & seen0))) {
      throwMissingFieldException(seen0, 1023, $serializer_getInstance_117().a2s_1);
    }
    $this.c2s_1 = id;
    $this.d2s_1 = name;
    $this.e2s_1 = description;
    $this.f2s_1 = sourceSlug;
    $this.g2s_1 = areas;
    $this.h2s_1 = manifestVersion;
    $this.i2s_1 = tableCount;
    $this.j2s_1 = rowCount;
    $this.k2s_1 = createdAtMs;
    $this.l2s_1 = createdBy;
    return $this;
  }
  function BlueprintView_init_$Create$(seen0, id, name, description, sourceSlug, areas, manifestVersion, tableCount, rowCount, createdAtMs, createdBy, serializationConstructorMarker) {
    return BlueprintView_init_$Init$(seen0, id, name, description, sourceSlug, areas, manifestVersion, tableCount, rowCount, createdAtMs, createdBy, serializationConstructorMarker, objectCreate(protoOf(BlueprintView)));
  }
  function BlueprintView(id, name, description, sourceSlug, areas, manifestVersion, tableCount, rowCount, createdAtMs, createdBy) {
    Companion_getInstance_94();
    this.c2s_1 = id;
    this.d2s_1 = name;
    this.e2s_1 = description;
    this.f2s_1 = sourceSlug;
    this.g2s_1 = areas;
    this.h2s_1 = manifestVersion;
    this.i2s_1 = tableCount;
    this.j2s_1 = rowCount;
    this.k2s_1 = createdAtMs;
    this.l2s_1 = createdBy;
  }
  protoOf(BlueprintView).toString = function () {
    return 'BlueprintView(id=' + this.c2s_1 + ', name=' + this.d2s_1 + ', description=' + this.e2s_1 + ', sourceSlug=' + this.f2s_1 + ', areas=' + toString(this.g2s_1) + ', manifestVersion=' + this.h2s_1 + ', tableCount=' + this.i2s_1 + ', rowCount=' + this.j2s_1 + ', createdAtMs=' + this.k2s_1.toString() + ', createdBy=' + this.l2s_1 + ')';
  };
  protoOf(BlueprintView).hashCode = function () {
    var result = getStringHashCode(this.c2s_1);
    result = imul(result, 31) + getStringHashCode(this.d2s_1) | 0;
    result = imul(result, 31) + (this.e2s_1 == null ? 0 : getStringHashCode(this.e2s_1)) | 0;
    result = imul(result, 31) + (this.f2s_1 == null ? 0 : getStringHashCode(this.f2s_1)) | 0;
    result = imul(result, 31) + hashCode(this.g2s_1) | 0;
    result = imul(result, 31) + this.h2s_1 | 0;
    result = imul(result, 31) + this.i2s_1 | 0;
    result = imul(result, 31) + this.j2s_1 | 0;
    result = imul(result, 31) + this.k2s_1.hashCode() | 0;
    result = imul(result, 31) + (this.l2s_1 == null ? 0 : getStringHashCode(this.l2s_1)) | 0;
    return result;
  };
  protoOf(BlueprintView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BlueprintView))
      return false;
    var tmp0_other_with_cast = other instanceof BlueprintView ? other : THROW_CCE();
    if (!(this.c2s_1 === tmp0_other_with_cast.c2s_1))
      return false;
    if (!(this.d2s_1 === tmp0_other_with_cast.d2s_1))
      return false;
    if (!(this.e2s_1 == tmp0_other_with_cast.e2s_1))
      return false;
    if (!(this.f2s_1 == tmp0_other_with_cast.f2s_1))
      return false;
    if (!equals(this.g2s_1, tmp0_other_with_cast.g2s_1))
      return false;
    if (!(this.h2s_1 === tmp0_other_with_cast.h2s_1))
      return false;
    if (!(this.i2s_1 === tmp0_other_with_cast.i2s_1))
      return false;
    if (!(this.j2s_1 === tmp0_other_with_cast.j2s_1))
      return false;
    if (!this.k2s_1.equals(tmp0_other_with_cast.k2s_1))
      return false;
    if (!(this.l2s_1 == tmp0_other_with_cast.l2s_1))
      return false;
    return true;
  };
  function Companion_95() {
    Companion_instance_95 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m2s_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_95;
  function Companion_getInstance_95() {
    if (Companion_instance_95 == null)
      new Companion_95();
    return Companion_instance_95;
  }
  function $serializer_119() {
    $serializer_instance_118 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SaveBlueprintRequest', this, 4);
    tmp0_serialDesc.gy('name', false);
    tmp0_serialDesc.gy('description', true);
    tmp0_serialDesc.gy('sourceTenantSlug', false);
    tmp0_serialDesc.gy('areas', true);
    this.n2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_119).o2s = function (encoder, value) {
    var tmp0_desc = this.n2s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_95().m2s_1;
    tmp1_output.hs(tmp0_desc, 0, value.p2s_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.q2s_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.q2s_1);
    }
    tmp1_output.hs(tmp0_desc, 2, value.r2s_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !equals(value.s2s_1, ConfigAreaKeys_getInstance().y2r_1)) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.s2s_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_119).on = function (encoder, value) {
    return this.o2s(encoder, value instanceof SaveBlueprintRequest ? value : THROW_CCE());
  };
  protoOf($serializer_119).pn = function (decoder) {
    var tmp0_desc = this.n2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_95().m2s_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return SaveBlueprintRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_119).nn = function () {
    return this.n2s_1;
  };
  protoOf($serializer_119).vy = function () {
    var tmp0_cached = Companion_getInstance_95().m2s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[3]];
  };
  var $serializer_instance_118;
  function $serializer_getInstance_118() {
    if ($serializer_instance_118 == null)
      new $serializer_119();
    return $serializer_instance_118;
  }
  function SaveBlueprintRequest_init_$Init$(seen0, name, description, sourceTenantSlug, areas, serializationConstructorMarker, $this) {
    if (!(5 === (5 & seen0))) {
      throwMissingFieldException(seen0, 5, $serializer_getInstance_118().n2s_1);
    }
    $this.p2s_1 = name;
    if (0 === (seen0 & 2))
      $this.q2s_1 = null;
    else
      $this.q2s_1 = description;
    $this.r2s_1 = sourceTenantSlug;
    if (0 === (seen0 & 8))
      $this.s2s_1 = ConfigAreaKeys_getInstance().y2r_1;
    else
      $this.s2s_1 = areas;
    return $this;
  }
  function SaveBlueprintRequest_init_$Create$(seen0, name, description, sourceTenantSlug, areas, serializationConstructorMarker) {
    return SaveBlueprintRequest_init_$Init$(seen0, name, description, sourceTenantSlug, areas, serializationConstructorMarker, objectCreate(protoOf(SaveBlueprintRequest)));
  }
  function SaveBlueprintRequest(name, description, sourceTenantSlug, areas) {
    Companion_getInstance_95();
    description = description === VOID ? null : description;
    areas = areas === VOID ? ConfigAreaKeys_getInstance().y2r_1 : areas;
    this.p2s_1 = name;
    this.q2s_1 = description;
    this.r2s_1 = sourceTenantSlug;
    this.s2s_1 = areas;
  }
  protoOf(SaveBlueprintRequest).toString = function () {
    return 'SaveBlueprintRequest(name=' + this.p2s_1 + ', description=' + this.q2s_1 + ', sourceTenantSlug=' + this.r2s_1 + ', areas=' + toString(this.s2s_1) + ')';
  };
  protoOf(SaveBlueprintRequest).hashCode = function () {
    var result = getStringHashCode(this.p2s_1);
    result = imul(result, 31) + (this.q2s_1 == null ? 0 : getStringHashCode(this.q2s_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.r2s_1) | 0;
    result = imul(result, 31) + hashCode(this.s2s_1) | 0;
    return result;
  };
  protoOf(SaveBlueprintRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaveBlueprintRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SaveBlueprintRequest ? other : THROW_CCE();
    if (!(this.p2s_1 === tmp0_other_with_cast.p2s_1))
      return false;
    if (!(this.q2s_1 == tmp0_other_with_cast.q2s_1))
      return false;
    if (!(this.r2s_1 === tmp0_other_with_cast.r2s_1))
      return false;
    if (!equals(this.s2s_1, tmp0_other_with_cast.s2s_1))
      return false;
    return true;
  };
  function Companion_96() {
    Companion_instance_96 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t2s_1 = [null, null, new ArrayListSerializer($serializer_getInstance_128())];
  }
  var Companion_instance_96;
  function Companion_getInstance_96() {
    if (Companion_instance_96 == null)
      new Companion_96();
    return Companion_instance_96;
  }
  function $serializer_120() {
    $serializer_instance_119 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ReadinessReportView', this, 3);
    tmp0_serialDesc.gy('tenantSlug', false);
    tmp0_serialDesc.gy('checkedAtMs', false);
    tmp0_serialDesc.gy('items', false);
    this.u2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_120).v2s = function (encoder, value) {
    var tmp0_desc = this.u2s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_96().t2s_1;
    tmp1_output.hs(tmp0_desc, 0, value.w2s_1);
    tmp1_output.ds(tmp0_desc, 1, value.x2s_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.y2s_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_120).on = function (encoder, value) {
    return this.v2s(encoder, value instanceof ReadinessReportView ? value : THROW_CCE());
  };
  protoOf($serializer_120).pn = function (decoder) {
    var tmp0_desc = this.u2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_96().t2s_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return ReadinessReportView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_120).nn = function () {
    return this.u2s_1;
  };
  protoOf($serializer_120).vy = function () {
    var tmp0_cached = Companion_getInstance_96().t2s_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[2]];
  };
  var $serializer_instance_119;
  function $serializer_getInstance_119() {
    if ($serializer_instance_119 == null)
      new $serializer_120();
    return $serializer_instance_119;
  }
  function ReadinessReportView_init_$Init$(seen0, tenantSlug, checkedAtMs, items, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_119().u2s_1);
    }
    $this.w2s_1 = tenantSlug;
    $this.x2s_1 = checkedAtMs;
    $this.y2s_1 = items;
    return $this;
  }
  function ReadinessReportView_init_$Create$(seen0, tenantSlug, checkedAtMs, items, serializationConstructorMarker) {
    return ReadinessReportView_init_$Init$(seen0, tenantSlug, checkedAtMs, items, serializationConstructorMarker, objectCreate(protoOf(ReadinessReportView)));
  }
  function ReadinessReportView(tenantSlug, checkedAtMs, items) {
    Companion_getInstance_96();
    this.w2s_1 = tenantSlug;
    this.x2s_1 = checkedAtMs;
    this.y2s_1 = items;
  }
  protoOf(ReadinessReportView).toString = function () {
    return 'ReadinessReportView(tenantSlug=' + this.w2s_1 + ', checkedAtMs=' + this.x2s_1.toString() + ', items=' + toString(this.y2s_1) + ')';
  };
  protoOf(ReadinessReportView).hashCode = function () {
    var result = getStringHashCode(this.w2s_1);
    result = imul(result, 31) + this.x2s_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.y2s_1) | 0;
    return result;
  };
  protoOf(ReadinessReportView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReadinessReportView))
      return false;
    var tmp0_other_with_cast = other instanceof ReadinessReportView ? other : THROW_CCE();
    if (!(this.w2s_1 === tmp0_other_with_cast.w2s_1))
      return false;
    if (!this.x2s_1.equals(tmp0_other_with_cast.x2s_1))
      return false;
    if (!equals(this.y2s_1, tmp0_other_with_cast.y2s_1))
      return false;
    return true;
  };
  function Companion_97() {
  }
  var Companion_instance_97;
  function Companion_getInstance_97() {
    return Companion_instance_97;
  }
  function $serializer_121() {
    $serializer_instance_120 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CreateTrainingCopyRequest', this, 3);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('host', true);
    tmp0_serialDesc.gy('ownerEmail', true);
    this.z2s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_121).a2t = function (encoder, value) {
    var tmp0_desc = this.z2s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.b2t_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.c2t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.c2t_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.d2t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.d2t_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_121).on = function (encoder, value) {
    return this.a2t(encoder, value instanceof CreateTrainingCopyRequest ? value : THROW_CCE());
  };
  protoOf($serializer_121).pn = function (decoder) {
    var tmp0_desc = this.z2s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return CreateTrainingCopyRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_121).nn = function () {
    return this.z2s_1;
  };
  protoOf($serializer_121).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_120;
  function $serializer_getInstance_120() {
    if ($serializer_instance_120 == null)
      new $serializer_121();
    return $serializer_instance_120;
  }
  function CreateTrainingCopyRequest_init_$Init$(seen0, reason, host, ownerEmail, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_120().z2s_1);
    }
    $this.b2t_1 = reason;
    if (0 === (seen0 & 2))
      $this.c2t_1 = null;
    else
      $this.c2t_1 = host;
    if (0 === (seen0 & 4))
      $this.d2t_1 = null;
    else
      $this.d2t_1 = ownerEmail;
    return $this;
  }
  function CreateTrainingCopyRequest_init_$Create$(seen0, reason, host, ownerEmail, serializationConstructorMarker) {
    return CreateTrainingCopyRequest_init_$Init$(seen0, reason, host, ownerEmail, serializationConstructorMarker, objectCreate(protoOf(CreateTrainingCopyRequest)));
  }
  function CreateTrainingCopyRequest(reason, host, ownerEmail) {
    host = host === VOID ? null : host;
    ownerEmail = ownerEmail === VOID ? null : ownerEmail;
    this.b2t_1 = reason;
    this.c2t_1 = host;
    this.d2t_1 = ownerEmail;
  }
  protoOf(CreateTrainingCopyRequest).toString = function () {
    return 'CreateTrainingCopyRequest(reason=' + this.b2t_1 + ', host=' + this.c2t_1 + ', ownerEmail=' + this.d2t_1 + ')';
  };
  protoOf(CreateTrainingCopyRequest).hashCode = function () {
    var result = getStringHashCode(this.b2t_1);
    result = imul(result, 31) + (this.c2t_1 == null ? 0 : getStringHashCode(this.c2t_1)) | 0;
    result = imul(result, 31) + (this.d2t_1 == null ? 0 : getStringHashCode(this.d2t_1)) | 0;
    return result;
  };
  protoOf(CreateTrainingCopyRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CreateTrainingCopyRequest))
      return false;
    var tmp0_other_with_cast = other instanceof CreateTrainingCopyRequest ? other : THROW_CCE();
    if (!(this.b2t_1 === tmp0_other_with_cast.b2t_1))
      return false;
    if (!(this.c2t_1 == tmp0_other_with_cast.c2t_1))
      return false;
    if (!(this.d2t_1 == tmp0_other_with_cast.d2t_1))
      return false;
    return true;
  };
  function Companion_98() {
  }
  var Companion_instance_98;
  function Companion_getInstance_98() {
    return Companion_instance_98;
  }
  function $serializer_122() {
    $serializer_instance_121 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.DiscardedTrainingCopyView', this, 3);
    tmp0_serialDesc.gy('slug', false);
    tmp0_serialDesc.gy('databaseName', false);
    tmp0_serialDesc.gy('uploadsRemoved', false);
    this.e2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_122).f2t = function (encoder, value) {
    var tmp0_desc = this.e2t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.g2t_1);
    tmp1_output.hs(tmp0_desc, 1, value.h2t_1);
    tmp1_output.zr(tmp0_desc, 2, value.i2t_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_122).on = function (encoder, value) {
    return this.f2t(encoder, value instanceof DiscardedTrainingCopyView ? value : THROW_CCE());
  };
  protoOf($serializer_122).pn = function (decoder) {
    var tmp0_desc = this.e2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return DiscardedTrainingCopyView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_122).nn = function () {
    return this.e2t_1;
  };
  protoOf($serializer_122).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_121;
  function $serializer_getInstance_121() {
    if ($serializer_instance_121 == null)
      new $serializer_122();
    return $serializer_instance_121;
  }
  function DiscardedTrainingCopyView_init_$Init$(seen0, slug, databaseName, uploadsRemoved, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_121().e2t_1);
    }
    $this.g2t_1 = slug;
    $this.h2t_1 = databaseName;
    $this.i2t_1 = uploadsRemoved;
    return $this;
  }
  function DiscardedTrainingCopyView_init_$Create$(seen0, slug, databaseName, uploadsRemoved, serializationConstructorMarker) {
    return DiscardedTrainingCopyView_init_$Init$(seen0, slug, databaseName, uploadsRemoved, serializationConstructorMarker, objectCreate(protoOf(DiscardedTrainingCopyView)));
  }
  function DiscardedTrainingCopyView(slug, databaseName, uploadsRemoved) {
    this.g2t_1 = slug;
    this.h2t_1 = databaseName;
    this.i2t_1 = uploadsRemoved;
  }
  protoOf(DiscardedTrainingCopyView).toString = function () {
    return 'DiscardedTrainingCopyView(slug=' + this.g2t_1 + ', databaseName=' + this.h2t_1 + ', uploadsRemoved=' + this.i2t_1 + ')';
  };
  protoOf(DiscardedTrainingCopyView).hashCode = function () {
    var result = getStringHashCode(this.g2t_1);
    result = imul(result, 31) + getStringHashCode(this.h2t_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i2t_1) | 0;
    return result;
  };
  protoOf(DiscardedTrainingCopyView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardedTrainingCopyView))
      return false;
    var tmp0_other_with_cast = other instanceof DiscardedTrainingCopyView ? other : THROW_CCE();
    if (!(this.g2t_1 === tmp0_other_with_cast.g2t_1))
      return false;
    if (!(this.h2t_1 === tmp0_other_with_cast.h2t_1))
      return false;
    if (!(this.i2t_1 === tmp0_other_with_cast.i2t_1))
      return false;
    return true;
  };
  function Companion_99() {
  }
  var Companion_instance_99;
  function Companion_getInstance_99() {
    return Companion_instance_99;
  }
  function $serializer_123() {
    $serializer_instance_122 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.DiscardTrainingCopyRequest', this, 2);
    tmp0_serialDesc.gy('confirmation', false);
    tmp0_serialDesc.gy('reason', false);
    this.j2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_123).k2t = function (encoder, value) {
    var tmp0_desc = this.j2t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.l2t_1);
    tmp1_output.hs(tmp0_desc, 1, value.m2t_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_123).on = function (encoder, value) {
    return this.k2t(encoder, value instanceof DiscardTrainingCopyRequest ? value : THROW_CCE());
  };
  protoOf($serializer_123).pn = function (decoder) {
    var tmp0_desc = this.j2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return DiscardTrainingCopyRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_123).nn = function () {
    return this.j2t_1;
  };
  protoOf($serializer_123).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_122;
  function $serializer_getInstance_122() {
    if ($serializer_instance_122 == null)
      new $serializer_123();
    return $serializer_instance_122;
  }
  function DiscardTrainingCopyRequest_init_$Init$(seen0, confirmation, reason, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_122().j2t_1);
    }
    $this.l2t_1 = confirmation;
    $this.m2t_1 = reason;
    return $this;
  }
  function DiscardTrainingCopyRequest_init_$Create$(seen0, confirmation, reason, serializationConstructorMarker) {
    return DiscardTrainingCopyRequest_init_$Init$(seen0, confirmation, reason, serializationConstructorMarker, objectCreate(protoOf(DiscardTrainingCopyRequest)));
  }
  function DiscardTrainingCopyRequest(confirmation, reason) {
    this.l2t_1 = confirmation;
    this.m2t_1 = reason;
  }
  protoOf(DiscardTrainingCopyRequest).toString = function () {
    return 'DiscardTrainingCopyRequest(confirmation=' + this.l2t_1 + ', reason=' + this.m2t_1 + ')';
  };
  protoOf(DiscardTrainingCopyRequest).hashCode = function () {
    var result = getStringHashCode(this.l2t_1);
    result = imul(result, 31) + getStringHashCode(this.m2t_1) | 0;
    return result;
  };
  protoOf(DiscardTrainingCopyRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DiscardTrainingCopyRequest))
      return false;
    var tmp0_other_with_cast = other instanceof DiscardTrainingCopyRequest ? other : THROW_CCE();
    if (!(this.l2t_1 === tmp0_other_with_cast.l2t_1))
      return false;
    if (!(this.m2t_1 === tmp0_other_with_cast.m2t_1))
      return false;
    return true;
  };
  function ConfigAreaKeys() {
    ConfigAreaKeys_instance = this;
    this.r2r_1 = 'roles';
    this.s2r_1 = 'pipeline';
    this.t2r_1 = 'messaging';
    this.u2r_1 = 'automations';
    this.v2r_1 = 'settings';
    this.w2r_1 = 'website';
    this.x2r_1 = listOf(['roles', 'pipeline', 'messaging', 'automations', 'settings', 'website']);
    this.y2r_1 = minus(this.x2r_1, 'website');
  }
  var ConfigAreaKeys_instance;
  function ConfigAreaKeys_getInstance() {
    if (ConfigAreaKeys_instance == null)
      new ConfigAreaKeys();
    return ConfigAreaKeys_instance;
  }
  function Companion_100() {
  }
  var Companion_instance_100;
  function Companion_getInstance_100() {
    return Companion_instance_100;
  }
  function $serializer_124() {
    $serializer_instance_123 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ConfigSourceRefView', this, 2);
    tmp0_serialDesc.gy('tenantSlug', true);
    tmp0_serialDesc.gy('blueprintId', true);
    this.n2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_124).o2t = function (encoder, value) {
    var tmp0_desc = this.n2t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.p2t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, StringSerializer_getInstance(), value.p2t_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.q2t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.q2t_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_124).on = function (encoder, value) {
    return this.o2t(encoder, value instanceof ConfigSourceRefView ? value : THROW_CCE());
  };
  protoOf($serializer_124).pn = function (decoder) {
    var tmp0_desc = this.n2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return ConfigSourceRefView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_124).nn = function () {
    return this.n2t_1;
  };
  protoOf($serializer_124).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_123;
  function $serializer_getInstance_123() {
    if ($serializer_instance_123 == null)
      new $serializer_124();
    return $serializer_instance_123;
  }
  function ConfigSourceRefView_init_$Init$(seen0, tenantSlug, blueprintId, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_123().n2t_1);
    }
    if (0 === (seen0 & 1))
      $this.p2t_1 = null;
    else
      $this.p2t_1 = tenantSlug;
    if (0 === (seen0 & 2))
      $this.q2t_1 = null;
    else
      $this.q2t_1 = blueprintId;
    return $this;
  }
  function ConfigSourceRefView_init_$Create$(seen0, tenantSlug, blueprintId, serializationConstructorMarker) {
    return ConfigSourceRefView_init_$Init$(seen0, tenantSlug, blueprintId, serializationConstructorMarker, objectCreate(protoOf(ConfigSourceRefView)));
  }
  function ConfigSourceRefView(tenantSlug, blueprintId) {
    tenantSlug = tenantSlug === VOID ? null : tenantSlug;
    blueprintId = blueprintId === VOID ? null : blueprintId;
    this.p2t_1 = tenantSlug;
    this.q2t_1 = blueprintId;
  }
  protoOf(ConfigSourceRefView).toString = function () {
    return 'ConfigSourceRefView(tenantSlug=' + this.p2t_1 + ', blueprintId=' + this.q2t_1 + ')';
  };
  protoOf(ConfigSourceRefView).hashCode = function () {
    var result = this.p2t_1 == null ? 0 : getStringHashCode(this.p2t_1);
    result = imul(result, 31) + (this.q2t_1 == null ? 0 : getStringHashCode(this.q2t_1)) | 0;
    return result;
  };
  protoOf(ConfigSourceRefView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ConfigSourceRefView))
      return false;
    var tmp0_other_with_cast = other instanceof ConfigSourceRefView ? other : THROW_CCE();
    if (!(this.p2t_1 == tmp0_other_with_cast.p2t_1))
      return false;
    if (!(this.q2t_1 == tmp0_other_with_cast.q2t_1))
      return false;
    return true;
  };
  function Companion_101() {
    Companion_instance_101 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r2t_1 = [null, null, new ArrayListSerializer($serializer_getInstance_125()), new ArrayListSerializer($serializer_getInstance_125()), new ArrayListSerializer($serializer_getInstance_126())];
  }
  var Companion_instance_101;
  function Companion_getInstance_101() {
    if (Companion_instance_101 == null)
      new Companion_101();
    return Companion_instance_101;
  }
  function $serializer_125() {
    $serializer_instance_124 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TableDiffView', this, 5);
    tmp0_serialDesc.gy('table', false);
    tmp0_serialDesc.gy('area', false);
    tmp0_serialDesc.gy('onlyLeft', false);
    tmp0_serialDesc.gy('onlyRight', false);
    tmp0_serialDesc.gy('changed', false);
    this.s2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_125).t2t = function (encoder, value) {
    var tmp0_desc = this.s2t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_101().r2t_1;
    tmp1_output.hs(tmp0_desc, 0, value.u2t_1);
    tmp1_output.hs(tmp0_desc, 1, value.v2t_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.w2t_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.x2t_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.y2t_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_125).on = function (encoder, value) {
    return this.t2t(encoder, value instanceof TableDiffView ? value : THROW_CCE());
  };
  protoOf($serializer_125).pn = function (decoder) {
    var tmp0_desc = this.s2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    var tmp10_cached = Companion_getInstance_101().r2t_1;
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.fr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.fr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.fr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.fr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.fr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.fr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return TableDiffView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_125).nn = function () {
    return this.s2t_1;
  };
  protoOf($serializer_125).vy = function () {
    var tmp0_cached = Companion_getInstance_101().r2t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], tmp0_cached[3], tmp0_cached[4]];
  };
  var $serializer_instance_124;
  function $serializer_getInstance_124() {
    if ($serializer_instance_124 == null)
      new $serializer_125();
    return $serializer_instance_124;
  }
  function TableDiffView_init_$Init$(seen0, table, area, onlyLeft, onlyRight, changed, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_124().s2t_1);
    }
    $this.u2t_1 = table;
    $this.v2t_1 = area;
    $this.w2t_1 = onlyLeft;
    $this.x2t_1 = onlyRight;
    $this.y2t_1 = changed;
    return $this;
  }
  function TableDiffView_init_$Create$(seen0, table, area, onlyLeft, onlyRight, changed, serializationConstructorMarker) {
    return TableDiffView_init_$Init$(seen0, table, area, onlyLeft, onlyRight, changed, serializationConstructorMarker, objectCreate(protoOf(TableDiffView)));
  }
  function TableDiffView() {
  }
  protoOf(TableDiffView).toString = function () {
    return 'TableDiffView(table=' + this.u2t_1 + ', area=' + this.v2t_1 + ', onlyLeft=' + toString(this.w2t_1) + ', onlyRight=' + toString(this.x2t_1) + ', changed=' + toString(this.y2t_1) + ')';
  };
  protoOf(TableDiffView).hashCode = function () {
    var result = getStringHashCode(this.u2t_1);
    result = imul(result, 31) + getStringHashCode(this.v2t_1) | 0;
    result = imul(result, 31) + hashCode(this.w2t_1) | 0;
    result = imul(result, 31) + hashCode(this.x2t_1) | 0;
    result = imul(result, 31) + hashCode(this.y2t_1) | 0;
    return result;
  };
  protoOf(TableDiffView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TableDiffView))
      return false;
    var tmp0_other_with_cast = other instanceof TableDiffView ? other : THROW_CCE();
    if (!(this.u2t_1 === tmp0_other_with_cast.u2t_1))
      return false;
    if (!(this.v2t_1 === tmp0_other_with_cast.v2t_1))
      return false;
    if (!equals(this.w2t_1, tmp0_other_with_cast.w2t_1))
      return false;
    if (!equals(this.x2t_1, tmp0_other_with_cast.x2t_1))
      return false;
    if (!equals(this.y2t_1, tmp0_other_with_cast.y2t_1))
      return false;
    return true;
  };
  function $serializer_126() {
    $serializer_instance_125 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RowRefView', this, 2);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('label', false);
    this.z2t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_126).a2u = function (encoder, value) {
    var tmp0_desc = this.z2t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.b2u_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.c2u_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_126).on = function (encoder, value) {
    return this.a2u(encoder, value instanceof RowRefView ? value : THROW_CCE());
  };
  protoOf($serializer_126).pn = function (decoder) {
    var tmp0_desc = this.z2t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return RowRefView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_126).nn = function () {
    return this.z2t_1;
  };
  protoOf($serializer_126).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_125;
  function $serializer_getInstance_125() {
    if ($serializer_instance_125 == null)
      new $serializer_126();
    return $serializer_instance_125;
  }
  function RowRefView_init_$Init$(seen0, key, label, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_125().z2t_1);
    }
    $this.b2u_1 = key;
    $this.c2u_1 = label;
    return $this;
  }
  function RowRefView_init_$Create$(seen0, key, label, serializationConstructorMarker) {
    return RowRefView_init_$Init$(seen0, key, label, serializationConstructorMarker, objectCreate(protoOf(RowRefView)));
  }
  function RowRefView() {
  }
  protoOf(RowRefView).toString = function () {
    return 'RowRefView(key=' + this.b2u_1 + ', label=' + this.c2u_1 + ')';
  };
  protoOf(RowRefView).hashCode = function () {
    var result = getStringHashCode(this.b2u_1);
    result = imul(result, 31) + (this.c2u_1 == null ? 0 : getStringHashCode(this.c2u_1)) | 0;
    return result;
  };
  protoOf(RowRefView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RowRefView))
      return false;
    var tmp0_other_with_cast = other instanceof RowRefView ? other : THROW_CCE();
    if (!(this.b2u_1 === tmp0_other_with_cast.b2u_1))
      return false;
    if (!(this.c2u_1 == tmp0_other_with_cast.c2u_1))
      return false;
    return true;
  };
  function Companion_102() {
    Companion_instance_102 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d2u_1 = [null, null, new ArrayListSerializer($serializer_getInstance_127())];
  }
  var Companion_instance_102;
  function Companion_getInstance_102() {
    if (Companion_instance_102 == null)
      new Companion_102();
    return Companion_instance_102;
  }
  function $serializer_127() {
    $serializer_instance_126 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RowChangeView', this, 3);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('label', false);
    tmp0_serialDesc.gy('fields', false);
    this.e2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_127).f2u = function (encoder, value) {
    var tmp0_desc = this.e2u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_102().d2u_1;
    tmp1_output.hs(tmp0_desc, 0, value.g2u_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.h2u_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.i2u_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_127).on = function (encoder, value) {
    return this.f2u(encoder, value instanceof RowChangeView ? value : THROW_CCE());
  };
  protoOf($serializer_127).pn = function (decoder) {
    var tmp0_desc = this.e2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_102().d2u_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return RowChangeView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_127).nn = function () {
    return this.e2u_1;
  };
  protoOf($serializer_127).vy = function () {
    var tmp0_cached = Companion_getInstance_102().d2u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[2]];
  };
  var $serializer_instance_126;
  function $serializer_getInstance_126() {
    if ($serializer_instance_126 == null)
      new $serializer_127();
    return $serializer_instance_126;
  }
  function RowChangeView_init_$Init$(seen0, key, label, fields, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_126().e2u_1);
    }
    $this.g2u_1 = key;
    $this.h2u_1 = label;
    $this.i2u_1 = fields;
    return $this;
  }
  function RowChangeView_init_$Create$(seen0, key, label, fields, serializationConstructorMarker) {
    return RowChangeView_init_$Init$(seen0, key, label, fields, serializationConstructorMarker, objectCreate(protoOf(RowChangeView)));
  }
  function RowChangeView() {
  }
  protoOf(RowChangeView).toString = function () {
    return 'RowChangeView(key=' + this.g2u_1 + ', label=' + this.h2u_1 + ', fields=' + toString(this.i2u_1) + ')';
  };
  protoOf(RowChangeView).hashCode = function () {
    var result = getStringHashCode(this.g2u_1);
    result = imul(result, 31) + (this.h2u_1 == null ? 0 : getStringHashCode(this.h2u_1)) | 0;
    result = imul(result, 31) + hashCode(this.i2u_1) | 0;
    return result;
  };
  protoOf(RowChangeView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RowChangeView))
      return false;
    var tmp0_other_with_cast = other instanceof RowChangeView ? other : THROW_CCE();
    if (!(this.g2u_1 === tmp0_other_with_cast.g2u_1))
      return false;
    if (!(this.h2u_1 == tmp0_other_with_cast.h2u_1))
      return false;
    if (!equals(this.i2u_1, tmp0_other_with_cast.i2u_1))
      return false;
    return true;
  };
  function $serializer_128() {
    $serializer_instance_127 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.FieldChangeView', this, 3);
    tmp0_serialDesc.gy('column', false);
    tmp0_serialDesc.gy('left', false);
    tmp0_serialDesc.gy('right', false);
    this.j2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_128).k2u = function (encoder, value) {
    var tmp0_desc = this.j2u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.l2u_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.m2u_1);
    tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.n2u_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_128).on = function (encoder, value) {
    return this.k2u(encoder, value instanceof FieldChangeView ? value : THROW_CCE());
  };
  protoOf($serializer_128).pn = function (decoder) {
    var tmp0_desc = this.j2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return FieldChangeView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_128).nn = function () {
    return this.j2u_1;
  };
  protoOf($serializer_128).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_127;
  function $serializer_getInstance_127() {
    if ($serializer_instance_127 == null)
      new $serializer_128();
    return $serializer_instance_127;
  }
  function FieldChangeView_init_$Init$(seen0, column, left, right, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_127().j2u_1);
    }
    $this.l2u_1 = column;
    $this.m2u_1 = left;
    $this.n2u_1 = right;
    return $this;
  }
  function FieldChangeView_init_$Create$(seen0, column, left, right, serializationConstructorMarker) {
    return FieldChangeView_init_$Init$(seen0, column, left, right, serializationConstructorMarker, objectCreate(protoOf(FieldChangeView)));
  }
  function FieldChangeView() {
  }
  protoOf(FieldChangeView).toString = function () {
    return 'FieldChangeView(column=' + this.l2u_1 + ', left=' + this.m2u_1 + ', right=' + this.n2u_1 + ')';
  };
  protoOf(FieldChangeView).hashCode = function () {
    var result = getStringHashCode(this.l2u_1);
    result = imul(result, 31) + (this.m2u_1 == null ? 0 : getStringHashCode(this.m2u_1)) | 0;
    result = imul(result, 31) + (this.n2u_1 == null ? 0 : getStringHashCode(this.n2u_1)) | 0;
    return result;
  };
  protoOf(FieldChangeView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FieldChangeView))
      return false;
    var tmp0_other_with_cast = other instanceof FieldChangeView ? other : THROW_CCE();
    if (!(this.l2u_1 === tmp0_other_with_cast.l2u_1))
      return false;
    if (!(this.m2u_1 == tmp0_other_with_cast.m2u_1))
      return false;
    if (!(this.n2u_1 == tmp0_other_with_cast.n2u_1))
      return false;
    return true;
  };
  function $serializer_129() {
    $serializer_instance_128 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ReadinessItemView', this, 4);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('label', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('detail', false);
    this.o2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_129).p2u = function (encoder, value) {
    var tmp0_desc = this.o2u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.q2u_1);
    tmp1_output.hs(tmp0_desc, 1, value.r2u_1);
    tmp1_output.hs(tmp0_desc, 2, value.s2u_1);
    tmp1_output.hs(tmp0_desc, 3, value.t2u_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_129).on = function (encoder, value) {
    return this.p2u(encoder, value instanceof ReadinessItemView ? value : THROW_CCE());
  };
  protoOf($serializer_129).pn = function (decoder) {
    var tmp0_desc = this.o2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return ReadinessItemView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_129).nn = function () {
    return this.o2u_1;
  };
  protoOf($serializer_129).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_128;
  function $serializer_getInstance_128() {
    if ($serializer_instance_128 == null)
      new $serializer_129();
    return $serializer_instance_128;
  }
  function ReadinessItemView_init_$Init$(seen0, key, label, status, detail, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_128().o2u_1);
    }
    $this.q2u_1 = key;
    $this.r2u_1 = label;
    $this.s2u_1 = status;
    $this.t2u_1 = detail;
    return $this;
  }
  function ReadinessItemView_init_$Create$(seen0, key, label, status, detail, serializationConstructorMarker) {
    return ReadinessItemView_init_$Init$(seen0, key, label, status, detail, serializationConstructorMarker, objectCreate(protoOf(ReadinessItemView)));
  }
  function ReadinessItemView() {
  }
  protoOf(ReadinessItemView).toString = function () {
    return 'ReadinessItemView(key=' + this.q2u_1 + ', label=' + this.r2u_1 + ', status=' + this.s2u_1 + ', detail=' + this.t2u_1 + ')';
  };
  protoOf(ReadinessItemView).hashCode = function () {
    var result = getStringHashCode(this.q2u_1);
    result = imul(result, 31) + getStringHashCode(this.r2u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s2u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t2u_1) | 0;
    return result;
  };
  protoOf(ReadinessItemView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReadinessItemView))
      return false;
    var tmp0_other_with_cast = other instanceof ReadinessItemView ? other : THROW_CCE();
    if (!(this.q2u_1 === tmp0_other_with_cast.q2u_1))
      return false;
    if (!(this.r2u_1 === tmp0_other_with_cast.r2u_1))
      return false;
    if (!(this.s2u_1 === tmp0_other_with_cast.s2u_1))
      return false;
    if (!(this.t2u_1 === tmp0_other_with_cast.t2u_1))
      return false;
    return true;
  };
  function Companion_103() {
  }
  var Companion_instance_103;
  function Companion_getInstance_103() {
    return Companion_instance_103;
  }
  function $serializer_130() {
    $serializer_instance_129 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OwnerInvitationStatusView', this, 11);
    tmp0_serialDesc.gy('ownerEmail', false);
    tmp0_serialDesc.gy('ownerFirstSignInAtMs', false);
    tmp0_serialDesc.gy('ownerActive', false);
    tmp0_serialDesc.gy('legacySessionEvidence', false);
    tmp0_serialDesc.gy('invitationEligible', false);
    tmp0_serialDesc.gy('issuedAtMs', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    tmp0_serialDesc.gy('mode', false);
    tmp0_serialDesc.gy('deliveryOutcome', false);
    tmp0_serialDesc.gy('sentAtMs', false);
    tmp0_serialDesc.gy('linkUsed', false);
    this.u2u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_130).v2u = function (encoder, value) {
    var tmp0_desc = this.u2u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.w2u_1);
    tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.x2u_1);
    tmp1_output.zr(tmp0_desc, 2, value.y2u_1);
    tmp1_output.zr(tmp0_desc, 3, value.z2u_1);
    tmp1_output.zr(tmp0_desc, 4, value.a2v_1);
    tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.b2v_1);
    tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.c2v_1);
    tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.d2v_1);
    tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.e2v_1);
    tmp1_output.ls(tmp0_desc, 9, LongSerializer_getInstance(), value.f2v_1);
    tmp1_output.ls(tmp0_desc, 10, BooleanSerializer_getInstance(), value.g2v_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_130).on = function (encoder, value) {
    return this.v2u(encoder, value instanceof OwnerInvitationStatusView ? value : THROW_CCE());
  };
  protoOf($serializer_130).pn = function (decoder) {
    var tmp0_desc = this.u2u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.tq(tmp0_desc);
    if (tmp15_input.ir()) {
      tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.hr(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.hr(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.hr(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.hr(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.uq(tmp0_desc);
    return OwnerInvitationStatusView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_130).nn = function () {
    return this.u2u_1;
  };
  protoOf($serializer_130).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
  };
  var $serializer_instance_129;
  function $serializer_getInstance_129() {
    if ($serializer_instance_129 == null)
      new $serializer_130();
    return $serializer_instance_129;
  }
  function OwnerInvitationStatusView_init_$Init$(seen0, ownerEmail, ownerFirstSignInAtMs, ownerActive, legacySessionEvidence, invitationEligible, issuedAtMs, expiresAtMs, mode, deliveryOutcome, sentAtMs, linkUsed, serializationConstructorMarker, $this) {
    if (!(2047 === (2047 & seen0))) {
      throwMissingFieldException(seen0, 2047, $serializer_getInstance_129().u2u_1);
    }
    $this.w2u_1 = ownerEmail;
    $this.x2u_1 = ownerFirstSignInAtMs;
    $this.y2u_1 = ownerActive;
    $this.z2u_1 = legacySessionEvidence;
    $this.a2v_1 = invitationEligible;
    $this.b2v_1 = issuedAtMs;
    $this.c2v_1 = expiresAtMs;
    $this.d2v_1 = mode;
    $this.e2v_1 = deliveryOutcome;
    $this.f2v_1 = sentAtMs;
    $this.g2v_1 = linkUsed;
    return $this;
  }
  function OwnerInvitationStatusView_init_$Create$(seen0, ownerEmail, ownerFirstSignInAtMs, ownerActive, legacySessionEvidence, invitationEligible, issuedAtMs, expiresAtMs, mode, deliveryOutcome, sentAtMs, linkUsed, serializationConstructorMarker) {
    return OwnerInvitationStatusView_init_$Init$(seen0, ownerEmail, ownerFirstSignInAtMs, ownerActive, legacySessionEvidence, invitationEligible, issuedAtMs, expiresAtMs, mode, deliveryOutcome, sentAtMs, linkUsed, serializationConstructorMarker, objectCreate(protoOf(OwnerInvitationStatusView)));
  }
  function OwnerInvitationStatusView(ownerEmail, ownerFirstSignInAtMs, ownerActive, legacySessionEvidence, invitationEligible, issuedAtMs, expiresAtMs, mode, deliveryOutcome, sentAtMs, linkUsed) {
    this.w2u_1 = ownerEmail;
    this.x2u_1 = ownerFirstSignInAtMs;
    this.y2u_1 = ownerActive;
    this.z2u_1 = legacySessionEvidence;
    this.a2v_1 = invitationEligible;
    this.b2v_1 = issuedAtMs;
    this.c2v_1 = expiresAtMs;
    this.d2v_1 = mode;
    this.e2v_1 = deliveryOutcome;
    this.f2v_1 = sentAtMs;
    this.g2v_1 = linkUsed;
  }
  protoOf(OwnerInvitationStatusView).toString = function () {
    return 'OwnerInvitationStatusView(ownerEmail=' + this.w2u_1 + ', ownerFirstSignInAtMs=' + toString_0(this.x2u_1) + ', ownerActive=' + this.y2u_1 + ', legacySessionEvidence=' + this.z2u_1 + ', invitationEligible=' + this.a2v_1 + ', issuedAtMs=' + toString_0(this.b2v_1) + ', expiresAtMs=' + toString_0(this.c2v_1) + ', mode=' + this.d2v_1 + ', deliveryOutcome=' + this.e2v_1 + ', sentAtMs=' + toString_0(this.f2v_1) + ', linkUsed=' + this.g2v_1 + ')';
  };
  protoOf(OwnerInvitationStatusView).hashCode = function () {
    var result = getStringHashCode(this.w2u_1);
    result = imul(result, 31) + (this.x2u_1 == null ? 0 : this.x2u_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y2u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z2u_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a2v_1) | 0;
    result = imul(result, 31) + (this.b2v_1 == null ? 0 : this.b2v_1.hashCode()) | 0;
    result = imul(result, 31) + (this.c2v_1 == null ? 0 : this.c2v_1.hashCode()) | 0;
    result = imul(result, 31) + (this.d2v_1 == null ? 0 : getStringHashCode(this.d2v_1)) | 0;
    result = imul(result, 31) + (this.e2v_1 == null ? 0 : getStringHashCode(this.e2v_1)) | 0;
    result = imul(result, 31) + (this.f2v_1 == null ? 0 : this.f2v_1.hashCode()) | 0;
    result = imul(result, 31) + (this.g2v_1 == null ? 0 : getBooleanHashCode(this.g2v_1)) | 0;
    return result;
  };
  protoOf(OwnerInvitationStatusView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OwnerInvitationStatusView))
      return false;
    var tmp0_other_with_cast = other instanceof OwnerInvitationStatusView ? other : THROW_CCE();
    if (!(this.w2u_1 === tmp0_other_with_cast.w2u_1))
      return false;
    if (!equals(this.x2u_1, tmp0_other_with_cast.x2u_1))
      return false;
    if (!(this.y2u_1 === tmp0_other_with_cast.y2u_1))
      return false;
    if (!(this.z2u_1 === tmp0_other_with_cast.z2u_1))
      return false;
    if (!(this.a2v_1 === tmp0_other_with_cast.a2v_1))
      return false;
    if (!equals(this.b2v_1, tmp0_other_with_cast.b2v_1))
      return false;
    if (!equals(this.c2v_1, tmp0_other_with_cast.c2v_1))
      return false;
    if (!(this.d2v_1 == tmp0_other_with_cast.d2v_1))
      return false;
    if (!(this.e2v_1 == tmp0_other_with_cast.e2v_1))
      return false;
    if (!equals(this.f2v_1, tmp0_other_with_cast.f2v_1))
      return false;
    if (!(this.g2v_1 == tmp0_other_with_cast.g2v_1))
      return false;
    return true;
  };
  function Companion_104() {
  }
  var Companion_instance_104;
  function Companion_getInstance_104() {
    return Companion_instance_104;
  }
  function $serializer_131() {
    $serializer_instance_130 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OwnerInvitationDeliveryView', this, 2);
    tmp0_serialDesc.gy('delivered', false);
    tmp0_serialDesc.gy('sentAtMs', false);
    this.h2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_131).i2v = function (encoder, value) {
    var tmp0_desc = this.h2v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.zr(tmp0_desc, 0, value.j2v_1);
    tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.k2v_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_131).on = function (encoder, value) {
    return this.i2v(encoder, value instanceof OwnerInvitationDeliveryView ? value : THROW_CCE());
  };
  protoOf($serializer_131).pn = function (decoder) {
    var tmp0_desc = this.h2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.vq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return OwnerInvitationDeliveryView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_131).nn = function () {
    return this.h2v_1;
  };
  protoOf($serializer_131).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_130;
  function $serializer_getInstance_130() {
    if ($serializer_instance_130 == null)
      new $serializer_131();
    return $serializer_instance_130;
  }
  function OwnerInvitationDeliveryView_init_$Init$(seen0, delivered, sentAtMs, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_130().h2v_1);
    }
    $this.j2v_1 = delivered;
    $this.k2v_1 = sentAtMs;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.j2v_1 === !($this.k2v_1 == null))) {
      // Inline function 'com.ems.console.api.OwnerInvitationDeliveryView.<init>.<anonymous>' call
      var message = 'Supply a consistent owner invitation delivery acknowledgment.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return $this;
  }
  function OwnerInvitationDeliveryView_init_$Create$(seen0, delivered, sentAtMs, serializationConstructorMarker) {
    return OwnerInvitationDeliveryView_init_$Init$(seen0, delivered, sentAtMs, serializationConstructorMarker, objectCreate(protoOf(OwnerInvitationDeliveryView)));
  }
  function OwnerInvitationDeliveryView(delivered, sentAtMs) {
    this.j2v_1 = delivered;
    this.k2v_1 = sentAtMs;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.j2v_1 === !(this.k2v_1 == null))) {
      // Inline function 'com.ems.console.api.OwnerInvitationDeliveryView.<anonymous>' call
      var message = 'Supply a consistent owner invitation delivery acknowledgment.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(OwnerInvitationDeliveryView).toString = function () {
    return 'OwnerInvitationDeliveryView(delivered=' + this.j2v_1 + ', sentAtMs=' + toString_0(this.k2v_1) + ')';
  };
  protoOf(OwnerInvitationDeliveryView).hashCode = function () {
    var result = getBooleanHashCode(this.j2v_1);
    result = imul(result, 31) + (this.k2v_1 == null ? 0 : this.k2v_1.hashCode()) | 0;
    return result;
  };
  protoOf(OwnerInvitationDeliveryView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OwnerInvitationDeliveryView))
      return false;
    var tmp0_other_with_cast = other instanceof OwnerInvitationDeliveryView ? other : THROW_CCE();
    if (!(this.j2v_1 === tmp0_other_with_cast.j2v_1))
      return false;
    if (!equals(this.k2v_1, tmp0_other_with_cast.k2v_1))
      return false;
    return true;
  };
  function Companion_105() {
  }
  var Companion_instance_105;
  function Companion_getInstance_105() {
    return Companion_instance_105;
  }
  function $serializer_132() {
    $serializer_instance_131 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OwnerInvitationOneTimeView', this, 3);
    tmp0_serialDesc.gy('alreadyIssued', false);
    tmp0_serialDesc.gy('link', true);
    tmp0_serialDesc.gy('expiresAtMs', true);
    this.l2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_132).m2v = function (encoder, value) {
    var tmp0_desc = this.l2v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.zr(tmp0_desc, 0, value.n2v_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.o2v_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.o2v_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.p2v_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, LongSerializer_getInstance(), value.p2v_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_132).on = function (encoder, value) {
    return this.m2v(encoder, value instanceof OwnerInvitationOneTimeView ? value : THROW_CCE());
  };
  protoOf($serializer_132).pn = function (decoder) {
    var tmp0_desc = this.l2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.vq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return OwnerInvitationOneTimeView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_132).nn = function () {
    return this.l2v_1;
  };
  protoOf($serializer_132).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_131;
  function $serializer_getInstance_131() {
    if ($serializer_instance_131 == null)
      new $serializer_132();
    return $serializer_instance_131;
  }
  function OwnerInvitationOneTimeView_init_$Init$(seen0, alreadyIssued, link, expiresAtMs, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_131().l2v_1);
    }
    $this.n2v_1 = alreadyIssued;
    if (0 === (seen0 & 2))
      $this.o2v_1 = null;
    else
      $this.o2v_1 = link;
    if (0 === (seen0 & 4))
      $this.p2v_1 = null;
    else
      $this.p2v_1 = expiresAtMs;
    // Inline function 'kotlin.require' call
    var tmp;
    if ($this.n2v_1) {
      tmp = ($this.o2v_1 == null && $this.p2v_1 == null);
    } else {
      var tmp_0;
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = $this.o2v_1;
      // Inline function 'kotlin.contracts.contract' call
      if (!(this_0 == null || isBlank(this_0))) {
        tmp_0 = !($this.p2v_1 == null);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'com.ems.console.api.OwnerInvitationOneTimeView.<init>.<anonymous>' call
      var message = 'Supply a consistent one-time owner invitation result.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return $this;
  }
  function OwnerInvitationOneTimeView_init_$Create$(seen0, alreadyIssued, link, expiresAtMs, serializationConstructorMarker) {
    return OwnerInvitationOneTimeView_init_$Init$(seen0, alreadyIssued, link, expiresAtMs, serializationConstructorMarker, objectCreate(protoOf(OwnerInvitationOneTimeView)));
  }
  function OwnerInvitationOneTimeView(alreadyIssued, link, expiresAtMs) {
    link = link === VOID ? null : link;
    expiresAtMs = expiresAtMs === VOID ? null : expiresAtMs;
    this.n2v_1 = alreadyIssued;
    this.o2v_1 = link;
    this.p2v_1 = expiresAtMs;
    // Inline function 'kotlin.require' call
    var tmp;
    if (this.n2v_1) {
      tmp = (this.o2v_1 == null && this.p2v_1 == null);
    } else {
      var tmp_0;
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = this.o2v_1;
      // Inline function 'kotlin.contracts.contract' call
      if (!(this_0 == null || isBlank(this_0))) {
        tmp_0 = !(this.p2v_1 == null);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'com.ems.console.api.OwnerInvitationOneTimeView.<anonymous>' call
      var message = 'Supply a consistent one-time owner invitation result.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(OwnerInvitationOneTimeView).toString = function () {
    return 'OwnerInvitationOneTimeView(alreadyIssued=' + this.n2v_1 + ', payload=redacted)';
  };
  protoOf(OwnerInvitationOneTimeView).hashCode = function () {
    var result = getBooleanHashCode(this.n2v_1);
    result = imul(result, 31) + (this.o2v_1 == null ? 0 : getStringHashCode(this.o2v_1)) | 0;
    result = imul(result, 31) + (this.p2v_1 == null ? 0 : this.p2v_1.hashCode()) | 0;
    return result;
  };
  protoOf(OwnerInvitationOneTimeView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OwnerInvitationOneTimeView))
      return false;
    var tmp0_other_with_cast = other instanceof OwnerInvitationOneTimeView ? other : THROW_CCE();
    if (!(this.n2v_1 === tmp0_other_with_cast.n2v_1))
      return false;
    if (!(this.o2v_1 == tmp0_other_with_cast.o2v_1))
      return false;
    if (!equals(this.p2v_1, tmp0_other_with_cast.p2v_1))
      return false;
    return true;
  };
  function Companion_106() {
  }
  var Companion_instance_106;
  function Companion_getInstance_106() {
    return Companion_instance_106;
  }
  function $serializer_133() {
    $serializer_instance_132 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopySourceView', this, 8);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('slug', false);
    tmp0_serialDesc.gy('displayNameEn', false);
    tmp0_serialDesc.gy('displayNameAr', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('locale', false);
    tmp0_serialDesc.gy('timezone', false);
    tmp0_serialDesc.gy('languageDefaultsSupported', false);
    this.q2v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_133).r2v = function (encoder, value) {
    var tmp0_desc = this.q2v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.s2v_1);
    tmp1_output.hs(tmp0_desc, 1, value.t2v_1);
    tmp1_output.hs(tmp0_desc, 2, value.u2v_1);
    tmp1_output.hs(tmp0_desc, 3, value.v2v_1);
    tmp1_output.hs(tmp0_desc, 4, value.w2v_1);
    tmp1_output.hs(tmp0_desc, 5, value.x2v_1);
    tmp1_output.hs(tmp0_desc, 6, value.y2v_1);
    tmp1_output.zr(tmp0_desc, 7, value.z2v_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_133).on = function (encoder, value) {
    return this.r2v(encoder, value instanceof SetupCopySourceView ? value : THROW_CCE());
  };
  protoOf($serializer_133).pn = function (decoder) {
    var tmp0_desc = this.q2v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_input = decoder.tq(tmp0_desc);
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return SetupCopySourceView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_133).nn = function () {
    return this.q2v_1;
  };
  protoOf($serializer_133).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_132;
  function $serializer_getInstance_132() {
    if ($serializer_instance_132 == null)
      new $serializer_133();
    return $serializer_instance_132;
  }
  function SetupCopySourceView_init_$Init$(seen0, tenantId, slug, displayNameEn, displayNameAr, state, locale, timezone, languageDefaultsSupported, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_132().q2v_1);
    }
    $this.s2v_1 = tenantId;
    $this.t2v_1 = slug;
    $this.u2v_1 = displayNameEn;
    $this.v2v_1 = displayNameAr;
    $this.w2v_1 = state;
    $this.x2v_1 = locale;
    $this.y2v_1 = timezone;
    $this.z2v_1 = languageDefaultsSupported;
    return $this;
  }
  function SetupCopySourceView_init_$Create$(seen0, tenantId, slug, displayNameEn, displayNameAr, state, locale, timezone, languageDefaultsSupported, serializationConstructorMarker) {
    return SetupCopySourceView_init_$Init$(seen0, tenantId, slug, displayNameEn, displayNameAr, state, locale, timezone, languageDefaultsSupported, serializationConstructorMarker, objectCreate(protoOf(SetupCopySourceView)));
  }
  function SetupCopySourceView(tenantId, slug, displayNameEn, displayNameAr, state, locale, timezone, languageDefaultsSupported) {
    this.s2v_1 = tenantId;
    this.t2v_1 = slug;
    this.u2v_1 = displayNameEn;
    this.v2v_1 = displayNameAr;
    this.w2v_1 = state;
    this.x2v_1 = locale;
    this.y2v_1 = timezone;
    this.z2v_1 = languageDefaultsSupported;
  }
  protoOf(SetupCopySourceView).toString = function () {
    return 'SetupCopySourceView(tenantId=' + this.s2v_1 + ', slug=' + this.t2v_1 + ', displayNameEn=' + this.u2v_1 + ', displayNameAr=' + this.v2v_1 + ', state=' + this.w2v_1 + ', locale=' + this.x2v_1 + ', timezone=' + this.y2v_1 + ', languageDefaultsSupported=' + this.z2v_1 + ')';
  };
  protoOf(SetupCopySourceView).hashCode = function () {
    var result = getStringHashCode(this.s2v_1);
    result = imul(result, 31) + getStringHashCode(this.t2v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u2v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v2v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w2v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x2v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2v_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z2v_1) | 0;
    return result;
  };
  protoOf(SetupCopySourceView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopySourceView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopySourceView ? other : THROW_CCE();
    if (!(this.s2v_1 === tmp0_other_with_cast.s2v_1))
      return false;
    if (!(this.t2v_1 === tmp0_other_with_cast.t2v_1))
      return false;
    if (!(this.u2v_1 === tmp0_other_with_cast.u2v_1))
      return false;
    if (!(this.v2v_1 === tmp0_other_with_cast.v2v_1))
      return false;
    if (!(this.w2v_1 === tmp0_other_with_cast.w2v_1))
      return false;
    if (!(this.x2v_1 === tmp0_other_with_cast.x2v_1))
      return false;
    if (!(this.y2v_1 === tmp0_other_with_cast.y2v_1))
      return false;
    if (!(this.z2v_1 === tmp0_other_with_cast.z2v_1))
      return false;
    return true;
  };
  function Companion_107() {
    Companion_instance_107 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a2w_1 = [new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_138()), null];
  }
  var Companion_instance_107;
  function Companion_getInstance_107() {
    if (Companion_instance_107 == null)
      new Companion_107();
    return Companion_instance_107;
  }
  function $serializer_134() {
    $serializer_instance_133 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupFormOptionsView', this, 4);
    tmp0_serialDesc.gy('locales', false);
    tmp0_serialDesc.gy('timezones', false);
    tmp0_serialDesc.gy('appearancePalettes', true);
    tmp0_serialDesc.gy('appearancePaletteCatalogVersion', true);
    this.b2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_134).c2w = function (encoder, value) {
    var tmp0_desc = this.b2w_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_107().a2w_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.d2w_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.e2w_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !equals(value.f2w_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.f2w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.g2w_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 3, value.g2w_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_134).on = function (encoder, value) {
    return this.c2w(encoder, value instanceof SetupFormOptionsView ? value : THROW_CCE());
  };
  protoOf($serializer_134).pn = function (decoder) {
    var tmp0_desc = this.b2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_107().a2w_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.yq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.yq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return SetupFormOptionsView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_134).nn = function () {
    return this.b2w_1;
  };
  protoOf($serializer_134).vy = function () {
    var tmp0_cached = Companion_getInstance_107().a2w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], IntSerializer_getInstance()];
  };
  var $serializer_instance_133;
  function $serializer_getInstance_133() {
    if ($serializer_instance_133 == null)
      new $serializer_134();
    return $serializer_instance_133;
  }
  function SetupFormOptionsView_init_$Init$(seen0, locales, timezones, appearancePalettes, appearancePaletteCatalogVersion, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_133().b2w_1);
    }
    $this.d2w_1 = locales;
    $this.e2w_1 = timezones;
    if (0 === (seen0 & 4))
      $this.f2w_1 = emptyList();
    else
      $this.f2w_1 = appearancePalettes;
    if (0 === (seen0 & 8))
      $this.g2w_1 = 0;
    else
      $this.g2w_1 = appearancePaletteCatalogVersion;
    return $this;
  }
  function SetupFormOptionsView_init_$Create$(seen0, locales, timezones, appearancePalettes, appearancePaletteCatalogVersion, serializationConstructorMarker) {
    return SetupFormOptionsView_init_$Init$(seen0, locales, timezones, appearancePalettes, appearancePaletteCatalogVersion, serializationConstructorMarker, objectCreate(protoOf(SetupFormOptionsView)));
  }
  function SetupFormOptionsView(locales, timezones, appearancePalettes, appearancePaletteCatalogVersion) {
    Companion_getInstance_107();
    appearancePalettes = appearancePalettes === VOID ? emptyList() : appearancePalettes;
    appearancePaletteCatalogVersion = appearancePaletteCatalogVersion === VOID ? 0 : appearancePaletteCatalogVersion;
    this.d2w_1 = locales;
    this.e2w_1 = timezones;
    this.f2w_1 = appearancePalettes;
    this.g2w_1 = appearancePaletteCatalogVersion;
  }
  protoOf(SetupFormOptionsView).toString = function () {
    return 'SetupFormOptionsView(locales=' + toString(this.d2w_1) + ', timezones=' + toString(this.e2w_1) + ', appearancePalettes=' + toString(this.f2w_1) + ', appearancePaletteCatalogVersion=' + this.g2w_1 + ')';
  };
  protoOf(SetupFormOptionsView).hashCode = function () {
    var result = hashCode(this.d2w_1);
    result = imul(result, 31) + hashCode(this.e2w_1) | 0;
    result = imul(result, 31) + hashCode(this.f2w_1) | 0;
    result = imul(result, 31) + this.g2w_1 | 0;
    return result;
  };
  protoOf(SetupFormOptionsView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupFormOptionsView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupFormOptionsView ? other : THROW_CCE();
    if (!equals(this.d2w_1, tmp0_other_with_cast.d2w_1))
      return false;
    if (!equals(this.e2w_1, tmp0_other_with_cast.e2w_1))
      return false;
    if (!equals(this.f2w_1, tmp0_other_with_cast.f2w_1))
      return false;
    if (!(this.g2w_1 === tmp0_other_with_cast.g2w_1))
      return false;
    return true;
  };
  function Companion_108() {
    Companion_instance_108 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i2w_1 = [Companion_getInstance_116().w19(), null, null, new ArrayListSerializer($serializer_getInstance_35())];
  }
  var Companion_instance_108;
  function Companion_getInstance_108() {
    if (Companion_instance_108 == null)
      new Companion_108();
    return Companion_instance_108;
  }
  function $serializer_135() {
    $serializer_instance_134 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantAddressAvailabilityView', this, 4);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('available', false);
    tmp0_serialDesc.gy('suggestedHost', true);
    tmp0_serialDesc.gy('fieldErrors', true);
    this.j2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_135).k2w = function (encoder, value) {
    var tmp0_desc = this.j2w_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_108().i2w_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.l2w_1);
    tmp1_output.zr(tmp0_desc, 1, value.m2w_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.n2w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.n2w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !equals(value.o2w_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.o2w_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_135).on = function (encoder, value) {
    return this.k2w(encoder, value instanceof TenantAddressAvailabilityView ? value : THROW_CCE());
  };
  protoOf($serializer_135).pn = function (decoder) {
    var tmp0_desc = this.j2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_108().i2w_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return TenantAddressAvailabilityView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_135).nn = function () {
    return this.j2w_1;
  };
  protoOf($serializer_135).vy = function () {
    var tmp0_cached = Companion_getInstance_108().i2w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[3]];
  };
  var $serializer_instance_134;
  function $serializer_getInstance_134() {
    if ($serializer_instance_134 == null)
      new $serializer_135();
    return $serializer_instance_134;
  }
  function TenantAddressAvailabilityView_init_$Init$(seen0, state, available, suggestedHost, fieldErrors, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_134().j2w_1);
    }
    $this.l2w_1 = state;
    $this.m2w_1 = available;
    if (0 === (seen0 & 4))
      $this.n2w_1 = null;
    else
      $this.n2w_1 = suggestedHost;
    if (0 === (seen0 & 8))
      $this.o2w_1 = emptyList();
    else
      $this.o2w_1 = fieldErrors;
    return $this;
  }
  function TenantAddressAvailabilityView_init_$Create$(seen0, state, available, suggestedHost, fieldErrors, serializationConstructorMarker) {
    return TenantAddressAvailabilityView_init_$Init$(seen0, state, available, suggestedHost, fieldErrors, serializationConstructorMarker, objectCreate(protoOf(TenantAddressAvailabilityView)));
  }
  function TenantAddressAvailabilityView(state, available, suggestedHost, fieldErrors) {
    Companion_getInstance_108();
    suggestedHost = suggestedHost === VOID ? null : suggestedHost;
    fieldErrors = fieldErrors === VOID ? emptyList() : fieldErrors;
    this.l2w_1 = state;
    this.m2w_1 = available;
    this.n2w_1 = suggestedHost;
    this.o2w_1 = fieldErrors;
  }
  protoOf(TenantAddressAvailabilityView).toString = function () {
    return 'TenantAddressAvailabilityView(state=' + this.l2w_1.toString() + ', available=' + this.m2w_1 + ', suggestedHost=' + this.n2w_1 + ', fieldErrors=' + toString(this.o2w_1) + ')';
  };
  protoOf(TenantAddressAvailabilityView).hashCode = function () {
    var result = this.l2w_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.m2w_1) | 0;
    result = imul(result, 31) + (this.n2w_1 == null ? 0 : getStringHashCode(this.n2w_1)) | 0;
    result = imul(result, 31) + hashCode(this.o2w_1) | 0;
    return result;
  };
  protoOf(TenantAddressAvailabilityView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantAddressAvailabilityView))
      return false;
    var tmp0_other_with_cast = other instanceof TenantAddressAvailabilityView ? other : THROW_CCE();
    if (!this.l2w_1.equals(tmp0_other_with_cast.l2w_1))
      return false;
    if (!(this.m2w_1 === tmp0_other_with_cast.m2w_1))
      return false;
    if (!(this.n2w_1 == tmp0_other_with_cast.n2w_1))
      return false;
    if (!equals(this.o2w_1, tmp0_other_with_cast.o2w_1))
      return false;
    return true;
  };
  function Companion_109() {
    Companion_instance_109 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r2w_1 = [null, null, null, Companion_getInstance_115().w19(), null, Companion_getInstance_110().w19(), null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_140())];
  }
  var Companion_instance_109;
  function Companion_getInstance_109() {
    if (Companion_instance_109 == null)
      new Companion_109();
    return Companion_instance_109;
  }
  function $serializer_136() {
    $serializer_instance_135 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupDraftView', this, 12);
    tmp0_serialDesc.gy('draftId', false);
    tmp0_serialDesc.gy('ownerOperatorId', false);
    tmp0_serialDesc.gy('draftRevision', false);
    tmp0_serialDesc.gy('startMode', false);
    tmp0_serialDesc.gy('answers', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('expiresAtMs', true);
    tmp0_serialDesc.gy('createdAtMs', false);
    tmp0_serialDesc.gy('updatedAtMs', false);
    tmp0_serialDesc.gy('addressAvailability', true);
    tmp0_serialDesc.gy('acceptedAttemptId', true);
    tmp0_serialDesc.gy('removedByPlan', true);
    this.s2w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_136).t2w = function (encoder, value) {
    var tmp0_desc = this.s2w_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_109().r2w_1;
    tmp1_output.hs(tmp0_desc, 0, value.u2w_1);
    tmp1_output.hs(tmp0_desc, 1, value.v2w_1);
    tmp1_output.ds(tmp0_desc, 2, value.w2w_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.x2w_1);
    tmp1_output.js(tmp0_desc, 4, $serializer_getInstance_139(), value.y2w_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.z2w_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.a2x_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.a2x_1);
    }
    tmp1_output.ds(tmp0_desc, 7, value.b2x_1);
    tmp1_output.ds(tmp0_desc, 8, value.c2x_1);
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.d2x_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, $serializer_getInstance_134(), value.d2x_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.e2x_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.e2x_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !equals(value.f2x_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 11, tmp2_cached[11], value.f2x_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_136).on = function (encoder, value) {
    return this.t2w(encoder, value instanceof SetupDraftView ? value : THROW_CCE());
  };
  protoOf($serializer_136).pn = function (decoder) {
    var tmp0_desc = this.s2w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = new Long(0, 0);
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_input = decoder.tq(tmp0_desc);
    var tmp17_cached = Companion_getInstance_109().r2w_1;
    if (tmp16_input.ir()) {
      tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.fr(tmp0_desc, 3, tmp17_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.fr(tmp0_desc, 4, $serializer_getInstance_139(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.fr(tmp0_desc, 5, tmp17_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.hr(tmp0_desc, 9, $serializer_getInstance_134(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.fr(tmp0_desc, 11, tmp17_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.fr(tmp0_desc, 3, tmp17_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.fr(tmp0_desc, 4, $serializer_getInstance_139(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.fr(tmp0_desc, 5, tmp17_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.hr(tmp0_desc, 9, $serializer_getInstance_134(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.fr(tmp0_desc, 11, tmp17_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.uq(tmp0_desc);
    return SetupDraftView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  protoOf($serializer_136).nn = function () {
    return this.s2w_1;
  };
  protoOf($serializer_136).vy = function () {
    var tmp0_cached = Companion_getInstance_109().r2w_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[3], $serializer_getInstance_139(), tmp0_cached[5], get_nullable(LongSerializer_getInstance()), LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable($serializer_getInstance_134()), get_nullable(StringSerializer_getInstance()), tmp0_cached[11]];
  };
  var $serializer_instance_135;
  function $serializer_getInstance_135() {
    if ($serializer_instance_135 == null)
      new $serializer_136();
    return $serializer_instance_135;
  }
  function SetupDraftView_init_$Init$(seen0, draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan, serializationConstructorMarker, $this) {
    if (!(447 === (447 & seen0))) {
      throwMissingFieldException(seen0, 447, $serializer_getInstance_135().s2w_1);
    }
    $this.u2w_1 = draftId;
    $this.v2w_1 = ownerOperatorId;
    $this.w2w_1 = draftRevision;
    $this.x2w_1 = startMode;
    $this.y2w_1 = answers;
    $this.z2w_1 = state;
    if (0 === (seen0 & 64))
      $this.a2x_1 = null;
    else
      $this.a2x_1 = expiresAtMs;
    $this.b2x_1 = createdAtMs;
    $this.c2x_1 = updatedAtMs;
    if (0 === (seen0 & 512))
      $this.d2x_1 = null;
    else
      $this.d2x_1 = addressAvailability;
    if (0 === (seen0 & 1024))
      $this.e2x_1 = null;
    else
      $this.e2x_1 = acceptedAttemptId;
    if (0 === (seen0 & 2048))
      $this.f2x_1 = emptyList();
    else
      $this.f2x_1 = removedByPlan;
    return $this;
  }
  function SetupDraftView_init_$Create$(seen0, draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan, serializationConstructorMarker) {
    return SetupDraftView_init_$Init$(seen0, draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan, serializationConstructorMarker, objectCreate(protoOf(SetupDraftView)));
  }
  function SetupDraftView(draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan) {
    Companion_getInstance_109();
    expiresAtMs = expiresAtMs === VOID ? null : expiresAtMs;
    addressAvailability = addressAvailability === VOID ? null : addressAvailability;
    acceptedAttemptId = acceptedAttemptId === VOID ? null : acceptedAttemptId;
    removedByPlan = removedByPlan === VOID ? emptyList() : removedByPlan;
    this.u2w_1 = draftId;
    this.v2w_1 = ownerOperatorId;
    this.w2w_1 = draftRevision;
    this.x2w_1 = startMode;
    this.y2w_1 = answers;
    this.z2w_1 = state;
    this.a2x_1 = expiresAtMs;
    this.b2x_1 = createdAtMs;
    this.c2x_1 = updatedAtMs;
    this.d2x_1 = addressAvailability;
    this.e2x_1 = acceptedAttemptId;
    this.f2x_1 = removedByPlan;
  }
  protoOf(SetupDraftView).g2x = function (draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan) {
    return new SetupDraftView(draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan);
  };
  protoOf(SetupDraftView).h2x = function (draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan, $super) {
    draftId = draftId === VOID ? this.u2w_1 : draftId;
    ownerOperatorId = ownerOperatorId === VOID ? this.v2w_1 : ownerOperatorId;
    draftRevision = draftRevision === VOID ? this.w2w_1 : draftRevision;
    startMode = startMode === VOID ? this.x2w_1 : startMode;
    answers = answers === VOID ? this.y2w_1 : answers;
    state = state === VOID ? this.z2w_1 : state;
    expiresAtMs = expiresAtMs === VOID ? this.a2x_1 : expiresAtMs;
    createdAtMs = createdAtMs === VOID ? this.b2x_1 : createdAtMs;
    updatedAtMs = updatedAtMs === VOID ? this.c2x_1 : updatedAtMs;
    addressAvailability = addressAvailability === VOID ? this.d2x_1 : addressAvailability;
    acceptedAttemptId = acceptedAttemptId === VOID ? this.e2x_1 : acceptedAttemptId;
    removedByPlan = removedByPlan === VOID ? this.f2x_1 : removedByPlan;
    return $super === VOID ? this.g2x(draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan) : $super.g2x.call(this, draftId, ownerOperatorId, draftRevision, startMode, answers, state, expiresAtMs, createdAtMs, updatedAtMs, addressAvailability, acceptedAttemptId, removedByPlan);
  };
  protoOf(SetupDraftView).toString = function () {
    return 'SetupDraftView(draftId=' + this.u2w_1 + ', ownerOperatorId=' + this.v2w_1 + ', draftRevision=' + this.w2w_1.toString() + ', startMode=' + this.x2w_1.toString() + ', answers=' + this.y2w_1.toString() + ', state=' + this.z2w_1.toString() + ', expiresAtMs=' + toString_0(this.a2x_1) + ', createdAtMs=' + this.b2x_1.toString() + ', updatedAtMs=' + this.c2x_1.toString() + ', addressAvailability=' + toString_0(this.d2x_1) + ', acceptedAttemptId=' + this.e2x_1 + ', removedByPlan=' + toString(this.f2x_1) + ')';
  };
  protoOf(SetupDraftView).hashCode = function () {
    var result = getStringHashCode(this.u2w_1);
    result = imul(result, 31) + getStringHashCode(this.v2w_1) | 0;
    result = imul(result, 31) + this.w2w_1.hashCode() | 0;
    result = imul(result, 31) + this.x2w_1.hashCode() | 0;
    result = imul(result, 31) + this.y2w_1.hashCode() | 0;
    result = imul(result, 31) + this.z2w_1.hashCode() | 0;
    result = imul(result, 31) + (this.a2x_1 == null ? 0 : this.a2x_1.hashCode()) | 0;
    result = imul(result, 31) + this.b2x_1.hashCode() | 0;
    result = imul(result, 31) + this.c2x_1.hashCode() | 0;
    result = imul(result, 31) + (this.d2x_1 == null ? 0 : this.d2x_1.hashCode()) | 0;
    result = imul(result, 31) + (this.e2x_1 == null ? 0 : getStringHashCode(this.e2x_1)) | 0;
    result = imul(result, 31) + hashCode(this.f2x_1) | 0;
    return result;
  };
  protoOf(SetupDraftView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupDraftView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupDraftView ? other : THROW_CCE();
    if (!(this.u2w_1 === tmp0_other_with_cast.u2w_1))
      return false;
    if (!(this.v2w_1 === tmp0_other_with_cast.v2w_1))
      return false;
    if (!this.w2w_1.equals(tmp0_other_with_cast.w2w_1))
      return false;
    if (!this.x2w_1.equals(tmp0_other_with_cast.x2w_1))
      return false;
    if (!this.y2w_1.equals(tmp0_other_with_cast.y2w_1))
      return false;
    if (!this.z2w_1.equals(tmp0_other_with_cast.z2w_1))
      return false;
    if (!equals(this.a2x_1, tmp0_other_with_cast.a2x_1))
      return false;
    if (!this.b2x_1.equals(tmp0_other_with_cast.b2x_1))
      return false;
    if (!this.c2x_1.equals(tmp0_other_with_cast.c2x_1))
      return false;
    if (!equals(this.d2x_1, tmp0_other_with_cast.d2x_1))
      return false;
    if (!(this.e2x_1 == tmp0_other_with_cast.e2x_1))
      return false;
    if (!equals(this.f2x_1, tmp0_other_with_cast.f2x_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_1($this) {
    return $this.q2w_1.w();
  }
  function SetupDraftState$Companion$_anonymous__39wqf6() {
    return createSimpleEnumSerializer('com.ems.console.api.SetupDraftState', values_1());
  }
  var SetupDraftState_EDITING_instance;
  var SetupDraftState_ACCEPTED_instance;
  var SetupDraftState_EXPIRED_instance;
  var SetupDraftState_ABANDONED_instance;
  function values_1() {
    return [SetupDraftState_EDITING_getInstance(), SetupDraftState_ACCEPTED_getInstance(), SetupDraftState_EXPIRED_getInstance(), SetupDraftState_ABANDONED_getInstance()];
  }
  function Companion_110() {
    Companion_instance_110 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q2w_1 = lazy(tmp_0, SetupDraftState$Companion$_anonymous__39wqf6);
  }
  protoOf(Companion_110).w19 = function () {
    return _get_$cachedSerializer__te6jhj_1(this);
  };
  protoOf(Companion_110).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_110;
  function Companion_getInstance_110() {
    SetupDraftState_initEntries();
    if (Companion_instance_110 == null)
      new Companion_110();
    return Companion_instance_110;
  }
  var SetupDraftState_entriesInitialized;
  function SetupDraftState_initEntries() {
    if (SetupDraftState_entriesInitialized)
      return Unit_instance;
    SetupDraftState_entriesInitialized = true;
    SetupDraftState_EDITING_instance = new SetupDraftState('EDITING', 0);
    SetupDraftState_ACCEPTED_instance = new SetupDraftState('ACCEPTED', 1);
    SetupDraftState_EXPIRED_instance = new SetupDraftState('EXPIRED', 2);
    SetupDraftState_ABANDONED_instance = new SetupDraftState('ABANDONED', 3);
    Companion_getInstance_110();
  }
  function SetupDraftState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_111() {
    Companion_instance_111 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i2x_1 = [Companion_getInstance_115().w19()];
  }
  var Companion_instance_111;
  function Companion_getInstance_111() {
    if (Companion_instance_111 == null)
      new Companion_111();
    return Companion_instance_111;
  }
  function $serializer_137() {
    $serializer_instance_136 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.CreateSetupDraftRequest', this, 1);
    tmp0_serialDesc.gy('startMode', true);
    this.j2x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_137).k2x = function (encoder, value) {
    var tmp0_desc = this.j2x_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_111().i2x_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !value.l2x_1.equals(SetupStartMode_SCRATCH_getInstance())) {
      tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.l2x_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_137).on = function (encoder, value) {
    return this.k2x(encoder, value instanceof CreateSetupDraftRequest ? value : THROW_CCE());
  };
  protoOf($serializer_137).pn = function (decoder) {
    var tmp0_desc = this.j2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    var tmp6_cached = Companion_getInstance_111().i2x_1;
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.fr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.fr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return CreateSetupDraftRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_137).nn = function () {
    return this.j2x_1;
  };
  protoOf($serializer_137).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_111().i2x_1[0]];
  };
  var $serializer_instance_136;
  function $serializer_getInstance_136() {
    if ($serializer_instance_136 == null)
      new $serializer_137();
    return $serializer_instance_136;
  }
  function CreateSetupDraftRequest_init_$Init$(seen0, startMode, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_136().j2x_1);
    }
    if (0 === (seen0 & 1))
      $this.l2x_1 = SetupStartMode_SCRATCH_getInstance();
    else
      $this.l2x_1 = startMode;
    return $this;
  }
  function CreateSetupDraftRequest_init_$Create$(seen0, startMode, serializationConstructorMarker) {
    return CreateSetupDraftRequest_init_$Init$(seen0, startMode, serializationConstructorMarker, objectCreate(protoOf(CreateSetupDraftRequest)));
  }
  function CreateSetupDraftRequest(startMode) {
    Companion_getInstance_111();
    startMode = startMode === VOID ? SetupStartMode_SCRATCH_getInstance() : startMode;
    this.l2x_1 = startMode;
  }
  protoOf(CreateSetupDraftRequest).toString = function () {
    return 'CreateSetupDraftRequest(startMode=' + this.l2x_1.toString() + ')';
  };
  protoOf(CreateSetupDraftRequest).hashCode = function () {
    return this.l2x_1.hashCode();
  };
  protoOf(CreateSetupDraftRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CreateSetupDraftRequest))
      return false;
    var tmp0_other_with_cast = other instanceof CreateSetupDraftRequest ? other : THROW_CCE();
    if (!this.l2x_1.equals(tmp0_other_with_cast.l2x_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_2($this) {
    return $this.m2x_1.w();
  }
  function SetupDraftStep$Companion$_anonymous__l5v9fj() {
    return createSimpleEnumSerializer('com.ems.console.api.SetupDraftStep', values_2());
  }
  var SetupDraftStep_START_instance;
  var SetupDraftStep_DETAILS_instance;
  var SetupDraftStep_PLAN_instance;
  var SetupDraftStep_APPEARANCE_instance;
  function values_2() {
    return [SetupDraftStep_START_getInstance(), SetupDraftStep_DETAILS_getInstance(), SetupDraftStep_PLAN_getInstance(), SetupDraftStep_APPEARANCE_getInstance()];
  }
  function Companion_112() {
    Companion_instance_112 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.m2x_1 = lazy(tmp_0, SetupDraftStep$Companion$_anonymous__l5v9fj);
  }
  protoOf(Companion_112).w19 = function () {
    return _get_$cachedSerializer__te6jhj_2(this);
  };
  protoOf(Companion_112).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_112;
  function Companion_getInstance_112() {
    SetupDraftStep_initEntries();
    if (Companion_instance_112 == null)
      new Companion_112();
    return Companion_instance_112;
  }
  var SetupDraftStep_entriesInitialized;
  function SetupDraftStep_initEntries() {
    if (SetupDraftStep_entriesInitialized)
      return Unit_instance;
    SetupDraftStep_entriesInitialized = true;
    SetupDraftStep_START_instance = new SetupDraftStep('START', 0);
    SetupDraftStep_DETAILS_instance = new SetupDraftStep('DETAILS', 1);
    SetupDraftStep_PLAN_instance = new SetupDraftStep('PLAN', 2);
    SetupDraftStep_APPEARANCE_instance = new SetupDraftStep('APPEARANCE', 3);
    Companion_getInstance_112();
  }
  function SetupDraftStep(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_113() {
  }
  var Companion_instance_113;
  function Companion_getInstance_113() {
    return Companion_instance_113;
  }
  function $serializer_138() {
    $serializer_instance_137 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SaveSetupDraftRequest', this, 3);
    tmp0_serialDesc.gy('expectedRevision', false);
    tmp0_serialDesc.gy('answers', false);
    tmp0_serialDesc.gy('completeStep', true);
    this.n2x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_138).o2x = function (encoder, value) {
    var tmp0_desc = this.n2x_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.p2x_1);
    tmp1_output.js(tmp0_desc, 1, $serializer_getInstance_139(), value.q2x_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.r2x_1 === false)) {
      tmp1_output.zr(tmp0_desc, 2, value.r2x_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_138).on = function (encoder, value) {
    return this.o2x(encoder, value instanceof SaveSetupDraftRequest ? value : THROW_CCE());
  };
  protoOf($serializer_138).pn = function (decoder) {
    var tmp0_desc = this.n2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, $serializer_getInstance_139(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.fr(tmp0_desc, 1, $serializer_getInstance_139(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return SaveSetupDraftRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_138).nn = function () {
    return this.n2x_1;
  };
  protoOf($serializer_138).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), $serializer_getInstance_139(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_137;
  function $serializer_getInstance_137() {
    if ($serializer_instance_137 == null)
      new $serializer_138();
    return $serializer_instance_137;
  }
  function SaveSetupDraftRequest_init_$Init$(seen0, expectedRevision, answers, completeStep, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_137().n2x_1);
    }
    $this.p2x_1 = expectedRevision;
    $this.q2x_1 = answers;
    if (0 === (seen0 & 4))
      $this.r2x_1 = false;
    else
      $this.r2x_1 = completeStep;
    return $this;
  }
  function SaveSetupDraftRequest_init_$Create$(seen0, expectedRevision, answers, completeStep, serializationConstructorMarker) {
    return SaveSetupDraftRequest_init_$Init$(seen0, expectedRevision, answers, completeStep, serializationConstructorMarker, objectCreate(protoOf(SaveSetupDraftRequest)));
  }
  function SaveSetupDraftRequest(expectedRevision, answers, completeStep) {
    completeStep = completeStep === VOID ? false : completeStep;
    this.p2x_1 = expectedRevision;
    this.q2x_1 = answers;
    this.r2x_1 = completeStep;
  }
  protoOf(SaveSetupDraftRequest).toString = function () {
    return 'SaveSetupDraftRequest(expectedRevision=' + this.p2x_1.toString() + ', answers=' + this.q2x_1.toString() + ', completeStep=' + this.r2x_1 + ')';
  };
  protoOf(SaveSetupDraftRequest).hashCode = function () {
    var result = this.p2x_1.hashCode();
    result = imul(result, 31) + this.q2x_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r2x_1) | 0;
    return result;
  };
  protoOf(SaveSetupDraftRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaveSetupDraftRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SaveSetupDraftRequest ? other : THROW_CCE();
    if (!this.p2x_1.equals(tmp0_other_with_cast.p2x_1))
      return false;
    if (!this.q2x_1.equals(tmp0_other_with_cast.q2x_1))
      return false;
    if (!(this.r2x_1 === tmp0_other_with_cast.r2x_1))
      return false;
    return true;
  };
  function $serializer_139() {
    $serializer_instance_138 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupAppearancePaletteView', this, 7);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('primaryColor', false);
    tmp0_serialDesc.gy('secondaryColor', false);
    tmp0_serialDesc.gy('accentColor', false);
    tmp0_serialDesc.gy('collection', false);
    this.s2x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_139).t2x = function (encoder, value) {
    var tmp0_desc = this.s2x_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.u2x_1);
    tmp1_output.hs(tmp0_desc, 1, value.v2x_1);
    tmp1_output.hs(tmp0_desc, 2, value.w2x_1);
    tmp1_output.hs(tmp0_desc, 3, value.x2x_1);
    tmp1_output.hs(tmp0_desc, 4, value.y2x_1);
    tmp1_output.hs(tmp0_desc, 5, value.z2x_1);
    tmp1_output.hs(tmp0_desc, 6, value.a2y_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_139).on = function (encoder, value) {
    return this.t2x(encoder, value instanceof SetupAppearancePaletteView ? value : THROW_CCE());
  };
  protoOf($serializer_139).pn = function (decoder) {
    var tmp0_desc = this.s2x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return SetupAppearancePaletteView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_139).nn = function () {
    return this.s2x_1;
  };
  protoOf($serializer_139).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_138;
  function $serializer_getInstance_138() {
    if ($serializer_instance_138 == null)
      new $serializer_139();
    return $serializer_instance_138;
  }
  function SetupAppearancePaletteView_init_$Init$(seen0, id, nameEn, nameAr, primaryColor, secondaryColor, accentColor, collection, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_138().s2x_1);
    }
    $this.u2x_1 = id;
    $this.v2x_1 = nameEn;
    $this.w2x_1 = nameAr;
    $this.x2x_1 = primaryColor;
    $this.y2x_1 = secondaryColor;
    $this.z2x_1 = accentColor;
    $this.a2y_1 = collection;
    return $this;
  }
  function SetupAppearancePaletteView_init_$Create$(seen0, id, nameEn, nameAr, primaryColor, secondaryColor, accentColor, collection, serializationConstructorMarker) {
    return SetupAppearancePaletteView_init_$Init$(seen0, id, nameEn, nameAr, primaryColor, secondaryColor, accentColor, collection, serializationConstructorMarker, objectCreate(protoOf(SetupAppearancePaletteView)));
  }
  function SetupAppearancePaletteView() {
  }
  protoOf(SetupAppearancePaletteView).toString = function () {
    return 'SetupAppearancePaletteView(id=' + this.u2x_1 + ', nameEn=' + this.v2x_1 + ', nameAr=' + this.w2x_1 + ', primaryColor=' + this.x2x_1 + ', secondaryColor=' + this.y2x_1 + ', accentColor=' + this.z2x_1 + ', collection=' + this.a2y_1 + ')';
  };
  protoOf(SetupAppearancePaletteView).hashCode = function () {
    var result = getStringHashCode(this.u2x_1);
    result = imul(result, 31) + getStringHashCode(this.v2x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w2x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x2x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z2x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a2y_1) | 0;
    return result;
  };
  protoOf(SetupAppearancePaletteView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAppearancePaletteView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAppearancePaletteView ? other : THROW_CCE();
    if (!(this.u2x_1 === tmp0_other_with_cast.u2x_1))
      return false;
    if (!(this.v2x_1 === tmp0_other_with_cast.v2x_1))
      return false;
    if (!(this.w2x_1 === tmp0_other_with_cast.w2x_1))
      return false;
    if (!(this.x2x_1 === tmp0_other_with_cast.x2x_1))
      return false;
    if (!(this.y2x_1 === tmp0_other_with_cast.y2x_1))
      return false;
    if (!(this.z2x_1 === tmp0_other_with_cast.z2x_1))
      return false;
    if (!(this.a2y_1 === tmp0_other_with_cast.a2y_1))
      return false;
    return true;
  };
  function Companion_114() {
    Companion_instance_114 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b2y_1 = [null, null, null, null, null, null, null, null, null, new LinkedHashSetSerializer(StringSerializer_getInstance()), null, null, null, null, null, null, null, null, null, null, null, null, new LinkedHashSetSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_114;
  function Companion_getInstance_114() {
    if (Companion_instance_114 == null)
      new Companion_114();
    return Companion_instance_114;
  }
  function $serializer_140() {
    $serializer_instance_139 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupDraftAnswers', this, 23);
    tmp0_serialDesc.gy('displayNameEn', true);
    tmp0_serialDesc.gy('displayNameAr', true);
    tmp0_serialDesc.gy('slug', true);
    tmp0_serialDesc.gy('ownerName', true);
    tmp0_serialDesc.gy('ownerEmail', true);
    tmp0_serialDesc.gy('locale', true);
    tmp0_serialDesc.gy('timezone', true);
    tmp0_serialDesc.gy('planKey', true);
    tmp0_serialDesc.gy('sourceTenantId', true);
    tmp0_serialDesc.gy('copyCategories', true);
    tmp0_serialDesc.gy('stagedLogoAssetId', true);
    tmp0_serialDesc.gy('stagedDarkLogoAssetId', true);
    tmp0_serialDesc.gy('stagedFaviconAssetId', true);
    tmp0_serialDesc.gy('appearance', true);
    tmp0_serialDesc.gy('copiedImages', true);
    tmp0_serialDesc.gy('billingLegalNameEn', true);
    tmp0_serialDesc.gy('billingLegalNameAr', true);
    tmp0_serialDesc.gy('billingTaxRegistrationNumber', true);
    tmp0_serialDesc.gy('billingCommercialRegistrationNumber', true);
    tmp0_serialDesc.gy('billingAddress', true);
    tmp0_serialDesc.gy('billingCountryCode', true);
    tmp0_serialDesc.gy('billingEmail', true);
    tmp0_serialDesc.gy('copyExceptions', true);
    this.c2y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_140).d2y = function (encoder, value) {
    var tmp0_desc = this.c2y_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_114().b2y_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.e2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 0, value.e2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.f2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 1, value.f2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.g2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 2, value.g2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.h2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 3, value.h2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.i2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 4, value.i2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.j2y_1 === 'ar')) {
      tmp1_output.hs(tmp0_desc, 5, value.j2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.k2y_1 === 'Africa/Cairo')) {
      tmp1_output.hs(tmp0_desc, 6, value.k2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.l2y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.l2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.m2y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.m2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !equals(value.n2y_1, emptySet())) {
      tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.n2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.o2y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.o2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.p2y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, StringSerializer_getInstance(), value.p2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.q2y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 12, StringSerializer_getInstance(), value.q2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.r2y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 13, $serializer_getInstance_174(), value.r2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !(value.s2y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 14, $serializer_getInstance_196(), value.s2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 15) ? true : !(value.t2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 15, value.t2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 16) ? true : !(value.u2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 16, value.u2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 17) ? true : !(value.v2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 17, value.v2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 18) ? true : !(value.w2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 18, value.w2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 19) ? true : !(value.x2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 19, value.x2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 20) ? true : !(value.y2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 20, value.y2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 21) ? true : !(value.z2y_1 === '')) {
      tmp1_output.hs(tmp0_desc, 21, value.z2y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 22) ? true : !equals(value.a2z_1, emptySet())) {
      tmp1_output.js(tmp0_desc, 22, tmp2_cached[22], value.a2z_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_140).on = function (encoder, value) {
    return this.d2y(encoder, value instanceof SetupDraftAnswers ? value : THROW_CCE());
  };
  protoOf($serializer_140).pn = function (decoder) {
    var tmp0_desc = this.c2y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = null;
    var tmp26_local22 = null;
    var tmp27_input = decoder.tq(tmp0_desc);
    var tmp28_cached = Companion_getInstance_114().b2y_1;
    if (tmp27_input.ir()) {
      tmp4_local0 = tmp27_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp27_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp27_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp27_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp27_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp27_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp27_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp27_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp27_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp27_input.fr(tmp0_desc, 9, tmp28_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp27_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp27_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp27_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp27_input.hr(tmp0_desc, 13, $serializer_getInstance_174(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp27_input.hr(tmp0_desc, 14, $serializer_getInstance_196(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp27_input.dr(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp27_input.dr(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp27_input.dr(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp27_input.dr(tmp0_desc, 18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp27_input.dr(tmp0_desc, 19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp27_input.dr(tmp0_desc, 20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp27_input.dr(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp27_input.fr(tmp0_desc, 22, tmp28_cached[22], tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp27_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp27_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp27_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp27_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp27_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp27_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp27_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp27_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp27_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp27_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp27_input.fr(tmp0_desc, 9, tmp28_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp27_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp27_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp27_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp27_input.hr(tmp0_desc, 13, $serializer_getInstance_174(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp27_input.hr(tmp0_desc, 14, $serializer_getInstance_196(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp27_input.dr(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp27_input.dr(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp27_input.dr(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp27_input.dr(tmp0_desc, 18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp27_input.dr(tmp0_desc, 19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp27_input.dr(tmp0_desc, 20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp27_input.dr(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp27_input.fr(tmp0_desc, 22, tmp28_cached[22], tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp27_input.uq(tmp0_desc);
    return SetupDraftAnswers_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, null);
  };
  protoOf($serializer_140).nn = function () {
    return this.c2y_1;
  };
  protoOf($serializer_140).vy = function () {
    var tmp0_cached = Companion_getInstance_114().b2y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[9], get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_174()), get_nullable($serializer_getInstance_196()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[22]];
  };
  var $serializer_instance_139;
  function $serializer_getInstance_139() {
    if ($serializer_instance_139 == null)
      new $serializer_140();
    return $serializer_instance_139;
  }
  function SetupDraftAnswers_init_$Init$(seen0, displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_139().c2y_1);
    }
    if (0 === (seen0 & 1))
      $this.e2y_1 = '';
    else
      $this.e2y_1 = displayNameEn;
    if (0 === (seen0 & 2))
      $this.f2y_1 = '';
    else
      $this.f2y_1 = displayNameAr;
    if (0 === (seen0 & 4))
      $this.g2y_1 = '';
    else
      $this.g2y_1 = slug;
    if (0 === (seen0 & 8))
      $this.h2y_1 = '';
    else
      $this.h2y_1 = ownerName;
    if (0 === (seen0 & 16))
      $this.i2y_1 = '';
    else
      $this.i2y_1 = ownerEmail;
    if (0 === (seen0 & 32))
      $this.j2y_1 = 'ar';
    else
      $this.j2y_1 = locale;
    if (0 === (seen0 & 64))
      $this.k2y_1 = 'Africa/Cairo';
    else
      $this.k2y_1 = timezone;
    if (0 === (seen0 & 128))
      $this.l2y_1 = null;
    else
      $this.l2y_1 = planKey;
    if (0 === (seen0 & 256))
      $this.m2y_1 = null;
    else
      $this.m2y_1 = sourceTenantId;
    if (0 === (seen0 & 512))
      $this.n2y_1 = emptySet();
    else
      $this.n2y_1 = copyCategories;
    if (0 === (seen0 & 1024))
      $this.o2y_1 = null;
    else
      $this.o2y_1 = stagedLogoAssetId;
    if (0 === (seen0 & 2048))
      $this.p2y_1 = null;
    else
      $this.p2y_1 = stagedDarkLogoAssetId;
    if (0 === (seen0 & 4096))
      $this.q2y_1 = null;
    else
      $this.q2y_1 = stagedFaviconAssetId;
    if (0 === (seen0 & 8192))
      $this.r2y_1 = null;
    else
      $this.r2y_1 = appearance;
    if (0 === (seen0 & 16384))
      $this.s2y_1 = null;
    else
      $this.s2y_1 = copiedImages;
    if (0 === (seen0 & 32768))
      $this.t2y_1 = '';
    else
      $this.t2y_1 = billingLegalNameEn;
    if (0 === (seen0 & 65536))
      $this.u2y_1 = '';
    else
      $this.u2y_1 = billingLegalNameAr;
    if (0 === (seen0 & 131072))
      $this.v2y_1 = '';
    else
      $this.v2y_1 = billingTaxRegistrationNumber;
    if (0 === (seen0 & 262144))
      $this.w2y_1 = '';
    else
      $this.w2y_1 = billingCommercialRegistrationNumber;
    if (0 === (seen0 & 524288))
      $this.x2y_1 = '';
    else
      $this.x2y_1 = billingAddress;
    if (0 === (seen0 & 1048576))
      $this.y2y_1 = '';
    else
      $this.y2y_1 = billingCountryCode;
    if (0 === (seen0 & 2097152))
      $this.z2y_1 = '';
    else
      $this.z2y_1 = billingEmail;
    if (0 === (seen0 & 4194304))
      $this.a2z_1 = emptySet();
    else
      $this.a2z_1 = copyExceptions;
    return $this;
  }
  function SetupDraftAnswers_init_$Create$(seen0, displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions, serializationConstructorMarker) {
    return SetupDraftAnswers_init_$Init$(seen0, displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions, serializationConstructorMarker, objectCreate(protoOf(SetupDraftAnswers)));
  }
  function SetupDraftAnswers(displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions) {
    Companion_getInstance_114();
    displayNameEn = displayNameEn === VOID ? '' : displayNameEn;
    displayNameAr = displayNameAr === VOID ? '' : displayNameAr;
    slug = slug === VOID ? '' : slug;
    ownerName = ownerName === VOID ? '' : ownerName;
    ownerEmail = ownerEmail === VOID ? '' : ownerEmail;
    locale = locale === VOID ? 'ar' : locale;
    timezone = timezone === VOID ? 'Africa/Cairo' : timezone;
    planKey = planKey === VOID ? null : planKey;
    sourceTenantId = sourceTenantId === VOID ? null : sourceTenantId;
    copyCategories = copyCategories === VOID ? emptySet() : copyCategories;
    stagedLogoAssetId = stagedLogoAssetId === VOID ? null : stagedLogoAssetId;
    stagedDarkLogoAssetId = stagedDarkLogoAssetId === VOID ? null : stagedDarkLogoAssetId;
    stagedFaviconAssetId = stagedFaviconAssetId === VOID ? null : stagedFaviconAssetId;
    appearance = appearance === VOID ? null : appearance;
    copiedImages = copiedImages === VOID ? null : copiedImages;
    billingLegalNameEn = billingLegalNameEn === VOID ? '' : billingLegalNameEn;
    billingLegalNameAr = billingLegalNameAr === VOID ? '' : billingLegalNameAr;
    billingTaxRegistrationNumber = billingTaxRegistrationNumber === VOID ? '' : billingTaxRegistrationNumber;
    billingCommercialRegistrationNumber = billingCommercialRegistrationNumber === VOID ? '' : billingCommercialRegistrationNumber;
    billingAddress = billingAddress === VOID ? '' : billingAddress;
    billingCountryCode = billingCountryCode === VOID ? '' : billingCountryCode;
    billingEmail = billingEmail === VOID ? '' : billingEmail;
    copyExceptions = copyExceptions === VOID ? emptySet() : copyExceptions;
    this.e2y_1 = displayNameEn;
    this.f2y_1 = displayNameAr;
    this.g2y_1 = slug;
    this.h2y_1 = ownerName;
    this.i2y_1 = ownerEmail;
    this.j2y_1 = locale;
    this.k2y_1 = timezone;
    this.l2y_1 = planKey;
    this.m2y_1 = sourceTenantId;
    this.n2y_1 = copyCategories;
    this.o2y_1 = stagedLogoAssetId;
    this.p2y_1 = stagedDarkLogoAssetId;
    this.q2y_1 = stagedFaviconAssetId;
    this.r2y_1 = appearance;
    this.s2y_1 = copiedImages;
    this.t2y_1 = billingLegalNameEn;
    this.u2y_1 = billingLegalNameAr;
    this.v2y_1 = billingTaxRegistrationNumber;
    this.w2y_1 = billingCommercialRegistrationNumber;
    this.x2y_1 = billingAddress;
    this.y2y_1 = billingCountryCode;
    this.z2y_1 = billingEmail;
    this.a2z_1 = copyExceptions;
  }
  protoOf(SetupDraftAnswers).b2z = function (displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions) {
    return new SetupDraftAnswers(displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions);
  };
  protoOf(SetupDraftAnswers).c2z = function (displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions, $super) {
    displayNameEn = displayNameEn === VOID ? this.e2y_1 : displayNameEn;
    displayNameAr = displayNameAr === VOID ? this.f2y_1 : displayNameAr;
    slug = slug === VOID ? this.g2y_1 : slug;
    ownerName = ownerName === VOID ? this.h2y_1 : ownerName;
    ownerEmail = ownerEmail === VOID ? this.i2y_1 : ownerEmail;
    locale = locale === VOID ? this.j2y_1 : locale;
    timezone = timezone === VOID ? this.k2y_1 : timezone;
    planKey = planKey === VOID ? this.l2y_1 : planKey;
    sourceTenantId = sourceTenantId === VOID ? this.m2y_1 : sourceTenantId;
    copyCategories = copyCategories === VOID ? this.n2y_1 : copyCategories;
    stagedLogoAssetId = stagedLogoAssetId === VOID ? this.o2y_1 : stagedLogoAssetId;
    stagedDarkLogoAssetId = stagedDarkLogoAssetId === VOID ? this.p2y_1 : stagedDarkLogoAssetId;
    stagedFaviconAssetId = stagedFaviconAssetId === VOID ? this.q2y_1 : stagedFaviconAssetId;
    appearance = appearance === VOID ? this.r2y_1 : appearance;
    copiedImages = copiedImages === VOID ? this.s2y_1 : copiedImages;
    billingLegalNameEn = billingLegalNameEn === VOID ? this.t2y_1 : billingLegalNameEn;
    billingLegalNameAr = billingLegalNameAr === VOID ? this.u2y_1 : billingLegalNameAr;
    billingTaxRegistrationNumber = billingTaxRegistrationNumber === VOID ? this.v2y_1 : billingTaxRegistrationNumber;
    billingCommercialRegistrationNumber = billingCommercialRegistrationNumber === VOID ? this.w2y_1 : billingCommercialRegistrationNumber;
    billingAddress = billingAddress === VOID ? this.x2y_1 : billingAddress;
    billingCountryCode = billingCountryCode === VOID ? this.y2y_1 : billingCountryCode;
    billingEmail = billingEmail === VOID ? this.z2y_1 : billingEmail;
    copyExceptions = copyExceptions === VOID ? this.a2z_1 : copyExceptions;
    return $super === VOID ? this.b2z(displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions) : $super.b2z.call(this, displayNameEn, displayNameAr, slug, ownerName, ownerEmail, locale, timezone, planKey, sourceTenantId, copyCategories, stagedLogoAssetId, stagedDarkLogoAssetId, stagedFaviconAssetId, appearance, copiedImages, billingLegalNameEn, billingLegalNameAr, billingTaxRegistrationNumber, billingCommercialRegistrationNumber, billingAddress, billingCountryCode, billingEmail, copyExceptions);
  };
  protoOf(SetupDraftAnswers).toString = function () {
    return 'SetupDraftAnswers(displayNameEn=' + this.e2y_1 + ', displayNameAr=' + this.f2y_1 + ', slug=' + this.g2y_1 + ', ownerName=' + this.h2y_1 + ', ownerEmail=' + this.i2y_1 + ', locale=' + this.j2y_1 + ', timezone=' + this.k2y_1 + ', planKey=' + this.l2y_1 + ', sourceTenantId=' + this.m2y_1 + ', copyCategories=' + toString(this.n2y_1) + ', stagedLogoAssetId=' + this.o2y_1 + ', stagedDarkLogoAssetId=' + this.p2y_1 + ', stagedFaviconAssetId=' + this.q2y_1 + ', appearance=' + toString_0(this.r2y_1) + ', copiedImages=' + toString_0(this.s2y_1) + ', billingLegalNameEn=' + this.t2y_1 + ', billingLegalNameAr=' + this.u2y_1 + ', billingTaxRegistrationNumber=' + this.v2y_1 + ', billingCommercialRegistrationNumber=' + this.w2y_1 + ', billingAddress=' + this.x2y_1 + ', billingCountryCode=' + this.y2y_1 + ', billingEmail=' + this.z2y_1 + ', copyExceptions=' + toString(this.a2z_1) + ')';
  };
  protoOf(SetupDraftAnswers).hashCode = function () {
    var result = getStringHashCode(this.e2y_1);
    result = imul(result, 31) + getStringHashCode(this.f2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2y_1) | 0;
    result = imul(result, 31) + (this.l2y_1 == null ? 0 : getStringHashCode(this.l2y_1)) | 0;
    result = imul(result, 31) + (this.m2y_1 == null ? 0 : getStringHashCode(this.m2y_1)) | 0;
    result = imul(result, 31) + hashCode(this.n2y_1) | 0;
    result = imul(result, 31) + (this.o2y_1 == null ? 0 : getStringHashCode(this.o2y_1)) | 0;
    result = imul(result, 31) + (this.p2y_1 == null ? 0 : getStringHashCode(this.p2y_1)) | 0;
    result = imul(result, 31) + (this.q2y_1 == null ? 0 : getStringHashCode(this.q2y_1)) | 0;
    result = imul(result, 31) + (this.r2y_1 == null ? 0 : this.r2y_1.hashCode()) | 0;
    result = imul(result, 31) + (this.s2y_1 == null ? 0 : this.s2y_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.t2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.x2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y2y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z2y_1) | 0;
    result = imul(result, 31) + hashCode(this.a2z_1) | 0;
    return result;
  };
  protoOf(SetupDraftAnswers).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupDraftAnswers))
      return false;
    var tmp0_other_with_cast = other instanceof SetupDraftAnswers ? other : THROW_CCE();
    if (!(this.e2y_1 === tmp0_other_with_cast.e2y_1))
      return false;
    if (!(this.f2y_1 === tmp0_other_with_cast.f2y_1))
      return false;
    if (!(this.g2y_1 === tmp0_other_with_cast.g2y_1))
      return false;
    if (!(this.h2y_1 === tmp0_other_with_cast.h2y_1))
      return false;
    if (!(this.i2y_1 === tmp0_other_with_cast.i2y_1))
      return false;
    if (!(this.j2y_1 === tmp0_other_with_cast.j2y_1))
      return false;
    if (!(this.k2y_1 === tmp0_other_with_cast.k2y_1))
      return false;
    if (!(this.l2y_1 == tmp0_other_with_cast.l2y_1))
      return false;
    if (!(this.m2y_1 == tmp0_other_with_cast.m2y_1))
      return false;
    if (!equals(this.n2y_1, tmp0_other_with_cast.n2y_1))
      return false;
    if (!(this.o2y_1 == tmp0_other_with_cast.o2y_1))
      return false;
    if (!(this.p2y_1 == tmp0_other_with_cast.p2y_1))
      return false;
    if (!(this.q2y_1 == tmp0_other_with_cast.q2y_1))
      return false;
    if (!equals(this.r2y_1, tmp0_other_with_cast.r2y_1))
      return false;
    if (!equals(this.s2y_1, tmp0_other_with_cast.s2y_1))
      return false;
    if (!(this.t2y_1 === tmp0_other_with_cast.t2y_1))
      return false;
    if (!(this.u2y_1 === tmp0_other_with_cast.u2y_1))
      return false;
    if (!(this.v2y_1 === tmp0_other_with_cast.v2y_1))
      return false;
    if (!(this.w2y_1 === tmp0_other_with_cast.w2y_1))
      return false;
    if (!(this.x2y_1 === tmp0_other_with_cast.x2y_1))
      return false;
    if (!(this.y2y_1 === tmp0_other_with_cast.y2y_1))
      return false;
    if (!(this.z2y_1 === tmp0_other_with_cast.z2y_1))
      return false;
    if (!equals(this.a2z_1, tmp0_other_with_cast.a2z_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_3($this) {
    return $this.p2w_1.w();
  }
  function SetupStartMode$Companion$_anonymous__u26ba1() {
    return createSimpleEnumSerializer('com.ems.console.api.SetupStartMode', values_3());
  }
  var SetupStartMode_SCRATCH_instance;
  var SetupStartMode_COPY_instance;
  function values_3() {
    return [SetupStartMode_SCRATCH_getInstance(), SetupStartMode_COPY_getInstance()];
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_3());
    return $ENTRIES_0;
  }
  function Companion_115() {
    Companion_instance_115 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p2w_1 = lazy(tmp_0, SetupStartMode$Companion$_anonymous__u26ba1);
  }
  protoOf(Companion_115).w19 = function () {
    return _get_$cachedSerializer__te6jhj_3(this);
  };
  protoOf(Companion_115).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_115;
  function Companion_getInstance_115() {
    SetupStartMode_initEntries();
    if (Companion_instance_115 == null)
      new Companion_115();
    return Companion_instance_115;
  }
  var SetupStartMode_entriesInitialized;
  function SetupStartMode_initEntries() {
    if (SetupStartMode_entriesInitialized)
      return Unit_instance;
    SetupStartMode_entriesInitialized = true;
    SetupStartMode_SCRATCH_instance = new SetupStartMode('SCRATCH', 0);
    SetupStartMode_COPY_instance = new SetupStartMode('COPY', 1);
    Companion_getInstance_115();
  }
  var $ENTRIES_0;
  function SetupStartMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function _get_$cachedSerializer__te6jhj_4($this) {
    return $this.h2w_1.w();
  }
  function TenantAddressState$Companion$_anonymous__lg3aq0() {
    return createSimpleEnumSerializer('com.ems.console.api.TenantAddressState', values_4());
  }
  var TenantAddressState_AVAILABLE_instance;
  var TenantAddressState_INVALID_instance;
  var TenantAddressState_RESERVED_instance;
  var TenantAddressState_SLUG_TAKEN_instance;
  var TenantAddressState_HOST_TAKEN_instance;
  function values_4() {
    return [TenantAddressState_AVAILABLE_getInstance(), TenantAddressState_INVALID_getInstance(), TenantAddressState_RESERVED_getInstance(), TenantAddressState_SLUG_TAKEN_getInstance(), TenantAddressState_HOST_TAKEN_getInstance()];
  }
  function Companion_116() {
    Companion_instance_116 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.h2w_1 = lazy(tmp_0, TenantAddressState$Companion$_anonymous__lg3aq0);
  }
  protoOf(Companion_116).w19 = function () {
    return _get_$cachedSerializer__te6jhj_4(this);
  };
  protoOf(Companion_116).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_116;
  function Companion_getInstance_116() {
    TenantAddressState_initEntries();
    if (Companion_instance_116 == null)
      new Companion_116();
    return Companion_instance_116;
  }
  var TenantAddressState_entriesInitialized;
  function TenantAddressState_initEntries() {
    if (TenantAddressState_entriesInitialized)
      return Unit_instance;
    TenantAddressState_entriesInitialized = true;
    TenantAddressState_AVAILABLE_instance = new TenantAddressState('AVAILABLE', 0);
    TenantAddressState_INVALID_instance = new TenantAddressState('INVALID', 1);
    TenantAddressState_RESERVED_instance = new TenantAddressState('RESERVED', 2);
    TenantAddressState_SLUG_TAKEN_instance = new TenantAddressState('SLUG_TAKEN', 3);
    TenantAddressState_HOST_TAKEN_instance = new TenantAddressState('HOST_TAKEN', 4);
    Companion_getInstance_116();
  }
  function TenantAddressState(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_117() {
    Companion_instance_117 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e2z_1 = [Companion_getInstance_118().w19(), null, null, null];
  }
  var Companion_instance_117;
  function Companion_getInstance_117() {
    if (Companion_instance_117 == null)
      new Companion_117();
    return Companion_instance_117;
  }
  function $serializer_141() {
    $serializer_instance_140 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RemovedByPlanItem', this, 4);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('labelEn', false);
    tmp0_serialDesc.gy('labelAr', false);
    this.f2z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_141).g2z = function (encoder, value) {
    var tmp0_desc = this.f2z_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_117().e2z_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.h2z_1);
    tmp1_output.hs(tmp0_desc, 1, value.i2z_1);
    tmp1_output.hs(tmp0_desc, 2, value.j2z_1);
    tmp1_output.hs(tmp0_desc, 3, value.k2z_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_141).on = function (encoder, value) {
    return this.g2z(encoder, value instanceof RemovedByPlanItem ? value : THROW_CCE());
  };
  protoOf($serializer_141).pn = function (decoder) {
    var tmp0_desc = this.f2z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_117().e2z_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return RemovedByPlanItem_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_141).nn = function () {
    return this.f2z_1;
  };
  protoOf($serializer_141).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_117().e2z_1[0], StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_140;
  function $serializer_getInstance_140() {
    if ($serializer_instance_140 == null)
      new $serializer_141();
    return $serializer_instance_140;
  }
  function RemovedByPlanItem_init_$Init$(seen0, kind, key, labelEn, labelAr, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_140().f2z_1);
    }
    $this.h2z_1 = kind;
    $this.i2z_1 = key;
    $this.j2z_1 = labelEn;
    $this.k2z_1 = labelAr;
    return $this;
  }
  function RemovedByPlanItem_init_$Create$(seen0, kind, key, labelEn, labelAr, serializationConstructorMarker) {
    return RemovedByPlanItem_init_$Init$(seen0, kind, key, labelEn, labelAr, serializationConstructorMarker, objectCreate(protoOf(RemovedByPlanItem)));
  }
  function RemovedByPlanItem() {
  }
  protoOf(RemovedByPlanItem).toString = function () {
    return 'RemovedByPlanItem(kind=' + this.h2z_1.toString() + ', key=' + this.i2z_1 + ', labelEn=' + this.j2z_1 + ', labelAr=' + this.k2z_1 + ')';
  };
  protoOf(RemovedByPlanItem).hashCode = function () {
    var result = this.h2z_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i2z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j2z_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k2z_1) | 0;
    return result;
  };
  protoOf(RemovedByPlanItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemovedByPlanItem))
      return false;
    var tmp0_other_with_cast = other instanceof RemovedByPlanItem ? other : THROW_CCE();
    if (!this.h2z_1.equals(tmp0_other_with_cast.h2z_1))
      return false;
    if (!(this.i2z_1 === tmp0_other_with_cast.i2z_1))
      return false;
    if (!(this.j2z_1 === tmp0_other_with_cast.j2z_1))
      return false;
    if (!(this.k2z_1 === tmp0_other_with_cast.k2z_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_5($this) {
    return $this.d2z_1.w();
  }
  function RemovedByPlanKind$Companion$_anonymous__sjq4cb() {
    return createSimpleEnumSerializer('com.ems.console.api.RemovedByPlanKind', values_5());
  }
  var RemovedByPlanKind_APPEARANCE_instance;
  var RemovedByPlanKind_STAGED_IMAGE_instance;
  var RemovedByPlanKind_COPY_CATEGORY_instance;
  function values_5() {
    return [RemovedByPlanKind_APPEARANCE_getInstance(), RemovedByPlanKind_STAGED_IMAGE_getInstance(), RemovedByPlanKind_COPY_CATEGORY_getInstance()];
  }
  function Companion_118() {
    Companion_instance_118 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d2z_1 = lazy(tmp_0, RemovedByPlanKind$Companion$_anonymous__sjq4cb);
  }
  protoOf(Companion_118).w19 = function () {
    return _get_$cachedSerializer__te6jhj_5(this);
  };
  protoOf(Companion_118).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_118;
  function Companion_getInstance_118() {
    RemovedByPlanKind_initEntries();
    if (Companion_instance_118 == null)
      new Companion_118();
    return Companion_instance_118;
  }
  var RemovedByPlanKind_entriesInitialized;
  function RemovedByPlanKind_initEntries() {
    if (RemovedByPlanKind_entriesInitialized)
      return Unit_instance;
    RemovedByPlanKind_entriesInitialized = true;
    RemovedByPlanKind_APPEARANCE_instance = new RemovedByPlanKind('APPEARANCE', 0);
    RemovedByPlanKind_STAGED_IMAGE_instance = new RemovedByPlanKind('STAGED_IMAGE', 1);
    RemovedByPlanKind_COPY_CATEGORY_instance = new RemovedByPlanKind('COPY_CATEGORY', 2);
    Companion_getInstance_118();
  }
  function RemovedByPlanKind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SetupDraftState_EDITING_getInstance() {
    SetupDraftState_initEntries();
    return SetupDraftState_EDITING_instance;
  }
  function SetupDraftState_ACCEPTED_getInstance() {
    SetupDraftState_initEntries();
    return SetupDraftState_ACCEPTED_instance;
  }
  function SetupDraftState_EXPIRED_getInstance() {
    SetupDraftState_initEntries();
    return SetupDraftState_EXPIRED_instance;
  }
  function SetupDraftState_ABANDONED_getInstance() {
    SetupDraftState_initEntries();
    return SetupDraftState_ABANDONED_instance;
  }
  function SetupDraftStep_START_getInstance() {
    SetupDraftStep_initEntries();
    return SetupDraftStep_START_instance;
  }
  function SetupDraftStep_DETAILS_getInstance() {
    SetupDraftStep_initEntries();
    return SetupDraftStep_DETAILS_instance;
  }
  function SetupDraftStep_PLAN_getInstance() {
    SetupDraftStep_initEntries();
    return SetupDraftStep_PLAN_instance;
  }
  function SetupDraftStep_APPEARANCE_getInstance() {
    SetupDraftStep_initEntries();
    return SetupDraftStep_APPEARANCE_instance;
  }
  function SetupStartMode_SCRATCH_getInstance() {
    SetupStartMode_initEntries();
    return SetupStartMode_SCRATCH_instance;
  }
  function SetupStartMode_COPY_getInstance() {
    SetupStartMode_initEntries();
    return SetupStartMode_COPY_instance;
  }
  function TenantAddressState_AVAILABLE_getInstance() {
    TenantAddressState_initEntries();
    return TenantAddressState_AVAILABLE_instance;
  }
  function TenantAddressState_INVALID_getInstance() {
    TenantAddressState_initEntries();
    return TenantAddressState_INVALID_instance;
  }
  function TenantAddressState_RESERVED_getInstance() {
    TenantAddressState_initEntries();
    return TenantAddressState_RESERVED_instance;
  }
  function TenantAddressState_SLUG_TAKEN_getInstance() {
    TenantAddressState_initEntries();
    return TenantAddressState_SLUG_TAKEN_instance;
  }
  function TenantAddressState_HOST_TAKEN_getInstance() {
    TenantAddressState_initEntries();
    return TenantAddressState_HOST_TAKEN_instance;
  }
  function RemovedByPlanKind_APPEARANCE_getInstance() {
    RemovedByPlanKind_initEntries();
    return RemovedByPlanKind_APPEARANCE_instance;
  }
  function RemovedByPlanKind_STAGED_IMAGE_getInstance() {
    RemovedByPlanKind_initEntries();
    return RemovedByPlanKind_STAGED_IMAGE_instance;
  }
  function RemovedByPlanKind_COPY_CATEGORY_getInstance() {
    RemovedByPlanKind_initEntries();
    return RemovedByPlanKind_COPY_CATEGORY_instance;
  }
  function ConsoleTenantBrandingPaths() {
    ConsoleTenantBrandingPaths_instance = this;
    this.l2z_1 = '/api/console/tenants/{tenantId}/branding';
    this.m2z_1 = '/api/console/tenants/{tenantId}/branding/logo';
    this.n2z_1 = 524288;
    this.o2z_1 = listOf(['image/png', 'image/jpeg', 'image/gif', 'image/webp']);
  }
  protoOf(ConsoleTenantBrandingPaths).p2z = function (tenantId) {
    return '/api/console/tenants/' + ConsoleApiPaths_instance.e1z(tenantId) + '/branding';
  };
  protoOf(ConsoleTenantBrandingPaths).q2z = function (tenantId) {
    return this.p2z(tenantId) + '/logo';
  };
  var ConsoleTenantBrandingPaths_instance;
  function ConsoleTenantBrandingPaths_getInstance() {
    if (ConsoleTenantBrandingPaths_instance == null)
      new ConsoleTenantBrandingPaths();
    return ConsoleTenantBrandingPaths_instance;
  }
  function ConsoleTenantConnectionLifecyclePaths() {
    ConsoleTenantConnectionLifecyclePaths_instance = this;
    this.r2z_1 = '/api/console/tenants/{tenantId}/connections/registry';
    this.s2z_1 = '/api/console/tenants/{tenantId}/connections';
    this.t2z_1 = '/api/console/tenants/{tenantId}/connections/{provider}/{instance}';
    this.u2z_1 = '/api/console/tenants/{tenantId}/connections/{provider}/{instance}/verify';
    this.v2z_1 = '/api/console/tenants/{tenantId}/connections/{provider}/{instance}/test-send';
    this.w2z_1 = '/api/console/tenants/{tenantId}/connections/{provider}/{instance}/activate';
    this.x2z_1 = '/api/console/tenants/{tenantId}/connections/{provider}/{instance}/deactivate';
    this.y2z_1 = 'verify';
    this.z2z_1 = 'test-send';
    this.a30_1 = 'activate';
    this.b30_1 = 'deactivate';
    this.c30_1 = Regex_init_$Create$('^[a-z][a-z0-9_]{0,63}$');
    this.d30_1 = Regex_init_$Create$('^[A-Za-z0-9][A-Za-z0-9_.:-]{0,99}$');
  }
  protoOf(ConsoleTenantConnectionLifecyclePaths).e30 = function (value) {
    return this.d30_1.nd(value);
  };
  protoOf(ConsoleTenantConnectionLifecyclePaths).f30 = function (tenantId) {
    return '/api/console/tenants/' + ConsoleApiPaths_instance.e1z(tenantId) + '/connections/registry';
  };
  protoOf(ConsoleTenantConnectionLifecyclePaths).g30 = function (tenantId) {
    return '/api/console/tenants/' + ConsoleApiPaths_instance.e1z(tenantId) + '/connections';
  };
  protoOf(ConsoleTenantConnectionLifecyclePaths).h30 = function (tenantId, provider, instance) {
    return '/api/console/tenants/' + ConsoleApiPaths_instance.e1z(tenantId) + '/connections/' + ConsoleApiPaths_instance.e1z(provider) + '/' + ConsoleApiPaths_instance.e1z(instance);
  };
  protoOf(ConsoleTenantConnectionLifecyclePaths).i30 = function (tenantId, provider, instance, action) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!setOf(['verify', 'test-send', 'activate', 'deactivate']).r(action)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.h30(tenantId, provider, instance) + '/' + action;
  };
  protoOf(ConsoleTenantConnectionLifecyclePaths).j30 = function (instance) {
    return 'REMOVE ' + instance;
  };
  var ConsoleTenantConnectionLifecyclePaths_instance;
  function ConsoleTenantConnectionLifecyclePaths_getInstance() {
    if (ConsoleTenantConnectionLifecyclePaths_instance == null)
      new ConsoleTenantConnectionLifecyclePaths();
    return ConsoleTenantConnectionLifecyclePaths_instance;
  }
  function ConsoleTenantConnectionPaths() {
    ConsoleTenantConnectionPaths_instance = this;
    this.k30_1 = '/api/console/tenants/{tenantId}/connections/smtp/{purpose}';
    this.l30_1 = '/api/console/tenants/{tenantId}/connections/smtp/{purpose}/{action}';
    this.m30_1 = '/api/console/tenants/{tenantId}/connections/smtp/{purpose}/operations/{action}';
    this.n30_1 = 'save';
    this.o30_1 = 'verify';
    this.p30_1 = 'activate';
    this.q30_1 = 'deactivate';
    this.r30_1 = 'remove';
    this.s30_1 = 'test-send';
    this.t30_1 = listOf(['save', 'verify', 'activate', 'deactivate', 'remove', 'test-send']);
    this.u30_1 = Regex_init_$Create$('^[A-Za-z0-9_-]{1,200}$');
    this.v30_1 = Regex_init_$Create$('^[A-Z_]{1,80}$');
  }
  protoOf(ConsoleTenantConnectionPaths).w30 = function (value) {
    return this.u30_1.nd(value);
  };
  protoOf(ConsoleTenantConnectionPaths).x30 = function (value) {
    return this.v30_1.nd(value);
  };
  protoOf(ConsoleTenantConnectionPaths).y30 = function (value) {
    return this.t30_1.r(value);
  };
  protoOf(ConsoleTenantConnectionPaths).z30 = function (tenantId, purpose) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.w30(tenantId)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.x30(purpose)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message_0 = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    return '/api/console/tenants/' + tenantId + '/connections/smtp/' + purpose;
  };
  protoOf(ConsoleTenantConnectionPaths).a31 = function (tenantId, purpose, action) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.y30(action)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.z30(tenantId, purpose) + '/' + action;
  };
  protoOf(ConsoleTenantConnectionPaths).b31 = function (tenantId, purpose, action) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.y30(action)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.z30(tenantId, purpose) + '/operations/' + action;
  };
  var ConsoleTenantConnectionPaths_instance;
  function ConsoleTenantConnectionPaths_getInstance() {
    if (ConsoleTenantConnectionPaths_instance == null)
      new ConsoleTenantConnectionPaths();
    return ConsoleTenantConnectionPaths_instance;
  }
  function groupLabel(_this__u8e3s4, language) {
    var tmp;
    if (language === 'ar') {
      // Inline function 'kotlin.text.ifBlank' call
      var this_0 = _this__u8e3s4.v2l_1;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (isBlank(this_0)) {
        // Inline function 'com.ems.console.api.groupLabel.<anonymous>' call
        tmp_0 = '\u0645\u064A\u0632\u0627\u062A';
      } else {
        tmp_0 = this_0;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.text.ifBlank' call
      var this_1 = _this__u8e3s4.u2l_1;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_1;
      if (isBlank(this_1)) {
        // Inline function 'com.ems.console.api.groupLabel.<anonymous>' call
        tmp_1 = 'Features';
      } else {
        tmp_1 = this_1;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  function ManagedAssignmentSettingsPolicy() {
    this.c31_1 = 'managed_assignment_opaque_settings';
    this.d31_1 = 'validation.managed_assignment.opaque_settings';
  }
  protoOf(ManagedAssignmentSettingsPolicy).e31 = function (settings) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = settings.c2();
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'com.ems.console.api.ManagedAssignmentSettingsPolicy.opaqueFields.<anonymous>' call
      var tmp;
      if (endsWith(element, 'Json', true)) {
        // Inline function 'kotlin.text.isNotBlank' call
        // Inline function 'kotlin.text.orEmpty' call
        var tmp0_elvis_lhs = settings.b2(element);
        var this_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        tmp = !isBlank(this_1);
      } else {
        tmp = false;
      }
      if (tmp) {
        destination.e(element);
      }
    }
    return sorted(destination);
  };
  protoOf(ManagedAssignmentSettingsPolicy).f31 = function (settings) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.e31(settings);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'com.ems.console.api.ManagedAssignmentSettingsPolicy.fieldErrors.<anonymous>' call
      var tmp$ret$0 = new ConsoleFieldError('settings.' + item, 'managed_assignment_opaque_settings', 'validation.managed_assignment.opaque_settings');
      destination.e(tmp$ret$0);
    }
    return destination;
  };
  var ManagedAssignmentSettingsPolicy_instance;
  function ManagedAssignmentSettingsPolicy_getInstance() {
    return ManagedAssignmentSettingsPolicy_instance;
  }
  function Companion_119() {
    Companion_instance_119 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g31_1 = [new ArrayListSerializer($serializer_getInstance_145()), null];
  }
  var Companion_instance_119;
  function Companion_getInstance_119() {
    if (Companion_instance_119 == null)
      new Companion_119();
    return Companion_instance_119;
  }
  function $serializer_142() {
    $serializer_instance_141 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.MarketplaceSubmissionList', this, 2);
    tmp0_serialDesc.gy('items', false);
    tmp0_serialDesc.gy('pendingCount', false);
    this.h31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_142).i31 = function (encoder, value) {
    var tmp0_desc = this.h31_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_119().g31_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.j31_1);
    tmp1_output.cs(tmp0_desc, 1, value.k31_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_142).on = function (encoder, value) {
    return this.i31(encoder, value instanceof MarketplaceSubmissionList ? value : THROW_CCE());
  };
  protoOf($serializer_142).pn = function (decoder) {
    var tmp0_desc = this.h31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_119().g31_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return MarketplaceSubmissionList_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_142).nn = function () {
    return this.h31_1;
  };
  protoOf($serializer_142).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_119().g31_1[0], IntSerializer_getInstance()];
  };
  var $serializer_instance_141;
  function $serializer_getInstance_141() {
    if ($serializer_instance_141 == null)
      new $serializer_142();
    return $serializer_instance_141;
  }
  function MarketplaceSubmissionList_init_$Init$(seen0, items, pendingCount, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_141().h31_1);
    }
    $this.j31_1 = items;
    $this.k31_1 = pendingCount;
    return $this;
  }
  function MarketplaceSubmissionList_init_$Create$(seen0, items, pendingCount, serializationConstructorMarker) {
    return MarketplaceSubmissionList_init_$Init$(seen0, items, pendingCount, serializationConstructorMarker, objectCreate(protoOf(MarketplaceSubmissionList)));
  }
  function MarketplaceSubmissionList(items, pendingCount) {
    Companion_getInstance_119();
    this.j31_1 = items;
    this.k31_1 = pendingCount;
  }
  protoOf(MarketplaceSubmissionList).toString = function () {
    return 'MarketplaceSubmissionList(items=' + toString(this.j31_1) + ', pendingCount=' + this.k31_1 + ')';
  };
  protoOf(MarketplaceSubmissionList).hashCode = function () {
    var result = hashCode(this.j31_1);
    result = imul(result, 31) + this.k31_1 | 0;
    return result;
  };
  protoOf(MarketplaceSubmissionList).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MarketplaceSubmissionList))
      return false;
    var tmp0_other_with_cast = other instanceof MarketplaceSubmissionList ? other : THROW_CCE();
    if (!equals(this.j31_1, tmp0_other_with_cast.j31_1))
      return false;
    if (!(this.k31_1 === tmp0_other_with_cast.k31_1))
      return false;
    return true;
  };
  function Companion_120() {
    Companion_instance_120 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l31_1 = [null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_120;
  function Companion_getInstance_120() {
    if (Companion_instance_120 == null)
      new Companion_120();
    return Companion_instance_120;
  }
  function $serializer_143() {
    $serializer_instance_142 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.MarketplaceSubmissionDetail', this, 7);
    tmp0_serialDesc.gy('submission', false);
    tmp0_serialDesc.gy('descriptionEn', false);
    tmp0_serialDesc.gy('descriptionAr', false);
    tmp0_serialDesc.gy('manifestJson', false);
    tmp0_serialDesc.gy('contentJson', false);
    tmp0_serialDesc.gy('scrubReportJson', false);
    tmp0_serialDesc.gy('residue', true);
    this.m31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_143).n31 = function (encoder, value) {
    var tmp0_desc = this.m31_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_120().l31_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_145(), value.o31_1);
    tmp1_output.hs(tmp0_desc, 1, value.p31_1);
    tmp1_output.hs(tmp0_desc, 2, value.q31_1);
    tmp1_output.hs(tmp0_desc, 3, value.r31_1);
    tmp1_output.hs(tmp0_desc, 4, value.s31_1);
    tmp1_output.hs(tmp0_desc, 5, value.t31_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !equals(value.u31_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.u31_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_143).on = function (encoder, value) {
    return this.n31(encoder, value instanceof MarketplaceSubmissionDetail ? value : THROW_CCE());
  };
  protoOf($serializer_143).pn = function (decoder) {
    var tmp0_desc = this.m31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    var tmp12_cached = Companion_getInstance_120().l31_1;
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.fr(tmp0_desc, 0, $serializer_getInstance_145(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.fr(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.fr(tmp0_desc, 0, $serializer_getInstance_145(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.fr(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return MarketplaceSubmissionDetail_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_143).nn = function () {
    return this.m31_1;
  };
  protoOf($serializer_143).vy = function () {
    var tmp0_cached = Companion_getInstance_120().l31_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_145(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[6]];
  };
  var $serializer_instance_142;
  function $serializer_getInstance_142() {
    if ($serializer_instance_142 == null)
      new $serializer_143();
    return $serializer_instance_142;
  }
  function MarketplaceSubmissionDetail_init_$Init$(seen0, submission, descriptionEn, descriptionAr, manifestJson, contentJson, scrubReportJson, residue, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_142().m31_1);
    }
    $this.o31_1 = submission;
    $this.p31_1 = descriptionEn;
    $this.q31_1 = descriptionAr;
    $this.r31_1 = manifestJson;
    $this.s31_1 = contentJson;
    $this.t31_1 = scrubReportJson;
    if (0 === (seen0 & 64))
      $this.u31_1 = emptyList();
    else
      $this.u31_1 = residue;
    return $this;
  }
  function MarketplaceSubmissionDetail_init_$Create$(seen0, submission, descriptionEn, descriptionAr, manifestJson, contentJson, scrubReportJson, residue, serializationConstructorMarker) {
    return MarketplaceSubmissionDetail_init_$Init$(seen0, submission, descriptionEn, descriptionAr, manifestJson, contentJson, scrubReportJson, residue, serializationConstructorMarker, objectCreate(protoOf(MarketplaceSubmissionDetail)));
  }
  function MarketplaceSubmissionDetail(submission, descriptionEn, descriptionAr, manifestJson, contentJson, scrubReportJson, residue) {
    Companion_getInstance_120();
    residue = residue === VOID ? emptyList() : residue;
    this.o31_1 = submission;
    this.p31_1 = descriptionEn;
    this.q31_1 = descriptionAr;
    this.r31_1 = manifestJson;
    this.s31_1 = contentJson;
    this.t31_1 = scrubReportJson;
    this.u31_1 = residue;
  }
  protoOf(MarketplaceSubmissionDetail).toString = function () {
    return 'MarketplaceSubmissionDetail(submission=' + this.o31_1.toString() + ', descriptionEn=' + this.p31_1 + ', descriptionAr=' + this.q31_1 + ', manifestJson=' + this.r31_1 + ', contentJson=' + this.s31_1 + ', scrubReportJson=' + this.t31_1 + ', residue=' + toString(this.u31_1) + ')';
  };
  protoOf(MarketplaceSubmissionDetail).hashCode = function () {
    var result = this.o31_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.p31_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q31_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r31_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s31_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t31_1) | 0;
    result = imul(result, 31) + hashCode(this.u31_1) | 0;
    return result;
  };
  protoOf(MarketplaceSubmissionDetail).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MarketplaceSubmissionDetail))
      return false;
    var tmp0_other_with_cast = other instanceof MarketplaceSubmissionDetail ? other : THROW_CCE();
    if (!this.o31_1.equals(tmp0_other_with_cast.o31_1))
      return false;
    if (!(this.p31_1 === tmp0_other_with_cast.p31_1))
      return false;
    if (!(this.q31_1 === tmp0_other_with_cast.q31_1))
      return false;
    if (!(this.r31_1 === tmp0_other_with_cast.r31_1))
      return false;
    if (!(this.s31_1 === tmp0_other_with_cast.s31_1))
      return false;
    if (!(this.t31_1 === tmp0_other_with_cast.t31_1))
      return false;
    if (!equals(this.u31_1, tmp0_other_with_cast.u31_1))
      return false;
    return true;
  };
  function MarketplacePaths() {
    this.v31_1 = '/api/console/marketplace/submissions';
    this.w31_1 = 'status';
  }
  protoOf(MarketplacePaths).a1l = function (versionId) {
    return '/api/console/marketplace/submissions/' + versionId;
  };
  protoOf(MarketplacePaths).b1l = function (versionId) {
    return '/api/console/marketplace/submissions/' + versionId + '/approve';
  };
  protoOf(MarketplacePaths).x31 = function (versionId) {
    return '/api/console/marketplace/submissions/' + versionId + '/reject';
  };
  var MarketplacePaths_instance;
  function MarketplacePaths_getInstance() {
    return MarketplacePaths_instance;
  }
  function Companion_121() {
  }
  var Companion_instance_121;
  function Companion_getInstance_121() {
    return Companion_instance_121;
  }
  function $serializer_144() {
    $serializer_instance_143 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.MarketplaceDecision', this, 2);
    tmp0_serialDesc.gy('submission', false);
    tmp0_serialDesc.gy('replayed', true);
    this.y31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_144).z31 = function (encoder, value) {
    var tmp0_desc = this.y31_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_145(), value.a32_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.b32_1 === false)) {
      tmp1_output.zr(tmp0_desc, 1, value.b32_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_144).on = function (encoder, value) {
    return this.z31(encoder, value instanceof MarketplaceDecision ? value : THROW_CCE());
  };
  protoOf($serializer_144).pn = function (decoder) {
    var tmp0_desc = this.y31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_145(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_145(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return MarketplaceDecision_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_144).nn = function () {
    return this.y31_1;
  };
  protoOf($serializer_144).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_145(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_143;
  function $serializer_getInstance_143() {
    if ($serializer_instance_143 == null)
      new $serializer_144();
    return $serializer_instance_143;
  }
  function MarketplaceDecision_init_$Init$(seen0, submission, replayed, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_143().y31_1);
    }
    $this.a32_1 = submission;
    if (0 === (seen0 & 2))
      $this.b32_1 = false;
    else
      $this.b32_1 = replayed;
    return $this;
  }
  function MarketplaceDecision_init_$Create$(seen0, submission, replayed, serializationConstructorMarker) {
    return MarketplaceDecision_init_$Init$(seen0, submission, replayed, serializationConstructorMarker, objectCreate(protoOf(MarketplaceDecision)));
  }
  function MarketplaceDecision(submission, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.a32_1 = submission;
    this.b32_1 = replayed;
  }
  protoOf(MarketplaceDecision).toString = function () {
    return 'MarketplaceDecision(submission=' + this.a32_1.toString() + ', replayed=' + this.b32_1 + ')';
  };
  protoOf(MarketplaceDecision).hashCode = function () {
    var result = this.a32_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.b32_1) | 0;
    return result;
  };
  protoOf(MarketplaceDecision).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MarketplaceDecision))
      return false;
    var tmp0_other_with_cast = other instanceof MarketplaceDecision ? other : THROW_CCE();
    if (!this.a32_1.equals(tmp0_other_with_cast.a32_1))
      return false;
    if (!(this.b32_1 === tmp0_other_with_cast.b32_1))
      return false;
    return true;
  };
  function Companion_122() {
  }
  var Companion_instance_122;
  function Companion_getInstance_122() {
    return Companion_instance_122;
  }
  function $serializer_145() {
    $serializer_instance_144 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.MarketplaceDecisionBody', this, 1);
    tmp0_serialDesc.gy('note', true);
    this.c32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_145).d32 = function (encoder, value) {
    var tmp0_desc = this.c32_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.e32_1 === '')) {
      tmp1_output.hs(tmp0_desc, 0, value.e32_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_145).on = function (encoder, value) {
    return this.d32(encoder, value instanceof MarketplaceDecisionBody ? value : THROW_CCE());
  };
  protoOf($serializer_145).pn = function (decoder) {
    var tmp0_desc = this.c32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return MarketplaceDecisionBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_145).nn = function () {
    return this.c32_1;
  };
  protoOf($serializer_145).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_144;
  function $serializer_getInstance_144() {
    if ($serializer_instance_144 == null)
      new $serializer_145();
    return $serializer_instance_144;
  }
  function MarketplaceDecisionBody_init_$Init$(seen0, note, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_144().c32_1);
    }
    if (0 === (seen0 & 1))
      $this.e32_1 = '';
    else
      $this.e32_1 = note;
    return $this;
  }
  function MarketplaceDecisionBody_init_$Create$(seen0, note, serializationConstructorMarker) {
    return MarketplaceDecisionBody_init_$Init$(seen0, note, serializationConstructorMarker, objectCreate(protoOf(MarketplaceDecisionBody)));
  }
  function MarketplaceDecisionBody(note) {
    note = note === VOID ? '' : note;
    this.e32_1 = note;
  }
  protoOf(MarketplaceDecisionBody).toString = function () {
    return 'MarketplaceDecisionBody(note=' + this.e32_1 + ')';
  };
  protoOf(MarketplaceDecisionBody).hashCode = function () {
    return getStringHashCode(this.e32_1);
  };
  protoOf(MarketplaceDecisionBody).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MarketplaceDecisionBody))
      return false;
    var tmp0_other_with_cast = other instanceof MarketplaceDecisionBody ? other : THROW_CCE();
    if (!(this.e32_1 === tmp0_other_with_cast.e32_1))
      return false;
    return true;
  };
  function $serializer_146() {
    $serializer_instance_145 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.MarketplaceSubmissionRow', this, 16);
    tmp0_serialDesc.gy('packageId', false);
    tmp0_serialDesc.gy('versionId', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('slug', false);
    tmp0_serialDesc.gy('titleEn', false);
    tmp0_serialDesc.gy('titleAr', false);
    tmp0_serialDesc.gy('publisherTenantId', false);
    tmp0_serialDesc.gy('publisherName', false);
    tmp0_serialDesc.gy('version', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('submittedAtMs', false);
    tmp0_serialDesc.gy('scrubWarningCount', false);
    tmp0_serialDesc.gy('personNameWarnings', true);
    tmp0_serialDesc.gy('reviewedAtMs', true);
    tmp0_serialDesc.gy('reviewedBy', true);
    tmp0_serialDesc.gy('reviewNote', true);
    this.f32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_146).g32 = function (encoder, value) {
    var tmp0_desc = this.f32_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.h32_1);
    tmp1_output.hs(tmp0_desc, 1, value.i32_1);
    tmp1_output.hs(tmp0_desc, 2, value.j32_1);
    tmp1_output.hs(tmp0_desc, 3, value.k32_1);
    tmp1_output.hs(tmp0_desc, 4, value.l32_1);
    tmp1_output.hs(tmp0_desc, 5, value.m32_1);
    tmp1_output.hs(tmp0_desc, 6, value.n32_1);
    tmp1_output.hs(tmp0_desc, 7, value.o32_1);
    tmp1_output.cs(tmp0_desc, 8, value.p32_1);
    tmp1_output.hs(tmp0_desc, 9, value.q32_1);
    tmp1_output.ds(tmp0_desc, 10, value.r32_1);
    tmp1_output.cs(tmp0_desc, 11, value.s32_1);
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.t32_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 12, value.t32_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.u32_1 == null)) {
      tmp1_output.ls(tmp0_desc, 13, LongSerializer_getInstance(), value.u32_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !(value.v32_1 == null)) {
      tmp1_output.ls(tmp0_desc, 14, StringSerializer_getInstance(), value.v32_1);
    }
    if (tmp1_output.ps(tmp0_desc, 15) ? true : !(value.w32_1 == null)) {
      tmp1_output.ls(tmp0_desc, 15, StringSerializer_getInstance(), value.w32_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_146).on = function (encoder, value) {
    return this.g32(encoder, value instanceof MarketplaceSubmissionRow ? value : THROW_CCE());
  };
  protoOf($serializer_146).pn = function (decoder) {
    var tmp0_desc = this.f32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = 0;
    var tmp13_local9 = null;
    var tmp14_local10 = new Long(0, 0);
    var tmp15_local11 = 0;
    var tmp16_local12 = 0;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_input = decoder.tq(tmp0_desc);
    if (tmp20_input.ir()) {
      tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp20_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp20_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp20_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp20_input.yq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp20_input.dr(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp20_input.zq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp20_input.yq(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp20_input.yq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp20_input.hr(tmp0_desc, 13, LongSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp20_input.hr(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp20_input.hr(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp20_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp20_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp20_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp20_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp20_input.yq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp20_input.dr(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp20_input.zq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp20_input.yq(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp20_input.yq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp20_input.hr(tmp0_desc, 13, LongSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp20_input.hr(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp20_input.hr(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp20_input.uq(tmp0_desc);
    return MarketplaceSubmissionRow_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
  };
  protoOf($serializer_146).nn = function () {
    return this.f32_1;
  };
  protoOf($serializer_146).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_145;
  function $serializer_getInstance_145() {
    if ($serializer_instance_145 == null)
      new $serializer_146();
    return $serializer_instance_145;
  }
  function MarketplaceSubmissionRow_init_$Init$(seen0, packageId, versionId, kind, slug, titleEn, titleAr, publisherTenantId, publisherName, version, status, submittedAtMs, scrubWarningCount, personNameWarnings, reviewedAtMs, reviewedBy, reviewNote, serializationConstructorMarker, $this) {
    if (!(4095 === (4095 & seen0))) {
      throwMissingFieldException(seen0, 4095, $serializer_getInstance_145().f32_1);
    }
    $this.h32_1 = packageId;
    $this.i32_1 = versionId;
    $this.j32_1 = kind;
    $this.k32_1 = slug;
    $this.l32_1 = titleEn;
    $this.m32_1 = titleAr;
    $this.n32_1 = publisherTenantId;
    $this.o32_1 = publisherName;
    $this.p32_1 = version;
    $this.q32_1 = status;
    $this.r32_1 = submittedAtMs;
    $this.s32_1 = scrubWarningCount;
    if (0 === (seen0 & 4096))
      $this.t32_1 = 0;
    else
      $this.t32_1 = personNameWarnings;
    if (0 === (seen0 & 8192))
      $this.u32_1 = null;
    else
      $this.u32_1 = reviewedAtMs;
    if (0 === (seen0 & 16384))
      $this.v32_1 = null;
    else
      $this.v32_1 = reviewedBy;
    if (0 === (seen0 & 32768))
      $this.w32_1 = null;
    else
      $this.w32_1 = reviewNote;
    return $this;
  }
  function MarketplaceSubmissionRow_init_$Create$(seen0, packageId, versionId, kind, slug, titleEn, titleAr, publisherTenantId, publisherName, version, status, submittedAtMs, scrubWarningCount, personNameWarnings, reviewedAtMs, reviewedBy, reviewNote, serializationConstructorMarker) {
    return MarketplaceSubmissionRow_init_$Init$(seen0, packageId, versionId, kind, slug, titleEn, titleAr, publisherTenantId, publisherName, version, status, submittedAtMs, scrubWarningCount, personNameWarnings, reviewedAtMs, reviewedBy, reviewNote, serializationConstructorMarker, objectCreate(protoOf(MarketplaceSubmissionRow)));
  }
  function MarketplaceSubmissionRow() {
  }
  protoOf(MarketplaceSubmissionRow).toString = function () {
    return 'MarketplaceSubmissionRow(packageId=' + this.h32_1 + ', versionId=' + this.i32_1 + ', kind=' + this.j32_1 + ', slug=' + this.k32_1 + ', titleEn=' + this.l32_1 + ', titleAr=' + this.m32_1 + ', publisherTenantId=' + this.n32_1 + ', publisherName=' + this.o32_1 + ', version=' + this.p32_1 + ', status=' + this.q32_1 + ', submittedAtMs=' + this.r32_1.toString() + ', scrubWarningCount=' + this.s32_1 + ', personNameWarnings=' + this.t32_1 + ', reviewedAtMs=' + toString_0(this.u32_1) + ', reviewedBy=' + this.v32_1 + ', reviewNote=' + this.w32_1 + ')';
  };
  protoOf(MarketplaceSubmissionRow).hashCode = function () {
    var result = getStringHashCode(this.h32_1);
    result = imul(result, 31) + getStringHashCode(this.i32_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j32_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k32_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l32_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m32_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n32_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o32_1) | 0;
    result = imul(result, 31) + this.p32_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.q32_1) | 0;
    result = imul(result, 31) + this.r32_1.hashCode() | 0;
    result = imul(result, 31) + this.s32_1 | 0;
    result = imul(result, 31) + this.t32_1 | 0;
    result = imul(result, 31) + (this.u32_1 == null ? 0 : this.u32_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v32_1 == null ? 0 : getStringHashCode(this.v32_1)) | 0;
    result = imul(result, 31) + (this.w32_1 == null ? 0 : getStringHashCode(this.w32_1)) | 0;
    return result;
  };
  protoOf(MarketplaceSubmissionRow).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MarketplaceSubmissionRow))
      return false;
    var tmp0_other_with_cast = other instanceof MarketplaceSubmissionRow ? other : THROW_CCE();
    if (!(this.h32_1 === tmp0_other_with_cast.h32_1))
      return false;
    if (!(this.i32_1 === tmp0_other_with_cast.i32_1))
      return false;
    if (!(this.j32_1 === tmp0_other_with_cast.j32_1))
      return false;
    if (!(this.k32_1 === tmp0_other_with_cast.k32_1))
      return false;
    if (!(this.l32_1 === tmp0_other_with_cast.l32_1))
      return false;
    if (!(this.m32_1 === tmp0_other_with_cast.m32_1))
      return false;
    if (!(this.n32_1 === tmp0_other_with_cast.n32_1))
      return false;
    if (!(this.o32_1 === tmp0_other_with_cast.o32_1))
      return false;
    if (!(this.p32_1 === tmp0_other_with_cast.p32_1))
      return false;
    if (!(this.q32_1 === tmp0_other_with_cast.q32_1))
      return false;
    if (!this.r32_1.equals(tmp0_other_with_cast.r32_1))
      return false;
    if (!(this.s32_1 === tmp0_other_with_cast.s32_1))
      return false;
    if (!(this.t32_1 === tmp0_other_with_cast.t32_1))
      return false;
    if (!equals(this.u32_1, tmp0_other_with_cast.u32_1))
      return false;
    if (!(this.v32_1 == tmp0_other_with_cast.v32_1))
      return false;
    if (!(this.w32_1 == tmp0_other_with_cast.w32_1))
      return false;
    return true;
  };
  function Companion_123() {
    Companion_instance_123 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x32_1 = [null, null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, new ArrayListSerializer($serializer_getInstance_150()), null, new ArrayListSerializer($serializer_getInstance_147()), new ArrayListSerializer($serializer_getInstance_147()), new ArrayListSerializer($serializer_getInstance_151()), new ArrayListSerializer($serializer_getInstance_148())];
  }
  var Companion_instance_123;
  function Companion_getInstance_123() {
    if (Companion_instance_123 == null)
      new Companion_123();
    return Companion_instance_123;
  }
  function $serializer_147() {
    $serializer_instance_146 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OfferReadinessView', this, 17);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('lifecycle', false);
    tmp0_serialDesc.gy('revision', false);
    tmp0_serialDesc.gy('catalogVersion', false);
    tmp0_serialDesc.gy('ledgerStatus', false);
    tmp0_serialDesc.gy('measuredCatalogVersion', true);
    tmp0_serialDesc.gy('modules', false);
    tmp0_serialDesc.gy('included', false);
    tmp0_serialDesc.gy('candidates', false);
    tmp0_serialDesc.gy('features', false);
    tmp0_serialDesc.gy('staffSeats', false);
    tmp0_serialDesc.gy('usage', false);
    tmp0_serialDesc.gy('capacity', false);
    tmp0_serialDesc.gy('prices', false);
    tmp0_serialDesc.gy('issues', false);
    this.y32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_147).z32 = function (encoder, value) {
    var tmp0_desc = this.y32_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_123().x32_1;
    tmp1_output.hs(tmp0_desc, 0, value.a33_1);
    tmp1_output.hs(tmp0_desc, 1, value.b33_1);
    tmp1_output.hs(tmp0_desc, 2, value.c33_1);
    tmp1_output.hs(tmp0_desc, 3, value.d33_1);
    tmp1_output.ds(tmp0_desc, 4, value.e33_1);
    tmp1_output.cs(tmp0_desc, 5, value.f33_1);
    tmp1_output.hs(tmp0_desc, 6, value.g33_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.h33_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, IntSerializer_getInstance(), value.h33_1);
    }
    tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.i33_1);
    tmp1_output.js(tmp0_desc, 9, $serializer_getInstance_149(), value.j33_1);
    tmp1_output.js(tmp0_desc, 10, $serializer_getInstance_149(), value.k33_1);
    tmp1_output.js(tmp0_desc, 11, tmp2_cached[11], value.l33_1);
    tmp1_output.js(tmp0_desc, 12, $serializer_getInstance_147(), value.m33_1);
    tmp1_output.js(tmp0_desc, 13, tmp2_cached[13], value.n33_1);
    tmp1_output.js(tmp0_desc, 14, tmp2_cached[14], value.o33_1);
    tmp1_output.js(tmp0_desc, 15, tmp2_cached[15], value.p33_1);
    tmp1_output.js(tmp0_desc, 16, tmp2_cached[16], value.q33_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_147).on = function (encoder, value) {
    return this.z32(encoder, value instanceof OfferReadinessView ? value : THROW_CCE());
  };
  protoOf($serializer_147).pn = function (decoder) {
    var tmp0_desc = this.y32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_input = decoder.tq(tmp0_desc);
    var tmp22_cached = Companion_getInstance_123().x32_1;
    if (tmp21_input.ir()) {
      tmp4_local0 = tmp21_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp21_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp21_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp21_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp21_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp21_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp21_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp21_input.hr(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp21_input.fr(tmp0_desc, 8, tmp22_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp21_input.fr(tmp0_desc, 9, $serializer_getInstance_149(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp21_input.fr(tmp0_desc, 10, $serializer_getInstance_149(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp21_input.fr(tmp0_desc, 11, tmp22_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp21_input.fr(tmp0_desc, 12, $serializer_getInstance_147(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp21_input.fr(tmp0_desc, 13, tmp22_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp21_input.fr(tmp0_desc, 14, tmp22_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp21_input.fr(tmp0_desc, 15, tmp22_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp21_input.fr(tmp0_desc, 16, tmp22_cached[16], tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp21_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp21_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp21_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp21_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp21_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp21_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp21_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp21_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp21_input.hr(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp21_input.fr(tmp0_desc, 8, tmp22_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp21_input.fr(tmp0_desc, 9, $serializer_getInstance_149(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp21_input.fr(tmp0_desc, 10, $serializer_getInstance_149(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp21_input.fr(tmp0_desc, 11, tmp22_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp21_input.fr(tmp0_desc, 12, $serializer_getInstance_147(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp21_input.fr(tmp0_desc, 13, tmp22_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp21_input.fr(tmp0_desc, 14, tmp22_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp21_input.fr(tmp0_desc, 15, tmp22_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp21_input.fr(tmp0_desc, 16, tmp22_cached[16], tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp21_input.uq(tmp0_desc);
    return OfferReadinessView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
  };
  protoOf($serializer_147).nn = function () {
    return this.y32_1;
  };
  protoOf($serializer_147).vy = function () {
    var tmp0_cached = Companion_getInstance_123().x32_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), tmp0_cached[8], $serializer_getInstance_149(), $serializer_getInstance_149(), tmp0_cached[11], $serializer_getInstance_147(), tmp0_cached[13], tmp0_cached[14], tmp0_cached[15], tmp0_cached[16]];
  };
  var $serializer_instance_146;
  function $serializer_getInstance_146() {
    if ($serializer_instance_146 == null)
      new $serializer_147();
    return $serializer_instance_146;
  }
  function OfferReadinessView_init_$Init$(seen0, planKey, nameEn, nameAr, lifecycle, revision, catalogVersion, ledgerStatus, measuredCatalogVersion, modules, included, candidates, features, staffSeats, usage, capacity, prices, issues, serializationConstructorMarker, $this) {
    if (!(130943 === (130943 & seen0))) {
      throwMissingFieldException(seen0, 130943, $serializer_getInstance_146().y32_1);
    }
    $this.a33_1 = planKey;
    $this.b33_1 = nameEn;
    $this.c33_1 = nameAr;
    $this.d33_1 = lifecycle;
    $this.e33_1 = revision;
    $this.f33_1 = catalogVersion;
    $this.g33_1 = ledgerStatus;
    if (0 === (seen0 & 128))
      $this.h33_1 = null;
    else
      $this.h33_1 = measuredCatalogVersion;
    $this.i33_1 = modules;
    $this.j33_1 = included;
    $this.k33_1 = candidates;
    $this.l33_1 = features;
    $this.m33_1 = staffSeats;
    $this.n33_1 = usage;
    $this.o33_1 = capacity;
    $this.p33_1 = prices;
    $this.q33_1 = issues;
    return $this;
  }
  function OfferReadinessView_init_$Create$(seen0, planKey, nameEn, nameAr, lifecycle, revision, catalogVersion, ledgerStatus, measuredCatalogVersion, modules, included, candidates, features, staffSeats, usage, capacity, prices, issues, serializationConstructorMarker) {
    return OfferReadinessView_init_$Init$(seen0, planKey, nameEn, nameAr, lifecycle, revision, catalogVersion, ledgerStatus, measuredCatalogVersion, modules, included, candidates, features, staffSeats, usage, capacity, prices, issues, serializationConstructorMarker, objectCreate(protoOf(OfferReadinessView)));
  }
  function OfferReadinessView() {
  }
  protoOf(OfferReadinessView).toString = function () {
    return 'OfferReadinessView(planKey=' + this.a33_1 + ', nameEn=' + this.b33_1 + ', nameAr=' + this.c33_1 + ', lifecycle=' + this.d33_1 + ', revision=' + this.e33_1.toString() + ', catalogVersion=' + this.f33_1 + ', ledgerStatus=' + this.g33_1 + ', measuredCatalogVersion=' + this.h33_1 + ', modules=' + toString(this.i33_1) + ', included=' + this.j33_1.toString() + ', candidates=' + this.k33_1.toString() + ', features=' + toString(this.l33_1) + ', staffSeats=' + this.m33_1.toString() + ', usage=' + toString(this.n33_1) + ', capacity=' + toString(this.o33_1) + ', prices=' + toString(this.p33_1) + ', issues=' + toString(this.q33_1) + ')';
  };
  protoOf(OfferReadinessView).hashCode = function () {
    var result = getStringHashCode(this.a33_1);
    result = imul(result, 31) + getStringHashCode(this.b33_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c33_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d33_1) | 0;
    result = imul(result, 31) + this.e33_1.hashCode() | 0;
    result = imul(result, 31) + this.f33_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.g33_1) | 0;
    result = imul(result, 31) + (this.h33_1 == null ? 0 : this.h33_1) | 0;
    result = imul(result, 31) + hashCode(this.i33_1) | 0;
    result = imul(result, 31) + this.j33_1.hashCode() | 0;
    result = imul(result, 31) + this.k33_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.l33_1) | 0;
    result = imul(result, 31) + this.m33_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.n33_1) | 0;
    result = imul(result, 31) + hashCode(this.o33_1) | 0;
    result = imul(result, 31) + hashCode(this.p33_1) | 0;
    result = imul(result, 31) + hashCode(this.q33_1) | 0;
    return result;
  };
  protoOf(OfferReadinessView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OfferReadinessView))
      return false;
    var tmp0_other_with_cast = other instanceof OfferReadinessView ? other : THROW_CCE();
    if (!(this.a33_1 === tmp0_other_with_cast.a33_1))
      return false;
    if (!(this.b33_1 === tmp0_other_with_cast.b33_1))
      return false;
    if (!(this.c33_1 === tmp0_other_with_cast.c33_1))
      return false;
    if (!(this.d33_1 === tmp0_other_with_cast.d33_1))
      return false;
    if (!this.e33_1.equals(tmp0_other_with_cast.e33_1))
      return false;
    if (!(this.f33_1 === tmp0_other_with_cast.f33_1))
      return false;
    if (!(this.g33_1 === tmp0_other_with_cast.g33_1))
      return false;
    if (!(this.h33_1 == tmp0_other_with_cast.h33_1))
      return false;
    if (!equals(this.i33_1, tmp0_other_with_cast.i33_1))
      return false;
    if (!this.j33_1.equals(tmp0_other_with_cast.j33_1))
      return false;
    if (!this.k33_1.equals(tmp0_other_with_cast.k33_1))
      return false;
    if (!equals(this.l33_1, tmp0_other_with_cast.l33_1))
      return false;
    if (!this.m33_1.equals(tmp0_other_with_cast.m33_1))
      return false;
    if (!equals(this.n33_1, tmp0_other_with_cast.n33_1))
      return false;
    if (!equals(this.o33_1, tmp0_other_with_cast.o33_1))
      return false;
    if (!equals(this.p33_1, tmp0_other_with_cast.p33_1))
      return false;
    if (!equals(this.q33_1, tmp0_other_with_cast.q33_1))
      return false;
    return true;
  };
  function Companion_124() {
  }
  var Companion_instance_124;
  function Companion_getInstance_124() {
    return Companion_instance_124;
  }
  function $serializer_148() {
    $serializer_instance_147 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OfferAllowance', this, 7);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('grant', false);
    tmp0_serialDesc.gy('value', true);
    tmp0_serialDesc.gy('period', false);
    tmp0_serialDesc.gy('policy', true);
    this.r33_1 = tmp0_serialDesc;
  }
  protoOf($serializer_148).s33 = function (encoder, value) {
    var tmp0_desc = this.r33_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.t33_1);
    tmp1_output.hs(tmp0_desc, 1, value.u33_1);
    tmp1_output.hs(tmp0_desc, 2, value.v33_1);
    tmp1_output.hs(tmp0_desc, 3, value.w33_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.x33_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.x33_1);
    }
    tmp1_output.hs(tmp0_desc, 5, value.y33_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.z33_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.z33_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_148).on = function (encoder, value) {
    return this.s33(encoder, value instanceof OfferAllowance ? value : THROW_CCE());
  };
  protoOf($serializer_148).pn = function (decoder) {
    var tmp0_desc = this.r33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return OfferAllowance_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_148).nn = function () {
    return this.r33_1;
  };
  protoOf($serializer_148).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_147;
  function $serializer_getInstance_147() {
    if ($serializer_instance_147 == null)
      new $serializer_148();
    return $serializer_instance_147;
  }
  function OfferAllowance_init_$Init$(seen0, limitKey, nameEn, nameAr, grant, value, period, policy, serializationConstructorMarker, $this) {
    if (!(47 === (47 & seen0))) {
      throwMissingFieldException(seen0, 47, $serializer_getInstance_147().r33_1);
    }
    $this.t33_1 = limitKey;
    $this.u33_1 = nameEn;
    $this.v33_1 = nameAr;
    $this.w33_1 = grant;
    if (0 === (seen0 & 16))
      $this.x33_1 = null;
    else
      $this.x33_1 = value;
    $this.y33_1 = period;
    if (0 === (seen0 & 64))
      $this.z33_1 = null;
    else
      $this.z33_1 = policy;
    return $this;
  }
  function OfferAllowance_init_$Create$(seen0, limitKey, nameEn, nameAr, grant, value, period, policy, serializationConstructorMarker) {
    return OfferAllowance_init_$Init$(seen0, limitKey, nameEn, nameAr, grant, value, period, policy, serializationConstructorMarker, objectCreate(protoOf(OfferAllowance)));
  }
  function OfferAllowance(limitKey, nameEn, nameAr, grant, value, period, policy) {
    value = value === VOID ? null : value;
    policy = policy === VOID ? null : policy;
    this.t33_1 = limitKey;
    this.u33_1 = nameEn;
    this.v33_1 = nameAr;
    this.w33_1 = grant;
    this.x33_1 = value;
    this.y33_1 = period;
    this.z33_1 = policy;
  }
  protoOf(OfferAllowance).toString = function () {
    return 'OfferAllowance(limitKey=' + this.t33_1 + ', nameEn=' + this.u33_1 + ', nameAr=' + this.v33_1 + ', grant=' + this.w33_1 + ', value=' + toString_0(this.x33_1) + ', period=' + this.y33_1 + ', policy=' + this.z33_1 + ')';
  };
  protoOf(OfferAllowance).hashCode = function () {
    var result = getStringHashCode(this.t33_1);
    result = imul(result, 31) + getStringHashCode(this.u33_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v33_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w33_1) | 0;
    result = imul(result, 31) + (this.x33_1 == null ? 0 : this.x33_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.y33_1) | 0;
    result = imul(result, 31) + (this.z33_1 == null ? 0 : getStringHashCode(this.z33_1)) | 0;
    return result;
  };
  protoOf(OfferAllowance).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OfferAllowance))
      return false;
    var tmp0_other_with_cast = other instanceof OfferAllowance ? other : THROW_CCE();
    if (!(this.t33_1 === tmp0_other_with_cast.t33_1))
      return false;
    if (!(this.u33_1 === tmp0_other_with_cast.u33_1))
      return false;
    if (!(this.v33_1 === tmp0_other_with_cast.v33_1))
      return false;
    if (!(this.w33_1 === tmp0_other_with_cast.w33_1))
      return false;
    if (!equals(this.x33_1, tmp0_other_with_cast.x33_1))
      return false;
    if (!(this.y33_1 === tmp0_other_with_cast.y33_1))
      return false;
    if (!(this.z33_1 == tmp0_other_with_cast.z33_1))
      return false;
    return true;
  };
  function $serializer_149() {
    $serializer_instance_148 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OfferReadinessIssue', this, 3);
    tmp0_serialDesc.gy('code', false);
    tmp0_serialDesc.gy('featureKey', true);
    tmp0_serialDesc.gy('limitKey', true);
    this.a34_1 = tmp0_serialDesc;
  }
  protoOf($serializer_149).b34 = function (encoder, value) {
    var tmp0_desc = this.a34_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.c34_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.d34_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.d34_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.e34_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.e34_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_149).on = function (encoder, value) {
    return this.b34(encoder, value instanceof OfferReadinessIssue ? value : THROW_CCE());
  };
  protoOf($serializer_149).pn = function (decoder) {
    var tmp0_desc = this.a34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return OfferReadinessIssue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_149).nn = function () {
    return this.a34_1;
  };
  protoOf($serializer_149).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_148;
  function $serializer_getInstance_148() {
    if ($serializer_instance_148 == null)
      new $serializer_149();
    return $serializer_instance_148;
  }
  function OfferReadinessIssue_init_$Init$(seen0, code, featureKey, limitKey, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_148().a34_1);
    }
    $this.c34_1 = code;
    if (0 === (seen0 & 2))
      $this.d34_1 = null;
    else
      $this.d34_1 = featureKey;
    if (0 === (seen0 & 4))
      $this.e34_1 = null;
    else
      $this.e34_1 = limitKey;
    return $this;
  }
  function OfferReadinessIssue_init_$Create$(seen0, code, featureKey, limitKey, serializationConstructorMarker) {
    return OfferReadinessIssue_init_$Init$(seen0, code, featureKey, limitKey, serializationConstructorMarker, objectCreate(protoOf(OfferReadinessIssue)));
  }
  function OfferReadinessIssue() {
  }
  protoOf(OfferReadinessIssue).toString = function () {
    return 'OfferReadinessIssue(code=' + this.c34_1 + ', featureKey=' + this.d34_1 + ', limitKey=' + this.e34_1 + ')';
  };
  protoOf(OfferReadinessIssue).hashCode = function () {
    var result = getStringHashCode(this.c34_1);
    result = imul(result, 31) + (this.d34_1 == null ? 0 : getStringHashCode(this.d34_1)) | 0;
    result = imul(result, 31) + (this.e34_1 == null ? 0 : getStringHashCode(this.e34_1)) | 0;
    return result;
  };
  protoOf(OfferReadinessIssue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OfferReadinessIssue))
      return false;
    var tmp0_other_with_cast = other instanceof OfferReadinessIssue ? other : THROW_CCE();
    if (!(this.c34_1 === tmp0_other_with_cast.c34_1))
      return false;
    if (!(this.d34_1 == tmp0_other_with_cast.d34_1))
      return false;
    if (!(this.e34_1 == tmp0_other_with_cast.e34_1))
      return false;
    return true;
  };
  function Companion_125() {
  }
  var Companion_instance_125;
  function Companion_getInstance_125() {
    return Companion_instance_125;
  }
  function $serializer_150() {
    $serializer_instance_149 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OfferReadinessCounts', this, 4);
    tmp0_serialDesc.gy('available', true);
    tmp0_serialDesc.gy('pilotOnly', true);
    tmp0_serialDesc.gy('planned', true);
    tmp0_serialDesc.gy('core', true);
    this.f34_1 = tmp0_serialDesc;
  }
  protoOf($serializer_150).g34 = function (encoder, value) {
    var tmp0_desc = this.f34_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.h34_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 0, value.h34_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.i34_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 1, value.i34_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.j34_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 2, value.j34_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.k34_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 3, value.k34_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_150).on = function (encoder, value) {
    return this.g34(encoder, value instanceof OfferReadinessCounts ? value : THROW_CCE());
  };
  protoOf($serializer_150).pn = function (decoder) {
    var tmp0_desc = this.f34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = 0;
    var tmp6_local2 = 0;
    var tmp7_local3 = 0;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.yq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.yq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.yq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.yq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.yq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.yq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return OfferReadinessCounts_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_150).nn = function () {
    return this.f34_1;
  };
  protoOf($serializer_150).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_149;
  function $serializer_getInstance_149() {
    if ($serializer_instance_149 == null)
      new $serializer_150();
    return $serializer_instance_149;
  }
  function OfferReadinessCounts_init_$Init$(seen0, available, pilotOnly, planned, core, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_149().f34_1);
    }
    if (0 === (seen0 & 1))
      $this.h34_1 = 0;
    else
      $this.h34_1 = available;
    if (0 === (seen0 & 2))
      $this.i34_1 = 0;
    else
      $this.i34_1 = pilotOnly;
    if (0 === (seen0 & 4))
      $this.j34_1 = 0;
    else
      $this.j34_1 = planned;
    if (0 === (seen0 & 8))
      $this.k34_1 = 0;
    else
      $this.k34_1 = core;
    return $this;
  }
  function OfferReadinessCounts_init_$Create$(seen0, available, pilotOnly, planned, core, serializationConstructorMarker) {
    return OfferReadinessCounts_init_$Init$(seen0, available, pilotOnly, planned, core, serializationConstructorMarker, objectCreate(protoOf(OfferReadinessCounts)));
  }
  function OfferReadinessCounts(available, pilotOnly, planned, core) {
    available = available === VOID ? 0 : available;
    pilotOnly = pilotOnly === VOID ? 0 : pilotOnly;
    planned = planned === VOID ? 0 : planned;
    core = core === VOID ? 0 : core;
    this.h34_1 = available;
    this.i34_1 = pilotOnly;
    this.j34_1 = planned;
    this.k34_1 = core;
  }
  protoOf(OfferReadinessCounts).toString = function () {
    return 'OfferReadinessCounts(available=' + this.h34_1 + ', pilotOnly=' + this.i34_1 + ', planned=' + this.j34_1 + ', core=' + this.k34_1 + ')';
  };
  protoOf(OfferReadinessCounts).hashCode = function () {
    var result = this.h34_1;
    result = imul(result, 31) + this.i34_1 | 0;
    result = imul(result, 31) + this.j34_1 | 0;
    result = imul(result, 31) + this.k34_1 | 0;
    return result;
  };
  protoOf(OfferReadinessCounts).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OfferReadinessCounts))
      return false;
    var tmp0_other_with_cast = other instanceof OfferReadinessCounts ? other : THROW_CCE();
    if (!(this.h34_1 === tmp0_other_with_cast.h34_1))
      return false;
    if (!(this.i34_1 === tmp0_other_with_cast.i34_1))
      return false;
    if (!(this.j34_1 === tmp0_other_with_cast.j34_1))
      return false;
    if (!(this.k34_1 === tmp0_other_with_cast.k34_1))
      return false;
    return true;
  };
  function $serializer_151() {
    $serializer_instance_150 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OfferFeatureReadiness', this, 9);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('moduleKey', true);
    tmp0_serialDesc.gy('group', false);
    tmp0_serialDesc.gy('readiness', false);
    tmp0_serialDesc.gy('catalogStatus', false);
    tmp0_serialDesc.gy('included', false);
    tmp0_serialDesc.gy('evidence', false);
    this.l34_1 = tmp0_serialDesc;
  }
  protoOf($serializer_151).m34 = function (encoder, value) {
    var tmp0_desc = this.l34_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.n34_1);
    tmp1_output.hs(tmp0_desc, 1, value.o34_1);
    tmp1_output.hs(tmp0_desc, 2, value.p34_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.q34_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.q34_1);
    }
    tmp1_output.hs(tmp0_desc, 4, value.r34_1);
    tmp1_output.hs(tmp0_desc, 5, value.s34_1);
    tmp1_output.hs(tmp0_desc, 6, value.t34_1);
    tmp1_output.zr(tmp0_desc, 7, value.u34_1);
    tmp1_output.js(tmp0_desc, 8, $serializer_getInstance_152(), value.v34_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_151).on = function (encoder, value) {
    return this.m34(encoder, value instanceof OfferFeatureReadiness ? value : THROW_CCE());
  };
  protoOf($serializer_151).pn = function (decoder) {
    var tmp0_desc = this.l34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.fr(tmp0_desc, 8, $serializer_getInstance_152(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.fr(tmp0_desc, 8, $serializer_getInstance_152(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return OfferFeatureReadiness_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_151).nn = function () {
    return this.l34_1;
  };
  protoOf($serializer_151).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), $serializer_getInstance_152()];
  };
  var $serializer_instance_150;
  function $serializer_getInstance_150() {
    if ($serializer_instance_150 == null)
      new $serializer_151();
    return $serializer_instance_150;
  }
  function OfferFeatureReadiness_init_$Init$(seen0, key, nameEn, nameAr, moduleKey, group, readiness, catalogStatus, included, evidence, serializationConstructorMarker, $this) {
    if (!(503 === (503 & seen0))) {
      throwMissingFieldException(seen0, 503, $serializer_getInstance_150().l34_1);
    }
    $this.n34_1 = key;
    $this.o34_1 = nameEn;
    $this.p34_1 = nameAr;
    if (0 === (seen0 & 8))
      $this.q34_1 = null;
    else
      $this.q34_1 = moduleKey;
    $this.r34_1 = group;
    $this.s34_1 = readiness;
    $this.t34_1 = catalogStatus;
    $this.u34_1 = included;
    $this.v34_1 = evidence;
    return $this;
  }
  function OfferFeatureReadiness_init_$Create$(seen0, key, nameEn, nameAr, moduleKey, group, readiness, catalogStatus, included, evidence, serializationConstructorMarker) {
    return OfferFeatureReadiness_init_$Init$(seen0, key, nameEn, nameAr, moduleKey, group, readiness, catalogStatus, included, evidence, serializationConstructorMarker, objectCreate(protoOf(OfferFeatureReadiness)));
  }
  function OfferFeatureReadiness() {
  }
  protoOf(OfferFeatureReadiness).toString = function () {
    return 'OfferFeatureReadiness(key=' + this.n34_1 + ', nameEn=' + this.o34_1 + ', nameAr=' + this.p34_1 + ', moduleKey=' + this.q34_1 + ', group=' + this.r34_1 + ', readiness=' + this.s34_1 + ', catalogStatus=' + this.t34_1 + ', included=' + this.u34_1 + ', evidence=' + this.v34_1.toString() + ')';
  };
  protoOf(OfferFeatureReadiness).hashCode = function () {
    var result = getStringHashCode(this.n34_1);
    result = imul(result, 31) + getStringHashCode(this.o34_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p34_1) | 0;
    result = imul(result, 31) + (this.q34_1 == null ? 0 : getStringHashCode(this.q34_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.r34_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s34_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.t34_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u34_1) | 0;
    result = imul(result, 31) + this.v34_1.hashCode() | 0;
    return result;
  };
  protoOf(OfferFeatureReadiness).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OfferFeatureReadiness))
      return false;
    var tmp0_other_with_cast = other instanceof OfferFeatureReadiness ? other : THROW_CCE();
    if (!(this.n34_1 === tmp0_other_with_cast.n34_1))
      return false;
    if (!(this.o34_1 === tmp0_other_with_cast.o34_1))
      return false;
    if (!(this.p34_1 === tmp0_other_with_cast.p34_1))
      return false;
    if (!(this.q34_1 == tmp0_other_with_cast.q34_1))
      return false;
    if (!(this.r34_1 === tmp0_other_with_cast.r34_1))
      return false;
    if (!(this.s34_1 === tmp0_other_with_cast.s34_1))
      return false;
    if (!(this.t34_1 === tmp0_other_with_cast.t34_1))
      return false;
    if (!(this.u34_1 === tmp0_other_with_cast.u34_1))
      return false;
    if (!this.v34_1.equals(tmp0_other_with_cast.v34_1))
      return false;
    return true;
  };
  function $serializer_152() {
    $serializer_instance_151 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OfferPriceTerm', this, 4);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('billingCycle', false);
    tmp0_serialDesc.gy('amountMinor', false);
    tmp0_serialDesc.gy('published', false);
    this.w34_1 = tmp0_serialDesc;
  }
  protoOf($serializer_152).x34 = function (encoder, value) {
    var tmp0_desc = this.w34_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.y34_1);
    tmp1_output.hs(tmp0_desc, 1, value.z34_1);
    tmp1_output.ds(tmp0_desc, 2, value.a35_1);
    tmp1_output.zr(tmp0_desc, 3, value.b35_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_152).on = function (encoder, value) {
    return this.x34(encoder, value instanceof OfferPriceTerm ? value : THROW_CCE());
  };
  protoOf($serializer_152).pn = function (decoder) {
    var tmp0_desc = this.w34_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = false;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return OfferPriceTerm_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_152).nn = function () {
    return this.w34_1;
  };
  protoOf($serializer_152).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_151;
  function $serializer_getInstance_151() {
    if ($serializer_instance_151 == null)
      new $serializer_152();
    return $serializer_instance_151;
  }
  function OfferPriceTerm_init_$Init$(seen0, currency, billingCycle, amountMinor, published, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_151().w34_1);
    }
    $this.y34_1 = currency;
    $this.z34_1 = billingCycle;
    $this.a35_1 = amountMinor;
    $this.b35_1 = published;
    return $this;
  }
  function OfferPriceTerm_init_$Create$(seen0, currency, billingCycle, amountMinor, published, serializationConstructorMarker) {
    return OfferPriceTerm_init_$Init$(seen0, currency, billingCycle, amountMinor, published, serializationConstructorMarker, objectCreate(protoOf(OfferPriceTerm)));
  }
  function OfferPriceTerm() {
  }
  protoOf(OfferPriceTerm).toString = function () {
    return 'OfferPriceTerm(currency=' + this.y34_1 + ', billingCycle=' + this.z34_1 + ', amountMinor=' + this.a35_1.toString() + ', published=' + this.b35_1 + ')';
  };
  protoOf(OfferPriceTerm).hashCode = function () {
    var result = getStringHashCode(this.y34_1);
    result = imul(result, 31) + getStringHashCode(this.z34_1) | 0;
    result = imul(result, 31) + this.a35_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b35_1) | 0;
    return result;
  };
  protoOf(OfferPriceTerm).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OfferPriceTerm))
      return false;
    var tmp0_other_with_cast = other instanceof OfferPriceTerm ? other : THROW_CCE();
    if (!(this.y34_1 === tmp0_other_with_cast.y34_1))
      return false;
    if (!(this.z34_1 === tmp0_other_with_cast.z34_1))
      return false;
    if (!this.a35_1.equals(tmp0_other_with_cast.a35_1))
      return false;
    if (!(this.b35_1 === tmp0_other_with_cast.b35_1))
      return false;
    return true;
  };
  function Companion_126() {
    Companion_instance_126 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c35_1 = [null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_126;
  function Companion_getInstance_126() {
    if (Companion_instance_126 == null)
      new Companion_126();
    return Companion_instance_126;
  }
  function $serializer_153() {
    $serializer_instance_152 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.OfferRuntimeEvidence', this, 8);
    tmp0_serialDesc.gy('measured', false);
    tmp0_serialDesc.gy('httpAuthored', true);
    tmp0_serialDesc.gy('httpMapped', true);
    tmp0_serialDesc.gy('httpGated', true);
    tmp0_serialDesc.gy('mcpAuthored', true);
    tmp0_serialDesc.gy('mcpMapped', true);
    tmp0_serialDesc.gy('mcpGated', true);
    tmp0_serialDesc.gy('gaps', true);
    this.d35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_153).e35 = function (encoder, value) {
    var tmp0_desc = this.d35_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_126().c35_1;
    tmp1_output.zr(tmp0_desc, 0, value.f35_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.g35_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 1, value.g35_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.h35_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, IntSerializer_getInstance(), value.h35_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.i35_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, IntSerializer_getInstance(), value.i35_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.j35_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 4, value.j35_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.k35_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, IntSerializer_getInstance(), value.k35_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.l35_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, IntSerializer_getInstance(), value.l35_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !equals(value.m35_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.m35_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_153).on = function (encoder, value) {
    return this.e35(encoder, value instanceof OfferRuntimeEvidence ? value : THROW_CCE());
  };
  protoOf($serializer_153).pn = function (decoder) {
    var tmp0_desc = this.d35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = false;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.tq(tmp0_desc);
    var tmp13_cached = Companion_getInstance_126().c35_1;
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.vq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.hr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.yq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.hr(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.hr(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.fr(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.vq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.hr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.yq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.hr(tmp0_desc, 5, IntSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.hr(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.fr(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return OfferRuntimeEvidence_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_153).nn = function () {
    return this.d35_1;
  };
  protoOf($serializer_153).vy = function () {
    var tmp0_cached = Companion_getInstance_126().c35_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [BooleanSerializer_getInstance(), IntSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), tmp0_cached[7]];
  };
  var $serializer_instance_152;
  function $serializer_getInstance_152() {
    if ($serializer_instance_152 == null)
      new $serializer_153();
    return $serializer_instance_152;
  }
  function OfferRuntimeEvidence_init_$Init$(seen0, measured, httpAuthored, httpMapped, httpGated, mcpAuthored, mcpMapped, mcpGated, gaps, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_152().d35_1);
    }
    $this.f35_1 = measured;
    if (0 === (seen0 & 2))
      $this.g35_1 = 0;
    else
      $this.g35_1 = httpAuthored;
    if (0 === (seen0 & 4))
      $this.h35_1 = null;
    else
      $this.h35_1 = httpMapped;
    if (0 === (seen0 & 8))
      $this.i35_1 = null;
    else
      $this.i35_1 = httpGated;
    if (0 === (seen0 & 16))
      $this.j35_1 = 0;
    else
      $this.j35_1 = mcpAuthored;
    if (0 === (seen0 & 32))
      $this.k35_1 = null;
    else
      $this.k35_1 = mcpMapped;
    if (0 === (seen0 & 64))
      $this.l35_1 = null;
    else
      $this.l35_1 = mcpGated;
    if (0 === (seen0 & 128))
      $this.m35_1 = emptyList();
    else
      $this.m35_1 = gaps;
    return $this;
  }
  function OfferRuntimeEvidence_init_$Create$(seen0, measured, httpAuthored, httpMapped, httpGated, mcpAuthored, mcpMapped, mcpGated, gaps, serializationConstructorMarker) {
    return OfferRuntimeEvidence_init_$Init$(seen0, measured, httpAuthored, httpMapped, httpGated, mcpAuthored, mcpMapped, mcpGated, gaps, serializationConstructorMarker, objectCreate(protoOf(OfferRuntimeEvidence)));
  }
  function OfferRuntimeEvidence() {
  }
  protoOf(OfferRuntimeEvidence).toString = function () {
    return 'OfferRuntimeEvidence(measured=' + this.f35_1 + ', httpAuthored=' + this.g35_1 + ', httpMapped=' + this.h35_1 + ', httpGated=' + this.i35_1 + ', mcpAuthored=' + this.j35_1 + ', mcpMapped=' + this.k35_1 + ', mcpGated=' + this.l35_1 + ', gaps=' + toString(this.m35_1) + ')';
  };
  protoOf(OfferRuntimeEvidence).hashCode = function () {
    var result = getBooleanHashCode(this.f35_1);
    result = imul(result, 31) + this.g35_1 | 0;
    result = imul(result, 31) + (this.h35_1 == null ? 0 : this.h35_1) | 0;
    result = imul(result, 31) + (this.i35_1 == null ? 0 : this.i35_1) | 0;
    result = imul(result, 31) + this.j35_1 | 0;
    result = imul(result, 31) + (this.k35_1 == null ? 0 : this.k35_1) | 0;
    result = imul(result, 31) + (this.l35_1 == null ? 0 : this.l35_1) | 0;
    result = imul(result, 31) + hashCode(this.m35_1) | 0;
    return result;
  };
  protoOf(OfferRuntimeEvidence).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OfferRuntimeEvidence))
      return false;
    var tmp0_other_with_cast = other instanceof OfferRuntimeEvidence ? other : THROW_CCE();
    if (!(this.f35_1 === tmp0_other_with_cast.f35_1))
      return false;
    if (!(this.g35_1 === tmp0_other_with_cast.g35_1))
      return false;
    if (!(this.h35_1 == tmp0_other_with_cast.h35_1))
      return false;
    if (!(this.i35_1 == tmp0_other_with_cast.i35_1))
      return false;
    if (!(this.j35_1 === tmp0_other_with_cast.j35_1))
      return false;
    if (!(this.k35_1 == tmp0_other_with_cast.k35_1))
      return false;
    if (!(this.l35_1 == tmp0_other_with_cast.l35_1))
      return false;
    if (!equals(this.m35_1, tmp0_other_with_cast.m35_1))
      return false;
    return true;
  };
  function Companion_127() {
  }
  var Companion_instance_127;
  function Companion_getInstance_127() {
    return Companion_instance_127;
  }
  function $serializer_154() {
    $serializer_instance_153 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanDeletionResult', this, 2);
    tmp0_serialDesc.gy('plan', false);
    tmp0_serialDesc.gy('replayed', true);
    this.n35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_154).o35 = function (encoder, value) {
    var tmp0_desc = this.n35_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_36(), value.p35_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.q35_1 === false)) {
      tmp1_output.zr(tmp0_desc, 1, value.q35_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_154).on = function (encoder, value) {
    return this.o35(encoder, value instanceof PlanDeletionResult ? value : THROW_CCE());
  };
  protoOf($serializer_154).pn = function (decoder) {
    var tmp0_desc = this.n35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_36(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_36(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return PlanDeletionResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_154).nn = function () {
    return this.n35_1;
  };
  protoOf($serializer_154).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_36(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_153;
  function $serializer_getInstance_153() {
    if ($serializer_instance_153 == null)
      new $serializer_154();
    return $serializer_instance_153;
  }
  function PlanDeletionResult_init_$Init$(seen0, plan, replayed, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_153().n35_1);
    }
    $this.p35_1 = plan;
    if (0 === (seen0 & 2))
      $this.q35_1 = false;
    else
      $this.q35_1 = replayed;
    return $this;
  }
  function PlanDeletionResult_init_$Create$(seen0, plan, replayed, serializationConstructorMarker) {
    return PlanDeletionResult_init_$Init$(seen0, plan, replayed, serializationConstructorMarker, objectCreate(protoOf(PlanDeletionResult)));
  }
  function PlanDeletionResult(plan, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.p35_1 = plan;
    this.q35_1 = replayed;
  }
  protoOf(PlanDeletionResult).toString = function () {
    return 'PlanDeletionResult(plan=' + this.p35_1.toString() + ', replayed=' + this.q35_1 + ')';
  };
  protoOf(PlanDeletionResult).hashCode = function () {
    var result = this.p35_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.q35_1) | 0;
    return result;
  };
  protoOf(PlanDeletionResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanDeletionResult))
      return false;
    var tmp0_other_with_cast = other instanceof PlanDeletionResult ? other : THROW_CCE();
    if (!this.p35_1.equals(tmp0_other_with_cast.p35_1))
      return false;
    if (!(this.q35_1 === tmp0_other_with_cast.q35_1))
      return false;
    return true;
  };
  function Companion_128() {
  }
  var Companion_instance_128;
  function Companion_getInstance_128() {
    return Companion_instance_128;
  }
  function $serializer_155() {
    $serializer_instance_154 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.DeletePlanRequest', this, 1);
    tmp0_serialDesc.gy('expectedRevision', false);
    this.r35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_155).s35 = function (encoder, value) {
    var tmp0_desc = this.r35_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.t35_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_155).on = function (encoder, value) {
    return this.s35(encoder, value instanceof DeletePlanRequest ? value : THROW_CCE());
  };
  protoOf($serializer_155).pn = function (decoder) {
    var tmp0_desc = this.r35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return DeletePlanRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_155).nn = function () {
    return this.r35_1;
  };
  protoOf($serializer_155).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_154;
  function $serializer_getInstance_154() {
    if ($serializer_instance_154 == null)
      new $serializer_155();
    return $serializer_instance_154;
  }
  function DeletePlanRequest_init_$Init$(seen0, expectedRevision, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_154().r35_1);
    }
    $this.t35_1 = expectedRevision;
    return $this;
  }
  function DeletePlanRequest_init_$Create$(seen0, expectedRevision, serializationConstructorMarker) {
    return DeletePlanRequest_init_$Init$(seen0, expectedRevision, serializationConstructorMarker, objectCreate(protoOf(DeletePlanRequest)));
  }
  function DeletePlanRequest(expectedRevision) {
    this.t35_1 = expectedRevision;
  }
  protoOf(DeletePlanRequest).toString = function () {
    return 'DeletePlanRequest(expectedRevision=' + this.t35_1.toString() + ')';
  };
  protoOf(DeletePlanRequest).hashCode = function () {
    return this.t35_1.hashCode();
  };
  protoOf(DeletePlanRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DeletePlanRequest))
      return false;
    var tmp0_other_with_cast = other instanceof DeletePlanRequest ? other : THROW_CCE();
    if (!this.t35_1.equals(tmp0_other_with_cast.t35_1))
      return false;
    return true;
  };
  function FeatureSelectionProposal(features, modules, addedDependencies, removedDependants, blocked, removedModules) {
    addedDependencies = addedDependencies === VOID ? emptySet() : addedDependencies;
    removedDependants = removedDependants === VOID ? emptySet() : removedDependants;
    blocked = blocked === VOID ? emptySet() : blocked;
    removedModules = removedModules === VOID ? emptySet() : removedModules;
    this.u35_1 = features;
    this.v35_1 = modules;
    this.w35_1 = addedDependencies;
    this.x35_1 = removedDependants;
    this.y35_1 = blocked;
    this.z35_1 = removedModules;
  }
  protoOf(FeatureSelectionProposal).a36 = function (features, modules, addedDependencies, removedDependants, blocked, removedModules) {
    return new FeatureSelectionProposal(features, modules, addedDependencies, removedDependants, blocked, removedModules);
  };
  protoOf(FeatureSelectionProposal).b36 = function (features, modules, addedDependencies, removedDependants, blocked, removedModules, $super) {
    features = features === VOID ? this.u35_1 : features;
    modules = modules === VOID ? this.v35_1 : modules;
    addedDependencies = addedDependencies === VOID ? this.w35_1 : addedDependencies;
    removedDependants = removedDependants === VOID ? this.x35_1 : removedDependants;
    blocked = blocked === VOID ? this.y35_1 : blocked;
    removedModules = removedModules === VOID ? this.z35_1 : removedModules;
    return $super === VOID ? this.a36(features, modules, addedDependencies, removedDependants, blocked, removedModules) : $super.a36.call(this, features, modules, addedDependencies, removedDependants, blocked, removedModules);
  };
  protoOf(FeatureSelectionProposal).toString = function () {
    return 'FeatureSelectionProposal(features=' + toString(this.u35_1) + ', modules=' + toString(this.v35_1) + ', addedDependencies=' + toString(this.w35_1) + ', removedDependants=' + toString(this.x35_1) + ', blocked=' + toString(this.y35_1) + ', removedModules=' + toString(this.z35_1) + ')';
  };
  protoOf(FeatureSelectionProposal).hashCode = function () {
    var result = hashCode(this.u35_1);
    result = imul(result, 31) + hashCode(this.v35_1) | 0;
    result = imul(result, 31) + hashCode(this.w35_1) | 0;
    result = imul(result, 31) + hashCode(this.x35_1) | 0;
    result = imul(result, 31) + hashCode(this.y35_1) | 0;
    result = imul(result, 31) + hashCode(this.z35_1) | 0;
    return result;
  };
  protoOf(FeatureSelectionProposal).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FeatureSelectionProposal))
      return false;
    var tmp0_other_with_cast = other instanceof FeatureSelectionProposal ? other : THROW_CCE();
    if (!equals(this.u35_1, tmp0_other_with_cast.u35_1))
      return false;
    if (!equals(this.v35_1, tmp0_other_with_cast.v35_1))
      return false;
    if (!equals(this.w35_1, tmp0_other_with_cast.w35_1))
      return false;
    if (!equals(this.x35_1, tmp0_other_with_cast.x35_1))
      return false;
    if (!equals(this.y35_1, tmp0_other_with_cast.y35_1))
      return false;
    if (!equals(this.z35_1, tmp0_other_with_cast.z35_1))
      return false;
    return true;
  };
  function include$visit(additions, byKey, blocked, parents, key) {
    if (additions.r(key))
      return Unit_instance;
    var feature = byKey.b2(key);
    if ((feature == null ? null : feature.h2l_1) === 'CORE')
      return Unit_instance;
    if (feature == null || !feature.s2l_1) {
      // Inline function 'kotlin.collections.plusAssign' call
      blocked.e(key);
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.plusAssign' call
    additions.e(key);
    var tmp1_safe_receiver = feature.o2l_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      parents.e(tmp1_safe_receiver);
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = feature.p2l_1.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      include$visit(additions, byKey, blocked, parents, element);
    }
  }
  function includeModules$visit(visited, byKey, blocked, parents, key) {
    if (!visited.e(key))
      return Unit_instance;
    var module_0 = byKey.b2(key);
    if (module_0 == null) {
      // Inline function 'kotlin.collections.plusAssign' call
      blocked.e(key);
      return Unit_instance;
    }
    // Inline function 'kotlin.collections.plusAssign' call
    parents.e(key);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = module_0.e2m_1.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      includeModules$visit(visited, byKey, blocked, parents, element);
    }
  }
  function PlanFeatureSelection() {
  }
  protoOf(PlanFeatureSelection).c36 = function (registry, selected, modules) {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = registry.d20_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.isResolved.<anonymous>' call
      var tmp$ret$0 = element.z2l_1;
      destination.k2(tmp$ret$0, element);
    }
    var byModule = destination;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = registry.h20_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
    var tmp0_iterator_0 = this_1.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.isResolved.<anonymous>' call
      var tmp$ret$3 = element_0.g2l_1;
      destination_0.k2(tmp$ret$3, element_0);
    }
    var byFeature = destination_0;
    var tmp;
    var tmp$ret$6;
    $l$block_2: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(modules, Collection)) {
        tmp_0 = modules.k();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$6 = true;
        break $l$block_2;
      }
      var tmp0_iterator_1 = modules.g();
      while (tmp0_iterator_1.h()) {
        var element_1 = tmp0_iterator_1.i();
        // Inline function 'com.ems.console.api.PlanFeatureSelection.isResolved.<anonymous>' call
        var tmp0_safe_receiver = byModule.b2(element_1);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e2m_1;
        var tmp_1;
        if (tmp1_safe_receiver == null) {
          tmp_1 = null;
        } else {
          var tmp$ret$7;
          $l$block_1: {
            // Inline function 'kotlin.collections.all' call
            var tmp_2;
            if (isInterface(tmp1_safe_receiver, Collection)) {
              tmp_2 = tmp1_safe_receiver.k();
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp$ret$7 = true;
              break $l$block_1;
            }
            var tmp0_iterator_2 = tmp1_safe_receiver.g();
            while (tmp0_iterator_2.h()) {
              var element_2 = tmp0_iterator_2.i();
              // Inline function 'com.ems.console.api.PlanFeatureSelection.isResolved.<anonymous>.<anonymous>' call
              if (!modules.r(element_2)) {
                tmp$ret$7 = false;
                break $l$block_1;
              }
            }
            tmp$ret$7 = true;
          }
          tmp_1 = tmp$ret$7;
        }
        if (!(tmp_1 === true)) {
          tmp$ret$6 = false;
          break $l$block_2;
        }
      }
      tmp$ret$6 = true;
    }
    if (tmp$ret$6) {
      var tmp$ret$10;
      $l$block_6: {
        // Inline function 'kotlin.collections.all' call
        var tmp_3;
        if (isInterface(selected, Collection)) {
          tmp_3 = selected.k();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$10 = true;
          break $l$block_6;
        }
        var tmp0_iterator_3 = selected.g();
        while (tmp0_iterator_3.h()) {
          var element_3 = tmp0_iterator_3.i();
          // Inline function 'com.ems.console.api.PlanFeatureSelection.isResolved.<anonymous>' call
          var feature = byFeature.b2(element_3);
          var tmp_4;
          if (!(feature == null) && feature.s2l_1 && setOf(['MODULE', 'WORKSPACE']).r(feature.h2l_1) && (feature.o2l_1 == null || modules.r(feature.o2l_1))) {
            var tmp$ret$11;
            $l$block_5: {
              // Inline function 'kotlin.collections.all' call
              var this_2 = feature.p2l_1;
              var tmp_5;
              if (isInterface(this_2, Collection)) {
                tmp_5 = this_2.k();
              } else {
                tmp_5 = false;
              }
              if (tmp_5) {
                tmp$ret$11 = true;
                break $l$block_5;
              }
              var tmp0_iterator_4 = this_2.g();
              while (tmp0_iterator_4.h()) {
                var element_4 = tmp0_iterator_4.i();
                // Inline function 'com.ems.console.api.PlanFeatureSelection.isResolved.<anonymous>.<anonymous>' call
                var tmp_6;
                if (selected.r(element_4)) {
                  tmp_6 = true;
                } else {
                  var tmp0_safe_receiver_0 = byFeature.b2(element_4);
                  var tmp_7;
                  if (tmp0_safe_receiver_0 == null) {
                    tmp_7 = null;
                  } else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'com.ems.console.api.PlanFeatureSelection.isResolved.<anonymous>.<anonymous>.<anonymous>' call
                    tmp_7 = (tmp0_safe_receiver_0.h2l_1 === 'CORE' && tmp0_safe_receiver_0.r2l_1 === 'CORE');
                  }
                  tmp_6 = tmp_7 === true;
                }
                if (!tmp_6) {
                  tmp$ret$11 = false;
                  break $l$block_5;
                }
              }
              tmp$ret$11 = true;
            }
            tmp_4 = tmp$ret$11;
          } else {
            tmp_4 = false;
          }
          if (!tmp_4) {
            tmp$ret$10 = false;
            break $l$block_6;
          }
        }
        tmp$ret$10 = true;
      }
      tmp = tmp$ret$10;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(PlanFeatureSelection).d36 = function (registry, query) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.text.split' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = toString(trim(isCharSequence(query) ? query : THROW_CCE())).toLowerCase();
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = Regex_init_$Create$('\\s+').ae(this_0, 0);
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = this_1.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.search.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.e(element);
      }
    }
    var terms = destination;
    // Inline function 'kotlin.collections.associateBy' call
    var this_2 = registry.d20_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator_0 = this_2.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.search.<anonymous>' call
      var tmp$ret$8 = element_0.z2l_1;
      destination_0.k2(tmp$ret$8, element_0);
    }
    var modules = destination_0;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_3 = registry.h20_1;
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = this_3.g();
    while (tmp0_iterator_1.h()) {
      var element_1 = tmp0_iterator_1.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.search.<anonymous>' call
      // Inline function 'kotlin.collections.get' call
      var key = element_1.o2l_1;
      var module_0 = (isInterface(modules, KtMap) ? modules : THROW_CCE()).b2(key);
      // Inline function 'kotlin.text.lowercase' call
      var tmp = groupLabel(element_1, 'en');
      var tmp_0 = groupLabel(element_1, 'ar');
      // Inline function 'kotlin.text.orEmpty' call
      var tmp0_elvis_lhs = module_0 == null ? null : module_0.a2m_1;
      var tmp_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      // Inline function 'kotlin.text.orEmpty' call
      var tmp0_elvis_lhs_0 = module_0 == null ? null : module_0.b2m_1;
      var tmp$ret$13 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
      // Inline function 'kotlin.js.asDynamic' call
      var text = joinToString(listOf([element_1.k2l_1, element_1.l2l_1, element_1.m2l_1, element_1.n2l_1, tmp, tmp_0, tmp_1, tmp$ret$13]), ' ').toLowerCase();
      var tmp$ret$16;
      $l$block_0: {
        // Inline function 'kotlin.collections.all' call
        var tmp_2;
        if (isInterface(terms, Collection)) {
          tmp_2 = terms.k();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$16 = true;
          break $l$block_0;
        }
        var tmp0_iterator_2 = terms.g();
        while (tmp0_iterator_2.h()) {
          var element_2 = tmp0_iterator_2.i();
          // Inline function 'com.ems.console.api.PlanFeatureSelection.search.<anonymous>.<anonymous>' call
          if (!contains_0(text, element_2)) {
            tmp$ret$16 = false;
            break $l$block_0;
          }
        }
        tmp$ret$16 = true;
      }
      if (tmp$ret$16) {
        destination_1.e(element_1);
      }
    }
    return destination_1;
  };
  protoOf(PlanFeatureSelection).e36 = function (registry, selected, modules, keys) {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = registry.h20_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.include.<anonymous>' call
      var tmp$ret$0 = element.g2l_1;
      destination.k2(tmp$ret$0, element);
    }
    var byKey = destination;
    // Inline function 'kotlin.collections.mutableSetOf' call
    var additions = LinkedHashSet_init_$Create$();
    var parents = toMutableSet(modules);
    // Inline function 'kotlin.collections.mutableSetOf' call
    var blocked = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = keys.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      include$visit(additions, byKey, blocked, parents, element_0);
    }
    var moduleProposal = this.f36(registry, plus(selected, additions), modules, minus_0(parents, modules));
    return moduleProposal.b36(VOID, VOID, minus_0(minus_0(additions, selected), keys), VOID, plus(blocked, moduleProposal.y35_1));
  };
  protoOf(PlanFeatureSelection).f36 = function (registry, selected, modules, keys) {
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = registry.d20_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.includeModules.<anonymous>' call
      var tmp$ret$0 = element.z2l_1;
      destination.k2(tmp$ret$0, element);
    }
    var byKey = destination;
    var parents = toMutableSet(modules);
    // Inline function 'kotlin.collections.mutableSetOf' call
    var visited = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.collections.mutableSetOf' call
    var blocked = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = plus(modules, keys).g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      includeModules$visit(visited, byKey, blocked, parents, element_0);
    }
    return new FeatureSelectionProposal(selected, parents, VOID, VOID, blocked);
  };
  protoOf(PlanFeatureSelection).g36 = function (registry, selected, modules, keys) {
    var removed = toMutableSet(intersect(modules, keys));
    do {
      var count = removed.j();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = registry.d20_1;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'com.ems.console.api.PlanFeatureSelection.removeModules.<anonymous>' call
        var tmp;
        if (modules.r(element.z2l_1)) {
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var this_1 = element.e2m_1;
            var tmp_0;
            if (isInterface(this_1, Collection)) {
              tmp_0 = this_1.k();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var tmp0_iterator_0 = this_1.g();
            while (tmp0_iterator_0.h()) {
              var element_0 = tmp0_iterator_0.i();
              // Inline function 'com.ems.console.api.PlanFeatureSelection.removeModules.<anonymous>.<anonymous>' call
              if (removed.r(element_0)) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          tmp = tmp$ret$0;
        } else {
          tmp = false;
        }
        if (tmp) {
          destination.e(element);
        }
      }
      var tmp0_iterator_1 = destination.g();
      while (tmp0_iterator_1.h()) {
        var element_1 = tmp0_iterator_1.i();
        // Inline function 'com.ems.console.api.PlanFeatureSelection.removeModules.<anonymous>' call
        // Inline function 'kotlin.collections.plusAssign' call
        var element_2 = element_1.z2l_1;
        removed.e(element_2);
      }
    }
     while (!(count === removed.j()));
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = registry.h20_1;
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_2 = this_2.g();
    while (tmp0_iterator_2.h()) {
      var element_3 = tmp0_iterator_2.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.removeModules.<anonymous>' call
      if (selected.r(element_3.g2l_1) && contains_1(removed, element_3.o2l_1)) {
        destination_0.e(element_3);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination_0, 10));
    var tmp0_iterator_3 = destination_0.g();
    while (tmp0_iterator_3.h()) {
      var item = tmp0_iterator_3.i();
      // Inline function 'com.ems.console.api.PlanFeatureSelection.removeModules.<anonymous>' call
      var tmp$ret$8 = item.g2l_1;
      destination_1.e(tmp$ret$8);
    }
    var leaves = toSet(destination_1);
    var next = this.h36(registry, selected, minus_0(modules, removed), leaves);
    return next.b36(VOID, VOID, VOID, minus_0(selected, next.u35_1), VOID, removed);
  };
  protoOf(PlanFeatureSelection).h36 = function (registry, selected, modules, keys) {
    var removed = toMutableSet(intersect(selected, keys));
    do {
      var count = removed.j();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = registry.h20_1;
      var destination = ArrayList_init_$Create$();
      var tmp0_iterator = this_0.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'com.ems.console.api.PlanFeatureSelection.remove.<anonymous>' call
        var tmp;
        if (selected.r(element.g2l_1)) {
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var this_1 = element.p2l_1;
            var tmp_0;
            if (isInterface(this_1, Collection)) {
              tmp_0 = this_1.k();
            } else {
              tmp_0 = false;
            }
            if (tmp_0) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var tmp0_iterator_0 = this_1.g();
            while (tmp0_iterator_0.h()) {
              var element_0 = tmp0_iterator_0.i();
              // Inline function 'com.ems.console.api.PlanFeatureSelection.remove.<anonymous>.<anonymous>' call
              if (removed.r(element_0)) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          tmp = tmp$ret$0;
        } else {
          tmp = false;
        }
        if (tmp) {
          destination.e(element);
        }
      }
      var tmp0_iterator_1 = destination.g();
      while (tmp0_iterator_1.h()) {
        var element_1 = tmp0_iterator_1.i();
        // Inline function 'com.ems.console.api.PlanFeatureSelection.remove.<anonymous>' call
        // Inline function 'kotlin.collections.plusAssign' call
        var element_2 = element_1.g2l_1;
        removed.e(element_2);
      }
    }
     while (!(count === removed.j()));
    return new FeatureSelectionProposal(minus_0(selected, removed), modules, VOID, minus_0(removed, keys));
  };
  var PlanFeatureSelection_instance;
  function PlanFeatureSelection_getInstance() {
    return PlanFeatureSelection_instance;
  }
  function Companion_129() {
    Companion_instance_129 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i36_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_158()), null, null, null];
  }
  var Companion_instance_129;
  function Companion_getInstance_129() {
    if (Companion_instance_129 == null)
      new Companion_129();
    return Companion_instance_129;
  }
  function $serializer_156() {
    $serializer_instance_155 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanImpactPreview', this, 7);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('revision', false);
    tmp0_serialDesc.gy('generatedAtMs', false);
    tmp0_serialDesc.gy('tenants', false);
    tmp0_serialDesc.gy('reviewReceipt', true);
    tmp0_serialDesc.gy('navigationPreview', true);
    tmp0_serialDesc.gy('offerReadiness', true);
    this.j36_1 = tmp0_serialDesc;
  }
  protoOf($serializer_156).k36 = function (encoder, value) {
    var tmp0_desc = this.j36_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_129().i36_1;
    tmp1_output.hs(tmp0_desc, 0, value.l36_1);
    tmp1_output.ds(tmp0_desc, 1, value.m36_1);
    tmp1_output.ds(tmp0_desc, 2, value.n36_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.o36_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.p36_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.p36_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !value.q36_1.equals(new PlanNavigationPreview())) {
      tmp1_output.js(tmp0_desc, 5, $serializer_getInstance_157(), value.q36_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.r36_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, $serializer_getInstance_146(), value.r36_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_156).on = function (encoder, value) {
    return this.k36(encoder, value instanceof PlanImpactPreview ? value : THROW_CCE());
  };
  protoOf($serializer_156).pn = function (decoder) {
    var tmp0_desc = this.j36_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    var tmp12_cached = Companion_getInstance_129().i36_1;
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.fr(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.fr(tmp0_desc, 5, $serializer_getInstance_157(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, $serializer_getInstance_146(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.fr(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.fr(tmp0_desc, 5, $serializer_getInstance_157(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, $serializer_getInstance_146(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return PlanImpactPreview_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_156).nn = function () {
    return this.j36_1;
  };
  protoOf($serializer_156).vy = function () {
    var tmp0_cached = Companion_getInstance_129().i36_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[3], get_nullable(StringSerializer_getInstance()), $serializer_getInstance_157(), get_nullable($serializer_getInstance_146())];
  };
  var $serializer_instance_155;
  function $serializer_getInstance_155() {
    if ($serializer_instance_155 == null)
      new $serializer_156();
    return $serializer_instance_155;
  }
  function PlanImpactPreview_init_$Init$(seen0, planKey, revision, generatedAtMs, tenants, reviewReceipt, navigationPreview, offerReadiness, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_155().j36_1);
    }
    $this.l36_1 = planKey;
    $this.m36_1 = revision;
    $this.n36_1 = generatedAtMs;
    $this.o36_1 = tenants;
    if (0 === (seen0 & 16))
      $this.p36_1 = null;
    else
      $this.p36_1 = reviewReceipt;
    if (0 === (seen0 & 32))
      $this.q36_1 = new PlanNavigationPreview();
    else
      $this.q36_1 = navigationPreview;
    if (0 === (seen0 & 64))
      $this.r36_1 = null;
    else
      $this.r36_1 = offerReadiness;
    return $this;
  }
  function PlanImpactPreview_init_$Create$(seen0, planKey, revision, generatedAtMs, tenants, reviewReceipt, navigationPreview, offerReadiness, serializationConstructorMarker) {
    return PlanImpactPreview_init_$Init$(seen0, planKey, revision, generatedAtMs, tenants, reviewReceipt, navigationPreview, offerReadiness, serializationConstructorMarker, objectCreate(protoOf(PlanImpactPreview)));
  }
  function PlanImpactPreview(planKey, revision, generatedAtMs, tenants, reviewReceipt, navigationPreview, offerReadiness) {
    Companion_getInstance_129();
    reviewReceipt = reviewReceipt === VOID ? null : reviewReceipt;
    navigationPreview = navigationPreview === VOID ? new PlanNavigationPreview() : navigationPreview;
    offerReadiness = offerReadiness === VOID ? null : offerReadiness;
    this.l36_1 = planKey;
    this.m36_1 = revision;
    this.n36_1 = generatedAtMs;
    this.o36_1 = tenants;
    this.p36_1 = reviewReceipt;
    this.q36_1 = navigationPreview;
    this.r36_1 = offerReadiness;
  }
  protoOf(PlanImpactPreview).toString = function () {
    return 'PlanImpactPreview(planKey=' + this.l36_1 + ', revision=' + this.m36_1.toString() + ', generatedAtMs=' + this.n36_1.toString() + ', tenants=' + toString(this.o36_1) + ', reviewReceipt=' + this.p36_1 + ', navigationPreview=' + this.q36_1.toString() + ', offerReadiness=' + toString_0(this.r36_1) + ')';
  };
  protoOf(PlanImpactPreview).hashCode = function () {
    var result = getStringHashCode(this.l36_1);
    result = imul(result, 31) + this.m36_1.hashCode() | 0;
    result = imul(result, 31) + this.n36_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.o36_1) | 0;
    result = imul(result, 31) + (this.p36_1 == null ? 0 : getStringHashCode(this.p36_1)) | 0;
    result = imul(result, 31) + this.q36_1.hashCode() | 0;
    result = imul(result, 31) + (this.r36_1 == null ? 0 : this.r36_1.hashCode()) | 0;
    return result;
  };
  protoOf(PlanImpactPreview).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanImpactPreview))
      return false;
    var tmp0_other_with_cast = other instanceof PlanImpactPreview ? other : THROW_CCE();
    if (!(this.l36_1 === tmp0_other_with_cast.l36_1))
      return false;
    if (!this.m36_1.equals(tmp0_other_with_cast.m36_1))
      return false;
    if (!this.n36_1.equals(tmp0_other_with_cast.n36_1))
      return false;
    if (!equals(this.o36_1, tmp0_other_with_cast.o36_1))
      return false;
    if (!(this.p36_1 == tmp0_other_with_cast.p36_1))
      return false;
    if (!this.q36_1.equals(tmp0_other_with_cast.q36_1))
      return false;
    if (!equals(this.r36_1, tmp0_other_with_cast.r36_1))
      return false;
    return true;
  };
  function Companion_130() {
  }
  var Companion_instance_130;
  function Companion_getInstance_130() {
    return Companion_instance_130;
  }
  function $serializer_157() {
    $serializer_instance_156 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.ImpactLabel', this, 3);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    this.s36_1 = tmp0_serialDesc;
  }
  protoOf($serializer_157).t36 = function (encoder, value) {
    var tmp0_desc = this.s36_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.u36_1);
    tmp1_output.hs(tmp0_desc, 1, value.v36_1);
    tmp1_output.hs(tmp0_desc, 2, value.w36_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_157).on = function (encoder, value) {
    return this.t36(encoder, value instanceof ImpactLabel ? value : THROW_CCE());
  };
  protoOf($serializer_157).pn = function (decoder) {
    var tmp0_desc = this.s36_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return ImpactLabel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_157).nn = function () {
    return this.s36_1;
  };
  protoOf($serializer_157).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_156;
  function $serializer_getInstance_156() {
    if ($serializer_instance_156 == null)
      new $serializer_157();
    return $serializer_instance_156;
  }
  function ImpactLabel_init_$Init$(seen0, key, nameEn, nameAr, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_156().s36_1);
    }
    $this.u36_1 = key;
    $this.v36_1 = nameEn;
    $this.w36_1 = nameAr;
    return $this;
  }
  function ImpactLabel_init_$Create$(seen0, key, nameEn, nameAr, serializationConstructorMarker) {
    return ImpactLabel_init_$Init$(seen0, key, nameEn, nameAr, serializationConstructorMarker, objectCreate(protoOf(ImpactLabel)));
  }
  function ImpactLabel(key, nameEn, nameAr) {
    this.u36_1 = key;
    this.v36_1 = nameEn;
    this.w36_1 = nameAr;
  }
  protoOf(ImpactLabel).toString = function () {
    return 'ImpactLabel(key=' + this.u36_1 + ', nameEn=' + this.v36_1 + ', nameAr=' + this.w36_1 + ')';
  };
  protoOf(ImpactLabel).hashCode = function () {
    var result = getStringHashCode(this.u36_1);
    result = imul(result, 31) + getStringHashCode(this.v36_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w36_1) | 0;
    return result;
  };
  protoOf(ImpactLabel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ImpactLabel))
      return false;
    var tmp0_other_with_cast = other instanceof ImpactLabel ? other : THROW_CCE();
    if (!(this.u36_1 === tmp0_other_with_cast.u36_1))
      return false;
    if (!(this.v36_1 === tmp0_other_with_cast.v36_1))
      return false;
    if (!(this.w36_1 === tmp0_other_with_cast.w36_1))
      return false;
    return true;
  };
  function Companion_131() {
    Companion_instance_131 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x36_1 = [new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_159()), null];
  }
  var Companion_instance_131;
  function Companion_getInstance_131() {
    if (Companion_instance_131 == null)
      new Companion_131();
    return Companion_instance_131;
  }
  function $serializer_158() {
    $serializer_instance_157 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanNavigationPreview', this, 5);
    tmp0_serialDesc.gy('web', true);
    tmp0_serialDesc.gy('adminMobile', true);
    tmp0_serialDesc.gy('mcpGroups', true);
    tmp0_serialDesc.gy('issues', true);
    tmp0_serialDesc.gy('computed', true);
    this.y36_1 = tmp0_serialDesc;
  }
  protoOf($serializer_158).z36 = function (encoder, value) {
    var tmp0_desc = this.y36_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_131().x36_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !equals(value.a37_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.a37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !equals(value.b37_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.b37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !equals(value.c37_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.c37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !equals(value.d37_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.d37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.e37_1 === false)) {
      tmp1_output.zr(tmp0_desc, 4, value.e37_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_158).on = function (encoder, value) {
    return this.z36(encoder, value instanceof PlanNavigationPreview ? value : THROW_CCE());
  };
  protoOf($serializer_158).pn = function (decoder) {
    var tmp0_desc = this.y36_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.tq(tmp0_desc);
    var tmp10_cached = Companion_getInstance_131().x36_1;
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.fr(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.fr(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.fr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.fr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.fr(tmp0_desc, 0, tmp10_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.fr(tmp0_desc, 1, tmp10_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.fr(tmp0_desc, 2, tmp10_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.fr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return PlanNavigationPreview_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_158).nn = function () {
    return this.y36_1;
  };
  protoOf($serializer_158).vy = function () {
    var tmp0_cached = Companion_getInstance_131().x36_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], tmp0_cached[2], tmp0_cached[3], BooleanSerializer_getInstance()];
  };
  var $serializer_instance_157;
  function $serializer_getInstance_157() {
    if ($serializer_instance_157 == null)
      new $serializer_158();
    return $serializer_instance_157;
  }
  function PlanNavigationPreview_init_$Init$(seen0, web, adminMobile, mcpGroups, issues, computed, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_157().y36_1);
    }
    if (0 === (seen0 & 1))
      $this.a37_1 = emptyList();
    else
      $this.a37_1 = web;
    if (0 === (seen0 & 2))
      $this.b37_1 = emptyList();
    else
      $this.b37_1 = adminMobile;
    if (0 === (seen0 & 4))
      $this.c37_1 = emptyList();
    else
      $this.c37_1 = mcpGroups;
    if (0 === (seen0 & 8))
      $this.d37_1 = emptyList();
    else
      $this.d37_1 = issues;
    if (0 === (seen0 & 16))
      $this.e37_1 = false;
    else
      $this.e37_1 = computed;
    return $this;
  }
  function PlanNavigationPreview_init_$Create$(seen0, web, adminMobile, mcpGroups, issues, computed, serializationConstructorMarker) {
    return PlanNavigationPreview_init_$Init$(seen0, web, adminMobile, mcpGroups, issues, computed, serializationConstructorMarker, objectCreate(protoOf(PlanNavigationPreview)));
  }
  function PlanNavigationPreview(web, adminMobile, mcpGroups, issues, computed) {
    Companion_getInstance_131();
    web = web === VOID ? emptyList() : web;
    adminMobile = adminMobile === VOID ? emptyList() : adminMobile;
    mcpGroups = mcpGroups === VOID ? emptyList() : mcpGroups;
    issues = issues === VOID ? emptyList() : issues;
    computed = computed === VOID ? false : computed;
    this.a37_1 = web;
    this.b37_1 = adminMobile;
    this.c37_1 = mcpGroups;
    this.d37_1 = issues;
    this.e37_1 = computed;
  }
  protoOf(PlanNavigationPreview).toString = function () {
    return 'PlanNavigationPreview(web=' + toString(this.a37_1) + ', adminMobile=' + toString(this.b37_1) + ', mcpGroups=' + toString(this.c37_1) + ', issues=' + toString(this.d37_1) + ', computed=' + this.e37_1 + ')';
  };
  protoOf(PlanNavigationPreview).hashCode = function () {
    var result = hashCode(this.a37_1);
    result = imul(result, 31) + hashCode(this.b37_1) | 0;
    result = imul(result, 31) + hashCode(this.c37_1) | 0;
    result = imul(result, 31) + hashCode(this.d37_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e37_1) | 0;
    return result;
  };
  protoOf(PlanNavigationPreview).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanNavigationPreview))
      return false;
    var tmp0_other_with_cast = other instanceof PlanNavigationPreview ? other : THROW_CCE();
    if (!equals(this.a37_1, tmp0_other_with_cast.a37_1))
      return false;
    if (!equals(this.b37_1, tmp0_other_with_cast.b37_1))
      return false;
    if (!equals(this.c37_1, tmp0_other_with_cast.c37_1))
      return false;
    if (!equals(this.d37_1, tmp0_other_with_cast.d37_1))
      return false;
    if (!(this.e37_1 === tmp0_other_with_cast.e37_1))
      return false;
    return true;
  };
  function Companion_132() {
    Companion_instance_132 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g37_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_163()), null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_160()), new ArrayListSerializer($serializer_getInstance_160()), new ArrayListSerializer($serializer_getInstance_161()), Companion_getInstance_135().w19(), new ArrayListSerializer($serializer_getInstance_162()), null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_132;
  function Companion_getInstance_132() {
    if (Companion_instance_132 == null)
      new Companion_132();
    return Companion_instance_132;
  }
  function $serializer_159() {
    $serializer_instance_158 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantPlanImpact', this, 23);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('slug', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('gainedModules', false);
    tmp0_serialDesc.gy('lostModules', false);
    tmp0_serialDesc.gy('gainedFeatures', false);
    tmp0_serialDesc.gy('lostFeatures', false);
    tmp0_serialDesc.gy('keptByFeatureException', false);
    tmp0_serialDesc.gy('limits', false);
    tmp0_serialDesc.gy('accessVersion', true);
    tmp0_serialDesc.gy('navigationBefore', true);
    tmp0_serialDesc.gy('navigationAfter', true);
    tmp0_serialDesc.gy('gainedNavigation', true);
    tmp0_serialDesc.gy('lostNavigation', true);
    tmp0_serialDesc.gy('keptNavigationByException', true);
    tmp0_serialDesc.gy('usageImpact', true);
    tmp0_serialDesc.gy('limitsOverUsage', true);
    tmp0_serialDesc.gy('pausedWork', true);
    tmp0_serialDesc.gy('pausedWorkEvidence', true);
    tmp0_serialDesc.gy('workImpact', true);
    tmp0_serialDesc.gy('workInventoryComplete', true);
    tmp0_serialDesc.gy('workIssues', true);
    this.h37_1 = tmp0_serialDesc;
  }
  protoOf($serializer_159).i37 = function (encoder, value) {
    var tmp0_desc = this.h37_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_132().g37_1;
    tmp1_output.hs(tmp0_desc, 0, value.j37_1);
    tmp1_output.hs(tmp0_desc, 1, value.k37_1);
    tmp1_output.hs(tmp0_desc, 2, value.l37_1);
    tmp1_output.hs(tmp0_desc, 3, value.m37_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.n37_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.o37_1);
    tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.p37_1);
    tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.q37_1);
    tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.r37_1);
    tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.s37_1);
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.t37_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, LongSerializer_getInstance(), value.t37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !value.u37_1.equals(new PlanNavigationPreview())) {
      tmp1_output.js(tmp0_desc, 11, $serializer_getInstance_157(), value.u37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !value.v37_1.equals(new PlanNavigationPreview())) {
      tmp1_output.js(tmp0_desc, 12, $serializer_getInstance_157(), value.v37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !value.w37_1.equals(new PlanNavigationPreview())) {
      tmp1_output.js(tmp0_desc, 13, $serializer_getInstance_157(), value.w37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !value.x37_1.equals(new PlanNavigationPreview())) {
      tmp1_output.js(tmp0_desc, 14, $serializer_getInstance_157(), value.x37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 15) ? true : !value.y37_1.equals(new PlanNavigationPreview())) {
      tmp1_output.js(tmp0_desc, 15, $serializer_getInstance_157(), value.y37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 16) ? true : !equals(value.z37_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 16, tmp2_cached[16], value.z37_1);
    }
    if (tmp1_output.ps(tmp0_desc, 17) ? true : !equals(value.a38_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 17, tmp2_cached[17], value.a38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 18) ? true : !equals(value.b38_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 18, tmp2_cached[18], value.b38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 19) ? true : !value.c38_1.equals(PlanWorkEvidence_UNKNOWN_getInstance())) {
      tmp1_output.js(tmp0_desc, 19, tmp2_cached[19], value.c38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 20) ? true : !equals(value.d38_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 20, tmp2_cached[20], value.d38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 21) ? true : !(value.e38_1 === false)) {
      tmp1_output.zr(tmp0_desc, 21, value.e38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 22) ? true : !equals(value.f38_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 22, tmp2_cached[22], value.f38_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_159).on = function (encoder, value) {
    return this.i37(encoder, value instanceof TenantPlanImpact ? value : THROW_CCE());
  };
  protoOf($serializer_159).pn = function (decoder) {
    var tmp0_desc = this.h37_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = null;
    var tmp21_local17 = null;
    var tmp22_local18 = null;
    var tmp23_local19 = null;
    var tmp24_local20 = null;
    var tmp25_local21 = false;
    var tmp26_local22 = null;
    var tmp27_input = decoder.tq(tmp0_desc);
    var tmp28_cached = Companion_getInstance_132().g37_1;
    if (tmp27_input.ir()) {
      tmp4_local0 = tmp27_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp27_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp27_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp27_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp27_input.fr(tmp0_desc, 4, tmp28_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp27_input.fr(tmp0_desc, 5, tmp28_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp27_input.fr(tmp0_desc, 6, tmp28_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp27_input.fr(tmp0_desc, 7, tmp28_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp27_input.fr(tmp0_desc, 8, tmp28_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp27_input.fr(tmp0_desc, 9, tmp28_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp27_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp27_input.fr(tmp0_desc, 11, $serializer_getInstance_157(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp27_input.fr(tmp0_desc, 12, $serializer_getInstance_157(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp27_input.fr(tmp0_desc, 13, $serializer_getInstance_157(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp27_input.fr(tmp0_desc, 14, $serializer_getInstance_157(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp27_input.fr(tmp0_desc, 15, $serializer_getInstance_157(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp27_input.fr(tmp0_desc, 16, tmp28_cached[16], tmp20_local16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp27_input.fr(tmp0_desc, 17, tmp28_cached[17], tmp21_local17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
      tmp22_local18 = tmp27_input.fr(tmp0_desc, 18, tmp28_cached[18], tmp22_local18);
      tmp3_bitMask0 = tmp3_bitMask0 | 262144;
      tmp23_local19 = tmp27_input.fr(tmp0_desc, 19, tmp28_cached[19], tmp23_local19);
      tmp3_bitMask0 = tmp3_bitMask0 | 524288;
      tmp24_local20 = tmp27_input.fr(tmp0_desc, 20, tmp28_cached[20], tmp24_local20);
      tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
      tmp25_local21 = tmp27_input.vq(tmp0_desc, 21);
      tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
      tmp26_local22 = tmp27_input.fr(tmp0_desc, 22, tmp28_cached[22], tmp26_local22);
      tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp27_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp27_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp27_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp27_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp27_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp27_input.fr(tmp0_desc, 4, tmp28_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp27_input.fr(tmp0_desc, 5, tmp28_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp27_input.fr(tmp0_desc, 6, tmp28_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp27_input.fr(tmp0_desc, 7, tmp28_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp27_input.fr(tmp0_desc, 8, tmp28_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp27_input.fr(tmp0_desc, 9, tmp28_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp27_input.hr(tmp0_desc, 10, LongSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp27_input.fr(tmp0_desc, 11, $serializer_getInstance_157(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp27_input.fr(tmp0_desc, 12, $serializer_getInstance_157(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp27_input.fr(tmp0_desc, 13, $serializer_getInstance_157(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp27_input.fr(tmp0_desc, 14, $serializer_getInstance_157(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp27_input.fr(tmp0_desc, 15, $serializer_getInstance_157(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp27_input.fr(tmp0_desc, 16, tmp28_cached[16], tmp20_local16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp27_input.fr(tmp0_desc, 17, tmp28_cached[17], tmp21_local17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          case 18:
            tmp22_local18 = tmp27_input.fr(tmp0_desc, 18, tmp28_cached[18], tmp22_local18);
            tmp3_bitMask0 = tmp3_bitMask0 | 262144;
            break;
          case 19:
            tmp23_local19 = tmp27_input.fr(tmp0_desc, 19, tmp28_cached[19], tmp23_local19);
            tmp3_bitMask0 = tmp3_bitMask0 | 524288;
            break;
          case 20:
            tmp24_local20 = tmp27_input.fr(tmp0_desc, 20, tmp28_cached[20], tmp24_local20);
            tmp3_bitMask0 = tmp3_bitMask0 | 1048576;
            break;
          case 21:
            tmp25_local21 = tmp27_input.vq(tmp0_desc, 21);
            tmp3_bitMask0 = tmp3_bitMask0 | 2097152;
            break;
          case 22:
            tmp26_local22 = tmp27_input.fr(tmp0_desc, 22, tmp28_cached[22], tmp26_local22);
            tmp3_bitMask0 = tmp3_bitMask0 | 4194304;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp27_input.uq(tmp0_desc);
    return TenantPlanImpact_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, tmp22_local18, tmp23_local19, tmp24_local20, tmp25_local21, tmp26_local22, null);
  };
  protoOf($serializer_159).nn = function () {
    return this.h37_1;
  };
  protoOf($serializer_159).vy = function () {
    var tmp0_cached = Companion_getInstance_132().g37_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4], tmp0_cached[5], tmp0_cached[6], tmp0_cached[7], tmp0_cached[8], tmp0_cached[9], get_nullable(LongSerializer_getInstance()), $serializer_getInstance_157(), $serializer_getInstance_157(), $serializer_getInstance_157(), $serializer_getInstance_157(), $serializer_getInstance_157(), tmp0_cached[16], tmp0_cached[17], tmp0_cached[18], tmp0_cached[19], tmp0_cached[20], BooleanSerializer_getInstance(), tmp0_cached[22]];
  };
  var $serializer_instance_158;
  function $serializer_getInstance_158() {
    if ($serializer_instance_158 == null)
      new $serializer_159();
    return $serializer_instance_158;
  }
  function TenantPlanImpact_init_$Init$(seen0, tenantId, slug, nameEn, nameAr, gainedModules, lostModules, gainedFeatures, lostFeatures, keptByFeatureException, limits, accessVersion, navigationBefore, navigationAfter, gainedNavigation, lostNavigation, keptNavigationByException, usageImpact, limitsOverUsage, pausedWork, pausedWorkEvidence, workImpact, workInventoryComplete, workIssues, serializationConstructorMarker, $this) {
    if (!(1023 === (1023 & seen0))) {
      throwMissingFieldException(seen0, 1023, $serializer_getInstance_158().h37_1);
    }
    $this.j37_1 = tenantId;
    $this.k37_1 = slug;
    $this.l37_1 = nameEn;
    $this.m37_1 = nameAr;
    $this.n37_1 = gainedModules;
    $this.o37_1 = lostModules;
    $this.p37_1 = gainedFeatures;
    $this.q37_1 = lostFeatures;
    $this.r37_1 = keptByFeatureException;
    $this.s37_1 = limits;
    if (0 === (seen0 & 1024))
      $this.t37_1 = null;
    else
      $this.t37_1 = accessVersion;
    if (0 === (seen0 & 2048))
      $this.u37_1 = new PlanNavigationPreview();
    else
      $this.u37_1 = navigationBefore;
    if (0 === (seen0 & 4096))
      $this.v37_1 = new PlanNavigationPreview();
    else
      $this.v37_1 = navigationAfter;
    if (0 === (seen0 & 8192))
      $this.w37_1 = new PlanNavigationPreview();
    else
      $this.w37_1 = gainedNavigation;
    if (0 === (seen0 & 16384))
      $this.x37_1 = new PlanNavigationPreview();
    else
      $this.x37_1 = lostNavigation;
    if (0 === (seen0 & 32768))
      $this.y37_1 = new PlanNavigationPreview();
    else
      $this.y37_1 = keptNavigationByException;
    if (0 === (seen0 & 65536))
      $this.z37_1 = emptyList();
    else
      $this.z37_1 = usageImpact;
    if (0 === (seen0 & 131072))
      $this.a38_1 = emptyList();
    else
      $this.a38_1 = limitsOverUsage;
    if (0 === (seen0 & 262144))
      $this.b38_1 = emptyList();
    else
      $this.b38_1 = pausedWork;
    if (0 === (seen0 & 524288))
      $this.c38_1 = PlanWorkEvidence_UNKNOWN_getInstance();
    else
      $this.c38_1 = pausedWorkEvidence;
    if (0 === (seen0 & 1048576))
      $this.d38_1 = emptyList();
    else
      $this.d38_1 = workImpact;
    if (0 === (seen0 & 2097152))
      $this.e38_1 = false;
    else
      $this.e38_1 = workInventoryComplete;
    if (0 === (seen0 & 4194304))
      $this.f38_1 = emptyList();
    else
      $this.f38_1 = workIssues;
    return $this;
  }
  function TenantPlanImpact_init_$Create$(seen0, tenantId, slug, nameEn, nameAr, gainedModules, lostModules, gainedFeatures, lostFeatures, keptByFeatureException, limits, accessVersion, navigationBefore, navigationAfter, gainedNavigation, lostNavigation, keptNavigationByException, usageImpact, limitsOverUsage, pausedWork, pausedWorkEvidence, workImpact, workInventoryComplete, workIssues, serializationConstructorMarker) {
    return TenantPlanImpact_init_$Init$(seen0, tenantId, slug, nameEn, nameAr, gainedModules, lostModules, gainedFeatures, lostFeatures, keptByFeatureException, limits, accessVersion, navigationBefore, navigationAfter, gainedNavigation, lostNavigation, keptNavigationByException, usageImpact, limitsOverUsage, pausedWork, pausedWorkEvidence, workImpact, workInventoryComplete, workIssues, serializationConstructorMarker, objectCreate(protoOf(TenantPlanImpact)));
  }
  function TenantPlanImpact() {
  }
  protoOf(TenantPlanImpact).toString = function () {
    return 'TenantPlanImpact(tenantId=' + this.j37_1 + ', slug=' + this.k37_1 + ', nameEn=' + this.l37_1 + ', nameAr=' + this.m37_1 + ', gainedModules=' + toString(this.n37_1) + ', lostModules=' + toString(this.o37_1) + ', gainedFeatures=' + toString(this.p37_1) + ', lostFeatures=' + toString(this.q37_1) + ', keptByFeatureException=' + toString(this.r37_1) + ', limits=' + toString(this.s37_1) + ', accessVersion=' + toString_0(this.t37_1) + ', navigationBefore=' + this.u37_1.toString() + ', navigationAfter=' + this.v37_1.toString() + ', gainedNavigation=' + this.w37_1.toString() + ', lostNavigation=' + this.x37_1.toString() + ', keptNavigationByException=' + this.y37_1.toString() + ', usageImpact=' + toString(this.z37_1) + ', limitsOverUsage=' + toString(this.a38_1) + ', pausedWork=' + toString(this.b38_1) + ', pausedWorkEvidence=' + this.c38_1.toString() + ', workImpact=' + toString(this.d38_1) + ', workInventoryComplete=' + this.e38_1 + ', workIssues=' + toString(this.f38_1) + ')';
  };
  protoOf(TenantPlanImpact).hashCode = function () {
    var result = getStringHashCode(this.j37_1);
    result = imul(result, 31) + getStringHashCode(this.k37_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l37_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m37_1) | 0;
    result = imul(result, 31) + hashCode(this.n37_1) | 0;
    result = imul(result, 31) + hashCode(this.o37_1) | 0;
    result = imul(result, 31) + hashCode(this.p37_1) | 0;
    result = imul(result, 31) + hashCode(this.q37_1) | 0;
    result = imul(result, 31) + hashCode(this.r37_1) | 0;
    result = imul(result, 31) + hashCode(this.s37_1) | 0;
    result = imul(result, 31) + (this.t37_1 == null ? 0 : this.t37_1.hashCode()) | 0;
    result = imul(result, 31) + this.u37_1.hashCode() | 0;
    result = imul(result, 31) + this.v37_1.hashCode() | 0;
    result = imul(result, 31) + this.w37_1.hashCode() | 0;
    result = imul(result, 31) + this.x37_1.hashCode() | 0;
    result = imul(result, 31) + this.y37_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.z37_1) | 0;
    result = imul(result, 31) + hashCode(this.a38_1) | 0;
    result = imul(result, 31) + hashCode(this.b38_1) | 0;
    result = imul(result, 31) + this.c38_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.d38_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e38_1) | 0;
    result = imul(result, 31) + hashCode(this.f38_1) | 0;
    return result;
  };
  protoOf(TenantPlanImpact).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantPlanImpact))
      return false;
    var tmp0_other_with_cast = other instanceof TenantPlanImpact ? other : THROW_CCE();
    if (!(this.j37_1 === tmp0_other_with_cast.j37_1))
      return false;
    if (!(this.k37_1 === tmp0_other_with_cast.k37_1))
      return false;
    if (!(this.l37_1 === tmp0_other_with_cast.l37_1))
      return false;
    if (!(this.m37_1 === tmp0_other_with_cast.m37_1))
      return false;
    if (!equals(this.n37_1, tmp0_other_with_cast.n37_1))
      return false;
    if (!equals(this.o37_1, tmp0_other_with_cast.o37_1))
      return false;
    if (!equals(this.p37_1, tmp0_other_with_cast.p37_1))
      return false;
    if (!equals(this.q37_1, tmp0_other_with_cast.q37_1))
      return false;
    if (!equals(this.r37_1, tmp0_other_with_cast.r37_1))
      return false;
    if (!equals(this.s37_1, tmp0_other_with_cast.s37_1))
      return false;
    if (!equals(this.t37_1, tmp0_other_with_cast.t37_1))
      return false;
    if (!this.u37_1.equals(tmp0_other_with_cast.u37_1))
      return false;
    if (!this.v37_1.equals(tmp0_other_with_cast.v37_1))
      return false;
    if (!this.w37_1.equals(tmp0_other_with_cast.w37_1))
      return false;
    if (!this.x37_1.equals(tmp0_other_with_cast.x37_1))
      return false;
    if (!this.y37_1.equals(tmp0_other_with_cast.y37_1))
      return false;
    if (!equals(this.z37_1, tmp0_other_with_cast.z37_1))
      return false;
    if (!equals(this.a38_1, tmp0_other_with_cast.a38_1))
      return false;
    if (!equals(this.b38_1, tmp0_other_with_cast.b38_1))
      return false;
    if (!this.c38_1.equals(tmp0_other_with_cast.c38_1))
      return false;
    if (!equals(this.d38_1, tmp0_other_with_cast.d38_1))
      return false;
    if (!(this.e38_1 === tmp0_other_with_cast.e38_1))
      return false;
    if (!equals(this.f38_1, tmp0_other_with_cast.f38_1))
      return false;
    return true;
  };
  function $serializer_160() {
    $serializer_instance_159 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanNavigationIssue', this, 5);
    tmp0_serialDesc.gy('surface', false);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('code', false);
    this.g38_1 = tmp0_serialDesc;
  }
  protoOf($serializer_160).h38 = function (encoder, value) {
    var tmp0_desc = this.g38_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.i38_1);
    tmp1_output.hs(tmp0_desc, 1, value.j38_1);
    tmp1_output.hs(tmp0_desc, 2, value.k38_1);
    tmp1_output.hs(tmp0_desc, 3, value.l38_1);
    tmp1_output.hs(tmp0_desc, 4, value.m38_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_160).on = function (encoder, value) {
    return this.h38(encoder, value instanceof PlanNavigationIssue ? value : THROW_CCE());
  };
  protoOf($serializer_160).pn = function (decoder) {
    var tmp0_desc = this.g38_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return PlanNavigationIssue_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_160).nn = function () {
    return this.g38_1;
  };
  protoOf($serializer_160).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_159;
  function $serializer_getInstance_159() {
    if ($serializer_instance_159 == null)
      new $serializer_160();
    return $serializer_instance_159;
  }
  function PlanNavigationIssue_init_$Init$(seen0, surface, key, nameEn, nameAr, code, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_159().g38_1);
    }
    $this.i38_1 = surface;
    $this.j38_1 = key;
    $this.k38_1 = nameEn;
    $this.l38_1 = nameAr;
    $this.m38_1 = code;
    return $this;
  }
  function PlanNavigationIssue_init_$Create$(seen0, surface, key, nameEn, nameAr, code, serializationConstructorMarker) {
    return PlanNavigationIssue_init_$Init$(seen0, surface, key, nameEn, nameAr, code, serializationConstructorMarker, objectCreate(protoOf(PlanNavigationIssue)));
  }
  function PlanNavigationIssue() {
  }
  protoOf(PlanNavigationIssue).toString = function () {
    return 'PlanNavigationIssue(surface=' + this.i38_1 + ', key=' + this.j38_1 + ', nameEn=' + this.k38_1 + ', nameAr=' + this.l38_1 + ', code=' + this.m38_1 + ')';
  };
  protoOf(PlanNavigationIssue).hashCode = function () {
    var result = getStringHashCode(this.i38_1);
    result = imul(result, 31) + getStringHashCode(this.j38_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k38_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l38_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m38_1) | 0;
    return result;
  };
  protoOf(PlanNavigationIssue).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanNavigationIssue))
      return false;
    var tmp0_other_with_cast = other instanceof PlanNavigationIssue ? other : THROW_CCE();
    if (!(this.i38_1 === tmp0_other_with_cast.i38_1))
      return false;
    if (!(this.j38_1 === tmp0_other_with_cast.j38_1))
      return false;
    if (!(this.k38_1 === tmp0_other_with_cast.k38_1))
      return false;
    if (!(this.l38_1 === tmp0_other_with_cast.l38_1))
      return false;
    if (!(this.m38_1 === tmp0_other_with_cast.m38_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_6($this) {
    return $this.n38_1.w();
  }
  function PlanUsageEvidence$Companion$_anonymous__5ex7xc() {
    return createSimpleEnumSerializer('com.ems.console.api.PlanUsageEvidence', values_6());
  }
  var PlanUsageEvidence_UNKNOWN_instance;
  var PlanUsageEvidence_HISTORICAL_ROLLUP_instance;
  var PlanUsageEvidence_LIVE_COUNT_UNAVAILABLE_instance;
  var PlanUsageEvidence_LIVE_COUNT_instance;
  var PlanUsageEvidence_CURRENT_COUNTER_instance;
  function values_6() {
    return [PlanUsageEvidence_UNKNOWN_getInstance(), PlanUsageEvidence_HISTORICAL_ROLLUP_getInstance(), PlanUsageEvidence_LIVE_COUNT_UNAVAILABLE_getInstance(), PlanUsageEvidence_LIVE_COUNT_getInstance(), PlanUsageEvidence_CURRENT_COUNTER_getInstance()];
  }
  function Companion_133() {
    Companion_instance_133 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.n38_1 = lazy(tmp_0, PlanUsageEvidence$Companion$_anonymous__5ex7xc);
  }
  protoOf(Companion_133).w19 = function () {
    return _get_$cachedSerializer__te6jhj_6(this);
  };
  protoOf(Companion_133).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_133;
  function Companion_getInstance_133() {
    PlanUsageEvidence_initEntries();
    if (Companion_instance_133 == null)
      new Companion_133();
    return Companion_instance_133;
  }
  var PlanUsageEvidence_entriesInitialized;
  function PlanUsageEvidence_initEntries() {
    if (PlanUsageEvidence_entriesInitialized)
      return Unit_instance;
    PlanUsageEvidence_entriesInitialized = true;
    PlanUsageEvidence_UNKNOWN_instance = new PlanUsageEvidence('UNKNOWN', 0);
    PlanUsageEvidence_HISTORICAL_ROLLUP_instance = new PlanUsageEvidence('HISTORICAL_ROLLUP', 1);
    PlanUsageEvidence_LIVE_COUNT_UNAVAILABLE_instance = new PlanUsageEvidence('LIVE_COUNT_UNAVAILABLE', 2);
    PlanUsageEvidence_LIVE_COUNT_instance = new PlanUsageEvidence('LIVE_COUNT', 3);
    PlanUsageEvidence_CURRENT_COUNTER_instance = new PlanUsageEvidence('CURRENT_COUNTER', 4);
    Companion_getInstance_133();
  }
  function PlanUsageEvidence(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_134() {
    Companion_instance_134 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o38_1 = [null, null, null, Companion_getInstance_133().w19(), null, null, null, null, null, null, null, null, null];
  }
  var Companion_instance_134;
  function Companion_getInstance_134() {
    if (Companion_instance_134 == null)
      new Companion_134();
    return Companion_instance_134;
  }
  function $serializer_161() {
    $serializer_instance_160 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanLimitUsageImpact', this, 13);
    tmp0_serialDesc.gy('limit', false);
    tmp0_serialDesc.gy('afterValue', false);
    tmp0_serialDesc.gy('afterPolicy', false);
    tmp0_serialDesc.gy('evidence', true);
    tmp0_serialDesc.gy('periodStart', true);
    tmp0_serialDesc.gy('collectedAtMs', true);
    tmp0_serialDesc.gy('counterUpdatedAtMs', true);
    tmp0_serialDesc.gy('used', true);
    tmp0_serialDesc.gy('reserved', true);
    tmp0_serialDesc.gy('observedOverAllowance', true);
    tmp0_serialDesc.gy('reason', true);
    tmp0_serialDesc.gy('usageCalendarZone', true);
    tmp0_serialDesc.gy('usageCalendarDate', true);
    this.p38_1 = tmp0_serialDesc;
  }
  protoOf($serializer_161).q38 = function (encoder, value) {
    var tmp0_desc = this.p38_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_134().o38_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_156(), value.r38_1);
    tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.s38_1);
    tmp1_output.hs(tmp0_desc, 2, value.t38_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !value.u38_1.equals(PlanUsageEvidence_UNKNOWN_getInstance())) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.u38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.v38_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.v38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.w38_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.w38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.x38_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.x38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.y38_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.y38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.z38_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, LongSerializer_getInstance(), value.z38_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.a39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, BooleanSerializer_getInstance(), value.a39_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.b39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.b39_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.c39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, StringSerializer_getInstance(), value.c39_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.d39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 12, StringSerializer_getInstance(), value.d39_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_161).on = function (encoder, value) {
    return this.q38(encoder, value instanceof PlanLimitUsageImpact ? value : THROW_CCE());
  };
  protoOf($serializer_161).pn = function (decoder) {
    var tmp0_desc = this.p38_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.tq(tmp0_desc);
    var tmp18_cached = Companion_getInstance_134().o38_1;
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.fr(tmp0_desc, 3, tmp18_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.hr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.fr(tmp0_desc, 3, tmp18_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.hr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.hr(tmp0_desc, 12, StringSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return PlanLimitUsageImpact_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_161).nn = function () {
    return this.p38_1;
  };
  protoOf($serializer_161).vy = function () {
    var tmp0_cached = Companion_getInstance_134().o38_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_156(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), tmp0_cached[3], get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_160;
  function $serializer_getInstance_160() {
    if ($serializer_instance_160 == null)
      new $serializer_161();
    return $serializer_instance_160;
  }
  function PlanLimitUsageImpact_init_$Init$(seen0, limit, afterValue, afterPolicy, evidence, periodStart, collectedAtMs, counterUpdatedAtMs, used, reserved, observedOverAllowance, reason, usageCalendarZone, usageCalendarDate, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_160().p38_1);
    }
    $this.r38_1 = limit;
    $this.s38_1 = afterValue;
    $this.t38_1 = afterPolicy;
    if (0 === (seen0 & 8))
      $this.u38_1 = PlanUsageEvidence_UNKNOWN_getInstance();
    else
      $this.u38_1 = evidence;
    if (0 === (seen0 & 16))
      $this.v38_1 = null;
    else
      $this.v38_1 = periodStart;
    if (0 === (seen0 & 32))
      $this.w38_1 = null;
    else
      $this.w38_1 = collectedAtMs;
    if (0 === (seen0 & 64))
      $this.x38_1 = null;
    else
      $this.x38_1 = counterUpdatedAtMs;
    if (0 === (seen0 & 128))
      $this.y38_1 = null;
    else
      $this.y38_1 = used;
    if (0 === (seen0 & 256))
      $this.z38_1 = null;
    else
      $this.z38_1 = reserved;
    if (0 === (seen0 & 512))
      $this.a39_1 = null;
    else
      $this.a39_1 = observedOverAllowance;
    if (0 === (seen0 & 1024))
      $this.b39_1 = null;
    else
      $this.b39_1 = reason;
    if (0 === (seen0 & 2048))
      $this.c39_1 = null;
    else
      $this.c39_1 = usageCalendarZone;
    if (0 === (seen0 & 4096))
      $this.d39_1 = null;
    else
      $this.d39_1 = usageCalendarDate;
    return $this;
  }
  function PlanLimitUsageImpact_init_$Create$(seen0, limit, afterValue, afterPolicy, evidence, periodStart, collectedAtMs, counterUpdatedAtMs, used, reserved, observedOverAllowance, reason, usageCalendarZone, usageCalendarDate, serializationConstructorMarker) {
    return PlanLimitUsageImpact_init_$Init$(seen0, limit, afterValue, afterPolicy, evidence, periodStart, collectedAtMs, counterUpdatedAtMs, used, reserved, observedOverAllowance, reason, usageCalendarZone, usageCalendarDate, serializationConstructorMarker, objectCreate(protoOf(PlanLimitUsageImpact)));
  }
  function PlanLimitUsageImpact() {
  }
  protoOf(PlanLimitUsageImpact).toString = function () {
    return 'PlanLimitUsageImpact(limit=' + this.r38_1.toString() + ', afterValue=' + toString_0(this.s38_1) + ', afterPolicy=' + this.t38_1 + ', evidence=' + this.u38_1.toString() + ', periodStart=' + this.v38_1 + ', collectedAtMs=' + toString_0(this.w38_1) + ', counterUpdatedAtMs=' + toString_0(this.x38_1) + ', used=' + toString_0(this.y38_1) + ', reserved=' + toString_0(this.z38_1) + ', observedOverAllowance=' + this.a39_1 + ', reason=' + this.b39_1 + ', usageCalendarZone=' + this.c39_1 + ', usageCalendarDate=' + this.d39_1 + ')';
  };
  protoOf(PlanLimitUsageImpact).hashCode = function () {
    var result = this.r38_1.hashCode();
    result = imul(result, 31) + (this.s38_1 == null ? 0 : this.s38_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.t38_1) | 0;
    result = imul(result, 31) + this.u38_1.hashCode() | 0;
    result = imul(result, 31) + (this.v38_1 == null ? 0 : getStringHashCode(this.v38_1)) | 0;
    result = imul(result, 31) + (this.w38_1 == null ? 0 : this.w38_1.hashCode()) | 0;
    result = imul(result, 31) + (this.x38_1 == null ? 0 : this.x38_1.hashCode()) | 0;
    result = imul(result, 31) + (this.y38_1 == null ? 0 : this.y38_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z38_1 == null ? 0 : this.z38_1.hashCode()) | 0;
    result = imul(result, 31) + (this.a39_1 == null ? 0 : getBooleanHashCode(this.a39_1)) | 0;
    result = imul(result, 31) + (this.b39_1 == null ? 0 : getStringHashCode(this.b39_1)) | 0;
    result = imul(result, 31) + (this.c39_1 == null ? 0 : getStringHashCode(this.c39_1)) | 0;
    result = imul(result, 31) + (this.d39_1 == null ? 0 : getStringHashCode(this.d39_1)) | 0;
    return result;
  };
  protoOf(PlanLimitUsageImpact).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanLimitUsageImpact))
      return false;
    var tmp0_other_with_cast = other instanceof PlanLimitUsageImpact ? other : THROW_CCE();
    if (!this.r38_1.equals(tmp0_other_with_cast.r38_1))
      return false;
    if (!equals(this.s38_1, tmp0_other_with_cast.s38_1))
      return false;
    if (!(this.t38_1 === tmp0_other_with_cast.t38_1))
      return false;
    if (!this.u38_1.equals(tmp0_other_with_cast.u38_1))
      return false;
    if (!(this.v38_1 == tmp0_other_with_cast.v38_1))
      return false;
    if (!equals(this.w38_1, tmp0_other_with_cast.w38_1))
      return false;
    if (!equals(this.x38_1, tmp0_other_with_cast.x38_1))
      return false;
    if (!equals(this.y38_1, tmp0_other_with_cast.y38_1))
      return false;
    if (!equals(this.z38_1, tmp0_other_with_cast.z38_1))
      return false;
    if (!(this.a39_1 == tmp0_other_with_cast.a39_1))
      return false;
    if (!(this.b39_1 == tmp0_other_with_cast.b39_1))
      return false;
    if (!(this.c39_1 == tmp0_other_with_cast.c39_1))
      return false;
    if (!(this.d39_1 == tmp0_other_with_cast.d39_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_7($this) {
    return $this.f37_1.w();
  }
  function PlanWorkEvidence$Companion$_anonymous__a1kagy() {
    return createSimpleEnumSerializer('com.ems.console.api.PlanWorkEvidence', values_7());
  }
  var PlanWorkEvidence_UNKNOWN_instance;
  var PlanWorkEvidence_UNAVAILABLE_TENANT_WORK_INVENTORY_instance;
  var PlanWorkEvidence_PARTIAL_KNOWN_REQUIREMENTS_instance;
  function values_7() {
    return [PlanWorkEvidence_UNKNOWN_getInstance(), PlanWorkEvidence_UNAVAILABLE_TENANT_WORK_INVENTORY_getInstance(), PlanWorkEvidence_PARTIAL_KNOWN_REQUIREMENTS_getInstance()];
  }
  function Companion_135() {
    Companion_instance_135 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.f37_1 = lazy(tmp_0, PlanWorkEvidence$Companion$_anonymous__a1kagy);
  }
  protoOf(Companion_135).w19 = function () {
    return _get_$cachedSerializer__te6jhj_7(this);
  };
  protoOf(Companion_135).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_135;
  function Companion_getInstance_135() {
    PlanWorkEvidence_initEntries();
    if (Companion_instance_135 == null)
      new Companion_135();
    return Companion_instance_135;
  }
  var PlanWorkEvidence_entriesInitialized;
  function PlanWorkEvidence_initEntries() {
    if (PlanWorkEvidence_entriesInitialized)
      return Unit_instance;
    PlanWorkEvidence_entriesInitialized = true;
    PlanWorkEvidence_UNKNOWN_instance = new PlanWorkEvidence('UNKNOWN', 0);
    PlanWorkEvidence_UNAVAILABLE_TENANT_WORK_INVENTORY_instance = new PlanWorkEvidence('UNAVAILABLE_TENANT_WORK_INVENTORY', 1);
    PlanWorkEvidence_PARTIAL_KNOWN_REQUIREMENTS_instance = new PlanWorkEvidence('PARTIAL_KNOWN_REQUIREMENTS', 2);
    Companion_getInstance_135();
  }
  function PlanWorkEvidence(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_136() {
    Companion_instance_136 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e39_1 = [null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_156())];
  }
  var Companion_instance_136;
  function Companion_getInstance_136() {
    if (Companion_instance_136 == null)
      new Companion_136();
    return Companion_instance_136;
  }
  function $serializer_162() {
    $serializer_instance_161 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanPausedWorkImpact', this, 8);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('count', true);
    tmp0_serialDesc.gy('status', true);
    tmp0_serialDesc.gy('channel', true);
    tmp0_serialDesc.gy('missingFeatures', true);
    this.f39_1 = tmp0_serialDesc;
  }
  protoOf($serializer_162).g39 = function (encoder, value) {
    var tmp0_desc = this.f39_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_136().e39_1;
    tmp1_output.hs(tmp0_desc, 0, value.h39_1);
    tmp1_output.hs(tmp0_desc, 1, value.i39_1);
    tmp1_output.hs(tmp0_desc, 2, value.j39_1);
    tmp1_output.hs(tmp0_desc, 3, value.k39_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.l39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.l39_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.m39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.m39_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.n39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.n39_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !equals(value.o39_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.o39_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_162).on = function (encoder, value) {
    return this.g39(encoder, value instanceof PlanPausedWorkImpact ? value : THROW_CCE());
  };
  protoOf($serializer_162).pn = function (decoder) {
    var tmp0_desc = this.f39_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.tq(tmp0_desc);
    var tmp13_cached = Companion_getInstance_136().e39_1;
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.fr(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.fr(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return PlanPausedWorkImpact_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_162).nn = function () {
    return this.f39_1;
  };
  protoOf($serializer_162).vy = function () {
    var tmp0_cached = Companion_getInstance_136().e39_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[7]];
  };
  var $serializer_instance_161;
  function $serializer_getInstance_161() {
    if ($serializer_instance_161 == null)
      new $serializer_162();
    return $serializer_instance_161;
  }
  function PlanPausedWorkImpact_init_$Init$(seen0, key, nameEn, nameAr, reason, count, status, channel, missingFeatures, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_161().f39_1);
    }
    $this.h39_1 = key;
    $this.i39_1 = nameEn;
    $this.j39_1 = nameAr;
    $this.k39_1 = reason;
    if (0 === (seen0 & 16))
      $this.l39_1 = null;
    else
      $this.l39_1 = count;
    if (0 === (seen0 & 32))
      $this.m39_1 = null;
    else
      $this.m39_1 = status;
    if (0 === (seen0 & 64))
      $this.n39_1 = null;
    else
      $this.n39_1 = channel;
    if (0 === (seen0 & 128))
      $this.o39_1 = emptyList();
    else
      $this.o39_1 = missingFeatures;
    return $this;
  }
  function PlanPausedWorkImpact_init_$Create$(seen0, key, nameEn, nameAr, reason, count, status, channel, missingFeatures, serializationConstructorMarker) {
    return PlanPausedWorkImpact_init_$Init$(seen0, key, nameEn, nameAr, reason, count, status, channel, missingFeatures, serializationConstructorMarker, objectCreate(protoOf(PlanPausedWorkImpact)));
  }
  function PlanPausedWorkImpact() {
  }
  protoOf(PlanPausedWorkImpact).toString = function () {
    return 'PlanPausedWorkImpact(key=' + this.h39_1 + ', nameEn=' + this.i39_1 + ', nameAr=' + this.j39_1 + ', reason=' + this.k39_1 + ', count=' + toString_0(this.l39_1) + ', status=' + this.m39_1 + ', channel=' + this.n39_1 + ', missingFeatures=' + toString(this.o39_1) + ')';
  };
  protoOf(PlanPausedWorkImpact).hashCode = function () {
    var result = getStringHashCode(this.h39_1);
    result = imul(result, 31) + getStringHashCode(this.i39_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j39_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k39_1) | 0;
    result = imul(result, 31) + (this.l39_1 == null ? 0 : this.l39_1.hashCode()) | 0;
    result = imul(result, 31) + (this.m39_1 == null ? 0 : getStringHashCode(this.m39_1)) | 0;
    result = imul(result, 31) + (this.n39_1 == null ? 0 : getStringHashCode(this.n39_1)) | 0;
    result = imul(result, 31) + hashCode(this.o39_1) | 0;
    return result;
  };
  protoOf(PlanPausedWorkImpact).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanPausedWorkImpact))
      return false;
    var tmp0_other_with_cast = other instanceof PlanPausedWorkImpact ? other : THROW_CCE();
    if (!(this.h39_1 === tmp0_other_with_cast.h39_1))
      return false;
    if (!(this.i39_1 === tmp0_other_with_cast.i39_1))
      return false;
    if (!(this.j39_1 === tmp0_other_with_cast.j39_1))
      return false;
    if (!(this.k39_1 === tmp0_other_with_cast.k39_1))
      return false;
    if (!equals(this.l39_1, tmp0_other_with_cast.l39_1))
      return false;
    if (!(this.m39_1 == tmp0_other_with_cast.m39_1))
      return false;
    if (!(this.n39_1 == tmp0_other_with_cast.n39_1))
      return false;
    if (!equals(this.o39_1, tmp0_other_with_cast.o39_1))
      return false;
    return true;
  };
  function Companion_137() {
    Companion_instance_137 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p39_1 = [null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), null, null, null];
  }
  var Companion_instance_137;
  function Companion_getInstance_137() {
    if (Companion_instance_137 == null)
      new Companion_137();
    return Companion_instance_137;
  }
  function $serializer_163() {
    $serializer_instance_162 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanWorkImpact', this, 13);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('channel', true);
    tmp0_serialDesc.gy('count', false);
    tmp0_serialDesc.gy('bindingId', true);
    tmp0_serialDesc.gy('bindingVersion', true);
    tmp0_serialDesc.gy('requiredFeatures', true);
    tmp0_serialDesc.gy('missingAfter', true);
    tmp0_serialDesc.gy('allowedBefore', true);
    tmp0_serialDesc.gy('allowedAfter', true);
    tmp0_serialDesc.gy('reason', true);
    this.q39_1 = tmp0_serialDesc;
  }
  protoOf($serializer_163).r39 = function (encoder, value) {
    var tmp0_desc = this.q39_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_137().p39_1;
    tmp1_output.hs(tmp0_desc, 0, value.s39_1);
    tmp1_output.hs(tmp0_desc, 1, value.t39_1);
    tmp1_output.hs(tmp0_desc, 2, value.u39_1);
    tmp1_output.hs(tmp0_desc, 3, value.v39_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.w39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.w39_1);
    }
    tmp1_output.ds(tmp0_desc, 5, value.x39_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.y39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.y39_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.z39_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, IntSerializer_getInstance(), value.z39_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !equals(value.a3a_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.a3a_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !equals(value.b3a_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.b3a_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.c3a_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, BooleanSerializer_getInstance(), value.c3a_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.d3a_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, BooleanSerializer_getInstance(), value.d3a_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.e3a_1 === 'execution_feature_mapping_unclassified')) {
      tmp1_output.hs(tmp0_desc, 12, value.e3a_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_163).on = function (encoder, value) {
    return this.r39(encoder, value instanceof PlanWorkImpact ? value : THROW_CCE());
  };
  protoOf($serializer_163).pn = function (decoder) {
    var tmp0_desc = this.q39_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.tq(tmp0_desc);
    var tmp18_cached = Companion_getInstance_137().p39_1;
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.hr(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.fr(tmp0_desc, 8, tmp18_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.dr(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.hr(tmp0_desc, 7, IntSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.fr(tmp0_desc, 8, tmp18_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, BooleanSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.hr(tmp0_desc, 11, BooleanSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.dr(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return PlanWorkImpact_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_163).nn = function () {
    return this.q39_1;
  };
  protoOf($serializer_163).vy = function () {
    var tmp0_cached = Companion_getInstance_137().p39_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), tmp0_cached[8], tmp0_cached[9], get_nullable(BooleanSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance()), StringSerializer_getInstance()];
  };
  var $serializer_instance_162;
  function $serializer_getInstance_162() {
    if ($serializer_instance_162 == null)
      new $serializer_163();
    return $serializer_instance_162;
  }
  function PlanWorkImpact_init_$Init$(seen0, key, nameEn, nameAr, status, channel, count, bindingId, bindingVersion, requiredFeatures, missingAfter, allowedBefore, allowedAfter, reason, serializationConstructorMarker, $this) {
    if (!(47 === (47 & seen0))) {
      throwMissingFieldException(seen0, 47, $serializer_getInstance_162().q39_1);
    }
    $this.s39_1 = key;
    $this.t39_1 = nameEn;
    $this.u39_1 = nameAr;
    $this.v39_1 = status;
    if (0 === (seen0 & 16))
      $this.w39_1 = null;
    else
      $this.w39_1 = channel;
    $this.x39_1 = count;
    if (0 === (seen0 & 64))
      $this.y39_1 = null;
    else
      $this.y39_1 = bindingId;
    if (0 === (seen0 & 128))
      $this.z39_1 = null;
    else
      $this.z39_1 = bindingVersion;
    if (0 === (seen0 & 256))
      $this.a3a_1 = emptyList();
    else
      $this.a3a_1 = requiredFeatures;
    if (0 === (seen0 & 512))
      $this.b3a_1 = emptyList();
    else
      $this.b3a_1 = missingAfter;
    if (0 === (seen0 & 1024))
      $this.c3a_1 = null;
    else
      $this.c3a_1 = allowedBefore;
    if (0 === (seen0 & 2048))
      $this.d3a_1 = null;
    else
      $this.d3a_1 = allowedAfter;
    if (0 === (seen0 & 4096))
      $this.e3a_1 = 'execution_feature_mapping_unclassified';
    else
      $this.e3a_1 = reason;
    return $this;
  }
  function PlanWorkImpact_init_$Create$(seen0, key, nameEn, nameAr, status, channel, count, bindingId, bindingVersion, requiredFeatures, missingAfter, allowedBefore, allowedAfter, reason, serializationConstructorMarker) {
    return PlanWorkImpact_init_$Init$(seen0, key, nameEn, nameAr, status, channel, count, bindingId, bindingVersion, requiredFeatures, missingAfter, allowedBefore, allowedAfter, reason, serializationConstructorMarker, objectCreate(protoOf(PlanWorkImpact)));
  }
  function PlanWorkImpact() {
  }
  protoOf(PlanWorkImpact).toString = function () {
    return 'PlanWorkImpact(key=' + this.s39_1 + ', nameEn=' + this.t39_1 + ', nameAr=' + this.u39_1 + ', status=' + this.v39_1 + ', channel=' + this.w39_1 + ', count=' + this.x39_1.toString() + ', bindingId=' + this.y39_1 + ', bindingVersion=' + this.z39_1 + ', requiredFeatures=' + toString(this.a3a_1) + ', missingAfter=' + toString(this.b3a_1) + ', allowedBefore=' + this.c3a_1 + ', allowedAfter=' + this.d3a_1 + ', reason=' + this.e3a_1 + ')';
  };
  protoOf(PlanWorkImpact).hashCode = function () {
    var result = getStringHashCode(this.s39_1);
    result = imul(result, 31) + getStringHashCode(this.t39_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u39_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v39_1) | 0;
    result = imul(result, 31) + (this.w39_1 == null ? 0 : getStringHashCode(this.w39_1)) | 0;
    result = imul(result, 31) + this.x39_1.hashCode() | 0;
    result = imul(result, 31) + (this.y39_1 == null ? 0 : getStringHashCode(this.y39_1)) | 0;
    result = imul(result, 31) + (this.z39_1 == null ? 0 : this.z39_1) | 0;
    result = imul(result, 31) + hashCode(this.a3a_1) | 0;
    result = imul(result, 31) + hashCode(this.b3a_1) | 0;
    result = imul(result, 31) + (this.c3a_1 == null ? 0 : getBooleanHashCode(this.c3a_1)) | 0;
    result = imul(result, 31) + (this.d3a_1 == null ? 0 : getBooleanHashCode(this.d3a_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.e3a_1) | 0;
    return result;
  };
  protoOf(PlanWorkImpact).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanWorkImpact))
      return false;
    var tmp0_other_with_cast = other instanceof PlanWorkImpact ? other : THROW_CCE();
    if (!(this.s39_1 === tmp0_other_with_cast.s39_1))
      return false;
    if (!(this.t39_1 === tmp0_other_with_cast.t39_1))
      return false;
    if (!(this.u39_1 === tmp0_other_with_cast.u39_1))
      return false;
    if (!(this.v39_1 === tmp0_other_with_cast.v39_1))
      return false;
    if (!(this.w39_1 == tmp0_other_with_cast.w39_1))
      return false;
    if (!this.x39_1.equals(tmp0_other_with_cast.x39_1))
      return false;
    if (!(this.y39_1 == tmp0_other_with_cast.y39_1))
      return false;
    if (!(this.z39_1 == tmp0_other_with_cast.z39_1))
      return false;
    if (!equals(this.a3a_1, tmp0_other_with_cast.a3a_1))
      return false;
    if (!equals(this.b3a_1, tmp0_other_with_cast.b3a_1))
      return false;
    if (!(this.c3a_1 == tmp0_other_with_cast.c3a_1))
      return false;
    if (!(this.d3a_1 == tmp0_other_with_cast.d3a_1))
      return false;
    if (!(this.e3a_1 === tmp0_other_with_cast.e3a_1))
      return false;
    return true;
  };
  function $serializer_164() {
    $serializer_instance_163 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanLimitImpact', this, 9);
    tmp0_serialDesc.gy('limit', false);
    tmp0_serialDesc.gy('beforeValue', false);
    tmp0_serialDesc.gy('afterValue', false);
    tmp0_serialDesc.gy('beforePolicy', false);
    tmp0_serialDesc.gy('afterPolicy', false);
    tmp0_serialDesc.gy('beforeSource', false);
    tmp0_serialDesc.gy('afterSource', false);
    tmp0_serialDesc.gy('beforeReason', false);
    tmp0_serialDesc.gy('afterReason', false);
    this.f3a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_164).g3a = function (encoder, value) {
    var tmp0_desc = this.f3a_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_156(), value.h3a_1);
    tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.i3a_1);
    tmp1_output.ls(tmp0_desc, 2, LongSerializer_getInstance(), value.j3a_1);
    tmp1_output.hs(tmp0_desc, 3, value.k3a_1);
    tmp1_output.hs(tmp0_desc, 4, value.l3a_1);
    tmp1_output.hs(tmp0_desc, 5, value.m3a_1);
    tmp1_output.hs(tmp0_desc, 6, value.n3a_1);
    tmp1_output.hs(tmp0_desc, 7, value.o3a_1);
    tmp1_output.hs(tmp0_desc, 8, value.p3a_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_164).on = function (encoder, value) {
    return this.g3a(encoder, value instanceof PlanLimitImpact ? value : THROW_CCE());
  };
  protoOf($serializer_164).pn = function (decoder) {
    var tmp0_desc = this.f3a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return PlanLimitImpact_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_164).nn = function () {
    return this.f3a_1;
  };
  protoOf($serializer_164).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_156(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_163;
  function $serializer_getInstance_163() {
    if ($serializer_instance_163 == null)
      new $serializer_164();
    return $serializer_instance_163;
  }
  function PlanLimitImpact_init_$Init$(seen0, limit, beforeValue, afterValue, beforePolicy, afterPolicy, beforeSource, afterSource, beforeReason, afterReason, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_163().f3a_1);
    }
    $this.h3a_1 = limit;
    $this.i3a_1 = beforeValue;
    $this.j3a_1 = afterValue;
    $this.k3a_1 = beforePolicy;
    $this.l3a_1 = afterPolicy;
    $this.m3a_1 = beforeSource;
    $this.n3a_1 = afterSource;
    $this.o3a_1 = beforeReason;
    $this.p3a_1 = afterReason;
    return $this;
  }
  function PlanLimitImpact_init_$Create$(seen0, limit, beforeValue, afterValue, beforePolicy, afterPolicy, beforeSource, afterSource, beforeReason, afterReason, serializationConstructorMarker) {
    return PlanLimitImpact_init_$Init$(seen0, limit, beforeValue, afterValue, beforePolicy, afterPolicy, beforeSource, afterSource, beforeReason, afterReason, serializationConstructorMarker, objectCreate(protoOf(PlanLimitImpact)));
  }
  function PlanLimitImpact() {
  }
  protoOf(PlanLimitImpact).toString = function () {
    return 'PlanLimitImpact(limit=' + this.h3a_1.toString() + ', beforeValue=' + toString_0(this.i3a_1) + ', afterValue=' + toString_0(this.j3a_1) + ', beforePolicy=' + this.k3a_1 + ', afterPolicy=' + this.l3a_1 + ', beforeSource=' + this.m3a_1 + ', afterSource=' + this.n3a_1 + ', beforeReason=' + this.o3a_1 + ', afterReason=' + this.p3a_1 + ')';
  };
  protoOf(PlanLimitImpact).hashCode = function () {
    var result = this.h3a_1.hashCode();
    result = imul(result, 31) + (this.i3a_1 == null ? 0 : this.i3a_1.hashCode()) | 0;
    result = imul(result, 31) + (this.j3a_1 == null ? 0 : this.j3a_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.k3a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l3a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m3a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n3a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o3a_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p3a_1) | 0;
    return result;
  };
  protoOf(PlanLimitImpact).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanLimitImpact))
      return false;
    var tmp0_other_with_cast = other instanceof PlanLimitImpact ? other : THROW_CCE();
    if (!this.h3a_1.equals(tmp0_other_with_cast.h3a_1))
      return false;
    if (!equals(this.i3a_1, tmp0_other_with_cast.i3a_1))
      return false;
    if (!equals(this.j3a_1, tmp0_other_with_cast.j3a_1))
      return false;
    if (!(this.k3a_1 === tmp0_other_with_cast.k3a_1))
      return false;
    if (!(this.l3a_1 === tmp0_other_with_cast.l3a_1))
      return false;
    if (!(this.m3a_1 === tmp0_other_with_cast.m3a_1))
      return false;
    if (!(this.n3a_1 === tmp0_other_with_cast.n3a_1))
      return false;
    if (!(this.o3a_1 === tmp0_other_with_cast.o3a_1))
      return false;
    if (!(this.p3a_1 === tmp0_other_with_cast.p3a_1))
      return false;
    return true;
  };
  function PlanUsageEvidence_UNKNOWN_getInstance() {
    PlanUsageEvidence_initEntries();
    return PlanUsageEvidence_UNKNOWN_instance;
  }
  function PlanUsageEvidence_HISTORICAL_ROLLUP_getInstance() {
    PlanUsageEvidence_initEntries();
    return PlanUsageEvidence_HISTORICAL_ROLLUP_instance;
  }
  function PlanUsageEvidence_LIVE_COUNT_UNAVAILABLE_getInstance() {
    PlanUsageEvidence_initEntries();
    return PlanUsageEvidence_LIVE_COUNT_UNAVAILABLE_instance;
  }
  function PlanUsageEvidence_LIVE_COUNT_getInstance() {
    PlanUsageEvidence_initEntries();
    return PlanUsageEvidence_LIVE_COUNT_instance;
  }
  function PlanUsageEvidence_CURRENT_COUNTER_getInstance() {
    PlanUsageEvidence_initEntries();
    return PlanUsageEvidence_CURRENT_COUNTER_instance;
  }
  function PlanWorkEvidence_UNKNOWN_getInstance() {
    PlanWorkEvidence_initEntries();
    return PlanWorkEvidence_UNKNOWN_instance;
  }
  function PlanWorkEvidence_UNAVAILABLE_TENANT_WORK_INVENTORY_getInstance() {
    PlanWorkEvidence_initEntries();
    return PlanWorkEvidence_UNAVAILABLE_TENANT_WORK_INVENTORY_instance;
  }
  function PlanWorkEvidence_PARTIAL_KNOWN_REQUIREMENTS_getInstance() {
    PlanWorkEvidence_initEntries();
    return PlanWorkEvidence_PARTIAL_KNOWN_REQUIREMENTS_instance;
  }
  function PlanKeys() {
  }
  protoOf(PlanKeys).q3a = function (nameEn) {
    // Inline function 'kotlin.text.replace' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = toString(trim(isCharSequence(nameEn) ? nameEn : THROW_CCE())).toLowerCase();
    var tmp$ret$3 = Regex_init_$Create$('[^a-z0-9]+').sd(this_0, '-');
    return trim_0(tmp$ret$3, charArrayOf([_Char___init__impl__6a9atx(45)]));
  };
  var PlanKeys_instance;
  function PlanKeys_getInstance() {
    return PlanKeys_instance;
  }
  function Companion_138() {
  }
  var Companion_instance_138;
  function Companion_getInstance_138() {
    return Companion_instance_138;
  }
  function $serializer_165() {
    $serializer_instance_164 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanLifecycleResult', this, 4);
    tmp0_serialDesc.gy('action', false);
    tmp0_serialDesc.gy('plan', false);
    tmp0_serialDesc.gy('sourcePlanKey', true);
    tmp0_serialDesc.gy('replayed', true);
    this.r3a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_165).s3a = function (encoder, value) {
    var tmp0_desc = this.r3a_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.t3a_1);
    tmp1_output.js(tmp0_desc, 1, $serializer_getInstance_36(), value.u3a_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.v3a_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.v3a_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.w3a_1 === false)) {
      tmp1_output.zr(tmp0_desc, 3, value.w3a_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_165).on = function (encoder, value) {
    return this.s3a(encoder, value instanceof PlanLifecycleResult ? value : THROW_CCE());
  };
  protoOf($serializer_165).pn = function (decoder) {
    var tmp0_desc = this.r3a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return PlanLifecycleResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_165).nn = function () {
    return this.r3a_1;
  };
  protoOf($serializer_165).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_36(), get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_164;
  function $serializer_getInstance_164() {
    if ($serializer_instance_164 == null)
      new $serializer_165();
    return $serializer_instance_164;
  }
  function PlanLifecycleResult_init_$Init$(seen0, action, plan, sourcePlanKey, replayed, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_164().r3a_1);
    }
    $this.t3a_1 = action;
    $this.u3a_1 = plan;
    if (0 === (seen0 & 4))
      $this.v3a_1 = null;
    else
      $this.v3a_1 = sourcePlanKey;
    if (0 === (seen0 & 8))
      $this.w3a_1 = false;
    else
      $this.w3a_1 = replayed;
    return $this;
  }
  function PlanLifecycleResult_init_$Create$(seen0, action, plan, sourcePlanKey, replayed, serializationConstructorMarker) {
    return PlanLifecycleResult_init_$Init$(seen0, action, plan, sourcePlanKey, replayed, serializationConstructorMarker, objectCreate(protoOf(PlanLifecycleResult)));
  }
  function PlanLifecycleResult(action, plan, sourcePlanKey, replayed) {
    sourcePlanKey = sourcePlanKey === VOID ? null : sourcePlanKey;
    replayed = replayed === VOID ? false : replayed;
    this.t3a_1 = action;
    this.u3a_1 = plan;
    this.v3a_1 = sourcePlanKey;
    this.w3a_1 = replayed;
  }
  protoOf(PlanLifecycleResult).toString = function () {
    return 'PlanLifecycleResult(action=' + this.t3a_1 + ', plan=' + this.u3a_1.toString() + ', sourcePlanKey=' + this.v3a_1 + ', replayed=' + this.w3a_1 + ')';
  };
  protoOf(PlanLifecycleResult).hashCode = function () {
    var result = getStringHashCode(this.t3a_1);
    result = imul(result, 31) + this.u3a_1.hashCode() | 0;
    result = imul(result, 31) + (this.v3a_1 == null ? 0 : getStringHashCode(this.v3a_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w3a_1) | 0;
    return result;
  };
  protoOf(PlanLifecycleResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanLifecycleResult))
      return false;
    var tmp0_other_with_cast = other instanceof PlanLifecycleResult ? other : THROW_CCE();
    if (!(this.t3a_1 === tmp0_other_with_cast.t3a_1))
      return false;
    if (!this.u3a_1.equals(tmp0_other_with_cast.u3a_1))
      return false;
    if (!(this.v3a_1 == tmp0_other_with_cast.v3a_1))
      return false;
    if (!(this.w3a_1 === tmp0_other_with_cast.w3a_1))
      return false;
    return true;
  };
  var PlanLifecycleAction_PUBLISH_instance;
  var PlanLifecycleAction_ARCHIVE_instance;
  var PlanLifecycleAction_RESTORE_instance;
  var PlanLifecycleAction_DUPLICATE_instance;
  function values_8() {
    return [PlanLifecycleAction_PUBLISH_getInstance(), PlanLifecycleAction_ARCHIVE_getInstance(), PlanLifecycleAction_RESTORE_getInstance(), PlanLifecycleAction_DUPLICATE_getInstance()];
  }
  function get_entries_1() {
    if ($ENTRIES_1 == null)
      $ENTRIES_1 = enumEntries(values_8());
    return $ENTRIES_1;
  }
  var PlanLifecycleAction_entriesInitialized;
  function PlanLifecycleAction_initEntries() {
    if (PlanLifecycleAction_entriesInitialized)
      return Unit_instance;
    PlanLifecycleAction_entriesInitialized = true;
    PlanLifecycleAction_PUBLISH_instance = new PlanLifecycleAction('PUBLISH', 0, 'publish', 'plan_publish');
    PlanLifecycleAction_ARCHIVE_instance = new PlanLifecycleAction('ARCHIVE', 1, 'archive', 'plan_archive');
    PlanLifecycleAction_RESTORE_instance = new PlanLifecycleAction('RESTORE', 2, 'restore', 'plan_restore');
    PlanLifecycleAction_DUPLICATE_instance = new PlanLifecycleAction('DUPLICATE', 3, 'duplicate', 'plan_duplicate');
  }
  var $ENTRIES_1;
  function PlanLifecycleAction(name, ordinal, wire, tool) {
    Enum.call(this, name, ordinal);
    this.z3a_1 = wire;
    this.a3b_1 = tool;
  }
  function Companion_139() {
  }
  var Companion_instance_139;
  function Companion_getInstance_139() {
    return Companion_instance_139;
  }
  function $serializer_166() {
    $serializer_instance_165 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanLifecycleRequest', this, 1);
    tmp0_serialDesc.gy('expectedRevision', false);
    this.b3b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_166).c3b = function (encoder, value) {
    var tmp0_desc = this.b3b_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.d3b_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_166).on = function (encoder, value) {
    return this.c3b(encoder, value instanceof PlanLifecycleRequest ? value : THROW_CCE());
  };
  protoOf($serializer_166).pn = function (decoder) {
    var tmp0_desc = this.b3b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return PlanLifecycleRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_166).nn = function () {
    return this.b3b_1;
  };
  protoOf($serializer_166).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_165;
  function $serializer_getInstance_165() {
    if ($serializer_instance_165 == null)
      new $serializer_166();
    return $serializer_instance_165;
  }
  function PlanLifecycleRequest_init_$Init$(seen0, expectedRevision, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_165().b3b_1);
    }
    $this.d3b_1 = expectedRevision;
    return $this;
  }
  function PlanLifecycleRequest_init_$Create$(seen0, expectedRevision, serializationConstructorMarker) {
    return PlanLifecycleRequest_init_$Init$(seen0, expectedRevision, serializationConstructorMarker, objectCreate(protoOf(PlanLifecycleRequest)));
  }
  function PlanLifecycleRequest(expectedRevision) {
    this.d3b_1 = expectedRevision;
  }
  protoOf(PlanLifecycleRequest).toString = function () {
    return 'PlanLifecycleRequest(expectedRevision=' + this.d3b_1.toString() + ')';
  };
  protoOf(PlanLifecycleRequest).hashCode = function () {
    return this.d3b_1.hashCode();
  };
  protoOf(PlanLifecycleRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanLifecycleRequest))
      return false;
    var tmp0_other_with_cast = other instanceof PlanLifecycleRequest ? other : THROW_CCE();
    if (!this.d3b_1.equals(tmp0_other_with_cast.d3b_1))
      return false;
    return true;
  };
  function PlanLifecyclePaths() {
  }
  protoOf(PlanLifecyclePaths).e3b = function (planKey, action) {
    return ConsoleApiPaths_instance.m1z(planKey) + '/' + action.z3a_1;
  };
  var PlanLifecyclePaths_instance;
  function PlanLifecyclePaths_getInstance() {
    return PlanLifecyclePaths_instance;
  }
  function Companion_140() {
  }
  var Companion_instance_140;
  function Companion_getInstance_140() {
    return Companion_instance_140;
  }
  function $serializer_167() {
    $serializer_instance_166 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.DuplicatePlanRequest', this, 4);
    tmp0_serialDesc.gy('expectedRevision', false);
    tmp0_serialDesc.gy('newKey', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    this.f3b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_167).g3b = function (encoder, value) {
    var tmp0_desc = this.f3b_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.h3b_1);
    tmp1_output.hs(tmp0_desc, 1, value.i3b_1);
    tmp1_output.hs(tmp0_desc, 2, value.j3b_1);
    tmp1_output.hs(tmp0_desc, 3, value.k3b_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_167).on = function (encoder, value) {
    return this.g3b(encoder, value instanceof DuplicatePlanRequest ? value : THROW_CCE());
  };
  protoOf($serializer_167).pn = function (decoder) {
    var tmp0_desc = this.f3b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return DuplicatePlanRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_167).nn = function () {
    return this.f3b_1;
  };
  protoOf($serializer_167).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_166;
  function $serializer_getInstance_166() {
    if ($serializer_instance_166 == null)
      new $serializer_167();
    return $serializer_instance_166;
  }
  function DuplicatePlanRequest_init_$Init$(seen0, expectedRevision, newKey, nameEn, nameAr, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_166().f3b_1);
    }
    $this.h3b_1 = expectedRevision;
    $this.i3b_1 = newKey;
    $this.j3b_1 = nameEn;
    $this.k3b_1 = nameAr;
    return $this;
  }
  function DuplicatePlanRequest_init_$Create$(seen0, expectedRevision, newKey, nameEn, nameAr, serializationConstructorMarker) {
    return DuplicatePlanRequest_init_$Init$(seen0, expectedRevision, newKey, nameEn, nameAr, serializationConstructorMarker, objectCreate(protoOf(DuplicatePlanRequest)));
  }
  function DuplicatePlanRequest(expectedRevision, newKey, nameEn, nameAr) {
    this.h3b_1 = expectedRevision;
    this.i3b_1 = newKey;
    this.j3b_1 = nameEn;
    this.k3b_1 = nameAr;
  }
  protoOf(DuplicatePlanRequest).toString = function () {
    return 'DuplicatePlanRequest(expectedRevision=' + this.h3b_1.toString() + ', newKey=' + this.i3b_1 + ', nameEn=' + this.j3b_1 + ', nameAr=' + this.k3b_1 + ')';
  };
  protoOf(DuplicatePlanRequest).hashCode = function () {
    var result = this.h3b_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i3b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j3b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k3b_1) | 0;
    return result;
  };
  protoOf(DuplicatePlanRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DuplicatePlanRequest))
      return false;
    var tmp0_other_with_cast = other instanceof DuplicatePlanRequest ? other : THROW_CCE();
    if (!this.h3b_1.equals(tmp0_other_with_cast.h3b_1))
      return false;
    if (!(this.i3b_1 === tmp0_other_with_cast.i3b_1))
      return false;
    if (!(this.j3b_1 === tmp0_other_with_cast.j3b_1))
      return false;
    if (!(this.k3b_1 === tmp0_other_with_cast.k3b_1))
      return false;
    return true;
  };
  function PlanLifecycleRules() {
  }
  protoOf(PlanLifecycleRules).l3b = function (action, lifecycle) {
    var tmp;
    switch (action.o2_1) {
      case 0:
        tmp = lifecycle === 'DRAFT';
        break;
      case 1:
        tmp = lifecycle === 'DRAFT' || lifecycle === 'AVAILABLE';
        break;
      case 2:
        tmp = lifecycle === 'ARCHIVED';
        break;
      case 3:
        tmp = setOf(['DRAFT', 'AVAILABLE', 'ARCHIVED']).r(lifecycle);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(PlanLifecycleRules).m3b = function (action) {
    var tmp;
    switch (action.o2_1) {
      case 0:
        tmp = 'AVAILABLE';
        break;
      case 1:
        tmp = 'ARCHIVED';
        break;
      case 2:
      case 3:
        tmp = 'DRAFT';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(PlanLifecycleRules).n3b = function (key) {
    return Regex_init_$Create$('[a-z0-9][a-z0-9_-]{1,63}').nd(key);
  };
  var PlanLifecycleRules_instance;
  function PlanLifecycleRules_getInstance() {
    return PlanLifecycleRules_instance;
  }
  function PlanLifecycleAction_PUBLISH_getInstance() {
    PlanLifecycleAction_initEntries();
    return PlanLifecycleAction_PUBLISH_instance;
  }
  function PlanLifecycleAction_ARCHIVE_getInstance() {
    PlanLifecycleAction_initEntries();
    return PlanLifecycleAction_ARCHIVE_instance;
  }
  function PlanLifecycleAction_RESTORE_getInstance() {
    PlanLifecycleAction_initEntries();
    return PlanLifecycleAction_RESTORE_instance;
  }
  function PlanLifecycleAction_DUPLICATE_getInstance() {
    PlanLifecycleAction_initEntries();
    return PlanLifecycleAction_DUPLICATE_instance;
  }
  function Companion_141() {
    Companion_instance_141 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o3b_1 = [new ArrayListSerializer($serializer_getInstance_171()), null];
  }
  var Companion_instance_141;
  function Companion_getInstance_141() {
    if (Companion_instance_141 == null)
      new Companion_141();
    return Companion_instance_141;
  }
  function $serializer_168() {
    $serializer_instance_167 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SandboxRequestList', this, 2);
    tmp0_serialDesc.gy('items', false);
    tmp0_serialDesc.gy('pendingCount', false);
    this.p3b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_168).q3b = function (encoder, value) {
    var tmp0_desc = this.p3b_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_141().o3b_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.r3b_1);
    tmp1_output.cs(tmp0_desc, 1, value.s3b_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_168).on = function (encoder, value) {
    return this.q3b(encoder, value instanceof SandboxRequestList ? value : THROW_CCE());
  };
  protoOf($serializer_168).pn = function (decoder) {
    var tmp0_desc = this.p3b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_141().o3b_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SandboxRequestList_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_168).nn = function () {
    return this.p3b_1;
  };
  protoOf($serializer_168).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_141().o3b_1[0], IntSerializer_getInstance()];
  };
  var $serializer_instance_167;
  function $serializer_getInstance_167() {
    if ($serializer_instance_167 == null)
      new $serializer_168();
    return $serializer_instance_167;
  }
  function SandboxRequestList_init_$Init$(seen0, items, pendingCount, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_167().p3b_1);
    }
    $this.r3b_1 = items;
    $this.s3b_1 = pendingCount;
    return $this;
  }
  function SandboxRequestList_init_$Create$(seen0, items, pendingCount, serializationConstructorMarker) {
    return SandboxRequestList_init_$Init$(seen0, items, pendingCount, serializationConstructorMarker, objectCreate(protoOf(SandboxRequestList)));
  }
  function SandboxRequestList(items, pendingCount) {
    Companion_getInstance_141();
    this.r3b_1 = items;
    this.s3b_1 = pendingCount;
  }
  protoOf(SandboxRequestList).toString = function () {
    return 'SandboxRequestList(items=' + toString(this.r3b_1) + ', pendingCount=' + this.s3b_1 + ')';
  };
  protoOf(SandboxRequestList).hashCode = function () {
    var result = hashCode(this.r3b_1);
    result = imul(result, 31) + this.s3b_1 | 0;
    return result;
  };
  protoOf(SandboxRequestList).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxRequestList))
      return false;
    var tmp0_other_with_cast = other instanceof SandboxRequestList ? other : THROW_CCE();
    if (!equals(this.r3b_1, tmp0_other_with_cast.r3b_1))
      return false;
    if (!(this.s3b_1 === tmp0_other_with_cast.s3b_1))
      return false;
    return true;
  };
  function Companion_142() {
  }
  var Companion_instance_142;
  function Companion_getInstance_142() {
    return Companion_instance_142;
  }
  function $serializer_169() {
    $serializer_instance_168 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SandboxRequestDecision', this, 2);
    tmp0_serialDesc.gy('request', false);
    tmp0_serialDesc.gy('replayed', true);
    this.t3b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_169).u3b = function (encoder, value) {
    var tmp0_desc = this.t3b_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_171(), value.v3b_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.w3b_1 === false)) {
      tmp1_output.zr(tmp0_desc, 1, value.w3b_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_169).on = function (encoder, value) {
    return this.u3b(encoder, value instanceof SandboxRequestDecision ? value : THROW_CCE());
  };
  protoOf($serializer_169).pn = function (decoder) {
    var tmp0_desc = this.t3b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_171(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_171(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SandboxRequestDecision_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_169).nn = function () {
    return this.t3b_1;
  };
  protoOf($serializer_169).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_171(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_168;
  function $serializer_getInstance_168() {
    if ($serializer_instance_168 == null)
      new $serializer_169();
    return $serializer_instance_168;
  }
  function SandboxRequestDecision_init_$Init$(seen0, request, replayed, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_168().t3b_1);
    }
    $this.v3b_1 = request;
    if (0 === (seen0 & 2))
      $this.w3b_1 = false;
    else
      $this.w3b_1 = replayed;
    return $this;
  }
  function SandboxRequestDecision_init_$Create$(seen0, request, replayed, serializationConstructorMarker) {
    return SandboxRequestDecision_init_$Init$(seen0, request, replayed, serializationConstructorMarker, objectCreate(protoOf(SandboxRequestDecision)));
  }
  function SandboxRequestDecision(request, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.v3b_1 = request;
    this.w3b_1 = replayed;
  }
  protoOf(SandboxRequestDecision).toString = function () {
    return 'SandboxRequestDecision(request=' + this.v3b_1.toString() + ', replayed=' + this.w3b_1 + ')';
  };
  protoOf(SandboxRequestDecision).hashCode = function () {
    var result = this.v3b_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.w3b_1) | 0;
    return result;
  };
  protoOf(SandboxRequestDecision).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxRequestDecision))
      return false;
    var tmp0_other_with_cast = other instanceof SandboxRequestDecision ? other : THROW_CCE();
    if (!this.v3b_1.equals(tmp0_other_with_cast.v3b_1))
      return false;
    if (!(this.w3b_1 === tmp0_other_with_cast.w3b_1))
      return false;
    return true;
  };
  function SandboxRequestPaths() {
    this.x3b_1 = '/api/console/sandbox-requests';
    this.y3b_1 = 'status';
  }
  protoOf(SandboxRequestPaths).z3b = function (id) {
    return '/api/console/sandbox-requests/' + id + '/provision';
  };
  protoOf(SandboxRequestPaths).c1l = function (id) {
    return '/api/console/sandbox-requests/' + id + '/decline';
  };
  var SandboxRequestPaths_instance;
  function SandboxRequestPaths_getInstance() {
    return SandboxRequestPaths_instance;
  }
  function Companion_143() {
  }
  var Companion_instance_143;
  function Companion_getInstance_143() {
    return Companion_instance_143;
  }
  function $serializer_170() {
    $serializer_instance_169 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SandboxProvisionBody', this, 1);
    tmp0_serialDesc.gy('ownerEmail', true);
    this.a3c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_170).b3c = function (encoder, value) {
    var tmp0_desc = this.a3c_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.c3c_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, StringSerializer_getInstance(), value.c3c_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_170).on = function (encoder, value) {
    return this.b3c(encoder, value instanceof SandboxProvisionBody ? value : THROW_CCE());
  };
  protoOf($serializer_170).pn = function (decoder) {
    var tmp0_desc = this.a3c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return SandboxProvisionBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_170).nn = function () {
    return this.a3c_1;
  };
  protoOf($serializer_170).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_169;
  function $serializer_getInstance_169() {
    if ($serializer_instance_169 == null)
      new $serializer_170();
    return $serializer_instance_169;
  }
  function SandboxProvisionBody_init_$Init$(seen0, ownerEmail, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_169().a3c_1);
    }
    if (0 === (seen0 & 1))
      $this.c3c_1 = null;
    else
      $this.c3c_1 = ownerEmail;
    return $this;
  }
  function SandboxProvisionBody_init_$Create$(seen0, ownerEmail, serializationConstructorMarker) {
    return SandboxProvisionBody_init_$Init$(seen0, ownerEmail, serializationConstructorMarker, objectCreate(protoOf(SandboxProvisionBody)));
  }
  function SandboxProvisionBody(ownerEmail) {
    ownerEmail = ownerEmail === VOID ? null : ownerEmail;
    this.c3c_1 = ownerEmail;
  }
  protoOf(SandboxProvisionBody).toString = function () {
    return 'SandboxProvisionBody(ownerEmail=' + this.c3c_1 + ')';
  };
  protoOf(SandboxProvisionBody).hashCode = function () {
    return this.c3c_1 == null ? 0 : getStringHashCode(this.c3c_1);
  };
  protoOf(SandboxProvisionBody).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxProvisionBody))
      return false;
    var tmp0_other_with_cast = other instanceof SandboxProvisionBody ? other : THROW_CCE();
    if (!(this.c3c_1 == tmp0_other_with_cast.c3c_1))
      return false;
    return true;
  };
  function Companion_144() {
  }
  var Companion_instance_144;
  function Companion_getInstance_144() {
    return Companion_instance_144;
  }
  function $serializer_171() {
    $serializer_instance_170 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SandboxDeclineBody', this, 1);
    tmp0_serialDesc.gy('note', true);
    this.d3c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_171).e3c = function (encoder, value) {
    var tmp0_desc = this.d3c_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.f3c_1 === '')) {
      tmp1_output.hs(tmp0_desc, 0, value.f3c_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_171).on = function (encoder, value) {
    return this.e3c(encoder, value instanceof SandboxDeclineBody ? value : THROW_CCE());
  };
  protoOf($serializer_171).pn = function (decoder) {
    var tmp0_desc = this.d3c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return SandboxDeclineBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_171).nn = function () {
    return this.d3c_1;
  };
  protoOf($serializer_171).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_170;
  function $serializer_getInstance_170() {
    if ($serializer_instance_170 == null)
      new $serializer_171();
    return $serializer_instance_170;
  }
  function SandboxDeclineBody_init_$Init$(seen0, note, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_170().d3c_1);
    }
    if (0 === (seen0 & 1))
      $this.f3c_1 = '';
    else
      $this.f3c_1 = note;
    return $this;
  }
  function SandboxDeclineBody_init_$Create$(seen0, note, serializationConstructorMarker) {
    return SandboxDeclineBody_init_$Init$(seen0, note, serializationConstructorMarker, objectCreate(protoOf(SandboxDeclineBody)));
  }
  function SandboxDeclineBody(note) {
    note = note === VOID ? '' : note;
    this.f3c_1 = note;
  }
  protoOf(SandboxDeclineBody).toString = function () {
    return 'SandboxDeclineBody(note=' + this.f3c_1 + ')';
  };
  protoOf(SandboxDeclineBody).hashCode = function () {
    return getStringHashCode(this.f3c_1);
  };
  protoOf(SandboxDeclineBody).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxDeclineBody))
      return false;
    var tmp0_other_with_cast = other instanceof SandboxDeclineBody ? other : THROW_CCE();
    if (!(this.f3c_1 === tmp0_other_with_cast.f3c_1))
      return false;
    return true;
  };
  function $serializer_172() {
    $serializer_instance_171 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SandboxRequestRow', this, 16);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantSlug', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('requestedByName', false);
    tmp0_serialDesc.gy('days', false);
    tmp0_serialDesc.gy('profile', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('sandboxTenantId', true);
    tmp0_serialDesc.gy('sandboxSlug', true);
    tmp0_serialDesc.gy('sandboxHost', true);
    tmp0_serialDesc.gy('expiresAtMs', true);
    tmp0_serialDesc.gy('createdAtMs', false);
    tmp0_serialDesc.gy('decidedAtMs', true);
    tmp0_serialDesc.gy('decidedBy', true);
    tmp0_serialDesc.gy('note', true);
    this.g3c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_172).h3c = function (encoder, value) {
    var tmp0_desc = this.g3c_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.i3c_1);
    tmp1_output.hs(tmp0_desc, 1, value.j3c_1);
    tmp1_output.hs(tmp0_desc, 2, value.k3c_1);
    tmp1_output.hs(tmp0_desc, 3, value.l3c_1);
    tmp1_output.hs(tmp0_desc, 4, value.m3c_1);
    tmp1_output.cs(tmp0_desc, 5, value.n3c_1);
    tmp1_output.hs(tmp0_desc, 6, value.o3c_1);
    tmp1_output.hs(tmp0_desc, 7, value.p3c_1);
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.q3c_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.q3c_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.r3c_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.r3c_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.s3c_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.s3c_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.t3c_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, LongSerializer_getInstance(), value.t3c_1);
    }
    tmp1_output.ds(tmp0_desc, 12, value.u3c_1);
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.v3c_1 == null)) {
      tmp1_output.ls(tmp0_desc, 13, LongSerializer_getInstance(), value.v3c_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !(value.w3c_1 == null)) {
      tmp1_output.ls(tmp0_desc, 14, StringSerializer_getInstance(), value.w3c_1);
    }
    if (tmp1_output.ps(tmp0_desc, 15) ? true : !(value.x3c_1 == null)) {
      tmp1_output.ls(tmp0_desc, 15, StringSerializer_getInstance(), value.x3c_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_172).on = function (encoder, value) {
    return this.h3c(encoder, value instanceof SandboxRequestRow ? value : THROW_CCE());
  };
  protoOf($serializer_172).pn = function (decoder) {
    var tmp0_desc = this.g3c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = new Long(0, 0);
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_input = decoder.tq(tmp0_desc);
    if (tmp20_input.ir()) {
      tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp20_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp20_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp20_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp20_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp20_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp20_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp20_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp20_input.zq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp20_input.hr(tmp0_desc, 13, LongSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp20_input.hr(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp20_input.hr(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp20_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp20_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp20_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp20_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp20_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp20_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp20_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp20_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp20_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp20_input.hr(tmp0_desc, 11, LongSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp20_input.zq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp20_input.hr(tmp0_desc, 13, LongSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp20_input.hr(tmp0_desc, 14, StringSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp20_input.hr(tmp0_desc, 15, StringSerializer_getInstance(), tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp20_input.uq(tmp0_desc);
    return SandboxRequestRow_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
  };
  protoOf($serializer_172).nn = function () {
    return this.g3c_1;
  };
  protoOf($serializer_172).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_171;
  function $serializer_getInstance_171() {
    if ($serializer_instance_171 == null)
      new $serializer_172();
    return $serializer_instance_171;
  }
  function SandboxRequestRow_init_$Init$(seen0, id, tenantId, tenantSlug, tenantName, requestedByName, days, profile, status, sandboxTenantId, sandboxSlug, sandboxHost, expiresAtMs, createdAtMs, decidedAtMs, decidedBy, note, serializationConstructorMarker, $this) {
    if (!(4351 === (4351 & seen0))) {
      throwMissingFieldException(seen0, 4351, $serializer_getInstance_171().g3c_1);
    }
    $this.i3c_1 = id;
    $this.j3c_1 = tenantId;
    $this.k3c_1 = tenantSlug;
    $this.l3c_1 = tenantName;
    $this.m3c_1 = requestedByName;
    $this.n3c_1 = days;
    $this.o3c_1 = profile;
    $this.p3c_1 = status;
    if (0 === (seen0 & 256))
      $this.q3c_1 = null;
    else
      $this.q3c_1 = sandboxTenantId;
    if (0 === (seen0 & 512))
      $this.r3c_1 = null;
    else
      $this.r3c_1 = sandboxSlug;
    if (0 === (seen0 & 1024))
      $this.s3c_1 = null;
    else
      $this.s3c_1 = sandboxHost;
    if (0 === (seen0 & 2048))
      $this.t3c_1 = null;
    else
      $this.t3c_1 = expiresAtMs;
    $this.u3c_1 = createdAtMs;
    if (0 === (seen0 & 8192))
      $this.v3c_1 = null;
    else
      $this.v3c_1 = decidedAtMs;
    if (0 === (seen0 & 16384))
      $this.w3c_1 = null;
    else
      $this.w3c_1 = decidedBy;
    if (0 === (seen0 & 32768))
      $this.x3c_1 = null;
    else
      $this.x3c_1 = note;
    return $this;
  }
  function SandboxRequestRow_init_$Create$(seen0, id, tenantId, tenantSlug, tenantName, requestedByName, days, profile, status, sandboxTenantId, sandboxSlug, sandboxHost, expiresAtMs, createdAtMs, decidedAtMs, decidedBy, note, serializationConstructorMarker) {
    return SandboxRequestRow_init_$Init$(seen0, id, tenantId, tenantSlug, tenantName, requestedByName, days, profile, status, sandboxTenantId, sandboxSlug, sandboxHost, expiresAtMs, createdAtMs, decidedAtMs, decidedBy, note, serializationConstructorMarker, objectCreate(protoOf(SandboxRequestRow)));
  }
  function SandboxRequestRow() {
  }
  protoOf(SandboxRequestRow).toString = function () {
    return 'SandboxRequestRow(id=' + this.i3c_1 + ', tenantId=' + this.j3c_1 + ', tenantSlug=' + this.k3c_1 + ', tenantName=' + this.l3c_1 + ', requestedByName=' + this.m3c_1 + ', days=' + this.n3c_1 + ', profile=' + this.o3c_1 + ', status=' + this.p3c_1 + ', sandboxTenantId=' + this.q3c_1 + ', sandboxSlug=' + this.r3c_1 + ', sandboxHost=' + this.s3c_1 + ', expiresAtMs=' + toString_0(this.t3c_1) + ', createdAtMs=' + this.u3c_1.toString() + ', decidedAtMs=' + toString_0(this.v3c_1) + ', decidedBy=' + this.w3c_1 + ', note=' + this.x3c_1 + ')';
  };
  protoOf(SandboxRequestRow).hashCode = function () {
    var result = getStringHashCode(this.i3c_1);
    result = imul(result, 31) + getStringHashCode(this.j3c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k3c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.l3c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m3c_1) | 0;
    result = imul(result, 31) + this.n3c_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.o3c_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p3c_1) | 0;
    result = imul(result, 31) + (this.q3c_1 == null ? 0 : getStringHashCode(this.q3c_1)) | 0;
    result = imul(result, 31) + (this.r3c_1 == null ? 0 : getStringHashCode(this.r3c_1)) | 0;
    result = imul(result, 31) + (this.s3c_1 == null ? 0 : getStringHashCode(this.s3c_1)) | 0;
    result = imul(result, 31) + (this.t3c_1 == null ? 0 : this.t3c_1.hashCode()) | 0;
    result = imul(result, 31) + this.u3c_1.hashCode() | 0;
    result = imul(result, 31) + (this.v3c_1 == null ? 0 : this.v3c_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w3c_1 == null ? 0 : getStringHashCode(this.w3c_1)) | 0;
    result = imul(result, 31) + (this.x3c_1 == null ? 0 : getStringHashCode(this.x3c_1)) | 0;
    return result;
  };
  protoOf(SandboxRequestRow).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SandboxRequestRow))
      return false;
    var tmp0_other_with_cast = other instanceof SandboxRequestRow ? other : THROW_CCE();
    if (!(this.i3c_1 === tmp0_other_with_cast.i3c_1))
      return false;
    if (!(this.j3c_1 === tmp0_other_with_cast.j3c_1))
      return false;
    if (!(this.k3c_1 === tmp0_other_with_cast.k3c_1))
      return false;
    if (!(this.l3c_1 === tmp0_other_with_cast.l3c_1))
      return false;
    if (!(this.m3c_1 === tmp0_other_with_cast.m3c_1))
      return false;
    if (!(this.n3c_1 === tmp0_other_with_cast.n3c_1))
      return false;
    if (!(this.o3c_1 === tmp0_other_with_cast.o3c_1))
      return false;
    if (!(this.p3c_1 === tmp0_other_with_cast.p3c_1))
      return false;
    if (!(this.q3c_1 == tmp0_other_with_cast.q3c_1))
      return false;
    if (!(this.r3c_1 == tmp0_other_with_cast.r3c_1))
      return false;
    if (!(this.s3c_1 == tmp0_other_with_cast.s3c_1))
      return false;
    if (!equals(this.t3c_1, tmp0_other_with_cast.t3c_1))
      return false;
    if (!this.u3c_1.equals(tmp0_other_with_cast.u3c_1))
      return false;
    if (!equals(this.v3c_1, tmp0_other_with_cast.v3c_1))
      return false;
    if (!(this.w3c_1 == tmp0_other_with_cast.w3c_1))
      return false;
    if (!(this.x3c_1 == tmp0_other_with_cast.x3c_1))
      return false;
    return true;
  };
  function Companion_145() {
  }
  var Companion_instance_145;
  function Companion_getInstance_145() {
    return Companion_instance_145;
  }
  function $serializer_173() {
    $serializer_instance_172 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupAcceptanceResult', this, 5);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('draftId', false);
    tmp0_serialDesc.gy('acceptedRevision', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('jobId', false);
    this.y3c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_173).z3c = function (encoder, value) {
    var tmp0_desc = this.y3c_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.a3d_1);
    tmp1_output.hs(tmp0_desc, 1, value.b3d_1);
    tmp1_output.ds(tmp0_desc, 2, value.c3d_1);
    tmp1_output.hs(tmp0_desc, 3, value.d3d_1);
    tmp1_output.hs(tmp0_desc, 4, value.e3d_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_173).on = function (encoder, value) {
    return this.z3c(encoder, value instanceof SetupAcceptanceResult ? value : THROW_CCE());
  };
  protoOf($serializer_173).pn = function (decoder) {
    var tmp0_desc = this.y3c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return SetupAcceptanceResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_173).nn = function () {
    return this.y3c_1;
  };
  protoOf($serializer_173).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_172;
  function $serializer_getInstance_172() {
    if ($serializer_instance_172 == null)
      new $serializer_173();
    return $serializer_instance_172;
  }
  function SetupAcceptanceResult_init_$Init$(seen0, attemptId, draftId, acceptedRevision, tenantId, jobId, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_172().y3c_1);
    }
    $this.a3d_1 = attemptId;
    $this.b3d_1 = draftId;
    $this.c3d_1 = acceptedRevision;
    $this.d3d_1 = tenantId;
    $this.e3d_1 = jobId;
    return $this;
  }
  function SetupAcceptanceResult_init_$Create$(seen0, attemptId, draftId, acceptedRevision, tenantId, jobId, serializationConstructorMarker) {
    return SetupAcceptanceResult_init_$Init$(seen0, attemptId, draftId, acceptedRevision, tenantId, jobId, serializationConstructorMarker, objectCreate(protoOf(SetupAcceptanceResult)));
  }
  function SetupAcceptanceResult(attemptId, draftId, acceptedRevision, tenantId, jobId) {
    this.a3d_1 = attemptId;
    this.b3d_1 = draftId;
    this.c3d_1 = acceptedRevision;
    this.d3d_1 = tenantId;
    this.e3d_1 = jobId;
  }
  protoOf(SetupAcceptanceResult).toString = function () {
    return 'SetupAcceptanceResult(attemptId=' + this.a3d_1 + ', draftId=' + this.b3d_1 + ', acceptedRevision=' + this.c3d_1.toString() + ', tenantId=' + this.d3d_1 + ', jobId=' + this.e3d_1 + ')';
  };
  protoOf(SetupAcceptanceResult).hashCode = function () {
    var result = getStringHashCode(this.a3d_1);
    result = imul(result, 31) + getStringHashCode(this.b3d_1) | 0;
    result = imul(result, 31) + this.c3d_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.d3d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e3d_1) | 0;
    return result;
  };
  protoOf(SetupAcceptanceResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAcceptanceResult))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAcceptanceResult ? other : THROW_CCE();
    if (!(this.a3d_1 === tmp0_other_with_cast.a3d_1))
      return false;
    if (!(this.b3d_1 === tmp0_other_with_cast.b3d_1))
      return false;
    if (!this.c3d_1.equals(tmp0_other_with_cast.c3d_1))
      return false;
    if (!(this.d3d_1 === tmp0_other_with_cast.d3d_1))
      return false;
    if (!(this.e3d_1 === tmp0_other_with_cast.e3d_1))
      return false;
    return true;
  };
  function Companion_146() {
  }
  var Companion_instance_146;
  function Companion_getInstance_146() {
    return Companion_instance_146;
  }
  function $serializer_174() {
    $serializer_instance_173 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AcceptSetupDraftRequest', this, 3);
    tmp0_serialDesc.gy('expectedRevision', false);
    tmp0_serialDesc.gy('reviewReceipt', false);
    tmp0_serialDesc.gy('snapshotSha256', true);
    this.f3d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_174).g3d = function (encoder, value) {
    var tmp0_desc = this.f3d_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.h3d_1);
    tmp1_output.hs(tmp0_desc, 1, value.i3d_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.j3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.j3d_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_174).on = function (encoder, value) {
    return this.g3d(encoder, value instanceof AcceptSetupDraftRequest ? value : THROW_CCE());
  };
  protoOf($serializer_174).pn = function (decoder) {
    var tmp0_desc = this.f3d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return AcceptSetupDraftRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_174).nn = function () {
    return this.f3d_1;
  };
  protoOf($serializer_174).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_173;
  function $serializer_getInstance_173() {
    if ($serializer_instance_173 == null)
      new $serializer_174();
    return $serializer_instance_173;
  }
  function AcceptSetupDraftRequest_init_$Init$(seen0, expectedRevision, reviewReceipt, snapshotSha256, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_173().f3d_1);
    }
    $this.h3d_1 = expectedRevision;
    $this.i3d_1 = reviewReceipt;
    if (0 === (seen0 & 4))
      $this.j3d_1 = null;
    else
      $this.j3d_1 = snapshotSha256;
    return $this;
  }
  function AcceptSetupDraftRequest_init_$Create$(seen0, expectedRevision, reviewReceipt, snapshotSha256, serializationConstructorMarker) {
    return AcceptSetupDraftRequest_init_$Init$(seen0, expectedRevision, reviewReceipt, snapshotSha256, serializationConstructorMarker, objectCreate(protoOf(AcceptSetupDraftRequest)));
  }
  function AcceptSetupDraftRequest(expectedRevision, reviewReceipt, snapshotSha256) {
    snapshotSha256 = snapshotSha256 === VOID ? null : snapshotSha256;
    this.h3d_1 = expectedRevision;
    this.i3d_1 = reviewReceipt;
    this.j3d_1 = snapshotSha256;
  }
  protoOf(AcceptSetupDraftRequest).toString = function () {
    return 'AcceptSetupDraftRequest(expectedRevision=' + this.h3d_1.toString() + ', reviewReceipt=' + this.i3d_1 + ', snapshotSha256=' + this.j3d_1 + ')';
  };
  protoOf(AcceptSetupDraftRequest).hashCode = function () {
    var result = this.h3d_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.i3d_1) | 0;
    result = imul(result, 31) + (this.j3d_1 == null ? 0 : getStringHashCode(this.j3d_1)) | 0;
    return result;
  };
  protoOf(AcceptSetupDraftRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AcceptSetupDraftRequest))
      return false;
    var tmp0_other_with_cast = other instanceof AcceptSetupDraftRequest ? other : THROW_CCE();
    if (!this.h3d_1.equals(tmp0_other_with_cast.h3d_1))
      return false;
    if (!(this.i3d_1 === tmp0_other_with_cast.i3d_1))
      return false;
    if (!(this.j3d_1 == tmp0_other_with_cast.j3d_1))
      return false;
    return true;
  };
  function Companion_147() {
  }
  var Companion_instance_147;
  function Companion_getInstance_147() {
    return Companion_instance_147;
  }
  function $serializer_175() {
    $serializer_instance_174 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupAppearanceChoices', this, 9);
    tmp0_serialDesc.gy('colorMode', true);
    tmp0_serialDesc.gy('primaryColor', true);
    tmp0_serialDesc.gy('secondaryColor', true);
    tmp0_serialDesc.gy('accentColor', true);
    tmp0_serialDesc.gy('fontFamily', true);
    tmp0_serialDesc.gy('sidebarPosition', true);
    tmp0_serialDesc.gy('itemsPerPage', true);
    tmp0_serialDesc.gy('density', true);
    tmp0_serialDesc.gy('arabicNumerals', true);
    this.k3d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_175).l3d = function (encoder, value) {
    var tmp0_desc = this.k3d_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.m3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, StringSerializer_getInstance(), value.m3d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.n3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.n3d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.o3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.o3d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.p3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.p3d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.q3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.q3d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.r3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.r3d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.s3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, IntSerializer_getInstance(), value.s3d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.t3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, StringSerializer_getInstance(), value.t3d_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.u3d_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, BooleanSerializer_getInstance(), value.u3d_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_175).on = function (encoder, value) {
    return this.l3d(encoder, value instanceof SetupAppearanceChoices ? value : THROW_CCE());
  };
  protoOf($serializer_175).pn = function (decoder) {
    var tmp0_desc = this.k3d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.hr(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.hr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.hr(tmp0_desc, 6, IntSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.hr(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, BooleanSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupAppearanceChoices_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_175).nn = function () {
    return this.k3d_1;
  };
  protoOf($serializer_175).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
  };
  var $serializer_instance_174;
  function $serializer_getInstance_174() {
    if ($serializer_instance_174 == null)
      new $serializer_175();
    return $serializer_instance_174;
  }
  function SetupAppearanceChoices_init_$Init$(seen0, colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_174().k3d_1);
    }
    if (0 === (seen0 & 1))
      $this.m3d_1 = null;
    else
      $this.m3d_1 = colorMode;
    if (0 === (seen0 & 2))
      $this.n3d_1 = null;
    else
      $this.n3d_1 = primaryColor;
    if (0 === (seen0 & 4))
      $this.o3d_1 = null;
    else
      $this.o3d_1 = secondaryColor;
    if (0 === (seen0 & 8))
      $this.p3d_1 = null;
    else
      $this.p3d_1 = accentColor;
    if (0 === (seen0 & 16))
      $this.q3d_1 = null;
    else
      $this.q3d_1 = fontFamily;
    if (0 === (seen0 & 32))
      $this.r3d_1 = null;
    else
      $this.r3d_1 = sidebarPosition;
    if (0 === (seen0 & 64))
      $this.s3d_1 = null;
    else
      $this.s3d_1 = itemsPerPage;
    if (0 === (seen0 & 128))
      $this.t3d_1 = null;
    else
      $this.t3d_1 = density;
    if (0 === (seen0 & 256))
      $this.u3d_1 = null;
    else
      $this.u3d_1 = arabicNumerals;
    return $this;
  }
  function SetupAppearanceChoices_init_$Create$(seen0, colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals, serializationConstructorMarker) {
    return SetupAppearanceChoices_init_$Init$(seen0, colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals, serializationConstructorMarker, objectCreate(protoOf(SetupAppearanceChoices)));
  }
  function SetupAppearanceChoices(colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals) {
    colorMode = colorMode === VOID ? null : colorMode;
    primaryColor = primaryColor === VOID ? null : primaryColor;
    secondaryColor = secondaryColor === VOID ? null : secondaryColor;
    accentColor = accentColor === VOID ? null : accentColor;
    fontFamily = fontFamily === VOID ? null : fontFamily;
    sidebarPosition = sidebarPosition === VOID ? null : sidebarPosition;
    itemsPerPage = itemsPerPage === VOID ? null : itemsPerPage;
    density = density === VOID ? null : density;
    arabicNumerals = arabicNumerals === VOID ? null : arabicNumerals;
    this.m3d_1 = colorMode;
    this.n3d_1 = primaryColor;
    this.o3d_1 = secondaryColor;
    this.p3d_1 = accentColor;
    this.q3d_1 = fontFamily;
    this.r3d_1 = sidebarPosition;
    this.s3d_1 = itemsPerPage;
    this.t3d_1 = density;
    this.u3d_1 = arabicNumerals;
  }
  protoOf(SetupAppearanceChoices).v3d = function (colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals) {
    return new SetupAppearanceChoices(colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals);
  };
  protoOf(SetupAppearanceChoices).w3d = function (colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals, $super) {
    colorMode = colorMode === VOID ? this.m3d_1 : colorMode;
    primaryColor = primaryColor === VOID ? this.n3d_1 : primaryColor;
    secondaryColor = secondaryColor === VOID ? this.o3d_1 : secondaryColor;
    accentColor = accentColor === VOID ? this.p3d_1 : accentColor;
    fontFamily = fontFamily === VOID ? this.q3d_1 : fontFamily;
    sidebarPosition = sidebarPosition === VOID ? this.r3d_1 : sidebarPosition;
    itemsPerPage = itemsPerPage === VOID ? this.s3d_1 : itemsPerPage;
    density = density === VOID ? this.t3d_1 : density;
    arabicNumerals = arabicNumerals === VOID ? this.u3d_1 : arabicNumerals;
    return $super === VOID ? this.v3d(colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals) : $super.v3d.call(this, colorMode, primaryColor, secondaryColor, accentColor, fontFamily, sidebarPosition, itemsPerPage, density, arabicNumerals);
  };
  protoOf(SetupAppearanceChoices).toString = function () {
    return 'SetupAppearanceChoices(colorMode=' + this.m3d_1 + ', primaryColor=' + this.n3d_1 + ', secondaryColor=' + this.o3d_1 + ', accentColor=' + this.p3d_1 + ', fontFamily=' + this.q3d_1 + ', sidebarPosition=' + this.r3d_1 + ', itemsPerPage=' + this.s3d_1 + ', density=' + this.t3d_1 + ', arabicNumerals=' + this.u3d_1 + ')';
  };
  protoOf(SetupAppearanceChoices).hashCode = function () {
    var result = this.m3d_1 == null ? 0 : getStringHashCode(this.m3d_1);
    result = imul(result, 31) + (this.n3d_1 == null ? 0 : getStringHashCode(this.n3d_1)) | 0;
    result = imul(result, 31) + (this.o3d_1 == null ? 0 : getStringHashCode(this.o3d_1)) | 0;
    result = imul(result, 31) + (this.p3d_1 == null ? 0 : getStringHashCode(this.p3d_1)) | 0;
    result = imul(result, 31) + (this.q3d_1 == null ? 0 : getStringHashCode(this.q3d_1)) | 0;
    result = imul(result, 31) + (this.r3d_1 == null ? 0 : getStringHashCode(this.r3d_1)) | 0;
    result = imul(result, 31) + (this.s3d_1 == null ? 0 : this.s3d_1) | 0;
    result = imul(result, 31) + (this.t3d_1 == null ? 0 : getStringHashCode(this.t3d_1)) | 0;
    result = imul(result, 31) + (this.u3d_1 == null ? 0 : getBooleanHashCode(this.u3d_1)) | 0;
    return result;
  };
  protoOf(SetupAppearanceChoices).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAppearanceChoices))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAppearanceChoices ? other : THROW_CCE();
    if (!(this.m3d_1 == tmp0_other_with_cast.m3d_1))
      return false;
    if (!(this.n3d_1 == tmp0_other_with_cast.n3d_1))
      return false;
    if (!(this.o3d_1 == tmp0_other_with_cast.o3d_1))
      return false;
    if (!(this.p3d_1 == tmp0_other_with_cast.p3d_1))
      return false;
    if (!(this.q3d_1 == tmp0_other_with_cast.q3d_1))
      return false;
    if (!(this.r3d_1 == tmp0_other_with_cast.r3d_1))
      return false;
    if (!(this.s3d_1 == tmp0_other_with_cast.s3d_1))
      return false;
    if (!(this.t3d_1 == tmp0_other_with_cast.t3d_1))
      return false;
    if (!(this.u3d_1 == tmp0_other_with_cast.u3d_1))
      return false;
    return true;
  };
  function SetupAppearanceValidation(normalized, errors) {
    this.x3d_1 = normalized;
    this.y3d_1 = errors;
  }
  protoOf(SetupAppearanceValidation).toString = function () {
    return 'SetupAppearanceValidation(normalized=' + toString_0(this.x3d_1) + ', errors=' + toString(this.y3d_1) + ')';
  };
  protoOf(SetupAppearanceValidation).hashCode = function () {
    var result = this.x3d_1 == null ? 0 : this.x3d_1.hashCode();
    result = imul(result, 31) + hashCode(this.y3d_1) | 0;
    return result;
  };
  protoOf(SetupAppearanceValidation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAppearanceValidation))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAppearanceValidation ? other : THROW_CCE();
    if (!equals(this.x3d_1, tmp0_other_with_cast.x3d_1))
      return false;
    if (!equals(this.y3d_1, tmp0_other_with_cast.y3d_1))
      return false;
    return true;
  };
  function validate$allowed(errors, path, field, choices) {
    if (!(field == null) && !choices.r(field)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element = new ConsoleFieldError('appearance.' + path, 'unsupported', 'validation.appearance.' + path);
      errors.e(element);
    }
  }
  function SetupAppearanceRules() {
    SetupAppearanceRules_instance = this;
    this.z3d_1 = setOf(['SYSTEM', 'LIGHT', 'DARK']);
    this.a3e_1 = setOf(['inter', 'roboto', 'poppins', 'noto_sans', 'lama_sans']);
    this.b3e_1 = setOf(['left', 'right']);
    this.c3e_1 = setOf([10, 25, 50, 100]);
    this.d3e_1 = setOf(['COMFORTABLE', 'COMPACT']);
  }
  protoOf(SetupAppearanceRules).e3e = function (value) {
    if (value == null)
      return new SetupAppearanceValidation(null, emptyList());
    var tmp0_safe_receiver = value.m3d_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp = toString(trim(isCharSequence(tmp0_safe_receiver) ? tmp0_safe_receiver : THROW_CCE()));
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = tmp1_safe_receiver.toUpperCase();
    }
    var tmp_1 = tmp_0;
    var tmp2_safe_receiver = value.n3d_1;
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp_2 = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
    }
    var tmp3_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp3_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_3 = tmp3_safe_receiver.toUpperCase();
    }
    var tmp_4 = tmp_3;
    var tmp4_safe_receiver = value.o3d_1;
    var tmp_5;
    if (tmp4_safe_receiver == null) {
      tmp_5 = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp_5 = toString(trim(isCharSequence(tmp4_safe_receiver) ? tmp4_safe_receiver : THROW_CCE()));
    }
    var tmp5_safe_receiver = tmp_5;
    var tmp_6;
    if (tmp5_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_6 = tmp5_safe_receiver.toUpperCase();
    }
    var tmp_7 = tmp_6;
    var tmp6_safe_receiver = value.p3d_1;
    var tmp_8;
    if (tmp6_safe_receiver == null) {
      tmp_8 = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp_8 = toString(trim(isCharSequence(tmp6_safe_receiver) ? tmp6_safe_receiver : THROW_CCE()));
    }
    var tmp7_safe_receiver = tmp_8;
    var tmp_9;
    if (tmp7_safe_receiver == null) {
      tmp_9 = null;
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_9 = tmp7_safe_receiver.toUpperCase();
    }
    var tmp_10 = tmp_9;
    var tmp8_safe_receiver = value.q3d_1;
    var tmp_11;
    if (tmp8_safe_receiver == null) {
      tmp_11 = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp_11 = toString(trim(isCharSequence(tmp8_safe_receiver) ? tmp8_safe_receiver : THROW_CCE()));
    }
    var tmp9_safe_receiver = tmp_11;
    var tmp_12;
    if (tmp9_safe_receiver == null) {
      tmp_12 = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_12 = tmp9_safe_receiver.toLowerCase();
    }
    var tmp_13 = tmp_12;
    var tmp10_safe_receiver = value.r3d_1;
    var tmp_14;
    if (tmp10_safe_receiver == null) {
      tmp_14 = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp_14 = toString(trim(isCharSequence(tmp10_safe_receiver) ? tmp10_safe_receiver : THROW_CCE()));
    }
    var tmp11_safe_receiver = tmp_14;
    var tmp_15;
    if (tmp11_safe_receiver == null) {
      tmp_15 = null;
    } else {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_15 = tmp11_safe_receiver.toLowerCase();
    }
    var tmp_16 = tmp_15;
    var tmp12_safe_receiver = value.t3d_1;
    var tmp_17;
    if (tmp12_safe_receiver == null) {
      tmp_17 = null;
    } else {
      // Inline function 'kotlin.text.trim' call
      tmp_17 = toString(trim(isCharSequence(tmp12_safe_receiver) ? tmp12_safe_receiver : THROW_CCE()));
    }
    var tmp13_safe_receiver = tmp_17;
    var tmp_18;
    if (tmp13_safe_receiver == null) {
      tmp_18 = null;
    } else {
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp_18 = tmp13_safe_receiver.toUpperCase();
    }
    var normalized = value.w3d(tmp_1, tmp_4, tmp_7, tmp_10, tmp_13, tmp_16, VOID, tmp_18);
    // Inline function 'kotlin.collections.mutableListOf' call
    var errors = ArrayList_init_$Create$();
    validate$allowed(errors, 'colorMode', normalized.m3d_1, this.z3d_1);
    validate$allowed(errors, 'fontFamily', normalized.q3d_1, this.a3e_1);
    validate$allowed(errors, 'sidebarPosition', normalized.r3d_1, this.b3e_1);
    validate$allowed(errors, 'density', normalized.t3d_1, this.d3e_1);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = listOf([to('primaryColor', normalized.n3d_1), to('secondaryColor', normalized.o3d_1), to('accentColor', normalized.p3d_1)]).g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'com.ems.console.api.SetupAppearanceRules.validate.<anonymous>' call
      var path = element.ug();
      var field = element.vg();
      var tmp_19;
      if (!(field == null)) {
        // Inline function 'kotlin.text.matches' call
        tmp_19 = !Regex_init_$Create$('#[0-9A-F]{6}').nd(field);
      } else {
        tmp_19 = false;
      }
      if (tmp_19) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = new ConsoleFieldError('appearance.' + path, 'invalid_color', 'validation.appearance.color');
        errors.e(element_0);
      }
    }
    if (!(normalized.s3d_1 == null) && !this.c3e_1.r(normalized.s3d_1)) {
      // Inline function 'kotlin.collections.plusAssign' call
      var element_1 = new ConsoleFieldError('appearance.itemsPerPage', 'unsupported', 'validation.appearance.itemsPerPage');
      errors.e(element_1);
    }
    return new SetupAppearanceValidation(normalized, errors);
  };
  var SetupAppearanceRules_instance;
  function SetupAppearanceRules_getInstance() {
    if (SetupAppearanceRules_instance == null)
      new SetupAppearanceRules();
    return SetupAppearanceRules_instance;
  }
  function Companion_148() {
    Companion_instance_148 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f3e_1 = [null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_177()), null, null, null, null, Companion_getInstance_115().w19()];
  }
  var Companion_instance_148;
  function Companion_getInstance_148() {
    if (Companion_instance_148 == null)
      new Companion_148();
    return Companion_instance_148;
  }
  function $serializer_176() {
    $serializer_instance_175 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupAttemptView', this, 15);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('draftId', false);
    tmp0_serialDesc.gy('acceptedRevision', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantSlug', false);
    tmp0_serialDesc.gy('tenantState', false);
    tmp0_serialDesc.gy('jobId', false);
    tmp0_serialDesc.gy('stage', false);
    tmp0_serialDesc.gy('jobStatus', false);
    tmp0_serialDesc.gy('steps', false);
    tmp0_serialDesc.gy('failureKind', true);
    tmp0_serialDesc.gy('tenantUsable', false);
    tmp0_serialDesc.gy('updatedAtMs', false);
    tmp0_serialDesc.gy('resumePending', true);
    tmp0_serialDesc.gy('startMode', true);
    this.g3e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_176).h3e = function (encoder, value) {
    var tmp0_desc = this.g3e_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_148().f3e_1;
    tmp1_output.hs(tmp0_desc, 0, value.i3e_1);
    tmp1_output.hs(tmp0_desc, 1, value.j3e_1);
    tmp1_output.ds(tmp0_desc, 2, value.k3e_1);
    tmp1_output.hs(tmp0_desc, 3, value.l3e_1);
    tmp1_output.hs(tmp0_desc, 4, value.m3e_1);
    tmp1_output.hs(tmp0_desc, 5, value.n3e_1);
    tmp1_output.hs(tmp0_desc, 6, value.o3e_1);
    tmp1_output.hs(tmp0_desc, 7, value.p3e_1);
    tmp1_output.hs(tmp0_desc, 8, value.q3e_1);
    tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.r3e_1);
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.s3e_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.s3e_1);
    }
    tmp1_output.zr(tmp0_desc, 11, value.t3e_1);
    tmp1_output.ds(tmp0_desc, 12, value.u3e_1);
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.v3e_1 === false)) {
      tmp1_output.zr(tmp0_desc, 13, value.v3e_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !(value.w3e_1 == null)) {
      tmp1_output.ls(tmp0_desc, 14, tmp2_cached[14], value.w3e_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_176).on = function (encoder, value) {
    return this.h3e(encoder, value instanceof SetupAttemptView ? value : THROW_CCE());
  };
  protoOf($serializer_176).pn = function (decoder) {
    var tmp0_desc = this.g3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = false;
    var tmp16_local12 = new Long(0, 0);
    var tmp17_local13 = false;
    var tmp18_local14 = null;
    var tmp19_input = decoder.tq(tmp0_desc);
    var tmp20_cached = Companion_getInstance_148().f3e_1;
    if (tmp19_input.ir()) {
      tmp4_local0 = tmp19_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp19_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp19_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp19_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp19_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp19_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp19_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp19_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp19_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp19_input.fr(tmp0_desc, 9, tmp20_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp19_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp19_input.vq(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp19_input.zq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp19_input.vq(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp19_input.hr(tmp0_desc, 14, tmp20_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp19_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp19_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp19_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp19_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp19_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp19_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp19_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp19_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp19_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp19_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp19_input.fr(tmp0_desc, 9, tmp20_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp19_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp19_input.vq(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp19_input.zq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp19_input.vq(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp19_input.hr(tmp0_desc, 14, tmp20_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp19_input.uq(tmp0_desc);
    return SetupAttemptView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
  };
  protoOf($serializer_176).nn = function () {
    return this.g3e_1;
  };
  protoOf($serializer_176).vy = function () {
    var tmp0_cached = Companion_getInstance_148().f3e_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[9], get_nullable(StringSerializer_getInstance()), BooleanSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(tmp0_cached[14])];
  };
  var $serializer_instance_175;
  function $serializer_getInstance_175() {
    if ($serializer_instance_175 == null)
      new $serializer_176();
    return $serializer_instance_175;
  }
  function SetupAttemptView_init_$Init$(seen0, attemptId, draftId, acceptedRevision, tenantId, tenantSlug, tenantState, jobId, stage, jobStatus, steps, failureKind, tenantUsable, updatedAtMs, resumePending, startMode, serializationConstructorMarker, $this) {
    if (!(7167 === (7167 & seen0))) {
      throwMissingFieldException(seen0, 7167, $serializer_getInstance_175().g3e_1);
    }
    $this.i3e_1 = attemptId;
    $this.j3e_1 = draftId;
    $this.k3e_1 = acceptedRevision;
    $this.l3e_1 = tenantId;
    $this.m3e_1 = tenantSlug;
    $this.n3e_1 = tenantState;
    $this.o3e_1 = jobId;
    $this.p3e_1 = stage;
    $this.q3e_1 = jobStatus;
    $this.r3e_1 = steps;
    if (0 === (seen0 & 1024))
      $this.s3e_1 = null;
    else
      $this.s3e_1 = failureKind;
    $this.t3e_1 = tenantUsable;
    $this.u3e_1 = updatedAtMs;
    if (0 === (seen0 & 8192))
      $this.v3e_1 = false;
    else
      $this.v3e_1 = resumePending;
    if (0 === (seen0 & 16384))
      $this.w3e_1 = null;
    else
      $this.w3e_1 = startMode;
    return $this;
  }
  function SetupAttemptView_init_$Create$(seen0, attemptId, draftId, acceptedRevision, tenantId, tenantSlug, tenantState, jobId, stage, jobStatus, steps, failureKind, tenantUsable, updatedAtMs, resumePending, startMode, serializationConstructorMarker) {
    return SetupAttemptView_init_$Init$(seen0, attemptId, draftId, acceptedRevision, tenantId, tenantSlug, tenantState, jobId, stage, jobStatus, steps, failureKind, tenantUsable, updatedAtMs, resumePending, startMode, serializationConstructorMarker, objectCreate(protoOf(SetupAttemptView)));
  }
  function SetupAttemptView(attemptId, draftId, acceptedRevision, tenantId, tenantSlug, tenantState, jobId, stage, jobStatus, steps, failureKind, tenantUsable, updatedAtMs, resumePending, startMode) {
    Companion_getInstance_148();
    failureKind = failureKind === VOID ? null : failureKind;
    resumePending = resumePending === VOID ? false : resumePending;
    startMode = startMode === VOID ? null : startMode;
    this.i3e_1 = attemptId;
    this.j3e_1 = draftId;
    this.k3e_1 = acceptedRevision;
    this.l3e_1 = tenantId;
    this.m3e_1 = tenantSlug;
    this.n3e_1 = tenantState;
    this.o3e_1 = jobId;
    this.p3e_1 = stage;
    this.q3e_1 = jobStatus;
    this.r3e_1 = steps;
    this.s3e_1 = failureKind;
    this.t3e_1 = tenantUsable;
    this.u3e_1 = updatedAtMs;
    this.v3e_1 = resumePending;
    this.w3e_1 = startMode;
  }
  protoOf(SetupAttemptView).toString = function () {
    return 'SetupAttemptView(attemptId=' + this.i3e_1 + ', draftId=' + this.j3e_1 + ', acceptedRevision=' + this.k3e_1.toString() + ', tenantId=' + this.l3e_1 + ', tenantSlug=' + this.m3e_1 + ', tenantState=' + this.n3e_1 + ', jobId=' + this.o3e_1 + ', stage=' + this.p3e_1 + ', jobStatus=' + this.q3e_1 + ', steps=' + toString(this.r3e_1) + ', failureKind=' + this.s3e_1 + ', tenantUsable=' + this.t3e_1 + ', updatedAtMs=' + this.u3e_1.toString() + ', resumePending=' + this.v3e_1 + ', startMode=' + toString_0(this.w3e_1) + ')';
  };
  protoOf(SetupAttemptView).hashCode = function () {
    var result = getStringHashCode(this.i3e_1);
    result = imul(result, 31) + getStringHashCode(this.j3e_1) | 0;
    result = imul(result, 31) + this.k3e_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.l3e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m3e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n3e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o3e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p3e_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q3e_1) | 0;
    result = imul(result, 31) + hashCode(this.r3e_1) | 0;
    result = imul(result, 31) + (this.s3e_1 == null ? 0 : getStringHashCode(this.s3e_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t3e_1) | 0;
    result = imul(result, 31) + this.u3e_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v3e_1) | 0;
    result = imul(result, 31) + (this.w3e_1 == null ? 0 : this.w3e_1.hashCode()) | 0;
    return result;
  };
  protoOf(SetupAttemptView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAttemptView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAttemptView ? other : THROW_CCE();
    if (!(this.i3e_1 === tmp0_other_with_cast.i3e_1))
      return false;
    if (!(this.j3e_1 === tmp0_other_with_cast.j3e_1))
      return false;
    if (!this.k3e_1.equals(tmp0_other_with_cast.k3e_1))
      return false;
    if (!(this.l3e_1 === tmp0_other_with_cast.l3e_1))
      return false;
    if (!(this.m3e_1 === tmp0_other_with_cast.m3e_1))
      return false;
    if (!(this.n3e_1 === tmp0_other_with_cast.n3e_1))
      return false;
    if (!(this.o3e_1 === tmp0_other_with_cast.o3e_1))
      return false;
    if (!(this.p3e_1 === tmp0_other_with_cast.p3e_1))
      return false;
    if (!(this.q3e_1 === tmp0_other_with_cast.q3e_1))
      return false;
    if (!equals(this.r3e_1, tmp0_other_with_cast.r3e_1))
      return false;
    if (!(this.s3e_1 == tmp0_other_with_cast.s3e_1))
      return false;
    if (!(this.t3e_1 === tmp0_other_with_cast.t3e_1))
      return false;
    if (!this.u3e_1.equals(tmp0_other_with_cast.u3e_1))
      return false;
    if (!(this.v3e_1 === tmp0_other_with_cast.v3e_1))
      return false;
    if (!equals(this.w3e_1, tmp0_other_with_cast.w3e_1))
      return false;
    return true;
  };
  function Companion_149() {
  }
  var Companion_instance_149;
  function Companion_getInstance_149() {
    return Companion_instance_149;
  }
  function $serializer_177() {
    $serializer_instance_176 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupAttemptResumeReceipt', this, 2);
    tmp0_serialDesc.gy('requestId', false);
    tmp0_serialDesc.gy('attemptId', false);
    this.x3e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_177).y3e = function (encoder, value) {
    var tmp0_desc = this.x3e_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.z3e_1);
    tmp1_output.hs(tmp0_desc, 1, value.a3f_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_177).on = function (encoder, value) {
    return this.y3e(encoder, value instanceof SetupAttemptResumeReceipt ? value : THROW_CCE());
  };
  protoOf($serializer_177).pn = function (decoder) {
    var tmp0_desc = this.x3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SetupAttemptResumeReceipt_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_177).nn = function () {
    return this.x3e_1;
  };
  protoOf($serializer_177).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_176;
  function $serializer_getInstance_176() {
    if ($serializer_instance_176 == null)
      new $serializer_177();
    return $serializer_instance_176;
  }
  function SetupAttemptResumeReceipt_init_$Init$(seen0, requestId, attemptId, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_176().x3e_1);
    }
    $this.z3e_1 = requestId;
    $this.a3f_1 = attemptId;
    return $this;
  }
  function SetupAttemptResumeReceipt_init_$Create$(seen0, requestId, attemptId, serializationConstructorMarker) {
    return SetupAttemptResumeReceipt_init_$Init$(seen0, requestId, attemptId, serializationConstructorMarker, objectCreate(protoOf(SetupAttemptResumeReceipt)));
  }
  function SetupAttemptResumeReceipt(requestId, attemptId) {
    this.z3e_1 = requestId;
    this.a3f_1 = attemptId;
  }
  protoOf(SetupAttemptResumeReceipt).toString = function () {
    return 'SetupAttemptResumeReceipt(requestId=' + this.z3e_1 + ', attemptId=' + this.a3f_1 + ')';
  };
  protoOf(SetupAttemptResumeReceipt).hashCode = function () {
    var result = getStringHashCode(this.z3e_1);
    result = imul(result, 31) + getStringHashCode(this.a3f_1) | 0;
    return result;
  };
  protoOf(SetupAttemptResumeReceipt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAttemptResumeReceipt))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAttemptResumeReceipt ? other : THROW_CCE();
    if (!(this.z3e_1 === tmp0_other_with_cast.z3e_1))
      return false;
    if (!(this.a3f_1 === tmp0_other_with_cast.a3f_1))
      return false;
    return true;
  };
  function $serializer_178() {
    $serializer_instance_177 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupAttemptStepView', this, 2);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('status', false);
    this.b3f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_178).c3f = function (encoder, value) {
    var tmp0_desc = this.b3f_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.d3f_1);
    tmp1_output.hs(tmp0_desc, 1, value.e3f_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_178).on = function (encoder, value) {
    return this.c3f(encoder, value instanceof SetupAttemptStepView ? value : THROW_CCE());
  };
  protoOf($serializer_178).pn = function (decoder) {
    var tmp0_desc = this.b3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SetupAttemptStepView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_178).nn = function () {
    return this.b3f_1;
  };
  protoOf($serializer_178).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_177;
  function $serializer_getInstance_177() {
    if ($serializer_instance_177 == null)
      new $serializer_178();
    return $serializer_instance_177;
  }
  function SetupAttemptStepView_init_$Init$(seen0, key, status, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_177().b3f_1);
    }
    $this.d3f_1 = key;
    $this.e3f_1 = status;
    return $this;
  }
  function SetupAttemptStepView_init_$Create$(seen0, key, status, serializationConstructorMarker) {
    return SetupAttemptStepView_init_$Init$(seen0, key, status, serializationConstructorMarker, objectCreate(protoOf(SetupAttemptStepView)));
  }
  function SetupAttemptStepView() {
  }
  protoOf(SetupAttemptStepView).toString = function () {
    return 'SetupAttemptStepView(key=' + this.d3f_1 + ', status=' + this.e3f_1 + ')';
  };
  protoOf(SetupAttemptStepView).hashCode = function () {
    var result = getStringHashCode(this.d3f_1);
    result = imul(result, 31) + getStringHashCode(this.e3f_1) | 0;
    return result;
  };
  protoOf(SetupAttemptStepView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAttemptStepView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAttemptStepView ? other : THROW_CCE();
    if (!(this.d3f_1 === tmp0_other_with_cast.d3f_1))
      return false;
    if (!(this.e3f_1 === tmp0_other_with_cast.e3f_1))
      return false;
    return true;
  };
  function SetupAttemptResumeRules() {
  }
  protoOf(SetupAttemptResumeRules).f3f = function (view) {
    return !view.t3e_1 && view.n3e_1 === 'PROVISIONING' && !(view.p3e_1 === 'READY') && !(view.s3e_1 === 'OPTIONAL_SETUP') && setOf(['reserved', 'pending', 'running', 'failed']).r(view.q3e_1);
  };
  var SetupAttemptResumeRules_instance;
  function SetupAttemptResumeRules_getInstance() {
    return SetupAttemptResumeRules_instance;
  }
  function Companion_150() {
    Companion_instance_150 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g3f_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_185()), null, null, null];
  }
  var Companion_instance_150;
  function Companion_getInstance_150() {
    if (Companion_instance_150 == null)
      new Companion_150();
    return Companion_instance_150;
  }
  function $serializer_179() {
    $serializer_instance_178 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCompletionView', this, 8);
    tmp0_serialDesc.gy('attempt', false);
    tmp0_serialDesc.gy('acceptedPlan', false);
    tmp0_serialDesc.gy('currentPlan', false);
    tmp0_serialDesc.gy('currentGrants', false);
    tmp0_serialDesc.gy('tasks', false);
    tmp0_serialDesc.gy('supportVisit', false);
    tmp0_serialDesc.gy('connectionDeferrals', false);
    tmp0_serialDesc.gy('observedAtMs', false);
    this.h3f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_179).i3f = function (encoder, value) {
    var tmp0_desc = this.h3f_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_150().g3f_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_175(), value.j3f_1);
    tmp1_output.js(tmp0_desc, 1, $serializer_getInstance_180(), value.k3f_1);
    tmp1_output.js(tmp0_desc, 2, $serializer_getInstance_183(), value.l3f_1);
    tmp1_output.js(tmp0_desc, 3, $serializer_getInstance_184(), value.m3f_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.n3f_1);
    tmp1_output.js(tmp0_desc, 5, $serializer_getInstance_186(), value.o3f_1);
    tmp1_output.js(tmp0_desc, 6, $serializer_getInstance_186(), value.p3f_1);
    tmp1_output.ds(tmp0_desc, 7, value.q3f_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_179).on = function (encoder, value) {
    return this.i3f(encoder, value instanceof SetupCompletionView ? value : THROW_CCE());
  };
  protoOf($serializer_179).pn = function (decoder) {
    var tmp0_desc = this.h3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = new Long(0, 0);
    var tmp12_input = decoder.tq(tmp0_desc);
    var tmp13_cached = Companion_getInstance_150().g3f_1;
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.fr(tmp0_desc, 0, $serializer_getInstance_175(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.fr(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.fr(tmp0_desc, 2, $serializer_getInstance_183(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.fr(tmp0_desc, 3, $serializer_getInstance_184(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.fr(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.fr(tmp0_desc, 5, $serializer_getInstance_186(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.fr(tmp0_desc, 6, $serializer_getInstance_186(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.fr(tmp0_desc, 0, $serializer_getInstance_175(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.fr(tmp0_desc, 1, $serializer_getInstance_180(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.fr(tmp0_desc, 2, $serializer_getInstance_183(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.fr(tmp0_desc, 3, $serializer_getInstance_184(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.fr(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.fr(tmp0_desc, 5, $serializer_getInstance_186(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.fr(tmp0_desc, 6, $serializer_getInstance_186(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return SetupCompletionView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_179).nn = function () {
    return this.h3f_1;
  };
  protoOf($serializer_179).vy = function () {
    var tmp0_cached = Companion_getInstance_150().g3f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_175(), $serializer_getInstance_180(), $serializer_getInstance_183(), $serializer_getInstance_184(), tmp0_cached[4], $serializer_getInstance_186(), $serializer_getInstance_186(), LongSerializer_getInstance()];
  };
  var $serializer_instance_178;
  function $serializer_getInstance_178() {
    if ($serializer_instance_178 == null)
      new $serializer_179();
    return $serializer_instance_178;
  }
  function SetupCompletionView_init_$Init$(seen0, attempt, acceptedPlan, currentPlan, currentGrants, tasks, supportVisit, connectionDeferrals, observedAtMs, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_178().h3f_1);
    }
    $this.j3f_1 = attempt;
    $this.k3f_1 = acceptedPlan;
    $this.l3f_1 = currentPlan;
    $this.m3f_1 = currentGrants;
    $this.n3f_1 = tasks;
    $this.o3f_1 = supportVisit;
    $this.p3f_1 = connectionDeferrals;
    $this.q3f_1 = observedAtMs;
    return $this;
  }
  function SetupCompletionView_init_$Create$(seen0, attempt, acceptedPlan, currentPlan, currentGrants, tasks, supportVisit, connectionDeferrals, observedAtMs, serializationConstructorMarker) {
    return SetupCompletionView_init_$Init$(seen0, attempt, acceptedPlan, currentPlan, currentGrants, tasks, supportVisit, connectionDeferrals, observedAtMs, serializationConstructorMarker, objectCreate(protoOf(SetupCompletionView)));
  }
  function SetupCompletionView(attempt, acceptedPlan, currentPlan, currentGrants, tasks, supportVisit, connectionDeferrals, observedAtMs) {
    Companion_getInstance_150();
    this.j3f_1 = attempt;
    this.k3f_1 = acceptedPlan;
    this.l3f_1 = currentPlan;
    this.m3f_1 = currentGrants;
    this.n3f_1 = tasks;
    this.o3f_1 = supportVisit;
    this.p3f_1 = connectionDeferrals;
    this.q3f_1 = observedAtMs;
  }
  protoOf(SetupCompletionView).toString = function () {
    return 'SetupCompletionView(attempt=' + this.j3f_1.toString() + ', acceptedPlan=' + this.k3f_1.toString() + ', currentPlan=' + this.l3f_1.toString() + ', currentGrants=' + this.m3f_1.toString() + ', tasks=' + toString(this.n3f_1) + ', supportVisit=' + this.o3f_1.toString() + ', connectionDeferrals=' + this.p3f_1.toString() + ', observedAtMs=' + this.q3f_1.toString() + ')';
  };
  protoOf(SetupCompletionView).hashCode = function () {
    var result = this.j3f_1.hashCode();
    result = imul(result, 31) + this.k3f_1.hashCode() | 0;
    result = imul(result, 31) + this.l3f_1.hashCode() | 0;
    result = imul(result, 31) + this.m3f_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.n3f_1) | 0;
    result = imul(result, 31) + this.o3f_1.hashCode() | 0;
    result = imul(result, 31) + this.p3f_1.hashCode() | 0;
    result = imul(result, 31) + this.q3f_1.hashCode() | 0;
    return result;
  };
  protoOf(SetupCompletionView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCompletionView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCompletionView ? other : THROW_CCE();
    if (!this.j3f_1.equals(tmp0_other_with_cast.j3f_1))
      return false;
    if (!this.k3f_1.equals(tmp0_other_with_cast.k3f_1))
      return false;
    if (!this.l3f_1.equals(tmp0_other_with_cast.l3f_1))
      return false;
    if (!this.m3f_1.equals(tmp0_other_with_cast.m3f_1))
      return false;
    if (!equals(this.n3f_1, tmp0_other_with_cast.n3f_1))
      return false;
    if (!this.o3f_1.equals(tmp0_other_with_cast.o3f_1))
      return false;
    if (!this.p3f_1.equals(tmp0_other_with_cast.p3f_1))
      return false;
    if (!this.q3f_1.equals(tmp0_other_with_cast.q3f_1))
      return false;
    return true;
  };
  function SetupCompletionApiPaths() {
  }
  protoOf(SetupCompletionApiPaths).r3f = function (encodedAttemptId) {
    return '/api/console/setup-attempts/' + encodedAttemptId + '/completion';
  };
  var SetupCompletionApiPaths_instance;
  function SetupCompletionApiPaths_getInstance() {
    return SetupCompletionApiPaths_instance;
  }
  function Companion_151() {
  }
  var Companion_instance_151;
  function Companion_getInstance_151() {
    return Companion_instance_151;
  }
  function $serializer_180() {
    $serializer_instance_179 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupLimitGrant', this, 9);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('value', false);
    tmp0_serialDesc.gy('unlimited', false);
    tmp0_serialDesc.gy('unit', false);
    tmp0_serialDesc.gy('period', false);
    tmp0_serialDesc.gy('mode', false);
    tmp0_serialDesc.gy('source', false);
    this.s3f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_180).t3f = function (encoder, value) {
    var tmp0_desc = this.s3f_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.u3f_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.v3f_1);
    tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.w3f_1);
    tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.x3f_1);
    tmp1_output.zr(tmp0_desc, 4, value.y3f_1);
    tmp1_output.hs(tmp0_desc, 5, value.z3f_1);
    tmp1_output.hs(tmp0_desc, 6, value.a3g_1);
    tmp1_output.hs(tmp0_desc, 7, value.b3g_1);
    tmp1_output.hs(tmp0_desc, 8, value.c3g_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_180).on = function (encoder, value) {
    return this.t3f(encoder, value instanceof SetupLimitGrant ? value : THROW_CCE());
  };
  protoOf($serializer_180).pn = function (decoder) {
    var tmp0_desc = this.s3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupLimitGrant_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_180).nn = function () {
    return this.s3f_1;
  };
  protoOf($serializer_180).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_179;
  function $serializer_getInstance_179() {
    if ($serializer_instance_179 == null)
      new $serializer_180();
    return $serializer_instance_179;
  }
  function SetupLimitGrant_init_$Init$(seen0, key, nameEn, nameAr, value, unlimited, unit, period, mode, source, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_179().s3f_1);
    }
    $this.u3f_1 = key;
    $this.v3f_1 = nameEn;
    $this.w3f_1 = nameAr;
    $this.x3f_1 = value;
    $this.y3f_1 = unlimited;
    $this.z3f_1 = unit;
    $this.a3g_1 = period;
    $this.b3g_1 = mode;
    $this.c3g_1 = source;
    return $this;
  }
  function SetupLimitGrant_init_$Create$(seen0, key, nameEn, nameAr, value, unlimited, unit, period, mode, source, serializationConstructorMarker) {
    return SetupLimitGrant_init_$Init$(seen0, key, nameEn, nameAr, value, unlimited, unit, period, mode, source, serializationConstructorMarker, objectCreate(protoOf(SetupLimitGrant)));
  }
  function SetupLimitGrant(key, nameEn, nameAr, value, unlimited, unit, period, mode, source) {
    this.u3f_1 = key;
    this.v3f_1 = nameEn;
    this.w3f_1 = nameAr;
    this.x3f_1 = value;
    this.y3f_1 = unlimited;
    this.z3f_1 = unit;
    this.a3g_1 = period;
    this.b3g_1 = mode;
    this.c3g_1 = source;
  }
  protoOf(SetupLimitGrant).toString = function () {
    return 'SetupLimitGrant(key=' + this.u3f_1 + ', nameEn=' + this.v3f_1 + ', nameAr=' + this.w3f_1 + ', value=' + toString_0(this.x3f_1) + ', unlimited=' + this.y3f_1 + ', unit=' + this.z3f_1 + ', period=' + this.a3g_1 + ', mode=' + this.b3g_1 + ', source=' + this.c3g_1 + ')';
  };
  protoOf(SetupLimitGrant).hashCode = function () {
    var result = getStringHashCode(this.u3f_1);
    result = imul(result, 31) + (this.v3f_1 == null ? 0 : getStringHashCode(this.v3f_1)) | 0;
    result = imul(result, 31) + (this.w3f_1 == null ? 0 : getStringHashCode(this.w3f_1)) | 0;
    result = imul(result, 31) + (this.x3f_1 == null ? 0 : this.x3f_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y3f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z3f_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a3g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b3g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c3g_1) | 0;
    return result;
  };
  protoOf(SetupLimitGrant).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupLimitGrant))
      return false;
    var tmp0_other_with_cast = other instanceof SetupLimitGrant ? other : THROW_CCE();
    if (!(this.u3f_1 === tmp0_other_with_cast.u3f_1))
      return false;
    if (!(this.v3f_1 == tmp0_other_with_cast.v3f_1))
      return false;
    if (!(this.w3f_1 == tmp0_other_with_cast.w3f_1))
      return false;
    if (!equals(this.x3f_1, tmp0_other_with_cast.x3f_1))
      return false;
    if (!(this.y3f_1 === tmp0_other_with_cast.y3f_1))
      return false;
    if (!(this.z3f_1 === tmp0_other_with_cast.z3f_1))
      return false;
    if (!(this.a3g_1 === tmp0_other_with_cast.a3g_1))
      return false;
    if (!(this.b3g_1 === tmp0_other_with_cast.b3g_1))
      return false;
    if (!(this.c3g_1 === tmp0_other_with_cast.c3g_1))
      return false;
    return true;
  };
  function $serializer_181() {
    $serializer_instance_180 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupAcceptedPlanRecord', this, 6);
    tmp0_serialDesc.gy('source', true);
    tmp0_serialDesc.gy('acceptedAtMs', false);
    tmp0_serialDesc.gy('planDetailsFrozen', true);
    tmp0_serialDesc.gy('planDetailsStatus', false);
    tmp0_serialDesc.gy('assignment', false);
    tmp0_serialDesc.gy('details', true);
    this.d3g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_181).e3g = function (encoder, value) {
    var tmp0_desc = this.d3g_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.f3g_1 === 'ACCEPTED_SETUP')) {
      tmp1_output.hs(tmp0_desc, 0, value.f3g_1);
    }
    tmp1_output.ds(tmp0_desc, 1, value.g3g_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.h3g_1 === false)) {
      tmp1_output.zr(tmp0_desc, 2, value.h3g_1);
    }
    tmp1_output.hs(tmp0_desc, 3, value.i3g_1);
    tmp1_output.hs(tmp0_desc, 4, value.j3g_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.k3g_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, $serializer_getInstance_181(), value.k3g_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_181).on = function (encoder, value) {
    return this.e3g(encoder, value instanceof SetupAcceptedPlanRecord ? value : THROW_CCE());
  };
  protoOf($serializer_181).pn = function (decoder) {
    var tmp0_desc = this.d3g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = false;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, $serializer_getInstance_181(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, $serializer_getInstance_181(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return SetupAcceptedPlanRecord_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_181).nn = function () {
    return this.d3g_1;
  };
  protoOf($serializer_181).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_181())];
  };
  var $serializer_instance_180;
  function $serializer_getInstance_180() {
    if ($serializer_instance_180 == null)
      new $serializer_181();
    return $serializer_instance_180;
  }
  function SetupAcceptedPlanRecord_init_$Init$(seen0, source, acceptedAtMs, planDetailsFrozen, planDetailsStatus, assignment, details, serializationConstructorMarker, $this) {
    if (!(26 === (26 & seen0))) {
      throwMissingFieldException(seen0, 26, $serializer_getInstance_180().d3g_1);
    }
    if (0 === (seen0 & 1))
      $this.f3g_1 = 'ACCEPTED_SETUP';
    else
      $this.f3g_1 = source;
    $this.g3g_1 = acceptedAtMs;
    if (0 === (seen0 & 4))
      $this.h3g_1 = false;
    else
      $this.h3g_1 = planDetailsFrozen;
    $this.i3g_1 = planDetailsStatus;
    $this.j3g_1 = assignment;
    if (0 === (seen0 & 32))
      $this.k3g_1 = null;
    else
      $this.k3g_1 = details;
    return $this;
  }
  function SetupAcceptedPlanRecord_init_$Create$(seen0, source, acceptedAtMs, planDetailsFrozen, planDetailsStatus, assignment, details, serializationConstructorMarker) {
    return SetupAcceptedPlanRecord_init_$Init$(seen0, source, acceptedAtMs, planDetailsFrozen, planDetailsStatus, assignment, details, serializationConstructorMarker, objectCreate(protoOf(SetupAcceptedPlanRecord)));
  }
  function SetupAcceptedPlanRecord() {
  }
  protoOf(SetupAcceptedPlanRecord).toString = function () {
    return 'SetupAcceptedPlanRecord(source=' + this.f3g_1 + ', acceptedAtMs=' + this.g3g_1.toString() + ', planDetailsFrozen=' + this.h3g_1 + ', planDetailsStatus=' + this.i3g_1 + ', assignment=' + this.j3g_1 + ', details=' + toString_0(this.k3g_1) + ')';
  };
  protoOf(SetupAcceptedPlanRecord).hashCode = function () {
    var result = getStringHashCode(this.f3g_1);
    result = imul(result, 31) + this.g3g_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h3g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i3g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j3g_1) | 0;
    result = imul(result, 31) + (this.k3g_1 == null ? 0 : this.k3g_1.hashCode()) | 0;
    return result;
  };
  protoOf(SetupAcceptedPlanRecord).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAcceptedPlanRecord))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAcceptedPlanRecord ? other : THROW_CCE();
    if (!(this.f3g_1 === tmp0_other_with_cast.f3g_1))
      return false;
    if (!this.g3g_1.equals(tmp0_other_with_cast.g3g_1))
      return false;
    if (!(this.h3g_1 === tmp0_other_with_cast.h3g_1))
      return false;
    if (!(this.i3g_1 === tmp0_other_with_cast.i3g_1))
      return false;
    if (!(this.j3g_1 === tmp0_other_with_cast.j3g_1))
      return false;
    if (!equals(this.k3g_1, tmp0_other_with_cast.k3g_1))
      return false;
    return true;
  };
  function Companion_152() {
    Companion_instance_152 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l3g_1 = [null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_182()), new ArrayListSerializer($serializer_getInstance_182()), new ArrayListSerializer($serializer_getInstance_179()), new ArrayListSerializer($serializer_getInstance_87())];
  }
  var Companion_instance_152;
  function Companion_getInstance_152() {
    if (Companion_instance_152 == null)
      new Companion_152();
    return Companion_instance_152;
  }
  function $serializer_182() {
    $serializer_instance_181 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupAcceptedPlanDetails', this, 11);
    tmp0_serialDesc.gy('version', true);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('descriptionEn', false);
    tmp0_serialDesc.gy('descriptionAr', false);
    tmp0_serialDesc.gy('planRevision', false);
    tmp0_serialDesc.gy('featureCatalogVersion', false);
    tmp0_serialDesc.gy('modules', false);
    tmp0_serialDesc.gy('features', false);
    tmp0_serialDesc.gy('limits', false);
    tmp0_serialDesc.gy('prices', false);
    this.m3g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_182).n3g = function (encoder, value) {
    var tmp0_desc = this.m3g_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_152().l3g_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.o3g_1 === 1)) {
      tmp1_output.cs(tmp0_desc, 0, value.o3g_1);
    }
    tmp1_output.hs(tmp0_desc, 1, value.p3g_1);
    tmp1_output.hs(tmp0_desc, 2, value.q3g_1);
    tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.r3g_1);
    tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.s3g_1);
    tmp1_output.ds(tmp0_desc, 5, value.t3g_1);
    tmp1_output.cs(tmp0_desc, 6, value.u3g_1);
    tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.v3g_1);
    tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.w3g_1);
    tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.x3g_1);
    tmp1_output.js(tmp0_desc, 10, tmp2_cached[10], value.y3g_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_182).on = function (encoder, value) {
    return this.n3g(encoder, value instanceof SetupAcceptedPlanDetails ? value : THROW_CCE());
  };
  protoOf($serializer_182).pn = function (decoder) {
    var tmp0_desc = this.m3g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.tq(tmp0_desc);
    var tmp16_cached = Companion_getInstance_152().l3g_1;
    if (tmp15_input.ir()) {
      tmp4_local0 = tmp15_input.yq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.yq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.fr(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.fr(tmp0_desc, 8, tmp16_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.fr(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.fr(tmp0_desc, 10, tmp16_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.yq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.yq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.fr(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.fr(tmp0_desc, 8, tmp16_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.fr(tmp0_desc, 9, tmp16_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.fr(tmp0_desc, 10, tmp16_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.uq(tmp0_desc);
    return SetupAcceptedPlanDetails_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_182).nn = function () {
    return this.m3g_1;
  };
  protoOf($serializer_182).vy = function () {
    var tmp0_cached = Companion_getInstance_152().l3g_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), LongSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[7], tmp0_cached[8], tmp0_cached[9], tmp0_cached[10]];
  };
  var $serializer_instance_181;
  function $serializer_getInstance_181() {
    if ($serializer_instance_181 == null)
      new $serializer_182();
    return $serializer_instance_181;
  }
  function SetupAcceptedPlanDetails_init_$Init$(seen0, version, nameEn, nameAr, descriptionEn, descriptionAr, planRevision, featureCatalogVersion, modules, features, limits, prices, serializationConstructorMarker, $this) {
    if (!(2046 === (2046 & seen0))) {
      throwMissingFieldException(seen0, 2046, $serializer_getInstance_181().m3g_1);
    }
    if (0 === (seen0 & 1))
      $this.o3g_1 = 1;
    else
      $this.o3g_1 = version;
    $this.p3g_1 = nameEn;
    $this.q3g_1 = nameAr;
    $this.r3g_1 = descriptionEn;
    $this.s3g_1 = descriptionAr;
    $this.t3g_1 = planRevision;
    $this.u3g_1 = featureCatalogVersion;
    $this.v3g_1 = modules;
    $this.w3g_1 = features;
    $this.x3g_1 = limits;
    $this.y3g_1 = prices;
    return $this;
  }
  function SetupAcceptedPlanDetails_init_$Create$(seen0, version, nameEn, nameAr, descriptionEn, descriptionAr, planRevision, featureCatalogVersion, modules, features, limits, prices, serializationConstructorMarker) {
    return SetupAcceptedPlanDetails_init_$Init$(seen0, version, nameEn, nameAr, descriptionEn, descriptionAr, planRevision, featureCatalogVersion, modules, features, limits, prices, serializationConstructorMarker, objectCreate(protoOf(SetupAcceptedPlanDetails)));
  }
  function SetupAcceptedPlanDetails() {
  }
  protoOf(SetupAcceptedPlanDetails).toString = function () {
    return 'SetupAcceptedPlanDetails(version=' + this.o3g_1 + ', nameEn=' + this.p3g_1 + ', nameAr=' + this.q3g_1 + ', descriptionEn=' + this.r3g_1 + ', descriptionAr=' + this.s3g_1 + ', planRevision=' + this.t3g_1.toString() + ', featureCatalogVersion=' + this.u3g_1 + ', modules=' + toString(this.v3g_1) + ', features=' + toString(this.w3g_1) + ', limits=' + toString(this.x3g_1) + ', prices=' + toString(this.y3g_1) + ')';
  };
  protoOf(SetupAcceptedPlanDetails).hashCode = function () {
    var result = this.o3g_1;
    result = imul(result, 31) + getStringHashCode(this.p3g_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q3g_1) | 0;
    result = imul(result, 31) + (this.r3g_1 == null ? 0 : getStringHashCode(this.r3g_1)) | 0;
    result = imul(result, 31) + (this.s3g_1 == null ? 0 : getStringHashCode(this.s3g_1)) | 0;
    result = imul(result, 31) + this.t3g_1.hashCode() | 0;
    result = imul(result, 31) + this.u3g_1 | 0;
    result = imul(result, 31) + hashCode(this.v3g_1) | 0;
    result = imul(result, 31) + hashCode(this.w3g_1) | 0;
    result = imul(result, 31) + hashCode(this.x3g_1) | 0;
    result = imul(result, 31) + hashCode(this.y3g_1) | 0;
    return result;
  };
  protoOf(SetupAcceptedPlanDetails).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupAcceptedPlanDetails))
      return false;
    var tmp0_other_with_cast = other instanceof SetupAcceptedPlanDetails ? other : THROW_CCE();
    if (!(this.o3g_1 === tmp0_other_with_cast.o3g_1))
      return false;
    if (!(this.p3g_1 === tmp0_other_with_cast.p3g_1))
      return false;
    if (!(this.q3g_1 === tmp0_other_with_cast.q3g_1))
      return false;
    if (!(this.r3g_1 == tmp0_other_with_cast.r3g_1))
      return false;
    if (!(this.s3g_1 == tmp0_other_with_cast.s3g_1))
      return false;
    if (!this.t3g_1.equals(tmp0_other_with_cast.t3g_1))
      return false;
    if (!(this.u3g_1 === tmp0_other_with_cast.u3g_1))
      return false;
    if (!equals(this.v3g_1, tmp0_other_with_cast.v3g_1))
      return false;
    if (!equals(this.w3g_1, tmp0_other_with_cast.w3g_1))
      return false;
    if (!equals(this.x3g_1, tmp0_other_with_cast.x3g_1))
      return false;
    if (!equals(this.y3g_1, tmp0_other_with_cast.y3g_1))
      return false;
    return true;
  };
  function $serializer_183() {
    $serializer_instance_182 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupNamedGrant', this, 4);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('status', true);
    this.z3g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_183).a3h = function (encoder, value) {
    var tmp0_desc = this.z3g_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.b3h_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.c3h_1);
    tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.d3h_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.e3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.e3h_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_183).on = function (encoder, value) {
    return this.a3h(encoder, value instanceof SetupNamedGrant ? value : THROW_CCE());
  };
  protoOf($serializer_183).pn = function (decoder) {
    var tmp0_desc = this.z3g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return SetupNamedGrant_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_183).nn = function () {
    return this.z3g_1;
  };
  protoOf($serializer_183).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_182;
  function $serializer_getInstance_182() {
    if ($serializer_instance_182 == null)
      new $serializer_183();
    return $serializer_instance_182;
  }
  function SetupNamedGrant_init_$Init$(seen0, key, nameEn, nameAr, status, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_182().z3g_1);
    }
    $this.b3h_1 = key;
    $this.c3h_1 = nameEn;
    $this.d3h_1 = nameAr;
    if (0 === (seen0 & 8))
      $this.e3h_1 = null;
    else
      $this.e3h_1 = status;
    return $this;
  }
  function SetupNamedGrant_init_$Create$(seen0, key, nameEn, nameAr, status, serializationConstructorMarker) {
    return SetupNamedGrant_init_$Init$(seen0, key, nameEn, nameAr, status, serializationConstructorMarker, objectCreate(protoOf(SetupNamedGrant)));
  }
  function SetupNamedGrant() {
  }
  protoOf(SetupNamedGrant).toString = function () {
    return 'SetupNamedGrant(key=' + this.b3h_1 + ', nameEn=' + this.c3h_1 + ', nameAr=' + this.d3h_1 + ', status=' + this.e3h_1 + ')';
  };
  protoOf(SetupNamedGrant).hashCode = function () {
    var result = getStringHashCode(this.b3h_1);
    result = imul(result, 31) + (this.c3h_1 == null ? 0 : getStringHashCode(this.c3h_1)) | 0;
    result = imul(result, 31) + (this.d3h_1 == null ? 0 : getStringHashCode(this.d3h_1)) | 0;
    result = imul(result, 31) + (this.e3h_1 == null ? 0 : getStringHashCode(this.e3h_1)) | 0;
    return result;
  };
  protoOf(SetupNamedGrant).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupNamedGrant))
      return false;
    var tmp0_other_with_cast = other instanceof SetupNamedGrant ? other : THROW_CCE();
    if (!(this.b3h_1 === tmp0_other_with_cast.b3h_1))
      return false;
    if (!(this.c3h_1 == tmp0_other_with_cast.c3h_1))
      return false;
    if (!(this.d3h_1 == tmp0_other_with_cast.d3h_1))
      return false;
    if (!(this.e3h_1 == tmp0_other_with_cast.e3h_1))
      return false;
    return true;
  };
  function $serializer_184() {
    $serializer_instance_183 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCurrentPlanSummary', this, 9);
    tmp0_serialDesc.gy('source', true);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('reason', true);
    tmp0_serialDesc.gy('nameEn', true);
    tmp0_serialDesc.gy('nameAr', true);
    tmp0_serialDesc.gy('descriptionEn', true);
    tmp0_serialDesc.gy('descriptionAr', true);
    tmp0_serialDesc.gy('planRevision', true);
    tmp0_serialDesc.gy('lifecycle', true);
    this.f3h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_184).g3h = function (encoder, value) {
    var tmp0_desc = this.f3h_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.h3h_1 === 'CURRENT_CATALOG')) {
      tmp1_output.hs(tmp0_desc, 0, value.h3h_1);
    }
    tmp1_output.hs(tmp0_desc, 1, value.i3h_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.j3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.j3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.k3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.k3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.l3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.l3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.m3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.m3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.n3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.n3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.o3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.o3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.p3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.p3h_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_184).on = function (encoder, value) {
    return this.g3h(encoder, value instanceof SetupCurrentPlanSummary ? value : THROW_CCE());
  };
  protoOf($serializer_184).pn = function (decoder) {
    var tmp0_desc = this.f3h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupCurrentPlanSummary_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_184).nn = function () {
    return this.f3h_1;
  };
  protoOf($serializer_184).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_183;
  function $serializer_getInstance_183() {
    if ($serializer_instance_183 == null)
      new $serializer_184();
    return $serializer_instance_183;
  }
  function SetupCurrentPlanSummary_init_$Init$(seen0, source, status, reason, nameEn, nameAr, descriptionEn, descriptionAr, planRevision, lifecycle, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_183().f3h_1);
    }
    if (0 === (seen0 & 1))
      $this.h3h_1 = 'CURRENT_CATALOG';
    else
      $this.h3h_1 = source;
    $this.i3h_1 = status;
    if (0 === (seen0 & 4))
      $this.j3h_1 = null;
    else
      $this.j3h_1 = reason;
    if (0 === (seen0 & 8))
      $this.k3h_1 = null;
    else
      $this.k3h_1 = nameEn;
    if (0 === (seen0 & 16))
      $this.l3h_1 = null;
    else
      $this.l3h_1 = nameAr;
    if (0 === (seen0 & 32))
      $this.m3h_1 = null;
    else
      $this.m3h_1 = descriptionEn;
    if (0 === (seen0 & 64))
      $this.n3h_1 = null;
    else
      $this.n3h_1 = descriptionAr;
    if (0 === (seen0 & 128))
      $this.o3h_1 = null;
    else
      $this.o3h_1 = planRevision;
    if (0 === (seen0 & 256))
      $this.p3h_1 = null;
    else
      $this.p3h_1 = lifecycle;
    return $this;
  }
  function SetupCurrentPlanSummary_init_$Create$(seen0, source, status, reason, nameEn, nameAr, descriptionEn, descriptionAr, planRevision, lifecycle, serializationConstructorMarker) {
    return SetupCurrentPlanSummary_init_$Init$(seen0, source, status, reason, nameEn, nameAr, descriptionEn, descriptionAr, planRevision, lifecycle, serializationConstructorMarker, objectCreate(protoOf(SetupCurrentPlanSummary)));
  }
  function SetupCurrentPlanSummary() {
  }
  protoOf(SetupCurrentPlanSummary).toString = function () {
    return 'SetupCurrentPlanSummary(source=' + this.h3h_1 + ', status=' + this.i3h_1 + ', reason=' + this.j3h_1 + ', nameEn=' + this.k3h_1 + ', nameAr=' + this.l3h_1 + ', descriptionEn=' + this.m3h_1 + ', descriptionAr=' + this.n3h_1 + ', planRevision=' + toString_0(this.o3h_1) + ', lifecycle=' + this.p3h_1 + ')';
  };
  protoOf(SetupCurrentPlanSummary).hashCode = function () {
    var result = getStringHashCode(this.h3h_1);
    result = imul(result, 31) + getStringHashCode(this.i3h_1) | 0;
    result = imul(result, 31) + (this.j3h_1 == null ? 0 : getStringHashCode(this.j3h_1)) | 0;
    result = imul(result, 31) + (this.k3h_1 == null ? 0 : getStringHashCode(this.k3h_1)) | 0;
    result = imul(result, 31) + (this.l3h_1 == null ? 0 : getStringHashCode(this.l3h_1)) | 0;
    result = imul(result, 31) + (this.m3h_1 == null ? 0 : getStringHashCode(this.m3h_1)) | 0;
    result = imul(result, 31) + (this.n3h_1 == null ? 0 : getStringHashCode(this.n3h_1)) | 0;
    result = imul(result, 31) + (this.o3h_1 == null ? 0 : this.o3h_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p3h_1 == null ? 0 : getStringHashCode(this.p3h_1)) | 0;
    return result;
  };
  protoOf(SetupCurrentPlanSummary).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCurrentPlanSummary))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCurrentPlanSummary ? other : THROW_CCE();
    if (!(this.h3h_1 === tmp0_other_with_cast.h3h_1))
      return false;
    if (!(this.i3h_1 === tmp0_other_with_cast.i3h_1))
      return false;
    if (!(this.j3h_1 == tmp0_other_with_cast.j3h_1))
      return false;
    if (!(this.k3h_1 == tmp0_other_with_cast.k3h_1))
      return false;
    if (!(this.l3h_1 == tmp0_other_with_cast.l3h_1))
      return false;
    if (!(this.m3h_1 == tmp0_other_with_cast.m3h_1))
      return false;
    if (!(this.n3h_1 == tmp0_other_with_cast.n3h_1))
      return false;
    if (!equals(this.o3h_1, tmp0_other_with_cast.o3h_1))
      return false;
    if (!(this.p3h_1 == tmp0_other_with_cast.p3h_1))
      return false;
    return true;
  };
  function Companion_153() {
    Companion_instance_153 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q3h_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_182()), new ArrayListSerializer($serializer_getInstance_182()), new ArrayListSerializer($serializer_getInstance_182()), new ArrayListSerializer($serializer_getInstance_179()), null];
  }
  var Companion_instance_153;
  function Companion_getInstance_153() {
    if (Companion_instance_153 == null)
      new Companion_153();
    return Companion_instance_153;
  }
  function $serializer_185() {
    $serializer_instance_184 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCurrentGrantsSummary', this, 9);
    tmp0_serialDesc.gy('source', true);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('entitlementVersion', true);
    tmp0_serialDesc.gy('featureCatalogVersion', true);
    tmp0_serialDesc.gy('modules', true);
    tmp0_serialDesc.gy('features', true);
    tmp0_serialDesc.gy('providerFamilies', true);
    tmp0_serialDesc.gy('limits', true);
    tmp0_serialDesc.gy('publicWebsite', false);
    this.r3h_1 = tmp0_serialDesc;
  }
  protoOf($serializer_185).s3h = function (encoder, value) {
    var tmp0_desc = this.r3h_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_153().q3h_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.t3h_1 === 'CURRENT_EFFECTIVE')) {
      tmp1_output.hs(tmp0_desc, 0, value.t3h_1);
    }
    tmp1_output.hs(tmp0_desc, 1, value.u3h_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.v3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, LongSerializer_getInstance(), value.v3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.w3h_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, IntSerializer_getInstance(), value.w3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !equals(value.x3h_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.x3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !equals(value.y3h_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.y3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !equals(value.z3h_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.z3h_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !equals(value.a3i_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.a3i_1);
    }
    tmp1_output.hs(tmp0_desc, 8, value.b3i_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_185).on = function (encoder, value) {
    return this.s3h(encoder, value instanceof SetupCurrentGrantsSummary ? value : THROW_CCE());
  };
  protoOf($serializer_185).pn = function (decoder) {
    var tmp0_desc = this.r3h_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    var tmp14_cached = Companion_getInstance_153().q3h_1;
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.fr(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.fr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.fr(tmp0_desc, 6, tmp14_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.hr(tmp0_desc, 3, IntSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.fr(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.fr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.fr(tmp0_desc, 6, tmp14_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.dr(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupCurrentGrantsSummary_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_185).nn = function () {
    return this.r3h_1;
  };
  protoOf($serializer_185).vy = function () {
    var tmp0_cached = Companion_getInstance_153().q3h_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), tmp0_cached[4], tmp0_cached[5], tmp0_cached[6], tmp0_cached[7], StringSerializer_getInstance()];
  };
  var $serializer_instance_184;
  function $serializer_getInstance_184() {
    if ($serializer_instance_184 == null)
      new $serializer_185();
    return $serializer_instance_184;
  }
  function SetupCurrentGrantsSummary_init_$Init$(seen0, source, status, entitlementVersion, featureCatalogVersion, modules, features, providerFamilies, limits, publicWebsite, serializationConstructorMarker, $this) {
    if (!(258 === (258 & seen0))) {
      throwMissingFieldException(seen0, 258, $serializer_getInstance_184().r3h_1);
    }
    if (0 === (seen0 & 1))
      $this.t3h_1 = 'CURRENT_EFFECTIVE';
    else
      $this.t3h_1 = source;
    $this.u3h_1 = status;
    if (0 === (seen0 & 4))
      $this.v3h_1 = null;
    else
      $this.v3h_1 = entitlementVersion;
    if (0 === (seen0 & 8))
      $this.w3h_1 = null;
    else
      $this.w3h_1 = featureCatalogVersion;
    if (0 === (seen0 & 16))
      $this.x3h_1 = emptyList();
    else
      $this.x3h_1 = modules;
    if (0 === (seen0 & 32))
      $this.y3h_1 = emptyList();
    else
      $this.y3h_1 = features;
    if (0 === (seen0 & 64))
      $this.z3h_1 = emptyList();
    else
      $this.z3h_1 = providerFamilies;
    if (0 === (seen0 & 128))
      $this.a3i_1 = emptyList();
    else
      $this.a3i_1 = limits;
    $this.b3i_1 = publicWebsite;
    return $this;
  }
  function SetupCurrentGrantsSummary_init_$Create$(seen0, source, status, entitlementVersion, featureCatalogVersion, modules, features, providerFamilies, limits, publicWebsite, serializationConstructorMarker) {
    return SetupCurrentGrantsSummary_init_$Init$(seen0, source, status, entitlementVersion, featureCatalogVersion, modules, features, providerFamilies, limits, publicWebsite, serializationConstructorMarker, objectCreate(protoOf(SetupCurrentGrantsSummary)));
  }
  function SetupCurrentGrantsSummary() {
  }
  protoOf(SetupCurrentGrantsSummary).toString = function () {
    return 'SetupCurrentGrantsSummary(source=' + this.t3h_1 + ', status=' + this.u3h_1 + ', entitlementVersion=' + toString_0(this.v3h_1) + ', featureCatalogVersion=' + this.w3h_1 + ', modules=' + toString(this.x3h_1) + ', features=' + toString(this.y3h_1) + ', providerFamilies=' + toString(this.z3h_1) + ', limits=' + toString(this.a3i_1) + ', publicWebsite=' + this.b3i_1 + ')';
  };
  protoOf(SetupCurrentGrantsSummary).hashCode = function () {
    var result = getStringHashCode(this.t3h_1);
    result = imul(result, 31) + getStringHashCode(this.u3h_1) | 0;
    result = imul(result, 31) + (this.v3h_1 == null ? 0 : this.v3h_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w3h_1 == null ? 0 : this.w3h_1) | 0;
    result = imul(result, 31) + hashCode(this.x3h_1) | 0;
    result = imul(result, 31) + hashCode(this.y3h_1) | 0;
    result = imul(result, 31) + hashCode(this.z3h_1) | 0;
    result = imul(result, 31) + hashCode(this.a3i_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b3i_1) | 0;
    return result;
  };
  protoOf(SetupCurrentGrantsSummary).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCurrentGrantsSummary))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCurrentGrantsSummary ? other : THROW_CCE();
    if (!(this.t3h_1 === tmp0_other_with_cast.t3h_1))
      return false;
    if (!(this.u3h_1 === tmp0_other_with_cast.u3h_1))
      return false;
    if (!equals(this.v3h_1, tmp0_other_with_cast.v3h_1))
      return false;
    if (!(this.w3h_1 == tmp0_other_with_cast.w3h_1))
      return false;
    if (!equals(this.x3h_1, tmp0_other_with_cast.x3h_1))
      return false;
    if (!equals(this.y3h_1, tmp0_other_with_cast.y3h_1))
      return false;
    if (!equals(this.z3h_1, tmp0_other_with_cast.z3h_1))
      return false;
    if (!equals(this.a3i_1, tmp0_other_with_cast.a3i_1))
      return false;
    if (!(this.b3i_1 === tmp0_other_with_cast.b3i_1))
      return false;
    return true;
  };
  function $serializer_186() {
    $serializer_instance_185 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCompletionTask', this, 7);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('category', true);
    tmp0_serialDesc.gy('subjectId', true);
    tmp0_serialDesc.gy('nameEn', true);
    tmp0_serialDesc.gy('nameAr', true);
    tmp0_serialDesc.gy('observedAtMs', true);
    this.c3i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_186).d3i = function (encoder, value) {
    var tmp0_desc = this.c3i_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.e3i_1);
    tmp1_output.hs(tmp0_desc, 1, value.f3i_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.g3i_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.g3i_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.h3i_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.h3i_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.i3i_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.i3i_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.j3i_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.j3i_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.k3i_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.k3i_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_186).on = function (encoder, value) {
    return this.d3i(encoder, value instanceof SetupCompletionTask ? value : THROW_CCE());
  };
  protoOf($serializer_186).pn = function (decoder) {
    var tmp0_desc = this.c3i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return SetupCompletionTask_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_186).nn = function () {
    return this.c3i_1;
  };
  protoOf($serializer_186).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_185;
  function $serializer_getInstance_185() {
    if ($serializer_instance_185 == null)
      new $serializer_186();
    return $serializer_instance_185;
  }
  function SetupCompletionTask_init_$Init$(seen0, key, status, category, subjectId, nameEn, nameAr, observedAtMs, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_185().c3i_1);
    }
    $this.e3i_1 = key;
    $this.f3i_1 = status;
    if (0 === (seen0 & 4))
      $this.g3i_1 = null;
    else
      $this.g3i_1 = category;
    if (0 === (seen0 & 8))
      $this.h3i_1 = null;
    else
      $this.h3i_1 = subjectId;
    if (0 === (seen0 & 16))
      $this.i3i_1 = null;
    else
      $this.i3i_1 = nameEn;
    if (0 === (seen0 & 32))
      $this.j3i_1 = null;
    else
      $this.j3i_1 = nameAr;
    if (0 === (seen0 & 64))
      $this.k3i_1 = null;
    else
      $this.k3i_1 = observedAtMs;
    return $this;
  }
  function SetupCompletionTask_init_$Create$(seen0, key, status, category, subjectId, nameEn, nameAr, observedAtMs, serializationConstructorMarker) {
    return SetupCompletionTask_init_$Init$(seen0, key, status, category, subjectId, nameEn, nameAr, observedAtMs, serializationConstructorMarker, objectCreate(protoOf(SetupCompletionTask)));
  }
  function SetupCompletionTask() {
  }
  protoOf(SetupCompletionTask).toString = function () {
    return 'SetupCompletionTask(key=' + this.e3i_1 + ', status=' + this.f3i_1 + ', category=' + this.g3i_1 + ', subjectId=' + this.h3i_1 + ', nameEn=' + this.i3i_1 + ', nameAr=' + this.j3i_1 + ', observedAtMs=' + toString_0(this.k3i_1) + ')';
  };
  protoOf(SetupCompletionTask).hashCode = function () {
    var result = getStringHashCode(this.e3i_1);
    result = imul(result, 31) + getStringHashCode(this.f3i_1) | 0;
    result = imul(result, 31) + (this.g3i_1 == null ? 0 : getStringHashCode(this.g3i_1)) | 0;
    result = imul(result, 31) + (this.h3i_1 == null ? 0 : getStringHashCode(this.h3i_1)) | 0;
    result = imul(result, 31) + (this.i3i_1 == null ? 0 : getStringHashCode(this.i3i_1)) | 0;
    result = imul(result, 31) + (this.j3i_1 == null ? 0 : getStringHashCode(this.j3i_1)) | 0;
    result = imul(result, 31) + (this.k3i_1 == null ? 0 : this.k3i_1.hashCode()) | 0;
    return result;
  };
  protoOf(SetupCompletionTask).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCompletionTask))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCompletionTask ? other : THROW_CCE();
    if (!(this.e3i_1 === tmp0_other_with_cast.e3i_1))
      return false;
    if (!(this.f3i_1 === tmp0_other_with_cast.f3i_1))
      return false;
    if (!(this.g3i_1 == tmp0_other_with_cast.g3i_1))
      return false;
    if (!(this.h3i_1 == tmp0_other_with_cast.h3i_1))
      return false;
    if (!(this.i3i_1 == tmp0_other_with_cast.i3i_1))
      return false;
    if (!(this.j3i_1 == tmp0_other_with_cast.j3i_1))
      return false;
    if (!equals(this.k3i_1, tmp0_other_with_cast.k3i_1))
      return false;
    return true;
  };
  function $serializer_187() {
    $serializer_instance_186 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCompletionAvailability', this, 2);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('reason', false);
    this.l3i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_187).m3i = function (encoder, value) {
    var tmp0_desc = this.l3i_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.n3i_1);
    tmp1_output.hs(tmp0_desc, 1, value.o3i_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_187).on = function (encoder, value) {
    return this.m3i(encoder, value instanceof SetupCompletionAvailability ? value : THROW_CCE());
  };
  protoOf($serializer_187).pn = function (decoder) {
    var tmp0_desc = this.l3i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SetupCompletionAvailability_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_187).nn = function () {
    return this.l3i_1;
  };
  protoOf($serializer_187).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_186;
  function $serializer_getInstance_186() {
    if ($serializer_instance_186 == null)
      new $serializer_187();
    return $serializer_instance_186;
  }
  function SetupCompletionAvailability_init_$Init$(seen0, status, reason, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_186().l3i_1);
    }
    $this.n3i_1 = status;
    $this.o3i_1 = reason;
    return $this;
  }
  function SetupCompletionAvailability_init_$Create$(seen0, status, reason, serializationConstructorMarker) {
    return SetupCompletionAvailability_init_$Init$(seen0, status, reason, serializationConstructorMarker, objectCreate(protoOf(SetupCompletionAvailability)));
  }
  function SetupCompletionAvailability() {
  }
  protoOf(SetupCompletionAvailability).toString = function () {
    return 'SetupCompletionAvailability(status=' + this.n3i_1 + ', reason=' + this.o3i_1 + ')';
  };
  protoOf(SetupCompletionAvailability).hashCode = function () {
    var result = getStringHashCode(this.n3i_1);
    result = imul(result, 31) + getStringHashCode(this.o3i_1) | 0;
    return result;
  };
  protoOf(SetupCompletionAvailability).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCompletionAvailability))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCompletionAvailability ? other : THROW_CCE();
    if (!(this.n3i_1 === tmp0_other_with_cast.n3i_1))
      return false;
    if (!(this.o3i_1 === tmp0_other_with_cast.o3i_1))
      return false;
    return true;
  };
  function Companion_154() {
    Companion_instance_154 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p3i_1 = [null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_190())];
  }
  var Companion_instance_154;
  function Companion_getInstance_154() {
    if (Companion_instance_154 == null)
      new Companion_154();
    return Companion_instance_154;
  }
  function $serializer_188() {
    $serializer_instance_187 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionDeferralView', this, 9);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantUsable', false);
    tmp0_serialDesc.gy('workflowRevision', false);
    tmp0_serialDesc.gy('grantsVerified', false);
    tmp0_serialDesc.gy('currentEntitlementVersion', true);
    tmp0_serialDesc.gy('currentCatalogVersion', false);
    tmp0_serialDesc.gy('includedProviderIds', false);
    tmp0_serialDesc.gy('decisions', false);
    this.q3i_1 = tmp0_serialDesc;
  }
  protoOf($serializer_188).r3i = function (encoder, value) {
    var tmp0_desc = this.q3i_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_154().p3i_1;
    tmp1_output.hs(tmp0_desc, 0, value.s3i_1);
    tmp1_output.hs(tmp0_desc, 1, value.t3i_1);
    tmp1_output.zr(tmp0_desc, 2, value.u3i_1);
    tmp1_output.ds(tmp0_desc, 3, value.v3i_1);
    tmp1_output.zr(tmp0_desc, 4, value.w3i_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.x3i_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.x3i_1);
    }
    tmp1_output.cs(tmp0_desc, 6, value.y3i_1);
    tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.z3i_1);
    tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.a3j_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_188).on = function (encoder, value) {
    return this.r3i(encoder, value instanceof SetupConnectionDeferralView ? value : THROW_CCE());
  };
  protoOf($serializer_188).pn = function (decoder) {
    var tmp0_desc = this.q3i_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_local6 = 0;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    var tmp14_cached = Companion_getInstance_154().p3i_1;
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.yq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.fr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.yq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.fr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupConnectionDeferralView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_188).nn = function () {
    return this.q3i_1;
  };
  protoOf($serializer_188).vy = function () {
    var tmp0_cached = Companion_getInstance_154().p3i_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), IntSerializer_getInstance(), tmp0_cached[7], tmp0_cached[8]];
  };
  var $serializer_instance_187;
  function $serializer_getInstance_187() {
    if ($serializer_instance_187 == null)
      new $serializer_188();
    return $serializer_instance_187;
  }
  function SetupConnectionDeferralView_init_$Init$(seen0, attemptId, tenantId, tenantUsable, workflowRevision, grantsVerified, currentEntitlementVersion, currentCatalogVersion, includedProviderIds, decisions, serializationConstructorMarker, $this) {
    if (!(479 === (479 & seen0))) {
      throwMissingFieldException(seen0, 479, $serializer_getInstance_187().q3i_1);
    }
    $this.s3i_1 = attemptId;
    $this.t3i_1 = tenantId;
    $this.u3i_1 = tenantUsable;
    $this.v3i_1 = workflowRevision;
    $this.w3i_1 = grantsVerified;
    if (0 === (seen0 & 32))
      $this.x3i_1 = null;
    else
      $this.x3i_1 = currentEntitlementVersion;
    $this.y3i_1 = currentCatalogVersion;
    $this.z3i_1 = includedProviderIds;
    $this.a3j_1 = decisions;
    return $this;
  }
  function SetupConnectionDeferralView_init_$Create$(seen0, attemptId, tenantId, tenantUsable, workflowRevision, grantsVerified, currentEntitlementVersion, currentCatalogVersion, includedProviderIds, decisions, serializationConstructorMarker) {
    return SetupConnectionDeferralView_init_$Init$(seen0, attemptId, tenantId, tenantUsable, workflowRevision, grantsVerified, currentEntitlementVersion, currentCatalogVersion, includedProviderIds, decisions, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionDeferralView)));
  }
  function SetupConnectionDeferralView(attemptId, tenantId, tenantUsable, workflowRevision, grantsVerified, currentEntitlementVersion, currentCatalogVersion, includedProviderIds, decisions) {
    Companion_getInstance_154();
    currentEntitlementVersion = currentEntitlementVersion === VOID ? null : currentEntitlementVersion;
    this.s3i_1 = attemptId;
    this.t3i_1 = tenantId;
    this.u3i_1 = tenantUsable;
    this.v3i_1 = workflowRevision;
    this.w3i_1 = grantsVerified;
    this.x3i_1 = currentEntitlementVersion;
    this.y3i_1 = currentCatalogVersion;
    this.z3i_1 = includedProviderIds;
    this.a3j_1 = decisions;
  }
  protoOf(SetupConnectionDeferralView).toString = function () {
    return 'SetupConnectionDeferralView(attemptId=' + this.s3i_1 + ', tenantId=' + this.t3i_1 + ', tenantUsable=' + this.u3i_1 + ', workflowRevision=' + this.v3i_1.toString() + ', grantsVerified=' + this.w3i_1 + ', currentEntitlementVersion=' + toString_0(this.x3i_1) + ', currentCatalogVersion=' + this.y3i_1 + ', includedProviderIds=' + toString(this.z3i_1) + ', decisions=' + toString(this.a3j_1) + ')';
  };
  protoOf(SetupConnectionDeferralView).hashCode = function () {
    var result = getStringHashCode(this.s3i_1);
    result = imul(result, 31) + getStringHashCode(this.t3i_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u3i_1) | 0;
    result = imul(result, 31) + this.v3i_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w3i_1) | 0;
    result = imul(result, 31) + (this.x3i_1 == null ? 0 : this.x3i_1.hashCode()) | 0;
    result = imul(result, 31) + this.y3i_1 | 0;
    result = imul(result, 31) + hashCode(this.z3i_1) | 0;
    result = imul(result, 31) + hashCode(this.a3j_1) | 0;
    return result;
  };
  protoOf(SetupConnectionDeferralView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionDeferralView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionDeferralView ? other : THROW_CCE();
    if (!(this.s3i_1 === tmp0_other_with_cast.s3i_1))
      return false;
    if (!(this.t3i_1 === tmp0_other_with_cast.t3i_1))
      return false;
    if (!(this.u3i_1 === tmp0_other_with_cast.u3i_1))
      return false;
    if (!this.v3i_1.equals(tmp0_other_with_cast.v3i_1))
      return false;
    if (!(this.w3i_1 === tmp0_other_with_cast.w3i_1))
      return false;
    if (!equals(this.x3i_1, tmp0_other_with_cast.x3i_1))
      return false;
    if (!(this.y3i_1 === tmp0_other_with_cast.y3i_1))
      return false;
    if (!equals(this.z3i_1, tmp0_other_with_cast.z3i_1))
      return false;
    if (!equals(this.a3j_1, tmp0_other_with_cast.a3j_1))
      return false;
    return true;
  };
  function SetupConnectionDeferralApiPaths() {
    this.b3j_1 = 'connection-deferrals';
  }
  protoOf(SetupConnectionDeferralApiPaths).c3j = function (attemptId) {
    return '/api/console/setup-attempts/' + attemptId + '/connection-deferrals';
  };
  var SetupConnectionDeferralApiPaths_instance;
  function SetupConnectionDeferralApiPaths_getInstance() {
    return SetupConnectionDeferralApiPaths_instance;
  }
  function Companion_155() {
    Companion_instance_155 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.f3j_1 = [null, null, null, Companion_getInstance_158().w19(), Companion_getInstance_159().w19(), new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, null];
  }
  var Companion_instance_155;
  function Companion_getInstance_155() {
    if (Companion_instance_155 == null)
      new Companion_155();
    return Companion_instance_155;
  }
  function $serializer_189() {
    $serializer_instance_188 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionDeferralReceipt', this, 11);
    tmp0_serialDesc.gy('operationId', false);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('scope', false);
    tmp0_serialDesc.gy('decision', false);
    tmp0_serialDesc.gy('providerIds', false);
    tmp0_serialDesc.gy('previousWorkflowRevision', false);
    tmp0_serialDesc.gy('workflowRevision', false);
    tmp0_serialDesc.gy('entitlementVersion', false);
    tmp0_serialDesc.gy('catalogVersion', false);
    tmp0_serialDesc.gy('decidedAtMs', false);
    this.g3j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_189).h3j = function (encoder, value) {
    var tmp0_desc = this.g3j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_155().f3j_1;
    tmp1_output.hs(tmp0_desc, 0, value.i3j_1);
    tmp1_output.hs(tmp0_desc, 1, value.j3j_1);
    tmp1_output.hs(tmp0_desc, 2, value.k3j_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.l3j_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.m3j_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.n3j_1);
    tmp1_output.ds(tmp0_desc, 6, value.o3j_1);
    tmp1_output.ds(tmp0_desc, 7, value.p3j_1);
    tmp1_output.ds(tmp0_desc, 8, value.q3j_1);
    tmp1_output.cs(tmp0_desc, 9, value.r3j_1);
    tmp1_output.ds(tmp0_desc, 10, value.s3j_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_189).on = function (encoder, value) {
    return this.h3j(encoder, value instanceof SetupConnectionDeferralReceipt ? value : THROW_CCE());
  };
  protoOf($serializer_189).pn = function (decoder) {
    var tmp0_desc = this.g3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = new Long(0, 0);
    var tmp11_local7 = new Long(0, 0);
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = 0;
    var tmp14_local10 = new Long(0, 0);
    var tmp15_input = decoder.tq(tmp0_desc);
    var tmp16_cached = Companion_getInstance_155().f3j_1;
    if (tmp15_input.ir()) {
      tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.fr(tmp0_desc, 3, tmp16_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.fr(tmp0_desc, 4, tmp16_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.fr(tmp0_desc, 5, tmp16_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.zq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.yq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.zq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.fr(tmp0_desc, 3, tmp16_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.fr(tmp0_desc, 4, tmp16_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.fr(tmp0_desc, 5, tmp16_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.zq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.yq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.zq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.uq(tmp0_desc);
    return SetupConnectionDeferralReceipt_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_189).nn = function () {
    return this.g3j_1;
  };
  protoOf($serializer_189).vy = function () {
    var tmp0_cached = Companion_getInstance_155().f3j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[3], tmp0_cached[4], tmp0_cached[5], LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), IntSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_188;
  function $serializer_getInstance_188() {
    if ($serializer_instance_188 == null)
      new $serializer_189();
    return $serializer_instance_188;
  }
  function SetupConnectionDeferralReceipt_init_$Init$(seen0, operationId, attemptId, tenantId, scope, decision, providerIds, previousWorkflowRevision, workflowRevision, entitlementVersion, catalogVersion, decidedAtMs, serializationConstructorMarker, $this) {
    if (!(2047 === (2047 & seen0))) {
      throwMissingFieldException(seen0, 2047, $serializer_getInstance_188().g3j_1);
    }
    $this.i3j_1 = operationId;
    $this.j3j_1 = attemptId;
    $this.k3j_1 = tenantId;
    $this.l3j_1 = scope;
    $this.m3j_1 = decision;
    $this.n3j_1 = providerIds;
    $this.o3j_1 = previousWorkflowRevision;
    $this.p3j_1 = workflowRevision;
    $this.q3j_1 = entitlementVersion;
    $this.r3j_1 = catalogVersion;
    $this.s3j_1 = decidedAtMs;
    return $this;
  }
  function SetupConnectionDeferralReceipt_init_$Create$(seen0, operationId, attemptId, tenantId, scope, decision, providerIds, previousWorkflowRevision, workflowRevision, entitlementVersion, catalogVersion, decidedAtMs, serializationConstructorMarker) {
    return SetupConnectionDeferralReceipt_init_$Init$(seen0, operationId, attemptId, tenantId, scope, decision, providerIds, previousWorkflowRevision, workflowRevision, entitlementVersion, catalogVersion, decidedAtMs, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionDeferralReceipt)));
  }
  function SetupConnectionDeferralReceipt(operationId, attemptId, tenantId, scope, decision, providerIds, previousWorkflowRevision, workflowRevision, entitlementVersion, catalogVersion, decidedAtMs) {
    Companion_getInstance_155();
    this.i3j_1 = operationId;
    this.j3j_1 = attemptId;
    this.k3j_1 = tenantId;
    this.l3j_1 = scope;
    this.m3j_1 = decision;
    this.n3j_1 = providerIds;
    this.o3j_1 = previousWorkflowRevision;
    this.p3j_1 = workflowRevision;
    this.q3j_1 = entitlementVersion;
    this.r3j_1 = catalogVersion;
    this.s3j_1 = decidedAtMs;
  }
  protoOf(SetupConnectionDeferralReceipt).toString = function () {
    return 'SetupConnectionDeferralReceipt(operationId=' + this.i3j_1 + ', attemptId=' + this.j3j_1 + ', tenantId=' + this.k3j_1 + ', scope=' + this.l3j_1.toString() + ', decision=' + this.m3j_1.toString() + ', providerIds=' + toString(this.n3j_1) + ', previousWorkflowRevision=' + this.o3j_1.toString() + ', workflowRevision=' + this.p3j_1.toString() + ', entitlementVersion=' + this.q3j_1.toString() + ', catalogVersion=' + this.r3j_1 + ', decidedAtMs=' + this.s3j_1.toString() + ')';
  };
  protoOf(SetupConnectionDeferralReceipt).hashCode = function () {
    var result = getStringHashCode(this.i3j_1);
    result = imul(result, 31) + getStringHashCode(this.j3j_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k3j_1) | 0;
    result = imul(result, 31) + this.l3j_1.hashCode() | 0;
    result = imul(result, 31) + this.m3j_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.n3j_1) | 0;
    result = imul(result, 31) + this.o3j_1.hashCode() | 0;
    result = imul(result, 31) + this.p3j_1.hashCode() | 0;
    result = imul(result, 31) + this.q3j_1.hashCode() | 0;
    result = imul(result, 31) + this.r3j_1 | 0;
    result = imul(result, 31) + this.s3j_1.hashCode() | 0;
    return result;
  };
  protoOf(SetupConnectionDeferralReceipt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionDeferralReceipt))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionDeferralReceipt ? other : THROW_CCE();
    if (!(this.i3j_1 === tmp0_other_with_cast.i3j_1))
      return false;
    if (!(this.j3j_1 === tmp0_other_with_cast.j3j_1))
      return false;
    if (!(this.k3j_1 === tmp0_other_with_cast.k3j_1))
      return false;
    if (!this.l3j_1.equals(tmp0_other_with_cast.l3j_1))
      return false;
    if (!this.m3j_1.equals(tmp0_other_with_cast.m3j_1))
      return false;
    if (!equals(this.n3j_1, tmp0_other_with_cast.n3j_1))
      return false;
    if (!this.o3j_1.equals(tmp0_other_with_cast.o3j_1))
      return false;
    if (!this.p3j_1.equals(tmp0_other_with_cast.p3j_1))
      return false;
    if (!this.q3j_1.equals(tmp0_other_with_cast.q3j_1))
      return false;
    if (!(this.r3j_1 === tmp0_other_with_cast.r3j_1))
      return false;
    if (!this.s3j_1.equals(tmp0_other_with_cast.s3j_1))
      return false;
    return true;
  };
  function Companion_156() {
    Companion_instance_156 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t3j_1 = [Companion_getInstance_158().w19(), null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_156;
  function Companion_getInstance_156() {
    if (Companion_instance_156 == null)
      new Companion_156();
    return Companion_instance_156;
  }
  function $serializer_190() {
    $serializer_instance_189 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionDeferralRequest', this, 4);
    tmp0_serialDesc.gy('scope', false);
    tmp0_serialDesc.gy('expectedWorkflowRevision', false);
    tmp0_serialDesc.gy('expectedEntitlementVersion', false);
    tmp0_serialDesc.gy('providerIds', false);
    this.u3j_1 = tmp0_serialDesc;
  }
  protoOf($serializer_190).v3j = function (encoder, value) {
    var tmp0_desc = this.u3j_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_156().t3j_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.w3j_1);
    tmp1_output.ds(tmp0_desc, 1, value.x3j_1);
    tmp1_output.ds(tmp0_desc, 2, value.y3j_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.z3j_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_190).on = function (encoder, value) {
    return this.v3j(encoder, value instanceof SetupConnectionDeferralRequest ? value : THROW_CCE());
  };
  protoOf($serializer_190).pn = function (decoder) {
    var tmp0_desc = this.u3j_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_156().t3j_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, tmp9_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return SetupConnectionDeferralRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_190).nn = function () {
    return this.u3j_1;
  };
  protoOf($serializer_190).vy = function () {
    var tmp0_cached = Companion_getInstance_156().t3j_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], LongSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[3]];
  };
  var $serializer_instance_189;
  function $serializer_getInstance_189() {
    if ($serializer_instance_189 == null)
      new $serializer_190();
    return $serializer_instance_189;
  }
  function SetupConnectionDeferralRequest_init_$Init$(seen0, scope, expectedWorkflowRevision, expectedEntitlementVersion, providerIds, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_189().u3j_1);
    }
    $this.w3j_1 = scope;
    $this.x3j_1 = expectedWorkflowRevision;
    $this.y3j_1 = expectedEntitlementVersion;
    $this.z3j_1 = providerIds;
    return $this;
  }
  function SetupConnectionDeferralRequest_init_$Create$(seen0, scope, expectedWorkflowRevision, expectedEntitlementVersion, providerIds, serializationConstructorMarker) {
    return SetupConnectionDeferralRequest_init_$Init$(seen0, scope, expectedWorkflowRevision, expectedEntitlementVersion, providerIds, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionDeferralRequest)));
  }
  function SetupConnectionDeferralRequest(scope, expectedWorkflowRevision, expectedEntitlementVersion, providerIds) {
    Companion_getInstance_156();
    this.w3j_1 = scope;
    this.x3j_1 = expectedWorkflowRevision;
    this.y3j_1 = expectedEntitlementVersion;
    this.z3j_1 = providerIds;
  }
  protoOf(SetupConnectionDeferralRequest).toString = function () {
    return 'SetupConnectionDeferralRequest(scope=' + this.w3j_1.toString() + ', expectedWorkflowRevision=' + this.x3j_1.toString() + ', expectedEntitlementVersion=' + this.y3j_1.toString() + ', providerIds=' + toString(this.z3j_1) + ')';
  };
  protoOf(SetupConnectionDeferralRequest).hashCode = function () {
    var result = this.w3j_1.hashCode();
    result = imul(result, 31) + this.x3j_1.hashCode() | 0;
    result = imul(result, 31) + this.y3j_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.z3j_1) | 0;
    return result;
  };
  protoOf(SetupConnectionDeferralRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionDeferralRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionDeferralRequest ? other : THROW_CCE();
    if (!this.w3j_1.equals(tmp0_other_with_cast.w3j_1))
      return false;
    if (!this.x3j_1.equals(tmp0_other_with_cast.x3j_1))
      return false;
    if (!this.y3j_1.equals(tmp0_other_with_cast.y3j_1))
      return false;
    if (!equals(this.z3j_1, tmp0_other_with_cast.z3j_1))
      return false;
    return true;
  };
  function Companion_157() {
    Companion_instance_157 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.a3k_1 = [null, Companion_getInstance_159().w19(), Companion_getInstance_158().w19(), null, null, null, null, null, null];
  }
  var Companion_instance_157;
  function Companion_getInstance_157() {
    if (Companion_instance_157 == null)
      new Companion_157();
    return Companion_instance_157;
  }
  function $serializer_191() {
    $serializer_instance_190 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionDeferralDecisionView', this, 9);
    tmp0_serialDesc.gy('providerId', false);
    tmp0_serialDesc.gy('decision', false);
    tmp0_serialDesc.gy('scope', false);
    tmp0_serialDesc.gy('entitlementVersion', false);
    tmp0_serialDesc.gy('catalogVersion', false);
    tmp0_serialDesc.gy('workflowRevision', false);
    tmp0_serialDesc.gy('decidedAtMs', false);
    tmp0_serialDesc.gy('currentlyIncluded', false);
    tmp0_serialDesc.gy('boundToCurrentEntitlement', false);
    this.b3k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_191).c3k = function (encoder, value) {
    var tmp0_desc = this.b3k_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_157().a3k_1;
    tmp1_output.hs(tmp0_desc, 0, value.d3k_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.e3k_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.f3k_1);
    tmp1_output.ds(tmp0_desc, 3, value.g3k_1);
    tmp1_output.cs(tmp0_desc, 4, value.h3k_1);
    tmp1_output.ds(tmp0_desc, 5, value.i3k_1);
    tmp1_output.ds(tmp0_desc, 6, value.j3k_1);
    tmp1_output.zr(tmp0_desc, 7, value.k3k_1);
    tmp1_output.zr(tmp0_desc, 8, value.l3k_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_191).on = function (encoder, value) {
    return this.c3k(encoder, value instanceof SetupConnectionDeferralDecisionView ? value : THROW_CCE());
  };
  protoOf($serializer_191).pn = function (decoder) {
    var tmp0_desc = this.b3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = 0;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = new Long(0, 0);
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_input = decoder.tq(tmp0_desc);
    var tmp14_cached = Companion_getInstance_157().a3k_1;
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.fr(tmp0_desc, 1, tmp14_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.fr(tmp0_desc, 2, tmp14_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.yq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.zq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.vq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.fr(tmp0_desc, 1, tmp14_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.fr(tmp0_desc, 2, tmp14_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.yq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.zq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.vq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupConnectionDeferralDecisionView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_191).nn = function () {
    return this.b3k_1;
  };
  protoOf($serializer_191).vy = function () {
    var tmp0_cached = Companion_getInstance_157().a3k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], tmp0_cached[2], LongSerializer_getInstance(), IntSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_190;
  function $serializer_getInstance_190() {
    if ($serializer_instance_190 == null)
      new $serializer_191();
    return $serializer_instance_190;
  }
  function SetupConnectionDeferralDecisionView_init_$Init$(seen0, providerId, decision, scope, entitlementVersion, catalogVersion, workflowRevision, decidedAtMs, currentlyIncluded, boundToCurrentEntitlement, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_190().b3k_1);
    }
    $this.d3k_1 = providerId;
    $this.e3k_1 = decision;
    $this.f3k_1 = scope;
    $this.g3k_1 = entitlementVersion;
    $this.h3k_1 = catalogVersion;
    $this.i3k_1 = workflowRevision;
    $this.j3k_1 = decidedAtMs;
    $this.k3k_1 = currentlyIncluded;
    $this.l3k_1 = boundToCurrentEntitlement;
    return $this;
  }
  function SetupConnectionDeferralDecisionView_init_$Create$(seen0, providerId, decision, scope, entitlementVersion, catalogVersion, workflowRevision, decidedAtMs, currentlyIncluded, boundToCurrentEntitlement, serializationConstructorMarker) {
    return SetupConnectionDeferralDecisionView_init_$Init$(seen0, providerId, decision, scope, entitlementVersion, catalogVersion, workflowRevision, decidedAtMs, currentlyIncluded, boundToCurrentEntitlement, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionDeferralDecisionView)));
  }
  function SetupConnectionDeferralDecisionView() {
  }
  protoOf(SetupConnectionDeferralDecisionView).toString = function () {
    return 'SetupConnectionDeferralDecisionView(providerId=' + this.d3k_1 + ', decision=' + this.e3k_1.toString() + ', scope=' + this.f3k_1.toString() + ', entitlementVersion=' + this.g3k_1.toString() + ', catalogVersion=' + this.h3k_1 + ', workflowRevision=' + this.i3k_1.toString() + ', decidedAtMs=' + this.j3k_1.toString() + ', currentlyIncluded=' + this.k3k_1 + ', boundToCurrentEntitlement=' + this.l3k_1 + ')';
  };
  protoOf(SetupConnectionDeferralDecisionView).hashCode = function () {
    var result = getStringHashCode(this.d3k_1);
    result = imul(result, 31) + this.e3k_1.hashCode() | 0;
    result = imul(result, 31) + this.f3k_1.hashCode() | 0;
    result = imul(result, 31) + this.g3k_1.hashCode() | 0;
    result = imul(result, 31) + this.h3k_1 | 0;
    result = imul(result, 31) + this.i3k_1.hashCode() | 0;
    result = imul(result, 31) + this.j3k_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k3k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l3k_1) | 0;
    return result;
  };
  protoOf(SetupConnectionDeferralDecisionView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionDeferralDecisionView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionDeferralDecisionView ? other : THROW_CCE();
    if (!(this.d3k_1 === tmp0_other_with_cast.d3k_1))
      return false;
    if (!this.e3k_1.equals(tmp0_other_with_cast.e3k_1))
      return false;
    if (!this.f3k_1.equals(tmp0_other_with_cast.f3k_1))
      return false;
    if (!this.g3k_1.equals(tmp0_other_with_cast.g3k_1))
      return false;
    if (!(this.h3k_1 === tmp0_other_with_cast.h3k_1))
      return false;
    if (!this.i3k_1.equals(tmp0_other_with_cast.i3k_1))
      return false;
    if (!this.j3k_1.equals(tmp0_other_with_cast.j3k_1))
      return false;
    if (!(this.k3k_1 === tmp0_other_with_cast.k3k_1))
      return false;
    if (!(this.l3k_1 === tmp0_other_with_cast.l3k_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_8($this) {
    return $this.d3j_1.w();
  }
  function SetupConnectionDeferralScope$Companion$_anonymous__psssf5() {
    return createSimpleEnumSerializer('com.ems.console.api.SetupConnectionDeferralScope', values_9());
  }
  var SetupConnectionDeferralScope_ONE_PROVIDER_instance;
  var SetupConnectionDeferralScope_SKIP_ALL_instance;
  function values_9() {
    return [SetupConnectionDeferralScope_ONE_PROVIDER_getInstance(), SetupConnectionDeferralScope_SKIP_ALL_getInstance()];
  }
  function Companion_158() {
    Companion_instance_158 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d3j_1 = lazy(tmp_0, SetupConnectionDeferralScope$Companion$_anonymous__psssf5);
  }
  protoOf(Companion_158).w19 = function () {
    return _get_$cachedSerializer__te6jhj_8(this);
  };
  protoOf(Companion_158).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_158;
  function Companion_getInstance_158() {
    SetupConnectionDeferralScope_initEntries();
    if (Companion_instance_158 == null)
      new Companion_158();
    return Companion_instance_158;
  }
  var SetupConnectionDeferralScope_entriesInitialized;
  function SetupConnectionDeferralScope_initEntries() {
    if (SetupConnectionDeferralScope_entriesInitialized)
      return Unit_instance;
    SetupConnectionDeferralScope_entriesInitialized = true;
    SetupConnectionDeferralScope_ONE_PROVIDER_instance = new SetupConnectionDeferralScope('ONE_PROVIDER', 0);
    SetupConnectionDeferralScope_SKIP_ALL_instance = new SetupConnectionDeferralScope('SKIP_ALL', 1);
    Companion_getInstance_158();
  }
  function SetupConnectionDeferralScope(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function _get_$cachedSerializer__te6jhj_9($this) {
    return $this.e3j_1.w();
  }
  function SetupConnectionDeferralDecision$Companion$_anonymous__17p8jx() {
    return createSimpleEnumSerializer('com.ems.console.api.SetupConnectionDeferralDecision', values_10());
  }
  var SetupConnectionDeferralDecision_SKIPPED_instance;
  function values_10() {
    return [SetupConnectionDeferralDecision_SKIPPED_getInstance()];
  }
  function Companion_159() {
    Companion_instance_159 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.e3j_1 = lazy(tmp_0, SetupConnectionDeferralDecision$Companion$_anonymous__17p8jx);
  }
  protoOf(Companion_159).w19 = function () {
    return _get_$cachedSerializer__te6jhj_9(this);
  };
  protoOf(Companion_159).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_159;
  function Companion_getInstance_159() {
    SetupConnectionDeferralDecision_initEntries();
    if (Companion_instance_159 == null)
      new Companion_159();
    return Companion_instance_159;
  }
  var SetupConnectionDeferralDecision_entriesInitialized;
  function SetupConnectionDeferralDecision_initEntries() {
    if (SetupConnectionDeferralDecision_entriesInitialized)
      return Unit_instance;
    SetupConnectionDeferralDecision_entriesInitialized = true;
    SetupConnectionDeferralDecision_SKIPPED_instance = new SetupConnectionDeferralDecision('SKIPPED', 0);
    Companion_getInstance_159();
  }
  function SetupConnectionDeferralDecision(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SetupConnectionDeferralScope_ONE_PROVIDER_getInstance() {
    SetupConnectionDeferralScope_initEntries();
    return SetupConnectionDeferralScope_ONE_PROVIDER_instance;
  }
  function SetupConnectionDeferralScope_SKIP_ALL_getInstance() {
    SetupConnectionDeferralScope_initEntries();
    return SetupConnectionDeferralScope_SKIP_ALL_instance;
  }
  function SetupConnectionDeferralDecision_SKIPPED_getInstance() {
    SetupConnectionDeferralDecision_initEntries();
    return SetupConnectionDeferralDecision_SKIPPED_instance;
  }
  function Companion_160() {
    Companion_instance_160 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m3k_1 = [null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_192())];
  }
  var Companion_instance_160;
  function Companion_getInstance_160() {
    if (Companion_instance_160 == null)
      new Companion_160();
    return Companion_instance_160;
  }
  function $serializer_192() {
    $serializer_instance_191 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionsReadView', this, 6);
    tmp0_serialDesc.gy('attempt', false);
    tmp0_serialDesc.gy('entitlementVersion', false);
    tmp0_serialDesc.gy('featureCatalogVersion', false);
    tmp0_serialDesc.gy('accessVerified', false);
    tmp0_serialDesc.gy('accountStatusAvailable', false);
    tmp0_serialDesc.gy('providers', false);
    this.n3k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_192).o3k = function (encoder, value) {
    var tmp0_desc = this.n3k_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_160().m3k_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_175(), value.p3k_1);
    tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.q3k_1);
    tmp1_output.ls(tmp0_desc, 2, IntSerializer_getInstance(), value.r3k_1);
    tmp1_output.zr(tmp0_desc, 3, value.s3k_1);
    tmp1_output.zr(tmp0_desc, 4, value.t3k_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.u3k_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_192).on = function (encoder, value) {
    return this.o3k(encoder, value instanceof SetupConnectionsReadView ? value : THROW_CCE());
  };
  protoOf($serializer_192).pn = function (decoder) {
    var tmp0_desc = this.n3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    var tmp11_cached = Companion_getInstance_160().m3k_1;
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.fr(tmp0_desc, 0, $serializer_getInstance_175(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.hr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.fr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.fr(tmp0_desc, 0, $serializer_getInstance_175(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.hr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.fr(tmp0_desc, 5, tmp11_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return SetupConnectionsReadView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_192).nn = function () {
    return this.n3k_1;
  };
  protoOf($serializer_192).vy = function () {
    var tmp0_cached = Companion_getInstance_160().m3k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_175(), get_nullable(LongSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[5]];
  };
  var $serializer_instance_191;
  function $serializer_getInstance_191() {
    if ($serializer_instance_191 == null)
      new $serializer_192();
    return $serializer_instance_191;
  }
  function SetupConnectionsReadView_init_$Init$(seen0, attempt, entitlementVersion, featureCatalogVersion, accessVerified, accountStatusAvailable, providers, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_191().n3k_1);
    }
    $this.p3k_1 = attempt;
    $this.q3k_1 = entitlementVersion;
    $this.r3k_1 = featureCatalogVersion;
    $this.s3k_1 = accessVerified;
    $this.t3k_1 = accountStatusAvailable;
    $this.u3k_1 = providers;
    return $this;
  }
  function SetupConnectionsReadView_init_$Create$(seen0, attempt, entitlementVersion, featureCatalogVersion, accessVerified, accountStatusAvailable, providers, serializationConstructorMarker) {
    return SetupConnectionsReadView_init_$Init$(seen0, attempt, entitlementVersion, featureCatalogVersion, accessVerified, accountStatusAvailable, providers, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionsReadView)));
  }
  function SetupConnectionsReadView(attempt, entitlementVersion, featureCatalogVersion, accessVerified, accountStatusAvailable, providers) {
    Companion_getInstance_160();
    this.p3k_1 = attempt;
    this.q3k_1 = entitlementVersion;
    this.r3k_1 = featureCatalogVersion;
    this.s3k_1 = accessVerified;
    this.t3k_1 = accountStatusAvailable;
    this.u3k_1 = providers;
  }
  protoOf(SetupConnectionsReadView).toString = function () {
    return 'SetupConnectionsReadView(attempt=' + this.p3k_1.toString() + ', entitlementVersion=' + toString_0(this.q3k_1) + ', featureCatalogVersion=' + this.r3k_1 + ', accessVerified=' + this.s3k_1 + ', accountStatusAvailable=' + this.t3k_1 + ', providers=' + toString(this.u3k_1) + ')';
  };
  protoOf(SetupConnectionsReadView).hashCode = function () {
    var result = this.p3k_1.hashCode();
    result = imul(result, 31) + (this.q3k_1 == null ? 0 : this.q3k_1.hashCode()) | 0;
    result = imul(result, 31) + (this.r3k_1 == null ? 0 : this.r3k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s3k_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t3k_1) | 0;
    result = imul(result, 31) + hashCode(this.u3k_1) | 0;
    return result;
  };
  protoOf(SetupConnectionsReadView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionsReadView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionsReadView ? other : THROW_CCE();
    if (!this.p3k_1.equals(tmp0_other_with_cast.p3k_1))
      return false;
    if (!equals(this.q3k_1, tmp0_other_with_cast.q3k_1))
      return false;
    if (!(this.r3k_1 == tmp0_other_with_cast.r3k_1))
      return false;
    if (!(this.s3k_1 === tmp0_other_with_cast.s3k_1))
      return false;
    if (!(this.t3k_1 === tmp0_other_with_cast.t3k_1))
      return false;
    if (!equals(this.u3k_1, tmp0_other_with_cast.u3k_1))
      return false;
    return true;
  };
  function Companion_161() {
    Companion_instance_161 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.v3k_1 = [null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_193()), new ArrayListSerializer($serializer_getInstance_195()), null, new ArrayListSerializer($serializer_getInstance_194())];
  }
  var Companion_instance_161;
  function Companion_getInstance_161() {
    if (Companion_instance_161 == null)
      new Companion_161();
    return Companion_instance_161;
  }
  function $serializer_193() {
    $serializer_instance_192 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionProviderView', this, 13);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('platformOnly', false);
    tmp0_serialDesc.gy('ownership', false);
    tmp0_serialDesc.gy('proofStatus', false);
    tmp0_serialDesc.gy('effectiveGranted', false);
    tmp0_serialDesc.gy('eligibleForSetup', false);
    tmp0_serialDesc.gy('blockedReasons', false);
    tmp0_serialDesc.gy('operations', false);
    tmp0_serialDesc.gy('accounts', false);
    tmp0_serialDesc.gy('runtimeStatus', true);
    tmp0_serialDesc.gy('fields', true);
    this.w3k_1 = tmp0_serialDesc;
  }
  protoOf($serializer_193).x3k = function (encoder, value) {
    var tmp0_desc = this.w3k_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_161().v3k_1;
    tmp1_output.hs(tmp0_desc, 0, value.y3k_1);
    tmp1_output.hs(tmp0_desc, 1, value.z3k_1);
    tmp1_output.hs(tmp0_desc, 2, value.a3l_1);
    tmp1_output.zr(tmp0_desc, 3, value.b3l_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.c3l_1);
    tmp1_output.hs(tmp0_desc, 5, value.d3l_1);
    tmp1_output.zr(tmp0_desc, 6, value.e3l_1);
    tmp1_output.zr(tmp0_desc, 7, value.f3l_1);
    tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.g3l_1);
    tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.h3l_1);
    tmp1_output.js(tmp0_desc, 10, tmp2_cached[10], value.i3l_1);
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.j3l_1 === 'UNVERIFIED')) {
      tmp1_output.hs(tmp0_desc, 11, value.j3l_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !equals(value.k3l_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 12, tmp2_cached[12], value.k3l_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_193).on = function (encoder, value) {
    return this.x3k(encoder, value instanceof SetupConnectionProviderView ? value : THROW_CCE());
  };
  protoOf($serializer_193).pn = function (decoder) {
    var tmp0_desc = this.w3k_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = false;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_local7 = false;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.tq(tmp0_desc);
    var tmp18_cached = Companion_getInstance_161().v3k_1;
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.fr(tmp0_desc, 4, tmp18_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.vq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.fr(tmp0_desc, 8, tmp18_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.fr(tmp0_desc, 10, tmp18_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.dr(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.fr(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.fr(tmp0_desc, 4, tmp18_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.vq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.fr(tmp0_desc, 8, tmp18_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.fr(tmp0_desc, 10, tmp18_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.dr(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.fr(tmp0_desc, 12, tmp18_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return SetupConnectionProviderView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_193).nn = function () {
    return this.w3k_1;
  };
  protoOf($serializer_193).vy = function () {
    var tmp0_cached = Companion_getInstance_161().v3k_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[4], StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[8], tmp0_cached[9], tmp0_cached[10], StringSerializer_getInstance(), tmp0_cached[12]];
  };
  var $serializer_instance_192;
  function $serializer_getInstance_192() {
    if ($serializer_instance_192 == null)
      new $serializer_193();
    return $serializer_instance_192;
  }
  function SetupConnectionProviderView_init_$Init$(seen0, id, nameEn, nameAr, platformOnly, ownership, proofStatus, effectiveGranted, eligibleForSetup, blockedReasons, operations, accounts, runtimeStatus, fields, serializationConstructorMarker, $this) {
    if (!(2047 === (2047 & seen0))) {
      throwMissingFieldException(seen0, 2047, $serializer_getInstance_192().w3k_1);
    }
    $this.y3k_1 = id;
    $this.z3k_1 = nameEn;
    $this.a3l_1 = nameAr;
    $this.b3l_1 = platformOnly;
    $this.c3l_1 = ownership;
    $this.d3l_1 = proofStatus;
    $this.e3l_1 = effectiveGranted;
    $this.f3l_1 = eligibleForSetup;
    $this.g3l_1 = blockedReasons;
    $this.h3l_1 = operations;
    $this.i3l_1 = accounts;
    if (0 === (seen0 & 2048))
      $this.j3l_1 = 'UNVERIFIED';
    else
      $this.j3l_1 = runtimeStatus;
    if (0 === (seen0 & 4096))
      $this.k3l_1 = emptyList();
    else
      $this.k3l_1 = fields;
    return $this;
  }
  function SetupConnectionProviderView_init_$Create$(seen0, id, nameEn, nameAr, platformOnly, ownership, proofStatus, effectiveGranted, eligibleForSetup, blockedReasons, operations, accounts, runtimeStatus, fields, serializationConstructorMarker) {
    return SetupConnectionProviderView_init_$Init$(seen0, id, nameEn, nameAr, platformOnly, ownership, proofStatus, effectiveGranted, eligibleForSetup, blockedReasons, operations, accounts, runtimeStatus, fields, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionProviderView)));
  }
  function SetupConnectionProviderView() {
  }
  protoOf(SetupConnectionProviderView).toString = function () {
    return 'SetupConnectionProviderView(id=' + this.y3k_1 + ', nameEn=' + this.z3k_1 + ', nameAr=' + this.a3l_1 + ', platformOnly=' + this.b3l_1 + ', ownership=' + toString(this.c3l_1) + ', proofStatus=' + this.d3l_1 + ', effectiveGranted=' + this.e3l_1 + ', eligibleForSetup=' + this.f3l_1 + ', blockedReasons=' + toString(this.g3l_1) + ', operations=' + toString(this.h3l_1) + ', accounts=' + toString(this.i3l_1) + ', runtimeStatus=' + this.j3l_1 + ', fields=' + toString(this.k3l_1) + ')';
  };
  protoOf(SetupConnectionProviderView).hashCode = function () {
    var result = getStringHashCode(this.y3k_1);
    result = imul(result, 31) + getStringHashCode(this.z3k_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.a3l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.b3l_1) | 0;
    result = imul(result, 31) + hashCode(this.c3l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d3l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e3l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f3l_1) | 0;
    result = imul(result, 31) + hashCode(this.g3l_1) | 0;
    result = imul(result, 31) + hashCode(this.h3l_1) | 0;
    result = imul(result, 31) + hashCode(this.i3l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j3l_1) | 0;
    result = imul(result, 31) + hashCode(this.k3l_1) | 0;
    return result;
  };
  protoOf(SetupConnectionProviderView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionProviderView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionProviderView ? other : THROW_CCE();
    if (!(this.y3k_1 === tmp0_other_with_cast.y3k_1))
      return false;
    if (!(this.z3k_1 === tmp0_other_with_cast.z3k_1))
      return false;
    if (!(this.a3l_1 === tmp0_other_with_cast.a3l_1))
      return false;
    if (!(this.b3l_1 === tmp0_other_with_cast.b3l_1))
      return false;
    if (!equals(this.c3l_1, tmp0_other_with_cast.c3l_1))
      return false;
    if (!(this.d3l_1 === tmp0_other_with_cast.d3l_1))
      return false;
    if (!(this.e3l_1 === tmp0_other_with_cast.e3l_1))
      return false;
    if (!(this.f3l_1 === tmp0_other_with_cast.f3l_1))
      return false;
    if (!equals(this.g3l_1, tmp0_other_with_cast.g3l_1))
      return false;
    if (!equals(this.h3l_1, tmp0_other_with_cast.h3l_1))
      return false;
    if (!equals(this.i3l_1, tmp0_other_with_cast.i3l_1))
      return false;
    if (!(this.j3l_1 === tmp0_other_with_cast.j3l_1))
      return false;
    if (!equals(this.k3l_1, tmp0_other_with_cast.k3l_1))
      return false;
    return true;
  };
  function Companion_162() {
    Companion_instance_162 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l3l_1 = [null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_162;
  function Companion_getInstance_162() {
    if (Companion_instance_162 == null)
      new Companion_162();
    return Companion_instance_162;
  }
  function $serializer_194() {
    $serializer_instance_193 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionOperationView', this, 9);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('featureKey', false);
    tmp0_serialDesc.gy('proofStatus', false);
    tmp0_serialDesc.gy('effectiveGranted', false);
    tmp0_serialDesc.gy('permitted', false);
    tmp0_serialDesc.gy('blockedReasons', false);
    tmp0_serialDesc.gy('consumedLimits', false);
    this.m3l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_194).n3l = function (encoder, value) {
    var tmp0_desc = this.m3l_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_162().l3l_1;
    tmp1_output.hs(tmp0_desc, 0, value.o3l_1);
    tmp1_output.hs(tmp0_desc, 1, value.p3l_1);
    tmp1_output.hs(tmp0_desc, 2, value.q3l_1);
    tmp1_output.hs(tmp0_desc, 3, value.r3l_1);
    tmp1_output.hs(tmp0_desc, 4, value.s3l_1);
    tmp1_output.zr(tmp0_desc, 5, value.t3l_1);
    tmp1_output.zr(tmp0_desc, 6, value.u3l_1);
    tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.v3l_1);
    tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.w3l_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_194).on = function (encoder, value) {
    return this.n3l(encoder, value instanceof SetupConnectionOperationView ? value : THROW_CCE());
  };
  protoOf($serializer_194).pn = function (decoder) {
    var tmp0_desc = this.m3l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = false;
    var tmp10_local6 = false;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    var tmp14_cached = Companion_getInstance_162().l3l_1;
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.vq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.vq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.fr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.vq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.vq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.fr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupConnectionOperationView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_194).nn = function () {
    return this.m3l_1;
  };
  protoOf($serializer_194).vy = function () {
    var tmp0_cached = Companion_getInstance_162().l3l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[7], tmp0_cached[8]];
  };
  var $serializer_instance_193;
  function $serializer_getInstance_193() {
    if ($serializer_instance_193 == null)
      new $serializer_194();
    return $serializer_instance_193;
  }
  function SetupConnectionOperationView_init_$Init$(seen0, key, nameEn, nameAr, featureKey, proofStatus, effectiveGranted, permitted, blockedReasons, consumedLimits, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_193().m3l_1);
    }
    $this.o3l_1 = key;
    $this.p3l_1 = nameEn;
    $this.q3l_1 = nameAr;
    $this.r3l_1 = featureKey;
    $this.s3l_1 = proofStatus;
    $this.t3l_1 = effectiveGranted;
    $this.u3l_1 = permitted;
    $this.v3l_1 = blockedReasons;
    $this.w3l_1 = consumedLimits;
    return $this;
  }
  function SetupConnectionOperationView_init_$Create$(seen0, key, nameEn, nameAr, featureKey, proofStatus, effectiveGranted, permitted, blockedReasons, consumedLimits, serializationConstructorMarker) {
    return SetupConnectionOperationView_init_$Init$(seen0, key, nameEn, nameAr, featureKey, proofStatus, effectiveGranted, permitted, blockedReasons, consumedLimits, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionOperationView)));
  }
  function SetupConnectionOperationView() {
  }
  protoOf(SetupConnectionOperationView).toString = function () {
    return 'SetupConnectionOperationView(key=' + this.o3l_1 + ', nameEn=' + this.p3l_1 + ', nameAr=' + this.q3l_1 + ', featureKey=' + this.r3l_1 + ', proofStatus=' + this.s3l_1 + ', effectiveGranted=' + this.t3l_1 + ', permitted=' + this.u3l_1 + ', blockedReasons=' + toString(this.v3l_1) + ', consumedLimits=' + toString(this.w3l_1) + ')';
  };
  protoOf(SetupConnectionOperationView).hashCode = function () {
    var result = getStringHashCode(this.o3l_1);
    result = imul(result, 31) + getStringHashCode(this.p3l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q3l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.r3l_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.s3l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t3l_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.u3l_1) | 0;
    result = imul(result, 31) + hashCode(this.v3l_1) | 0;
    result = imul(result, 31) + hashCode(this.w3l_1) | 0;
    return result;
  };
  protoOf(SetupConnectionOperationView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionOperationView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionOperationView ? other : THROW_CCE();
    if (!(this.o3l_1 === tmp0_other_with_cast.o3l_1))
      return false;
    if (!(this.p3l_1 === tmp0_other_with_cast.p3l_1))
      return false;
    if (!(this.q3l_1 === tmp0_other_with_cast.q3l_1))
      return false;
    if (!(this.r3l_1 === tmp0_other_with_cast.r3l_1))
      return false;
    if (!(this.s3l_1 === tmp0_other_with_cast.s3l_1))
      return false;
    if (!(this.t3l_1 === tmp0_other_with_cast.t3l_1))
      return false;
    if (!(this.u3l_1 === tmp0_other_with_cast.u3l_1))
      return false;
    if (!equals(this.v3l_1, tmp0_other_with_cast.v3l_1))
      return false;
    if (!equals(this.w3l_1, tmp0_other_with_cast.w3l_1))
      return false;
    return true;
  };
  function Companion_163() {
    Companion_instance_163 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x3l_1 = [null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_163;
  function Companion_getInstance_163() {
    if (Companion_instance_163 == null)
      new Companion_163();
    return Companion_instance_163;
  }
  function $serializer_195() {
    $serializer_instance_194 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionFieldView', this, 9);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('type', false);
    tmp0_serialDesc.gy('secret', false);
    tmp0_serialDesc.gy('required', false);
    tmp0_serialDesc.gy('options', true);
    tmp0_serialDesc.gy('minimum', true);
    tmp0_serialDesc.gy('maximum', true);
    this.y3l_1 = tmp0_serialDesc;
  }
  protoOf($serializer_195).z3l = function (encoder, value) {
    var tmp0_desc = this.y3l_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_163().x3l_1;
    tmp1_output.hs(tmp0_desc, 0, value.a3m_1);
    tmp1_output.hs(tmp0_desc, 1, value.b3m_1);
    tmp1_output.hs(tmp0_desc, 2, value.c3m_1);
    tmp1_output.hs(tmp0_desc, 3, value.d3m_1);
    tmp1_output.zr(tmp0_desc, 4, value.e3m_1);
    tmp1_output.zr(tmp0_desc, 5, value.f3m_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !equals(value.g3m_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.g3m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.h3m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.h3m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.i3m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, LongSerializer_getInstance(), value.i3m_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_195).on = function (encoder, value) {
    return this.z3l(encoder, value instanceof SetupConnectionFieldView ? value : THROW_CCE());
  };
  protoOf($serializer_195).pn = function (decoder) {
    var tmp0_desc = this.y3l_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    var tmp14_cached = Companion_getInstance_163().x3l_1;
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.vq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.fr(tmp0_desc, 6, tmp14_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.vq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.fr(tmp0_desc, 6, tmp14_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.hr(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupConnectionFieldView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_195).nn = function () {
    return this.y3l_1;
  };
  protoOf($serializer_195).vy = function () {
    var tmp0_cached = Companion_getInstance_163().x3l_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[6], get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_194;
  function $serializer_getInstance_194() {
    if ($serializer_instance_194 == null)
      new $serializer_195();
    return $serializer_instance_194;
  }
  function SetupConnectionFieldView_init_$Init$(seen0, key, nameEn, nameAr, type, secret, required, options, minimum, maximum, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_194().y3l_1);
    }
    $this.a3m_1 = key;
    $this.b3m_1 = nameEn;
    $this.c3m_1 = nameAr;
    $this.d3m_1 = type;
    $this.e3m_1 = secret;
    $this.f3m_1 = required;
    if (0 === (seen0 & 64))
      $this.g3m_1 = emptyList();
    else
      $this.g3m_1 = options;
    if (0 === (seen0 & 128))
      $this.h3m_1 = null;
    else
      $this.h3m_1 = minimum;
    if (0 === (seen0 & 256))
      $this.i3m_1 = null;
    else
      $this.i3m_1 = maximum;
    return $this;
  }
  function SetupConnectionFieldView_init_$Create$(seen0, key, nameEn, nameAr, type, secret, required, options, minimum, maximum, serializationConstructorMarker) {
    return SetupConnectionFieldView_init_$Init$(seen0, key, nameEn, nameAr, type, secret, required, options, minimum, maximum, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionFieldView)));
  }
  function SetupConnectionFieldView() {
  }
  protoOf(SetupConnectionFieldView).toString = function () {
    return 'SetupConnectionFieldView(key=' + this.a3m_1 + ', nameEn=' + this.b3m_1 + ', nameAr=' + this.c3m_1 + ', type=' + this.d3m_1 + ', secret=' + this.e3m_1 + ', required=' + this.f3m_1 + ', options=' + toString(this.g3m_1) + ', minimum=' + toString_0(this.h3m_1) + ', maximum=' + toString_0(this.i3m_1) + ')';
  };
  protoOf(SetupConnectionFieldView).hashCode = function () {
    var result = getStringHashCode(this.a3m_1);
    result = imul(result, 31) + getStringHashCode(this.b3m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c3m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d3m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e3m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f3m_1) | 0;
    result = imul(result, 31) + hashCode(this.g3m_1) | 0;
    result = imul(result, 31) + (this.h3m_1 == null ? 0 : this.h3m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.i3m_1 == null ? 0 : this.i3m_1.hashCode()) | 0;
    return result;
  };
  protoOf(SetupConnectionFieldView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionFieldView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionFieldView ? other : THROW_CCE();
    if (!(this.a3m_1 === tmp0_other_with_cast.a3m_1))
      return false;
    if (!(this.b3m_1 === tmp0_other_with_cast.b3m_1))
      return false;
    if (!(this.c3m_1 === tmp0_other_with_cast.c3m_1))
      return false;
    if (!(this.d3m_1 === tmp0_other_with_cast.d3m_1))
      return false;
    if (!(this.e3m_1 === tmp0_other_with_cast.e3m_1))
      return false;
    if (!(this.f3m_1 === tmp0_other_with_cast.f3m_1))
      return false;
    if (!equals(this.g3m_1, tmp0_other_with_cast.g3m_1))
      return false;
    if (!equals(this.h3m_1, tmp0_other_with_cast.h3m_1))
      return false;
    if (!equals(this.i3m_1, tmp0_other_with_cast.i3m_1))
      return false;
    return true;
  };
  function $serializer_196() {
    $serializer_instance_195 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupConnectionAccountView', this, 5);
    tmp0_serialDesc.gy('accountId', false);
    tmp0_serialDesc.gy('displayName', false);
    tmp0_serialDesc.gy('credentialOwner', false);
    tmp0_serialDesc.gy('configurationStatus', false);
    tmp0_serialDesc.gy('assignmentEnabled', false);
    this.j3m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_196).k3m = function (encoder, value) {
    var tmp0_desc = this.j3m_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.l3m_1);
    tmp1_output.hs(tmp0_desc, 1, value.m3m_1);
    tmp1_output.hs(tmp0_desc, 2, value.n3m_1);
    tmp1_output.hs(tmp0_desc, 3, value.o3m_1);
    tmp1_output.zr(tmp0_desc, 4, value.p3m_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_196).on = function (encoder, value) {
    return this.k3m(encoder, value instanceof SetupConnectionAccountView ? value : THROW_CCE());
  };
  protoOf($serializer_196).pn = function (decoder) {
    var tmp0_desc = this.j3m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return SetupConnectionAccountView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_196).nn = function () {
    return this.j3m_1;
  };
  protoOf($serializer_196).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_195;
  function $serializer_getInstance_195() {
    if ($serializer_instance_195 == null)
      new $serializer_196();
    return $serializer_instance_195;
  }
  function SetupConnectionAccountView_init_$Init$(seen0, accountId, displayName, credentialOwner, configurationStatus, assignmentEnabled, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_195().j3m_1);
    }
    $this.l3m_1 = accountId;
    $this.m3m_1 = displayName;
    $this.n3m_1 = credentialOwner;
    $this.o3m_1 = configurationStatus;
    $this.p3m_1 = assignmentEnabled;
    return $this;
  }
  function SetupConnectionAccountView_init_$Create$(seen0, accountId, displayName, credentialOwner, configurationStatus, assignmentEnabled, serializationConstructorMarker) {
    return SetupConnectionAccountView_init_$Init$(seen0, accountId, displayName, credentialOwner, configurationStatus, assignmentEnabled, serializationConstructorMarker, objectCreate(protoOf(SetupConnectionAccountView)));
  }
  function SetupConnectionAccountView() {
  }
  protoOf(SetupConnectionAccountView).toString = function () {
    return 'SetupConnectionAccountView(accountId=' + this.l3m_1 + ', displayName=' + this.m3m_1 + ', credentialOwner=' + this.n3m_1 + ', configurationStatus=' + this.o3m_1 + ', assignmentEnabled=' + this.p3m_1 + ')';
  };
  protoOf(SetupConnectionAccountView).hashCode = function () {
    var result = getStringHashCode(this.l3m_1);
    result = imul(result, 31) + getStringHashCode(this.m3m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n3m_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o3m_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.p3m_1) | 0;
    return result;
  };
  protoOf(SetupConnectionAccountView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupConnectionAccountView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupConnectionAccountView ? other : THROW_CCE();
    if (!(this.l3m_1 === tmp0_other_with_cast.l3m_1))
      return false;
    if (!(this.m3m_1 === tmp0_other_with_cast.m3m_1))
      return false;
    if (!(this.n3m_1 === tmp0_other_with_cast.n3m_1))
      return false;
    if (!(this.o3m_1 === tmp0_other_with_cast.o3m_1))
      return false;
    if (!(this.p3m_1 === tmp0_other_with_cast.p3m_1))
      return false;
    return true;
  };
  function _get_$cachedSerializer__te6jhj_10($this) {
    return $this.q3m_1.w();
  }
  function SetupCopiedImageChoice$Companion$_anonymous__c7qi7g() {
    return createSimpleEnumSerializer('com.ems.console.api.SetupCopiedImageChoice', values_11());
  }
  var SetupCopiedImageChoice_KEEP_instance;
  var SetupCopiedImageChoice_CLEAR_instance;
  var SetupCopiedImageChoice_REPLACE_instance;
  function values_11() {
    return [SetupCopiedImageChoice_KEEP_getInstance(), SetupCopiedImageChoice_CLEAR_getInstance(), SetupCopiedImageChoice_REPLACE_getInstance()];
  }
  function Companion_164() {
    Companion_instance_164 = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.q3m_1 = lazy(tmp_0, SetupCopiedImageChoice$Companion$_anonymous__c7qi7g);
  }
  protoOf(Companion_164).w19 = function () {
    return _get_$cachedSerializer__te6jhj_10(this);
  };
  protoOf(Companion_164).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var Companion_instance_164;
  function Companion_getInstance_164() {
    SetupCopiedImageChoice_initEntries();
    if (Companion_instance_164 == null)
      new Companion_164();
    return Companion_instance_164;
  }
  var SetupCopiedImageChoice_entriesInitialized;
  function SetupCopiedImageChoice_initEntries() {
    if (SetupCopiedImageChoice_entriesInitialized)
      return Unit_instance;
    SetupCopiedImageChoice_entriesInitialized = true;
    SetupCopiedImageChoice_KEEP_instance = new SetupCopiedImageChoice('KEEP', 0);
    SetupCopiedImageChoice_CLEAR_instance = new SetupCopiedImageChoice('CLEAR', 1);
    SetupCopiedImageChoice_REPLACE_instance = new SetupCopiedImageChoice('REPLACE', 2);
    Companion_getInstance_164();
  }
  function SetupCopiedImageChoice(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Companion_165() {
    Companion_instance_165 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r3m_1 = [Companion_getInstance_164().w19(), Companion_getInstance_164().w19(), Companion_getInstance_164().w19()];
  }
  var Companion_instance_165;
  function Companion_getInstance_165() {
    if (Companion_instance_165 == null)
      new Companion_165();
    return Companion_instance_165;
  }
  function $serializer_197() {
    $serializer_instance_196 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopiedImageChoices', this, 3);
    tmp0_serialDesc.gy('lightLogo', true);
    tmp0_serialDesc.gy('darkLogo', true);
    tmp0_serialDesc.gy('favicon', true);
    this.s3m_1 = tmp0_serialDesc;
  }
  protoOf($serializer_197).t3m = function (encoder, value) {
    var tmp0_desc = this.s3m_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_165().r3m_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.u3m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, tmp2_cached[0], value.u3m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.v3m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, tmp2_cached[1], value.v3m_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.w3m_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, tmp2_cached[2], value.w3m_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_197).on = function (encoder, value) {
    return this.t3m(encoder, value instanceof SetupCopiedImageChoices ? value : THROW_CCE());
  };
  protoOf($serializer_197).pn = function (decoder) {
    var tmp0_desc = this.s3m_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_165().r3m_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.hr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.hr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return SetupCopiedImageChoices_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_197).nn = function () {
    return this.s3m_1;
  };
  protoOf($serializer_197).vy = function () {
    var tmp0_cached = Companion_getInstance_165().r3m_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable(tmp0_cached[1]), get_nullable(tmp0_cached[2])];
  };
  var $serializer_instance_196;
  function $serializer_getInstance_196() {
    if ($serializer_instance_196 == null)
      new $serializer_197();
    return $serializer_instance_196;
  }
  function SetupCopiedImageChoices_init_$Init$(seen0, lightLogo, darkLogo, favicon, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_196().s3m_1);
    }
    if (0 === (seen0 & 1))
      $this.u3m_1 = null;
    else
      $this.u3m_1 = lightLogo;
    if (0 === (seen0 & 2))
      $this.v3m_1 = null;
    else
      $this.v3m_1 = darkLogo;
    if (0 === (seen0 & 4))
      $this.w3m_1 = null;
    else
      $this.w3m_1 = favicon;
    return $this;
  }
  function SetupCopiedImageChoices_init_$Create$(seen0, lightLogo, darkLogo, favicon, serializationConstructorMarker) {
    return SetupCopiedImageChoices_init_$Init$(seen0, lightLogo, darkLogo, favicon, serializationConstructorMarker, objectCreate(protoOf(SetupCopiedImageChoices)));
  }
  function SetupCopiedImageChoices(lightLogo, darkLogo, favicon) {
    Companion_getInstance_165();
    lightLogo = lightLogo === VOID ? null : lightLogo;
    darkLogo = darkLogo === VOID ? null : darkLogo;
    favicon = favicon === VOID ? null : favicon;
    this.u3m_1 = lightLogo;
    this.v3m_1 = darkLogo;
    this.w3m_1 = favicon;
  }
  protoOf(SetupCopiedImageChoices).x3m = function (lightLogo, darkLogo, favicon) {
    return new SetupCopiedImageChoices(lightLogo, darkLogo, favicon);
  };
  protoOf(SetupCopiedImageChoices).y3m = function (lightLogo, darkLogo, favicon, $super) {
    lightLogo = lightLogo === VOID ? this.u3m_1 : lightLogo;
    darkLogo = darkLogo === VOID ? this.v3m_1 : darkLogo;
    favicon = favicon === VOID ? this.w3m_1 : favicon;
    return $super === VOID ? this.x3m(lightLogo, darkLogo, favicon) : $super.x3m.call(this, lightLogo, darkLogo, favicon);
  };
  protoOf(SetupCopiedImageChoices).toString = function () {
    return 'SetupCopiedImageChoices(lightLogo=' + toString_0(this.u3m_1) + ', darkLogo=' + toString_0(this.v3m_1) + ', favicon=' + toString_0(this.w3m_1) + ')';
  };
  protoOf(SetupCopiedImageChoices).hashCode = function () {
    var result = this.u3m_1 == null ? 0 : this.u3m_1.hashCode();
    result = imul(result, 31) + (this.v3m_1 == null ? 0 : this.v3m_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w3m_1 == null ? 0 : this.w3m_1.hashCode()) | 0;
    return result;
  };
  protoOf(SetupCopiedImageChoices).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopiedImageChoices))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopiedImageChoices ? other : THROW_CCE();
    if (!equals(this.u3m_1, tmp0_other_with_cast.u3m_1))
      return false;
    if (!equals(this.v3m_1, tmp0_other_with_cast.v3m_1))
      return false;
    if (!equals(this.w3m_1, tmp0_other_with_cast.w3m_1))
      return false;
    return true;
  };
  function withReferences$choice(old, new_0, existing) {
    return old == new_0 ? existing : new_0 == null ? SetupCopiedImageChoice_CLEAR_getInstance() : SetupCopiedImageChoice_REPLACE_getInstance();
  }
  function SetupCopiedImageRules() {
  }
  protoOf(SetupCopiedImageRules).z3m = function (before, kind, choice) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(!(before.m2y_1 == null) && before.n2y_1.r('BRANDING_ASSETS'))) {
      // Inline function 'com.ems.console.api.SetupCopiedImageRules.choose.<anonymous>' call
      var message = 'Copy appearance must be selected';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!choice.equals(SetupCopiedImageChoice_REPLACE_getInstance())) {
      // Inline function 'com.ems.console.api.SetupCopiedImageRules.choose.<anonymous>' call
      var message_0 = 'Upload a replacement image first';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var tmp0_elvis_lhs = before.s2y_1;
    var current = tmp0_elvis_lhs == null ? new SetupCopiedImageChoices() : tmp0_elvis_lhs;
    var tmp;
    switch (kind.o2_1) {
      case 0:
        tmp = before.c2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null, VOID, VOID, VOID, current.y3m(choice));
        break;
      case 1:
        tmp = before.c2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null, VOID, VOID, current.y3m(VOID, choice));
        break;
      case 2:
        tmp = before.c2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, null, VOID, current.y3m(VOID, VOID, choice));
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(SetupCopiedImageRules).a3n = function (before, light, dark, favicon) {
    var changed = !(before.o2y_1 == light) || !(before.p2y_1 == dark) || !(before.q2y_1 == favicon);
    var copying = !(before.m2y_1 == null) && before.n2y_1.r('BRANDING_ASSETS');
    var tmp;
    if (!copying || !changed) {
      tmp = before.s2y_1;
    } else {
      var tmp0_safe_receiver = before.s2y_1;
      var tmp_0 = withReferences$choice(before.o2y_1, light, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u3m_1);
      var tmp1_safe_receiver = before.s2y_1;
      var tmp_1 = withReferences$choice(before.p2y_1, dark, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.v3m_1);
      var tmp2_safe_receiver = before.s2y_1;
      tmp = new SetupCopiedImageChoices(tmp_0, tmp_1, withReferences$choice(before.q2y_1, favicon, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.w3m_1));
    }
    var intent = tmp;
    return before.c2z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, light, dark, favicon, VOID, intent);
  };
  var SetupCopiedImageRules_instance;
  function SetupCopiedImageRules_getInstance() {
    return SetupCopiedImageRules_instance;
  }
  function SetupCopiedImageChoice_KEEP_getInstance() {
    SetupCopiedImageChoice_initEntries();
    return SetupCopiedImageChoice_KEEP_instance;
  }
  function SetupCopiedImageChoice_CLEAR_getInstance() {
    SetupCopiedImageChoice_initEntries();
    return SetupCopiedImageChoice_CLEAR_instance;
  }
  function SetupCopiedImageChoice_REPLACE_getInstance() {
    SetupCopiedImageChoice_initEntries();
    return SetupCopiedImageChoice_REPLACE_instance;
  }
  function Companion_166() {
    Companion_instance_166 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b3n_1 = [null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_200()), null, new ArrayListSerializer($serializer_getInstance_35()), new ArrayListSerializer($serializer_getInstance_199())];
  }
  var Companion_instance_166;
  function Companion_getInstance_166() {
    if (Companion_instance_166 == null)
      new Companion_166();
    return Companion_instance_166;
  }
  function $serializer_198() {
    $serializer_instance_197 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyPreviewView', this, 9);
    tmp0_serialDesc.gy('draftId', false);
    tmp0_serialDesc.gy('draftRevision', false);
    tmp0_serialDesc.gy('snapshotId', false);
    tmp0_serialDesc.gy('snapshotSha256', false);
    tmp0_serialDesc.gy('templateIdentity', false);
    tmp0_serialDesc.gy('categories', false);
    tmp0_serialDesc.gy('canAccept', false);
    tmp0_serialDesc.gy('fieldErrors', true);
    tmp0_serialDesc.gy('exceptions', true);
    this.c3n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_198).d3n = function (encoder, value) {
    var tmp0_desc = this.c3n_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_166().b3n_1;
    tmp1_output.hs(tmp0_desc, 0, value.e3n_1);
    tmp1_output.ds(tmp0_desc, 1, value.f3n_1);
    tmp1_output.hs(tmp0_desc, 2, value.g3n_1);
    tmp1_output.hs(tmp0_desc, 3, value.h3n_1);
    tmp1_output.hs(tmp0_desc, 4, value.i3n_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.j3n_1);
    tmp1_output.zr(tmp0_desc, 6, value.k3n_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !equals(value.l3n_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.l3n_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !equals(value.m3n_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.m3n_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_198).on = function (encoder, value) {
    return this.d3n(encoder, value instanceof SetupCopyPreviewView ? value : THROW_CCE());
  };
  protoOf($serializer_198).pn = function (decoder) {
    var tmp0_desc = this.c3n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.tq(tmp0_desc);
    var tmp14_cached = Companion_getInstance_166().b3n_1;
    if (tmp13_input.ir()) {
      tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.fr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.vq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.fr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.fr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.vq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.fr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.fr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.uq(tmp0_desc);
    return SetupCopyPreviewView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_198).nn = function () {
    return this.c3n_1;
  };
  protoOf($serializer_198).vy = function () {
    var tmp0_cached = Companion_getInstance_166().b3n_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[5], BooleanSerializer_getInstance(), tmp0_cached[7], tmp0_cached[8]];
  };
  var $serializer_instance_197;
  function $serializer_getInstance_197() {
    if ($serializer_instance_197 == null)
      new $serializer_198();
    return $serializer_instance_197;
  }
  function SetupCopyPreviewView_init_$Init$(seen0, draftId, draftRevision, snapshotId, snapshotSha256, templateIdentity, categories, canAccept, fieldErrors, exceptions, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_197().c3n_1);
    }
    $this.e3n_1 = draftId;
    $this.f3n_1 = draftRevision;
    $this.g3n_1 = snapshotId;
    $this.h3n_1 = snapshotSha256;
    $this.i3n_1 = templateIdentity;
    $this.j3n_1 = categories;
    $this.k3n_1 = canAccept;
    if (0 === (seen0 & 128))
      $this.l3n_1 = emptyList();
    else
      $this.l3n_1 = fieldErrors;
    if (0 === (seen0 & 256))
      $this.m3n_1 = emptyList();
    else
      $this.m3n_1 = exceptions;
    return $this;
  }
  function SetupCopyPreviewView_init_$Create$(seen0, draftId, draftRevision, snapshotId, snapshotSha256, templateIdentity, categories, canAccept, fieldErrors, exceptions, serializationConstructorMarker) {
    return SetupCopyPreviewView_init_$Init$(seen0, draftId, draftRevision, snapshotId, snapshotSha256, templateIdentity, categories, canAccept, fieldErrors, exceptions, serializationConstructorMarker, objectCreate(protoOf(SetupCopyPreviewView)));
  }
  function SetupCopyPreviewView(draftId, draftRevision, snapshotId, snapshotSha256, templateIdentity, categories, canAccept, fieldErrors, exceptions) {
    Companion_getInstance_166();
    fieldErrors = fieldErrors === VOID ? emptyList() : fieldErrors;
    exceptions = exceptions === VOID ? emptyList() : exceptions;
    this.e3n_1 = draftId;
    this.f3n_1 = draftRevision;
    this.g3n_1 = snapshotId;
    this.h3n_1 = snapshotSha256;
    this.i3n_1 = templateIdentity;
    this.j3n_1 = categories;
    this.k3n_1 = canAccept;
    this.l3n_1 = fieldErrors;
    this.m3n_1 = exceptions;
  }
  protoOf(SetupCopyPreviewView).toString = function () {
    return 'SetupCopyPreviewView(draftId=' + this.e3n_1 + ', draftRevision=' + this.f3n_1.toString() + ', snapshotId=' + this.g3n_1 + ', snapshotSha256=' + this.h3n_1 + ', templateIdentity=' + this.i3n_1 + ', categories=' + toString(this.j3n_1) + ', canAccept=' + this.k3n_1 + ', fieldErrors=' + toString(this.l3n_1) + ', exceptions=' + toString(this.m3n_1) + ')';
  };
  protoOf(SetupCopyPreviewView).hashCode = function () {
    var result = getStringHashCode(this.e3n_1);
    result = imul(result, 31) + this.f3n_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.g3n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h3n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i3n_1) | 0;
    result = imul(result, 31) + hashCode(this.j3n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k3n_1) | 0;
    result = imul(result, 31) + hashCode(this.l3n_1) | 0;
    result = imul(result, 31) + hashCode(this.m3n_1) | 0;
    return result;
  };
  protoOf(SetupCopyPreviewView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyPreviewView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyPreviewView ? other : THROW_CCE();
    if (!(this.e3n_1 === tmp0_other_with_cast.e3n_1))
      return false;
    if (!this.f3n_1.equals(tmp0_other_with_cast.f3n_1))
      return false;
    if (!(this.g3n_1 === tmp0_other_with_cast.g3n_1))
      return false;
    if (!(this.h3n_1 === tmp0_other_with_cast.h3n_1))
      return false;
    if (!(this.i3n_1 === tmp0_other_with_cast.i3n_1))
      return false;
    if (!equals(this.j3n_1, tmp0_other_with_cast.j3n_1))
      return false;
    if (!(this.k3n_1 === tmp0_other_with_cast.k3n_1))
      return false;
    if (!equals(this.l3n_1, tmp0_other_with_cast.l3n_1))
      return false;
    if (!equals(this.m3n_1, tmp0_other_with_cast.m3n_1))
      return false;
    return true;
  };
  function Companion_167() {
  }
  var Companion_instance_167;
  function Companion_getInstance_167() {
    return Companion_instance_167;
  }
  function $serializer_199() {
    $serializer_instance_198 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PreviewSetupCopyRequest', this, 1);
    tmp0_serialDesc.gy('expectedRevision', false);
    this.n3n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_199).o3n = function (encoder, value) {
    var tmp0_desc = this.n3n_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.ds(tmp0_desc, 0, value.p3n_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_199).on = function (encoder, value) {
    return this.o3n(encoder, value instanceof PreviewSetupCopyRequest ? value : THROW_CCE());
  };
  protoOf($serializer_199).pn = function (decoder) {
    var tmp0_desc = this.n3n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return PreviewSetupCopyRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_199).nn = function () {
    return this.n3n_1;
  };
  protoOf($serializer_199).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance()];
  };
  var $serializer_instance_198;
  function $serializer_getInstance_198() {
    if ($serializer_instance_198 == null)
      new $serializer_199();
    return $serializer_instance_198;
  }
  function PreviewSetupCopyRequest_init_$Init$(seen0, expectedRevision, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_198().n3n_1);
    }
    $this.p3n_1 = expectedRevision;
    return $this;
  }
  function PreviewSetupCopyRequest_init_$Create$(seen0, expectedRevision, serializationConstructorMarker) {
    return PreviewSetupCopyRequest_init_$Init$(seen0, expectedRevision, serializationConstructorMarker, objectCreate(protoOf(PreviewSetupCopyRequest)));
  }
  function PreviewSetupCopyRequest(expectedRevision) {
    this.p3n_1 = expectedRevision;
  }
  protoOf(PreviewSetupCopyRequest).toString = function () {
    return 'PreviewSetupCopyRequest(expectedRevision=' + this.p3n_1.toString() + ')';
  };
  protoOf(PreviewSetupCopyRequest).hashCode = function () {
    return this.p3n_1.hashCode();
  };
  protoOf(PreviewSetupCopyRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PreviewSetupCopyRequest))
      return false;
    var tmp0_other_with_cast = other instanceof PreviewSetupCopyRequest ? other : THROW_CCE();
    if (!this.p3n_1.equals(tmp0_other_with_cast.p3n_1))
      return false;
    return true;
  };
  function $serializer_200() {
    $serializer_instance_199 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyExceptionView', this, 10);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('targetKind', false);
    tmp0_serialDesc.gy('target', false);
    tmp0_serialDesc.gy('effect', false);
    tmp0_serialDesc.gy('value', true);
    tmp0_serialDesc.gy('expiresAtMs', true);
    tmp0_serialDesc.gy('selected', true);
    tmp0_serialDesc.gy('copyable', true);
    tmp0_serialDesc.gy('reason', true);
    this.q3n_1 = tmp0_serialDesc;
  }
  protoOf($serializer_200).r3n = function (encoder, value) {
    var tmp0_desc = this.q3n_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.s3n_1);
    tmp1_output.hs(tmp0_desc, 1, value.t3n_1);
    tmp1_output.hs(tmp0_desc, 2, value.u3n_1);
    tmp1_output.hs(tmp0_desc, 3, value.v3n_1);
    tmp1_output.hs(tmp0_desc, 4, value.w3n_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.x3n_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.x3n_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.y3n_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, LongSerializer_getInstance(), value.y3n_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.z3n_1 === false)) {
      tmp1_output.zr(tmp0_desc, 7, value.z3n_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.a3o_1 === true)) {
      tmp1_output.zr(tmp0_desc, 8, value.a3o_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.b3o_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.b3o_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_200).on = function (encoder, value) {
    return this.r3n(encoder, value instanceof SetupCopyExceptionView ? value : THROW_CCE());
  };
  protoOf($serializer_200).pn = function (decoder) {
    var tmp0_desc = this.q3n_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = null;
    var tmp14_input = decoder.tq(tmp0_desc);
    if (tmp14_input.ir()) {
      tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.vq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.hr(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.vq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.uq(tmp0_desc);
    return SetupCopyExceptionView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_200).nn = function () {
    return this.q3n_1;
  };
  protoOf($serializer_200).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_199;
  function $serializer_getInstance_199() {
    if ($serializer_instance_199 == null)
      new $serializer_200();
    return $serializer_instance_199;
  }
  function SetupCopyExceptionView_init_$Init$(seen0, id, kind, targetKind, target, effect, value, expiresAtMs, selected, copyable, reason, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_199().q3n_1);
    }
    $this.s3n_1 = id;
    $this.t3n_1 = kind;
    $this.u3n_1 = targetKind;
    $this.v3n_1 = target;
    $this.w3n_1 = effect;
    if (0 === (seen0 & 32))
      $this.x3n_1 = null;
    else
      $this.x3n_1 = value;
    if (0 === (seen0 & 64))
      $this.y3n_1 = null;
    else
      $this.y3n_1 = expiresAtMs;
    if (0 === (seen0 & 128))
      $this.z3n_1 = false;
    else
      $this.z3n_1 = selected;
    if (0 === (seen0 & 256))
      $this.a3o_1 = true;
    else
      $this.a3o_1 = copyable;
    if (0 === (seen0 & 512))
      $this.b3o_1 = null;
    else
      $this.b3o_1 = reason;
    return $this;
  }
  function SetupCopyExceptionView_init_$Create$(seen0, id, kind, targetKind, target, effect, value, expiresAtMs, selected, copyable, reason, serializationConstructorMarker) {
    return SetupCopyExceptionView_init_$Init$(seen0, id, kind, targetKind, target, effect, value, expiresAtMs, selected, copyable, reason, serializationConstructorMarker, objectCreate(protoOf(SetupCopyExceptionView)));
  }
  function SetupCopyExceptionView() {
  }
  protoOf(SetupCopyExceptionView).toString = function () {
    return 'SetupCopyExceptionView(id=' + this.s3n_1 + ', kind=' + this.t3n_1 + ', targetKind=' + this.u3n_1 + ', target=' + this.v3n_1 + ', effect=' + this.w3n_1 + ', value=' + toString_0(this.x3n_1) + ', expiresAtMs=' + toString_0(this.y3n_1) + ', selected=' + this.z3n_1 + ', copyable=' + this.a3o_1 + ', reason=' + this.b3o_1 + ')';
  };
  protoOf(SetupCopyExceptionView).hashCode = function () {
    var result = getStringHashCode(this.s3n_1);
    result = imul(result, 31) + getStringHashCode(this.t3n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u3n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.v3n_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w3n_1) | 0;
    result = imul(result, 31) + (this.x3n_1 == null ? 0 : this.x3n_1.hashCode()) | 0;
    result = imul(result, 31) + (this.y3n_1 == null ? 0 : this.y3n_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z3n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a3o_1) | 0;
    result = imul(result, 31) + (this.b3o_1 == null ? 0 : getStringHashCode(this.b3o_1)) | 0;
    return result;
  };
  protoOf(SetupCopyExceptionView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyExceptionView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyExceptionView ? other : THROW_CCE();
    if (!(this.s3n_1 === tmp0_other_with_cast.s3n_1))
      return false;
    if (!(this.t3n_1 === tmp0_other_with_cast.t3n_1))
      return false;
    if (!(this.u3n_1 === tmp0_other_with_cast.u3n_1))
      return false;
    if (!(this.v3n_1 === tmp0_other_with_cast.v3n_1))
      return false;
    if (!(this.w3n_1 === tmp0_other_with_cast.w3n_1))
      return false;
    if (!equals(this.x3n_1, tmp0_other_with_cast.x3n_1))
      return false;
    if (!equals(this.y3n_1, tmp0_other_with_cast.y3n_1))
      return false;
    if (!(this.z3n_1 === tmp0_other_with_cast.z3n_1))
      return false;
    if (!(this.a3o_1 === tmp0_other_with_cast.a3o_1))
      return false;
    if (!(this.b3o_1 == tmp0_other_with_cast.b3o_1))
      return false;
    return true;
  };
  function Companion_168() {
    Companion_instance_168 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c3o_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_202())];
  }
  var Companion_instance_168;
  function Companion_getInstance_168() {
    if (Companion_instance_168 == null)
      new Companion_168();
    return Companion_instance_168;
  }
  function $serializer_201() {
    $serializer_instance_200 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyPreviewCategoryView', this, 4);
    tmp0_serialDesc.gy('category', false);
    tmp0_serialDesc.gy('count', false);
    tmp0_serialDesc.gy('eligibility', false);
    tmp0_serialDesc.gy('issues', false);
    this.d3o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_201).e3o = function (encoder, value) {
    var tmp0_desc = this.d3o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_168().c3o_1;
    tmp1_output.hs(tmp0_desc, 0, value.f3o_1);
    tmp1_output.cs(tmp0_desc, 1, value.g3o_1);
    tmp1_output.js(tmp0_desc, 2, $serializer_getInstance_201(), value.h3o_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.i3o_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_201).on = function (encoder, value) {
    return this.e3o(encoder, value instanceof SetupCopyPreviewCategoryView ? value : THROW_CCE());
  };
  protoOf($serializer_201).pn = function (decoder) {
    var tmp0_desc = this.d3o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_168().c3o_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, $serializer_getInstance_201(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, $serializer_getInstance_201(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.fr(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return SetupCopyPreviewCategoryView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_201).nn = function () {
    return this.d3o_1;
  };
  protoOf($serializer_201).vy = function () {
    var tmp0_cached = Companion_getInstance_168().c3o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance(), $serializer_getInstance_201(), tmp0_cached[3]];
  };
  var $serializer_instance_200;
  function $serializer_getInstance_200() {
    if ($serializer_instance_200 == null)
      new $serializer_201();
    return $serializer_instance_200;
  }
  function SetupCopyPreviewCategoryView_init_$Init$(seen0, category, count, eligibility, issues, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_200().d3o_1);
    }
    $this.f3o_1 = category;
    $this.g3o_1 = count;
    $this.h3o_1 = eligibility;
    $this.i3o_1 = issues;
    return $this;
  }
  function SetupCopyPreviewCategoryView_init_$Create$(seen0, category, count, eligibility, issues, serializationConstructorMarker) {
    return SetupCopyPreviewCategoryView_init_$Init$(seen0, category, count, eligibility, issues, serializationConstructorMarker, objectCreate(protoOf(SetupCopyPreviewCategoryView)));
  }
  function SetupCopyPreviewCategoryView() {
  }
  protoOf(SetupCopyPreviewCategoryView).toString = function () {
    return 'SetupCopyPreviewCategoryView(category=' + this.f3o_1 + ', count=' + this.g3o_1 + ', eligibility=' + this.h3o_1.toString() + ', issues=' + toString(this.i3o_1) + ')';
  };
  protoOf(SetupCopyPreviewCategoryView).hashCode = function () {
    var result = getStringHashCode(this.f3o_1);
    result = imul(result, 31) + this.g3o_1 | 0;
    result = imul(result, 31) + this.h3o_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.i3o_1) | 0;
    return result;
  };
  protoOf(SetupCopyPreviewCategoryView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyPreviewCategoryView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyPreviewCategoryView ? other : THROW_CCE();
    if (!(this.f3o_1 === tmp0_other_with_cast.f3o_1))
      return false;
    if (!(this.g3o_1 === tmp0_other_with_cast.g3o_1))
      return false;
    if (!this.h3o_1.equals(tmp0_other_with_cast.h3o_1))
      return false;
    if (!equals(this.i3o_1, tmp0_other_with_cast.i3o_1))
      return false;
    return true;
  };
  function Companion_169() {
    Companion_instance_169 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j3o_1 = [null, new LinkedHashSetSerializer(StringSerializer_getInstance()), new LinkedHashSetSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_169;
  function Companion_getInstance_169() {
    if (Companion_instance_169 == null)
      new Companion_169();
    return Companion_instance_169;
  }
  function $serializer_202() {
    $serializer_instance_201 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyPreviewEligibilityView', this, 4);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('missingFeatures', true);
    tmp0_serialDesc.gy('heldBy', true);
    tmp0_serialDesc.gy('reason', true);
    this.k3o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_202).l3o = function (encoder, value) {
    var tmp0_desc = this.k3o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_169().j3o_1;
    tmp1_output.hs(tmp0_desc, 0, value.m3o_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !equals(value.n3o_1, emptySet())) {
      tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.n3o_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !equals(value.o3o_1, emptySet())) {
      tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.o3o_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.p3o_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.p3o_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_202).on = function (encoder, value) {
    return this.l3o(encoder, value instanceof SetupCopyPreviewEligibilityView ? value : THROW_CCE());
  };
  protoOf($serializer_202).pn = function (decoder) {
    var tmp0_desc = this.k3o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_169().j3o_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, tmp9_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return SetupCopyPreviewEligibilityView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_202).nn = function () {
    return this.k3o_1;
  };
  protoOf($serializer_202).vy = function () {
    var tmp0_cached = Companion_getInstance_169().j3o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], tmp0_cached[2], get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_201;
  function $serializer_getInstance_201() {
    if ($serializer_instance_201 == null)
      new $serializer_202();
    return $serializer_instance_201;
  }
  function SetupCopyPreviewEligibilityView_init_$Init$(seen0, state, missingFeatures, heldBy, reason, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_201().k3o_1);
    }
    $this.m3o_1 = state;
    if (0 === (seen0 & 2))
      $this.n3o_1 = emptySet();
    else
      $this.n3o_1 = missingFeatures;
    if (0 === (seen0 & 4))
      $this.o3o_1 = emptySet();
    else
      $this.o3o_1 = heldBy;
    if (0 === (seen0 & 8))
      $this.p3o_1 = null;
    else
      $this.p3o_1 = reason;
    return $this;
  }
  function SetupCopyPreviewEligibilityView_init_$Create$(seen0, state, missingFeatures, heldBy, reason, serializationConstructorMarker) {
    return SetupCopyPreviewEligibilityView_init_$Init$(seen0, state, missingFeatures, heldBy, reason, serializationConstructorMarker, objectCreate(protoOf(SetupCopyPreviewEligibilityView)));
  }
  function SetupCopyPreviewEligibilityView() {
  }
  protoOf(SetupCopyPreviewEligibilityView).toString = function () {
    return 'SetupCopyPreviewEligibilityView(state=' + this.m3o_1 + ', missingFeatures=' + toString(this.n3o_1) + ', heldBy=' + toString(this.o3o_1) + ', reason=' + this.p3o_1 + ')';
  };
  protoOf(SetupCopyPreviewEligibilityView).hashCode = function () {
    var result = getStringHashCode(this.m3o_1);
    result = imul(result, 31) + hashCode(this.n3o_1) | 0;
    result = imul(result, 31) + hashCode(this.o3o_1) | 0;
    result = imul(result, 31) + (this.p3o_1 == null ? 0 : getStringHashCode(this.p3o_1)) | 0;
    return result;
  };
  protoOf(SetupCopyPreviewEligibilityView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyPreviewEligibilityView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyPreviewEligibilityView ? other : THROW_CCE();
    if (!(this.m3o_1 === tmp0_other_with_cast.m3o_1))
      return false;
    if (!equals(this.n3o_1, tmp0_other_with_cast.n3o_1))
      return false;
    if (!equals(this.o3o_1, tmp0_other_with_cast.o3o_1))
      return false;
    if (!(this.p3o_1 == tmp0_other_with_cast.p3o_1))
      return false;
    return true;
  };
  function $serializer_203() {
    $serializer_instance_202 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyExportIssueView', this, 2);
    tmp0_serialDesc.gy('path', false);
    tmp0_serialDesc.gy('code', false);
    this.q3o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_203).r3o = function (encoder, value) {
    var tmp0_desc = this.q3o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.s3o_1);
    tmp1_output.hs(tmp0_desc, 1, value.t3o_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_203).on = function (encoder, value) {
    return this.r3o(encoder, value instanceof SetupCopyExportIssueView ? value : THROW_CCE());
  };
  protoOf($serializer_203).pn = function (decoder) {
    var tmp0_desc = this.q3o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SetupCopyExportIssueView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_203).nn = function () {
    return this.q3o_1;
  };
  protoOf($serializer_203).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_202;
  function $serializer_getInstance_202() {
    if ($serializer_instance_202 == null)
      new $serializer_203();
    return $serializer_instance_202;
  }
  function SetupCopyExportIssueView_init_$Init$(seen0, path, code, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_202().q3o_1);
    }
    $this.s3o_1 = path;
    $this.t3o_1 = code;
    return $this;
  }
  function SetupCopyExportIssueView_init_$Create$(seen0, path, code, serializationConstructorMarker) {
    return SetupCopyExportIssueView_init_$Init$(seen0, path, code, serializationConstructorMarker, objectCreate(protoOf(SetupCopyExportIssueView)));
  }
  function SetupCopyExportIssueView() {
  }
  protoOf(SetupCopyExportIssueView).toString = function () {
    return 'SetupCopyExportIssueView(path=' + this.s3o_1 + ', code=' + this.t3o_1 + ')';
  };
  protoOf(SetupCopyExportIssueView).hashCode = function () {
    var result = getStringHashCode(this.s3o_1);
    result = imul(result, 31) + getStringHashCode(this.t3o_1) | 0;
    return result;
  };
  protoOf(SetupCopyExportIssueView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyExportIssueView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyExportIssueView ? other : THROW_CCE();
    if (!(this.s3o_1 === tmp0_other_with_cast.s3o_1))
      return false;
    if (!(this.t3o_1 === tmp0_other_with_cast.t3o_1))
      return false;
    return true;
  };
  function Companion_170() {
    Companion_instance_170 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u3o_1 = [null, null, new ArrayListSerializer($serializer_getInstance_204()), null];
  }
  var Companion_instance_170;
  function Companion_getInstance_170() {
    if (Companion_instance_170 == null)
      new Companion_170();
    return Companion_instance_170;
  }
  function $serializer_204() {
    $serializer_instance_203 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyStatusView', this, 4);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('snapshotSha256', false);
    tmp0_serialDesc.gy('categories', false);
    tmp0_serialDesc.gy('observedAtMs', false);
    this.v3o_1 = tmp0_serialDesc;
  }
  protoOf($serializer_204).w3o = function (encoder, value) {
    var tmp0_desc = this.v3o_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_170().u3o_1;
    tmp1_output.hs(tmp0_desc, 0, value.x3o_1);
    tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.y3o_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.z3o_1);
    tmp1_output.ds(tmp0_desc, 3, value.a3p_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_204).on = function (encoder, value) {
    return this.w3o(encoder, value instanceof SetupCopyStatusView ? value : THROW_CCE());
  };
  protoOf($serializer_204).pn = function (decoder) {
    var tmp0_desc = this.v3o_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_input = decoder.tq(tmp0_desc);
    var tmp9_cached = Companion_getInstance_170().u3o_1;
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.fr(tmp0_desc, 2, tmp9_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return SetupCopyStatusView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_204).nn = function () {
    return this.v3o_1;
  };
  protoOf($serializer_204).vy = function () {
    var tmp0_cached = Companion_getInstance_170().u3o_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[2], LongSerializer_getInstance()];
  };
  var $serializer_instance_203;
  function $serializer_getInstance_203() {
    if ($serializer_instance_203 == null)
      new $serializer_204();
    return $serializer_instance_203;
  }
  function SetupCopyStatusView_init_$Init$(seen0, attemptId, snapshotSha256, categories, observedAtMs, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_203().v3o_1);
    }
    $this.x3o_1 = attemptId;
    $this.y3o_1 = snapshotSha256;
    $this.z3o_1 = categories;
    $this.a3p_1 = observedAtMs;
    return $this;
  }
  function SetupCopyStatusView_init_$Create$(seen0, attemptId, snapshotSha256, categories, observedAtMs, serializationConstructorMarker) {
    return SetupCopyStatusView_init_$Init$(seen0, attemptId, snapshotSha256, categories, observedAtMs, serializationConstructorMarker, objectCreate(protoOf(SetupCopyStatusView)));
  }
  function SetupCopyStatusView(attemptId, snapshotSha256, categories, observedAtMs) {
    Companion_getInstance_170();
    this.x3o_1 = attemptId;
    this.y3o_1 = snapshotSha256;
    this.z3o_1 = categories;
    this.a3p_1 = observedAtMs;
  }
  protoOf(SetupCopyStatusView).toString = function () {
    return 'SetupCopyStatusView(attemptId=' + this.x3o_1 + ', snapshotSha256=' + this.y3o_1 + ', categories=' + toString(this.z3o_1) + ', observedAtMs=' + this.a3p_1.toString() + ')';
  };
  protoOf(SetupCopyStatusView).hashCode = function () {
    var result = getStringHashCode(this.x3o_1);
    result = imul(result, 31) + (this.y3o_1 == null ? 0 : getStringHashCode(this.y3o_1)) | 0;
    result = imul(result, 31) + hashCode(this.z3o_1) | 0;
    result = imul(result, 31) + this.a3p_1.hashCode() | 0;
    return result;
  };
  protoOf(SetupCopyStatusView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyStatusView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyStatusView ? other : THROW_CCE();
    if (!(this.x3o_1 === tmp0_other_with_cast.x3o_1))
      return false;
    if (!(this.y3o_1 == tmp0_other_with_cast.y3o_1))
      return false;
    if (!equals(this.z3o_1, tmp0_other_with_cast.z3o_1))
      return false;
    if (!this.a3p_1.equals(tmp0_other_with_cast.a3p_1))
      return false;
    return true;
  };
  function SetupCopyStatusRules() {
    SetupCopyStatusRules_instance = this;
    this.b3p_1 = setOf(['APPLIED', 'HELD', 'SKIPPED', 'FAILED', 'PENDING']);
  }
  protoOf(SetupCopyStatusRules).c3p = function (attemptId) {
    return '/api/console/setup-attempts/' + attemptId + '/copy';
  };
  var SetupCopyStatusRules_instance;
  function SetupCopyStatusRules_getInstance() {
    if (SetupCopyStatusRules_instance == null)
      new SetupCopyStatusRules();
    return SetupCopyStatusRules_instance;
  }
  function Companion_171() {
    Companion_instance_171 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d3p_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer($serializer_getInstance_205()), null];
  }
  var Companion_instance_171;
  function Companion_getInstance_171() {
    if (Companion_instance_171 == null)
      new Companion_171();
    return Companion_instance_171;
  }
  function $serializer_205() {
    $serializer_instance_204 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyCategoryStatusView', this, 7);
    tmp0_serialDesc.gy('category', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('reasonCode', true);
    tmp0_serialDesc.gy('heldBy', true);
    tmp0_serialDesc.gy('missingFeatures', true);
    tmp0_serialDesc.gy('items', true);
    tmp0_serialDesc.gy('itemCount', true);
    this.e3p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_205).f3p = function (encoder, value) {
    var tmp0_desc = this.e3p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_171().d3p_1;
    tmp1_output.hs(tmp0_desc, 0, value.g3p_1);
    tmp1_output.hs(tmp0_desc, 1, value.h3p_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.i3p_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.i3p_1);
    }
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !equals(value.j3p_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.j3p_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !equals(value.k3p_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.k3p_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !equals(value.l3p_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.l3p_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.m3p_1 === 0)) {
      tmp1_output.cs(tmp0_desc, 6, value.m3p_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_205).on = function (encoder, value) {
    return this.f3p(encoder, value instanceof SetupCopyCategoryStatusView ? value : THROW_CCE());
  };
  protoOf($serializer_205).pn = function (decoder) {
    var tmp0_desc = this.e3p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = 0;
    var tmp11_input = decoder.tq(tmp0_desc);
    var tmp12_cached = Companion_getInstance_171().d3p_1;
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.fr(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.fr(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.fr(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.yq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.fr(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.fr(tmp0_desc, 4, tmp12_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.fr(tmp0_desc, 5, tmp12_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.yq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return SetupCopyCategoryStatusView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_205).nn = function () {
    return this.e3p_1;
  };
  protoOf($serializer_205).vy = function () {
    var tmp0_cached = Companion_getInstance_171().d3p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), tmp0_cached[3], tmp0_cached[4], tmp0_cached[5], IntSerializer_getInstance()];
  };
  var $serializer_instance_204;
  function $serializer_getInstance_204() {
    if ($serializer_instance_204 == null)
      new $serializer_205();
    return $serializer_instance_204;
  }
  function SetupCopyCategoryStatusView_init_$Init$(seen0, category, state, reasonCode, heldBy, missingFeatures, items, itemCount, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_204().e3p_1);
    }
    $this.g3p_1 = category;
    $this.h3p_1 = state;
    if (0 === (seen0 & 4))
      $this.i3p_1 = null;
    else
      $this.i3p_1 = reasonCode;
    if (0 === (seen0 & 8))
      $this.j3p_1 = emptyList();
    else
      $this.j3p_1 = heldBy;
    if (0 === (seen0 & 16))
      $this.k3p_1 = emptyList();
    else
      $this.k3p_1 = missingFeatures;
    if (0 === (seen0 & 32))
      $this.l3p_1 = emptyList();
    else
      $this.l3p_1 = items;
    if (0 === (seen0 & 64))
      $this.m3p_1 = 0;
    else
      $this.m3p_1 = itemCount;
    return $this;
  }
  function SetupCopyCategoryStatusView_init_$Create$(seen0, category, state, reasonCode, heldBy, missingFeatures, items, itemCount, serializationConstructorMarker) {
    return SetupCopyCategoryStatusView_init_$Init$(seen0, category, state, reasonCode, heldBy, missingFeatures, items, itemCount, serializationConstructorMarker, objectCreate(protoOf(SetupCopyCategoryStatusView)));
  }
  function SetupCopyCategoryStatusView() {
  }
  protoOf(SetupCopyCategoryStatusView).toString = function () {
    return 'SetupCopyCategoryStatusView(category=' + this.g3p_1 + ', state=' + this.h3p_1 + ', reasonCode=' + this.i3p_1 + ', heldBy=' + toString(this.j3p_1) + ', missingFeatures=' + toString(this.k3p_1) + ', items=' + toString(this.l3p_1) + ', itemCount=' + this.m3p_1 + ')';
  };
  protoOf(SetupCopyCategoryStatusView).hashCode = function () {
    var result = getStringHashCode(this.g3p_1);
    result = imul(result, 31) + getStringHashCode(this.h3p_1) | 0;
    result = imul(result, 31) + (this.i3p_1 == null ? 0 : getStringHashCode(this.i3p_1)) | 0;
    result = imul(result, 31) + hashCode(this.j3p_1) | 0;
    result = imul(result, 31) + hashCode(this.k3p_1) | 0;
    result = imul(result, 31) + hashCode(this.l3p_1) | 0;
    result = imul(result, 31) + this.m3p_1 | 0;
    return result;
  };
  protoOf(SetupCopyCategoryStatusView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyCategoryStatusView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyCategoryStatusView ? other : THROW_CCE();
    if (!(this.g3p_1 === tmp0_other_with_cast.g3p_1))
      return false;
    if (!(this.h3p_1 === tmp0_other_with_cast.h3p_1))
      return false;
    if (!(this.i3p_1 == tmp0_other_with_cast.i3p_1))
      return false;
    if (!equals(this.j3p_1, tmp0_other_with_cast.j3p_1))
      return false;
    if (!equals(this.k3p_1, tmp0_other_with_cast.k3p_1))
      return false;
    if (!equals(this.l3p_1, tmp0_other_with_cast.l3p_1))
      return false;
    if (!(this.m3p_1 === tmp0_other_with_cast.m3p_1))
      return false;
    return true;
  };
  function $serializer_206() {
    $serializer_instance_205 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupCopyItemNoteView', this, 2);
    tmp0_serialDesc.gy('path', false);
    tmp0_serialDesc.gy('code', false);
    this.n3p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_206).o3p = function (encoder, value) {
    var tmp0_desc = this.n3p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.p3p_1);
    tmp1_output.hs(tmp0_desc, 1, value.q3p_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_206).on = function (encoder, value) {
    return this.o3p(encoder, value instanceof SetupCopyItemNoteView ? value : THROW_CCE());
  };
  protoOf($serializer_206).pn = function (decoder) {
    var tmp0_desc = this.n3p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SetupCopyItemNoteView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_206).nn = function () {
    return this.n3p_1;
  };
  protoOf($serializer_206).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_205;
  function $serializer_getInstance_205() {
    if ($serializer_instance_205 == null)
      new $serializer_206();
    return $serializer_instance_205;
  }
  function SetupCopyItemNoteView_init_$Init$(seen0, path, code, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_205().n3p_1);
    }
    $this.p3p_1 = path;
    $this.q3p_1 = code;
    return $this;
  }
  function SetupCopyItemNoteView_init_$Create$(seen0, path, code, serializationConstructorMarker) {
    return SetupCopyItemNoteView_init_$Init$(seen0, path, code, serializationConstructorMarker, objectCreate(protoOf(SetupCopyItemNoteView)));
  }
  function SetupCopyItemNoteView() {
  }
  protoOf(SetupCopyItemNoteView).toString = function () {
    return 'SetupCopyItemNoteView(path=' + this.p3p_1 + ', code=' + this.q3p_1 + ')';
  };
  protoOf(SetupCopyItemNoteView).hashCode = function () {
    var result = getStringHashCode(this.p3p_1);
    result = imul(result, 31) + getStringHashCode(this.q3p_1) | 0;
    return result;
  };
  protoOf(SetupCopyItemNoteView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupCopyItemNoteView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupCopyItemNoteView ? other : THROW_CCE();
    if (!(this.p3p_1 === tmp0_other_with_cast.p3p_1))
      return false;
    if (!(this.q3p_1 === tmp0_other_with_cast.q3p_1))
      return false;
    return true;
  };
  function Companion_172() {
    Companion_instance_172 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r3p_1 = [null, null, null, new ArrayListSerializer($serializer_getInstance_35()), null, null];
  }
  var Companion_instance_172;
  function Companion_getInstance_172() {
    if (Companion_instance_172 == null)
      new Companion_172();
    return Companion_instance_172;
  }
  function $serializer_207() {
    $serializer_instance_206 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupDraftReviewView', this, 6);
    tmp0_serialDesc.gy('draft', false);
    tmp0_serialDesc.gy('plan', false);
    tmp0_serialDesc.gy('registry', false);
    tmp0_serialDesc.gy('fieldErrors', false);
    tmp0_serialDesc.gy('requiresCopyReview', false);
    tmp0_serialDesc.gy('reviewReceipt', true);
    this.s3p_1 = tmp0_serialDesc;
  }
  protoOf($serializer_207).t3p = function (encoder, value) {
    var tmp0_desc = this.s3p_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_172().r3p_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_135(), value.u3p_1);
    tmp1_output.ls(tmp0_desc, 1, $serializer_getInstance_36(), value.v3p_1);
    tmp1_output.js(tmp0_desc, 2, $serializer_getInstance_39(), value.w3p_1);
    tmp1_output.js(tmp0_desc, 3, tmp2_cached[3], value.x3p_1);
    tmp1_output.zr(tmp0_desc, 4, value.y3p_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.z3p_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.z3p_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_207).on = function (encoder, value) {
    return this.t3p(encoder, value instanceof SetupDraftReviewView ? value : THROW_CCE());
  };
  protoOf($serializer_207).pn = function (decoder) {
    var tmp0_desc = this.s3p_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    var tmp11_cached = Companion_getInstance_172().r3p_1;
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.fr(tmp0_desc, 0, $serializer_getInstance_135(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.fr(tmp0_desc, 2, $serializer_getInstance_39(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.fr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.fr(tmp0_desc, 0, $serializer_getInstance_135(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.fr(tmp0_desc, 2, $serializer_getInstance_39(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.fr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return SetupDraftReviewView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_207).nn = function () {
    return this.s3p_1;
  };
  protoOf($serializer_207).vy = function () {
    var tmp0_cached = Companion_getInstance_172().r3p_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_135(), get_nullable($serializer_getInstance_36()), $serializer_getInstance_39(), tmp0_cached[3], BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_206;
  function $serializer_getInstance_206() {
    if ($serializer_instance_206 == null)
      new $serializer_207();
    return $serializer_instance_206;
  }
  function SetupDraftReviewView_init_$Init$(seen0, draft, plan, registry, fieldErrors, requiresCopyReview, reviewReceipt, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_206().s3p_1);
    }
    $this.u3p_1 = draft;
    $this.v3p_1 = plan;
    $this.w3p_1 = registry;
    $this.x3p_1 = fieldErrors;
    $this.y3p_1 = requiresCopyReview;
    if (0 === (seen0 & 32))
      $this.z3p_1 = null;
    else
      $this.z3p_1 = reviewReceipt;
    return $this;
  }
  function SetupDraftReviewView_init_$Create$(seen0, draft, plan, registry, fieldErrors, requiresCopyReview, reviewReceipt, serializationConstructorMarker) {
    return SetupDraftReviewView_init_$Init$(seen0, draft, plan, registry, fieldErrors, requiresCopyReview, reviewReceipt, serializationConstructorMarker, objectCreate(protoOf(SetupDraftReviewView)));
  }
  function SetupDraftReviewView(draft, plan, registry, fieldErrors, requiresCopyReview, reviewReceipt) {
    Companion_getInstance_172();
    reviewReceipt = reviewReceipt === VOID ? null : reviewReceipt;
    this.u3p_1 = draft;
    this.v3p_1 = plan;
    this.w3p_1 = registry;
    this.x3p_1 = fieldErrors;
    this.y3p_1 = requiresCopyReview;
    this.z3p_1 = reviewReceipt;
  }
  protoOf(SetupDraftReviewView).toString = function () {
    return 'SetupDraftReviewView(draft=' + this.u3p_1.toString() + ', plan=' + toString_0(this.v3p_1) + ', registry=' + this.w3p_1.toString() + ', fieldErrors=' + toString(this.x3p_1) + ', requiresCopyReview=' + this.y3p_1 + ', reviewReceipt=' + this.z3p_1 + ')';
  };
  protoOf(SetupDraftReviewView).hashCode = function () {
    var result = this.u3p_1.hashCode();
    result = imul(result, 31) + (this.v3p_1 == null ? 0 : this.v3p_1.hashCode()) | 0;
    result = imul(result, 31) + this.w3p_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.x3p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y3p_1) | 0;
    result = imul(result, 31) + (this.z3p_1 == null ? 0 : getStringHashCode(this.z3p_1)) | 0;
    return result;
  };
  protoOf(SetupDraftReviewView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupDraftReviewView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupDraftReviewView ? other : THROW_CCE();
    if (!this.u3p_1.equals(tmp0_other_with_cast.u3p_1))
      return false;
    if (!equals(this.v3p_1, tmp0_other_with_cast.v3p_1))
      return false;
    if (!this.w3p_1.equals(tmp0_other_with_cast.w3p_1))
      return false;
    if (!equals(this.x3p_1, tmp0_other_with_cast.x3p_1))
      return false;
    if (!(this.y3p_1 === tmp0_other_with_cast.y3p_1))
      return false;
    if (!(this.z3p_1 == tmp0_other_with_cast.z3p_1))
      return false;
    return true;
  };
  function SetupPlanRules() {
  }
  protoOf(SetupPlanRules).a3q = function (plan) {
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single = null;
      var found = false;
      var tmp0_iterator = plan.d1w_1.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'com.ems.console.api.SetupPlanRules.permitsFreshOwner.<anonymous>' call
        if (element.k2i_1 === 'seats.admin') {
          if (found) {
            tmp$ret$1 = null;
            break $l$block_0;
          }
          single = element;
          found = true;
        }
      }
      if (!found) {
        tmp$ret$1 = null;
        break $l$block_0;
      }
      tmp$ret$1 = single;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var seats = tmp;
    var tmp_0;
    if (seats.m2i_1) {
      tmp_0 = seats.l2i_1 == null;
    } else {
      var tmp1_safe_receiver = seats.l2i_1;
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ems.console.api.SetupPlanRules.permitsFreshOwner.<anonymous>' call
        tmp_1 = tmp1_safe_receiver.e1(new Long(1, 0)) >= 0;
      }
      tmp_0 = tmp_1 === true;
    }
    return tmp_0;
  };
  protoOf(SetupPlanRules).b3q = function (plan, registry) {
    var tmp;
    var tmp_0;
    var tmp$ret$0;
    $l$block_2: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = plan.c1w_1;
      var tmp_1;
      if (isInterface(this_0, Collection)) {
        tmp_1 = this_0.k();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = true;
        break $l$block_2;
      }
      var tmp0_iterator = this_0.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>' call
        var tmp$ret$2;
        $l$block_1: {
          // Inline function 'kotlin.collections.singleOrNull' call
          var single = null;
          var found = false;
          var tmp0_iterator_0 = registry.d20_1.g();
          while (tmp0_iterator_0.h()) {
            var element_0 = tmp0_iterator_0.i();
            // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>.<anonymous>' call
            if (element_0.z2l_1 === element) {
              if (found) {
                tmp$ret$2 = null;
                break $l$block_1;
              }
              single = element_0;
              found = true;
            }
          }
          if (!found) {
            tmp$ret$2 = null;
            break $l$block_1;
          }
          tmp$ret$2 = single;
        }
        if (!!(tmp$ret$2 == null)) {
          tmp$ret$0 = false;
          break $l$block_2;
        }
      }
      tmp$ret$0 = true;
    }
    if (tmp$ret$0) {
      var tmp$ret$4;
      $l$block_6: {
        // Inline function 'kotlin.collections.all' call
        var this_1 = plan.g1w_1;
        var tmp_2;
        if (isInterface(this_1, Collection)) {
          tmp_2 = this_1.k();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$4 = true;
          break $l$block_6;
        }
        var tmp0_iterator_1 = this_1.g();
        while (tmp0_iterator_1.h()) {
          var element_1 = tmp0_iterator_1.i();
          // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>' call
          var tmp$ret$6;
          $l$block_5: {
            // Inline function 'kotlin.collections.singleOrNull' call
            var single_0 = null;
            var found_0 = false;
            var tmp0_iterator_2 = registry.h20_1.g();
            while (tmp0_iterator_2.h()) {
              var element_2 = tmp0_iterator_2.i();
              // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>.<anonymous>' call
              if (element_2.g2l_1 === element_1) {
                if (found_0) {
                  tmp$ret$6 = null;
                  break $l$block_5;
                }
                single_0 = element_2;
                found_0 = true;
              }
            }
            if (!found_0) {
              tmp$ret$6 = null;
              break $l$block_5;
            }
            tmp$ret$6 = single_0;
          }
          var tmp0_safe_receiver = tmp$ret$6;
          var tmp_3;
          if (tmp0_safe_receiver == null) {
            tmp_3 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>.<anonymous>' call
            tmp_3 = (tmp0_safe_receiver.s2l_1 && tmp0_safe_receiver.r2l_1 === 'AVAILABLE');
          }
          if (!(tmp_3 === true)) {
            tmp$ret$4 = false;
            break $l$block_6;
          }
        }
        tmp$ret$4 = true;
      }
      tmp_0 = tmp$ret$4;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$10;
      $l$block_10: {
        // Inline function 'kotlin.collections.all' call
        var this_2 = plan.d1w_1;
        var tmp_4;
        if (isInterface(this_2, Collection)) {
          tmp_4 = this_2.k();
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp$ret$10 = true;
          break $l$block_10;
        }
        var tmp0_iterator_3 = this_2.g();
        while (tmp0_iterator_3.h()) {
          var element_3 = tmp0_iterator_3.i();
          // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>' call
          var tmp$ret$12;
          $l$block_9: {
            // Inline function 'kotlin.collections.singleOrNull' call
            var single_1 = null;
            var found_1 = false;
            var tmp0_iterator_4 = registry.e20_1.g();
            while (tmp0_iterator_4.h()) {
              var element_4 = tmp0_iterator_4.i();
              // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>.<anonymous>' call
              if (element_4.j2h_1 === element_3.k2i_1) {
                if (found_1) {
                  tmp$ret$12 = null;
                  break $l$block_9;
                }
                single_1 = element_4;
                found_1 = true;
              }
            }
            if (!found_1) {
              tmp$ret$12 = null;
              break $l$block_9;
            }
            tmp$ret$12 = single_1;
          }
          var tmp0_safe_receiver_0 = tmp$ret$12;
          var tmp_5;
          if (tmp0_safe_receiver_0 == null) {
            tmp_5 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>.<anonymous>' call
            var tmp_6;
            var tmp_7;
            var tmp_8 = setOf(['ABSOLUTE', 'MONTHLY', 'DAILY', 'PER_EVENT']);
            // Inline function 'kotlin.text.uppercase' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$14 = tmp0_safe_receiver_0.n2h_1.toUpperCase();
            if (tmp_8.r(tmp$ret$14)) {
              var tmp0_safe_receiver_1 = element_3.l2i_1;
              var tmp_9;
              if (tmp0_safe_receiver_1 == null) {
                tmp_9 = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'kotlin.contracts.contract' call
                // Inline function 'com.ems.console.api.SetupPlanRules.catalogComplete.<anonymous>.<anonymous>.<anonymous>' call
                tmp_9 = tmp0_safe_receiver_1.e1(new Long(0, 0)) >= 0;
              }
              tmp_7 = !(tmp_9 === false);
            } else {
              tmp_7 = false;
            }
            if (tmp_7) {
              tmp_6 = element_3.o2i_1 == null || setOf(['STOP', 'OVERAGE', 'NOTIFY']).r(element_3.o2i_1);
            } else {
              tmp_6 = false;
            }
            tmp_5 = tmp_6;
          }
          if (!(tmp_5 === true)) {
            tmp$ret$10 = false;
            break $l$block_10;
          }
        }
        tmp$ret$10 = true;
      }
      tmp = tmp$ret$10;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(SetupPlanRules).c3q = function (plan, registry) {
    return plan.i1w_1 === 'AVAILABLE' && plan.y1v_1 && this.b3q(plan, registry);
  };
  var SetupPlanRules_instance;
  function SetupPlanRules_getInstance() {
    return SetupPlanRules_instance;
  }
  function Companion_173() {
  }
  var Companion_instance_173;
  function Companion_getInstance_173() {
    return Companion_instance_173;
  }
  function $serializer_208() {
    $serializer_instance_207 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpActivationReceipt', this, 11);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('accountId', false);
    tmp0_serialDesc.gy('proofId', false);
    tmp0_serialDesc.gy('activationRequestId', false);
    tmp0_serialDesc.gy('targetConfigVersion', false);
    tmp0_serialDesc.gy('targetAssignmentGeneration', false);
    tmp0_serialDesc.gy('targetAssignmentRevision', false);
    tmp0_serialDesc.gy('entitlementVersion', false);
    tmp0_serialDesc.gy('status', true);
    tmp0_serialDesc.gy('activationStatus', true);
    this.d3q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_208).e3q = function (encoder, value) {
    var tmp0_desc = this.d3q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.f3q_1);
    tmp1_output.hs(tmp0_desc, 1, value.g3q_1);
    tmp1_output.hs(tmp0_desc, 2, value.h3q_1);
    tmp1_output.hs(tmp0_desc, 3, value.i3q_1);
    tmp1_output.hs(tmp0_desc, 4, value.j3q_1);
    tmp1_output.ds(tmp0_desc, 5, value.k3q_1);
    tmp1_output.hs(tmp0_desc, 6, value.l3q_1);
    tmp1_output.ds(tmp0_desc, 7, value.m3q_1);
    tmp1_output.ds(tmp0_desc, 8, value.n3q_1);
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.o3q_1 === 'WAITING_RUNTIME')) {
      tmp1_output.hs(tmp0_desc, 9, value.o3q_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.p3q_1 === 'REQUESTED')) {
      tmp1_output.hs(tmp0_desc, 10, value.p3q_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_208).on = function (encoder, value) {
    return this.e3q(encoder, value instanceof SetupSmtpActivationReceipt ? value : THROW_CCE());
  };
  protoOf($serializer_208).pn = function (decoder) {
    var tmp0_desc = this.d3q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = null;
    var tmp11_local7 = new Long(0, 0);
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.tq(tmp0_desc);
    if (tmp15_input.ir()) {
      tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.dr(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.dr(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.dr(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.dr(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.uq(tmp0_desc);
    return SetupSmtpActivationReceipt_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_208).nn = function () {
    return this.d3q_1;
  };
  protoOf($serializer_208).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_207;
  function $serializer_getInstance_207() {
    if ($serializer_instance_207 == null)
      new $serializer_208();
    return $serializer_instance_207;
  }
  function SetupSmtpActivationReceipt_init_$Init$(seen0, attemptId, tenantId, accountId, proofId, activationRequestId, targetConfigVersion, targetAssignmentGeneration, targetAssignmentRevision, entitlementVersion, status, activationStatus, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_207().d3q_1);
    }
    $this.f3q_1 = attemptId;
    $this.g3q_1 = tenantId;
    $this.h3q_1 = accountId;
    $this.i3q_1 = proofId;
    $this.j3q_1 = activationRequestId;
    $this.k3q_1 = targetConfigVersion;
    $this.l3q_1 = targetAssignmentGeneration;
    $this.m3q_1 = targetAssignmentRevision;
    $this.n3q_1 = entitlementVersion;
    if (0 === (seen0 & 512))
      $this.o3q_1 = 'WAITING_RUNTIME';
    else
      $this.o3q_1 = status;
    if (0 === (seen0 & 1024))
      $this.p3q_1 = 'REQUESTED';
    else
      $this.p3q_1 = activationStatus;
    return $this;
  }
  function SetupSmtpActivationReceipt_init_$Create$(seen0, attemptId, tenantId, accountId, proofId, activationRequestId, targetConfigVersion, targetAssignmentGeneration, targetAssignmentRevision, entitlementVersion, status, activationStatus, serializationConstructorMarker) {
    return SetupSmtpActivationReceipt_init_$Init$(seen0, attemptId, tenantId, accountId, proofId, activationRequestId, targetConfigVersion, targetAssignmentGeneration, targetAssignmentRevision, entitlementVersion, status, activationStatus, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpActivationReceipt)));
  }
  function SetupSmtpActivationReceipt(attemptId, tenantId, accountId, proofId, activationRequestId, targetConfigVersion, targetAssignmentGeneration, targetAssignmentRevision, entitlementVersion, status, activationStatus) {
    status = status === VOID ? 'WAITING_RUNTIME' : status;
    activationStatus = activationStatus === VOID ? 'REQUESTED' : activationStatus;
    this.f3q_1 = attemptId;
    this.g3q_1 = tenantId;
    this.h3q_1 = accountId;
    this.i3q_1 = proofId;
    this.j3q_1 = activationRequestId;
    this.k3q_1 = targetConfigVersion;
    this.l3q_1 = targetAssignmentGeneration;
    this.m3q_1 = targetAssignmentRevision;
    this.n3q_1 = entitlementVersion;
    this.o3q_1 = status;
    this.p3q_1 = activationStatus;
  }
  protoOf(SetupSmtpActivationReceipt).toString = function () {
    return 'SetupSmtpActivationReceipt(attemptId=' + this.f3q_1 + ', tenantId=' + this.g3q_1 + ', accountId=' + this.h3q_1 + ', proofId=' + this.i3q_1 + ', activationRequestId=' + this.j3q_1 + ', targetConfigVersion=' + this.k3q_1.toString() + ', targetAssignmentGeneration=' + this.l3q_1 + ', targetAssignmentRevision=' + this.m3q_1.toString() + ', entitlementVersion=' + this.n3q_1.toString() + ', status=' + this.o3q_1 + ', activationStatus=' + this.p3q_1 + ')';
  };
  protoOf(SetupSmtpActivationReceipt).hashCode = function () {
    var result = getStringHashCode(this.f3q_1);
    result = imul(result, 31) + getStringHashCode(this.g3q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h3q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i3q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j3q_1) | 0;
    result = imul(result, 31) + this.k3q_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.l3q_1) | 0;
    result = imul(result, 31) + this.m3q_1.hashCode() | 0;
    result = imul(result, 31) + this.n3q_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.o3q_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p3q_1) | 0;
    return result;
  };
  protoOf(SetupSmtpActivationReceipt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpActivationReceipt))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpActivationReceipt ? other : THROW_CCE();
    if (!(this.f3q_1 === tmp0_other_with_cast.f3q_1))
      return false;
    if (!(this.g3q_1 === tmp0_other_with_cast.g3q_1))
      return false;
    if (!(this.h3q_1 === tmp0_other_with_cast.h3q_1))
      return false;
    if (!(this.i3q_1 === tmp0_other_with_cast.i3q_1))
      return false;
    if (!(this.j3q_1 === tmp0_other_with_cast.j3q_1))
      return false;
    if (!this.k3q_1.equals(tmp0_other_with_cast.k3q_1))
      return false;
    if (!(this.l3q_1 === tmp0_other_with_cast.l3q_1))
      return false;
    if (!this.m3q_1.equals(tmp0_other_with_cast.m3q_1))
      return false;
    if (!this.n3q_1.equals(tmp0_other_with_cast.n3q_1))
      return false;
    if (!(this.o3q_1 === tmp0_other_with_cast.o3q_1))
      return false;
    if (!(this.p3q_1 === tmp0_other_with_cast.p3q_1))
      return false;
    return true;
  };
  function Companion_174() {
  }
  var Companion_instance_174;
  function Companion_getInstance_174() {
    return Companion_instance_174;
  }
  function $serializer_209() {
    $serializer_instance_208 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpActivationRequest', this, 6);
    tmp0_serialDesc.gy('accountId', false);
    tmp0_serialDesc.gy('proofId', false);
    tmp0_serialDesc.gy('expectedEntitlementVersion', false);
    tmp0_serialDesc.gy('expectedConfigVersion', false);
    tmp0_serialDesc.gy('expectedAssignmentGeneration', false);
    tmp0_serialDesc.gy('expectedAssignmentRevision', false);
    this.q3q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_209).r3q = function (encoder, value) {
    var tmp0_desc = this.q3q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.s3q_1);
    tmp1_output.hs(tmp0_desc, 1, value.t3q_1);
    tmp1_output.ds(tmp0_desc, 2, value.u3q_1);
    tmp1_output.ds(tmp0_desc, 3, value.v3q_1);
    tmp1_output.hs(tmp0_desc, 4, value.w3q_1);
    tmp1_output.ds(tmp0_desc, 5, value.x3q_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_209).on = function (encoder, value) {
    return this.r3q(encoder, value instanceof SetupSmtpActivationRequest ? value : THROW_CCE());
  };
  protoOf($serializer_209).pn = function (decoder) {
    var tmp0_desc = this.q3q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return SetupSmtpActivationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_209).nn = function () {
    return this.q3q_1;
  };
  protoOf($serializer_209).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_208;
  function $serializer_getInstance_208() {
    if ($serializer_instance_208 == null)
      new $serializer_209();
    return $serializer_instance_208;
  }
  function SetupSmtpActivationRequest_init_$Init$(seen0, accountId, proofId, expectedEntitlementVersion, expectedConfigVersion, expectedAssignmentGeneration, expectedAssignmentRevision, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen0))) {
      throwMissingFieldException(seen0, 63, $serializer_getInstance_208().q3q_1);
    }
    $this.s3q_1 = accountId;
    $this.t3q_1 = proofId;
    $this.u3q_1 = expectedEntitlementVersion;
    $this.v3q_1 = expectedConfigVersion;
    $this.w3q_1 = expectedAssignmentGeneration;
    $this.x3q_1 = expectedAssignmentRevision;
    return $this;
  }
  function SetupSmtpActivationRequest_init_$Create$(seen0, accountId, proofId, expectedEntitlementVersion, expectedConfigVersion, expectedAssignmentGeneration, expectedAssignmentRevision, serializationConstructorMarker) {
    return SetupSmtpActivationRequest_init_$Init$(seen0, accountId, proofId, expectedEntitlementVersion, expectedConfigVersion, expectedAssignmentGeneration, expectedAssignmentRevision, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpActivationRequest)));
  }
  function SetupSmtpActivationRequest(accountId, proofId, expectedEntitlementVersion, expectedConfigVersion, expectedAssignmentGeneration, expectedAssignmentRevision) {
    this.s3q_1 = accountId;
    this.t3q_1 = proofId;
    this.u3q_1 = expectedEntitlementVersion;
    this.v3q_1 = expectedConfigVersion;
    this.w3q_1 = expectedAssignmentGeneration;
    this.x3q_1 = expectedAssignmentRevision;
  }
  protoOf(SetupSmtpActivationRequest).toString = function () {
    return 'SetupSmtpActivationRequest(accountId=' + this.s3q_1 + ', proofId=' + this.t3q_1 + ', expectedEntitlementVersion=' + this.u3q_1.toString() + ', expectedConfigVersion=' + this.v3q_1.toString() + ', expectedAssignmentGeneration=' + this.w3q_1 + ', expectedAssignmentRevision=' + this.x3q_1.toString() + ')';
  };
  protoOf(SetupSmtpActivationRequest).hashCode = function () {
    var result = getStringHashCode(this.s3q_1);
    result = imul(result, 31) + getStringHashCode(this.t3q_1) | 0;
    result = imul(result, 31) + this.u3q_1.hashCode() | 0;
    result = imul(result, 31) + this.v3q_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.w3q_1) | 0;
    result = imul(result, 31) + this.x3q_1.hashCode() | 0;
    return result;
  };
  protoOf(SetupSmtpActivationRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpActivationRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpActivationRequest ? other : THROW_CCE();
    if (!(this.s3q_1 === tmp0_other_with_cast.s3q_1))
      return false;
    if (!(this.t3q_1 === tmp0_other_with_cast.t3q_1))
      return false;
    if (!this.u3q_1.equals(tmp0_other_with_cast.u3q_1))
      return false;
    if (!this.v3q_1.equals(tmp0_other_with_cast.v3q_1))
      return false;
    if (!(this.w3q_1 === tmp0_other_with_cast.w3q_1))
      return false;
    if (!this.x3q_1.equals(tmp0_other_with_cast.x3q_1))
      return false;
    return true;
  };
  function Companion_175() {
  }
  var Companion_instance_175;
  function Companion_getInstance_175() {
    return Companion_instance_175;
  }
  function $serializer_210() {
    $serializer_instance_209 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpConfigurationReceipt', this, 6);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('accountId', false);
    tmp0_serialDesc.gy('configVersion', false);
    tmp0_serialDesc.gy('entitlementVersion', false);
    tmp0_serialDesc.gy('configurationStatus', true);
    this.y3q_1 = tmp0_serialDesc;
  }
  protoOf($serializer_210).z3q = function (encoder, value) {
    var tmp0_desc = this.y3q_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.a3r_1);
    tmp1_output.hs(tmp0_desc, 1, value.b3r_1);
    tmp1_output.hs(tmp0_desc, 2, value.c3r_1);
    tmp1_output.ds(tmp0_desc, 3, value.d3r_1);
    tmp1_output.ds(tmp0_desc, 4, value.e3r_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.f3r_1 === 'SAVED_DISABLED')) {
      tmp1_output.hs(tmp0_desc, 5, value.f3r_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_210).on = function (encoder, value) {
    return this.z3q(encoder, value instanceof SetupSmtpConfigurationReceipt ? value : THROW_CCE());
  };
  protoOf($serializer_210).pn = function (decoder) {
    var tmp0_desc = this.y3q_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return SetupSmtpConfigurationReceipt_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_210).nn = function () {
    return this.y3q_1;
  };
  protoOf($serializer_210).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_209;
  function $serializer_getInstance_209() {
    if ($serializer_instance_209 == null)
      new $serializer_210();
    return $serializer_instance_209;
  }
  function SetupSmtpConfigurationReceipt_init_$Init$(seen0, attemptId, tenantId, accountId, configVersion, entitlementVersion, configurationStatus, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_209().y3q_1);
    }
    $this.a3r_1 = attemptId;
    $this.b3r_1 = tenantId;
    $this.c3r_1 = accountId;
    $this.d3r_1 = configVersion;
    $this.e3r_1 = entitlementVersion;
    if (0 === (seen0 & 32))
      $this.f3r_1 = 'SAVED_DISABLED';
    else
      $this.f3r_1 = configurationStatus;
    return $this;
  }
  function SetupSmtpConfigurationReceipt_init_$Create$(seen0, attemptId, tenantId, accountId, configVersion, entitlementVersion, configurationStatus, serializationConstructorMarker) {
    return SetupSmtpConfigurationReceipt_init_$Init$(seen0, attemptId, tenantId, accountId, configVersion, entitlementVersion, configurationStatus, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpConfigurationReceipt)));
  }
  function SetupSmtpConfigurationReceipt(attemptId, tenantId, accountId, configVersion, entitlementVersion, configurationStatus) {
    configurationStatus = configurationStatus === VOID ? 'SAVED_DISABLED' : configurationStatus;
    this.a3r_1 = attemptId;
    this.b3r_1 = tenantId;
    this.c3r_1 = accountId;
    this.d3r_1 = configVersion;
    this.e3r_1 = entitlementVersion;
    this.f3r_1 = configurationStatus;
  }
  protoOf(SetupSmtpConfigurationReceipt).toString = function () {
    return 'SetupSmtpConfigurationReceipt(attemptId=' + this.a3r_1 + ', tenantId=' + this.b3r_1 + ', accountId=' + this.c3r_1 + ', configVersion=' + this.d3r_1.toString() + ', entitlementVersion=' + this.e3r_1.toString() + ', configurationStatus=' + this.f3r_1 + ')';
  };
  protoOf(SetupSmtpConfigurationReceipt).hashCode = function () {
    var result = getStringHashCode(this.a3r_1);
    result = imul(result, 31) + getStringHashCode(this.b3r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c3r_1) | 0;
    result = imul(result, 31) + this.d3r_1.hashCode() | 0;
    result = imul(result, 31) + this.e3r_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.f3r_1) | 0;
    return result;
  };
  protoOf(SetupSmtpConfigurationReceipt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpConfigurationReceipt))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpConfigurationReceipt ? other : THROW_CCE();
    if (!(this.a3r_1 === tmp0_other_with_cast.a3r_1))
      return false;
    if (!(this.b3r_1 === tmp0_other_with_cast.b3r_1))
      return false;
    if (!(this.c3r_1 === tmp0_other_with_cast.c3r_1))
      return false;
    if (!this.d3r_1.equals(tmp0_other_with_cast.d3r_1))
      return false;
    if (!this.e3r_1.equals(tmp0_other_with_cast.e3r_1))
      return false;
    if (!(this.f3r_1 === tmp0_other_with_cast.f3r_1))
      return false;
    return true;
  };
  function Companion_176() {
    Companion_instance_176 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g3r_1 = [null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), StringSerializer_getInstance()), null, null, null, null, null];
  }
  var Companion_instance_176;
  function Companion_getInstance_176() {
    if (Companion_instance_176 == null)
      new Companion_176();
    return Companion_instance_176;
  }
  function $serializer_211() {
    $serializer_instance_210 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpConfigurationRequest', this, 8);
    tmp0_serialDesc.gy('expectedEntitlementVersion', false);
    tmp0_serialDesc.gy('displayName', false);
    tmp0_serialDesc.gy('configuration', false);
    tmp0_serialDesc.gy('ownership', false);
    tmp0_serialDesc.gy('accountId', true);
    tmp0_serialDesc.gy('expectedConfigVersion', true);
    tmp0_serialDesc.gy('password', true);
    tmp0_serialDesc.gy('clearPassword', true);
    this.h3r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_211).i3r = function (encoder, value) {
    var tmp0_desc = this.h3r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_176().g3r_1;
    tmp1_output.ds(tmp0_desc, 0, value.j3r_1);
    tmp1_output.hs(tmp0_desc, 1, value.k3r_1);
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.l3r_1);
    tmp1_output.hs(tmp0_desc, 3, value.m3r_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.n3r_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, StringSerializer_getInstance(), value.n3r_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.o3r_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, LongSerializer_getInstance(), value.o3r_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.p3r_1 === '')) {
      tmp1_output.hs(tmp0_desc, 6, value.p3r_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.q3r_1 === false)) {
      tmp1_output.zr(tmp0_desc, 7, value.q3r_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_211).on = function (encoder, value) {
    return this.i3r(encoder, value instanceof SetupSmtpConfigurationRequest ? value : THROW_CCE());
  };
  protoOf($serializer_211).pn = function (decoder) {
    var tmp0_desc = this.h3r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = new Long(0, 0);
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_input = decoder.tq(tmp0_desc);
    var tmp13_cached = Companion_getInstance_176().g3r_1;
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.zq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.fr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.zq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.fr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.hr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.hr(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return SetupSmtpConfigurationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_211).nn = function () {
    return this.h3r_1;
  };
  protoOf($serializer_211).vy = function () {
    var tmp0_cached = Companion_getInstance_176().g3r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [LongSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2], StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_210;
  function $serializer_getInstance_210() {
    if ($serializer_instance_210 == null)
      new $serializer_211();
    return $serializer_instance_210;
  }
  function SetupSmtpConfigurationRequest_init_$Init$(seen0, expectedEntitlementVersion, displayName, configuration, ownership, accountId, expectedConfigVersion, password, clearPassword, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_210().h3r_1);
    }
    $this.j3r_1 = expectedEntitlementVersion;
    $this.k3r_1 = displayName;
    $this.l3r_1 = configuration;
    $this.m3r_1 = ownership;
    if (0 === (seen0 & 16))
      $this.n3r_1 = null;
    else
      $this.n3r_1 = accountId;
    if (0 === (seen0 & 32))
      $this.o3r_1 = null;
    else
      $this.o3r_1 = expectedConfigVersion;
    if (0 === (seen0 & 64))
      $this.p3r_1 = '';
    else
      $this.p3r_1 = password;
    if (0 === (seen0 & 128))
      $this.q3r_1 = false;
    else
      $this.q3r_1 = clearPassword;
    return $this;
  }
  function SetupSmtpConfigurationRequest_init_$Create$(seen0, expectedEntitlementVersion, displayName, configuration, ownership, accountId, expectedConfigVersion, password, clearPassword, serializationConstructorMarker) {
    return SetupSmtpConfigurationRequest_init_$Init$(seen0, expectedEntitlementVersion, displayName, configuration, ownership, accountId, expectedConfigVersion, password, clearPassword, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpConfigurationRequest)));
  }
  function SetupSmtpConfigurationRequest(expectedEntitlementVersion, displayName, configuration, ownership, accountId, expectedConfigVersion, password, clearPassword) {
    Companion_getInstance_176();
    accountId = accountId === VOID ? null : accountId;
    expectedConfigVersion = expectedConfigVersion === VOID ? null : expectedConfigVersion;
    password = password === VOID ? '' : password;
    clearPassword = clearPassword === VOID ? false : clearPassword;
    this.j3r_1 = expectedEntitlementVersion;
    this.k3r_1 = displayName;
    this.l3r_1 = configuration;
    this.m3r_1 = ownership;
    this.n3r_1 = accountId;
    this.o3r_1 = expectedConfigVersion;
    this.p3r_1 = password;
    this.q3r_1 = clearPassword;
  }
  protoOf(SetupSmtpConfigurationRequest).toString = function () {
    return 'SetupSmtpConfigurationRequest(credentials=redacted)';
  };
  protoOf(SetupSmtpConfigurationRequest).hashCode = function () {
    var result = this.j3r_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.k3r_1) | 0;
    result = imul(result, 31) + hashCode(this.l3r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m3r_1) | 0;
    result = imul(result, 31) + (this.n3r_1 == null ? 0 : getStringHashCode(this.n3r_1)) | 0;
    result = imul(result, 31) + (this.o3r_1 == null ? 0 : this.o3r_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.p3r_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q3r_1) | 0;
    return result;
  };
  protoOf(SetupSmtpConfigurationRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpConfigurationRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpConfigurationRequest ? other : THROW_CCE();
    if (!this.j3r_1.equals(tmp0_other_with_cast.j3r_1))
      return false;
    if (!(this.k3r_1 === tmp0_other_with_cast.k3r_1))
      return false;
    if (!equals(this.l3r_1, tmp0_other_with_cast.l3r_1))
      return false;
    if (!(this.m3r_1 === tmp0_other_with_cast.m3r_1))
      return false;
    if (!(this.n3r_1 == tmp0_other_with_cast.n3r_1))
      return false;
    if (!equals(this.o3r_1, tmp0_other_with_cast.o3r_1))
      return false;
    if (!(this.p3r_1 === tmp0_other_with_cast.p3r_1))
      return false;
    if (!(this.q3r_1 === tmp0_other_with_cast.q3r_1))
      return false;
    return true;
  };
  function Companion_177() {
  }
  var Companion_instance_177;
  function Companion_getInstance_177() {
    return Companion_instance_177;
  }
  function $serializer_212() {
    $serializer_instance_211 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpConfigurationRecovery', this, 1);
    tmp0_serialDesc.gy('receipt', true);
    this.r3r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_212).s3r = function (encoder, value) {
    var tmp0_desc = this.r3r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.t3r_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, $serializer_getInstance_209(), value.t3r_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_212).on = function (encoder, value) {
    return this.s3r(encoder, value instanceof SetupSmtpConfigurationRecovery ? value : THROW_CCE());
  };
  protoOf($serializer_212).pn = function (decoder) {
    var tmp0_desc = this.r3r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.hr(tmp0_desc, 0, $serializer_getInstance_209(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hr(tmp0_desc, 0, $serializer_getInstance_209(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return SetupSmtpConfigurationRecovery_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_212).nn = function () {
    return this.r3r_1;
  };
  protoOf($serializer_212).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_209())];
  };
  var $serializer_instance_211;
  function $serializer_getInstance_211() {
    if ($serializer_instance_211 == null)
      new $serializer_212();
    return $serializer_instance_211;
  }
  function SetupSmtpConfigurationRecovery_init_$Init$(seen0, receipt, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_211().r3r_1);
    }
    if (0 === (seen0 & 1))
      $this.t3r_1 = null;
    else
      $this.t3r_1 = receipt;
    return $this;
  }
  function SetupSmtpConfigurationRecovery_init_$Create$(seen0, receipt, serializationConstructorMarker) {
    return SetupSmtpConfigurationRecovery_init_$Init$(seen0, receipt, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpConfigurationRecovery)));
  }
  function SetupSmtpConfigurationRecovery(receipt) {
    receipt = receipt === VOID ? null : receipt;
    this.t3r_1 = receipt;
  }
  protoOf(SetupSmtpConfigurationRecovery).toString = function () {
    return 'SetupSmtpConfigurationRecovery(receipt=' + toString_0(this.t3r_1) + ')';
  };
  protoOf(SetupSmtpConfigurationRecovery).hashCode = function () {
    return this.t3r_1 == null ? 0 : this.t3r_1.hashCode();
  };
  protoOf(SetupSmtpConfigurationRecovery).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpConfigurationRecovery))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpConfigurationRecovery ? other : THROW_CCE();
    if (!equals(this.t3r_1, tmp0_other_with_cast.t3r_1))
      return false;
    return true;
  };
  function Companion_178() {
    Companion_instance_178 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u3r_1 = [null, null, null, null, null, null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null];
  }
  var Companion_instance_178;
  function Companion_getInstance_178() {
    if (Companion_instance_178 == null)
      new Companion_178();
    return Companion_instance_178;
  }
  function $serializer_213() {
    $serializer_instance_212 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpOriginView', this, 13);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('accountId', false);
    tmp0_serialDesc.gy('configVersion', false);
    tmp0_serialDesc.gy('assignmentGeneration', false);
    tmp0_serialDesc.gy('assignmentRevision', false);
    tmp0_serialDesc.gy('entitlementVersion', false);
    tmp0_serialDesc.gy('verificationEligible', false);
    tmp0_serialDesc.gy('activationEligible', false);
    tmp0_serialDesc.gy('blockedReasons', false);
    tmp0_serialDesc.gy('verificationProofId', false);
    tmp0_serialDesc.gy('proofStatus', false);
    tmp0_serialDesc.gy('runtimeStatus', false);
    this.v3r_1 = tmp0_serialDesc;
  }
  protoOf($serializer_213).w3r = function (encoder, value) {
    var tmp0_desc = this.v3r_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_178().u3r_1;
    tmp1_output.hs(tmp0_desc, 0, value.x3r_1);
    tmp1_output.hs(tmp0_desc, 1, value.y3r_1);
    tmp1_output.hs(tmp0_desc, 2, value.z3r_1);
    tmp1_output.ds(tmp0_desc, 3, value.a3s_1);
    tmp1_output.hs(tmp0_desc, 4, value.b3s_1);
    tmp1_output.ds(tmp0_desc, 5, value.c3s_1);
    tmp1_output.ds(tmp0_desc, 6, value.d3s_1);
    tmp1_output.zr(tmp0_desc, 7, value.e3s_1);
    tmp1_output.zr(tmp0_desc, 8, value.f3s_1);
    tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.g3s_1);
    tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.h3s_1);
    tmp1_output.hs(tmp0_desc, 11, value.i3s_1);
    tmp1_output.hs(tmp0_desc, 12, value.j3s_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_213).on = function (encoder, value) {
    return this.w3r(encoder, value instanceof SetupSmtpOriginView ? value : THROW_CCE());
  };
  protoOf($serializer_213).pn = function (decoder) {
    var tmp0_desc = this.v3r_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = new Long(0, 0);
    var tmp11_local7 = false;
    var tmp12_local8 = false;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_input = decoder.tq(tmp0_desc);
    var tmp18_cached = Companion_getInstance_178().u3r_1;
    if (tmp17_input.ir()) {
      tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp17_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp17_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp17_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp17_input.zq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp17_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp17_input.vq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp17_input.dr(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp17_input.dr(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp17_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp17_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp17_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp17_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp17_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp17_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp17_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp17_input.zq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp17_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp17_input.vq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp17_input.fr(tmp0_desc, 9, tmp18_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp17_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp17_input.dr(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp17_input.dr(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp17_input.uq(tmp0_desc);
    return SetupSmtpOriginView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, null);
  };
  protoOf($serializer_213).nn = function () {
    return this.v3r_1;
  };
  protoOf($serializer_213).vy = function () {
    var tmp0_cached = Companion_getInstance_178().u3r_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), tmp0_cached[9], get_nullable(StringSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_212;
  function $serializer_getInstance_212() {
    if ($serializer_instance_212 == null)
      new $serializer_213();
    return $serializer_instance_212;
  }
  function SetupSmtpOriginView_init_$Init$(seen0, attemptId, tenantId, accountId, configVersion, assignmentGeneration, assignmentRevision, entitlementVersion, verificationEligible, activationEligible, blockedReasons, verificationProofId, proofStatus, runtimeStatus, serializationConstructorMarker, $this) {
    if (!(8191 === (8191 & seen0))) {
      throwMissingFieldException(seen0, 8191, $serializer_getInstance_212().v3r_1);
    }
    $this.x3r_1 = attemptId;
    $this.y3r_1 = tenantId;
    $this.z3r_1 = accountId;
    $this.a3s_1 = configVersion;
    $this.b3s_1 = assignmentGeneration;
    $this.c3s_1 = assignmentRevision;
    $this.d3s_1 = entitlementVersion;
    $this.e3s_1 = verificationEligible;
    $this.f3s_1 = activationEligible;
    $this.g3s_1 = blockedReasons;
    $this.h3s_1 = verificationProofId;
    $this.i3s_1 = proofStatus;
    $this.j3s_1 = runtimeStatus;
    return $this;
  }
  function SetupSmtpOriginView_init_$Create$(seen0, attemptId, tenantId, accountId, configVersion, assignmentGeneration, assignmentRevision, entitlementVersion, verificationEligible, activationEligible, blockedReasons, verificationProofId, proofStatus, runtimeStatus, serializationConstructorMarker) {
    return SetupSmtpOriginView_init_$Init$(seen0, attemptId, tenantId, accountId, configVersion, assignmentGeneration, assignmentRevision, entitlementVersion, verificationEligible, activationEligible, blockedReasons, verificationProofId, proofStatus, runtimeStatus, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpOriginView)));
  }
  function SetupSmtpOriginView(attemptId, tenantId, accountId, configVersion, assignmentGeneration, assignmentRevision, entitlementVersion, verificationEligible, activationEligible, blockedReasons, verificationProofId, proofStatus, runtimeStatus) {
    Companion_getInstance_178();
    this.x3r_1 = attemptId;
    this.y3r_1 = tenantId;
    this.z3r_1 = accountId;
    this.a3s_1 = configVersion;
    this.b3s_1 = assignmentGeneration;
    this.c3s_1 = assignmentRevision;
    this.d3s_1 = entitlementVersion;
    this.e3s_1 = verificationEligible;
    this.f3s_1 = activationEligible;
    this.g3s_1 = blockedReasons;
    this.h3s_1 = verificationProofId;
    this.i3s_1 = proofStatus;
    this.j3s_1 = runtimeStatus;
  }
  protoOf(SetupSmtpOriginView).toString = function () {
    return 'SetupSmtpOriginView(attemptId=' + this.x3r_1 + ', tenantId=' + this.y3r_1 + ', accountId=' + this.z3r_1 + ', configVersion=' + this.a3s_1.toString() + ', assignmentGeneration=' + this.b3s_1 + ', assignmentRevision=' + this.c3s_1.toString() + ', entitlementVersion=' + this.d3s_1.toString() + ', verificationEligible=' + this.e3s_1 + ', activationEligible=' + this.f3s_1 + ', blockedReasons=' + toString(this.g3s_1) + ', verificationProofId=' + this.h3s_1 + ', proofStatus=' + this.i3s_1 + ', runtimeStatus=' + this.j3s_1 + ')';
  };
  protoOf(SetupSmtpOriginView).hashCode = function () {
    var result = getStringHashCode(this.x3r_1);
    result = imul(result, 31) + getStringHashCode(this.y3r_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z3r_1) | 0;
    result = imul(result, 31) + this.a3s_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.b3s_1) | 0;
    result = imul(result, 31) + this.c3s_1.hashCode() | 0;
    result = imul(result, 31) + this.d3s_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e3s_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f3s_1) | 0;
    result = imul(result, 31) + hashCode(this.g3s_1) | 0;
    result = imul(result, 31) + (this.h3s_1 == null ? 0 : getStringHashCode(this.h3s_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.i3s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j3s_1) | 0;
    return result;
  };
  protoOf(SetupSmtpOriginView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpOriginView))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpOriginView ? other : THROW_CCE();
    if (!(this.x3r_1 === tmp0_other_with_cast.x3r_1))
      return false;
    if (!(this.y3r_1 === tmp0_other_with_cast.y3r_1))
      return false;
    if (!(this.z3r_1 === tmp0_other_with_cast.z3r_1))
      return false;
    if (!this.a3s_1.equals(tmp0_other_with_cast.a3s_1))
      return false;
    if (!(this.b3s_1 === tmp0_other_with_cast.b3s_1))
      return false;
    if (!this.c3s_1.equals(tmp0_other_with_cast.c3s_1))
      return false;
    if (!this.d3s_1.equals(tmp0_other_with_cast.d3s_1))
      return false;
    if (!(this.e3s_1 === tmp0_other_with_cast.e3s_1))
      return false;
    if (!(this.f3s_1 === tmp0_other_with_cast.f3s_1))
      return false;
    if (!equals(this.g3s_1, tmp0_other_with_cast.g3s_1))
      return false;
    if (!(this.h3s_1 == tmp0_other_with_cast.h3s_1))
      return false;
    if (!(this.i3s_1 === tmp0_other_with_cast.i3s_1))
      return false;
    if (!(this.j3s_1 === tmp0_other_with_cast.j3s_1))
      return false;
    return true;
  };
  function Companion_179() {
  }
  var Companion_instance_179;
  function Companion_getInstance_179() {
    return Companion_instance_179;
  }
  function $serializer_214() {
    $serializer_instance_213 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpVerificationReceipt', this, 11);
    tmp0_serialDesc.gy('verificationId', false);
    tmp0_serialDesc.gy('attemptId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('accountId', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('entitlementVersion', false);
    tmp0_serialDesc.gy('configVersion', false);
    tmp0_serialDesc.gy('assignmentGeneration', false);
    tmp0_serialDesc.gy('assignmentRevision', false);
    tmp0_serialDesc.gy('proofId', true);
    tmp0_serialDesc.gy('reasonCode', true);
    this.k3s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_214).l3s = function (encoder, value) {
    var tmp0_desc = this.k3s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.m3s_1);
    tmp1_output.hs(tmp0_desc, 1, value.n3s_1);
    tmp1_output.hs(tmp0_desc, 2, value.o3s_1);
    tmp1_output.hs(tmp0_desc, 3, value.p3s_1);
    tmp1_output.hs(tmp0_desc, 4, value.q3s_1);
    tmp1_output.ds(tmp0_desc, 5, value.r3s_1);
    tmp1_output.ds(tmp0_desc, 6, value.s3s_1);
    tmp1_output.hs(tmp0_desc, 7, value.t3s_1);
    tmp1_output.ds(tmp0_desc, 8, value.u3s_1);
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.v3s_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, StringSerializer_getInstance(), value.v3s_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.w3s_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.w3s_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_214).on = function (encoder, value) {
    return this.l3s(encoder, value instanceof SetupSmtpVerificationReceipt ? value : THROW_CCE());
  };
  protoOf($serializer_214).pn = function (decoder) {
    var tmp0_desc = this.k3s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = new Long(0, 0);
    var tmp10_local6 = new Long(0, 0);
    var tmp11_local7 = null;
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.tq(tmp0_desc);
    if (tmp15_input.ir()) {
      tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.zq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.zq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.zq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.zq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.hr(tmp0_desc, 9, StringSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.uq(tmp0_desc);
    return SetupSmtpVerificationReceipt_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_214).nn = function () {
    return this.k3s_1;
  };
  protoOf($serializer_214).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_213;
  function $serializer_getInstance_213() {
    if ($serializer_instance_213 == null)
      new $serializer_214();
    return $serializer_instance_213;
  }
  function SetupSmtpVerificationReceipt_init_$Init$(seen0, verificationId, attemptId, tenantId, accountId, status, entitlementVersion, configVersion, assignmentGeneration, assignmentRevision, proofId, reasonCode, serializationConstructorMarker, $this) {
    if (!(511 === (511 & seen0))) {
      throwMissingFieldException(seen0, 511, $serializer_getInstance_213().k3s_1);
    }
    $this.m3s_1 = verificationId;
    $this.n3s_1 = attemptId;
    $this.o3s_1 = tenantId;
    $this.p3s_1 = accountId;
    $this.q3s_1 = status;
    $this.r3s_1 = entitlementVersion;
    $this.s3s_1 = configVersion;
    $this.t3s_1 = assignmentGeneration;
    $this.u3s_1 = assignmentRevision;
    if (0 === (seen0 & 512))
      $this.v3s_1 = null;
    else
      $this.v3s_1 = proofId;
    if (0 === (seen0 & 1024))
      $this.w3s_1 = null;
    else
      $this.w3s_1 = reasonCode;
    return $this;
  }
  function SetupSmtpVerificationReceipt_init_$Create$(seen0, verificationId, attemptId, tenantId, accountId, status, entitlementVersion, configVersion, assignmentGeneration, assignmentRevision, proofId, reasonCode, serializationConstructorMarker) {
    return SetupSmtpVerificationReceipt_init_$Init$(seen0, verificationId, attemptId, tenantId, accountId, status, entitlementVersion, configVersion, assignmentGeneration, assignmentRevision, proofId, reasonCode, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpVerificationReceipt)));
  }
  function SetupSmtpVerificationReceipt(verificationId, attemptId, tenantId, accountId, status, entitlementVersion, configVersion, assignmentGeneration, assignmentRevision, proofId, reasonCode) {
    proofId = proofId === VOID ? null : proofId;
    reasonCode = reasonCode === VOID ? null : reasonCode;
    this.m3s_1 = verificationId;
    this.n3s_1 = attemptId;
    this.o3s_1 = tenantId;
    this.p3s_1 = accountId;
    this.q3s_1 = status;
    this.r3s_1 = entitlementVersion;
    this.s3s_1 = configVersion;
    this.t3s_1 = assignmentGeneration;
    this.u3s_1 = assignmentRevision;
    this.v3s_1 = proofId;
    this.w3s_1 = reasonCode;
  }
  protoOf(SetupSmtpVerificationReceipt).toString = function () {
    return 'SetupSmtpVerificationReceipt(verificationId=' + this.m3s_1 + ', attemptId=' + this.n3s_1 + ', tenantId=' + this.o3s_1 + ', accountId=' + this.p3s_1 + ', status=' + this.q3s_1 + ', entitlementVersion=' + this.r3s_1.toString() + ', configVersion=' + this.s3s_1.toString() + ', assignmentGeneration=' + this.t3s_1 + ', assignmentRevision=' + this.u3s_1.toString() + ', proofId=' + this.v3s_1 + ', reasonCode=' + this.w3s_1 + ')';
  };
  protoOf(SetupSmtpVerificationReceipt).hashCode = function () {
    var result = getStringHashCode(this.m3s_1);
    result = imul(result, 31) + getStringHashCode(this.n3s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o3s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p3s_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q3s_1) | 0;
    result = imul(result, 31) + this.r3s_1.hashCode() | 0;
    result = imul(result, 31) + this.s3s_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.t3s_1) | 0;
    result = imul(result, 31) + this.u3s_1.hashCode() | 0;
    result = imul(result, 31) + (this.v3s_1 == null ? 0 : getStringHashCode(this.v3s_1)) | 0;
    result = imul(result, 31) + (this.w3s_1 == null ? 0 : getStringHashCode(this.w3s_1)) | 0;
    return result;
  };
  protoOf(SetupSmtpVerificationReceipt).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpVerificationReceipt))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpVerificationReceipt ? other : THROW_CCE();
    if (!(this.m3s_1 === tmp0_other_with_cast.m3s_1))
      return false;
    if (!(this.n3s_1 === tmp0_other_with_cast.n3s_1))
      return false;
    if (!(this.o3s_1 === tmp0_other_with_cast.o3s_1))
      return false;
    if (!(this.p3s_1 === tmp0_other_with_cast.p3s_1))
      return false;
    if (!(this.q3s_1 === tmp0_other_with_cast.q3s_1))
      return false;
    if (!this.r3s_1.equals(tmp0_other_with_cast.r3s_1))
      return false;
    if (!this.s3s_1.equals(tmp0_other_with_cast.s3s_1))
      return false;
    if (!(this.t3s_1 === tmp0_other_with_cast.t3s_1))
      return false;
    if (!this.u3s_1.equals(tmp0_other_with_cast.u3s_1))
      return false;
    if (!(this.v3s_1 == tmp0_other_with_cast.v3s_1))
      return false;
    if (!(this.w3s_1 == tmp0_other_with_cast.w3s_1))
      return false;
    return true;
  };
  function Companion_180() {
  }
  var Companion_instance_180;
  function Companion_getInstance_180() {
    return Companion_instance_180;
  }
  function $serializer_215() {
    $serializer_instance_214 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpVerificationRequest', this, 5);
    tmp0_serialDesc.gy('accountId', false);
    tmp0_serialDesc.gy('expectedEntitlementVersion', false);
    tmp0_serialDesc.gy('expectedConfigVersion', false);
    tmp0_serialDesc.gy('expectedAssignmentGeneration', false);
    tmp0_serialDesc.gy('expectedAssignmentRevision', false);
    this.x3s_1 = tmp0_serialDesc;
  }
  protoOf($serializer_215).y3s = function (encoder, value) {
    var tmp0_desc = this.x3s_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.z3s_1);
    tmp1_output.ds(tmp0_desc, 1, value.a3t_1);
    tmp1_output.ds(tmp0_desc, 2, value.b3t_1);
    tmp1_output.hs(tmp0_desc, 3, value.c3t_1);
    tmp1_output.ds(tmp0_desc, 4, value.d3t_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_215).on = function (encoder, value) {
    return this.y3s(encoder, value instanceof SetupSmtpVerificationRequest ? value : THROW_CCE());
  };
  protoOf($serializer_215).pn = function (decoder) {
    var tmp0_desc = this.x3s_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return SetupSmtpVerificationRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_215).nn = function () {
    return this.x3s_1;
  };
  protoOf($serializer_215).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_214;
  function $serializer_getInstance_214() {
    if ($serializer_instance_214 == null)
      new $serializer_215();
    return $serializer_instance_214;
  }
  function SetupSmtpVerificationRequest_init_$Init$(seen0, accountId, expectedEntitlementVersion, expectedConfigVersion, expectedAssignmentGeneration, expectedAssignmentRevision, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_214().x3s_1);
    }
    $this.z3s_1 = accountId;
    $this.a3t_1 = expectedEntitlementVersion;
    $this.b3t_1 = expectedConfigVersion;
    $this.c3t_1 = expectedAssignmentGeneration;
    $this.d3t_1 = expectedAssignmentRevision;
    return $this;
  }
  function SetupSmtpVerificationRequest_init_$Create$(seen0, accountId, expectedEntitlementVersion, expectedConfigVersion, expectedAssignmentGeneration, expectedAssignmentRevision, serializationConstructorMarker) {
    return SetupSmtpVerificationRequest_init_$Init$(seen0, accountId, expectedEntitlementVersion, expectedConfigVersion, expectedAssignmentGeneration, expectedAssignmentRevision, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpVerificationRequest)));
  }
  function SetupSmtpVerificationRequest(accountId, expectedEntitlementVersion, expectedConfigVersion, expectedAssignmentGeneration, expectedAssignmentRevision) {
    this.z3s_1 = accountId;
    this.a3t_1 = expectedEntitlementVersion;
    this.b3t_1 = expectedConfigVersion;
    this.c3t_1 = expectedAssignmentGeneration;
    this.d3t_1 = expectedAssignmentRevision;
  }
  protoOf(SetupSmtpVerificationRequest).toString = function () {
    return 'SetupSmtpVerificationRequest(accountId=' + this.z3s_1 + ', expectedEntitlementVersion=' + this.a3t_1.toString() + ', expectedConfigVersion=' + this.b3t_1.toString() + ', expectedAssignmentGeneration=' + this.c3t_1 + ', expectedAssignmentRevision=' + this.d3t_1.toString() + ')';
  };
  protoOf(SetupSmtpVerificationRequest).hashCode = function () {
    var result = getStringHashCode(this.z3s_1);
    result = imul(result, 31) + this.a3t_1.hashCode() | 0;
    result = imul(result, 31) + this.b3t_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.c3t_1) | 0;
    result = imul(result, 31) + this.d3t_1.hashCode() | 0;
    return result;
  };
  protoOf(SetupSmtpVerificationRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpVerificationRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpVerificationRequest ? other : THROW_CCE();
    if (!(this.z3s_1 === tmp0_other_with_cast.z3s_1))
      return false;
    if (!this.a3t_1.equals(tmp0_other_with_cast.a3t_1))
      return false;
    if (!this.b3t_1.equals(tmp0_other_with_cast.b3t_1))
      return false;
    if (!(this.c3t_1 === tmp0_other_with_cast.c3t_1))
      return false;
    if (!this.d3t_1.equals(tmp0_other_with_cast.d3t_1))
      return false;
    return true;
  };
  function Companion_181() {
  }
  var Companion_instance_181;
  function Companion_getInstance_181() {
    return Companion_instance_181;
  }
  function $serializer_216() {
    $serializer_instance_215 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SetupSmtpVerificationRecovery', this, 1);
    tmp0_serialDesc.gy('receipt', true);
    this.e3t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_216).f3t = function (encoder, value) {
    var tmp0_desc = this.e3t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.g3t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 0, $serializer_getInstance_213(), value.g3t_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_216).on = function (encoder, value) {
    return this.f3t(encoder, value instanceof SetupSmtpVerificationRecovery ? value : THROW_CCE());
  };
  protoOf($serializer_216).pn = function (decoder) {
    var tmp0_desc = this.e3t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.hr(tmp0_desc, 0, $serializer_getInstance_213(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.hr(tmp0_desc, 0, $serializer_getInstance_213(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return SetupSmtpVerificationRecovery_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_216).nn = function () {
    return this.e3t_1;
  };
  protoOf($serializer_216).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_213())];
  };
  var $serializer_instance_215;
  function $serializer_getInstance_215() {
    if ($serializer_instance_215 == null)
      new $serializer_216();
    return $serializer_instance_215;
  }
  function SetupSmtpVerificationRecovery_init_$Init$(seen0, receipt, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_215().e3t_1);
    }
    if (0 === (seen0 & 1))
      $this.g3t_1 = null;
    else
      $this.g3t_1 = receipt;
    return $this;
  }
  function SetupSmtpVerificationRecovery_init_$Create$(seen0, receipt, serializationConstructorMarker) {
    return SetupSmtpVerificationRecovery_init_$Init$(seen0, receipt, serializationConstructorMarker, objectCreate(protoOf(SetupSmtpVerificationRecovery)));
  }
  function SetupSmtpVerificationRecovery(receipt) {
    receipt = receipt === VOID ? null : receipt;
    this.g3t_1 = receipt;
  }
  protoOf(SetupSmtpVerificationRecovery).toString = function () {
    return 'SetupSmtpVerificationRecovery(receipt=' + toString_0(this.g3t_1) + ')';
  };
  protoOf(SetupSmtpVerificationRecovery).hashCode = function () {
    return this.g3t_1 == null ? 0 : this.g3t_1.hashCode();
  };
  protoOf(SetupSmtpVerificationRecovery).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SetupSmtpVerificationRecovery))
      return false;
    var tmp0_other_with_cast = other instanceof SetupSmtpVerificationRecovery ? other : THROW_CCE();
    if (!equals(this.g3t_1, tmp0_other_with_cast.g3t_1))
      return false;
    return true;
  };
  function Companion_182() {
    Companion_instance_182 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h3t_1 = [null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_222())];
  }
  var Companion_instance_182;
  function Companion_getInstance_182() {
    if (Companion_instance_182 == null)
      new Companion_182();
    return Companion_instance_182;
  }
  function $serializer_217() {
    $serializer_instance_216 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionCommitmentState', this, 7);
    tmp0_serialDesc.gy('subscriptionId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('currentVersion', false);
    tmp0_serialDesc.gy('commitment', true);
    tmp0_serialDesc.gy('usageBilledSeparately', true);
    this.i3t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_217).j3t = function (encoder, value) {
    var tmp0_desc = this.i3t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_182().h3t_1;
    tmp1_output.hs(tmp0_desc, 0, value.k3t_1);
    tmp1_output.hs(tmp0_desc, 1, value.l3t_1);
    tmp1_output.hs(tmp0_desc, 2, value.m3t_1);
    tmp1_output.hs(tmp0_desc, 3, value.n3t_1);
    tmp1_output.ds(tmp0_desc, 4, value.o3t_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.p3t_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, $serializer_getInstance_223(), value.p3t_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !equals(value.q3t_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.q3t_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_217).on = function (encoder, value) {
    return this.j3t(encoder, value instanceof SubscriptionCommitmentState ? value : THROW_CCE());
  };
  protoOf($serializer_217).pn = function (decoder) {
    var tmp0_desc = this.i3t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    var tmp12_cached = Companion_getInstance_182().h3t_1;
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.hr(tmp0_desc, 5, $serializer_getInstance_223(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.fr(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.hr(tmp0_desc, 5, $serializer_getInstance_223(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.fr(tmp0_desc, 6, tmp12_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return SubscriptionCommitmentState_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_217).nn = function () {
    return this.i3t_1;
  };
  protoOf($serializer_217).vy = function () {
    var tmp0_cached = Companion_getInstance_182().h3t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), get_nullable($serializer_getInstance_223()), tmp0_cached[6]];
  };
  var $serializer_instance_216;
  function $serializer_getInstance_216() {
    if ($serializer_instance_216 == null)
      new $serializer_217();
    return $serializer_instance_216;
  }
  function SubscriptionCommitmentState_init_$Init$(seen0, subscriptionId, tenantId, planKey, currency, currentVersion, commitment, usageBilledSeparately, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_216().i3t_1);
    }
    $this.k3t_1 = subscriptionId;
    $this.l3t_1 = tenantId;
    $this.m3t_1 = planKey;
    $this.n3t_1 = currency;
    $this.o3t_1 = currentVersion;
    if (0 === (seen0 & 32))
      $this.p3t_1 = null;
    else
      $this.p3t_1 = commitment;
    if (0 === (seen0 & 64))
      $this.q3t_1 = emptyList();
    else
      $this.q3t_1 = usageBilledSeparately;
    return $this;
  }
  function SubscriptionCommitmentState_init_$Create$(seen0, subscriptionId, tenantId, planKey, currency, currentVersion, commitment, usageBilledSeparately, serializationConstructorMarker) {
    return SubscriptionCommitmentState_init_$Init$(seen0, subscriptionId, tenantId, planKey, currency, currentVersion, commitment, usageBilledSeparately, serializationConstructorMarker, objectCreate(protoOf(SubscriptionCommitmentState)));
  }
  function SubscriptionCommitmentState(subscriptionId, tenantId, planKey, currency, currentVersion, commitment, usageBilledSeparately) {
    Companion_getInstance_182();
    commitment = commitment === VOID ? null : commitment;
    usageBilledSeparately = usageBilledSeparately === VOID ? emptyList() : usageBilledSeparately;
    this.k3t_1 = subscriptionId;
    this.l3t_1 = tenantId;
    this.m3t_1 = planKey;
    this.n3t_1 = currency;
    this.o3t_1 = currentVersion;
    this.p3t_1 = commitment;
    this.q3t_1 = usageBilledSeparately;
  }
  protoOf(SubscriptionCommitmentState).toString = function () {
    return 'SubscriptionCommitmentState(subscriptionId=' + this.k3t_1 + ', tenantId=' + this.l3t_1 + ', planKey=' + this.m3t_1 + ', currency=' + this.n3t_1 + ', currentVersion=' + this.o3t_1.toString() + ', commitment=' + toString_0(this.p3t_1) + ', usageBilledSeparately=' + toString(this.q3t_1) + ')';
  };
  protoOf(SubscriptionCommitmentState).hashCode = function () {
    var result = getStringHashCode(this.k3t_1);
    result = imul(result, 31) + getStringHashCode(this.l3t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.m3t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n3t_1) | 0;
    result = imul(result, 31) + this.o3t_1.hashCode() | 0;
    result = imul(result, 31) + (this.p3t_1 == null ? 0 : this.p3t_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.q3t_1) | 0;
    return result;
  };
  protoOf(SubscriptionCommitmentState).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionCommitmentState))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionCommitmentState ? other : THROW_CCE();
    if (!(this.k3t_1 === tmp0_other_with_cast.k3t_1))
      return false;
    if (!(this.l3t_1 === tmp0_other_with_cast.l3t_1))
      return false;
    if (!(this.m3t_1 === tmp0_other_with_cast.m3t_1))
      return false;
    if (!(this.n3t_1 === tmp0_other_with_cast.n3t_1))
      return false;
    if (!this.o3t_1.equals(tmp0_other_with_cast.o3t_1))
      return false;
    if (!equals(this.p3t_1, tmp0_other_with_cast.p3t_1))
      return false;
    if (!equals(this.q3t_1, tmp0_other_with_cast.q3t_1))
      return false;
    return true;
  };
  function SubscriptionCommitmentPaths() {
  }
  protoOf(SubscriptionCommitmentPaths).r3t = function (subscriptionId) {
    return '/api/console/subscriptions/' + ConsoleApiPaths_instance.e1z(subscriptionId) + '/commitment';
  };
  protoOf(SubscriptionCommitmentPaths).s3t = function (subscriptionId) {
    return '/api/console/subscriptions/' + ConsoleApiPaths_instance.e1z(subscriptionId) + '/commitment-preview';
  };
  var SubscriptionCommitmentPaths_instance;
  function SubscriptionCommitmentPaths_getInstance() {
    return SubscriptionCommitmentPaths_instance;
  }
  function Companion_183() {
    Companion_instance_183 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t3t_1 = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_221()), new ArrayListSerializer($serializer_getInstance_222()), null, null];
  }
  var Companion_instance_183;
  function Companion_getInstance_183() {
    if (Companion_instance_183 == null)
      new Companion_183();
    return Companion_instance_183;
  }
  function $serializer_218() {
    $serializer_instance_217 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionCommitmentPreview', this, 18);
    tmp0_serialDesc.gy('previewId', false);
    tmp0_serialDesc.gy('subscriptionId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('expectedVersion', false);
    tmp0_serialDesc.gy('commitmentMonths', false);
    tmp0_serialDesc.gy('paymentCadence', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('listAnnualMinor', false);
    tmp0_serialDesc.gy('discountBasisPoints', false);
    tmp0_serialDesc.gy('discountMinor', false);
    tmp0_serialDesc.gy('committedAnnualMinor', false);
    tmp0_serialDesc.gy('monthlyEquivalentMinor', false);
    tmp0_serialDesc.gy('monthlyEquivalentRemainderMinor', false);
    tmp0_serialDesc.gy('installments', false);
    tmp0_serialDesc.gy('usageBilledSeparately', false);
    tmp0_serialDesc.gy('generatedAtMs', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    this.u3t_1 = tmp0_serialDesc;
  }
  protoOf($serializer_218).v3t = function (encoder, value) {
    var tmp0_desc = this.u3t_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_183().t3t_1;
    tmp1_output.hs(tmp0_desc, 0, value.w3t_1);
    tmp1_output.hs(tmp0_desc, 1, value.x3t_1);
    tmp1_output.hs(tmp0_desc, 2, value.y3t_1);
    tmp1_output.hs(tmp0_desc, 3, value.z3t_1);
    tmp1_output.ds(tmp0_desc, 4, value.a3u_1);
    tmp1_output.cs(tmp0_desc, 5, value.b3u_1);
    tmp1_output.hs(tmp0_desc, 6, value.c3u_1);
    tmp1_output.hs(tmp0_desc, 7, value.d3u_1);
    tmp1_output.ds(tmp0_desc, 8, value.e3u_1);
    tmp1_output.cs(tmp0_desc, 9, value.f3u_1);
    tmp1_output.ds(tmp0_desc, 10, value.g3u_1);
    tmp1_output.ds(tmp0_desc, 11, value.h3u_1);
    tmp1_output.ds(tmp0_desc, 12, value.i3u_1);
    tmp1_output.ds(tmp0_desc, 13, value.j3u_1);
    tmp1_output.js(tmp0_desc, 14, tmp2_cached[14], value.k3u_1);
    tmp1_output.js(tmp0_desc, 15, tmp2_cached[15], value.l3u_1);
    tmp1_output.ds(tmp0_desc, 16, value.m3u_1);
    tmp1_output.ds(tmp0_desc, 17, value.n3u_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_218).on = function (encoder, value) {
    return this.v3t(encoder, value instanceof SubscriptionCommitmentPreview ? value : THROW_CCE());
  };
  protoOf($serializer_218).pn = function (decoder) {
    var tmp0_desc = this.u3t_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = new Long(0, 0);
    var tmp9_local5 = 0;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = 0;
    var tmp14_local10 = new Long(0, 0);
    var tmp15_local11 = new Long(0, 0);
    var tmp16_local12 = new Long(0, 0);
    var tmp17_local13 = new Long(0, 0);
    var tmp18_local14 = null;
    var tmp19_local15 = null;
    var tmp20_local16 = new Long(0, 0);
    var tmp21_local17 = new Long(0, 0);
    var tmp22_input = decoder.tq(tmp0_desc);
    var tmp23_cached = Companion_getInstance_183().t3t_1;
    if (tmp22_input.ir()) {
      tmp4_local0 = tmp22_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp22_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp22_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp22_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp22_input.zq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp22_input.yq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp22_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp22_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp22_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp22_input.yq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp22_input.zq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp22_input.zq(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp22_input.zq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp22_input.zq(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp22_input.fr(tmp0_desc, 14, tmp23_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp22_input.fr(tmp0_desc, 15, tmp23_cached[15], tmp19_local15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp22_input.zq(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
      tmp21_local17 = tmp22_input.zq(tmp0_desc, 17);
      tmp3_bitMask0 = tmp3_bitMask0 | 131072;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp22_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp22_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp22_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp22_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp22_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp22_input.zq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp22_input.yq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp22_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp22_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp22_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp22_input.yq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp22_input.zq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp22_input.zq(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp22_input.zq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp22_input.zq(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp22_input.fr(tmp0_desc, 14, tmp23_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp22_input.fr(tmp0_desc, 15, tmp23_cached[15], tmp19_local15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp22_input.zq(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          case 17:
            tmp21_local17 = tmp22_input.zq(tmp0_desc, 17);
            tmp3_bitMask0 = tmp3_bitMask0 | 131072;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp22_input.uq(tmp0_desc);
    return SubscriptionCommitmentPreview_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, tmp21_local17, null);
  };
  protoOf($serializer_218).nn = function () {
    return this.u3t_1;
  };
  protoOf($serializer_218).vy = function () {
    var tmp0_cached = Companion_getInstance_183().t3t_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), IntSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[14], tmp0_cached[15], LongSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_217;
  function $serializer_getInstance_217() {
    if ($serializer_instance_217 == null)
      new $serializer_218();
    return $serializer_instance_217;
  }
  function SubscriptionCommitmentPreview_init_$Init$(seen0, previewId, subscriptionId, tenantId, planKey, expectedVersion, commitmentMonths, paymentCadence, currency, listAnnualMinor, discountBasisPoints, discountMinor, committedAnnualMinor, monthlyEquivalentMinor, monthlyEquivalentRemainderMinor, installments, usageBilledSeparately, generatedAtMs, expiresAtMs, serializationConstructorMarker, $this) {
    if (!(262143 === (262143 & seen0))) {
      throwMissingFieldException(seen0, 262143, $serializer_getInstance_217().u3t_1);
    }
    $this.w3t_1 = previewId;
    $this.x3t_1 = subscriptionId;
    $this.y3t_1 = tenantId;
    $this.z3t_1 = planKey;
    $this.a3u_1 = expectedVersion;
    $this.b3u_1 = commitmentMonths;
    $this.c3u_1 = paymentCadence;
    $this.d3u_1 = currency;
    $this.e3u_1 = listAnnualMinor;
    $this.f3u_1 = discountBasisPoints;
    $this.g3u_1 = discountMinor;
    $this.h3u_1 = committedAnnualMinor;
    $this.i3u_1 = monthlyEquivalentMinor;
    $this.j3u_1 = monthlyEquivalentRemainderMinor;
    $this.k3u_1 = installments;
    $this.l3u_1 = usageBilledSeparately;
    $this.m3u_1 = generatedAtMs;
    $this.n3u_1 = expiresAtMs;
    return $this;
  }
  function SubscriptionCommitmentPreview_init_$Create$(seen0, previewId, subscriptionId, tenantId, planKey, expectedVersion, commitmentMonths, paymentCadence, currency, listAnnualMinor, discountBasisPoints, discountMinor, committedAnnualMinor, monthlyEquivalentMinor, monthlyEquivalentRemainderMinor, installments, usageBilledSeparately, generatedAtMs, expiresAtMs, serializationConstructorMarker) {
    return SubscriptionCommitmentPreview_init_$Init$(seen0, previewId, subscriptionId, tenantId, planKey, expectedVersion, commitmentMonths, paymentCadence, currency, listAnnualMinor, discountBasisPoints, discountMinor, committedAnnualMinor, monthlyEquivalentMinor, monthlyEquivalentRemainderMinor, installments, usageBilledSeparately, generatedAtMs, expiresAtMs, serializationConstructorMarker, objectCreate(protoOf(SubscriptionCommitmentPreview)));
  }
  function SubscriptionCommitmentPreview(previewId, subscriptionId, tenantId, planKey, expectedVersion, commitmentMonths, paymentCadence, currency, listAnnualMinor, discountBasisPoints, discountMinor, committedAnnualMinor, monthlyEquivalentMinor, monthlyEquivalentRemainderMinor, installments, usageBilledSeparately, generatedAtMs, expiresAtMs) {
    Companion_getInstance_183();
    this.w3t_1 = previewId;
    this.x3t_1 = subscriptionId;
    this.y3t_1 = tenantId;
    this.z3t_1 = planKey;
    this.a3u_1 = expectedVersion;
    this.b3u_1 = commitmentMonths;
    this.c3u_1 = paymentCadence;
    this.d3u_1 = currency;
    this.e3u_1 = listAnnualMinor;
    this.f3u_1 = discountBasisPoints;
    this.g3u_1 = discountMinor;
    this.h3u_1 = committedAnnualMinor;
    this.i3u_1 = monthlyEquivalentMinor;
    this.j3u_1 = monthlyEquivalentRemainderMinor;
    this.k3u_1 = installments;
    this.l3u_1 = usageBilledSeparately;
    this.m3u_1 = generatedAtMs;
    this.n3u_1 = expiresAtMs;
  }
  protoOf(SubscriptionCommitmentPreview).toString = function () {
    return 'SubscriptionCommitmentPreview(previewId=' + this.w3t_1 + ', subscriptionId=' + this.x3t_1 + ', tenantId=' + this.y3t_1 + ', planKey=' + this.z3t_1 + ', expectedVersion=' + this.a3u_1.toString() + ', commitmentMonths=' + this.b3u_1 + ', paymentCadence=' + this.c3u_1 + ', currency=' + this.d3u_1 + ', listAnnualMinor=' + this.e3u_1.toString() + ', discountBasisPoints=' + this.f3u_1 + ', discountMinor=' + this.g3u_1.toString() + ', committedAnnualMinor=' + this.h3u_1.toString() + ', monthlyEquivalentMinor=' + this.i3u_1.toString() + ', monthlyEquivalentRemainderMinor=' + this.j3u_1.toString() + ', installments=' + toString(this.k3u_1) + ', usageBilledSeparately=' + toString(this.l3u_1) + ', generatedAtMs=' + this.m3u_1.toString() + ', expiresAtMs=' + this.n3u_1.toString() + ')';
  };
  protoOf(SubscriptionCommitmentPreview).hashCode = function () {
    var result = getStringHashCode(this.w3t_1);
    result = imul(result, 31) + getStringHashCode(this.x3t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y3t_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.z3t_1) | 0;
    result = imul(result, 31) + this.a3u_1.hashCode() | 0;
    result = imul(result, 31) + this.b3u_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.c3u_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d3u_1) | 0;
    result = imul(result, 31) + this.e3u_1.hashCode() | 0;
    result = imul(result, 31) + this.f3u_1 | 0;
    result = imul(result, 31) + this.g3u_1.hashCode() | 0;
    result = imul(result, 31) + this.h3u_1.hashCode() | 0;
    result = imul(result, 31) + this.i3u_1.hashCode() | 0;
    result = imul(result, 31) + this.j3u_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.k3u_1) | 0;
    result = imul(result, 31) + hashCode(this.l3u_1) | 0;
    result = imul(result, 31) + this.m3u_1.hashCode() | 0;
    result = imul(result, 31) + this.n3u_1.hashCode() | 0;
    return result;
  };
  protoOf(SubscriptionCommitmentPreview).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionCommitmentPreview))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionCommitmentPreview ? other : THROW_CCE();
    if (!(this.w3t_1 === tmp0_other_with_cast.w3t_1))
      return false;
    if (!(this.x3t_1 === tmp0_other_with_cast.x3t_1))
      return false;
    if (!(this.y3t_1 === tmp0_other_with_cast.y3t_1))
      return false;
    if (!(this.z3t_1 === tmp0_other_with_cast.z3t_1))
      return false;
    if (!this.a3u_1.equals(tmp0_other_with_cast.a3u_1))
      return false;
    if (!(this.b3u_1 === tmp0_other_with_cast.b3u_1))
      return false;
    if (!(this.c3u_1 === tmp0_other_with_cast.c3u_1))
      return false;
    if (!(this.d3u_1 === tmp0_other_with_cast.d3u_1))
      return false;
    if (!this.e3u_1.equals(tmp0_other_with_cast.e3u_1))
      return false;
    if (!(this.f3u_1 === tmp0_other_with_cast.f3u_1))
      return false;
    if (!this.g3u_1.equals(tmp0_other_with_cast.g3u_1))
      return false;
    if (!this.h3u_1.equals(tmp0_other_with_cast.h3u_1))
      return false;
    if (!this.i3u_1.equals(tmp0_other_with_cast.i3u_1))
      return false;
    if (!this.j3u_1.equals(tmp0_other_with_cast.j3u_1))
      return false;
    if (!equals(this.k3u_1, tmp0_other_with_cast.k3u_1))
      return false;
    if (!equals(this.l3u_1, tmp0_other_with_cast.l3u_1))
      return false;
    if (!this.m3u_1.equals(tmp0_other_with_cast.m3u_1))
      return false;
    if (!this.n3u_1.equals(tmp0_other_with_cast.n3u_1))
      return false;
    return true;
  };
  function Companion_184() {
    Companion_instance_184 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o3u_1 = [null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_184;
  function Companion_getInstance_184() {
    if (Companion_instance_184 == null)
      new Companion_184();
    return Companion_instance_184;
  }
  function $serializer_219() {
    $serializer_instance_218 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionCommitmentPreviewRequest', this, 5);
    tmp0_serialDesc.gy('commitmentMonths', true);
    tmp0_serialDesc.gy('annualPriceMinor', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('discountBasisPoints', false);
    tmp0_serialDesc.gy('paymentDates', false);
    this.p3u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_219).q3u = function (encoder, value) {
    var tmp0_desc = this.p3u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_184().o3u_1;
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.r3u_1 === 12)) {
      tmp1_output.cs(tmp0_desc, 0, value.r3u_1);
    }
    tmp1_output.ds(tmp0_desc, 1, value.s3u_1);
    tmp1_output.hs(tmp0_desc, 2, value.t3u_1);
    tmp1_output.cs(tmp0_desc, 3, value.u3u_1);
    tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.v3u_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_219).on = function (encoder, value) {
    return this.q3u(encoder, value instanceof SubscriptionCommitmentPreviewRequest ? value : THROW_CCE());
  };
  protoOf($serializer_219).pn = function (decoder) {
    var tmp0_desc = this.p3u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = null;
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    var tmp10_cached = Companion_getInstance_184().o3u_1;
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.yq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.yq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.fr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.yq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.yq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.fr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return SubscriptionCommitmentPreviewRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_219).nn = function () {
    return this.p3u_1;
  };
  protoOf($serializer_219).vy = function () {
    var tmp0_cached = Companion_getInstance_184().o3u_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[4]];
  };
  var $serializer_instance_218;
  function $serializer_getInstance_218() {
    if ($serializer_instance_218 == null)
      new $serializer_219();
    return $serializer_instance_218;
  }
  function SubscriptionCommitmentPreviewRequest_init_$Init$(seen0, commitmentMonths, annualPriceMinor, currency, discountBasisPoints, paymentDates, serializationConstructorMarker, $this) {
    if (!(30 === (30 & seen0))) {
      throwMissingFieldException(seen0, 30, $serializer_getInstance_218().p3u_1);
    }
    if (0 === (seen0 & 1))
      $this.r3u_1 = 12;
    else
      $this.r3u_1 = commitmentMonths;
    $this.s3u_1 = annualPriceMinor;
    $this.t3u_1 = currency;
    $this.u3u_1 = discountBasisPoints;
    $this.v3u_1 = paymentDates;
    return $this;
  }
  function SubscriptionCommitmentPreviewRequest_init_$Create$(seen0, commitmentMonths, annualPriceMinor, currency, discountBasisPoints, paymentDates, serializationConstructorMarker) {
    return SubscriptionCommitmentPreviewRequest_init_$Init$(seen0, commitmentMonths, annualPriceMinor, currency, discountBasisPoints, paymentDates, serializationConstructorMarker, objectCreate(protoOf(SubscriptionCommitmentPreviewRequest)));
  }
  function SubscriptionCommitmentPreviewRequest(commitmentMonths, annualPriceMinor, currency, discountBasisPoints, paymentDates) {
    Companion_getInstance_184();
    commitmentMonths = commitmentMonths === VOID ? 12 : commitmentMonths;
    this.r3u_1 = commitmentMonths;
    this.s3u_1 = annualPriceMinor;
    this.t3u_1 = currency;
    this.u3u_1 = discountBasisPoints;
    this.v3u_1 = paymentDates;
  }
  protoOf(SubscriptionCommitmentPreviewRequest).toString = function () {
    return 'SubscriptionCommitmentPreviewRequest(commitmentMonths=' + this.r3u_1 + ', annualPriceMinor=' + this.s3u_1.toString() + ', currency=' + this.t3u_1 + ', discountBasisPoints=' + this.u3u_1 + ', paymentDates=' + toString(this.v3u_1) + ')';
  };
  protoOf(SubscriptionCommitmentPreviewRequest).hashCode = function () {
    var result = this.r3u_1;
    result = imul(result, 31) + this.s3u_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.t3u_1) | 0;
    result = imul(result, 31) + this.u3u_1 | 0;
    result = imul(result, 31) + hashCode(this.v3u_1) | 0;
    return result;
  };
  protoOf(SubscriptionCommitmentPreviewRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionCommitmentPreviewRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionCommitmentPreviewRequest ? other : THROW_CCE();
    if (!(this.r3u_1 === tmp0_other_with_cast.r3u_1))
      return false;
    if (!this.s3u_1.equals(tmp0_other_with_cast.s3u_1))
      return false;
    if (!(this.t3u_1 === tmp0_other_with_cast.t3u_1))
      return false;
    if (!(this.u3u_1 === tmp0_other_with_cast.u3u_1))
      return false;
    if (!equals(this.v3u_1, tmp0_other_with_cast.v3u_1))
      return false;
    return true;
  };
  function Companion_185() {
  }
  var Companion_instance_185;
  function Companion_getInstance_185() {
    return Companion_instance_185;
  }
  function $serializer_220() {
    $serializer_instance_219 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionCommitmentSaveResult', this, 2);
    tmp0_serialDesc.gy('commitment', false);
    tmp0_serialDesc.gy('replayed', true);
    this.w3u_1 = tmp0_serialDesc;
  }
  protoOf($serializer_220).x3u = function (encoder, value) {
    var tmp0_desc = this.w3u_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_223(), value.y3u_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.z3u_1 === false)) {
      tmp1_output.zr(tmp0_desc, 1, value.z3u_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_220).on = function (encoder, value) {
    return this.x3u(encoder, value instanceof SubscriptionCommitmentSaveResult ? value : THROW_CCE());
  };
  protoOf($serializer_220).pn = function (decoder) {
    var tmp0_desc = this.w3u_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_223(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_223(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SubscriptionCommitmentSaveResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_220).nn = function () {
    return this.w3u_1;
  };
  protoOf($serializer_220).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_223(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_219;
  function $serializer_getInstance_219() {
    if ($serializer_instance_219 == null)
      new $serializer_220();
    return $serializer_instance_219;
  }
  function SubscriptionCommitmentSaveResult_init_$Init$(seen0, commitment, replayed, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_219().w3u_1);
    }
    $this.y3u_1 = commitment;
    if (0 === (seen0 & 2))
      $this.z3u_1 = false;
    else
      $this.z3u_1 = replayed;
    return $this;
  }
  function SubscriptionCommitmentSaveResult_init_$Create$(seen0, commitment, replayed, serializationConstructorMarker) {
    return SubscriptionCommitmentSaveResult_init_$Init$(seen0, commitment, replayed, serializationConstructorMarker, objectCreate(protoOf(SubscriptionCommitmentSaveResult)));
  }
  function SubscriptionCommitmentSaveResult(commitment, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.y3u_1 = commitment;
    this.z3u_1 = replayed;
  }
  protoOf(SubscriptionCommitmentSaveResult).toString = function () {
    return 'SubscriptionCommitmentSaveResult(commitment=' + this.y3u_1.toString() + ', replayed=' + this.z3u_1 + ')';
  };
  protoOf(SubscriptionCommitmentSaveResult).hashCode = function () {
    var result = this.y3u_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.z3u_1) | 0;
    return result;
  };
  protoOf(SubscriptionCommitmentSaveResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionCommitmentSaveResult))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionCommitmentSaveResult ? other : THROW_CCE();
    if (!this.y3u_1.equals(tmp0_other_with_cast.y3u_1))
      return false;
    if (!(this.z3u_1 === tmp0_other_with_cast.z3u_1))
      return false;
    return true;
  };
  function Companion_186() {
  }
  var Companion_instance_186;
  function Companion_getInstance_186() {
    return Companion_instance_186;
  }
  function $serializer_221() {
    $serializer_instance_220 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SaveSubscriptionCommitmentRequest', this, 3);
    tmp0_serialDesc.gy('previewId', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('expectedVersion', false);
    this.a3v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_221).b3v = function (encoder, value) {
    var tmp0_desc = this.a3v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.c3v_1);
    tmp1_output.hs(tmp0_desc, 1, value.d3v_1);
    tmp1_output.ds(tmp0_desc, 2, value.e3v_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_221).on = function (encoder, value) {
    return this.b3v(encoder, value instanceof SaveSubscriptionCommitmentRequest ? value : THROW_CCE());
  };
  protoOf($serializer_221).pn = function (decoder) {
    var tmp0_desc = this.a3v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return SaveSubscriptionCommitmentRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_221).nn = function () {
    return this.a3v_1;
  };
  protoOf($serializer_221).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_220;
  function $serializer_getInstance_220() {
    if ($serializer_instance_220 == null)
      new $serializer_221();
    return $serializer_instance_220;
  }
  function SaveSubscriptionCommitmentRequest_init_$Init$(seen0, previewId, reason, expectedVersion, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_220().a3v_1);
    }
    $this.c3v_1 = previewId;
    $this.d3v_1 = reason;
    $this.e3v_1 = expectedVersion;
    return $this;
  }
  function SaveSubscriptionCommitmentRequest_init_$Create$(seen0, previewId, reason, expectedVersion, serializationConstructorMarker) {
    return SaveSubscriptionCommitmentRequest_init_$Init$(seen0, previewId, reason, expectedVersion, serializationConstructorMarker, objectCreate(protoOf(SaveSubscriptionCommitmentRequest)));
  }
  function SaveSubscriptionCommitmentRequest(previewId, reason, expectedVersion) {
    this.c3v_1 = previewId;
    this.d3v_1 = reason;
    this.e3v_1 = expectedVersion;
  }
  protoOf(SaveSubscriptionCommitmentRequest).toString = function () {
    return 'SaveSubscriptionCommitmentRequest(previewId=' + this.c3v_1 + ', reason=' + this.d3v_1 + ', expectedVersion=' + this.e3v_1.toString() + ')';
  };
  protoOf(SaveSubscriptionCommitmentRequest).hashCode = function () {
    var result = getStringHashCode(this.c3v_1);
    result = imul(result, 31) + getStringHashCode(this.d3v_1) | 0;
    result = imul(result, 31) + this.e3v_1.hashCode() | 0;
    return result;
  };
  protoOf(SaveSubscriptionCommitmentRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SaveSubscriptionCommitmentRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SaveSubscriptionCommitmentRequest ? other : THROW_CCE();
    if (!(this.c3v_1 === tmp0_other_with_cast.c3v_1))
      return false;
    if (!(this.d3v_1 === tmp0_other_with_cast.d3v_1))
      return false;
    if (!this.e3v_1.equals(tmp0_other_with_cast.e3v_1))
      return false;
    return true;
  };
  function $serializer_222() {
    $serializer_instance_221 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionCommitmentInstallment', this, 3);
    tmp0_serialDesc.gy('sequence', false);
    tmp0_serialDesc.gy('dueDate', false);
    tmp0_serialDesc.gy('amountMinor', false);
    this.f3v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_222).g3v = function (encoder, value) {
    var tmp0_desc = this.f3v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.cs(tmp0_desc, 0, value.h3v_1);
    tmp1_output.hs(tmp0_desc, 1, value.i3v_1);
    tmp1_output.ds(tmp0_desc, 2, value.j3v_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_222).on = function (encoder, value) {
    return this.g3v(encoder, value instanceof SubscriptionCommitmentInstallment ? value : THROW_CCE());
  };
  protoOf($serializer_222).pn = function (decoder) {
    var tmp0_desc = this.f3v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = 0;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.yq(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.yq(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return SubscriptionCommitmentInstallment_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_222).nn = function () {
    return this.f3v_1;
  };
  protoOf($serializer_222).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [IntSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_221;
  function $serializer_getInstance_221() {
    if ($serializer_instance_221 == null)
      new $serializer_222();
    return $serializer_instance_221;
  }
  function SubscriptionCommitmentInstallment_init_$Init$(seen0, sequence, dueDate, amountMinor, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_221().f3v_1);
    }
    $this.h3v_1 = sequence;
    $this.i3v_1 = dueDate;
    $this.j3v_1 = amountMinor;
    return $this;
  }
  function SubscriptionCommitmentInstallment_init_$Create$(seen0, sequence, dueDate, amountMinor, serializationConstructorMarker) {
    return SubscriptionCommitmentInstallment_init_$Init$(seen0, sequence, dueDate, amountMinor, serializationConstructorMarker, objectCreate(protoOf(SubscriptionCommitmentInstallment)));
  }
  function SubscriptionCommitmentInstallment() {
  }
  protoOf(SubscriptionCommitmentInstallment).toString = function () {
    return 'SubscriptionCommitmentInstallment(sequence=' + this.h3v_1 + ', dueDate=' + this.i3v_1 + ', amountMinor=' + this.j3v_1.toString() + ')';
  };
  protoOf(SubscriptionCommitmentInstallment).hashCode = function () {
    var result = this.h3v_1;
    result = imul(result, 31) + getStringHashCode(this.i3v_1) | 0;
    result = imul(result, 31) + this.j3v_1.hashCode() | 0;
    return result;
  };
  protoOf(SubscriptionCommitmentInstallment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionCommitmentInstallment))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionCommitmentInstallment ? other : THROW_CCE();
    if (!(this.h3v_1 === tmp0_other_with_cast.h3v_1))
      return false;
    if (!(this.i3v_1 === tmp0_other_with_cast.i3v_1))
      return false;
    if (!this.j3v_1.equals(tmp0_other_with_cast.j3v_1))
      return false;
    return true;
  };
  function $serializer_223() {
    $serializer_instance_222 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionUsageLine', this, 7);
    tmp0_serialDesc.gy('limitKey', false);
    tmp0_serialDesc.gy('nameEn', false);
    tmp0_serialDesc.gy('nameAr', false);
    tmp0_serialDesc.gy('grant', false);
    tmp0_serialDesc.gy('value', true);
    tmp0_serialDesc.gy('period', false);
    tmp0_serialDesc.gy('policy', true);
    this.k3v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_223).l3v = function (encoder, value) {
    var tmp0_desc = this.k3v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.m3v_1);
    tmp1_output.hs(tmp0_desc, 1, value.n3v_1);
    tmp1_output.hs(tmp0_desc, 2, value.o3v_1);
    tmp1_output.hs(tmp0_desc, 3, value.p3v_1);
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !(value.q3v_1 == null)) {
      tmp1_output.ls(tmp0_desc, 4, LongSerializer_getInstance(), value.q3v_1);
    }
    tmp1_output.hs(tmp0_desc, 5, value.r3v_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.s3v_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.s3v_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_223).on = function (encoder, value) {
    return this.l3v(encoder, value instanceof SubscriptionUsageLine ? value : THROW_CCE());
  };
  protoOf($serializer_223).pn = function (decoder) {
    var tmp0_desc = this.k3v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.hr(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return SubscriptionUsageLine_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_223).nn = function () {
    return this.k3v_1;
  };
  protoOf($serializer_223).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_222;
  function $serializer_getInstance_222() {
    if ($serializer_instance_222 == null)
      new $serializer_223();
    return $serializer_instance_222;
  }
  function SubscriptionUsageLine_init_$Init$(seen0, limitKey, nameEn, nameAr, grant, value, period, policy, serializationConstructorMarker, $this) {
    if (!(47 === (47 & seen0))) {
      throwMissingFieldException(seen0, 47, $serializer_getInstance_222().k3v_1);
    }
    $this.m3v_1 = limitKey;
    $this.n3v_1 = nameEn;
    $this.o3v_1 = nameAr;
    $this.p3v_1 = grant;
    if (0 === (seen0 & 16))
      $this.q3v_1 = null;
    else
      $this.q3v_1 = value;
    $this.r3v_1 = period;
    if (0 === (seen0 & 64))
      $this.s3v_1 = null;
    else
      $this.s3v_1 = policy;
    return $this;
  }
  function SubscriptionUsageLine_init_$Create$(seen0, limitKey, nameEn, nameAr, grant, value, period, policy, serializationConstructorMarker) {
    return SubscriptionUsageLine_init_$Init$(seen0, limitKey, nameEn, nameAr, grant, value, period, policy, serializationConstructorMarker, objectCreate(protoOf(SubscriptionUsageLine)));
  }
  function SubscriptionUsageLine() {
  }
  protoOf(SubscriptionUsageLine).toString = function () {
    return 'SubscriptionUsageLine(limitKey=' + this.m3v_1 + ', nameEn=' + this.n3v_1 + ', nameAr=' + this.o3v_1 + ', grant=' + this.p3v_1 + ', value=' + toString_0(this.q3v_1) + ', period=' + this.r3v_1 + ', policy=' + this.s3v_1 + ')';
  };
  protoOf(SubscriptionUsageLine).hashCode = function () {
    var result = getStringHashCode(this.m3v_1);
    result = imul(result, 31) + getStringHashCode(this.n3v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.o3v_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.p3v_1) | 0;
    result = imul(result, 31) + (this.q3v_1 == null ? 0 : this.q3v_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.r3v_1) | 0;
    result = imul(result, 31) + (this.s3v_1 == null ? 0 : getStringHashCode(this.s3v_1)) | 0;
    return result;
  };
  protoOf(SubscriptionUsageLine).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionUsageLine))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionUsageLine ? other : THROW_CCE();
    if (!(this.m3v_1 === tmp0_other_with_cast.m3v_1))
      return false;
    if (!(this.n3v_1 === tmp0_other_with_cast.n3v_1))
      return false;
    if (!(this.o3v_1 === tmp0_other_with_cast.o3v_1))
      return false;
    if (!(this.p3v_1 === tmp0_other_with_cast.p3v_1))
      return false;
    if (!equals(this.q3v_1, tmp0_other_with_cast.q3v_1))
      return false;
    if (!(this.r3v_1 === tmp0_other_with_cast.r3v_1))
      return false;
    if (!(this.s3v_1 == tmp0_other_with_cast.s3v_1))
      return false;
    return true;
  };
  function Companion_187() {
    Companion_instance_187 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t3v_1 = [null, null, null, null, null, null, null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_221()), null, null, null];
  }
  var Companion_instance_187;
  function Companion_getInstance_187() {
    if (Companion_instance_187 == null)
      new Companion_187();
    return Companion_instance_187;
  }
  function $serializer_224() {
    $serializer_instance_223 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionCommitmentView', this, 16);
    tmp0_serialDesc.gy('subscriptionId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('version', false);
    tmp0_serialDesc.gy('commitmentMonths', false);
    tmp0_serialDesc.gy('paymentCadence', false);
    tmp0_serialDesc.gy('currency', false);
    tmp0_serialDesc.gy('listAnnualMinor', false);
    tmp0_serialDesc.gy('discountBasisPoints', false);
    tmp0_serialDesc.gy('discountMinor', false);
    tmp0_serialDesc.gy('committedAnnualMinor', false);
    tmp0_serialDesc.gy('monthlyEquivalentMinor', false);
    tmp0_serialDesc.gy('monthlyEquivalentRemainderMinor', false);
    tmp0_serialDesc.gy('installments', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('savedByOperatorId', false);
    tmp0_serialDesc.gy('savedAtMs', false);
    this.u3v_1 = tmp0_serialDesc;
  }
  protoOf($serializer_224).v3v = function (encoder, value) {
    var tmp0_desc = this.u3v_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_187().t3v_1;
    tmp1_output.hs(tmp0_desc, 0, value.w3v_1);
    tmp1_output.hs(tmp0_desc, 1, value.x3v_1);
    tmp1_output.ds(tmp0_desc, 2, value.y3v_1);
    tmp1_output.cs(tmp0_desc, 3, value.z3v_1);
    tmp1_output.hs(tmp0_desc, 4, value.a3w_1);
    tmp1_output.hs(tmp0_desc, 5, value.b3w_1);
    tmp1_output.ds(tmp0_desc, 6, value.c3w_1);
    tmp1_output.cs(tmp0_desc, 7, value.d3w_1);
    tmp1_output.ds(tmp0_desc, 8, value.e3w_1);
    tmp1_output.ds(tmp0_desc, 9, value.f3w_1);
    tmp1_output.ds(tmp0_desc, 10, value.g3w_1);
    tmp1_output.ds(tmp0_desc, 11, value.h3w_1);
    tmp1_output.js(tmp0_desc, 12, tmp2_cached[12], value.i3w_1);
    tmp1_output.hs(tmp0_desc, 13, value.j3w_1);
    tmp1_output.hs(tmp0_desc, 14, value.k3w_1);
    tmp1_output.ds(tmp0_desc, 15, value.l3w_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_224).on = function (encoder, value) {
    return this.v3v(encoder, value instanceof SubscriptionCommitmentView ? value : THROW_CCE());
  };
  protoOf($serializer_224).pn = function (decoder) {
    var tmp0_desc = this.u3v_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = 0;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = new Long(0, 0);
    var tmp11_local7 = 0;
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = new Long(0, 0);
    var tmp14_local10 = new Long(0, 0);
    var tmp15_local11 = new Long(0, 0);
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = new Long(0, 0);
    var tmp20_input = decoder.tq(tmp0_desc);
    var tmp21_cached = Companion_getInstance_187().t3v_1;
    if (tmp20_input.ir()) {
      tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp20_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp20_input.yq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp20_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp20_input.zq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp20_input.yq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp20_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp20_input.zq(tmp0_desc, 9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp20_input.zq(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp20_input.zq(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp20_input.fr(tmp0_desc, 12, tmp21_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp20_input.dr(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp20_input.dr(tmp0_desc, 14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp20_input.zq(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp20_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp20_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp20_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp20_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp20_input.yq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp20_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp20_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp20_input.zq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp20_input.yq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp20_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp20_input.zq(tmp0_desc, 9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp20_input.zq(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp20_input.zq(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp20_input.fr(tmp0_desc, 12, tmp21_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp20_input.dr(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp20_input.dr(tmp0_desc, 14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp20_input.zq(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp20_input.uq(tmp0_desc);
    return SubscriptionCommitmentView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, null);
  };
  protoOf($serializer_224).nn = function () {
    return this.u3v_1;
  };
  protoOf($serializer_224).vy = function () {
    var tmp0_cached = Companion_getInstance_187().t3v_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), IntSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), tmp0_cached[12], StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_223;
  function $serializer_getInstance_223() {
    if ($serializer_instance_223 == null)
      new $serializer_224();
    return $serializer_instance_223;
  }
  function SubscriptionCommitmentView_init_$Init$(seen0, subscriptionId, tenantId, version, commitmentMonths, paymentCadence, currency, listAnnualMinor, discountBasisPoints, discountMinor, committedAnnualMinor, monthlyEquivalentMinor, monthlyEquivalentRemainderMinor, installments, reason, savedByOperatorId, savedAtMs, serializationConstructorMarker, $this) {
    if (!(65535 === (65535 & seen0))) {
      throwMissingFieldException(seen0, 65535, $serializer_getInstance_223().u3v_1);
    }
    $this.w3v_1 = subscriptionId;
    $this.x3v_1 = tenantId;
    $this.y3v_1 = version;
    $this.z3v_1 = commitmentMonths;
    $this.a3w_1 = paymentCadence;
    $this.b3w_1 = currency;
    $this.c3w_1 = listAnnualMinor;
    $this.d3w_1 = discountBasisPoints;
    $this.e3w_1 = discountMinor;
    $this.f3w_1 = committedAnnualMinor;
    $this.g3w_1 = monthlyEquivalentMinor;
    $this.h3w_1 = monthlyEquivalentRemainderMinor;
    $this.i3w_1 = installments;
    $this.j3w_1 = reason;
    $this.k3w_1 = savedByOperatorId;
    $this.l3w_1 = savedAtMs;
    return $this;
  }
  function SubscriptionCommitmentView_init_$Create$(seen0, subscriptionId, tenantId, version, commitmentMonths, paymentCadence, currency, listAnnualMinor, discountBasisPoints, discountMinor, committedAnnualMinor, monthlyEquivalentMinor, monthlyEquivalentRemainderMinor, installments, reason, savedByOperatorId, savedAtMs, serializationConstructorMarker) {
    return SubscriptionCommitmentView_init_$Init$(seen0, subscriptionId, tenantId, version, commitmentMonths, paymentCadence, currency, listAnnualMinor, discountBasisPoints, discountMinor, committedAnnualMinor, monthlyEquivalentMinor, monthlyEquivalentRemainderMinor, installments, reason, savedByOperatorId, savedAtMs, serializationConstructorMarker, objectCreate(protoOf(SubscriptionCommitmentView)));
  }
  function SubscriptionCommitmentView() {
  }
  protoOf(SubscriptionCommitmentView).toString = function () {
    return 'SubscriptionCommitmentView(subscriptionId=' + this.w3v_1 + ', tenantId=' + this.x3v_1 + ', version=' + this.y3v_1.toString() + ', commitmentMonths=' + this.z3v_1 + ', paymentCadence=' + this.a3w_1 + ', currency=' + this.b3w_1 + ', listAnnualMinor=' + this.c3w_1.toString() + ', discountBasisPoints=' + this.d3w_1 + ', discountMinor=' + this.e3w_1.toString() + ', committedAnnualMinor=' + this.f3w_1.toString() + ', monthlyEquivalentMinor=' + this.g3w_1.toString() + ', monthlyEquivalentRemainderMinor=' + this.h3w_1.toString() + ', installments=' + toString(this.i3w_1) + ', reason=' + this.j3w_1 + ', savedByOperatorId=' + this.k3w_1 + ', savedAtMs=' + this.l3w_1.toString() + ')';
  };
  protoOf(SubscriptionCommitmentView).hashCode = function () {
    var result = getStringHashCode(this.w3v_1);
    result = imul(result, 31) + getStringHashCode(this.x3v_1) | 0;
    result = imul(result, 31) + this.y3v_1.hashCode() | 0;
    result = imul(result, 31) + this.z3v_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.a3w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b3w_1) | 0;
    result = imul(result, 31) + this.c3w_1.hashCode() | 0;
    result = imul(result, 31) + this.d3w_1 | 0;
    result = imul(result, 31) + this.e3w_1.hashCode() | 0;
    result = imul(result, 31) + this.f3w_1.hashCode() | 0;
    result = imul(result, 31) + this.g3w_1.hashCode() | 0;
    result = imul(result, 31) + this.h3w_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.i3w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j3w_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k3w_1) | 0;
    result = imul(result, 31) + this.l3w_1.hashCode() | 0;
    return result;
  };
  protoOf(SubscriptionCommitmentView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionCommitmentView))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionCommitmentView ? other : THROW_CCE();
    if (!(this.w3v_1 === tmp0_other_with_cast.w3v_1))
      return false;
    if (!(this.x3v_1 === tmp0_other_with_cast.x3v_1))
      return false;
    if (!this.y3v_1.equals(tmp0_other_with_cast.y3v_1))
      return false;
    if (!(this.z3v_1 === tmp0_other_with_cast.z3v_1))
      return false;
    if (!(this.a3w_1 === tmp0_other_with_cast.a3w_1))
      return false;
    if (!(this.b3w_1 === tmp0_other_with_cast.b3w_1))
      return false;
    if (!this.c3w_1.equals(tmp0_other_with_cast.c3w_1))
      return false;
    if (!(this.d3w_1 === tmp0_other_with_cast.d3w_1))
      return false;
    if (!this.e3w_1.equals(tmp0_other_with_cast.e3w_1))
      return false;
    if (!this.f3w_1.equals(tmp0_other_with_cast.f3w_1))
      return false;
    if (!this.g3w_1.equals(tmp0_other_with_cast.g3w_1))
      return false;
    if (!this.h3w_1.equals(tmp0_other_with_cast.h3w_1))
      return false;
    if (!equals(this.i3w_1, tmp0_other_with_cast.i3w_1))
      return false;
    if (!(this.j3w_1 === tmp0_other_with_cast.j3w_1))
      return false;
    if (!(this.k3w_1 === tmp0_other_with_cast.k3w_1))
      return false;
    if (!this.l3w_1.equals(tmp0_other_with_cast.l3w_1))
      return false;
    return true;
  };
  function Companion_188() {
  }
  var Companion_instance_188;
  function Companion_getInstance_188() {
    return Companion_instance_188;
  }
  function $serializer_225() {
    $serializer_instance_224 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SupportVisitPreparationView', this, 7);
    tmp0_serialDesc.gy('visit', false);
    tmp0_serialDesc.gy('tenantHost', false);
    tmp0_serialDesc.gy('handoffCode', false);
    tmp0_serialDesc.gy('handoffExpiresAtMs', false);
    tmp0_serialDesc.gy('alreadyIssued', false);
    tmp0_serialDesc.gy('entryReady', true);
    tmp0_serialDesc.gy('entryUrl', true);
    this.m3w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_225).n3w = function (encoder, value) {
    var tmp0_desc = this.m3w_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_226(), value.o3w_1);
    tmp1_output.hs(tmp0_desc, 1, value.p3w_1);
    tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.q3w_1);
    tmp1_output.ls(tmp0_desc, 3, LongSerializer_getInstance(), value.r3w_1);
    tmp1_output.zr(tmp0_desc, 4, value.s3w_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.t3w_1 === false)) {
      tmp1_output.zr(tmp0_desc, 5, value.t3w_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.u3w_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, StringSerializer_getInstance(), value.u3w_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_225).on = function (encoder, value) {
    return this.n3w(encoder, value instanceof SupportVisitPreparationView ? value : THROW_CCE());
  };
  protoOf($serializer_225).pn = function (decoder) {
    var tmp0_desc = this.m3w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_local5 = false;
    var tmp10_local6 = null;
    var tmp11_input = decoder.tq(tmp0_desc);
    if (tmp11_input.ir()) {
      tmp4_local0 = tmp11_input.fr(tmp0_desc, 0, $serializer_getInstance_226(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.vq(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.fr(tmp0_desc, 0, $serializer_getInstance_226(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.hr(tmp0_desc, 3, LongSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.vq(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.hr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.uq(tmp0_desc);
    return SupportVisitPreparationView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_225).nn = function () {
    return this.m3w_1;
  };
  protoOf($serializer_225).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_226(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_224;
  function $serializer_getInstance_224() {
    if ($serializer_instance_224 == null)
      new $serializer_225();
    return $serializer_instance_224;
  }
  function SupportVisitPreparationView_init_$Init$(seen0, visit, tenantHost, handoffCode, handoffExpiresAtMs, alreadyIssued, entryReady, entryUrl, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_224().m3w_1);
    }
    $this.o3w_1 = visit;
    $this.p3w_1 = tenantHost;
    $this.q3w_1 = handoffCode;
    $this.r3w_1 = handoffExpiresAtMs;
    $this.s3w_1 = alreadyIssued;
    if (0 === (seen0 & 32))
      $this.t3w_1 = false;
    else
      $this.t3w_1 = entryReady;
    if (0 === (seen0 & 64))
      $this.u3w_1 = null;
    else
      $this.u3w_1 = entryUrl;
    return $this;
  }
  function SupportVisitPreparationView_init_$Create$(seen0, visit, tenantHost, handoffCode, handoffExpiresAtMs, alreadyIssued, entryReady, entryUrl, serializationConstructorMarker) {
    return SupportVisitPreparationView_init_$Init$(seen0, visit, tenantHost, handoffCode, handoffExpiresAtMs, alreadyIssued, entryReady, entryUrl, serializationConstructorMarker, objectCreate(protoOf(SupportVisitPreparationView)));
  }
  function SupportVisitPreparationView(visit, tenantHost, handoffCode, handoffExpiresAtMs, alreadyIssued, entryReady, entryUrl) {
    entryReady = entryReady === VOID ? false : entryReady;
    entryUrl = entryUrl === VOID ? null : entryUrl;
    this.o3w_1 = visit;
    this.p3w_1 = tenantHost;
    this.q3w_1 = handoffCode;
    this.r3w_1 = handoffExpiresAtMs;
    this.s3w_1 = alreadyIssued;
    this.t3w_1 = entryReady;
    this.u3w_1 = entryUrl;
  }
  protoOf(SupportVisitPreparationView).toString = function () {
    return 'SupportVisitPreparationView(visit=' + this.o3w_1.toString() + ', tenantHost=' + this.p3w_1 + ', handoffCode=' + this.q3w_1 + ', handoffExpiresAtMs=' + toString_0(this.r3w_1) + ', alreadyIssued=' + this.s3w_1 + ', entryReady=' + this.t3w_1 + ', entryUrl=' + this.u3w_1 + ')';
  };
  protoOf(SupportVisitPreparationView).hashCode = function () {
    var result = this.o3w_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.p3w_1) | 0;
    result = imul(result, 31) + (this.q3w_1 == null ? 0 : getStringHashCode(this.q3w_1)) | 0;
    result = imul(result, 31) + (this.r3w_1 == null ? 0 : this.r3w_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s3w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.t3w_1) | 0;
    result = imul(result, 31) + (this.u3w_1 == null ? 0 : getStringHashCode(this.u3w_1)) | 0;
    return result;
  };
  protoOf(SupportVisitPreparationView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SupportVisitPreparationView))
      return false;
    var tmp0_other_with_cast = other instanceof SupportVisitPreparationView ? other : THROW_CCE();
    if (!this.o3w_1.equals(tmp0_other_with_cast.o3w_1))
      return false;
    if (!(this.p3w_1 === tmp0_other_with_cast.p3w_1))
      return false;
    if (!(this.q3w_1 == tmp0_other_with_cast.q3w_1))
      return false;
    if (!equals(this.r3w_1, tmp0_other_with_cast.r3w_1))
      return false;
    if (!(this.s3w_1 === tmp0_other_with_cast.s3w_1))
      return false;
    if (!(this.t3w_1 === tmp0_other_with_cast.t3w_1))
      return false;
    if (!(this.u3w_1 == tmp0_other_with_cast.u3w_1))
      return false;
    return true;
  };
  function Companion_189() {
  }
  var Companion_instance_189;
  function Companion_getInstance_189() {
    return Companion_instance_189;
  }
  function $serializer_226() {
    $serializer_instance_225 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SupportVisitOpenRequest', this, 2);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('minutes', true);
    this.v3w_1 = tmp0_serialDesc;
  }
  protoOf($serializer_226).w3w = function (encoder, value) {
    var tmp0_desc = this.v3w_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.x3w_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.y3w_1 === 60)) {
      tmp1_output.cs(tmp0_desc, 1, value.y3w_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_226).on = function (encoder, value) {
    return this.w3w(encoder, value instanceof SupportVisitOpenRequest ? value : THROW_CCE());
  };
  protoOf($serializer_226).pn = function (decoder) {
    var tmp0_desc = this.v3w_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = 0;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.yq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.yq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SupportVisitOpenRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_226).nn = function () {
    return this.v3w_1;
  };
  protoOf($serializer_226).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), IntSerializer_getInstance()];
  };
  var $serializer_instance_225;
  function $serializer_getInstance_225() {
    if ($serializer_instance_225 == null)
      new $serializer_226();
    return $serializer_instance_225;
  }
  function SupportVisitOpenRequest_init_$Init$(seen0, reason, minutes, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_225().v3w_1);
    }
    $this.x3w_1 = reason;
    if (0 === (seen0 & 2))
      $this.y3w_1 = 60;
    else
      $this.y3w_1 = minutes;
    return $this;
  }
  function SupportVisitOpenRequest_init_$Create$(seen0, reason, minutes, serializationConstructorMarker) {
    return SupportVisitOpenRequest_init_$Init$(seen0, reason, minutes, serializationConstructorMarker, objectCreate(protoOf(SupportVisitOpenRequest)));
  }
  function SupportVisitOpenRequest(reason, minutes) {
    minutes = minutes === VOID ? 60 : minutes;
    this.x3w_1 = reason;
    this.y3w_1 = minutes;
  }
  protoOf(SupportVisitOpenRequest).toString = function () {
    return 'SupportVisitOpenRequest(reason=' + this.x3w_1 + ', minutes=' + this.y3w_1 + ')';
  };
  protoOf(SupportVisitOpenRequest).hashCode = function () {
    var result = getStringHashCode(this.x3w_1);
    result = imul(result, 31) + this.y3w_1 | 0;
    return result;
  };
  protoOf(SupportVisitOpenRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SupportVisitOpenRequest))
      return false;
    var tmp0_other_with_cast = other instanceof SupportVisitOpenRequest ? other : THROW_CCE();
    if (!(this.x3w_1 === tmp0_other_with_cast.x3w_1))
      return false;
    if (!(this.y3w_1 === tmp0_other_with_cast.y3w_1))
      return false;
    return true;
  };
  function ConsoleSupportVisitPaths() {
    this.z3w_1 = '/api/console/support-visits';
  }
  protoOf(ConsoleSupportVisitPaths).a3x = function (tenantId) {
    return removeSuffix(ConsoleApiPaths_instance.h1z(tenantId), 'support-session') + 'support-visit';
  };
  var ConsoleSupportVisitPaths_instance;
  function ConsoleSupportVisitPaths_getInstance() {
    return ConsoleSupportVisitPaths_instance;
  }
  function Companion_190() {
  }
  var Companion_instance_190;
  function Companion_getInstance_190() {
    return Companion_instance_190;
  }
  function $serializer_227() {
    $serializer_instance_226 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SupportVisitView', this, 12);
    tmp0_serialDesc.gy('visitId', false);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('operatorId', false);
    tmp0_serialDesc.gy('tenantNameEn', false);
    tmp0_serialDesc.gy('tenantNameAr', false);
    tmp0_serialDesc.gy('operatorName', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('grantedAtMs', false);
    tmp0_serialDesc.gy('expiresAtMs', false);
    tmp0_serialDesc.gy('endedAtMs', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('readOnly', false);
    this.b3x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_227).c3x = function (encoder, value) {
    var tmp0_desc = this.b3x_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.d3x_1);
    tmp1_output.hs(tmp0_desc, 1, value.e3x_1);
    tmp1_output.hs(tmp0_desc, 2, value.f3x_1);
    tmp1_output.hs(tmp0_desc, 3, value.g3x_1);
    tmp1_output.hs(tmp0_desc, 4, value.h3x_1);
    tmp1_output.hs(tmp0_desc, 5, value.i3x_1);
    tmp1_output.hs(tmp0_desc, 6, value.j3x_1);
    tmp1_output.ds(tmp0_desc, 7, value.k3x_1);
    tmp1_output.ds(tmp0_desc, 8, value.l3x_1);
    tmp1_output.ls(tmp0_desc, 9, LongSerializer_getInstance(), value.m3x_1);
    tmp1_output.hs(tmp0_desc, 10, value.n3x_1);
    tmp1_output.zr(tmp0_desc, 11, value.o3x_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_227).on = function (encoder, value) {
    return this.c3x(encoder, value instanceof SupportVisitView ? value : THROW_CCE());
  };
  protoOf($serializer_227).pn = function (decoder) {
    var tmp0_desc = this.b3x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = new Long(0, 0);
    var tmp12_local8 = new Long(0, 0);
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = false;
    var tmp16_input = decoder.tq(tmp0_desc);
    if (tmp16_input.ir()) {
      tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp16_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp16_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp16_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp16_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp16_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp16_input.dr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp16_input.zq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp16_input.zq(tmp0_desc, 8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp16_input.hr(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp16_input.dr(tmp0_desc, 10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp16_input.vq(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp16_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp16_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp16_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp16_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp16_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp16_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp16_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp16_input.dr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp16_input.zq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp16_input.zq(tmp0_desc, 8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp16_input.hr(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp16_input.dr(tmp0_desc, 10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp16_input.vq(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp16_input.uq(tmp0_desc);
    return SupportVisitView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, null);
  };
  protoOf($serializer_227).nn = function () {
    return this.b3x_1;
  };
  protoOf($serializer_227).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), LongSerializer_getInstance(), LongSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_226;
  function $serializer_getInstance_226() {
    if ($serializer_instance_226 == null)
      new $serializer_227();
    return $serializer_instance_226;
  }
  function SupportVisitView_init_$Init$(seen0, visitId, tenantId, operatorId, tenantNameEn, tenantNameAr, operatorName, reason, grantedAtMs, expiresAtMs, endedAtMs, state, readOnly, serializationConstructorMarker, $this) {
    if (!(4095 === (4095 & seen0))) {
      throwMissingFieldException(seen0, 4095, $serializer_getInstance_226().b3x_1);
    }
    $this.d3x_1 = visitId;
    $this.e3x_1 = tenantId;
    $this.f3x_1 = operatorId;
    $this.g3x_1 = tenantNameEn;
    $this.h3x_1 = tenantNameAr;
    $this.i3x_1 = operatorName;
    $this.j3x_1 = reason;
    $this.k3x_1 = grantedAtMs;
    $this.l3x_1 = expiresAtMs;
    $this.m3x_1 = endedAtMs;
    $this.n3x_1 = state;
    $this.o3x_1 = readOnly;
    return $this;
  }
  function SupportVisitView_init_$Create$(seen0, visitId, tenantId, operatorId, tenantNameEn, tenantNameAr, operatorName, reason, grantedAtMs, expiresAtMs, endedAtMs, state, readOnly, serializationConstructorMarker) {
    return SupportVisitView_init_$Init$(seen0, visitId, tenantId, operatorId, tenantNameEn, tenantNameAr, operatorName, reason, grantedAtMs, expiresAtMs, endedAtMs, state, readOnly, serializationConstructorMarker, objectCreate(protoOf(SupportVisitView)));
  }
  function SupportVisitView(visitId, tenantId, operatorId, tenantNameEn, tenantNameAr, operatorName, reason, grantedAtMs, expiresAtMs, endedAtMs, state, readOnly) {
    this.d3x_1 = visitId;
    this.e3x_1 = tenantId;
    this.f3x_1 = operatorId;
    this.g3x_1 = tenantNameEn;
    this.h3x_1 = tenantNameAr;
    this.i3x_1 = operatorName;
    this.j3x_1 = reason;
    this.k3x_1 = grantedAtMs;
    this.l3x_1 = expiresAtMs;
    this.m3x_1 = endedAtMs;
    this.n3x_1 = state;
    this.o3x_1 = readOnly;
  }
  protoOf(SupportVisitView).toString = function () {
    return 'SupportVisitView(visitId=' + this.d3x_1 + ', tenantId=' + this.e3x_1 + ', operatorId=' + this.f3x_1 + ', tenantNameEn=' + this.g3x_1 + ', tenantNameAr=' + this.h3x_1 + ', operatorName=' + this.i3x_1 + ', reason=' + this.j3x_1 + ', grantedAtMs=' + this.k3x_1.toString() + ', expiresAtMs=' + this.l3x_1.toString() + ', endedAtMs=' + toString_0(this.m3x_1) + ', state=' + this.n3x_1 + ', readOnly=' + this.o3x_1 + ')';
  };
  protoOf(SupportVisitView).hashCode = function () {
    var result = getStringHashCode(this.d3x_1);
    result = imul(result, 31) + getStringHashCode(this.e3x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f3x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.g3x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h3x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.i3x_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.j3x_1) | 0;
    result = imul(result, 31) + this.k3x_1.hashCode() | 0;
    result = imul(result, 31) + this.l3x_1.hashCode() | 0;
    result = imul(result, 31) + (this.m3x_1 == null ? 0 : this.m3x_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.n3x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o3x_1) | 0;
    return result;
  };
  protoOf(SupportVisitView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SupportVisitView))
      return false;
    var tmp0_other_with_cast = other instanceof SupportVisitView ? other : THROW_CCE();
    if (!(this.d3x_1 === tmp0_other_with_cast.d3x_1))
      return false;
    if (!(this.e3x_1 === tmp0_other_with_cast.e3x_1))
      return false;
    if (!(this.f3x_1 === tmp0_other_with_cast.f3x_1))
      return false;
    if (!(this.g3x_1 === tmp0_other_with_cast.g3x_1))
      return false;
    if (!(this.h3x_1 === tmp0_other_with_cast.h3x_1))
      return false;
    if (!(this.i3x_1 === tmp0_other_with_cast.i3x_1))
      return false;
    if (!(this.j3x_1 === tmp0_other_with_cast.j3x_1))
      return false;
    if (!this.k3x_1.equals(tmp0_other_with_cast.k3x_1))
      return false;
    if (!this.l3x_1.equals(tmp0_other_with_cast.l3x_1))
      return false;
    if (!equals(this.m3x_1, tmp0_other_with_cast.m3x_1))
      return false;
    if (!(this.n3x_1 === tmp0_other_with_cast.n3x_1))
      return false;
    if (!(this.o3x_1 === tmp0_other_with_cast.o3x_1))
      return false;
    return true;
  };
  function Companion_191() {
    Companion_instance_191 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p3x_1 = [new ArrayListSerializer($serializer_getInstance_226()), null];
  }
  var Companion_instance_191;
  function Companion_getInstance_191() {
    if (Companion_instance_191 == null)
      new Companion_191();
    return Companion_instance_191;
  }
  function $serializer_228() {
    $serializer_instance_227 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SupportVisitHistoryView', this, 2);
    tmp0_serialDesc.gy('visits', false);
    tmp0_serialDesc.gy('entryReady', true);
    this.q3x_1 = tmp0_serialDesc;
  }
  protoOf($serializer_228).r3x = function (encoder, value) {
    var tmp0_desc = this.q3x_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_191().p3x_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.s3x_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.t3x_1 === true)) {
      tmp1_output.zr(tmp0_desc, 1, value.t3x_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_228).on = function (encoder, value) {
    return this.r3x(encoder, value instanceof SupportVisitHistoryView ? value : THROW_CCE());
  };
  protoOf($serializer_228).pn = function (decoder) {
    var tmp0_desc = this.q3x_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_191().p3x_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return SupportVisitHistoryView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_228).nn = function () {
    return this.q3x_1;
  };
  protoOf($serializer_228).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_191().p3x_1[0], BooleanSerializer_getInstance()];
  };
  var $serializer_instance_227;
  function $serializer_getInstance_227() {
    if ($serializer_instance_227 == null)
      new $serializer_228();
    return $serializer_instance_227;
  }
  function SupportVisitHistoryView_init_$Init$(seen0, visits, entryReady, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_227().q3x_1);
    }
    $this.s3x_1 = visits;
    if (0 === (seen0 & 2))
      $this.t3x_1 = true;
    else
      $this.t3x_1 = entryReady;
    return $this;
  }
  function SupportVisitHistoryView_init_$Create$(seen0, visits, entryReady, serializationConstructorMarker) {
    return SupportVisitHistoryView_init_$Init$(seen0, visits, entryReady, serializationConstructorMarker, objectCreate(protoOf(SupportVisitHistoryView)));
  }
  function SupportVisitHistoryView(visits, entryReady) {
    Companion_getInstance_191();
    entryReady = entryReady === VOID ? true : entryReady;
    this.s3x_1 = visits;
    this.t3x_1 = entryReady;
  }
  protoOf(SupportVisitHistoryView).toString = function () {
    return 'SupportVisitHistoryView(visits=' + toString(this.s3x_1) + ', entryReady=' + this.t3x_1 + ')';
  };
  protoOf(SupportVisitHistoryView).hashCode = function () {
    var result = hashCode(this.s3x_1);
    result = imul(result, 31) + getBooleanHashCode(this.t3x_1) | 0;
    return result;
  };
  protoOf(SupportVisitHistoryView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SupportVisitHistoryView))
      return false;
    var tmp0_other_with_cast = other instanceof SupportVisitHistoryView ? other : THROW_CCE();
    if (!equals(this.s3x_1, tmp0_other_with_cast.s3x_1))
      return false;
    if (!(this.t3x_1 === tmp0_other_with_cast.t3x_1))
      return false;
    return true;
  };
  function TenantAccessPaths() {
    this.u3x_1 = 'effective-access';
    this.v3x_1 = 'plan-change/preview';
    this.w3x_1 = 'exceptions';
  }
  protoOf(TenantAccessPaths).x3x = function (tenantId) {
    return ConsoleApiPaths_instance.d1z(tenantId) + '/effective-access';
  };
  protoOf(TenantAccessPaths).y3x = function (tenantId) {
    return ConsoleApiPaths_instance.d1z(tenantId) + '/plan-change/preview';
  };
  protoOf(TenantAccessPaths).z3x = function (tenantId, exceptionId) {
    return ConsoleApiPaths_instance.d1z(tenantId) + '/exceptions/' + ConsoleApiPaths_instance.e1z(exceptionId);
  };
  protoOf(TenantAccessPaths).a3y = function (tenantId) {
    return ConsoleApiPaths_instance.g1z(tenantId);
  };
  protoOf(TenantAccessPaths).b3y = function (subscriptionId) {
    return '/api/console/subscriptions/' + ConsoleApiPaths_instance.e1z(subscriptionId) + '/plan';
  };
  var TenantAccessPaths_instance;
  function TenantAccessPaths_getInstance() {
    return TenantAccessPaths_instance;
  }
  function Companion_192() {
    Companion_instance_192 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c3y_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_235()), new ArrayListSerializer($serializer_getInstance_236()), new ArrayListSerializer($serializer_getInstance_237()), new ArrayListSerializer($serializer_getInstance_239()), new ArrayListSerializer($serializer_getInstance_240()), new ArrayListSerializer($serializer_getInstance_234()), new ArrayListSerializer($serializer_getInstance_234()), null, null, null];
  }
  var Companion_instance_192;
  function Companion_getInstance_192() {
    if (Companion_instance_192 == null)
      new Companion_192();
    return Companion_instance_192;
  }
  function $serializer_229() {
    $serializer_instance_228 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.EffectiveAccessView', this, 14);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantNameEn', false);
    tmp0_serialDesc.gy('tenantNameAr', false);
    tmp0_serialDesc.gy('primaryPlan', true);
    tmp0_serialDesc.gy('extraPlans', true);
    tmp0_serialDesc.gy('modules', true);
    tmp0_serialDesc.gy('features', true);
    tmp0_serialDesc.gy('withheld', true);
    tmp0_serialDesc.gy('limits', true);
    tmp0_serialDesc.gy('exceptions', true);
    tmp0_serialDesc.gy('inactiveExceptions', true);
    tmp0_serialDesc.gy('accessVersion', false);
    tmp0_serialDesc.gy('verifiedAtMs', false);
    tmp0_serialDesc.gy('usageEvidence', true);
    this.d3y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_229).e3y = function (encoder, value) {
    var tmp0_desc = this.d3y_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_192().c3y_1;
    tmp1_output.hs(tmp0_desc, 0, value.f3y_1);
    tmp1_output.hs(tmp0_desc, 1, value.g3y_1);
    tmp1_output.hs(tmp0_desc, 2, value.h3y_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.i3y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, $serializer_getInstance_235(), value.i3y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 4) ? true : !equals(value.j3y_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 4, tmp2_cached[4], value.j3y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !equals(value.k3y_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.k3y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !equals(value.l3y_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.l3y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !equals(value.m3y_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.m3y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !equals(value.n3y_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.n3y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !equals(value.o3y_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.o3y_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !equals(value.p3y_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 10, tmp2_cached[10], value.p3y_1);
    }
    tmp1_output.ds(tmp0_desc, 11, value.q3y_1);
    tmp1_output.ds(tmp0_desc, 12, value.r3y_1);
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.s3y_1 === 'historical')) {
      tmp1_output.hs(tmp0_desc, 13, value.s3y_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_229).on = function (encoder, value) {
    return this.e3y(encoder, value instanceof EffectiveAccessView ? value : THROW_CCE());
  };
  protoOf($serializer_229).pn = function (decoder) {
    var tmp0_desc = this.d3y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = new Long(0, 0);
    var tmp16_local12 = new Long(0, 0);
    var tmp17_local13 = null;
    var tmp18_input = decoder.tq(tmp0_desc);
    var tmp19_cached = Companion_getInstance_192().c3y_1;
    if (tmp18_input.ir()) {
      tmp4_local0 = tmp18_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp18_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp18_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp18_input.hr(tmp0_desc, 3, $serializer_getInstance_235(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp18_input.fr(tmp0_desc, 4, tmp19_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp18_input.fr(tmp0_desc, 5, tmp19_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp18_input.fr(tmp0_desc, 6, tmp19_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp18_input.fr(tmp0_desc, 7, tmp19_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp18_input.fr(tmp0_desc, 8, tmp19_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp18_input.fr(tmp0_desc, 9, tmp19_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp18_input.fr(tmp0_desc, 10, tmp19_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp18_input.zq(tmp0_desc, 11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp18_input.zq(tmp0_desc, 12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp18_input.dr(tmp0_desc, 13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp18_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp18_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp18_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp18_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp18_input.hr(tmp0_desc, 3, $serializer_getInstance_235(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp18_input.fr(tmp0_desc, 4, tmp19_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp18_input.fr(tmp0_desc, 5, tmp19_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp18_input.fr(tmp0_desc, 6, tmp19_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp18_input.fr(tmp0_desc, 7, tmp19_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp18_input.fr(tmp0_desc, 8, tmp19_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp18_input.fr(tmp0_desc, 9, tmp19_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp18_input.fr(tmp0_desc, 10, tmp19_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp18_input.zq(tmp0_desc, 11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp18_input.zq(tmp0_desc, 12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp18_input.dr(tmp0_desc, 13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp18_input.uq(tmp0_desc);
    return EffectiveAccessView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, null);
  };
  protoOf($serializer_229).nn = function () {
    return this.d3y_1;
  };
  protoOf($serializer_229).vy = function () {
    var tmp0_cached = Companion_getInstance_192().c3y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_235()), tmp0_cached[4], tmp0_cached[5], tmp0_cached[6], tmp0_cached[7], tmp0_cached[8], tmp0_cached[9], tmp0_cached[10], LongSerializer_getInstance(), LongSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_228;
  function $serializer_getInstance_228() {
    if ($serializer_instance_228 == null)
      new $serializer_229();
    return $serializer_instance_228;
  }
  function EffectiveAccessView_init_$Init$(seen0, tenantId, tenantNameEn, tenantNameAr, primaryPlan, extraPlans, modules, features, withheld, limits, exceptions, inactiveExceptions, accessVersion, verifiedAtMs, usageEvidence, serializationConstructorMarker, $this) {
    if (!(6151 === (6151 & seen0))) {
      throwMissingFieldException(seen0, 6151, $serializer_getInstance_228().d3y_1);
    }
    $this.f3y_1 = tenantId;
    $this.g3y_1 = tenantNameEn;
    $this.h3y_1 = tenantNameAr;
    if (0 === (seen0 & 8))
      $this.i3y_1 = null;
    else
      $this.i3y_1 = primaryPlan;
    if (0 === (seen0 & 16))
      $this.j3y_1 = emptyList();
    else
      $this.j3y_1 = extraPlans;
    if (0 === (seen0 & 32))
      $this.k3y_1 = emptyList();
    else
      $this.k3y_1 = modules;
    if (0 === (seen0 & 64))
      $this.l3y_1 = emptyList();
    else
      $this.l3y_1 = features;
    if (0 === (seen0 & 128))
      $this.m3y_1 = emptyList();
    else
      $this.m3y_1 = withheld;
    if (0 === (seen0 & 256))
      $this.n3y_1 = emptyList();
    else
      $this.n3y_1 = limits;
    if (0 === (seen0 & 512))
      $this.o3y_1 = emptyList();
    else
      $this.o3y_1 = exceptions;
    if (0 === (seen0 & 1024))
      $this.p3y_1 = emptyList();
    else
      $this.p3y_1 = inactiveExceptions;
    $this.q3y_1 = accessVersion;
    $this.r3y_1 = verifiedAtMs;
    if (0 === (seen0 & 8192))
      $this.s3y_1 = 'historical';
    else
      $this.s3y_1 = usageEvidence;
    return $this;
  }
  function EffectiveAccessView_init_$Create$(seen0, tenantId, tenantNameEn, tenantNameAr, primaryPlan, extraPlans, modules, features, withheld, limits, exceptions, inactiveExceptions, accessVersion, verifiedAtMs, usageEvidence, serializationConstructorMarker) {
    return EffectiveAccessView_init_$Init$(seen0, tenantId, tenantNameEn, tenantNameAr, primaryPlan, extraPlans, modules, features, withheld, limits, exceptions, inactiveExceptions, accessVersion, verifiedAtMs, usageEvidence, serializationConstructorMarker, objectCreate(protoOf(EffectiveAccessView)));
  }
  function EffectiveAccessView(tenantId, tenantNameEn, tenantNameAr, primaryPlan, extraPlans, modules, features, withheld, limits, exceptions, inactiveExceptions, accessVersion, verifiedAtMs, usageEvidence) {
    Companion_getInstance_192();
    primaryPlan = primaryPlan === VOID ? null : primaryPlan;
    extraPlans = extraPlans === VOID ? emptyList() : extraPlans;
    modules = modules === VOID ? emptyList() : modules;
    features = features === VOID ? emptyList() : features;
    withheld = withheld === VOID ? emptyList() : withheld;
    limits = limits === VOID ? emptyList() : limits;
    exceptions = exceptions === VOID ? emptyList() : exceptions;
    inactiveExceptions = inactiveExceptions === VOID ? emptyList() : inactiveExceptions;
    usageEvidence = usageEvidence === VOID ? 'historical' : usageEvidence;
    this.f3y_1 = tenantId;
    this.g3y_1 = tenantNameEn;
    this.h3y_1 = tenantNameAr;
    this.i3y_1 = primaryPlan;
    this.j3y_1 = extraPlans;
    this.k3y_1 = modules;
    this.l3y_1 = features;
    this.m3y_1 = withheld;
    this.n3y_1 = limits;
    this.o3y_1 = exceptions;
    this.p3y_1 = inactiveExceptions;
    this.q3y_1 = accessVersion;
    this.r3y_1 = verifiedAtMs;
    this.s3y_1 = usageEvidence;
  }
  protoOf(EffectiveAccessView).toString = function () {
    return 'EffectiveAccessView(tenantId=' + this.f3y_1 + ', tenantNameEn=' + this.g3y_1 + ', tenantNameAr=' + this.h3y_1 + ', primaryPlan=' + toString_0(this.i3y_1) + ', extraPlans=' + toString(this.j3y_1) + ', modules=' + toString(this.k3y_1) + ', features=' + toString(this.l3y_1) + ', withheld=' + toString(this.m3y_1) + ', limits=' + toString(this.n3y_1) + ', exceptions=' + toString(this.o3y_1) + ', inactiveExceptions=' + toString(this.p3y_1) + ', accessVersion=' + this.q3y_1.toString() + ', verifiedAtMs=' + this.r3y_1.toString() + ', usageEvidence=' + this.s3y_1 + ')';
  };
  protoOf(EffectiveAccessView).hashCode = function () {
    var result = getStringHashCode(this.f3y_1);
    result = imul(result, 31) + getStringHashCode(this.g3y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.h3y_1) | 0;
    result = imul(result, 31) + (this.i3y_1 == null ? 0 : this.i3y_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.j3y_1) | 0;
    result = imul(result, 31) + hashCode(this.k3y_1) | 0;
    result = imul(result, 31) + hashCode(this.l3y_1) | 0;
    result = imul(result, 31) + hashCode(this.m3y_1) | 0;
    result = imul(result, 31) + hashCode(this.n3y_1) | 0;
    result = imul(result, 31) + hashCode(this.o3y_1) | 0;
    result = imul(result, 31) + hashCode(this.p3y_1) | 0;
    result = imul(result, 31) + this.q3y_1.hashCode() | 0;
    result = imul(result, 31) + this.r3y_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.s3y_1) | 0;
    return result;
  };
  protoOf(EffectiveAccessView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EffectiveAccessView))
      return false;
    var tmp0_other_with_cast = other instanceof EffectiveAccessView ? other : THROW_CCE();
    if (!(this.f3y_1 === tmp0_other_with_cast.f3y_1))
      return false;
    if (!(this.g3y_1 === tmp0_other_with_cast.g3y_1))
      return false;
    if (!(this.h3y_1 === tmp0_other_with_cast.h3y_1))
      return false;
    if (!equals(this.i3y_1, tmp0_other_with_cast.i3y_1))
      return false;
    if (!equals(this.j3y_1, tmp0_other_with_cast.j3y_1))
      return false;
    if (!equals(this.k3y_1, tmp0_other_with_cast.k3y_1))
      return false;
    if (!equals(this.l3y_1, tmp0_other_with_cast.l3y_1))
      return false;
    if (!equals(this.m3y_1, tmp0_other_with_cast.m3y_1))
      return false;
    if (!equals(this.n3y_1, tmp0_other_with_cast.n3y_1))
      return false;
    if (!equals(this.o3y_1, tmp0_other_with_cast.o3y_1))
      return false;
    if (!equals(this.p3y_1, tmp0_other_with_cast.p3y_1))
      return false;
    if (!this.q3y_1.equals(tmp0_other_with_cast.q3y_1))
      return false;
    if (!this.r3y_1.equals(tmp0_other_with_cast.r3y_1))
      return false;
    if (!(this.s3y_1 === tmp0_other_with_cast.s3y_1))
      return false;
    return true;
  };
  function Companion_193() {
    Companion_instance_193 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.t3y_1 = [null, null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_156()), new ArrayListSerializer($serializer_getInstance_163()), new ArrayListSerializer($serializer_getInstance_160()), new ArrayListSerializer($serializer_getInstance_161()), Companion_getInstance_135().w19(), null, null];
  }
  var Companion_instance_193;
  function Companion_getInstance_193() {
    if (Companion_instance_193 == null)
      new Companion_193();
    return Companion_instance_193;
  }
  function $serializer_230() {
    $serializer_instance_229 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanChangePreviewView', this, 17);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('mode', false);
    tmp0_serialDesc.gy('subscriptionId', true);
    tmp0_serialDesc.gy('plan', false);
    tmp0_serialDesc.gy('current', false);
    tmp0_serialDesc.gy('proposed', false);
    tmp0_serialDesc.gy('gainedModules', true);
    tmp0_serialDesc.gy('lostModules', true);
    tmp0_serialDesc.gy('gainedFeatures', true);
    tmp0_serialDesc.gy('lostFeatures', true);
    tmp0_serialDesc.gy('keptByException', true);
    tmp0_serialDesc.gy('limitChanges', true);
    tmp0_serialDesc.gy('limitsOverUsage', true);
    tmp0_serialDesc.gy('pausedWork', true);
    tmp0_serialDesc.gy('pausedWorkEvidence', true);
    tmp0_serialDesc.gy('accessVersion', false);
    tmp0_serialDesc.gy('generatedAtMs', false);
    this.u3y_1 = tmp0_serialDesc;
  }
  protoOf($serializer_230).v3y = function (encoder, value) {
    var tmp0_desc = this.u3y_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_193().t3y_1;
    tmp1_output.hs(tmp0_desc, 0, value.w3y_1);
    tmp1_output.hs(tmp0_desc, 1, value.x3y_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.y3y_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.y3y_1);
    }
    tmp1_output.js(tmp0_desc, 3, $serializer_getInstance_156(), value.z3y_1);
    tmp1_output.js(tmp0_desc, 4, $serializer_getInstance_228(), value.a3z_1);
    tmp1_output.js(tmp0_desc, 5, $serializer_getInstance_228(), value.b3z_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !equals(value.c3z_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.c3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !equals(value.d3z_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 7, tmp2_cached[7], value.d3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !equals(value.e3z_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 8, tmp2_cached[8], value.e3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !equals(value.f3z_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.f3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !equals(value.g3z_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 10, tmp2_cached[10], value.g3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !equals(value.h3z_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 11, tmp2_cached[11], value.h3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !equals(value.i3z_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 12, tmp2_cached[12], value.i3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !equals(value.j3z_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 13, tmp2_cached[13], value.j3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !value.k3z_1.equals(PlanWorkEvidence_UNKNOWN_getInstance())) {
      tmp1_output.js(tmp0_desc, 14, tmp2_cached[14], value.k3z_1);
    }
    tmp1_output.ds(tmp0_desc, 15, value.l3z_1);
    tmp1_output.ds(tmp0_desc, 16, value.m3z_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_230).on = function (encoder, value) {
    return this.v3y(encoder, value instanceof PlanChangePreviewView ? value : THROW_CCE());
  };
  protoOf($serializer_230).pn = function (decoder) {
    var tmp0_desc = this.u3y_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_local15 = new Long(0, 0);
    var tmp20_local16 = new Long(0, 0);
    var tmp21_input = decoder.tq(tmp0_desc);
    var tmp22_cached = Companion_getInstance_193().t3y_1;
    if (tmp21_input.ir()) {
      tmp4_local0 = tmp21_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp21_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp21_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp21_input.fr(tmp0_desc, 3, $serializer_getInstance_156(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp21_input.fr(tmp0_desc, 4, $serializer_getInstance_228(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp21_input.fr(tmp0_desc, 5, $serializer_getInstance_228(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp21_input.fr(tmp0_desc, 6, tmp22_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp21_input.fr(tmp0_desc, 7, tmp22_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp21_input.fr(tmp0_desc, 8, tmp22_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp21_input.fr(tmp0_desc, 9, tmp22_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp21_input.fr(tmp0_desc, 10, tmp22_cached[10], tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp21_input.fr(tmp0_desc, 11, tmp22_cached[11], tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp21_input.fr(tmp0_desc, 12, tmp22_cached[12], tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp21_input.fr(tmp0_desc, 13, tmp22_cached[13], tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp21_input.fr(tmp0_desc, 14, tmp22_cached[14], tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
      tmp19_local15 = tmp21_input.zq(tmp0_desc, 15);
      tmp3_bitMask0 = tmp3_bitMask0 | 32768;
      tmp20_local16 = tmp21_input.zq(tmp0_desc, 16);
      tmp3_bitMask0 = tmp3_bitMask0 | 65536;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp21_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp21_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp21_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp21_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp21_input.fr(tmp0_desc, 3, $serializer_getInstance_156(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp21_input.fr(tmp0_desc, 4, $serializer_getInstance_228(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp21_input.fr(tmp0_desc, 5, $serializer_getInstance_228(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp21_input.fr(tmp0_desc, 6, tmp22_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp21_input.fr(tmp0_desc, 7, tmp22_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp21_input.fr(tmp0_desc, 8, tmp22_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp21_input.fr(tmp0_desc, 9, tmp22_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp21_input.fr(tmp0_desc, 10, tmp22_cached[10], tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp21_input.fr(tmp0_desc, 11, tmp22_cached[11], tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp21_input.fr(tmp0_desc, 12, tmp22_cached[12], tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp21_input.fr(tmp0_desc, 13, tmp22_cached[13], tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp21_input.fr(tmp0_desc, 14, tmp22_cached[14], tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          case 15:
            tmp19_local15 = tmp21_input.zq(tmp0_desc, 15);
            tmp3_bitMask0 = tmp3_bitMask0 | 32768;
            break;
          case 16:
            tmp20_local16 = tmp21_input.zq(tmp0_desc, 16);
            tmp3_bitMask0 = tmp3_bitMask0 | 65536;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp21_input.uq(tmp0_desc);
    return PlanChangePreviewView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, tmp19_local15, tmp20_local16, null);
  };
  protoOf($serializer_230).nn = function () {
    return this.u3y_1;
  };
  protoOf($serializer_230).vy = function () {
    var tmp0_cached = Companion_getInstance_193().t3y_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), $serializer_getInstance_156(), $serializer_getInstance_228(), $serializer_getInstance_228(), tmp0_cached[6], tmp0_cached[7], tmp0_cached[8], tmp0_cached[9], tmp0_cached[10], tmp0_cached[11], tmp0_cached[12], tmp0_cached[13], tmp0_cached[14], LongSerializer_getInstance(), LongSerializer_getInstance()];
  };
  var $serializer_instance_229;
  function $serializer_getInstance_229() {
    if ($serializer_instance_229 == null)
      new $serializer_230();
    return $serializer_instance_229;
  }
  function PlanChangePreviewView_init_$Init$(seen0, tenantId, mode, subscriptionId, plan, current, proposed, gainedModules, lostModules, gainedFeatures, lostFeatures, keptByException, limitChanges, limitsOverUsage, pausedWork, pausedWorkEvidence, accessVersion, generatedAtMs, serializationConstructorMarker, $this) {
    if (!(98363 === (98363 & seen0))) {
      throwMissingFieldException(seen0, 98363, $serializer_getInstance_229().u3y_1);
    }
    $this.w3y_1 = tenantId;
    $this.x3y_1 = mode;
    if (0 === (seen0 & 4))
      $this.y3y_1 = null;
    else
      $this.y3y_1 = subscriptionId;
    $this.z3y_1 = plan;
    $this.a3z_1 = current;
    $this.b3z_1 = proposed;
    if (0 === (seen0 & 64))
      $this.c3z_1 = emptyList();
    else
      $this.c3z_1 = gainedModules;
    if (0 === (seen0 & 128))
      $this.d3z_1 = emptyList();
    else
      $this.d3z_1 = lostModules;
    if (0 === (seen0 & 256))
      $this.e3z_1 = emptyList();
    else
      $this.e3z_1 = gainedFeatures;
    if (0 === (seen0 & 512))
      $this.f3z_1 = emptyList();
    else
      $this.f3z_1 = lostFeatures;
    if (0 === (seen0 & 1024))
      $this.g3z_1 = emptyList();
    else
      $this.g3z_1 = keptByException;
    if (0 === (seen0 & 2048))
      $this.h3z_1 = emptyList();
    else
      $this.h3z_1 = limitChanges;
    if (0 === (seen0 & 4096))
      $this.i3z_1 = emptyList();
    else
      $this.i3z_1 = limitsOverUsage;
    if (0 === (seen0 & 8192))
      $this.j3z_1 = emptyList();
    else
      $this.j3z_1 = pausedWork;
    if (0 === (seen0 & 16384))
      $this.k3z_1 = PlanWorkEvidence_UNKNOWN_getInstance();
    else
      $this.k3z_1 = pausedWorkEvidence;
    $this.l3z_1 = accessVersion;
    $this.m3z_1 = generatedAtMs;
    return $this;
  }
  function PlanChangePreviewView_init_$Create$(seen0, tenantId, mode, subscriptionId, plan, current, proposed, gainedModules, lostModules, gainedFeatures, lostFeatures, keptByException, limitChanges, limitsOverUsage, pausedWork, pausedWorkEvidence, accessVersion, generatedAtMs, serializationConstructorMarker) {
    return PlanChangePreviewView_init_$Init$(seen0, tenantId, mode, subscriptionId, plan, current, proposed, gainedModules, lostModules, gainedFeatures, lostFeatures, keptByException, limitChanges, limitsOverUsage, pausedWork, pausedWorkEvidence, accessVersion, generatedAtMs, serializationConstructorMarker, objectCreate(protoOf(PlanChangePreviewView)));
  }
  function PlanChangePreviewView(tenantId, mode, subscriptionId, plan, current, proposed, gainedModules, lostModules, gainedFeatures, lostFeatures, keptByException, limitChanges, limitsOverUsage, pausedWork, pausedWorkEvidence, accessVersion, generatedAtMs) {
    Companion_getInstance_193();
    subscriptionId = subscriptionId === VOID ? null : subscriptionId;
    gainedModules = gainedModules === VOID ? emptyList() : gainedModules;
    lostModules = lostModules === VOID ? emptyList() : lostModules;
    gainedFeatures = gainedFeatures === VOID ? emptyList() : gainedFeatures;
    lostFeatures = lostFeatures === VOID ? emptyList() : lostFeatures;
    keptByException = keptByException === VOID ? emptyList() : keptByException;
    limitChanges = limitChanges === VOID ? emptyList() : limitChanges;
    limitsOverUsage = limitsOverUsage === VOID ? emptyList() : limitsOverUsage;
    pausedWork = pausedWork === VOID ? emptyList() : pausedWork;
    pausedWorkEvidence = pausedWorkEvidence === VOID ? PlanWorkEvidence_UNKNOWN_getInstance() : pausedWorkEvidence;
    this.w3y_1 = tenantId;
    this.x3y_1 = mode;
    this.y3y_1 = subscriptionId;
    this.z3y_1 = plan;
    this.a3z_1 = current;
    this.b3z_1 = proposed;
    this.c3z_1 = gainedModules;
    this.d3z_1 = lostModules;
    this.e3z_1 = gainedFeatures;
    this.f3z_1 = lostFeatures;
    this.g3z_1 = keptByException;
    this.h3z_1 = limitChanges;
    this.i3z_1 = limitsOverUsage;
    this.j3z_1 = pausedWork;
    this.k3z_1 = pausedWorkEvidence;
    this.l3z_1 = accessVersion;
    this.m3z_1 = generatedAtMs;
  }
  protoOf(PlanChangePreviewView).toString = function () {
    return 'PlanChangePreviewView(tenantId=' + this.w3y_1 + ', mode=' + this.x3y_1 + ', subscriptionId=' + this.y3y_1 + ', plan=' + this.z3y_1.toString() + ', current=' + this.a3z_1.toString() + ', proposed=' + this.b3z_1.toString() + ', gainedModules=' + toString(this.c3z_1) + ', lostModules=' + toString(this.d3z_1) + ', gainedFeatures=' + toString(this.e3z_1) + ', lostFeatures=' + toString(this.f3z_1) + ', keptByException=' + toString(this.g3z_1) + ', limitChanges=' + toString(this.h3z_1) + ', limitsOverUsage=' + toString(this.i3z_1) + ', pausedWork=' + toString(this.j3z_1) + ', pausedWorkEvidence=' + this.k3z_1.toString() + ', accessVersion=' + this.l3z_1.toString() + ', generatedAtMs=' + this.m3z_1.toString() + ')';
  };
  protoOf(PlanChangePreviewView).hashCode = function () {
    var result = getStringHashCode(this.w3y_1);
    result = imul(result, 31) + getStringHashCode(this.x3y_1) | 0;
    result = imul(result, 31) + (this.y3y_1 == null ? 0 : getStringHashCode(this.y3y_1)) | 0;
    result = imul(result, 31) + this.z3y_1.hashCode() | 0;
    result = imul(result, 31) + this.a3z_1.hashCode() | 0;
    result = imul(result, 31) + this.b3z_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.c3z_1) | 0;
    result = imul(result, 31) + hashCode(this.d3z_1) | 0;
    result = imul(result, 31) + hashCode(this.e3z_1) | 0;
    result = imul(result, 31) + hashCode(this.f3z_1) | 0;
    result = imul(result, 31) + hashCode(this.g3z_1) | 0;
    result = imul(result, 31) + hashCode(this.h3z_1) | 0;
    result = imul(result, 31) + hashCode(this.i3z_1) | 0;
    result = imul(result, 31) + hashCode(this.j3z_1) | 0;
    result = imul(result, 31) + this.k3z_1.hashCode() | 0;
    result = imul(result, 31) + this.l3z_1.hashCode() | 0;
    result = imul(result, 31) + this.m3z_1.hashCode() | 0;
    return result;
  };
  protoOf(PlanChangePreviewView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanChangePreviewView))
      return false;
    var tmp0_other_with_cast = other instanceof PlanChangePreviewView ? other : THROW_CCE();
    if (!(this.w3y_1 === tmp0_other_with_cast.w3y_1))
      return false;
    if (!(this.x3y_1 === tmp0_other_with_cast.x3y_1))
      return false;
    if (!(this.y3y_1 == tmp0_other_with_cast.y3y_1))
      return false;
    if (!this.z3y_1.equals(tmp0_other_with_cast.z3y_1))
      return false;
    if (!this.a3z_1.equals(tmp0_other_with_cast.a3z_1))
      return false;
    if (!this.b3z_1.equals(tmp0_other_with_cast.b3z_1))
      return false;
    if (!equals(this.c3z_1, tmp0_other_with_cast.c3z_1))
      return false;
    if (!equals(this.d3z_1, tmp0_other_with_cast.d3z_1))
      return false;
    if (!equals(this.e3z_1, tmp0_other_with_cast.e3z_1))
      return false;
    if (!equals(this.f3z_1, tmp0_other_with_cast.f3z_1))
      return false;
    if (!equals(this.g3z_1, tmp0_other_with_cast.g3z_1))
      return false;
    if (!equals(this.h3z_1, tmp0_other_with_cast.h3z_1))
      return false;
    if (!equals(this.i3z_1, tmp0_other_with_cast.i3z_1))
      return false;
    if (!equals(this.j3z_1, tmp0_other_with_cast.j3z_1))
      return false;
    if (!this.k3z_1.equals(tmp0_other_with_cast.k3z_1))
      return false;
    if (!this.l3z_1.equals(tmp0_other_with_cast.l3z_1))
      return false;
    if (!this.m3z_1.equals(tmp0_other_with_cast.m3z_1))
      return false;
    return true;
  };
  function Companion_194() {
  }
  var Companion_instance_194;
  function Companion_getInstance_194() {
    return Companion_instance_194;
  }
  function $serializer_231() {
    $serializer_instance_230 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.PlanChangePreviewRequest', this, 3);
    tmp0_serialDesc.gy('planKey', false);
    tmp0_serialDesc.gy('subscriptionId', true);
    tmp0_serialDesc.gy('billingCycle', true);
    this.n3z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_231).o3z = function (encoder, value) {
    var tmp0_desc = this.n3z_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.p3z_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.q3z_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.q3z_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.r3z_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.r3z_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_231).on = function (encoder, value) {
    return this.o3z(encoder, value instanceof PlanChangePreviewRequest ? value : THROW_CCE());
  };
  protoOf($serializer_231).pn = function (decoder) {
    var tmp0_desc = this.n3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return PlanChangePreviewRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_231).nn = function () {
    return this.n3z_1;
  };
  protoOf($serializer_231).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_230;
  function $serializer_getInstance_230() {
    if ($serializer_instance_230 == null)
      new $serializer_231();
    return $serializer_instance_230;
  }
  function PlanChangePreviewRequest_init_$Init$(seen0, planKey, subscriptionId, billingCycle, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_230().n3z_1);
    }
    $this.p3z_1 = planKey;
    if (0 === (seen0 & 2))
      $this.q3z_1 = null;
    else
      $this.q3z_1 = subscriptionId;
    if (0 === (seen0 & 4))
      $this.r3z_1 = null;
    else
      $this.r3z_1 = billingCycle;
    return $this;
  }
  function PlanChangePreviewRequest_init_$Create$(seen0, planKey, subscriptionId, billingCycle, serializationConstructorMarker) {
    return PlanChangePreviewRequest_init_$Init$(seen0, planKey, subscriptionId, billingCycle, serializationConstructorMarker, objectCreate(protoOf(PlanChangePreviewRequest)));
  }
  function PlanChangePreviewRequest(planKey, subscriptionId, billingCycle) {
    subscriptionId = subscriptionId === VOID ? null : subscriptionId;
    billingCycle = billingCycle === VOID ? null : billingCycle;
    this.p3z_1 = planKey;
    this.q3z_1 = subscriptionId;
    this.r3z_1 = billingCycle;
  }
  protoOf(PlanChangePreviewRequest).toString = function () {
    return 'PlanChangePreviewRequest(planKey=' + this.p3z_1 + ', subscriptionId=' + this.q3z_1 + ', billingCycle=' + this.r3z_1 + ')';
  };
  protoOf(PlanChangePreviewRequest).hashCode = function () {
    var result = getStringHashCode(this.p3z_1);
    result = imul(result, 31) + (this.q3z_1 == null ? 0 : getStringHashCode(this.q3z_1)) | 0;
    result = imul(result, 31) + (this.r3z_1 == null ? 0 : getStringHashCode(this.r3z_1)) | 0;
    return result;
  };
  protoOf(PlanChangePreviewRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlanChangePreviewRequest))
      return false;
    var tmp0_other_with_cast = other instanceof PlanChangePreviewRequest ? other : THROW_CCE();
    if (!(this.p3z_1 === tmp0_other_with_cast.p3z_1))
      return false;
    if (!(this.q3z_1 == tmp0_other_with_cast.q3z_1))
      return false;
    if (!(this.r3z_1 == tmp0_other_with_cast.r3z_1))
      return false;
    return true;
  };
  function Companion_195() {
  }
  var Companion_instance_195;
  function Companion_getInstance_195() {
    return Companion_instance_195;
  }
  function $serializer_232() {
    $serializer_instance_231 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.SubscriptionChangeResult', this, 3);
    tmp0_serialDesc.gy('subscription', false);
    tmp0_serialDesc.gy('accessVersion', false);
    tmp0_serialDesc.gy('replayed', true);
    this.s3z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_232).t3z = function (encoder, value) {
    var tmp0_desc = this.s3z_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_103(), value.u3z_1);
    tmp1_output.ds(tmp0_desc, 1, value.v3z_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.w3z_1 === false)) {
      tmp1_output.zr(tmp0_desc, 2, value.w3z_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_232).on = function (encoder, value) {
    return this.t3z(encoder, value instanceof SubscriptionChangeResult ? value : THROW_CCE());
  };
  protoOf($serializer_232).pn = function (decoder) {
    var tmp0_desc = this.s3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_local2 = false;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_103(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.vq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_103(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.vq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return SubscriptionChangeResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_232).nn = function () {
    return this.s3z_1;
  };
  protoOf($serializer_232).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_103(), LongSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_231;
  function $serializer_getInstance_231() {
    if ($serializer_instance_231 == null)
      new $serializer_232();
    return $serializer_instance_231;
  }
  function SubscriptionChangeResult_init_$Init$(seen0, subscription, accessVersion, replayed, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_231().s3z_1);
    }
    $this.u3z_1 = subscription;
    $this.v3z_1 = accessVersion;
    if (0 === (seen0 & 4))
      $this.w3z_1 = false;
    else
      $this.w3z_1 = replayed;
    return $this;
  }
  function SubscriptionChangeResult_init_$Create$(seen0, subscription, accessVersion, replayed, serializationConstructorMarker) {
    return SubscriptionChangeResult_init_$Init$(seen0, subscription, accessVersion, replayed, serializationConstructorMarker, objectCreate(protoOf(SubscriptionChangeResult)));
  }
  function SubscriptionChangeResult(subscription, accessVersion, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.u3z_1 = subscription;
    this.v3z_1 = accessVersion;
    this.w3z_1 = replayed;
  }
  protoOf(SubscriptionChangeResult).toString = function () {
    return 'SubscriptionChangeResult(subscription=' + this.u3z_1.toString() + ', accessVersion=' + this.v3z_1.toString() + ', replayed=' + this.w3z_1 + ')';
  };
  protoOf(SubscriptionChangeResult).hashCode = function () {
    var result = this.u3z_1.hashCode();
    result = imul(result, 31) + this.v3z_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w3z_1) | 0;
    return result;
  };
  protoOf(SubscriptionChangeResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SubscriptionChangeResult))
      return false;
    var tmp0_other_with_cast = other instanceof SubscriptionChangeResult ? other : THROW_CCE();
    if (!this.u3z_1.equals(tmp0_other_with_cast.u3z_1))
      return false;
    if (!this.v3z_1.equals(tmp0_other_with_cast.v3z_1))
      return false;
    if (!(this.w3z_1 === tmp0_other_with_cast.w3z_1))
      return false;
    return true;
  };
  function Companion_196() {
  }
  var Companion_instance_196;
  function Companion_getInstance_196() {
    return Companion_instance_196;
  }
  function $serializer_233() {
    $serializer_instance_232 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantExceptionRemovalResult', this, 4);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('exception', false);
    tmp0_serialDesc.gy('accessVersion', false);
    tmp0_serialDesc.gy('replayed', true);
    this.x3z_1 = tmp0_serialDesc;
  }
  protoOf($serializer_233).y3z = function (encoder, value) {
    var tmp0_desc = this.x3z_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.z3z_1);
    tmp1_output.js(tmp0_desc, 1, $serializer_getInstance_234(), value.a40_1);
    tmp1_output.ds(tmp0_desc, 2, value.b40_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.c40_1 === false)) {
      tmp1_output.zr(tmp0_desc, 3, value.c40_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_233).on = function (encoder, value) {
    return this.y3z(encoder, value instanceof TenantExceptionRemovalResult ? value : THROW_CCE());
  };
  protoOf($serializer_233).pn = function (decoder) {
    var tmp0_desc = this.x3z_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = false;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, $serializer_getInstance_234(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.fr(tmp0_desc, 1, $serializer_getInstance_234(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return TenantExceptionRemovalResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_233).nn = function () {
    return this.x3z_1;
  };
  protoOf($serializer_233).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_234(), LongSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_232;
  function $serializer_getInstance_232() {
    if ($serializer_instance_232 == null)
      new $serializer_233();
    return $serializer_instance_232;
  }
  function TenantExceptionRemovalResult_init_$Init$(seen0, tenantId, exception, accessVersion, replayed, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_232().x3z_1);
    }
    $this.z3z_1 = tenantId;
    $this.a40_1 = exception;
    $this.b40_1 = accessVersion;
    if (0 === (seen0 & 8))
      $this.c40_1 = false;
    else
      $this.c40_1 = replayed;
    return $this;
  }
  function TenantExceptionRemovalResult_init_$Create$(seen0, tenantId, exception, accessVersion, replayed, serializationConstructorMarker) {
    return TenantExceptionRemovalResult_init_$Init$(seen0, tenantId, exception, accessVersion, replayed, serializationConstructorMarker, objectCreate(protoOf(TenantExceptionRemovalResult)));
  }
  function TenantExceptionRemovalResult(tenantId, exception, accessVersion, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.z3z_1 = tenantId;
    this.a40_1 = exception;
    this.b40_1 = accessVersion;
    this.c40_1 = replayed;
  }
  protoOf(TenantExceptionRemovalResult).toString = function () {
    return 'TenantExceptionRemovalResult(tenantId=' + this.z3z_1 + ', exception=' + this.a40_1.toString() + ', accessVersion=' + this.b40_1.toString() + ', replayed=' + this.c40_1 + ')';
  };
  protoOf(TenantExceptionRemovalResult).hashCode = function () {
    var result = getStringHashCode(this.z3z_1);
    result = imul(result, 31) + this.a40_1.hashCode() | 0;
    result = imul(result, 31) + this.b40_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.c40_1) | 0;
    return result;
  };
  protoOf(TenantExceptionRemovalResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantExceptionRemovalResult))
      return false;
    var tmp0_other_with_cast = other instanceof TenantExceptionRemovalResult ? other : THROW_CCE();
    if (!(this.z3z_1 === tmp0_other_with_cast.z3z_1))
      return false;
    if (!this.a40_1.equals(tmp0_other_with_cast.a40_1))
      return false;
    if (!this.b40_1.equals(tmp0_other_with_cast.b40_1))
      return false;
    if (!(this.c40_1 === tmp0_other_with_cast.c40_1))
      return false;
    return true;
  };
  function Companion_197() {
  }
  var Companion_instance_197;
  function Companion_getInstance_197() {
    return Companion_instance_197;
  }
  function $serializer_234() {
    $serializer_instance_233 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.RemoveTenantExceptionRequest', this, 2);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('expectedAccessVersion', true);
    this.d40_1 = tmp0_serialDesc;
  }
  protoOf($serializer_234).e40 = function (encoder, value) {
    var tmp0_desc = this.d40_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.f40_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.g40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, LongSerializer_getInstance(), value.g40_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_234).on = function (encoder, value) {
    return this.e40(encoder, value instanceof RemoveTenantExceptionRequest ? value : THROW_CCE());
  };
  protoOf($serializer_234).pn = function (decoder) {
    var tmp0_desc = this.d40_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.hr(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return RemoveTenantExceptionRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_234).nn = function () {
    return this.d40_1;
  };
  protoOf($serializer_234).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_233;
  function $serializer_getInstance_233() {
    if ($serializer_instance_233 == null)
      new $serializer_234();
    return $serializer_instance_233;
  }
  function RemoveTenantExceptionRequest_init_$Init$(seen0, reason, expectedAccessVersion, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_233().d40_1);
    }
    $this.f40_1 = reason;
    if (0 === (seen0 & 2))
      $this.g40_1 = null;
    else
      $this.g40_1 = expectedAccessVersion;
    return $this;
  }
  function RemoveTenantExceptionRequest_init_$Create$(seen0, reason, expectedAccessVersion, serializationConstructorMarker) {
    return RemoveTenantExceptionRequest_init_$Init$(seen0, reason, expectedAccessVersion, serializationConstructorMarker, objectCreate(protoOf(RemoveTenantExceptionRequest)));
  }
  function RemoveTenantExceptionRequest(reason, expectedAccessVersion) {
    expectedAccessVersion = expectedAccessVersion === VOID ? null : expectedAccessVersion;
    this.f40_1 = reason;
    this.g40_1 = expectedAccessVersion;
  }
  protoOf(RemoveTenantExceptionRequest).toString = function () {
    return 'RemoveTenantExceptionRequest(reason=' + this.f40_1 + ', expectedAccessVersion=' + toString_0(this.g40_1) + ')';
  };
  protoOf(RemoveTenantExceptionRequest).hashCode = function () {
    var result = getStringHashCode(this.f40_1);
    result = imul(result, 31) + (this.g40_1 == null ? 0 : this.g40_1.hashCode()) | 0;
    return result;
  };
  protoOf(RemoveTenantExceptionRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RemoveTenantExceptionRequest))
      return false;
    var tmp0_other_with_cast = other instanceof RemoveTenantExceptionRequest ? other : THROW_CCE();
    if (!(this.f40_1 === tmp0_other_with_cast.f40_1))
      return false;
    if (!equals(this.g40_1, tmp0_other_with_cast.g40_1))
      return false;
    return true;
  };
  function TenantAccessRules() {
    this.h40_1 = 500;
  }
  protoOf(TenantAccessRules).i40 = function (reason) {
    var tmp;
    if (isBlank(reason)) {
      tmp = 'required';
    } else {
      // Inline function 'kotlin.text.trim' call
      if (toString(trim(isCharSequence(reason) ? reason : THROW_CCE())).length > 500) {
        tmp = 'too_long';
      } else {
        tmp = null;
      }
    }
    return tmp;
  };
  var TenantAccessRules_instance;
  function TenantAccessRules_getInstance() {
    return TenantAccessRules_instance;
  }
  function $serializer_235() {
    $serializer_instance_234 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AccessExceptionView', this, 15);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('targetKind', false);
    tmp0_serialDesc.gy('target', false);
    tmp0_serialDesc.gy('effect', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('counted', false);
    tmp0_serialDesc.gy('value', true);
    tmp0_serialDesc.gy('policy', true);
    tmp0_serialDesc.gy('relatedLimit', true);
    tmp0_serialDesc.gy('reason', true);
    tmp0_serialDesc.gy('createdBy', true);
    tmp0_serialDesc.gy('createdAtMs', true);
    tmp0_serialDesc.gy('startsAtMs', true);
    tmp0_serialDesc.gy('expiresAtMs', true);
    this.j40_1 = tmp0_serialDesc;
  }
  protoOf($serializer_235).k40 = function (encoder, value) {
    var tmp0_desc = this.j40_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.l40_1);
    tmp1_output.hs(tmp0_desc, 1, value.m40_1);
    tmp1_output.hs(tmp0_desc, 2, value.n40_1);
    tmp1_output.js(tmp0_desc, 3, $serializer_getInstance_156(), value.o40_1);
    tmp1_output.hs(tmp0_desc, 4, value.p40_1);
    tmp1_output.hs(tmp0_desc, 5, value.q40_1);
    tmp1_output.zr(tmp0_desc, 6, value.r40_1);
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.s40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 7, LongSerializer_getInstance(), value.s40_1);
    }
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.t40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, StringSerializer_getInstance(), value.t40_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !(value.u40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 9, $serializer_getInstance_156(), value.u40_1);
    }
    if (tmp1_output.ps(tmp0_desc, 10) ? true : !(value.v40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 10, StringSerializer_getInstance(), value.v40_1);
    }
    if (tmp1_output.ps(tmp0_desc, 11) ? true : !(value.w40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 11, StringSerializer_getInstance(), value.w40_1);
    }
    if (tmp1_output.ps(tmp0_desc, 12) ? true : !(value.x40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 12, LongSerializer_getInstance(), value.x40_1);
    }
    if (tmp1_output.ps(tmp0_desc, 13) ? true : !(value.y40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 13, LongSerializer_getInstance(), value.y40_1);
    }
    if (tmp1_output.ps(tmp0_desc, 14) ? true : !(value.z40_1 == null)) {
      tmp1_output.ls(tmp0_desc, 14, LongSerializer_getInstance(), value.z40_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_235).on = function (encoder, value) {
    return this.k40(encoder, value instanceof AccessExceptionView ? value : THROW_CCE());
  };
  protoOf($serializer_235).pn = function (decoder) {
    var tmp0_desc = this.j40_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = false;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_local11 = null;
    var tmp16_local12 = null;
    var tmp17_local13 = null;
    var tmp18_local14 = null;
    var tmp19_input = decoder.tq(tmp0_desc);
    if (tmp19_input.ir()) {
      tmp4_local0 = tmp19_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp19_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp19_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp19_input.fr(tmp0_desc, 3, $serializer_getInstance_156(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp19_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp19_input.dr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp19_input.vq(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp19_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp19_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp19_input.hr(tmp0_desc, 9, $serializer_getInstance_156(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp19_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
      tmp15_local11 = tmp19_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
      tmp3_bitMask0 = tmp3_bitMask0 | 2048;
      tmp16_local12 = tmp19_input.hr(tmp0_desc, 12, LongSerializer_getInstance(), tmp16_local12);
      tmp3_bitMask0 = tmp3_bitMask0 | 4096;
      tmp17_local13 = tmp19_input.hr(tmp0_desc, 13, LongSerializer_getInstance(), tmp17_local13);
      tmp3_bitMask0 = tmp3_bitMask0 | 8192;
      tmp18_local14 = tmp19_input.hr(tmp0_desc, 14, LongSerializer_getInstance(), tmp18_local14);
      tmp3_bitMask0 = tmp3_bitMask0 | 16384;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp19_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp19_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp19_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp19_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp19_input.fr(tmp0_desc, 3, $serializer_getInstance_156(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp19_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp19_input.dr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp19_input.vq(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp19_input.hr(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp19_input.hr(tmp0_desc, 8, StringSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp19_input.hr(tmp0_desc, 9, $serializer_getInstance_156(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp19_input.hr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          case 11:
            tmp15_local11 = tmp19_input.hr(tmp0_desc, 11, StringSerializer_getInstance(), tmp15_local11);
            tmp3_bitMask0 = tmp3_bitMask0 | 2048;
            break;
          case 12:
            tmp16_local12 = tmp19_input.hr(tmp0_desc, 12, LongSerializer_getInstance(), tmp16_local12);
            tmp3_bitMask0 = tmp3_bitMask0 | 4096;
            break;
          case 13:
            tmp17_local13 = tmp19_input.hr(tmp0_desc, 13, LongSerializer_getInstance(), tmp17_local13);
            tmp3_bitMask0 = tmp3_bitMask0 | 8192;
            break;
          case 14:
            tmp18_local14 = tmp19_input.hr(tmp0_desc, 14, LongSerializer_getInstance(), tmp18_local14);
            tmp3_bitMask0 = tmp3_bitMask0 | 16384;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp19_input.uq(tmp0_desc);
    return AccessExceptionView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, tmp15_local11, tmp16_local12, tmp17_local13, tmp18_local14, null);
  };
  protoOf($serializer_235).nn = function () {
    return this.j40_1;
  };
  protoOf($serializer_235).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_156(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_156()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_234;
  function $serializer_getInstance_234() {
    if ($serializer_instance_234 == null)
      new $serializer_235();
    return $serializer_instance_234;
  }
  function AccessExceptionView_init_$Init$(seen0, id, kind, targetKind, target, effect, status, counted, value, policy, relatedLimit, reason, createdBy, createdAtMs, startsAtMs, expiresAtMs, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen0))) {
      throwMissingFieldException(seen0, 127, $serializer_getInstance_234().j40_1);
    }
    $this.l40_1 = id;
    $this.m40_1 = kind;
    $this.n40_1 = targetKind;
    $this.o40_1 = target;
    $this.p40_1 = effect;
    $this.q40_1 = status;
    $this.r40_1 = counted;
    if (0 === (seen0 & 128))
      $this.s40_1 = null;
    else
      $this.s40_1 = value;
    if (0 === (seen0 & 256))
      $this.t40_1 = null;
    else
      $this.t40_1 = policy;
    if (0 === (seen0 & 512))
      $this.u40_1 = null;
    else
      $this.u40_1 = relatedLimit;
    if (0 === (seen0 & 1024))
      $this.v40_1 = null;
    else
      $this.v40_1 = reason;
    if (0 === (seen0 & 2048))
      $this.w40_1 = null;
    else
      $this.w40_1 = createdBy;
    if (0 === (seen0 & 4096))
      $this.x40_1 = null;
    else
      $this.x40_1 = createdAtMs;
    if (0 === (seen0 & 8192))
      $this.y40_1 = null;
    else
      $this.y40_1 = startsAtMs;
    if (0 === (seen0 & 16384))
      $this.z40_1 = null;
    else
      $this.z40_1 = expiresAtMs;
    return $this;
  }
  function AccessExceptionView_init_$Create$(seen0, id, kind, targetKind, target, effect, status, counted, value, policy, relatedLimit, reason, createdBy, createdAtMs, startsAtMs, expiresAtMs, serializationConstructorMarker) {
    return AccessExceptionView_init_$Init$(seen0, id, kind, targetKind, target, effect, status, counted, value, policy, relatedLimit, reason, createdBy, createdAtMs, startsAtMs, expiresAtMs, serializationConstructorMarker, objectCreate(protoOf(AccessExceptionView)));
  }
  function AccessExceptionView() {
  }
  protoOf(AccessExceptionView).toString = function () {
    return 'AccessExceptionView(id=' + this.l40_1 + ', kind=' + this.m40_1 + ', targetKind=' + this.n40_1 + ', target=' + this.o40_1.toString() + ', effect=' + this.p40_1 + ', status=' + this.q40_1 + ', counted=' + this.r40_1 + ', value=' + toString_0(this.s40_1) + ', policy=' + this.t40_1 + ', relatedLimit=' + toString_0(this.u40_1) + ', reason=' + this.v40_1 + ', createdBy=' + this.w40_1 + ', createdAtMs=' + toString_0(this.x40_1) + ', startsAtMs=' + toString_0(this.y40_1) + ', expiresAtMs=' + toString_0(this.z40_1) + ')';
  };
  protoOf(AccessExceptionView).hashCode = function () {
    var result = getStringHashCode(this.l40_1);
    result = imul(result, 31) + getStringHashCode(this.m40_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.n40_1) | 0;
    result = imul(result, 31) + this.o40_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.p40_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.q40_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r40_1) | 0;
    result = imul(result, 31) + (this.s40_1 == null ? 0 : this.s40_1.hashCode()) | 0;
    result = imul(result, 31) + (this.t40_1 == null ? 0 : getStringHashCode(this.t40_1)) | 0;
    result = imul(result, 31) + (this.u40_1 == null ? 0 : this.u40_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v40_1 == null ? 0 : getStringHashCode(this.v40_1)) | 0;
    result = imul(result, 31) + (this.w40_1 == null ? 0 : getStringHashCode(this.w40_1)) | 0;
    result = imul(result, 31) + (this.x40_1 == null ? 0 : this.x40_1.hashCode()) | 0;
    result = imul(result, 31) + (this.y40_1 == null ? 0 : this.y40_1.hashCode()) | 0;
    result = imul(result, 31) + (this.z40_1 == null ? 0 : this.z40_1.hashCode()) | 0;
    return result;
  };
  protoOf(AccessExceptionView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccessExceptionView))
      return false;
    var tmp0_other_with_cast = other instanceof AccessExceptionView ? other : THROW_CCE();
    if (!(this.l40_1 === tmp0_other_with_cast.l40_1))
      return false;
    if (!(this.m40_1 === tmp0_other_with_cast.m40_1))
      return false;
    if (!(this.n40_1 === tmp0_other_with_cast.n40_1))
      return false;
    if (!this.o40_1.equals(tmp0_other_with_cast.o40_1))
      return false;
    if (!(this.p40_1 === tmp0_other_with_cast.p40_1))
      return false;
    if (!(this.q40_1 === tmp0_other_with_cast.q40_1))
      return false;
    if (!(this.r40_1 === tmp0_other_with_cast.r40_1))
      return false;
    if (!equals(this.s40_1, tmp0_other_with_cast.s40_1))
      return false;
    if (!(this.t40_1 == tmp0_other_with_cast.t40_1))
      return false;
    if (!equals(this.u40_1, tmp0_other_with_cast.u40_1))
      return false;
    if (!(this.v40_1 == tmp0_other_with_cast.v40_1))
      return false;
    if (!(this.w40_1 == tmp0_other_with_cast.w40_1))
      return false;
    if (!equals(this.x40_1, tmp0_other_with_cast.x40_1))
      return false;
    if (!equals(this.y40_1, tmp0_other_with_cast.y40_1))
      return false;
    if (!equals(this.z40_1, tmp0_other_with_cast.z40_1))
      return false;
    return true;
  };
  function $serializer_236() {
    $serializer_instance_235 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AccessPlanRef', this, 5);
    tmp0_serialDesc.gy('subscriptionId', false);
    tmp0_serialDesc.gy('plan', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('billingCycle', false);
    tmp0_serialDesc.gy('primary', false);
    this.a41_1 = tmp0_serialDesc;
  }
  protoOf($serializer_236).b41 = function (encoder, value) {
    var tmp0_desc = this.a41_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.c41_1);
    tmp1_output.js(tmp0_desc, 1, $serializer_getInstance_156(), value.d41_1);
    tmp1_output.hs(tmp0_desc, 2, value.e41_1);
    tmp1_output.hs(tmp0_desc, 3, value.f41_1);
    tmp1_output.zr(tmp0_desc, 4, value.g41_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_236).on = function (encoder, value) {
    return this.b41(encoder, value instanceof AccessPlanRef ? value : THROW_CCE());
  };
  protoOf($serializer_236).pn = function (decoder) {
    var tmp0_desc = this.a41_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = false;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.fr(tmp0_desc, 1, $serializer_getInstance_156(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.vq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.fr(tmp0_desc, 1, $serializer_getInstance_156(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.vq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return AccessPlanRef_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_236).nn = function () {
    return this.a41_1;
  };
  protoOf($serializer_236).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_156(), StringSerializer_getInstance(), StringSerializer_getInstance(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_235;
  function $serializer_getInstance_235() {
    if ($serializer_instance_235 == null)
      new $serializer_236();
    return $serializer_instance_235;
  }
  function AccessPlanRef_init_$Init$(seen0, subscriptionId, plan, status, billingCycle, primary, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_235().a41_1);
    }
    $this.c41_1 = subscriptionId;
    $this.d41_1 = plan;
    $this.e41_1 = status;
    $this.f41_1 = billingCycle;
    $this.g41_1 = primary;
    return $this;
  }
  function AccessPlanRef_init_$Create$(seen0, subscriptionId, plan, status, billingCycle, primary, serializationConstructorMarker) {
    return AccessPlanRef_init_$Init$(seen0, subscriptionId, plan, status, billingCycle, primary, serializationConstructorMarker, objectCreate(protoOf(AccessPlanRef)));
  }
  function AccessPlanRef() {
  }
  protoOf(AccessPlanRef).toString = function () {
    return 'AccessPlanRef(subscriptionId=' + this.c41_1 + ', plan=' + this.d41_1.toString() + ', status=' + this.e41_1 + ', billingCycle=' + this.f41_1 + ', primary=' + this.g41_1 + ')';
  };
  protoOf(AccessPlanRef).hashCode = function () {
    var result = getStringHashCode(this.c41_1);
    result = imul(result, 31) + this.d41_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.e41_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.f41_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g41_1) | 0;
    return result;
  };
  protoOf(AccessPlanRef).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccessPlanRef))
      return false;
    var tmp0_other_with_cast = other instanceof AccessPlanRef ? other : THROW_CCE();
    if (!(this.c41_1 === tmp0_other_with_cast.c41_1))
      return false;
    if (!this.d41_1.equals(tmp0_other_with_cast.d41_1))
      return false;
    if (!(this.e41_1 === tmp0_other_with_cast.e41_1))
      return false;
    if (!(this.f41_1 === tmp0_other_with_cast.f41_1))
      return false;
    if (!(this.g41_1 === tmp0_other_with_cast.g41_1))
      return false;
    return true;
  };
  function Companion_198() {
    Companion_instance_198 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h41_1 = [null, new ArrayListSerializer($serializer_getInstance_238())];
  }
  var Companion_instance_198;
  function Companion_getInstance_198() {
    if (Companion_instance_198 == null)
      new Companion_198();
    return Companion_instance_198;
  }
  function $serializer_237() {
    $serializer_instance_236 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.EffectiveModuleAccess', this, 2);
    tmp0_serialDesc.gy('module', false);
    tmp0_serialDesc.gy('sources', false);
    this.i41_1 = tmp0_serialDesc;
  }
  protoOf($serializer_237).j41 = function (encoder, value) {
    var tmp0_desc = this.i41_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_198().h41_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_156(), value.k41_1);
    tmp1_output.js(tmp0_desc, 1, tmp2_cached[1], value.l41_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_237).on = function (encoder, value) {
    return this.j41(encoder, value instanceof EffectiveModuleAccess ? value : THROW_CCE());
  };
  protoOf($serializer_237).pn = function (decoder) {
    var tmp0_desc = this.i41_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.tq(tmp0_desc);
    var tmp7_cached = Companion_getInstance_198().h41_1;
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.fr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.fr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return EffectiveModuleAccess_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_237).nn = function () {
    return this.i41_1;
  };
  protoOf($serializer_237).vy = function () {
    var tmp0_cached = Companion_getInstance_198().h41_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_156(), tmp0_cached[1]];
  };
  var $serializer_instance_236;
  function $serializer_getInstance_236() {
    if ($serializer_instance_236 == null)
      new $serializer_237();
    return $serializer_instance_236;
  }
  function EffectiveModuleAccess_init_$Init$(seen0, module_0, sources, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_236().i41_1);
    }
    $this.k41_1 = module_0;
    $this.l41_1 = sources;
    return $this;
  }
  function EffectiveModuleAccess_init_$Create$(seen0, module_0, sources, serializationConstructorMarker) {
    return EffectiveModuleAccess_init_$Init$(seen0, module_0, sources, serializationConstructorMarker, objectCreate(protoOf(EffectiveModuleAccess)));
  }
  function EffectiveModuleAccess() {
  }
  protoOf(EffectiveModuleAccess).toString = function () {
    return 'EffectiveModuleAccess(module=' + this.k41_1.toString() + ', sources=' + toString(this.l41_1) + ')';
  };
  protoOf(EffectiveModuleAccess).hashCode = function () {
    var result = this.k41_1.hashCode();
    result = imul(result, 31) + hashCode(this.l41_1) | 0;
    return result;
  };
  protoOf(EffectiveModuleAccess).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EffectiveModuleAccess))
      return false;
    var tmp0_other_with_cast = other instanceof EffectiveModuleAccess ? other : THROW_CCE();
    if (!this.k41_1.equals(tmp0_other_with_cast.k41_1))
      return false;
    if (!equals(this.l41_1, tmp0_other_with_cast.l41_1))
      return false;
    return true;
  };
  function Companion_199() {
    Companion_instance_199 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m41_1 = [null, null, new ArrayListSerializer($serializer_getInstance_238())];
  }
  var Companion_instance_199;
  function Companion_getInstance_199() {
    if (Companion_instance_199 == null)
      new Companion_199();
    return Companion_instance_199;
  }
  function $serializer_238() {
    $serializer_instance_237 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.EffectiveFeatureAccess', this, 3);
    tmp0_serialDesc.gy('feature', false);
    tmp0_serialDesc.gy('moduleKey', true);
    tmp0_serialDesc.gy('sources', false);
    this.n41_1 = tmp0_serialDesc;
  }
  protoOf($serializer_238).o41 = function (encoder, value) {
    var tmp0_desc = this.n41_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_199().m41_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_156(), value.p41_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.q41_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, StringSerializer_getInstance(), value.q41_1);
    }
    tmp1_output.js(tmp0_desc, 2, tmp2_cached[2], value.r41_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_238).on = function (encoder, value) {
    return this.o41(encoder, value instanceof EffectiveFeatureAccess ? value : THROW_CCE());
  };
  protoOf($serializer_238).pn = function (decoder) {
    var tmp0_desc = this.n41_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    var tmp8_cached = Companion_getInstance_199().m41_1;
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.fr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return EffectiveFeatureAccess_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_238).nn = function () {
    return this.n41_1;
  };
  protoOf($serializer_238).vy = function () {
    var tmp0_cached = Companion_getInstance_199().m41_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_156(), get_nullable(StringSerializer_getInstance()), tmp0_cached[2]];
  };
  var $serializer_instance_237;
  function $serializer_getInstance_237() {
    if ($serializer_instance_237 == null)
      new $serializer_238();
    return $serializer_instance_237;
  }
  function EffectiveFeatureAccess_init_$Init$(seen0, feature, moduleKey, sources, serializationConstructorMarker, $this) {
    if (!(5 === (5 & seen0))) {
      throwMissingFieldException(seen0, 5, $serializer_getInstance_237().n41_1);
    }
    $this.p41_1 = feature;
    if (0 === (seen0 & 2))
      $this.q41_1 = null;
    else
      $this.q41_1 = moduleKey;
    $this.r41_1 = sources;
    return $this;
  }
  function EffectiveFeatureAccess_init_$Create$(seen0, feature, moduleKey, sources, serializationConstructorMarker) {
    return EffectiveFeatureAccess_init_$Init$(seen0, feature, moduleKey, sources, serializationConstructorMarker, objectCreate(protoOf(EffectiveFeatureAccess)));
  }
  function EffectiveFeatureAccess() {
  }
  protoOf(EffectiveFeatureAccess).toString = function () {
    return 'EffectiveFeatureAccess(feature=' + this.p41_1.toString() + ', moduleKey=' + this.q41_1 + ', sources=' + toString(this.r41_1) + ')';
  };
  protoOf(EffectiveFeatureAccess).hashCode = function () {
    var result = this.p41_1.hashCode();
    result = imul(result, 31) + (this.q41_1 == null ? 0 : getStringHashCode(this.q41_1)) | 0;
    result = imul(result, 31) + hashCode(this.r41_1) | 0;
    return result;
  };
  protoOf(EffectiveFeatureAccess).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EffectiveFeatureAccess))
      return false;
    var tmp0_other_with_cast = other instanceof EffectiveFeatureAccess ? other : THROW_CCE();
    if (!this.p41_1.equals(tmp0_other_with_cast.p41_1))
      return false;
    if (!(this.q41_1 == tmp0_other_with_cast.q41_1))
      return false;
    if (!equals(this.r41_1, tmp0_other_with_cast.r41_1))
      return false;
    return true;
  };
  function $serializer_239() {
    $serializer_instance_238 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.AccessGrantSource', this, 3);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('label', true);
    tmp0_serialDesc.gy('exceptionId', true);
    this.s41_1 = tmp0_serialDesc;
  }
  protoOf($serializer_239).t41 = function (encoder, value) {
    var tmp0_desc = this.s41_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.u41_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.v41_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, $serializer_getInstance_156(), value.v41_1);
    }
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.w41_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, StringSerializer_getInstance(), value.w41_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_239).on = function (encoder, value) {
    return this.t41(encoder, value instanceof AccessGrantSource ? value : THROW_CCE());
  };
  protoOf($serializer_239).pn = function (decoder) {
    var tmp0_desc = this.s41_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.tq(tmp0_desc);
    if (tmp7_input.ir()) {
      tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, $serializer_getInstance_156(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.hr(tmp0_desc, 1, $serializer_getInstance_156(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.hr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.uq(tmp0_desc);
    return AccessGrantSource_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_239).nn = function () {
    return this.s41_1;
  };
  protoOf($serializer_239).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_156()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_238;
  function $serializer_getInstance_238() {
    if ($serializer_instance_238 == null)
      new $serializer_239();
    return $serializer_instance_238;
  }
  function AccessGrantSource_init_$Init$(seen0, kind, label, exceptionId, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_238().s41_1);
    }
    $this.u41_1 = kind;
    if (0 === (seen0 & 2))
      $this.v41_1 = null;
    else
      $this.v41_1 = label;
    if (0 === (seen0 & 4))
      $this.w41_1 = null;
    else
      $this.w41_1 = exceptionId;
    return $this;
  }
  function AccessGrantSource_init_$Create$(seen0, kind, label, exceptionId, serializationConstructorMarker) {
    return AccessGrantSource_init_$Init$(seen0, kind, label, exceptionId, serializationConstructorMarker, objectCreate(protoOf(AccessGrantSource)));
  }
  function AccessGrantSource() {
  }
  protoOf(AccessGrantSource).toString = function () {
    return 'AccessGrantSource(kind=' + this.u41_1 + ', label=' + toString_0(this.v41_1) + ', exceptionId=' + this.w41_1 + ')';
  };
  protoOf(AccessGrantSource).hashCode = function () {
    var result = getStringHashCode(this.u41_1);
    result = imul(result, 31) + (this.v41_1 == null ? 0 : this.v41_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w41_1 == null ? 0 : getStringHashCode(this.w41_1)) | 0;
    return result;
  };
  protoOf(AccessGrantSource).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof AccessGrantSource))
      return false;
    var tmp0_other_with_cast = other instanceof AccessGrantSource ? other : THROW_CCE();
    if (!(this.u41_1 === tmp0_other_with_cast.u41_1))
      return false;
    if (!equals(this.v41_1, tmp0_other_with_cast.v41_1))
      return false;
    if (!(this.w41_1 == tmp0_other_with_cast.w41_1))
      return false;
    return true;
  };
  function $serializer_240() {
    $serializer_instance_239 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.WithheldAccess', this, 4);
    tmp0_serialDesc.gy('target', false);
    tmp0_serialDesc.gy('kind', false);
    tmp0_serialDesc.gy('reason', false);
    tmp0_serialDesc.gy('revokedBy', true);
    this.x41_1 = tmp0_serialDesc;
  }
  protoOf($serializer_240).y41 = function (encoder, value) {
    var tmp0_desc = this.x41_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_156(), value.z41_1);
    tmp1_output.hs(tmp0_desc, 1, value.a42_1);
    tmp1_output.hs(tmp0_desc, 2, value.b42_1);
    if (tmp1_output.ps(tmp0_desc, 3) ? true : !(value.c42_1 == null)) {
      tmp1_output.ls(tmp0_desc, 3, StringSerializer_getInstance(), value.c42_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_240).on = function (encoder, value) {
    return this.y41(encoder, value instanceof WithheldAccess ? value : THROW_CCE());
  };
  protoOf($serializer_240).pn = function (decoder) {
    var tmp0_desc = this.x41_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.hr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return WithheldAccess_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_240).nn = function () {
    return this.x41_1;
  };
  protoOf($serializer_240).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_156(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_239;
  function $serializer_getInstance_239() {
    if ($serializer_instance_239 == null)
      new $serializer_240();
    return $serializer_instance_239;
  }
  function WithheldAccess_init_$Init$(seen0, target, kind, reason, revokedBy, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_239().x41_1);
    }
    $this.z41_1 = target;
    $this.a42_1 = kind;
    $this.b42_1 = reason;
    if (0 === (seen0 & 8))
      $this.c42_1 = null;
    else
      $this.c42_1 = revokedBy;
    return $this;
  }
  function WithheldAccess_init_$Create$(seen0, target, kind, reason, revokedBy, serializationConstructorMarker) {
    return WithheldAccess_init_$Init$(seen0, target, kind, reason, revokedBy, serializationConstructorMarker, objectCreate(protoOf(WithheldAccess)));
  }
  function WithheldAccess() {
  }
  protoOf(WithheldAccess).toString = function () {
    return 'WithheldAccess(target=' + this.z41_1.toString() + ', kind=' + this.a42_1 + ', reason=' + this.b42_1 + ', revokedBy=' + this.c42_1 + ')';
  };
  protoOf(WithheldAccess).hashCode = function () {
    var result = this.z41_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.a42_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b42_1) | 0;
    result = imul(result, 31) + (this.c42_1 == null ? 0 : getStringHashCode(this.c42_1)) | 0;
    return result;
  };
  protoOf(WithheldAccess).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WithheldAccess))
      return false;
    var tmp0_other_with_cast = other instanceof WithheldAccess ? other : THROW_CCE();
    if (!this.z41_1.equals(tmp0_other_with_cast.z41_1))
      return false;
    if (!(this.a42_1 === tmp0_other_with_cast.a42_1))
      return false;
    if (!(this.b42_1 === tmp0_other_with_cast.b42_1))
      return false;
    if (!(this.c42_1 == tmp0_other_with_cast.c42_1))
      return false;
    return true;
  };
  function Companion_200() {
    Companion_instance_200 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d42_1 = [null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_238()), null, null];
  }
  var Companion_instance_200;
  function Companion_getInstance_200() {
    if (Companion_instance_200 == null)
      new Companion_200();
    return Companion_instance_200;
  }
  function $serializer_241() {
    $serializer_instance_240 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.EffectiveLimitAccess', this, 8);
    tmp0_serialDesc.gy('limit', false);
    tmp0_serialDesc.gy('state', false);
    tmp0_serialDesc.gy('value', false);
    tmp0_serialDesc.gy('policy', false);
    tmp0_serialDesc.gy('source', false);
    tmp0_serialDesc.gy('contributors', true);
    tmp0_serialDesc.gy('usage', true);
    tmp0_serialDesc.gy('isLiveCount', true);
    this.e42_1 = tmp0_serialDesc;
  }
  protoOf($serializer_241).f42 = function (encoder, value) {
    var tmp0_desc = this.e42_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_200().d42_1;
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_156(), value.g42_1);
    tmp1_output.hs(tmp0_desc, 1, value.h42_1);
    tmp1_output.ls(tmp0_desc, 2, LongSerializer_getInstance(), value.i42_1);
    tmp1_output.hs(tmp0_desc, 3, value.j42_1);
    tmp1_output.hs(tmp0_desc, 4, value.k42_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !equals(value.l42_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.l42_1);
    }
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !(value.m42_1 == null)) {
      tmp1_output.ls(tmp0_desc, 6, $serializer_getInstance_160(), value.m42_1);
    }
    if (tmp1_output.ps(tmp0_desc, 7) ? true : !(value.n42_1 === false)) {
      tmp1_output.zr(tmp0_desc, 7, value.n42_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_241).on = function (encoder, value) {
    return this.f42(encoder, value instanceof EffectiveLimitAccess ? value : THROW_CCE());
  };
  protoOf($serializer_241).pn = function (decoder) {
    var tmp0_desc = this.e42_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = false;
    var tmp12_input = decoder.tq(tmp0_desc);
    var tmp13_cached = Companion_getInstance_200().d42_1;
    if (tmp12_input.ir()) {
      tmp4_local0 = tmp12_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.fr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.hr(tmp0_desc, 6, $serializer_getInstance_160(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.vq(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.fr(tmp0_desc, 0, $serializer_getInstance_156(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.hr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.fr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.hr(tmp0_desc, 6, $serializer_getInstance_160(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.vq(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.uq(tmp0_desc);
    return EffectiveLimitAccess_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_241).nn = function () {
    return this.e42_1;
  };
  protoOf($serializer_241).vy = function () {
    var tmp0_cached = Companion_getInstance_200().d42_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_156(), StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance()), StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[5], get_nullable($serializer_getInstance_160()), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_240;
  function $serializer_getInstance_240() {
    if ($serializer_instance_240 == null)
      new $serializer_241();
    return $serializer_instance_240;
  }
  function EffectiveLimitAccess_init_$Init$(seen0, limit, state, value, policy, source, contributors, usage, isLiveCount, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_240().e42_1);
    }
    $this.g42_1 = limit;
    $this.h42_1 = state;
    $this.i42_1 = value;
    $this.j42_1 = policy;
    $this.k42_1 = source;
    if (0 === (seen0 & 32))
      $this.l42_1 = emptyList();
    else
      $this.l42_1 = contributors;
    if (0 === (seen0 & 64))
      $this.m42_1 = null;
    else
      $this.m42_1 = usage;
    if (0 === (seen0 & 128))
      $this.n42_1 = false;
    else
      $this.n42_1 = isLiveCount;
    return $this;
  }
  function EffectiveLimitAccess_init_$Create$(seen0, limit, state, value, policy, source, contributors, usage, isLiveCount, serializationConstructorMarker) {
    return EffectiveLimitAccess_init_$Init$(seen0, limit, state, value, policy, source, contributors, usage, isLiveCount, serializationConstructorMarker, objectCreate(protoOf(EffectiveLimitAccess)));
  }
  function EffectiveLimitAccess() {
  }
  protoOf(EffectiveLimitAccess).toString = function () {
    return 'EffectiveLimitAccess(limit=' + this.g42_1.toString() + ', state=' + this.h42_1 + ', value=' + toString_0(this.i42_1) + ', policy=' + this.j42_1 + ', source=' + this.k42_1 + ', contributors=' + toString(this.l42_1) + ', usage=' + toString_0(this.m42_1) + ', isLiveCount=' + this.n42_1 + ')';
  };
  protoOf(EffectiveLimitAccess).hashCode = function () {
    var result = this.g42_1.hashCode();
    result = imul(result, 31) + getStringHashCode(this.h42_1) | 0;
    result = imul(result, 31) + (this.i42_1 == null ? 0 : this.i42_1.hashCode()) | 0;
    result = imul(result, 31) + getStringHashCode(this.j42_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k42_1) | 0;
    result = imul(result, 31) + hashCode(this.l42_1) | 0;
    result = imul(result, 31) + (this.m42_1 == null ? 0 : this.m42_1.hashCode()) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n42_1) | 0;
    return result;
  };
  protoOf(EffectiveLimitAccess).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EffectiveLimitAccess))
      return false;
    var tmp0_other_with_cast = other instanceof EffectiveLimitAccess ? other : THROW_CCE();
    if (!this.g42_1.equals(tmp0_other_with_cast.g42_1))
      return false;
    if (!(this.h42_1 === tmp0_other_with_cast.h42_1))
      return false;
    if (!equals(this.i42_1, tmp0_other_with_cast.i42_1))
      return false;
    if (!(this.j42_1 === tmp0_other_with_cast.j42_1))
      return false;
    if (!(this.k42_1 === tmp0_other_with_cast.k42_1))
      return false;
    if (!equals(this.l42_1, tmp0_other_with_cast.l42_1))
      return false;
    if (!equals(this.m42_1, tmp0_other_with_cast.m42_1))
      return false;
    if (!(this.n42_1 === tmp0_other_with_cast.n42_1))
      return false;
    return true;
  };
  function Companion_201() {
    Companion_instance_201 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.o42_1 = [new ArrayListSerializer($serializer_getInstance_242())];
  }
  var Companion_instance_201;
  function Companion_getInstance_201() {
    if (Companion_instance_201 == null)
      new Companion_201();
    return Companion_instance_201;
  }
  function $serializer_242() {
    $serializer_instance_241 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantHealthList', this, 1);
    tmp0_serialDesc.gy('items', false);
    this.p42_1 = tmp0_serialDesc;
  }
  protoOf($serializer_242).q42 = function (encoder, value) {
    var tmp0_desc = this.p42_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_201().o42_1;
    tmp1_output.js(tmp0_desc, 0, tmp2_cached[0], value.r42_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_242).on = function (encoder, value) {
    return this.q42(encoder, value instanceof TenantHealthList ? value : THROW_CCE());
  };
  protoOf($serializer_242).pn = function (decoder) {
    var tmp0_desc = this.p42_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    var tmp6_cached = Companion_getInstance_201().o42_1;
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.fr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.fr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return TenantHealthList_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_242).nn = function () {
    return this.p42_1;
  };
  protoOf($serializer_242).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_201().o42_1[0]];
  };
  var $serializer_instance_241;
  function $serializer_getInstance_241() {
    if ($serializer_instance_241 == null)
      new $serializer_242();
    return $serializer_instance_241;
  }
  function TenantHealthList_init_$Init$(seen0, items, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_241().p42_1);
    }
    $this.r42_1 = items;
    return $this;
  }
  function TenantHealthList_init_$Create$(seen0, items, serializationConstructorMarker) {
    return TenantHealthList_init_$Init$(seen0, items, serializationConstructorMarker, objectCreate(protoOf(TenantHealthList)));
  }
  function TenantHealthList(items) {
    Companion_getInstance_201();
    this.r42_1 = items;
  }
  protoOf(TenantHealthList).toString = function () {
    return 'TenantHealthList(items=' + toString(this.r42_1) + ')';
  };
  protoOf(TenantHealthList).hashCode = function () {
    return hashCode(this.r42_1);
  };
  protoOf(TenantHealthList).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantHealthList))
      return false;
    var tmp0_other_with_cast = other instanceof TenantHealthList ? other : THROW_CCE();
    if (!equals(this.r42_1, tmp0_other_with_cast.r42_1))
      return false;
    return true;
  };
  function Companion_202() {
    Companion_instance_202 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s42_1 = [null, null, null, null, null, new ArrayListSerializer($serializer_getInstance_245()), new ArrayListSerializer(get_nullable(IntSerializer_getInstance())), null, null, new ArrayListSerializer($serializer_getInstance_246())];
  }
  var Companion_instance_202;
  function Companion_getInstance_202() {
    if (Companion_instance_202 == null)
      new Companion_202();
    return Companion_instance_202;
  }
  function $serializer_243() {
    $serializer_instance_242 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantHealthDto', this, 10);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('tenantName', false);
    tmp0_serialDesc.gy('score', true);
    tmp0_serialDesc.gy('band', false);
    tmp0_serialDesc.gy('coverage', false);
    tmp0_serialDesc.gy('dimensions', false);
    tmp0_serialDesc.gy('trend', true);
    tmp0_serialDesc.gy('computedAt', false);
    tmp0_serialDesc.gy('lastAck', true);
    tmp0_serialDesc.gy('acks', true);
    this.t42_1 = tmp0_serialDesc;
  }
  protoOf($serializer_243).u42 = function (encoder, value) {
    var tmp0_desc = this.t42_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    var tmp2_cached = Companion_getInstance_202().s42_1;
    tmp1_output.hs(tmp0_desc, 0, value.v42_1);
    tmp1_output.hs(tmp0_desc, 1, value.w42_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.x42_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, IntSerializer_getInstance(), value.x42_1);
    }
    tmp1_output.hs(tmp0_desc, 3, value.y42_1);
    tmp1_output.cs(tmp0_desc, 4, value.z42_1);
    tmp1_output.js(tmp0_desc, 5, tmp2_cached[5], value.a43_1);
    if (tmp1_output.ps(tmp0_desc, 6) ? true : !equals(value.b43_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 6, tmp2_cached[6], value.b43_1);
    }
    tmp1_output.hs(tmp0_desc, 7, value.c43_1);
    if (tmp1_output.ps(tmp0_desc, 8) ? true : !(value.d43_1 == null)) {
      tmp1_output.ls(tmp0_desc, 8, $serializer_getInstance_246(), value.d43_1);
    }
    if (tmp1_output.ps(tmp0_desc, 9) ? true : !equals(value.e43_1, emptyList())) {
      tmp1_output.js(tmp0_desc, 9, tmp2_cached[9], value.e43_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_243).on = function (encoder, value) {
    return this.u42(encoder, value instanceof TenantHealthDto ? value : THROW_CCE());
  };
  protoOf($serializer_243).pn = function (decoder) {
    var tmp0_desc = this.t42_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = 0;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.tq(tmp0_desc);
    var tmp15_cached = Companion_getInstance_202().s42_1;
    if (tmp14_input.ir()) {
      tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.hr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.yq(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.fr(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.fr(tmp0_desc, 6, tmp15_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.dr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.hr(tmp0_desc, 8, $serializer_getInstance_246(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.fr(tmp0_desc, 9, tmp15_cached[9], tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.hr(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.yq(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.fr(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.fr(tmp0_desc, 6, tmp15_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.dr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.hr(tmp0_desc, 8, $serializer_getInstance_246(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.fr(tmp0_desc, 9, tmp15_cached[9], tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.uq(tmp0_desc);
    return TenantHealthDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_243).nn = function () {
    return this.t42_1;
  };
  protoOf($serializer_243).vy = function () {
    var tmp0_cached = Companion_getInstance_202().s42_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), StringSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[5], tmp0_cached[6], StringSerializer_getInstance(), get_nullable($serializer_getInstance_246()), tmp0_cached[9]];
  };
  var $serializer_instance_242;
  function $serializer_getInstance_242() {
    if ($serializer_instance_242 == null)
      new $serializer_243();
    return $serializer_instance_242;
  }
  function TenantHealthDto_init_$Init$(seen0, tenantId, tenantName, score, band, coverage, dimensions, trend, computedAt, lastAck, acks, serializationConstructorMarker, $this) {
    if (!(187 === (187 & seen0))) {
      throwMissingFieldException(seen0, 187, $serializer_getInstance_242().t42_1);
    }
    $this.v42_1 = tenantId;
    $this.w42_1 = tenantName;
    if (0 === (seen0 & 4))
      $this.x42_1 = null;
    else
      $this.x42_1 = score;
    $this.y42_1 = band;
    $this.z42_1 = coverage;
    $this.a43_1 = dimensions;
    if (0 === (seen0 & 64))
      $this.b43_1 = emptyList();
    else
      $this.b43_1 = trend;
    $this.c43_1 = computedAt;
    if (0 === (seen0 & 256))
      $this.d43_1 = null;
    else
      $this.d43_1 = lastAck;
    if (0 === (seen0 & 512))
      $this.e43_1 = emptyList();
    else
      $this.e43_1 = acks;
    return $this;
  }
  function TenantHealthDto_init_$Create$(seen0, tenantId, tenantName, score, band, coverage, dimensions, trend, computedAt, lastAck, acks, serializationConstructorMarker) {
    return TenantHealthDto_init_$Init$(seen0, tenantId, tenantName, score, band, coverage, dimensions, trend, computedAt, lastAck, acks, serializationConstructorMarker, objectCreate(protoOf(TenantHealthDto)));
  }
  function TenantHealthDto(tenantId, tenantName, score, band, coverage, dimensions, trend, computedAt, lastAck, acks) {
    Companion_getInstance_202();
    score = score === VOID ? null : score;
    trend = trend === VOID ? emptyList() : trend;
    lastAck = lastAck === VOID ? null : lastAck;
    acks = acks === VOID ? emptyList() : acks;
    this.v42_1 = tenantId;
    this.w42_1 = tenantName;
    this.x42_1 = score;
    this.y42_1 = band;
    this.z42_1 = coverage;
    this.a43_1 = dimensions;
    this.b43_1 = trend;
    this.c43_1 = computedAt;
    this.d43_1 = lastAck;
    this.e43_1 = acks;
  }
  protoOf(TenantHealthDto).toString = function () {
    return 'TenantHealthDto(tenantId=' + this.v42_1 + ', tenantName=' + this.w42_1 + ', score=' + this.x42_1 + ', band=' + this.y42_1 + ', coverage=' + this.z42_1 + ', dimensions=' + toString(this.a43_1) + ', trend=' + toString(this.b43_1) + ', computedAt=' + this.c43_1 + ', lastAck=' + toString_0(this.d43_1) + ', acks=' + toString(this.e43_1) + ')';
  };
  protoOf(TenantHealthDto).hashCode = function () {
    var result = getStringHashCode(this.v42_1);
    result = imul(result, 31) + getStringHashCode(this.w42_1) | 0;
    result = imul(result, 31) + (this.x42_1 == null ? 0 : this.x42_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y42_1) | 0;
    result = imul(result, 31) + this.z42_1 | 0;
    result = imul(result, 31) + hashCode(this.a43_1) | 0;
    result = imul(result, 31) + hashCode(this.b43_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c43_1) | 0;
    result = imul(result, 31) + (this.d43_1 == null ? 0 : this.d43_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.e43_1) | 0;
    return result;
  };
  protoOf(TenantHealthDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantHealthDto))
      return false;
    var tmp0_other_with_cast = other instanceof TenantHealthDto ? other : THROW_CCE();
    if (!(this.v42_1 === tmp0_other_with_cast.v42_1))
      return false;
    if (!(this.w42_1 === tmp0_other_with_cast.w42_1))
      return false;
    if (!(this.x42_1 == tmp0_other_with_cast.x42_1))
      return false;
    if (!(this.y42_1 === tmp0_other_with_cast.y42_1))
      return false;
    if (!(this.z42_1 === tmp0_other_with_cast.z42_1))
      return false;
    if (!equals(this.a43_1, tmp0_other_with_cast.a43_1))
      return false;
    if (!equals(this.b43_1, tmp0_other_with_cast.b43_1))
      return false;
    if (!(this.c43_1 === tmp0_other_with_cast.c43_1))
      return false;
    if (!equals(this.d43_1, tmp0_other_with_cast.d43_1))
      return false;
    if (!equals(this.e43_1, tmp0_other_with_cast.e43_1))
      return false;
    return true;
  };
  function TenantHealthPaths() {
    this.f43_1 = '/api/console/tenant-health';
    this.g43_1 = 'limit';
    this.h43_1 = 'band';
  }
  protoOf(TenantHealthPaths).a1l = function (tenantId) {
    return '/api/console/tenants/' + tenantId + '/health';
  };
  protoOf(TenantHealthPaths).i43 = function (tenantId) {
    return '/api/console/tenants/' + tenantId + '/health/acknowledge';
  };
  var TenantHealthPaths_instance;
  function TenantHealthPaths_getInstance() {
    return TenantHealthPaths_instance;
  }
  function Companion_203() {
  }
  var Companion_instance_203;
  function Companion_getInstance_203() {
    return Companion_instance_203;
  }
  function $serializer_244() {
    $serializer_instance_243 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantHealthAckResult', this, 2);
    tmp0_serialDesc.gy('ack', false);
    tmp0_serialDesc.gy('replayed', true);
    this.j43_1 = tmp0_serialDesc;
  }
  protoOf($serializer_244).k43 = function (encoder, value) {
    var tmp0_desc = this.j43_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.js(tmp0_desc, 0, $serializer_getInstance_246(), value.l43_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.m43_1 === false)) {
      tmp1_output.zr(tmp0_desc, 1, value.m43_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_244).on = function (encoder, value) {
    return this.k43(encoder, value instanceof TenantHealthAckResult ? value : THROW_CCE());
  };
  protoOf($serializer_244).pn = function (decoder) {
    var tmp0_desc = this.j43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = false;
    var tmp6_input = decoder.tq(tmp0_desc);
    if (tmp6_input.ir()) {
      tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_246(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.fr(tmp0_desc, 0, $serializer_getInstance_246(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vq(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.uq(tmp0_desc);
    return TenantHealthAckResult_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_244).nn = function () {
    return this.j43_1;
  };
  protoOf($serializer_244).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_246(), BooleanSerializer_getInstance()];
  };
  var $serializer_instance_243;
  function $serializer_getInstance_243() {
    if ($serializer_instance_243 == null)
      new $serializer_244();
    return $serializer_instance_243;
  }
  function TenantHealthAckResult_init_$Init$(seen0, ack, replayed, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_243().j43_1);
    }
    $this.l43_1 = ack;
    if (0 === (seen0 & 2))
      $this.m43_1 = false;
    else
      $this.m43_1 = replayed;
    return $this;
  }
  function TenantHealthAckResult_init_$Create$(seen0, ack, replayed, serializationConstructorMarker) {
    return TenantHealthAckResult_init_$Init$(seen0, ack, replayed, serializationConstructorMarker, objectCreate(protoOf(TenantHealthAckResult)));
  }
  function TenantHealthAckResult(ack, replayed) {
    replayed = replayed === VOID ? false : replayed;
    this.l43_1 = ack;
    this.m43_1 = replayed;
  }
  protoOf(TenantHealthAckResult).toString = function () {
    return 'TenantHealthAckResult(ack=' + this.l43_1.toString() + ', replayed=' + this.m43_1 + ')';
  };
  protoOf(TenantHealthAckResult).hashCode = function () {
    var result = this.l43_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.m43_1) | 0;
    return result;
  };
  protoOf(TenantHealthAckResult).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantHealthAckResult))
      return false;
    var tmp0_other_with_cast = other instanceof TenantHealthAckResult ? other : THROW_CCE();
    if (!this.l43_1.equals(tmp0_other_with_cast.l43_1))
      return false;
    if (!(this.m43_1 === tmp0_other_with_cast.m43_1))
      return false;
    return true;
  };
  function Companion_204() {
  }
  var Companion_instance_204;
  function Companion_getInstance_204() {
    return Companion_instance_204;
  }
  function $serializer_245() {
    $serializer_instance_244 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantHealthAckBody', this, 1);
    tmp0_serialDesc.gy('note', true);
    this.n43_1 = tmp0_serialDesc;
  }
  protoOf($serializer_245).o43 = function (encoder, value) {
    var tmp0_desc = this.n43_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    if (tmp1_output.ps(tmp0_desc, 0) ? true : !(value.p43_1 === '')) {
      tmp1_output.hs(tmp0_desc, 0, value.p43_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_245).on = function (encoder, value) {
    return this.o43(encoder, value instanceof TenantHealthAckBody ? value : THROW_CCE());
  };
  protoOf($serializer_245).pn = function (decoder) {
    var tmp0_desc = this.n43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.tq(tmp0_desc);
    if (tmp5_input.ir()) {
      tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.uq(tmp0_desc);
    return TenantHealthAckBody_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_245).nn = function () {
    return this.n43_1;
  };
  protoOf($serializer_245).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  var $serializer_instance_244;
  function $serializer_getInstance_244() {
    if ($serializer_instance_244 == null)
      new $serializer_245();
    return $serializer_instance_244;
  }
  function TenantHealthAckBody_init_$Init$(seen0, note, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_244().n43_1);
    }
    if (0 === (seen0 & 1))
      $this.p43_1 = '';
    else
      $this.p43_1 = note;
    return $this;
  }
  function TenantHealthAckBody_init_$Create$(seen0, note, serializationConstructorMarker) {
    return TenantHealthAckBody_init_$Init$(seen0, note, serializationConstructorMarker, objectCreate(protoOf(TenantHealthAckBody)));
  }
  function TenantHealthAckBody(note) {
    note = note === VOID ? '' : note;
    this.p43_1 = note;
  }
  protoOf(TenantHealthAckBody).toString = function () {
    return 'TenantHealthAckBody(note=' + this.p43_1 + ')';
  };
  protoOf(TenantHealthAckBody).hashCode = function () {
    return getStringHashCode(this.p43_1);
  };
  protoOf(TenantHealthAckBody).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantHealthAckBody))
      return false;
    var tmp0_other_with_cast = other instanceof TenantHealthAckBody ? other : THROW_CCE();
    if (!(this.p43_1 === tmp0_other_with_cast.p43_1))
      return false;
    return true;
  };
  function $serializer_246() {
    $serializer_instance_245 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.HealthDimensionDto', this, 6);
    tmp0_serialDesc.gy('key', false);
    tmp0_serialDesc.gy('score', true);
    tmp0_serialDesc.gy('weight', false);
    tmp0_serialDesc.gy('reasonEn', false);
    tmp0_serialDesc.gy('reasonAr', false);
    tmp0_serialDesc.gy('freshness', true);
    this.q43_1 = tmp0_serialDesc;
  }
  protoOf($serializer_246).r43 = function (encoder, value) {
    var tmp0_desc = this.q43_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.s43_1);
    if (tmp1_output.ps(tmp0_desc, 1) ? true : !(value.t43_1 == null)) {
      tmp1_output.ls(tmp0_desc, 1, IntSerializer_getInstance(), value.t43_1);
    }
    tmp1_output.cs(tmp0_desc, 2, value.u43_1);
    tmp1_output.hs(tmp0_desc, 3, value.v43_1);
    tmp1_output.hs(tmp0_desc, 4, value.w43_1);
    if (tmp1_output.ps(tmp0_desc, 5) ? true : !(value.x43_1 == null)) {
      tmp1_output.ls(tmp0_desc, 5, StringSerializer_getInstance(), value.x43_1);
    }
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_246).on = function (encoder, value) {
    return this.r43(encoder, value instanceof HealthDimensionDto ? value : THROW_CCE());
  };
  protoOf($serializer_246).pn = function (decoder) {
    var tmp0_desc = this.q43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.tq(tmp0_desc);
    if (tmp10_input.ir()) {
      tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.yq(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.hr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.yq(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.hr(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.uq(tmp0_desc);
    return HealthDimensionDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_246).nn = function () {
    return this.q43_1;
  };
  protoOf($serializer_246).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(IntSerializer_getInstance()), IntSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_245;
  function $serializer_getInstance_245() {
    if ($serializer_instance_245 == null)
      new $serializer_246();
    return $serializer_instance_245;
  }
  function HealthDimensionDto_init_$Init$(seen0, key, score, weight, reasonEn, reasonAr, freshness, serializationConstructorMarker, $this) {
    if (!(29 === (29 & seen0))) {
      throwMissingFieldException(seen0, 29, $serializer_getInstance_245().q43_1);
    }
    $this.s43_1 = key;
    if (0 === (seen0 & 2))
      $this.t43_1 = null;
    else
      $this.t43_1 = score;
    $this.u43_1 = weight;
    $this.v43_1 = reasonEn;
    $this.w43_1 = reasonAr;
    if (0 === (seen0 & 32))
      $this.x43_1 = null;
    else
      $this.x43_1 = freshness;
    return $this;
  }
  function HealthDimensionDto_init_$Create$(seen0, key, score, weight, reasonEn, reasonAr, freshness, serializationConstructorMarker) {
    return HealthDimensionDto_init_$Init$(seen0, key, score, weight, reasonEn, reasonAr, freshness, serializationConstructorMarker, objectCreate(protoOf(HealthDimensionDto)));
  }
  function HealthDimensionDto() {
  }
  protoOf(HealthDimensionDto).toString = function () {
    return 'HealthDimensionDto(key=' + this.s43_1 + ', score=' + this.t43_1 + ', weight=' + this.u43_1 + ', reasonEn=' + this.v43_1 + ', reasonAr=' + this.w43_1 + ', freshness=' + this.x43_1 + ')';
  };
  protoOf(HealthDimensionDto).hashCode = function () {
    var result = getStringHashCode(this.s43_1);
    result = imul(result, 31) + (this.t43_1 == null ? 0 : this.t43_1) | 0;
    result = imul(result, 31) + this.u43_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.v43_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.w43_1) | 0;
    result = imul(result, 31) + (this.x43_1 == null ? 0 : getStringHashCode(this.x43_1)) | 0;
    return result;
  };
  protoOf(HealthDimensionDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HealthDimensionDto))
      return false;
    var tmp0_other_with_cast = other instanceof HealthDimensionDto ? other : THROW_CCE();
    if (!(this.s43_1 === tmp0_other_with_cast.s43_1))
      return false;
    if (!(this.t43_1 == tmp0_other_with_cast.t43_1))
      return false;
    if (!(this.u43_1 === tmp0_other_with_cast.u43_1))
      return false;
    if (!(this.v43_1 === tmp0_other_with_cast.v43_1))
      return false;
    if (!(this.w43_1 === tmp0_other_with_cast.w43_1))
      return false;
    if (!(this.x43_1 == tmp0_other_with_cast.x43_1))
      return false;
    return true;
  };
  function $serializer_247() {
    $serializer_instance_246 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantHealthAckDto', this, 5);
    tmp0_serialDesc.gy('id', false);
    tmp0_serialDesc.gy('operatorName', false);
    tmp0_serialDesc.gy('note', false);
    tmp0_serialDesc.gy('bandAtAck', false);
    tmp0_serialDesc.gy('createdAt', false);
    this.y43_1 = tmp0_serialDesc;
  }
  protoOf($serializer_247).z43 = function (encoder, value) {
    var tmp0_desc = this.y43_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.a44_1);
    tmp1_output.hs(tmp0_desc, 1, value.b44_1);
    tmp1_output.hs(tmp0_desc, 2, value.c44_1);
    tmp1_output.hs(tmp0_desc, 3, value.d44_1);
    tmp1_output.hs(tmp0_desc, 4, value.e44_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_247).on = function (encoder, value) {
    return this.z43(encoder, value instanceof TenantHealthAckDto ? value : THROW_CCE());
  };
  protoOf($serializer_247).pn = function (decoder) {
    var tmp0_desc = this.y43_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.tq(tmp0_desc);
    if (tmp9_input.ir()) {
      tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.dr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.dr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.dr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.uq(tmp0_desc);
    return TenantHealthAckDto_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_247).nn = function () {
    return this.y43_1;
  };
  protoOf($serializer_247).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_246;
  function $serializer_getInstance_246() {
    if ($serializer_instance_246 == null)
      new $serializer_247();
    return $serializer_instance_246;
  }
  function TenantHealthAckDto_init_$Init$(seen0, id, operatorName, note, bandAtAck, createdAt, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_246().y43_1);
    }
    $this.a44_1 = id;
    $this.b44_1 = operatorName;
    $this.c44_1 = note;
    $this.d44_1 = bandAtAck;
    $this.e44_1 = createdAt;
    return $this;
  }
  function TenantHealthAckDto_init_$Create$(seen0, id, operatorName, note, bandAtAck, createdAt, serializationConstructorMarker) {
    return TenantHealthAckDto_init_$Init$(seen0, id, operatorName, note, bandAtAck, createdAt, serializationConstructorMarker, objectCreate(protoOf(TenantHealthAckDto)));
  }
  function TenantHealthAckDto() {
  }
  protoOf(TenantHealthAckDto).toString = function () {
    return 'TenantHealthAckDto(id=' + this.a44_1 + ', operatorName=' + this.b44_1 + ', note=' + this.c44_1 + ', bandAtAck=' + this.d44_1 + ', createdAt=' + this.e44_1 + ')';
  };
  protoOf(TenantHealthAckDto).hashCode = function () {
    var result = getStringHashCode(this.a44_1);
    result = imul(result, 31) + getStringHashCode(this.b44_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.c44_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.d44_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.e44_1) | 0;
    return result;
  };
  protoOf(TenantHealthAckDto).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantHealthAckDto))
      return false;
    var tmp0_other_with_cast = other instanceof TenantHealthAckDto ? other : THROW_CCE();
    if (!(this.a44_1 === tmp0_other_with_cast.a44_1))
      return false;
    if (!(this.b44_1 === tmp0_other_with_cast.b44_1))
      return false;
    if (!(this.c44_1 === tmp0_other_with_cast.c44_1))
      return false;
    if (!(this.d44_1 === tmp0_other_with_cast.d44_1))
      return false;
    if (!(this.e44_1 === tmp0_other_with_cast.e44_1))
      return false;
    return true;
  };
  function TenantLifecycleActions() {
    TenantLifecycleActions_instance = this;
    this.f44_1 = 'activate';
    this.g44_1 = 'resume';
    this.h44_1 = 'restrict';
    this.i44_1 = 'suspend';
    this.j44_1 = 'archive';
    this.k44_1 = 'delete';
    this.l44_1 = linkedMapOf([to('activate', to(setOf_0('TRIAL'), 'ACTIVE')), to('resume', to(setOf(['SUSPENDED', 'PAST_DUE']), 'ACTIVE')), to('restrict', to(setOf(['TRIAL', 'ACTIVE']), 'PAST_DUE')), to('suspend', to(setOf(['TRIAL', 'ACTIVE', 'PAST_DUE']), 'SUSPENDED')), to('archive', to(setOf(['TRIAL', 'ACTIVE', 'PAST_DUE', 'SUSPENDED']), 'CANCELLED'))]);
  }
  protoOf(TenantLifecycleActions).m44 = function (status) {
    // Inline function 'kotlin.collections.filterValues' call
    var this_0 = this.l44_1;
    var result = LinkedHashMap_init_$Create$_0();
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.u().g();
    while (tmp0_iterator.h()) {
      var entry = tmp0_iterator.i();
      // Inline function 'com.ems.console.api.TenantLifecycleActions.availableFrom.<anonymous>' call
      var from = entry.w().ug();
      // Inline function 'kotlin.text.uppercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = status.toUpperCase();
      if (from.r(tmp$ret$2)) {
        result.k2(entry.v(), entry.w());
      }
    }
    return toList(result.c2());
  };
  var TenantLifecycleActions_instance;
  function TenantLifecycleActions_getInstance() {
    if (TenantLifecycleActions_instance == null)
      new TenantLifecycleActions();
    return TenantLifecycleActions_instance;
  }
  function Companion_205() {
  }
  var Companion_instance_205;
  function Companion_getInstance_205() {
    return Companion_instance_205;
  }
  function $serializer_248() {
    $serializer_instance_247 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.ems.console.api.TenantSetupLookupView', this, 4);
    tmp0_serialDesc.gy('tenantId', false);
    tmp0_serialDesc.gy('status', false);
    tmp0_serialDesc.gy('attempt', true);
    tmp0_serialDesc.gy('observedAtMs', false);
    this.n44_1 = tmp0_serialDesc;
  }
  protoOf($serializer_248).o44 = function (encoder, value) {
    var tmp0_desc = this.n44_1;
    var tmp1_output = encoder.tq(tmp0_desc);
    tmp1_output.hs(tmp0_desc, 0, value.p44_1);
    tmp1_output.hs(tmp0_desc, 1, value.q44_1);
    if (tmp1_output.ps(tmp0_desc, 2) ? true : !(value.r44_1 == null)) {
      tmp1_output.ls(tmp0_desc, 2, $serializer_getInstance_175(), value.r44_1);
    }
    tmp1_output.ds(tmp0_desc, 3, value.s44_1);
    tmp1_output.uq(tmp0_desc);
  };
  protoOf($serializer_248).on = function (encoder, value) {
    return this.o44(encoder, value instanceof TenantSetupLookupView ? value : THROW_CCE());
  };
  protoOf($serializer_248).pn = function (decoder) {
    var tmp0_desc = this.n44_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = new Long(0, 0);
    var tmp8_input = decoder.tq(tmp0_desc);
    if (tmp8_input.ir()) {
      tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, $serializer_getInstance_175(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zq(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.jr(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.dr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.dr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.hr(tmp0_desc, 2, $serializer_getInstance_175(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zq(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.uq(tmp0_desc);
    return TenantSetupLookupView_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_248).nn = function () {
    return this.n44_1;
  };
  protoOf($serializer_248).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_175()), LongSerializer_getInstance()];
  };
  var $serializer_instance_247;
  function $serializer_getInstance_247() {
    if ($serializer_instance_247 == null)
      new $serializer_248();
    return $serializer_instance_247;
  }
  function TenantSetupLookupView_init_$Init$(seen0, tenantId, status, attempt, observedAtMs, serializationConstructorMarker, $this) {
    if (!(11 === (11 & seen0))) {
      throwMissingFieldException(seen0, 11, $serializer_getInstance_247().n44_1);
    }
    $this.p44_1 = tenantId;
    $this.q44_1 = status;
    if (0 === (seen0 & 4))
      $this.r44_1 = null;
    else
      $this.r44_1 = attempt;
    $this.s44_1 = observedAtMs;
    return $this;
  }
  function TenantSetupLookupView_init_$Create$(seen0, tenantId, status, attempt, observedAtMs, serializationConstructorMarker) {
    return TenantSetupLookupView_init_$Init$(seen0, tenantId, status, attempt, observedAtMs, serializationConstructorMarker, objectCreate(protoOf(TenantSetupLookupView)));
  }
  function TenantSetupLookupView(tenantId, status, attempt, observedAtMs) {
    attempt = attempt === VOID ? null : attempt;
    this.p44_1 = tenantId;
    this.q44_1 = status;
    this.r44_1 = attempt;
    this.s44_1 = observedAtMs;
  }
  protoOf(TenantSetupLookupView).toString = function () {
    return 'TenantSetupLookupView(tenantId=' + this.p44_1 + ', status=' + this.q44_1 + ', attempt=' + toString_0(this.r44_1) + ', observedAtMs=' + this.s44_1.toString() + ')';
  };
  protoOf(TenantSetupLookupView).hashCode = function () {
    var result = getStringHashCode(this.p44_1);
    result = imul(result, 31) + getStringHashCode(this.q44_1) | 0;
    result = imul(result, 31) + (this.r44_1 == null ? 0 : this.r44_1.hashCode()) | 0;
    result = imul(result, 31) + this.s44_1.hashCode() | 0;
    return result;
  };
  protoOf(TenantSetupLookupView).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TenantSetupLookupView))
      return false;
    var tmp0_other_with_cast = other instanceof TenantSetupLookupView ? other : THROW_CCE();
    if (!(this.p44_1 === tmp0_other_with_cast.p44_1))
      return false;
    if (!(this.q44_1 === tmp0_other_with_cast.q44_1))
      return false;
    if (!equals(this.r44_1, tmp0_other_with_cast.r44_1))
      return false;
    if (!this.s44_1.equals(tmp0_other_with_cast.s44_1))
      return false;
    return true;
  };
  function TenantSetupLookupApiPaths() {
    this.t44_1 = '/api/console/tenants/{tenantId}/setup';
  }
  protoOf(TenantSetupLookupApiPaths).w30 = function (value) {
    return ConsoleTenantConnectionPaths_getInstance().w30(value);
  };
  protoOf(TenantSetupLookupApiPaths).u44 = function (view, tenantId) {
    var tmp;
    if (view.p44_1 === tenantId) {
      var tmp_0;
      switch (view.q44_1) {
        case 'FOUND':
          var tmp1_safe_receiver = view.r44_1;
          tmp_0 = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l3e_1) === tenantId;
          break;
        case 'NONE':
          tmp_0 = view.r44_1 == null;
          break;
        default:
          tmp_0 = false;
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  var TenantSetupLookupApiPaths_instance;
  function TenantSetupLookupApiPaths_getInstance() {
    return TenantSetupLookupApiPaths_instance;
  }
  //region block: post-declaration
  protoOf($serializer).wy = typeParametersSerializers;
  protoOf($serializer_0).wy = typeParametersSerializers;
  protoOf($serializer_1).wy = typeParametersSerializers;
  protoOf($serializer_2).wy = typeParametersSerializers;
  protoOf($serializer_3).wy = typeParametersSerializers;
  protoOf($serializer_4).wy = typeParametersSerializers;
  protoOf($serializer_5).wy = typeParametersSerializers;
  protoOf($serializer_6).wy = typeParametersSerializers;
  protoOf($serializer_7).wy = typeParametersSerializers;
  protoOf($serializer_8).wy = typeParametersSerializers;
  protoOf($serializer_9).wy = typeParametersSerializers;
  protoOf($serializer_10).wy = typeParametersSerializers;
  protoOf($serializer_11).wy = typeParametersSerializers;
  protoOf($serializer_12).wy = typeParametersSerializers;
  protoOf($serializer_13).wy = typeParametersSerializers;
  protoOf($serializer_14).wy = typeParametersSerializers;
  protoOf($serializer_15).wy = typeParametersSerializers;
  protoOf($serializer_16).wy = typeParametersSerializers;
  protoOf($serializer_17).wy = typeParametersSerializers;
  protoOf($serializer_18).wy = typeParametersSerializers;
  protoOf($serializer_19).wy = typeParametersSerializers;
  protoOf($serializer_20).wy = typeParametersSerializers;
  protoOf($serializer_21).wy = typeParametersSerializers;
  protoOf($serializer_22).wy = typeParametersSerializers;
  protoOf($serializer_23).wy = typeParametersSerializers;
  protoOf($serializer_24).wy = typeParametersSerializers;
  protoOf($serializer_25).wy = typeParametersSerializers;
  protoOf($serializer_26).wy = typeParametersSerializers;
  protoOf($serializer_27).wy = typeParametersSerializers;
  protoOf($serializer_28).wy = typeParametersSerializers;
  protoOf($serializer_29).wy = typeParametersSerializers;
  protoOf($serializer_30).wy = typeParametersSerializers;
  protoOf($serializer_31).wy = typeParametersSerializers;
  protoOf($serializer_32).wy = typeParametersSerializers;
  protoOf($serializer_33).wy = typeParametersSerializers;
  protoOf($serializer_34).wy = typeParametersSerializers;
  protoOf($serializer_35).wy = typeParametersSerializers;
  protoOf($serializer_36).wy = typeParametersSerializers;
  protoOf($serializer_37).wy = typeParametersSerializers;
  protoOf($serializer_38).wy = typeParametersSerializers;
  protoOf($serializer_39).wy = typeParametersSerializers;
  protoOf($serializer_40).wy = typeParametersSerializers;
  protoOf($serializer_41).wy = typeParametersSerializers;
  protoOf($serializer_42).wy = typeParametersSerializers;
  protoOf($serializer_43).wy = typeParametersSerializers;
  protoOf($serializer_44).wy = typeParametersSerializers;
  protoOf($serializer_45).wy = typeParametersSerializers;
  protoOf($serializer_46).wy = typeParametersSerializers;
  protoOf($serializer_47).wy = typeParametersSerializers;
  protoOf($serializer_48).wy = typeParametersSerializers;
  protoOf($serializer_49).wy = typeParametersSerializers;
  protoOf($serializer_50).wy = typeParametersSerializers;
  protoOf($serializer_52).wy = typeParametersSerializers;
  protoOf($serializer_53).wy = typeParametersSerializers;
  protoOf($serializer_54).wy = typeParametersSerializers;
  protoOf($serializer_55).wy = typeParametersSerializers;
  protoOf($serializer_56).wy = typeParametersSerializers;
  protoOf($serializer_57).wy = typeParametersSerializers;
  protoOf($serializer_58).wy = typeParametersSerializers;
  protoOf($serializer_59).wy = typeParametersSerializers;
  protoOf($serializer_60).wy = typeParametersSerializers;
  protoOf($serializer_61).wy = typeParametersSerializers;
  protoOf($serializer_62).wy = typeParametersSerializers;
  protoOf($serializer_63).wy = typeParametersSerializers;
  protoOf($serializer_64).wy = typeParametersSerializers;
  protoOf($serializer_65).wy = typeParametersSerializers;
  protoOf($serializer_66).wy = typeParametersSerializers;
  protoOf($serializer_67).wy = typeParametersSerializers;
  protoOf($serializer_68).wy = typeParametersSerializers;
  protoOf($serializer_69).wy = typeParametersSerializers;
  protoOf($serializer_70).wy = typeParametersSerializers;
  protoOf($serializer_71).wy = typeParametersSerializers;
  protoOf($serializer_72).wy = typeParametersSerializers;
  protoOf($serializer_73).wy = typeParametersSerializers;
  protoOf($serializer_74).wy = typeParametersSerializers;
  protoOf($serializer_75).wy = typeParametersSerializers;
  protoOf($serializer_76).wy = typeParametersSerializers;
  protoOf($serializer_77).wy = typeParametersSerializers;
  protoOf($serializer_78).wy = typeParametersSerializers;
  protoOf($serializer_79).wy = typeParametersSerializers;
  protoOf($serializer_80).wy = typeParametersSerializers;
  protoOf($serializer_81).wy = typeParametersSerializers;
  protoOf($serializer_82).wy = typeParametersSerializers;
  protoOf($serializer_83).wy = typeParametersSerializers;
  protoOf($serializer_84).wy = typeParametersSerializers;
  protoOf($serializer_85).wy = typeParametersSerializers;
  protoOf($serializer_86).wy = typeParametersSerializers;
  protoOf($serializer_87).wy = typeParametersSerializers;
  protoOf($serializer_88).wy = typeParametersSerializers;
  protoOf($serializer_89).wy = typeParametersSerializers;
  protoOf($serializer_90).wy = typeParametersSerializers;
  protoOf($serializer_91).wy = typeParametersSerializers;
  protoOf($serializer_92).wy = typeParametersSerializers;
  protoOf($serializer_93).wy = typeParametersSerializers;
  protoOf($serializer_94).wy = typeParametersSerializers;
  protoOf($serializer_95).wy = typeParametersSerializers;
  protoOf($serializer_96).wy = typeParametersSerializers;
  protoOf($serializer_97).wy = typeParametersSerializers;
  protoOf($serializer_98).wy = typeParametersSerializers;
  protoOf($serializer_99).wy = typeParametersSerializers;
  protoOf($serializer_100).wy = typeParametersSerializers;
  protoOf($serializer_101).wy = typeParametersSerializers;
  protoOf($serializer_102).wy = typeParametersSerializers;
  protoOf($serializer_103).wy = typeParametersSerializers;
  protoOf($serializer_104).wy = typeParametersSerializers;
  protoOf($serializer_105).wy = typeParametersSerializers;
  protoOf($serializer_106).wy = typeParametersSerializers;
  protoOf($serializer_107).wy = typeParametersSerializers;
  protoOf($serializer_108).wy = typeParametersSerializers;
  protoOf($serializer_109).wy = typeParametersSerializers;
  protoOf($serializer_110).wy = typeParametersSerializers;
  protoOf($serializer_111).wy = typeParametersSerializers;
  protoOf($serializer_112).wy = typeParametersSerializers;
  protoOf($serializer_113).wy = typeParametersSerializers;
  protoOf($serializer_114).wy = typeParametersSerializers;
  protoOf($serializer_115).wy = typeParametersSerializers;
  protoOf($serializer_116).wy = typeParametersSerializers;
  protoOf($serializer_117).wy = typeParametersSerializers;
  protoOf($serializer_118).wy = typeParametersSerializers;
  protoOf($serializer_119).wy = typeParametersSerializers;
  protoOf($serializer_120).wy = typeParametersSerializers;
  protoOf($serializer_121).wy = typeParametersSerializers;
  protoOf($serializer_122).wy = typeParametersSerializers;
  protoOf($serializer_123).wy = typeParametersSerializers;
  protoOf($serializer_124).wy = typeParametersSerializers;
  protoOf($serializer_125).wy = typeParametersSerializers;
  protoOf($serializer_126).wy = typeParametersSerializers;
  protoOf($serializer_127).wy = typeParametersSerializers;
  protoOf($serializer_128).wy = typeParametersSerializers;
  protoOf($serializer_129).wy = typeParametersSerializers;
  protoOf($serializer_130).wy = typeParametersSerializers;
  protoOf($serializer_131).wy = typeParametersSerializers;
  protoOf($serializer_132).wy = typeParametersSerializers;
  protoOf($serializer_133).wy = typeParametersSerializers;
  protoOf($serializer_134).wy = typeParametersSerializers;
  protoOf($serializer_135).wy = typeParametersSerializers;
  protoOf($serializer_136).wy = typeParametersSerializers;
  protoOf($serializer_137).wy = typeParametersSerializers;
  protoOf($serializer_138).wy = typeParametersSerializers;
  protoOf($serializer_139).wy = typeParametersSerializers;
  protoOf($serializer_140).wy = typeParametersSerializers;
  protoOf($serializer_141).wy = typeParametersSerializers;
  protoOf($serializer_142).wy = typeParametersSerializers;
  protoOf($serializer_143).wy = typeParametersSerializers;
  protoOf($serializer_144).wy = typeParametersSerializers;
  protoOf($serializer_145).wy = typeParametersSerializers;
  protoOf($serializer_146).wy = typeParametersSerializers;
  protoOf($serializer_147).wy = typeParametersSerializers;
  protoOf($serializer_148).wy = typeParametersSerializers;
  protoOf($serializer_149).wy = typeParametersSerializers;
  protoOf($serializer_150).wy = typeParametersSerializers;
  protoOf($serializer_151).wy = typeParametersSerializers;
  protoOf($serializer_152).wy = typeParametersSerializers;
  protoOf($serializer_153).wy = typeParametersSerializers;
  protoOf($serializer_154).wy = typeParametersSerializers;
  protoOf($serializer_155).wy = typeParametersSerializers;
  protoOf($serializer_156).wy = typeParametersSerializers;
  protoOf($serializer_157).wy = typeParametersSerializers;
  protoOf($serializer_158).wy = typeParametersSerializers;
  protoOf($serializer_159).wy = typeParametersSerializers;
  protoOf($serializer_160).wy = typeParametersSerializers;
  protoOf($serializer_161).wy = typeParametersSerializers;
  protoOf($serializer_162).wy = typeParametersSerializers;
  protoOf($serializer_163).wy = typeParametersSerializers;
  protoOf($serializer_164).wy = typeParametersSerializers;
  protoOf($serializer_165).wy = typeParametersSerializers;
  protoOf($serializer_166).wy = typeParametersSerializers;
  protoOf($serializer_167).wy = typeParametersSerializers;
  protoOf($serializer_168).wy = typeParametersSerializers;
  protoOf($serializer_169).wy = typeParametersSerializers;
  protoOf($serializer_170).wy = typeParametersSerializers;
  protoOf($serializer_171).wy = typeParametersSerializers;
  protoOf($serializer_172).wy = typeParametersSerializers;
  protoOf($serializer_173).wy = typeParametersSerializers;
  protoOf($serializer_174).wy = typeParametersSerializers;
  protoOf($serializer_175).wy = typeParametersSerializers;
  protoOf($serializer_176).wy = typeParametersSerializers;
  protoOf($serializer_177).wy = typeParametersSerializers;
  protoOf($serializer_178).wy = typeParametersSerializers;
  protoOf($serializer_179).wy = typeParametersSerializers;
  protoOf($serializer_180).wy = typeParametersSerializers;
  protoOf($serializer_181).wy = typeParametersSerializers;
  protoOf($serializer_182).wy = typeParametersSerializers;
  protoOf($serializer_183).wy = typeParametersSerializers;
  protoOf($serializer_184).wy = typeParametersSerializers;
  protoOf($serializer_185).wy = typeParametersSerializers;
  protoOf($serializer_186).wy = typeParametersSerializers;
  protoOf($serializer_187).wy = typeParametersSerializers;
  protoOf($serializer_188).wy = typeParametersSerializers;
  protoOf($serializer_189).wy = typeParametersSerializers;
  protoOf($serializer_190).wy = typeParametersSerializers;
  protoOf($serializer_191).wy = typeParametersSerializers;
  protoOf($serializer_192).wy = typeParametersSerializers;
  protoOf($serializer_193).wy = typeParametersSerializers;
  protoOf($serializer_194).wy = typeParametersSerializers;
  protoOf($serializer_195).wy = typeParametersSerializers;
  protoOf($serializer_196).wy = typeParametersSerializers;
  protoOf($serializer_197).wy = typeParametersSerializers;
  protoOf($serializer_198).wy = typeParametersSerializers;
  protoOf($serializer_199).wy = typeParametersSerializers;
  protoOf($serializer_200).wy = typeParametersSerializers;
  protoOf($serializer_201).wy = typeParametersSerializers;
  protoOf($serializer_202).wy = typeParametersSerializers;
  protoOf($serializer_203).wy = typeParametersSerializers;
  protoOf($serializer_204).wy = typeParametersSerializers;
  protoOf($serializer_205).wy = typeParametersSerializers;
  protoOf($serializer_206).wy = typeParametersSerializers;
  protoOf($serializer_207).wy = typeParametersSerializers;
  protoOf($serializer_208).wy = typeParametersSerializers;
  protoOf($serializer_209).wy = typeParametersSerializers;
  protoOf($serializer_210).wy = typeParametersSerializers;
  protoOf($serializer_211).wy = typeParametersSerializers;
  protoOf($serializer_212).wy = typeParametersSerializers;
  protoOf($serializer_213).wy = typeParametersSerializers;
  protoOf($serializer_214).wy = typeParametersSerializers;
  protoOf($serializer_215).wy = typeParametersSerializers;
  protoOf($serializer_216).wy = typeParametersSerializers;
  protoOf($serializer_217).wy = typeParametersSerializers;
  protoOf($serializer_218).wy = typeParametersSerializers;
  protoOf($serializer_219).wy = typeParametersSerializers;
  protoOf($serializer_220).wy = typeParametersSerializers;
  protoOf($serializer_221).wy = typeParametersSerializers;
  protoOf($serializer_222).wy = typeParametersSerializers;
  protoOf($serializer_223).wy = typeParametersSerializers;
  protoOf($serializer_224).wy = typeParametersSerializers;
  protoOf($serializer_225).wy = typeParametersSerializers;
  protoOf($serializer_226).wy = typeParametersSerializers;
  protoOf($serializer_227).wy = typeParametersSerializers;
  protoOf($serializer_228).wy = typeParametersSerializers;
  protoOf($serializer_229).wy = typeParametersSerializers;
  protoOf($serializer_230).wy = typeParametersSerializers;
  protoOf($serializer_231).wy = typeParametersSerializers;
  protoOf($serializer_232).wy = typeParametersSerializers;
  protoOf($serializer_233).wy = typeParametersSerializers;
  protoOf($serializer_234).wy = typeParametersSerializers;
  protoOf($serializer_235).wy = typeParametersSerializers;
  protoOf($serializer_236).wy = typeParametersSerializers;
  protoOf($serializer_237).wy = typeParametersSerializers;
  protoOf($serializer_238).wy = typeParametersSerializers;
  protoOf($serializer_239).wy = typeParametersSerializers;
  protoOf($serializer_240).wy = typeParametersSerializers;
  protoOf($serializer_241).wy = typeParametersSerializers;
  protoOf($serializer_242).wy = typeParametersSerializers;
  protoOf($serializer_243).wy = typeParametersSerializers;
  protoOf($serializer_244).wy = typeParametersSerializers;
  protoOf($serializer_245).wy = typeParametersSerializers;
  protoOf($serializer_246).wy = typeParametersSerializers;
  protoOf($serializer_247).wy = typeParametersSerializers;
  protoOf($serializer_248).wy = typeParametersSerializers;
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_2 = new Companion_2();
  Companion_instance_4 = new Companion_4();
  AddonRequestPaths_instance = new AddonRequestPaths();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  Companion_instance_11 = new Companion_11();
  Companion_instance_15 = new Companion_15();
  Companion_instance_19 = new Companion_19();
  Companion_instance_20 = new Companion_20();
  Companion_instance_21 = new Companion_21();
  Companion_instance_24 = new Companion_24();
  Companion_instance_32 = new Companion_32();
  ConsoleApiPaths_instance = new ConsoleApiPaths();
  Companion_instance_36 = new Companion_36();
  Companion_instance_37 = new Companion_37();
  Companion_instance_38 = new Companion_38();
  Companion_instance_43 = new Companion_43();
  Companion_instance_47 = new Companion_47();
  Companion_instance_48 = new Companion_48();
  Companion_instance_50 = new Companion_50();
  Companion_instance_52 = new Companion_52();
  Companion_instance_56 = new Companion_56();
  Companion_instance_57 = new Companion_57();
  Companion_instance_60 = new Companion_60();
  Companion_instance_61 = new Companion_61();
  Companion_instance_62 = new Companion_62();
  Companion_instance_63 = new Companion_63();
  Companion_instance_64 = new Companion_64();
  Companion_instance_67 = new Companion_67();
  Companion_instance_68 = new Companion_68();
  Companion_instance_72 = new Companion_72();
  Companion_instance_74 = new Companion_74();
  Companion_instance_76 = new Companion_76();
  Companion_instance_77 = new Companion_77();
  Companion_instance_78 = new Companion_78();
  Companion_instance_79 = new Companion_79();
  Companion_instance_81 = new Companion_81();
  Companion_instance_82 = new Companion_82();
  Companion_instance_97 = new Companion_97();
  Companion_instance_98 = new Companion_98();
  Companion_instance_99 = new Companion_99();
  Companion_instance_100 = new Companion_100();
  Companion_instance_103 = new Companion_103();
  Companion_instance_104 = new Companion_104();
  Companion_instance_105 = new Companion_105();
  Companion_instance_106 = new Companion_106();
  Companion_instance_113 = new Companion_113();
  ManagedAssignmentSettingsPolicy_instance = new ManagedAssignmentSettingsPolicy();
  MarketplacePaths_instance = new MarketplacePaths();
  Companion_instance_121 = new Companion_121();
  Companion_instance_122 = new Companion_122();
  Companion_instance_124 = new Companion_124();
  Companion_instance_125 = new Companion_125();
  Companion_instance_127 = new Companion_127();
  Companion_instance_128 = new Companion_128();
  PlanFeatureSelection_instance = new PlanFeatureSelection();
  Companion_instance_130 = new Companion_130();
  PlanKeys_instance = new PlanKeys();
  Companion_instance_138 = new Companion_138();
  Companion_instance_139 = new Companion_139();
  PlanLifecyclePaths_instance = new PlanLifecyclePaths();
  Companion_instance_140 = new Companion_140();
  PlanLifecycleRules_instance = new PlanLifecycleRules();
  Companion_instance_142 = new Companion_142();
  SandboxRequestPaths_instance = new SandboxRequestPaths();
  Companion_instance_143 = new Companion_143();
  Companion_instance_144 = new Companion_144();
  Companion_instance_145 = new Companion_145();
  Companion_instance_146 = new Companion_146();
  Companion_instance_147 = new Companion_147();
  Companion_instance_149 = new Companion_149();
  SetupAttemptResumeRules_instance = new SetupAttemptResumeRules();
  SetupCompletionApiPaths_instance = new SetupCompletionApiPaths();
  Companion_instance_151 = new Companion_151();
  SetupConnectionDeferralApiPaths_instance = new SetupConnectionDeferralApiPaths();
  SetupCopiedImageRules_instance = new SetupCopiedImageRules();
  Companion_instance_167 = new Companion_167();
  SetupPlanRules_instance = new SetupPlanRules();
  Companion_instance_173 = new Companion_173();
  Companion_instance_174 = new Companion_174();
  Companion_instance_175 = new Companion_175();
  Companion_instance_177 = new Companion_177();
  Companion_instance_179 = new Companion_179();
  Companion_instance_180 = new Companion_180();
  Companion_instance_181 = new Companion_181();
  SubscriptionCommitmentPaths_instance = new SubscriptionCommitmentPaths();
  Companion_instance_185 = new Companion_185();
  Companion_instance_186 = new Companion_186();
  Companion_instance_188 = new Companion_188();
  Companion_instance_189 = new Companion_189();
  ConsoleSupportVisitPaths_instance = new ConsoleSupportVisitPaths();
  Companion_instance_190 = new Companion_190();
  TenantAccessPaths_instance = new TenantAccessPaths();
  Companion_instance_194 = new Companion_194();
  Companion_instance_195 = new Companion_195();
  Companion_instance_196 = new Companion_196();
  Companion_instance_197 = new Companion_197();
  TenantAccessRules_instance = new TenantAccessRules();
  TenantHealthPaths_instance = new TenantHealthPaths();
  Companion_instance_203 = new Companion_203();
  Companion_instance_204 = new Companion_204();
  Companion_instance_205 = new Companion_205();
  TenantSetupLookupApiPaths_instance = new TenantSetupLookupApiPaths();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = AcceptSetupDraftRequest;
  _.$_$.b = AddProtectedIdentityRequest;
  _.$_$.c = AddWaRateCardRequest;
  _.$_$.d = AddonPackSaveResult;
  _.$_$.e = AddonPackView;
  _.$_$.f = AddonRequestDecisionBody;
  _.$_$.g = AddonRequestDecision;
  _.$_$.h = AddonRequestDetail;
  _.$_$.i = AddonRequestList;
  _.$_$.j = AuditEntry;
  _.$_$.k = AuditQuery;
  _.$_$.l = BillingEffectResult;
  _.$_$.m = BlueprintView;
  _.$_$.n = get_entries;
  _.$_$.o = BrandingContrastPair;
  _.$_$.p = BrandingContrastRequest;
  _.$_$.q = BrandingContrastView;
  _.$_$.r = CapabilityBundleGrantRequest;
  _.$_$.s = CapabilityBundleGrantResult;
  _.$_$.t = CapabilityBundlePreviewRequest;
  _.$_$.u = CapabilityBundlePreview;
  _.$_$.v = CapabilityBundleRevokePreview;
  _.$_$.w = CapabilityBundleRevokeRequest;
  _.$_$.x = CapabilityBundleRevokeResult;
  _.$_$.y = CapabilityBundleTemplate;
  _.$_$.z = CapabilityBundleView;
  _.$_$.a1 = CapabilityEvidenceView;
  _.$_$.b1 = ChangePlanRequest;
  _.$_$.c1 = ChangeProtectedIdentityRequest;
  _.$_$.d1 = CockpitResponse;
  _.$_$.e1 = CommercialLedgerView;
  _.$_$.f1 = ConfigDiffQuery;
  _.$_$.g1 = ConfigDiffView;
  _.$_$.h1 = ConfigSourceRefView;
  _.$_$.i1 = ConfirmTotpRequest;
  _.$_$.j1 = ConsoleError;
  _.$_$.k1 = ConsoleFieldError;
  _.$_$.l1 = CreateOperatorTokenRequest;
  _.$_$.m1 = CreateSetupDraftRequest;
  _.$_$.n1 = CreateTrainingCopyRequest;
  _.$_$.o1 = CreatedOperatorTokenResponse;
  _.$_$.p1 = DeletePlanRequest;
  _.$_$.q1 = DiscardTrainingCopyRequest;
  _.$_$.r1 = DiscardedTrainingCopyView;
  _.$_$.s1 = DuplicatePlanRequest;
  _.$_$.t1 = EffectiveAccessView;
  _.$_$.u1 = FeatureFlagView;
  _.$_$.v1 = ImpactLabel;
  _.$_$.w1 = IntegrationAccountOperationRecovery;
  _.$_$.x1 = IntegrationAccountView;
  _.$_$.y1 = IntegrationAssignmentView;
  _.$_$.z1 = IntegrationCatalogResponse;
  _.$_$.a2 = InvoiceView;
  _.$_$.b2 = LimitPolicySaveResult;
  _.$_$.c2 = LoginRequest;
  _.$_$.d2 = LoginResponse;
  _.$_$.e2 = MarketplaceDecisionBody;
  _.$_$.f2 = MarketplaceDecision;
  _.$_$.g2 = MarketplaceSubmissionDetail;
  _.$_$.h2 = MarketplaceSubmissionList;
  _.$_$.i2 = NoticeView;
  _.$_$.j2 = OfferAllowance;
  _.$_$.k2 = OperatorMcpCallView;
  _.$_$.l2 = OperatorSummary;
  _.$_$.m2 = OperatorTokenView;
  _.$_$.n2 = OwnerInvitationDeliveryView;
  _.$_$.o2 = OwnerInvitationOneTimeView;
  _.$_$.p2 = OwnerInvitationStatusView;
  _.$_$.q2 = Page;
  _.$_$.r2 = PlanChangePreviewRequest;
  _.$_$.s2 = PlanChangePreviewView;
  _.$_$.t2 = PlanDeletionResult;
  _.$_$.u2 = PlanImpactPreview;
  _.$_$.v2 = get_entries_1;
  _.$_$.w2 = PlanLifecycleRequest;
  _.$_$.x2 = PlanLifecycleResult;
  _.$_$.y2 = PlanLimitValue;
  _.$_$.z2 = PlanPriceView;
  _.$_$.a3 = PlanView;
  _.$_$.b3 = PreviewSetupCopyRequest;
  _.$_$.c3 = ProtectedIdentityPageView;
  _.$_$.d3 = ProtectedIdentityView;
  _.$_$.e3 = ProtectionStatusView;
  _.$_$.f3 = ProvisioningJobView;
  _.$_$.g3 = ReadinessReportView;
  _.$_$.h3 = RecordBillingEffectRequest;
  _.$_$.i3 = RecordPaymentRequest;
  _.$_$.j3 = RegistryResponse;
  _.$_$.k3 = RemoveTenantExceptionRequest;
  _.$_$.l3 = ReverifyCapabilityRequest;
  _.$_$.m3 = RevokeOperatorTokenRequest;
  _.$_$.n3 = SandboxDeclineBody;
  _.$_$.o3 = SandboxProvisionBody;
  _.$_$.p3 = SandboxRequestDecision;
  _.$_$.q3 = SandboxRequestList;
  _.$_$.r3 = SaveBlueprintRequest;
  _.$_$.s3 = SaveSetupDraftRequest;
  _.$_$.t3 = SaveSubscriptionCommitmentRequest;
  _.$_$.u3 = SetFeatureFlagRequest;
  _.$_$.v3 = SetupAcceptanceResult;
  _.$_$.w3 = SetupAppearanceChoices;
  _.$_$.x3 = SetupAttemptResumeReceipt;
  _.$_$.y3 = SetupAttemptView;
  _.$_$.z3 = SetupCompletionView;
  _.$_$.a4 = SetupConnectionDeferralReceipt;
  _.$_$.b4 = SetupConnectionDeferralRequest;
  _.$_$.c4 = SetupConnectionDeferralView;
  _.$_$.d4 = SetupConnectionsReadView;
  _.$_$.e4 = SetupCopyPreviewView;
  _.$_$.f4 = SetupCopySourceView;
  _.$_$.g4 = SetupCopyStatusView;
  _.$_$.h4 = SetupDraftAnswers;
  _.$_$.i4 = SetupDraftReviewView;
  _.$_$.j4 = SetupDraftView;
  _.$_$.k4 = SetupFormOptionsView;
  _.$_$.l4 = SetupLimitGrant;
  _.$_$.m4 = SetupSmtpActivationReceipt;
  _.$_$.n4 = SetupSmtpActivationRequest;
  _.$_$.o4 = SetupSmtpConfigurationReceipt;
  _.$_$.p4 = SetupSmtpConfigurationRecovery;
  _.$_$.q4 = SetupSmtpConfigurationRequest;
  _.$_$.r4 = SetupSmtpOriginView;
  _.$_$.s4 = SetupSmtpVerificationReceipt;
  _.$_$.t4 = SetupSmtpVerificationRecovery;
  _.$_$.u4 = SetupSmtpVerificationRequest;
  _.$_$.v4 = get_entries_0;
  _.$_$.w4 = StageBrandingAssetRequest;
  _.$_$.x4 = StagedBrandingAssetContent;
  _.$_$.y4 = StagedBrandingAssetView;
  _.$_$.z4 = SubscribeRequest;
  _.$_$.a5 = SubscriptionChangeResult;
  _.$_$.b5 = SubscriptionCommitmentPreviewRequest;
  _.$_$.c5 = SubscriptionCommitmentPreview;
  _.$_$.d5 = SubscriptionCommitmentSaveResult;
  _.$_$.e5 = SubscriptionCommitmentState;
  _.$_$.f5 = SubscriptionQueue;
  _.$_$.g5 = SupportVisitHistoryView;
  _.$_$.h5 = SupportVisitOpenRequest;
  _.$_$.i5 = SupportVisitPreparationView;
  _.$_$.j5 = SupportVisitView;
  _.$_$.k5 = TenantAddressAvailabilityView;
  _.$_$.l5 = TenantDetail;
  _.$_$.m5 = TenantExceptionRemovalResult;
  _.$_$.n5 = TenantHealthAckBody;
  _.$_$.o5 = TenantHealthAckResult;
  _.$_$.p5 = TenantHealthDto;
  _.$_$.q5 = TenantHealthList;
  _.$_$.r5 = TenantLifecycleRequest;
  _.$_$.s5 = TenantListQuery;
  _.$_$.t5 = TenantOverrideSaveResult;
  _.$_$.u5 = TenantRow;
  _.$_$.v5 = TenantSetupLookupView;
  _.$_$.w5 = TotpEnrolmentResponse;
  _.$_$.x5 = UpdateLimitPolicyRequest;
  _.$_$.y5 = UpsertAddonPackRequest;
  _.$_$.z5 = UpsertIntegrationAccountRequest;
  _.$_$.a6 = UpsertIntegrationAssignmentRequest;
  _.$_$.b6 = UpsertNoticeRequest;
  _.$_$.c6 = UpsertOverrideRequest;
  _.$_$.d6 = UpsertPlanRequest;
  _.$_$.e6 = UsageOverview;
  _.$_$.f6 = WaRateCardView;
  _.$_$.g6 = groupLabel;
  _.$_$.h6 = BrandingAssetKind_DARK_LOGO_getInstance;
  _.$_$.i6 = BrandingAssetKind_FAVICON_getInstance;
  _.$_$.j6 = BrandingAssetKind_LIGHT_LOGO_getInstance;
  _.$_$.k6 = PlanLifecycleAction_ARCHIVE_getInstance;
  _.$_$.l6 = PlanLifecycleAction_DUPLICATE_getInstance;
  _.$_$.m6 = PlanLifecycleAction_PUBLISH_getInstance;
  _.$_$.n6 = PlanLifecycleAction_RESTORE_getInstance;
  _.$_$.o6 = PlanUsageEvidence_CURRENT_COUNTER_getInstance;
  _.$_$.p6 = PlanUsageEvidence_HISTORICAL_ROLLUP_getInstance;
  _.$_$.q6 = PlanUsageEvidence_LIVE_COUNT_getInstance;
  _.$_$.r6 = PlanWorkEvidence_PARTIAL_KNOWN_REQUIREMENTS_getInstance;
  _.$_$.s6 = SetupConnectionDeferralDecision_SKIPPED_getInstance;
  _.$_$.t6 = SetupConnectionDeferralScope_ONE_PROVIDER_getInstance;
  _.$_$.u6 = SetupConnectionDeferralScope_SKIP_ALL_getInstance;
  _.$_$.v6 = SetupCopiedImageChoice_CLEAR_getInstance;
  _.$_$.w6 = SetupCopiedImageChoice_KEEP_getInstance;
  _.$_$.x6 = SetupDraftState_ACCEPTED_getInstance;
  _.$_$.y6 = SetupDraftState_EDITING_getInstance;
  _.$_$.z6 = SetupDraftStep_APPEARANCE_getInstance;
  _.$_$.a7 = SetupDraftStep_DETAILS_getInstance;
  _.$_$.b7 = SetupDraftStep_PLAN_getInstance;
  _.$_$.c7 = SetupDraftStep_START_getInstance;
  _.$_$.d7 = SetupStartMode_COPY_getInstance;
  _.$_$.e7 = SetupStartMode_SCRATCH_getInstance;
  _.$_$.f7 = TenantAddressState_HOST_TAKEN_getInstance;
  _.$_$.g7 = TenantAddressState_INVALID_getInstance;
  _.$_$.h7 = TenantAddressState_RESERVED_getInstance;
  _.$_$.i7 = TenantAddressState_SLUG_TAKEN_getInstance;
  _.$_$.j7 = $serializer_getInstance_173;
  _.$_$.k7 = AddonRequestPaths_instance;
  _.$_$.l7 = BillingEffectKinds_getInstance;
  _.$_$.m7 = $serializer_getInstance_16;
  _.$_$.n7 = CatalogEditorRules_getInstance;
  _.$_$.o7 = ConfigAreaKeys_getInstance;
  _.$_$.p7 = ConsoleApiPaths_instance;
  _.$_$.q7 = Companion_getInstance_28;
  _.$_$.r7 = ConsoleSupportVisitPaths_instance;
  _.$_$.s7 = ConsoleTenantBrandingPaths_getInstance;
  _.$_$.t7 = ConsoleTenantConnectionLifecyclePaths_getInstance;
  _.$_$.u7 = ConsoleTenantConnectionPaths_getInstance;
  _.$_$.v7 = $serializer_getInstance_154;
  _.$_$.w7 = $serializer_getInstance_166;
  _.$_$.x7 = LedgerSurfaceKeys_getInstance;
  _.$_$.y7 = ManagedAssignmentSettingsPolicy_instance;
  _.$_$.z7 = MarketplacePaths_instance;
  _.$_$.a8 = PlanFeatureSelection_instance;
  _.$_$.b8 = PlanKeys_instance;
  _.$_$.c8 = PlanLifecyclePaths_instance;
  _.$_$.d8 = $serializer_getInstance_165;
  _.$_$.e8 = PlanLifecycleRules_instance;
  _.$_$.f8 = SandboxRequestPaths_instance;
  _.$_$.g8 = SetupAppearanceRules_getInstance;
  _.$_$.h8 = SetupAttemptResumeRules_instance;
  _.$_$.i8 = SetupCompletionApiPaths_instance;
  _.$_$.j8 = SetupConnectionDeferralApiPaths_instance;
  _.$_$.k8 = $serializer_getInstance_189;
  _.$_$.l8 = SetupCopiedImageRules_instance;
  _.$_$.m8 = SetupCopyStatusRules_getInstance;
  _.$_$.n8 = SetupPlanRules_instance;
  _.$_$.o8 = $serializer_getInstance_208;
  _.$_$.p8 = $serializer_getInstance_214;
  _.$_$.q8 = SubscriptionCommitmentPaths_instance;
  _.$_$.r8 = TenantAccessPaths_instance;
  _.$_$.s8 = TenantAccessRules_instance;
  _.$_$.t8 = TenantHealthPaths_instance;
  _.$_$.u8 = TenantLifecycleActions_getInstance;
  _.$_$.v8 = TenantSetupLookupApiPaths_instance;
  _.$_$.w8 = $serializer_getInstance_50;
  _.$_$.x8 = $serializer_getInstance_59;
  //endregion
  return _;
}));
